import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Bullseye segment ID */
  BullseyeSegmentID: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: { input: any; output: any; }
};

/** A representation of an ASIN. */
export type Asin = {
  __typename?: 'ASIN';
  announceDate?: Maybe<Scalars['DateTime']['output']>;
  asin: Scalars['String']['output'];
  /** The bundle ASINs this current ASIN is a component of. */
  bundles: AsinBundles_Connection;
  /** Returns campaigns that link to this Asin or are scheduled to this Asin. */
  campaigns: AsinCampaigns_Connection;
  canAct: CanActResponse;
  /** The ASINs that are components of this ASIN if this ASIN is a bundle. */
  components: AsinComponents_Connection;
  description?: Maybe<Scalars['String']['output']>;
  /** ASIN vertex ID from DCS */
  id: Scalars['ID']['output'];
  /** Launch gating information for this ASIN */
  launchGating: AsinLaunchGating;
  liveness?: Maybe<AsinLiveness>;
  marketplace: Marketplace;
  offlineStreetDate?: Maybe<Scalars['DateTime']['output']>;
  onlineStreetDate?: Maybe<Scalars['DateTime']['output']>;
  partNumber?: Maybe<Scalars['String']['output']>;
  party: Scalars['String']['output'];
  /** The DPB product ID associated with this ASIN */
  productId?: Maybe<Scalars['String']['output']>;
  /** The product line this ASIN belongs to. Will be null for non-1p ASINs. */
  productLine?: Maybe<ProductLine2>;
  /** The program this ASIN belongs to. Will be null for some non-1p ASINs. */
  program?: Maybe<Program>;
  salesChannel?: Maybe<Array<Scalars['String']['output']>>;
  /** A 100px thumbnail of the main slate image for the detail page, if it exists. */
  thumbnailURL?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};


/** A representation of an ASIN. */
export type AsinBundlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AsinFilterInput>;
  first: Scalars['Int']['input'];
  sortOptions?: InputMaybe<Array<AsinSortInput>>;
};


/** A representation of an ASIN. */
export type AsinCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  campaignRelationType?: CampaignRelationType;
  first: Scalars['Int']['input'];
  sortOptions?: SortOptions;
};


/** A representation of an ASIN. */
export type AsinCanActArgs = {
  action: AsinActions;
};


/** A representation of an ASIN. */
export type AsinComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AsinFilterInput>;
  first: Scalars['Int']['input'];
  sortOptions?: InputMaybe<Array<AsinSortInput>>;
};

export type AsinAccessInput = {
  destinationAsins: Array<Scalars['String']['input']>;
  destinationMarketplace: Scalars['String']['input'];
};

export type AsinAccessResponse = {
  __typename?: 'ASINAccessResponse';
  failed: Array<Scalars['String']['output']>;
  succeeded: Array<Scalars['String']['output']>;
};

export enum AsinActions {
  PublishConfidentialAttributes = 'PublishConfidentialAttributes',
  PublishNonConfidentialAttributes = 'PublishNonConfidentialAttributes',
  PublishPricing = 'PublishPricing',
  PublishSensitiveAttributes = 'PublishSensitiveAttributes',
  PublishSlates = 'PublishSlates'
}

export type AsinBundles_Connection = {
  __typename?: 'ASINBundles_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<AsinEdge>;
  /** Flattened list of ASIN type */
  nodes: Array<Asin>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AsinCampaigns_Connection = {
  __typename?: 'ASINCampaigns_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<CampaignEdge>;
  /** Flattened list of Campaign type */
  nodes: Array<Campaign>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AsinComponents_Connection = {
  __typename?: 'ASINComponents_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<AsinEdge>;
  /** Flattened list of ASIN type */
  nodes: Array<Asin>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AsinEdge = {
  __typename?: 'ASINEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: Asin;
};

/** A representation of an ASIN launch gating. */
export type AsinLaunchGating = {
  __typename?: 'ASINLaunchGating';
  /** The attribute checked for launch gating logic. */
  attributeChecked: AsinLaunchGatingAttributeEnum;
  /** TRUE if current time is beyond the ASIN announce date. Defaults to false if no announce date is set. */
  beyondLaunchDate: Scalars['Boolean']['output'];
  /** The ASIN causing launch gating */
  gatingAsin?: Maybe<Scalars['String']['output']>;
  /** The computed ASIN launch date. */
  launchDate?: Maybe<Scalars['DateTime']['output']>;
  /** The launch gating threshold (in hours). */
  launchDateThreshold: Scalars['Int']['output'];
  /** Whether the ASIN is within the launch gating threshold date. Defaults to false if no launch date is set. */
  withinLaunchDate: Scalars['Boolean']['output'];
};

export enum AsinLaunchGatingAttributeEnum {
  AnnounceDate = 'ANNOUNCE_DATE',
  ProductSiteLaunchDate = 'PRODUCT_SITE_LAUNCH_DATE'
}

/** A representation of an ASIN launch gating per marketplace. */
export type AsinLaunchGatingInfo = {
  __typename?: 'ASINLaunchGatingInfo';
  /** ASINs causing launch gating */
  gatingAsins: AsinLaunchGatingInfoGatingAsins_Connection;
  marketplace: Marketplace;
};


/** A representation of an ASIN launch gating per marketplace. */
export type AsinLaunchGatingInfoGatingAsinsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  includeMissingAnnounceDate?: InputMaybe<Scalars['Boolean']['input']>;
  sortOptions?: InputMaybe<Array<AsinSortInput>>;
};

export type AsinLaunchGatingInfoGatingAsins_Connection = {
  __typename?: 'ASINLaunchGatingInfoGatingAsins_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<AsinEdge>;
  /** Flattened list of ASIN type */
  nodes: Array<Asin>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** The liveness of the ASIN */
export enum AsinLiveness {
  Live = 'live',
  NotLive = 'not_live',
  PartiallyLive = 'partially_live',
  Unknown = 'unknown'
}

export enum AsinSortEnum {
  AnnounceDate = 'announceDate',
  Asin = 'asin',
  Country = 'country',
  Description = 'description',
  ProgramName = 'programName',
  Type = 'type'
}

export type AsinSortInput = {
  direction?: InputMaybe<SortDirectionEnum>;
  field: AsinSortEnum;
};

/** The types of the ASINType */
export enum AsinTypes {
  Accessory = 'ACCESSORY',
  AdRemoval = 'AD_REMOVAL',
  CertifiedRefurb = 'CERTIFIED_REFURB',
  CertifiedRefurbPlaceholder = 'CERTIFIED_REFURB_PLACEHOLDER',
  Demo = 'DEMO',
  DemoPlaceholder = 'DEMO_PLACEHOLDER',
  Device = 'DEVICE',
  DPBundle = 'D_P_BUNDLE',
  ExtendedWarranty = 'EXTENDED_WARRANTY',
  FreshLot = 'FRESH_LOT',
  FreshLotPlaceholder = 'FRESH_LOT_PLACEHOLDER',
  Mfa = 'MFA',
  NonMfa = 'NON_MFA',
  Parent = 'PARENT',
  Refurb = 'REFURB',
  RefurbPlaceholder = 'REFURB_PLACEHOLDER',
  SoftBundle = 'SOFT_BUNDLE',
  Subscription = 'SUBSCRIPTION',
  VmpBundle = 'VMP_BUNDLE',
  Warranty = 'WARRANTY',
  WarrantyPlaceholder = 'WARRANTY_PLACEHOLDER'
}

export type AdvancedPreviewSessionData = {
  /** preview session data */
  data: PreviewSessionDataInput;
  /** Expiry time of the preview session (e.g. 2024-09-17T01:19:02Z) */
  expiryTime: Scalars['DateTime']['input'];
  /** A previewer ID used in the preview session (e.g. AV981118UJMD0) */
  previewerId: Scalars['String']['input'];
  /** Start time of the preview session (e.g. 2024-09-17T00:19:02Z) */
  startTime: Scalars['DateTime']['input'];
};

export type ArchiveOrRestoreTrafficCampaignInput = {
  /** The ID of the campaign to be archived, this can be MVT, Journeys, or Traffic campaigns */
  campaignId: Scalars['ID']['input'];
  /** ID of the project to be archived, this has to be a trafficProject */
  projectId: Scalars['ID']['input'];
  /** userVersion of the project */
  userVersion: Scalars['Int']['input'];
};

export type ArchiveOrRestoreTrafficCampaignsInput = {
  /** list of campaigns to be archived */
  campaigns: Array<ArchiveOrRestoreTrafficCampaignInput>;
  /** set true for Archive operation; false for Restore operation */
  isArchived: Scalars['Boolean']['input'];
};

export type ArchiveOrRestoreTrafficCampaignsMutationResponse = {
  __typename?: 'ArchiveOrRestoreTrafficCampaignsMutationResponse';
  campaigns: Array<TrafficCampaign>;
};

export type AsinAndCatalogFeatureBullets = {
  __typename?: 'AsinAndCatalogFeatureBullets';
  /** The asin associated with the title */
  asin: Scalars['String']['output'];
  /** The catalog feature bullets for the asin */
  featureBullets: Array<Scalars['String']['output']>;
};

export type AsinAndCatalogTitle = {
  __typename?: 'AsinAndCatalogTitle';
  /** The asin associated with the title */
  asin: Scalars['String']['output'];
  /** The locale of the title */
  locale: Scalars['String']['output'];
  /** The marketplace for the title */
  marketplace: Scalars['String']['output'];
  /** The catalog title for the asin */
  title: Scalars['String']['output'];
};

export type AsinAndCatalogTitleWithParentFlag = {
  __typename?: 'AsinAndCatalogTitleWithParentFlag';
  /** The asin associated with the title */
  asin: Scalars['String']['output'];
  /** True if the ASIN is a parent ASIN, false otherwise */
  isParent: Scalars['Boolean']['output'];
  /** The catalog title for the asin */
  title: Scalars['String']['output'];
};

export type AsinAndCatalogVariantImages = {
  __typename?: 'AsinAndCatalogVariantImages';
  /** The asin associated with the images */
  asin: Scalars['String']['output'];
  /** A Map in the form of variant:size:url */
  images?: Maybe<Scalars['JSON']['output']>;
};

export type AsinCountryInput = {
  /** ASIN */
  asin: Scalars['String']['input'];
  /** Short hand representation of the marketplace (e.g. US) */
  country: Scalars['String']['input'];
};

export type AsinExperimentConfig = {
  __typename?: 'AsinExperimentConfig';
  asin: Scalars['String']['output'];
  asinConfigId: Scalars['ID']['output'];
  featureVariants: DpExperimentAsinVariantsV2;
};

export type AsinFilterInput = {
  /** Date range for ASIN announce date */
  announceDateRange?: InputMaybe<DateRangeInput>;
  /** Asin and Country combinations that will be converted to ASIN vertex IDs and added to the ids filter */
  asinCountries?: InputMaybe<Array<AsinCountryInput>>;
  asinParty?: InputMaybe<Array<Scalars['String']['input']>>;
  asinType?: InputMaybe<Array<Scalars['String']['input']>>;
  asins?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ASIN vertex ID from DCS */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Marketplace vertex ID from DCS */
  marketplaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Product Linevertex ID from DCS */
  productLineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Program vertex ID from DCS */
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Error details for an ASIN that failed to resolve. */
export type AsinResolutionError = {
  __typename?: 'AsinResolutionError';
  /** The ASIN that failed to resolve. */
  asin: Scalars['String']['output'];
  /** The marketplace where the ASIN failed to resolve. */
  marketplace: Scalars['String']['output'];
  /** A human-readable message describing the resolution failure. */
  message: Scalars['String']['output'];
};

export type AsinToCatalogImageUrlsMap = {
  __typename?: 'AsinToCatalogImageUrlsMap';
  /** Map of ASINs to catalog image urls */
  asinToCatalogImageUrlsMap?: Maybe<Scalars['JSON']['output']>;
};

/** Boolean field content */
export type AssetBoolean = {
  __typename?: 'AssetBoolean';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type AssetDetail = {
  __typename?: 'AssetDetail';
  destinationUrl: DestinationUrl;
  imageVariants: Array<ImageVariant>;
};

/** Dimension of a field */
export type AssetFieldDimension = {
  __typename?: 'AssetFieldDimension';
  id: Scalars['ID']['output'];
  position?: Maybe<AssetFieldDimensionPosition>;
  size?: Maybe<AssetFieldDimensionSize>;
};

/** Interface for fields that can have dimension */
export type AssetFieldDimensionBase = {
  dimension?: Maybe<AssetFieldDimension>;
};

/** Position of a field (top, left) */
export type AssetFieldDimensionPosition = {
  __typename?: 'AssetFieldDimensionPosition';
  left?: Maybe<Scalars['Int']['output']>;
  top?: Maybe<Scalars['Int']['output']>;
};

/** Size of a field (height, width) */
export type AssetFieldDimensionSize = {
  __typename?: 'AssetFieldDimensionSize';
  height?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** Styling for a field (including size, color, font, etc) */
export type AssetFieldStyle = {
  __typename?: 'AssetFieldStyle';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  size?: Maybe<Scalars['Int']['output']>;
};

/** Interface for fields that can have styling */
export type AssetFieldStyleBase = {
  style?: Maybe<AssetFieldStyle>;
};

/** A representation of a JAG */
export type AssetGroup = {
  __typename?: 'AssetGroup';
  canAct: CanActResponse;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** JAG vertex ID from DCS */
  id: Scalars['ID']['output'];
  /** LIAs this current JAG has. */
  layeredImageAssets: AssetGroupLayeredImageAssets_Connection;
  name: Scalars['String']['output'];
  /** Projects this current JAG is associated with. */
  projects: AssetGroupProjects_Connection;
  /** Asset Group record version number, used for conflict detection */
  rvn: Scalars['Int']['output'];
  state: JagState;
  templateGroup: TemplateGroup;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};


/** A representation of a JAG */
export type AssetGroupCanActArgs = {
  action: AssetGroupActions;
};


/** A representation of a JAG */
export type AssetGroupLayeredImageAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<LayeredImageAssetsFilterInput>;
  first: Scalars['Int']['input'];
};


/** A representation of a JAG */
export type AssetGroupProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export enum AssetGroupActions {
  Discard = 'DISCARD',
  Merge = 'MERGE'
}

export type AssetGroupEdge = {
  __typename?: 'AssetGroupEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: AssetGroup;
};

export type AssetGroupLayeredImageAssets_Connection = {
  __typename?: 'AssetGroupLayeredImageAssets_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<LayeredImageAssetEdge>;
  /** Marketplaces this JAG is associated with */
  marketplaces: Array<Marketplace>;
  /** Flattened list of LayeredImageAsset type */
  nodes: Array<LayeredImageAsset>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetGroupProjects_Connection = {
  __typename?: 'AssetGroupProjects_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<TrafficProjectEdge>;
  /** Flattened list of TrafficProject type */
  nodes: Array<TrafficProject>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetInterface = {
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** composite id ex(jnid:projectId1-jaid:assetId1) */
  assetId: Scalars['String']['output'];
  device?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  docId: Scalars['String']['output'];
  docName?: Maybe<Scalars['String']['output']>;
  isPublishedMap?: Maybe<Scalars['JSON']['output']>;
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mediaCentralUrls?: Maybe<Scalars['JSON']['output']>;
  modifiedBy: Scalars['String']['output'];
  modifiedDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** S3 signed url for fullsize asset. Not affected by maxHeight or maxWidth properties. */
  originalAssetS3Get?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  productLine?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  s3SignedUrlGet?: Maybe<Scalars['String']['output']>;
  s3SignedUrlPut?: Maybe<Scalars['String']['output']>;
  /** Size in bytes */
  size?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  /**  The type string here is an artifact of Java serialization. It will besomething like com.amazon.amazonjourneyslambda.lambda.dto.JourneysAssetSearchResult */
  type?: Maybe<Scalars['String']['output']>;
  /** Timestamp in Milliseconds */
  uploadedAt: Scalars['Float']['output'];
  uploadedBy: Scalars['String']['output'];
};

/** JSON field content (can be used for custom fields, etc) */
export type AssetJson = {
  __typename?: 'AssetJSON';
  id: Scalars['ID']['output'];
  json?: Maybe<Scalars['JSON']['output']>;
};

export type AssetMetadata = {
  __typename?: 'AssetMetadata';
  height?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type AssetMetadataInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type AssetModel = {
  __typename?: 'AssetModel';
  alt: Scalars['String']['output'];
  assetId: Scalars['String']['output'];
  isLowRes?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  origHeight: Scalars['Int']['output'];
  origWidth: Scalars['Int']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  width: Scalars['Int']['output'];
};

/** Number field content (can be used for prices, percentages, etc) */
export type AssetNumber = {
  __typename?: 'AssetNumber';
  id: Scalars['ID']['output'];
  number?: Maybe<Scalars['Float']['output']>;
};

export type AssetPublishConfig = {
  /** The assetId of the asset that you want to publish. This is the composite asset ID which has the project ID followed by the asset ID. E.g. jnid:1234-jaid:4321 */
  assetId: Scalars['ID']['input'];
  /** (Optional) If you want to publish the asset with specific dimensions, pass that here. The asset will be scaled to those dimensions before publishing. */
  dimension?: InputMaybe<DimensionInput>;
  /** Max size of this asset in KB. Publishing will lower the image quality to be within this weight. */
  maxWeight?: InputMaybe<Scalars['Int']['input']>;
};

export type AssetPublishInput = {
  /** The assetId for the asset to be published */
  assetId: Scalars['String']['input'];
  /** The asset's type extension */
  extension: Scalars['String']['input'];
  /** The folderPath in MediaCentral that the asset will be uploaded to */
  folderPath: Scalars['String']['input'];
  /** orgUnit that corresponds to the marketplace */
  orgUnit: Scalars['String']['input'];
  /** the publicUrl where the asset can be retrieved from MediaCentral */
  publicUrl: Scalars['String']['input'];
  /** The signed s3 Url for the asset to be uploaded to MediaCentral */
  url: Scalars['String']['input'];
};

export type AssetPublishObject = {
  __typename?: 'AssetPublishObject';
  /** The assetId for the asset to be published */
  assetId: Scalars['String']['output'];
  /** The asset's type extension */
  extension: Scalars['String']['output'];
  /** The folderPath in MediaCentral that the asset will be uploaded to */
  folderPath: Scalars['String']['output'];
  /** orgUnit that corresponds to the marketplace */
  orgUnit: Scalars['String']['output'];
  /** the publicUrl where the asset can be retrieved from MediaCentral */
  publicUrl: Scalars['String']['output'];
  /** The signed s3 Url for the asset to be uploaded to MediaCentral */
  url: Scalars['String']['output'];
};

export type AssetPublishRequest = {
  assets: Array<AssetPublishInput>;
  /** orgUnit to publish the assets to */
  ou: Scalars['String']['input'];
};

export type AssetRenameInput = {
  /** The asset ID (e.g., jaid:assetId1) */
  assetId: Scalars['ID']['input'];
  /** New name for the asset */
  name: Scalars['String']['input'];
  /** The project ID (e.g., jnid:projectId1) */
  projectId: Scalars['ID']['input'];
  /** Asset Revision number */
  rvn: Scalars['Int']['input'];
};

export type AssetRenameResponse = {
  __typename?: 'AssetRenameResponse';
  /** The renamed asset with updated information */
  asset: AssetResult;
};

export type AssetResult = FlattenedImageAsset | MediaAssetNode;

export type AssetSearchRequest = {
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateFilterType?: InputMaybe<DateFilter>;
  /** projectId that if passed we will search for assets by projectId */
  docId?: InputMaybe<Scalars['String']['input']>;
  /** paging lower bound */
  from?: InputMaybe<Scalars['Int']['input']>;
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  /** user query text if blank will search for everything */
  query?: InputMaybe<Scalars['String']['input']>;
  /** What kind of thing the user is searching for (assets, notebooks, etc). If blank will search all. */
  searchType?: InputMaybe<Scalars['String']['input']>;
  /** paging upper bound */
  to?: InputMaybe<Scalars['Int']['input']>;
};

export type AssetSearchResponse = {
  __typename?: 'AssetSearchResponse';
  from?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
  numberOfResults?: Maybe<Scalars['Int']['output']>;
  searchResults: Array<Maybe<AssetSearchResult>>;
  to?: Maybe<Scalars['Int']['output']>;
};

export type AssetSearchResponses = {
  __typename?: 'AssetSearchResponses';
  results: Array<Maybe<AssetSearchResponse>>;
};

export type AssetSearchResult = AssetInterface & {
  __typename?: 'AssetSearchResult';
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** composite id ex(jnid:projectId1-jaid:assetId1) */
  assetId: Scalars['String']['output'];
  assetMetadata?: Maybe<AssetMetadata>;
  device?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  docId: Scalars['String']['output'];
  docName?: Maybe<Scalars['String']['output']>;
  isPublishedMap?: Maybe<Scalars['JSON']['output']>;
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mediaCentralUrls?: Maybe<Scalars['JSON']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  modifiedBy: Scalars['String']['output'];
  modifiedDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** S3 signed url for fullsize asset. Not affected by maxHeight or maxWidth properties. */
  originalAssetS3Get?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  productLine?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  s3SignedUrlGet?: Maybe<Scalars['String']['output']>;
  s3SignedUrlPut?: Maybe<Scalars['String']['output']>;
  /** Size in bytes */
  size?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  /**  The type string here is an artifact of Java serialization. It will besomething like com.amazon.amazonjourneyslambda.lambda.dto.JourneysAssetSearchResult */
  type?: Maybe<Scalars['String']['output']>;
  /** Timestamp in Milliseconds */
  uploadedAt: Scalars['Float']['output'];
  uploadedBy: Scalars['String']['output'];
};

/** Text field content */
export type AssetText = {
  __typename?: 'AssetText';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type AssetsOffsetPage = {
  __typename?: 'AssetsOffsetPage';
  assets: Array<AssetSearchResult>;
  from: Scalars['Int']['output'];
  /** The number of results total available. */
  numberOfResults: Scalars['Int']['output'];
  to: Scalars['Int']['output'];
};

export type AssetsQueryInput = {
  from: Scalars['Int']['input'];
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  /** user query text if blank will search for everything */
  query: Scalars['String']['input'];
  to: Scalars['Int']['input'];
  visibleToAll: Scalars['Boolean']['input'];
};

export type AttributeOrPricingErrors = {
  __typename?: 'AttributeOrPricingErrors';
  errorMessage: Scalars['String']['output'];
  errorType: ColumnErrorType;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AutoNamingConfiguration = {
  __typename?: 'AutoNamingConfiguration';
  /** Map of supported input fields and their validation requirements. Structure: Record<string, {required: boolean}> */
  supportedInputs: Scalars['JSON']['output'];
};

export type AutoNamingConfigurationInput = {
  /** Map of supported input fields and their validation requirements. Structure: Record<string, {required: boolean}> */
  supportedInputs: Scalars['JSON']['input'];
};

export type BackfillPermissionsMutationResponse = MutationResponse & {
  __typename?: 'BackfillPermissionsMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  failures: Array<Scalars['String']['output']>;
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type BaseVariant = {
  variantId: Scalars['ID']['output'];
};

export type BindlePermission = {
  __typename?: 'BindlePermission';
  id: Scalars['String']['output'];
  resourceName: Scalars['String']['output'];
};

/** Input for a boolean field */
export type BooleanFieldCreateInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the field to set */
  name: Scalars['String']['input'];
};

/** Input for a boolean field */
export type BooleanFieldInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Layered Image Asset IDs to set this field on */
  layeredImageAssetIds: Array<Scalars['String']['input']>;
  /** Name of the field to set */
  name: Scalars['String']['input'];
};

export type BulkAtfJob = JobInterface & {
  __typename?: 'BulkAtfJob';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the job */
  id: Scalars['ID']['output'];
  /** The metadata associated with the BulkAtfJob */
  metadata?: Maybe<BulkAtfMetadata>;
  status: JobStatus;
};

export type BulkAtfMetadata = {
  __typename?: 'BulkAtfMetadata';
  bulkPublishExecutionIdList?: Maybe<Array<Scalars['String']['output']>>;
  results?: Maybe<UploadJobResult>;
  uploadFileKey: Scalars['String']['output'];
};

export type BulkAtfQueryErrors = {
  __typename?: 'BulkAtfQueryErrors';
  asinMissAllMp: Array<Scalars['String']['output']>;
  permissionDenied: Array<Scalars['String']['output']>;
};

export type BulkAtfQueryInput = {
  global: Array<Scalars['String']['input']>;
  language_level: Array<Scalars['String']['input']>;
};

export type BulkAtfQueryResponse = {
  __typename?: 'BulkAtfQueryResponse';
  errors: BulkAtfQueryErrors;
  url: Scalars['String']['output'];
};

export type BulkCreateAssetInput = {
  device: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  mediaType?: InputMaybe<Scalars['String']['input']>;
  metadata: AssetMetadataInput;
  name: Scalars['String']['input'];
  originalFileName: Scalars['String']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  productLine: Array<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  size: Scalars['Int']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type BulkCreateAssetMutationResponse = MutationResponse & {
  __typename?: 'BulkCreateAssetMutationResponse';
  asset: AssetSearchResult;
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type BulkDeleteTrafficProjectMutationError = {
  __typename?: 'BulkDeleteTrafficProjectMutationError';
  /** The errors that occured during deletion */
  error: Scalars['String']['output'];
  /** The project id with deletion errors */
  projectId: Scalars['String']['output'];
};

export type BulkDeleteTrafficProjectsMutationResponse = {
  __typename?: 'BulkDeleteTrafficProjectsMutationResponse';
  /** A list of succesfully deleted project ids */
  deletedProjectIds: Array<Scalars['String']['output']>;
  /** A list of bulk operation errors */
  errors: Array<BulkDeleteTrafficProjectMutationError>;
};

export type BulkPublishAsinError = {
  __typename?: 'BulkPublishAsinError';
  message: Scalars['String']['output'];
  type: BulkPublishAsinErrorType;
};

export enum BulkPublishAsinErrorType {
  InvalidAttribute = 'INVALID_ATTRIBUTE',
  NotAuthorized = 'NOT_AUTHORIZED',
  PartiallyAuthorized = 'PARTIALLY_AUTHORIZED',
  PublishGated = 'PUBLISH_GATED',
  Unknown = 'UNKNOWN'
}

export type BulkPublishAsinResult = {
  __typename?: 'BulkPublishAsinResult';
  asinVertexId: Scalars['String']['output'];
  error?: Maybe<BulkPublishAsinError>;
  status: BulkPublishAsinStatus;
};

export enum BulkPublishAsinStatus {
  Published = 'PUBLISHED',
  Publishing = 'PUBLISHING',
  PublishFailed = 'PUBLISH_FAILED',
  Waiting = 'WAITING'
}

export type BulkPublishAttributeInput = {
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type BulkPublishInput = {
  /** List of ASINs to process in the bulk publish. */
  asins: Array<Scalars['ID']['input']>;
  /** List of attribute keys to publish for each ASIN. */
  attributes: Array<Scalars['String']['input']>;
  /** List of marketplace and language combinations to process (e.g., ["US English", "CA English", "CA French"]). */
  marketplacesAndLanguages: Array<Scalars['String']['input']>;
  /** Whether to publish using data augmenter instead of retail merchant */
  useDataAugmenter?: Scalars['Boolean']['input'];
};

export type BulkPublishJob = JobInterface & {
  __typename?: 'BulkPublishJob';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the job */
  id: Scalars['ID']['output'];
  /** The metadata associated with the BulkPublishJob */
  metadata: BulkPublishMetadata;
  status: JobStatus;
};

export type BulkPublishMetadata = {
  __typename?: 'BulkPublishMetadata';
  results: Array<BulkPublishAsinResult>;
};

export type BulkPublishPreviewInput = {
  /** List of ASINs to process in the bulk publish preview. */
  asins: Array<Scalars['ID']['input']>;
  /** List of attribute keys to retrieve for each ASIN. */
  attributes: Array<Scalars['String']['input']>;
  /** Optional marketplace filters to limit results to specific marketplaces (e.g., ["US", "CA"]). */
  marketplaces?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of marketplace and language combinations to process (e.g., ["US_en", "UK_en"]). */
  marketplacesAndLanguages: Array<Scalars['String']['input']>;
  /** Optional program id filters to limit results to specific programs. Expects program id like ["Program:amzn1.c2m.concept.ktnb5q32hhl4uxucfn4a"] */
  programIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Sort direction */
  sortDirection?: InputMaybe<BulkPublishSortDirection>;
  /** Field to sort by */
  sortField?: InputMaybe<BulkPublishSortField>;
};

export type BulkPublishResponse = {
  __typename?: 'BulkPublishResponse';
  /** The ID of the created bulk publish job */
  jobId: Scalars['String']['output'];
  /** Total number of unique ASINs attempted to published */
  totalAsinsAttemptedToPublish: Scalars['Int']['output'];
  /** Total number of attributes attempted to published across all ASINs */
  totalAttributesAttemptedToPublish: Scalars['Int']['output'];
};

/** Sort direction for bulk publish preview results */
export enum BulkPublishSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Fields that can be used for sorting bulk publish preview results */
export enum BulkPublishSortField {
  Marketplace = 'MARKETPLACE',
  ProgramName = 'PROGRAM_NAME'
}

export type BulkPublishV2Error = {
  __typename?: 'BulkPublishV2Error';
  /** Error information in any format propagated as is from upstream */
  error: Scalars['JSON']['output'];
};

export type BulkPublishV2Job = JobInterface & {
  __typename?: 'BulkPublishV2Job';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the job */
  id: Scalars['ID']['output'];
  /** The metadata associated with the BulkPublishV2Job */
  metadata?: Maybe<BulkPublishV2Metadata>;
  status: JobStatus;
};

export type BulkPublishV2Metadata = {
  __typename?: 'BulkPublishV2Metadata';
  /** ASINs that failed to publish with error info */
  failedResults?: Maybe<Array<BulkPublishV2StateMachineOutputAsinItem>>;
  /** ASINs that were successfully published */
  successfulResults?: Maybe<Array<BulkPublishV2StateMachineOutputAsinItem>>;
};

/** Type for storing the results after upload */
export type BulkPublishV2StateMachineOutputAsinItem = {
  __typename?: 'BulkPublishV2StateMachineOutputAsinItem';
  asin: Asin;
  attributes: Array<DpAttributeWithError>;
  /** Error information if the publish failed */
  error?: Maybe<BulkPublishV2Error>;
};

export type BulkSaveSlatesMutationResponse = MutationResponse & {
  __typename?: 'BulkSaveSlatesMutationResponse';
  asin: Scalars['String']['output'];
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  failed: Array<SlateImageFailure>;
  marketplace: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  succeeded: Array<SlateImage>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type BulkSlateImageResponse = {
  __typename?: 'BulkSlateImageResponse';
  asin: Scalars['String']['output'];
  marketplace: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  slates: Array<SlateImage>;
};

export type BulkSlatesQueryObject = {
  /** The asin of the product. */
  asin: Scalars['String']['input'];
  /** A marketplace for the product. */
  marketplace: Scalars['String']['input'];
  /** The product ID, if one was found. */
  productId: Scalars['String']['input'];
};

export type BullseyeSegmentError = {
  __typename?: 'BullseyeSegmentError';
  /** ID of Bullseye Segment */
  id: Scalars['ID']['output'];
  /** A raw error message. */
  message: Scalars['String']['output'];
  /** The type of error. */
  type: Scalars['String']['output'];
};

/** bullseye ID and what variants to exclude */
export type BullseyeSegmentInfo = {
  __typename?: 'BullseyeSegmentInfo';
  /** list of bullet variant IDs to exclude for this segment (v0, v1, v2, etc.) */
  bulletExclusions?: Maybe<Array<Scalars['Int']['output']>>;
  /** Whether this info object represents a precomputed set-based segment combination, or not */
  combination?: Maybe<Scalars['Boolean']['output']>;
  /** list of image variant IDs to exclude for this segment (v0, v1, v2, etc.) */
  landingImageExclusions?: Maybe<Array<Scalars['Int']['output']>>;
  /** The position reflecting the order which bullseye segments will be evaluated in */
  position: Scalars['Int']['output'];
  /** The ID of the bullseye segment */
  segmentId: Scalars['ID']['output'];
  /** list of title variant IDs to exclude for this segment (v0, v1, v2, etc.) */
  titleExclusions?: Maybe<Array<Scalars['Int']['output']>>;
};

/** bullseye ID and what variants to exclude */
export type BullseyeSegmentInfoInput = {
  /** list of bullet variant IDs to exclude for this segment (v0, v1, v2, etc.) */
  bulletExclusions?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Whether this info object represents a precomputed set-based segment combination, or not */
  combination?: InputMaybe<Scalars['Boolean']['input']>;
  /** list of image variant IDs to exclude for this segment (v0, v1, v2, etc.) */
  landingImageExclusions?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The position reflecting the order which bullseye segments will be evaluated in */
  position: Scalars['Int']['input'];
  /** The ID of the bullseye segment */
  segmentId: Scalars['ID']['input'];
  /** list of title variant IDs to exclude for this segment (v0, v1, v2, etc.) */
  titleExclusions?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** bullseye ID and what variants to exclude */
export type BullseyeSegmentInfoInputV2 = {
  /** list of bullet variant IDs to exclude for this segment (v0, v1, v2, etc.) */
  bulletExclusions?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The ID of the bullseye segment */
  bullseyeSegmentId: Scalars['ID']['input'];
  /** list of image variant IDs to exclude for this segment (v0, v1, v2, etc.) */
  landingImageExclusions?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The position reflecting the order which bullseye segments will be evaluated in */
  position: Scalars['Int']['input'];
  /** list of title variant IDs to exclude for this segment (v0, v1, v2, etc.) */
  titleExclusions?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** bullseye ID and what variants to exclude */
export type BullseyeSegmentInfoV2 = {
  __typename?: 'BullseyeSegmentInfoV2';
  /** list of bullet variant IDs to exclude for this segment (v0, v1, v2, etc.) */
  bulletExclusions?: Maybe<Array<Scalars['Int']['output']>>;
  /** The ID of the bullseye segment */
  bullseyeSegmentId: Scalars['ID']['output'];
  /** Whether this info object represents a precomputed set-based segment combination, or not */
  combination?: Maybe<Scalars['Boolean']['output']>;
  /** list of image variant IDs to exclude for this segment (v0, v1, v2, etc.) */
  landingImageExclusions?: Maybe<Array<Scalars['Int']['output']>>;
  /** The position reflecting the order which bullseye segments will be evaluated in */
  position: Scalars['Int']['output'];
  /** list of title variant IDs to exclude for this segment (v0, v1, v2, etc.) */
  titleExclusions?: Maybe<Array<Scalars['Int']['output']>>;
};

export type BullseyeSegmentStatus = {
  __typename?: 'BullseyeSegmentStatus';
  /** ID of Bullseye Segment */
  id: Scalars['ID']['output'];
  /** Marketplace id */
  marketplaceId?: Maybe<Scalars['Int']['output']>;
  /** Segment name */
  name: Scalars['String']['output'];
  /** Online status */
  onlineStatus?: Maybe<Scalars['String']['output']>;
  /** Segment status */
  segmentStatus: Scalars['String']['output'];
  /** Segment size */
  yesSize?: Maybe<Scalars['Int']['output']>;
};

export type BullseyeSegmentsQueryResult = BullseyeSegmentError | BullseyeSegmentStatus;

export type BundleAsin = {
  __typename?: 'BundleAsin';
  bundleAsin: Scalars['String']['output'];
  bundleName: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  otherComponents: Array<Scalars['String']['output']>;
};

export type BundleAsins = {
  __typename?: 'BundleAsins';
  bundleAsins: Array<BundleAsin>;
};

export type BundleComponentInput = {
  asinAttributesMap: Scalars['JSON']['input'];
  asins: Array<Scalars['String']['input']>;
  program: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type BundleComponentOutput = {
  __typename?: 'BundleComponentOutput';
  asinAttributesMap: Scalars['JSON']['output'];
  asins: Array<Scalars['String']['output']>;
  program: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type BundleEntityOutput = {
  __typename?: 'BundleEntityOutput';
  asin?: Maybe<Scalars['String']['output']>;
  bundleForm: BundleRequestOutput;
  errorRecord: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  submissionDate: Scalars['String']['output'];
};

export type BundleInfo = BundleAsins | ComponentAsin;

/** Object describing an ASIN and its properties. */
export type BundleManagerAsin = {
  __typename?: 'BundleManagerAsin';
  /** ASIN number. */
  asin: Scalars['ID']['output'];
  /** Common device name associated with the asin. */
  deviceName: Scalars['String']['output'];
  /** List of marketplaces ASIN is available. */
  marketplaces: Array<Scalars['String']['output']>;
  /** Codename of the program the asin belongs to. */
  programName: Scalars['String']['output'];
};

/** object to identify a device Program. */
export type BundleManagerProgram = {
  __typename?: 'BundleManagerProgram';
  /** list of asins associated with given program */
  asins: Array<BundleManagerAsin>;
  /** list of marketplaces where the program is active. */
  marketplace: Array<Scalars['String']['output']>;
  /** The ID of the program */
  programId: Scalars['ID']['output'];
  /** Codename of the program */
  programName: Scalars['String']['output'];
};


/** object to identify a device Program. */
export type BundleManagerProgramAsinsArgs = {
  marketplace?: InputMaybe<Scalars['String']['input']>;
};

export type BundleRequestInput = {
  autoGeneratedCreativeName: Scalars['Boolean']['input'];
  autogenerateBulletPoints: Scalars['Boolean']['input'];
  autogenerateTitle: Scalars['Boolean']['input'];
  baseComponent: BundleComponentInput;
  bindingType: Scalars['String']['input'];
  bullets: Array<Scalars['String']['input']>;
  components: Array<BundleComponentInput>;
  embargoDate: Scalars['String']['input'];
  indexSuppression: Scalars['Boolean']['input'];
  inheritBulletPoints: Scalars['Boolean']['input'];
  launchDate: Scalars['String']['input'];
  launchGating: Scalars['Boolean']['input'];
  marketplaceId: Scalars['String']['input'];
  preLaunch: Scalars['Boolean']['input'];
  programParticipation: Scalars['String']['input'];
  thirdPartySiteExclusion: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type BundleRequestOutput = {
  __typename?: 'BundleRequestOutput';
  autoGeneratedCreativeName: Scalars['Boolean']['output'];
  autogenerateBulletPoints: Scalars['Boolean']['output'];
  autogenerateTitle: Scalars['Boolean']['output'];
  baseComponent: BundleComponentOutput;
  bindingType: Scalars['String']['output'];
  bullets: Array<Scalars['String']['output']>;
  components: Array<BundleComponentOutput>;
  embargoDate: Scalars['String']['output'];
  indexSuppression: Scalars['Boolean']['output'];
  inheritBulletPoints: Scalars['Boolean']['output'];
  launchDate: Scalars['String']['output'];
  launchGating: Scalars['Boolean']['output'];
  marketplaceId: Scalars['String']['output'];
  preLaunch: Scalars['Boolean']['output'];
  programParticipation: Scalars['String']['output'];
  thirdPartySiteExclusion: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type Campaign = {
  __typename?: 'Campaign';
  accessControlGroup?: Maybe<Scalars['String']['output']>;
  additionalName?: Maybe<Scalars['String']['output']>;
  alexaEnabled?: Maybe<Scalars['String']['output']>;
  businessGroup?: Maybe<Scalars['String']['output']>;
  /** If you update your frontend code, you can compare this version you receive from the server to the version in your code to see if the campaign needs to be upgraded. */
  campaignTypeVersion: Scalars['String']['output'];
  /** The dynamic content, controlled by the specific campaign type. Whatever the campaign needs to save, it should store in this object. */
  content: Scalars['JSON']['output'];
  /** datetime of the user created the campaign */
  createdAt: Scalars['String']['output'];
  /** id of the user created the campaign */
  createdBy: Scalars['String']['output'];
  /** a list of errors generated from step functions */
  errors: Array<Scalars['String']['output']>;
  eventShortName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intent?: Maybe<Scalars['String']['output']>;
  /** boolean flag which determines whether or not the campaign is archived for not */
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAutoGenerateCreativeName?: Maybe<Scalars['Boolean']['output']>;
  /** boolean flag to indicate whether campaign is locked for processing, if locked user can not edit on UI */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** boolean flag which determine whether it is a MVT campaign or not */
  isMVT?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  languageOptions: Array<Scalars['String']['output']>;
  lastActiveContentHash?: Maybe<Scalars['String']['output']>;
  /** A summary of the live status of the campaign's placements in Symphony: If the campaign has at least one approved and live placement, this will be LIVE state. If all placements are expired, this will have EXPIRED state. If the campaign has approved placements but none of them are live yet, this will have NOT_YET_LIVE state. If no placements are approved, it will have NOT_APPROVED state. */
  liveState: LiveStateType;
  /** datetime of the user recently updated the campaign */
  modifiedAt: Scalars['String']['output'];
  /** id of the user recently updated the campaign */
  modifiedBy: Scalars['String']['output'];
  mvtExperimentInfo?: Maybe<MvtExperimentInfo>;
  /** JSON payload of the Journeys PodData object, only available when useReactAppUrl is false */
  originalPodData?: Maybe<Scalars['JSON']['output']>;
  placements: Array<Placement>;
  productLine?: Maybe<Scalars['String']['output']>;
  program?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  /** The Journeys campaign state. Based on Symphony status, if the campaign is published. */
  state: CampaignState;
  symphonyInfo?: Maybe<Array<SymphonyInfo>>;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  typeId: Scalars['ID']['output'];
  /** boolean flag to indicate whether campaign comes from DPB or Journeys */
  useReactAppUrl?: Maybe<Scalars['Boolean']['output']>;
  /** The version for optimistic locking. You should pass this in the saveCampaign mutation. */
  userVersion: Scalars['Int']['output'];
};

/** Information about the published asset, along with the dimensions it was published with */
export type CampaignAssetPublishResult = {
  __typename?: 'CampaignAssetPublishResult';
  /** The assetId for the asset to be published */
  assetId: Scalars['String']['output'];
  /** If the asset was published with specified dimensions, this will contain those dimensions. */
  dimension?: Maybe<Dimension>;
  /** The asset's type extension */
  extension: Scalars['String']['output'];
  /** The folderPath in MediaCentral that the asset will be uploaded to */
  folderPath: Scalars['String']['output'];
  /** orgUnit that corresponds to the marketplace */
  orgUnit: Scalars['String']['output'];
  /** the publicUrl where the asset can be retrieved from MediaCentral */
  publicUrl: Scalars['String']['output'];
  /** The signed s3 Url for the asset to be uploaded to MediaCentral */
  url: Scalars['String']['output'];
};

export type CampaignConfiguration = {
  __typename?: 'CampaignConfiguration';
  /** Information about the widget used in this configuration */
  componentInfos: Array<ComponentInfoVariant>;
  /** Configuration for the campaign content */
  contentConfiguration: ContentConfiguration;
  /** Array of feature groups for feature toggling (optional) */
  featureGroups?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether this campaign supports multiple platform flavors */
  hasMultiPlatformFlavors: Scalars['Boolean']['output'];
  /** Unique identifier for the campaign configuration */
  id: Scalars['ID']['output'];
  /** Whether this is a Multi-Creative Campaign configuration */
  isMCC: Scalars['Boolean']['output'];
  /** Whether this campaign is platform agnostic */
  isPlatformAgnostic?: Maybe<Scalars['Boolean']['output']>;
  /** Configuration for Live preview */
  livePreviewConfiguration?: Maybe<LivePreviewConfiguration>;
  /** Display name for the campaign (required) */
  name: Scalars['String']['output'];
  /** Configuration for the overview section of the campaign */
  overviewConfiguration?: Maybe<OverviewConfiguration>;
  /** The type of page where the campaign will be displayed */
  pageType: PageTypeEnum;
  /** Configuration for the placements section of the campaign */
  placementsSection: PlacementsSectionConfig;
  /** Configuration for publishing to Symphony */
  publishing?: Maybe<PublishingConfiguration>;
  /** Whether this campaign requires Customer Behavior Reports */
  requiresCBR: Scalars['Boolean']['output'];
  /** Whether this campaign requires Mocar integration */
  requiresMocar: Scalars['Boolean']['output'];
  /** Configuration options for variable sharing behavior */
  sharingOptions?: Maybe<SharingOptions>;
  /** Short name for the campaign (required) */
  shortName: Scalars['String']['output'];
  /** Current version of the campaign configuration (always returns the latest version) */
  version: Scalars['Int']['output'];
};

export type CampaignConfigurationConnection = {
  __typename?: 'CampaignConfigurationConnection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<CampaignConfigurationEdge>;
  /** Flattened list of CampaignConfiguration type */
  nodes: Array<CampaignConfiguration>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
};

export type CampaignConfigurationDeleteResponse = {
  __typename?: 'CampaignConfigurationDeleteResponse';
  /** Unique identifier for the campaign configuration */
  id: Scalars['String']['output'];
};

export type CampaignConfigurationEdge = {
  __typename?: 'CampaignConfigurationEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: CampaignConfiguration;
};

export type CampaignConfigurationMutationResponse = {
  __typename?: 'CampaignConfigurationMutationResponse';
  /** The campaign configuration that was mutated */
  campaignConfiguration: CampaignConfiguration;
};

export type CampaignEdge = {
  __typename?: 'CampaignEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: Campaign;
};

/** Filter campaign based on whether the requested campaigns are onlyArchived, active(excludingArchived), all campaigns */
export enum CampaignFilterByViewInput {
  Active = 'active',
  All = 'all',
  Archived = 'archived'
}

/** How the campaign relates to this ASIN */
export enum CampaignRelationType {
  All = 'all',
  LinkedTo = 'linked_to',
  ScheduledTo = 'scheduled_to'
}

/** How campaigns should be sorted */
export enum CampaignSortByOptionsInput {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Id = 'id',
  ModifiedAt = 'modifiedAt',
  ModifiedBy = 'modifiedBy'
}

export enum CampaignState {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  DraftWithActive = 'DRAFT_WITH_ACTIVE',
  Loading = 'LOADING',
  MixedStatus = 'MIXED_STATUS',
  Mvt = 'MVT',
  NotAvailable = 'NOT_AVAILABLE',
  NotPublished = 'NOT_PUBLISHED',
  PartiallyApproved = 'PARTIALLY_APPROVED',
  PendingApproval = 'PENDING_APPROVAL',
  PendingApprovalWithActive = 'PENDING_APPROVAL_WITH_ACTIVE',
  PermissionDenied = 'PERMISSION_DENIED',
  Rejected = 'REJECTED',
  RejectedWithActive = 'REJECTED_WITH_ACTIVE',
  Skipped = 'SKIPPED',
  Suspended = 'SUSPENDED'
}

export enum CampaignType {
  QuadAsinCard = 'QuadAsinCard',
  QuadImageCard = 'QuadImageCard',
  SingleAsinCard = 'SingleAsinCard',
  SingleImageCard = 'SingleImageCard'
}

export type CanActAllowedResponse = CanActResponseBase & {
  __typename?: 'CanActAllowedResponse';
  allowed: Scalars['Boolean']['output'];
};

export type CanActDisallowedResponse = CanActResponseBase & {
  __typename?: 'CanActDisallowedResponse';
  allowed: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
};

/** The union of allowed and disallowed responses for CanAct */
export type CanActResponse = CanActAllowedResponse | CanActDisallowedResponse;

export type CanActResponseBase = {
  allowed: Scalars['Boolean']['output'];
};

export type CardContent = SingleImageCardContent;

export type ChatConversation = ChatConversationPending | ChatConversationReady;

export type ChatConversationEdge = {
  __typename?: 'ChatConversationEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: ChatConversation;
};

export type ChatConversationInterface = {
  /** Generic ID for grouping related conversations (campaign, ASIN, project, etc.) */
  correlationId: Scalars['String']['output'];
  /** Bedrock session ID */
  id: Scalars['ID']['output'];
  /** Get message history for this conversation */
  messages: Array<ChatMessage>;
};

/** A chat conversation that is pending a response from Bedrock */
export type ChatConversationPending = ChatConversationInterface & {
  __typename?: 'ChatConversationPending';
  /** Generic ID for grouping related conversations (campaign, ASIN, project, etc.) */
  correlationId: Scalars['String']['output'];
  /** Bedrock session ID */
  id: Scalars['ID']['output'];
  /** Get message history for this conversation */
  messages: Array<ChatMessage>;
};

/** A chat conversation that is ready with messages available */
export type ChatConversationReady = ChatConversationInterface & {
  __typename?: 'ChatConversationReady';
  /** Generic ID for grouping related conversations (campaign, ASIN, project, etc.) */
  correlationId: Scalars['String']['output'];
  /** Bedrock session ID */
  id: Scalars['ID']['output'];
  /** Get message history for this conversation */
  messages: Array<ChatMessage>;
};

/** A message in a conversation */
export type ChatMessage = {
  __typename?: 'ChatMessage';
  /** The message content */
  content: Scalars['String']['output'];
  /** The role of the message sender */
  role: MessageRole;
  /** When the message was created */
  timestamp: Scalars['DateTime']['output'];
};

export type ChildEvent = {
  __typename?: 'ChildEvent';
  childEventId?: Maybe<Scalars['String']['output']>;
  elemId: Scalars['String']['output'];
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CloneCampaignConvertFlavorConfig = {
  newFlavors: Array<CloneNewFlavorConfig>;
  /** ID of a flavor in the original campaign */
  originalFlavorId: Scalars['ID']['input'];
};

export type CloneCampaignMutationResponse = {
  __typename?: 'CloneCampaignMutationResponse';
  id: Scalars['String']['output'];
};

export type CloneJaGsResponse = {
  __typename?: 'CloneJAGsResponse';
  assetGroups: Array<AssetGroup>;
};

export type CloneNewFlavorConfig = {
  /** language of the new Flavor (e.g.: de_DE) */
  language: Scalars['String']['input'];
  /** marketplace of the new Flavor (e.g.: DE) */
  marketplace: Scalars['String']['input'];
};

export type CloneTrafficCampaignInput = {
  convertFlavorConfigs?: InputMaybe<Array<CloneCampaignConvertFlavorConfig>>;
  /** ID of the TrafficCampaign */
  id: Scalars['ID']['input'];
  /** ID of the TrafficProject */
  projectId: Scalars['ID']['input'];
};

export type CloneTrafficCampaignOutput = {
  __typename?: 'CloneTrafficCampaignOutput';
  campaign: TrafficCampaign;
};

export type CloneTrafficProjectInput = {
  /** ID of the project to be cloned */
  id: Scalars['ID']['input'];
};

export type CloneTrafficProjectOutput = {
  __typename?: 'CloneTrafficProjectOutput';
  /** The cloned TrafficProject with all the cloned source campaigns, assets and event(if present) */
  project: TrafficProject;
};

export enum ColumnErrorType {
  Formatting = 'FORMATTING',
  Processing = 'PROCESSING',
  Unknown = 'UNKNOWN'
}

export type CombinationContent = {
  __typename?: 'CombinationContent';
  combination: MvtCombination;
  content: Scalars['JSON']['output'];
};

export type CommonMutationResponse = MutationResponse & {
  __typename?: 'CommonMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type ComponentAsin = {
  __typename?: 'ComponentAsin';
  bundleBaseComponent: Array<Scalars['String']['output']>;
  bundleComponents: Array<Scalars['String']['output']>;
  componentDescription: Array<ComponentString>;
  componentImage: Array<ComponentString>;
  componentQuantity: Array<ComponentInt>;
  programName?: Maybe<Scalars['String']['output']>;
};

export type ComponentDetailsInput = {
  /** Name of the component */
  componentName: Scalars['String']['input'];
  /** project id / document id */
  projectId: Scalars['String']['input'];
};

export type ComponentDetailsQueryResponse = MutationResponse & {
  __typename?: 'ComponentDetailsQueryResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** Name of the component */
  componentName: Scalars['String']['output'];
  /** Legacy name space of the component */
  componentNamespace: Scalars['String']['output'];
  /** Latest version of the component. */
  componentVersion: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type ComponentDetailsV2QueryResponse = {
  __typename?: 'ComponentDetailsV2QueryResponse';
  /** Name of the component */
  componentName: Scalars['String']['output'];
  /** Legacy name space of the component */
  componentNamespace: Scalars['String']['output'];
  /** Latest version of the component. */
  componentVersion: Scalars['String']['output'];
};

export type ComponentInfo = {
  __typename?: 'ComponentInfo';
  /** Name of the component */
  name: Scalars['String']['output'];
  /** Namespace of the component */
  namespace: Scalars['String']['output'];
  /** Version of the component */
  version: Scalars['String']['output'];
};

export type ComponentInfoInput = {
  /** Name of the Component */
  name: Scalars['String']['input'];
  /** Namespace of the component */
  namespace: Scalars['String']['input'];
  /** Supported versions of the Component */
  version: Scalars['String']['input'];
};

export type ComponentInfoVariant = {
  __typename?: 'ComponentInfoVariant';
  componentInfo: ComponentInfo;
  variant: Scalars['String']['output'];
};

export type ComponentInfoVariantInput = {
  componentInfo: ComponentInfoInput;
  variant: Scalars['String']['input'];
};

export type Content = {
  id: Scalars['ID']['output'];
};

export type ContentConfiguration = {
  __typename?: 'ContentConfiguration';
  /** Custom validation function as a serialized string (optional) */
  customValidate?: Maybe<Scalars['String']['output']>;
  /** JSON schema that defines the structure for the campaign content output (required) */
  jsonSchema: Scalars['JSON']['output'];
  /** UI schema that is passed to react-jsonschema-form library (optional) */
  uiSchema?: Maybe<Scalars['JSON']['output']>;
};

export type ContentConfigurationInput = {
  /** Custom validation function as a serialized string (optional) */
  customValidate?: InputMaybe<Scalars['String']['input']>;
  /** JSON schema that defines the structure for the campaign content output (required) */
  jsonSchema: Scalars['JSON']['input'];
  /** UI schema that is passed to react-jsonschema-form library (optional) */
  uiSchema?: InputMaybe<Scalars['JSON']['input']>;
};

export type CopyDpInput = {
  asin: Scalars['ID']['input'];
  /** Target ASINs */
  destinationAsins: Array<Scalars['String']['input']>;
  destinationMarketplace: Scalars['String']['input'];
  isLaunchPermOn?: Scalars['Boolean']['input'];
  marketplace: Scalars['String']['input'];
  /** Full attribute objects */
  selectedAttributes: Array<DpAttributeInput>;
  /** Pod IDs */
  selectedPodIds: Array<Scalars['String']['input']>;
  /** Pricing keys */
  selectedPricing: Array<Scalars['String']['input']>;
  /** Slate variants */
  selectedSlates: Array<Scalars['String']['input']>;
};

export type CreateAssetInput = {
  device: Array<Scalars['String']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  metadata: AssetMetadataInput;
  name: Scalars['String']['input'];
  originalFileName: Scalars['String']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  productLine: Array<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  size: Scalars['Int']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type CreateAssetMutationResponse = MutationResponse & {
  __typename?: 'CreateAssetMutationResponse';
  asset: AssetSearchResult;
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type CreateBulkAtfJobMutationResponse = {
  __typename?: 'CreateBulkAtfJobMutationResponse';
  job: BulkAtfJob;
  /** The URL to upload the file to */
  uploadUrl: Scalars['String']['output'];
};

export type CreateBulkPublishJobInput = {
  /** The ASIN vertex ids to publish */
  asinVertexIds: Array<Scalars['ID']['input']>;
  /** The attributes to publish */
  attributes: Array<BulkPublishAttributeInput>;
};

export type CreateBulkPublishJobMutationResponse = {
  __typename?: 'CreateBulkPublishJobMutationResponse';
  job: BulkPublishJob;
};

export type CreateBundleRequest = {
  bundleRequests: Array<BundleRequestInput>;
};

export type CreateBundleResponse = {
  __typename?: 'CreateBundleResponse';
  bundleEntities: Array<BundleEntityOutput>;
};

export type CreateCampaignConfigurationInput = {
  /** Information about the widget used in this configuration */
  componentInfos: Array<ComponentInfoVariantInput>;
  /** Configuration for the campaign content */
  contentConfiguration: ContentConfigurationInput;
  /** Array of feature groups for feature toggling (optional) */
  featureGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether this campaign supports multiple platform flavors */
  hasMultiPlatformFlavors?: Scalars['Boolean']['input'];
  /** Human readable campaign ID (required) */
  id: Scalars['String']['input'];
  /** Whether this is a Multi-Creative Campaign configuration */
  isMCC?: Scalars['Boolean']['input'];
  /** Whether this campaign is platform agnostic */
  isPlatformAgnostic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration for live preview */
  livePreviewConfiguration?: InputMaybe<LivePreviewConfigurationInput>;
  /** Display name for the campaign (required) */
  name: Scalars['String']['input'];
  /** Configuration for the overview section of the campaign */
  overviewConfiguration?: InputMaybe<OverviewConfigurationInput>;
  /** The type of page where the campaign will be displayed */
  pageType: PageTypeEnum;
  /** Configuration for the placements section of the campaign */
  placementsSection: PlacementsSectionConfigInput;
  /** Configuration for publishing to Symphony */
  publishing?: InputMaybe<PublishingConfigurationInput>;
  /** Whether this campaign requires Customer Behavior Reports */
  requiresCBR?: Scalars['Boolean']['input'];
  /** Whether this campaign requires Mocar integration */
  requiresMocar?: Scalars['Boolean']['input'];
  /** Configuration options for variable sharing behavior */
  sharingOptions?: InputMaybe<SharingOptionsInput>;
  /** Short name for the campaign (required) */
  shortName: Scalars['String']['input'];
};

export type CreateCampaignInput = {
  accessControlGroup?: InputMaybe<Scalars['String']['input']>;
  additionalName?: InputMaybe<Scalars['String']['input']>;
  alexaEnabled?: InputMaybe<Scalars['String']['input']>;
  businessGroup?: InputMaybe<Scalars['String']['input']>;
  /** Pass the version of your campaign type here. If you update your frontend code, you can compare this version you receive from the server to the version in your code to see if the campaign needs to be upgraded. */
  campaignTypeVersion: Scalars['String']['input'];
  /** The dynamic content, controlled by the specific campaign type. Whatever the campaign needs to save, it should store in this object. */
  content?: InputMaybe<Scalars['JSON']['input']>;
  eventShortName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  intent?: InputMaybe<Scalars['String']['input']>;
  isAutoGenerateCreativeName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the campaign valid and ready to publish to Symphony */
  isCampaignValid: Scalars['Boolean']['input'];
  isMVT?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastActiveContentHash?: InputMaybe<Scalars['String']['input']>;
  mvtExperimentInfo?: InputMaybe<MvtExperimentInfoInput>;
  placements: Array<PlacementInput>;
  productLine?: InputMaybe<Scalars['String']['input']>;
  program?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  /** The MP config (called "backendPt" in Vue app). If the componentName in this changes, that will trigger Journeys to send Content to Symphony. */
  publishConfig: Scalars['JSON']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** The pod type ID for this new campaign */
  typeId: Scalars['ID']['input'];
};

export type CreateExperimentV2MutationResponse = CreateOrUpdateExperimentV2MutationResponseInterface & {
  __typename?: 'CreateExperimentV2MutationResponse';
  /** The created or updated experiment */
  experiment?: Maybe<DpExperimentDetailsV2>;
  /** True if an experiment exists and creation failed, false if successfuls */
  experimentExists: Scalars['Boolean']['output'];
};

export type CreateMccTransitionJobMutationResponse = {
  __typename?: 'CreateMCCTransitionJobMutationResponse';
  job: MccTransitionJob;
};

export type CreateOrUpdateBulletsVariantMutationResponse = MutationResponse & {
  __typename?: 'CreateOrUpdateBulletsVariantMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
  variant: DpBulletsVariant;
};

export type CreateOrUpdateExperimentMutationResponse = MutationResponse & {
  __typename?: 'CreateOrUpdateExperimentMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  experiment?: Maybe<DpExperimentDetails>;
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type CreateOrUpdateExperimentV2MutationResponseInterface = {
  /** The created or updated experiment */
  experiment?: Maybe<DpExperimentDetailsV2>;
};

export type CreateOrUpdateLandingImageVariantMutationResponse = MutationResponse & {
  __typename?: 'CreateOrUpdateLandingImageVariantMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
  variant: DpLandingImageVariant;
};

export type CreateOrUpdateStructuredTitleVariantMutationResponse = MutationResponse & {
  __typename?: 'CreateOrUpdateStructuredTitleVariantMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
  variant: DpStructuredTitleVariant;
};

export type CreateOrUpdateTitleVariantMutationResponse = MutationResponse & {
  __typename?: 'CreateOrUpdateTitleVariantMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
  variant: DpTitleVariant;
};

export type CreateOrUpdateVariantMutationResponse = {
  __typename?: 'CreateOrUpdateVariantMutationResponse';
  /** The ASIN experiment configuration */
  asinConfigs: Array<AsinExperimentConfig>;
};

export type CreatePreviewSessionInput = {
  /** includes data related to preview session like username, start and expiry time of the preview session etc */
  advancedPreviewSessionData: AdvancedPreviewSessionData;
  /** A previewer ID used to start the preview session */
  obfuscatedPreviewerId: Scalars['String']['input'];
  /** placements we are going to preview in this session */
  previewPlacements: Array<PreviewPlacementInput>;
  /** A realm */
  realm: SymphonyRealm;
};

export type CreatePreviewSessionOutput = {
  __typename?: 'CreatePreviewSessionOutput';
  /** preview session created date */
  created?: Maybe<Scalars['Date']['output']>;
  /** preview session created by */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** preview session data that is used to create the preview session */
  data: PreviewSessionData;
  /** expiry time of the preview session (e.g. 2024-09-17T00:19:02Z) */
  expiryTime: Scalars['String']['output'];
  /** preview session last modified */
  lastModified?: Maybe<Scalars['Date']['output']>;
  /** preview session last modified by */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** previewer id of the user */
  previewerId?: Maybe<Scalars['String']['output']>;
  /** start time of the preview session (e.g. 2024-09-17T00:19:02Z) */
  startTime: Scalars['String']['output'];
  /** username */
  username?: Maybe<Scalars['String']['output']>;
};

export type CreateProductInput = {
  /** ACGs for Symphony preview */
  accessControlGroups: Array<Scalars['String']['input']>;
  /** BGs for Symphony preview */
  businessGroupsIds: Array<Scalars['String']['input']>;
  detailPages: Array<DetailPageInput>;
  /** The user must be in at least one of these LDAP groups in order to access the Product or any of its Detail Pages. */
  ldapGroups: Array<Scalars['String']['input']>;
  /** A unique ID for the product. This will be used in the URL when navigating in DPB, so use something that is URL-friendly, like 'Puget' */
  productId: Scalars['ID']['input'];
  /** The title or codename of the product. */
  title: Scalars['String']['input'];
};

export type CreateProductsMutationResponse = MutationResponse & {
  __typename?: 'CreateProductsMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  products: Array<Product>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type CreateQaCommentInput = {
  comment: Scalars['String']['input'];
  reviewId: Scalars['ID']['input'];
};

export type CreateQaReviewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contentId: Scalars['ID']['input'];
  status?: InputMaybe<QaStatusEnum>;
};

export type CreateTrafficCampaignCommonInput = {
  accessControlGroup: Scalars['String']['input'];
  autoName?: InputMaybe<TrafficCampaignAutoNameInput>;
  businessGroup: Scalars['String']['input'];
  marketingType: Scalars['String']['input'];
  mocarObjective?: InputMaybe<Scalars['String']['input']>;
  /** Used to pick or suggest BG and ACG values */
  productLine: Scalars['String']['input'];
  /** Associated programs sub group for campaign */
  programSubGroup?: InputMaybe<Scalars['String']['input']>;
  /** List of associated programs for campaign */
  programs?: InputMaybe<Array<Scalars['String']['input']>>;
  reason: Scalars['String']['input'];
};

export type CreateTrafficCampaignFlavorInput = {
  /** Initial data for the new flavor */
  flavor: NewTrafficCampaignFlavorInput;
  /** ID of the TrafficCampaign which will contain this new flavor */
  id: Scalars['ID']['input'];
  /** Name of this TrafficCampaign */
  name: Scalars['String']['input'];
  /** ID of the TrafficProject containing this TrafficCampaign */
  projectId: Scalars['ID']['input'];
  /** Version of the schema used to store this campaign's data */
  schemaVersion: Scalars['Int']['input'];
  /** The version of this TrafficCampaign expected by the client */
  version: Scalars['Int']['input'];
};

export type CreateTrafficCampaignInput = {
  /** Form inputs for this campaign's common config that shared among flavors. */
  common?: InputMaybe<CreateTrafficCampaignCommonInput>;
  /** Initial set of flavors contained in this TrafficCampaign */
  flavors: Array<NewTrafficCampaignFlavorInput>;
  /** Global campaign-wide content applied to all flavors */
  globalContent?: InputMaybe<Scalars['JSON']['input']>;
  /** Optional pre-generated campaign ID. Used internally for adjacency record creation during cloning. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name of this TrafficCampaign */
  name: Scalars['String']['input'];
  /** Form inputs for this campaign's placements config. This metadata will be propagated to placements on the flavor. */
  placements?: InputMaybe<CreateTrafficCampaignPlacementInput>;
  /** ID of the TrafficProject which should contain this TrafficCampaign */
  projectId: Scalars['ID']['input'];
  /** Name of the schema used to represent this campaign type's data (e.g., herotator) */
  schema: Scalars['String']['input'];
  /** Version of the schema used to store this campaign's data */
  schemaVersion: Scalars['Int']['input'];
  varSharing?: InputMaybe<TrafficCampaignVariableSharingInput>;
};

export type CreateTrafficCampaignPlacementGroupInput = {
  eligibilityCriteria: TrafficCampaignEligibilityCriteriaInput;
  /** Flavor IDs that this placement applies to. If flavor has not been saved yet, you can reference the index of the flavor in the flavors array. */
  flavorIds?: Array<Scalars['String']['input']>;
  /** Special Symphony field required when creating a placement. When KoTH is enabled, this value is 0 */
  guarantee: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  scheduling?: InputMaybe<Array<PlacementGroupSchedulingInfoInput>>;
};

export type CreateTrafficCampaignPlacementInput = {
  /** Default field values that can be used by placement groups. */
  defaults?: InputMaybe<TrafficCampaignPlacementDefaultInput>;
  groups?: InputMaybe<Array<CreateTrafficCampaignPlacementGroupInput>>;
};

export type CumulativeGainMetric = {
  __typename?: 'CumulativeGainMetric';
  /** The human-readable combination */
  combination: Scalars['String']['output'];
  /** The context of this metric, "default" if non-contextual */
  context?: Maybe<Scalars['String']['output']>;
  /** The date of the metric */
  date: Scalars['String']['output'];
  /** The MVES experiment ID */
  experimentId: Scalars['String']['output'];
  /** The impression count */
  impressionCount: Scalars['Int']['output'];
  /** The lower bound Proportional Cumulative Gain */
  lowerBoundPCG: Scalars['Float']['output'];
  /** The mean Proportional Cumulative Gain */
  meanPCG: Scalars['Float']['output'];
  /** The p-value of the Proportional Cumulative Gain */
  pvaluePCG: Scalars['Float']['output'];
  /** The rank of the combination */
  rank?: Maybe<Scalars['Int']['output']>;
  /** The success count */
  successCount: Scalars['Int']['output'];
  /** A running total of impressions */
  totalImpressionCount: Scalars['Int']['output'];
  /** A running total of impressions */
  totalSuccessCount: Scalars['Int']['output'];
  /** The combination ID */
  treatment: Scalars['String']['output'];
  /** The upper bound Proportional Cumulative Gain */
  upperBoundPCG: Scalars['Float']['output'];
};

export enum CustomerOptions {
  All = 'ALL',
  Recognized = 'RECOGNIZED',
  RecognizedAndUnrecognized = 'RECOGNIZED_AND_UNRECOGNIZED',
  Unrecognized = 'UNRECOGNIZED'
}

/** Customer options configuration to use */
export enum CustomerOptionsConfigEnum {
  DetailPage = 'DETAIL_PAGE',
  Gateway = 'GATEWAY'
}

export enum CustomerOptionsEnum {
  All = 'ALL',
  Recognized = 'RECOGNIZED',
  RecognizedAndUnrecognized = 'RECOGNIZED_AND_UNRECOGNIZED',
  Unrecognized = 'UNRECOGNIZED'
}

/** The different types of date filters. */
export enum DateFilter {
  All = 'all',
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export type DateRange = {
  __typename?: 'DateRange';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type DateRangeInput = {
  /** The date to end the range lookup at (inclusive). */
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /** Include vertices that do not have date defined in DCS. */
  includeMissing?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date to start the range lookup from (inclusive). */
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateRangeInputDeprecated = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type DeactivateOrDeleteExperimentMutationResponse = MutationResponse & {
  __typename?: 'DeactivateOrDeleteExperimentMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  experiment?: Maybe<DpExperimentDetails>;
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type DeletePermissionsInput = {
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
};

export type DeletePermissionsMutationResponse = MutationResponse & {
  __typename?: 'DeletePermissionsMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type DeletePreviewSessionError = {
  __typename?: 'DeletePreviewSessionError';
  message: Scalars['String']['output'];
};

/** The result of deleting a singular preview session */
export type DeletePreviewSessionResult = DeletePreviewSessionError | DeletedPreviewSession;

export type DeleteProductMutationResponse = MutationResponse & {
  __typename?: 'DeleteProductMutationResponse';
  /** Whether all database items under this product were deleted successfully. */
  allItemsWereProcessed: Scalars['Boolean']['output'];
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type DeleteTrafficProjectMutationResponse = {
  __typename?: 'DeleteTrafficProjectMutationResponse';
  /** The id of the deleted project */
  deletedProjectId: Scalars['String']['output'];
};

export type DeletedPreviewSession = {
  __typename?: 'DeletedPreviewSession';
  obfuscatedPreviewerId: Scalars['String']['output'];
};

export type DestinationUrl = {
  __typename?: 'DestinationURL';
  generatedUrl: Scalars['String']['output'];
  linkType: Scalars['String']['output'];
  linkTypeValue: Scalars['String']['output'];
  refTag: RefTag;
};

export type DetailPage = {
  __typename?: 'DetailPage';
  asin: Scalars['ID']['output'];
  /** A thumbnail image URL for the DP (the MAIN-positioned slate image). */
  image?: Maybe<Scalars['String']['output']>;
  /** The marketplace that the ASIN is in, e.g. 'US' or 'BR' */
  marketplace: Scalars['String']['output'];
  /** merchantId used for overriding default config values. */
  merchantId?: Maybe<Scalars['String']['output']>;
  /** Groups that control permission for publishing. */
  permissionsGroup?: Maybe<PermissionsLdapGroups>;
  /** The title of the Detail Page (the item_name attribute). */
  title: Scalars['String']['output'];
};

export type DetailPageInput = {
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
  permissionsGroup: PermissionsLdapGroupsInput;
  title: Scalars['String']['input'];
};

export type DetailPageStatusQueryResponse = {
  __typename?: 'DetailPageStatusQueryResponse';
  /** Error code if there was an error */
  code?: Maybe<Scalars['String']['output']>;
  /** An error message if the user doesn't have access to the Detail Page or something elsewent wrong such as the not finding the Detail Page. */
  error?: Maybe<Scalars['String']['output']>;
  /** The product ID for the product. This is provided for convenience of other calls. */
  productId?: Maybe<Scalars['ID']['output']>;
  /** The product status, a culmination of other statuses. Failure to calculate will result in a draft state. */
  status: PublishStatusEnum;
};

export type Dimension = {
  __typename?: 'Dimension';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type DimensionInfo = {
  __typename?: 'DimensionInfo';
  name: Scalars['String']['output'];
  variants: Array<Scalars['String']['output']>;
};

export type DimensionInfoInput = {
  name: Scalars['String']['input'];
  variants: Array<Scalars['String']['input']>;
};

export type DimensionInput = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type DimensionVariantKey = {
  __typename?: 'DimensionVariantKey';
  dimensionName: Scalars['String']['output'];
  variantName: Scalars['String']['output'];
};

export type DimensionVariantKeyInput = {
  dimensionName: Scalars['String']['input'];
  variantName: Scalars['String']['input'];
};

export type Dimensions = {
  __typename?: 'Dimensions';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type DiscardAssetGroupChangesResponse = {
  __typename?: 'DiscardAssetGroupChangesResponse';
  /** The AssetGroup that was discarded */
  assetGroup: AssetGroup;
};

export type DpAttribute = DpAttributeInterface & {
  __typename?: 'DpAttribute';
  asinObject?: Maybe<Asin>;
  /** Issues returned from getView during validation */
  issues?: Maybe<Array<Scalars['JSON']['output']>>;
  key: Scalars['String']['output'];
  language: Scalars['String']['output'];
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  modifiedAt: Scalars['String']['output'];
  modifiedBy: Scalars['String']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  /** Whether this attribute has been removed from the UI. */
  removed: Scalars['Boolean']['output'];
  value: Scalars['JSON']['output'];
  /** The latest version of this attribute */
  version: Scalars['Int']['output'];
};

export type DpAttributeCopyFailure = DpAttributeFailureInterface & {
  __typename?: 'DpAttributeCopyFailure';
  /** The ASIN associated with the copy failure */
  asin: Scalars['String']['output'];
  key: Scalars['String']['output'];
  /** The reason the saving for this attribute failed. */
  reason: Scalars['String']['output'];
};

export type DpAttributeCopyResponse = DpAttributeInterface & {
  __typename?: 'DpAttributeCopyResponse';
  /** The ASIN that the attribute was copied too */
  asin: Scalars['String']['output'];
  asinObject?: Maybe<Asin>;
  /** Issues returned from getView during validation */
  issues?: Maybe<Array<Scalars['JSON']['output']>>;
  key: Scalars['String']['output'];
  language: Scalars['String']['output'];
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  modifiedAt: Scalars['String']['output'];
  modifiedBy: Scalars['String']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  /** Whether this attribute has been removed from the UI. */
  removed: Scalars['Boolean']['output'];
  value: Scalars['JSON']['output'];
  /** The latest version of this attribute */
  version: Scalars['Int']['output'];
};

export type DpAttributeEdge = {
  __typename?: 'DpAttributeEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: DpAttribute;
};

export type DpAttributeFailure = DpAttributeFailureInterface & {
  __typename?: 'DpAttributeFailure';
  key: Scalars['String']['output'];
  /** The reason the saving for this attribute failed. */
  reason: Scalars['String']['output'];
};

export type DpAttributeFailureInterface = {
  key: Scalars['String']['output'];
  /** The reason the saving for this attribute failed. */
  reason: Scalars['String']['output'];
};

export type DpAttributeInput = {
  key: Scalars['String']['input'];
  language: Scalars['String']['input'];
  /** Result from publish attempt */
  publishResult?: InputMaybe<DpPublishResultInput>;
  /** Whether this attribute has been removed from the UI. */
  removed: Scalars['Boolean']['input'];
  value: Scalars['JSON']['input'];
  /** The most recent version number that you, the client, have for this attribute. If you are creating a new attribute, pass zero for the version. */
  version: Scalars['Int']['input'];
};

export type DpAttributeInterface = {
  asinObject?: Maybe<Asin>;
  /** Issues returned from getView during validation */
  issues?: Maybe<Array<Scalars['JSON']['output']>>;
  key: Scalars['String']['output'];
  language: Scalars['String']['output'];
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  modifiedAt: Scalars['String']['output'];
  modifiedBy: Scalars['String']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  /** Whether this attribute has been removed from the UI. */
  removed: Scalars['Boolean']['output'];
  value: Scalars['JSON']['output'];
  /** The latest version of this attribute */
  version: Scalars['Int']['output'];
};

export type DpAttributeWithError = DpAttributeInterface & {
  __typename?: 'DpAttributeWithError';
  asinObject?: Maybe<Asin>;
  /** Error information if the attribute failed to publish */
  error?: Maybe<BulkPublishV2Error>;
  /** Issues returned from getView during validation */
  issues?: Maybe<Array<Scalars['JSON']['output']>>;
  key: Scalars['String']['output'];
  language: Scalars['String']['output'];
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  modifiedAt: Scalars['String']['output'];
  modifiedBy: Scalars['String']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  /** Whether this attribute has been removed from the UI. */
  removed: Scalars['Boolean']['output'];
  value: Scalars['JSON']['output'];
  /** The latest version of this attribute */
  version: Scalars['Int']['output'];
};

export type DpAttributesMutationResponse = MutationResponse & {
  __typename?: 'DpAttributesMutationResponse';
  asin?: Maybe<Asin>;
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  failed: Array<DpAttributeFailure>;
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  succeeded: Array<DpAttribute>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type DpBulletsVariant = DpExperimentVariantInterface & {
  __typename?: 'DpBulletsVariant';
  /** The feature bullets string values for this variant */
  bulletStrings: Array<Scalars['String']['output']>;
  /** Whether the bullets were generated by AI */
  genaiBulletStrings?: Maybe<Array<Scalars['Boolean']['output']>>;
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  /** The locale for the bullets strings */
  locale: Scalars['String']['output'];
  /** Whether or not this variant has been previewed */
  previewed: Scalars['Boolean']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  /** Unique ID used in the sort key for variant items */
  uniqueReferenceId: Scalars['ID']['output'];
  /** The ISO timestamp of when this variant was last updated */
  updatedAt: Scalars['String']['output'];
  /** The alias of the user that last updated this variant */
  updatedBy: Scalars['String']['output'];
  /** The ID of the variant - V1 (control), V2, V3, etc */
  variantId: Scalars['Int']['output'];
  /** The name of the variant group provided by user */
  variantName?: Maybe<Scalars['String']['output']>;
  /** The latest version of this variant */
  version: Scalars['Int']['output'];
};

export type DpBulletsVariantInput = {
  /** The ASIN that the variant is being configured for */
  asin: Scalars['String']['input'];
  /** The feature bullets string values for this variant */
  bulletStrings: Array<Scalars['String']['input']>;
  /** Whether the bullets were generated by AI */
  genaiBulletStrings?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** The locale for the bullets strings */
  locale: Scalars['String']['input'];
  /** Whether or not this variant has been previewed */
  previewed?: Scalars['Boolean']['input'];
  /** Unique ID used in the sort key for variant items */
  uniqueReferenceId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the variant - V1 (control), V2, V3, etc */
  variantId: Scalars['Int']['input'];
};

export type DpBulletsVariantInputV2 = {
  /** The ASIN that the variant is being configured for */
  asin: Scalars['String']['input'];
  /** The feature bullets string values for this variant */
  bulletStrings: Array<Scalars['String']['input']>;
  /** The locale for the bullets strings */
  locale: Scalars['String']['input'];
  /** The ID of the variant group */
  variantId: Scalars['ID']['input'];
  /** The name of the variant */
  variantName: Scalars['String']['input'];
  /** The ID of the variant - V1 (control), V2, V3, etc */
  variantPosition: Scalars['Int']['input'];
};

export type DpBulletsVariantV2 = DpExperimentVariantInterfaceV2 & {
  __typename?: 'DpBulletsVariantV2';
  /** The feature bullets string values for this variant */
  bulletStrings: Array<Scalars['String']['output']>;
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  /** The locale for the bullets strings */
  locale: Scalars['String']['output'];
  /** Whether or not this variant has been previewed */
  previewed: Scalars['Boolean']['output'];
  /** The status of this variant */
  status?: Maybe<DpExperimentVariantStatus>;
  /** Unique ID of the variant item */
  uniqueReferenceId: Scalars['ID']['output'];
  /** The ISO timestamp of when this variant was last updated */
  updatedAt: Scalars['String']['output'];
  /** The alias of the user that last updated this variant */
  updatedBy: Scalars['String']['output'];
  /** The ID of the variant group */
  variantId: Scalars['ID']['output'];
  /** The name of the variant group provided by user */
  variantName: Scalars['String']['output'];
  /** Order/The ID of the variant - V1 (control), V2, V3, etc */
  variantPosition: Scalars['Int']['output'];
};

export type DpCopyMutationResponse = MutationResponse & {
  __typename?: 'DpCopyMutationResponse';
  asin: Scalars['String']['output'];
  attributesFailed: Array<DpAttributeCopyFailure>;
  attributesSucceeded: Array<DpAttributeCopyResponse>;
  campaignCopyErrors: Array<Scalars['String']['output']>;
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  marketplace: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  pricingFailed: Array<PricingInfoCopyFailure>;
  pricingSucceeded: Array<PricingInfoCopyResponse>;
  slatesFailed: Array<SlateImageCopyFailure>;
  slatesSucceeded: Array<SlateImageCopyResponse>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type DpDuplicateExperimentResponse = MutationResponse & {
  __typename?: 'DpDuplicateExperimentResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** the ID of the newly created experiment */
  dpbExperimentId?: Maybe<Scalars['String']['output']>;
  /** the experimentType of the newly created experiment */
  experimentType?: Maybe<Scalars['String']['output']>;
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type DpExperimentAsinVariants = {
  __typename?: 'DpExperimentAsinVariants';
  bullets: Array<DpBulletsVariant>;
  landingImages: Array<DpLandingImageVariant>;
  structuredTitles: Array<DpStructuredTitleVariant>;
  titles: Array<DpTitleVariant>;
};

export type DpExperimentAsinVariantsMap = {
  __typename?: 'DpExperimentAsinVariantsMap';
  /** Map of ASINs to DpExperimentAsinVariants */
  asinToVariantsMap?: Maybe<Scalars['JSON']['output']>;
};

export type DpExperimentAsinVariantsV2 = {
  __typename?: 'DpExperimentAsinVariantsV2';
  bullets: Array<DpBulletsVariantV2>;
  landingImages: Array<DpLandingImageVariantV2>;
  titles: Array<DpTitleVariantV2>;
};

export enum DpExperimentContextualCohortType {
  Partition = 'PARTITION',
  Set = 'SET'
}

export type DpExperimentDetails = DpExperimentDetailsInterface & {
  __typename?: 'DpExperimentDetails';
  /** The activation date for the experiment */
  activationDate?: Maybe<Scalars['String']['output']>;
  /** For contextual MVT experiments only, the bullseye segments for the cohorts of the experiment */
  bullseyeSegments?: Maybe<Array<BullseyeSegmentInfo>>;
  /** For contextual MVT experiments only, the type of cohorts - SET | PARTITION */
  contextualCohortType?: Maybe<Scalars['String']['output']>;
  /** Defines the control configuration - none | catalogControl | banditBasedLift */
  controlConfigurationType?: Maybe<Scalars['String']['output']>;
  /** The ISO timestamp of when the experiment was created */
  createdAt: Scalars['String']['output'];
  /** The alias of the user that created the experiment */
  createdBy: Scalars['String']['output'];
  /** A list of Cumulative Gain Reporting metrics for an experiment */
  cumulativeGainMetrics?: Maybe<Array<CumulativeGainMetric>>;
  /** The deactivation date for the experiment */
  deactivationDate?: Maybe<Scalars['String']['output']>;
  /** The description of the DetailPage experiment */
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the experiment */
  dpbExperimentId: Scalars['ID']['output'];
  /** The type of experiment - CONTEXTUAL_MVT | NON_CONTEXTUAL_MVT | AB */
  experimentType: Scalars['String']['output'];
  /** Defines the hash dimension for the experiment. sessionId if not defined. - sessionId | obfuscatedCustomerId */
  hashDimension?: Maybe<Scalars['String']['output']>;
  /** True if the primary ASIN is a parent, false otherwise */
  isPrimaryParent?: Maybe<Scalars['Boolean']['output']>;
  /** A hash of the experiment to detect modifications to fields that allow a republish */
  lastPublishedExperimentHash?: Maybe<Scalars['String']['output']>;
  /** The locale(s) for the marketplace where the experiment is being conducted */
  locales: Array<Scalars['String']['output']>;
  /** The marketplace(s) where the experiment is being conducted */
  marketplaces: Array<Scalars['String']['output']>;
  /** The MVES experiment IDs for the marketplaces / locales the experiment is being conducted */
  mvesExperimentIds?: Maybe<Scalars['JSON']['output']>;
  /** The Iotalab experiment ID for the MVES experiment */
  mvesIotalabId?: Maybe<Scalars['String']['output']>;
  /** A map between MVES experiment IDs and the results from publishing those experiments */
  mvesPublishResults?: Maybe<Scalars['JSON']['output']>;
  /** The name of the DetailPage experiment */
  name: Scalars['String']['output'];
  /** The primary ASIN for the experiment */
  primaryAsin?: Maybe<Scalars['String']['output']>;
  /** The prouct line experiment belongs to */
  productLine?: Maybe<Scalars['String']['output']>;
  /** The program name experiment belongs to */
  program?: Maybe<Scalars['String']['output']>;
  /** The current status of the experiment */
  status: Scalars['String']['output'];
  /** A map between MVES experiment IDs and the experiment summary for those experiments */
  summaryInfos?: Maybe<Scalars['JSON']['output']>;
  /** The ISO timestamp of when the experiment was last updated */
  updatedAt: Scalars['String']['output'];
  /** The alias of the user that last updated the experiment */
  updatedBy: Scalars['String']['output'];
  /** The variational ASINs of the experiment */
  variationalAsins?: Maybe<Array<Scalars['String']['output']>>;
};


export type DpExperimentDetailsCumulativeGainMetricsArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type DpExperimentDetailsCreateInput = {
  /** The description of the DetailPage experiment */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The type of experiment - CONTEXTUAL_MVT | NON_CONTEXTUAL_MVT | AB */
  experimentType: Scalars['String']['input'];
  /** The locale(s) for the marketplace where the experiment is being conducted */
  locales: Array<Scalars['String']['input']>;
  /** The marketplace(s) where the experiment is being conducted */
  marketplaces: Array<Scalars['String']['input']>;
  /** The name of the DetailPage experiment */
  name: Scalars['String']['input'];
  /** The program of the detial page exeriment */
  program?: InputMaybe<Scalars['String']['input']>;
};

export type DpExperimentDetailsCreateInputV2 = {
  /** The type of experiment - MVT | AB */
  experimentType: DpExperimentType;
  marketplaceConfigs: Array<MarketplaceExperimentInput>;
  /** The program of the detial page exeriment */
  programId: Scalars['String']['input'];
};

export type DpExperimentDetailsDeactivateInputV2 = {
  /** The deactivation date for the experiment */
  deactivationDate?: InputMaybe<Scalars['String']['input']>;
  /** The experimentId of the detail page experiment */
  experimentId: Scalars['ID']['input'];
  /** Marketplaces to schedule */
  marketplaces: Array<Scalars['String']['input']>;
};

export type DpExperimentDetailsInterface = {
  /** The activation date for the experiment */
  activationDate?: Maybe<Scalars['String']['output']>;
  /** Defines the control configuration - none | catalogControl | banditBasedLift */
  controlConfigurationType?: Maybe<Scalars['String']['output']>;
  /** The ISO timestamp of when the experiment was created */
  createdAt: Scalars['String']['output'];
  /** The alias of the user that created the experiment */
  createdBy: Scalars['String']['output'];
  /** A list of Cumulative Gain Reporting metrics for an experiment */
  cumulativeGainMetrics?: Maybe<Array<CumulativeGainMetric>>;
  /** The deactivation date for the experiment */
  deactivationDate?: Maybe<Scalars['String']['output']>;
  /** The description of the DetailPage experiment */
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the experiment */
  dpbExperimentId: Scalars['ID']['output'];
  /** The type of experiment - CONTEXTUAL_MVT | NON_CONTEXTUAL_MVT | AB */
  experimentType: Scalars['String']['output'];
  /** Defines the hash dimension for the experiment. sessionId if not defined. - sessionId | obfuscatedCustomerId */
  hashDimension?: Maybe<Scalars['String']['output']>;
  /** True if the primary ASIN is a parent, false otherwise */
  isPrimaryParent?: Maybe<Scalars['Boolean']['output']>;
  /** A hash of the experiment to detect modifications to fields that allow a republish */
  lastPublishedExperimentHash?: Maybe<Scalars['String']['output']>;
  /** The locale(s) for the marketplace where the experiment is being conducted */
  locales: Array<Scalars['String']['output']>;
  /** The marketplace(s) where the experiment is being conducted */
  marketplaces: Array<Scalars['String']['output']>;
  /** The MVES experiment IDs for the marketplaces / locales the experiment is being conducted */
  mvesExperimentIds?: Maybe<Scalars['JSON']['output']>;
  /** The Iotalab experiment ID for the MVES experiment */
  mvesIotalabId?: Maybe<Scalars['String']['output']>;
  /** A map between MVES experiment IDs and the results from publishing those experiments */
  mvesPublishResults?: Maybe<Scalars['JSON']['output']>;
  /** The name of the DetailPage experiment */
  name: Scalars['String']['output'];
  /** The primary ASIN for the experiment */
  primaryAsin?: Maybe<Scalars['String']['output']>;
  /** The prouct line experiment belongs to */
  productLine?: Maybe<Scalars['String']['output']>;
  /** The program name experiment belongs to */
  program?: Maybe<Scalars['String']['output']>;
  /** The current status of the experiment */
  status: Scalars['String']['output'];
  /** A map between MVES experiment IDs and the experiment summary for those experiments */
  summaryInfos?: Maybe<Scalars['JSON']['output']>;
  /** The ISO timestamp of when the experiment was last updated */
  updatedAt: Scalars['String']['output'];
  /** The alias of the user that last updated the experiment */
  updatedBy: Scalars['String']['output'];
  /** The variational ASINs of the experiment */
  variationalAsins?: Maybe<Array<Scalars['String']['output']>>;
};


export type DpExperimentDetailsInterfaceCumulativeGainMetricsArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type DpExperimentDetailsPublishInputV2 = {
  /** The activation date for the experiment */
  activationDate: Scalars['String']['input'];
  /** The deactivation date for the experiment */
  deactivationDate: Scalars['String']['input'];
  /** The experimentId of the detail page experiment */
  experimentId: Scalars['ID']['input'];
};

export type DpExperimentDetailsScheduleInputV2 = {
  /** The activation date for the experiment */
  activationDate?: InputMaybe<Scalars['String']['input']>;
  /** The deactivation date for the experiment */
  deactivationDate?: InputMaybe<Scalars['String']['input']>;
  /** The experimentId of the detail page experiment */
  experimentId: Scalars['ID']['input'];
  /** Marketplaces to schedule */
  marketplaces: Array<Scalars['String']['input']>;
};

export type DpExperimentDetailsUpdateInput = {
  /** The activation date for the experiment */
  activationDate?: InputMaybe<Scalars['String']['input']>;
  /** For contextual MVT experiments only, the bullseye segments for the cohorts of the experiment */
  bullseyeSegments?: InputMaybe<Array<BullseyeSegmentInfoInput>>;
  /** For contextual MVT experiments only, the type of cohorts - SET | PARTITION */
  contextualCohortType?: InputMaybe<Scalars['String']['input']>;
  /** Defines the control configuration - none | catalogControl | banditBasedLift */
  controlConfigurationType?: InputMaybe<Scalars['String']['input']>;
  /** The deactivation date for the experiment */
  deactivationDate?: InputMaybe<Scalars['String']['input']>;
  /** The description of the DetailPage experiment */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Defines the hash dimension for the experiment. sessionId if not defined. - sessionId | obfuscatedCustomerId */
  hashDimension?: InputMaybe<Scalars['String']['input']>;
  /** A hash of the experiment to detect modifications to fields that allow a republish */
  lastPublishedExperimentHash?: InputMaybe<Scalars['String']['input']>;
  /** The locale(s) for the marketplace where the experiment is being conducted */
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The marketplace(s) where the experiment is being conducted */
  marketplaces?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The MVES experiment IDs for the marketplaces / locales the experiment is being conducted */
  mvesExperimentIds?: InputMaybe<Scalars['JSON']['input']>;
  /** The Iotalab experiment ID for the MVES experiment */
  mvesIotalabId?: InputMaybe<Scalars['String']['input']>;
  /** A map between MVES experiment IDs and the results from publishing those experiments */
  mvesPublishResults?: InputMaybe<Scalars['JSON']['input']>;
  /** The name of the DetailPage experiment */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The primary ASIN for the experiment */
  primaryAsin?: InputMaybe<Scalars['String']['input']>;
  /** The DPB experiment status */
  status?: InputMaybe<DpExperimentStatus>;
  /** The variational ASINs of the experiment */
  variationalAsins?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DpExperimentDetailsUpdateInputV2 = {
  /** The experimentId of the detial page exeriment */
  experimentId: Scalars['ID']['input'];
  marketplaceConfigs: Array<MarketplaceExperimentInput>;
};

export type DpExperimentDetailsV2 = DpExperimentDetailsV2Interface & {
  __typename?: 'DpExperimentDetailsV2';
  /** The ISO timestamp of when the experiment was created */
  createdAt: Scalars['String']['output'];
  /** The alias of the user that created the experiment */
  createdBy: Scalars['String']['output'];
  /** The type of experiment - MVT | AB */
  experimentType: Scalars['String']['output'];
  /** The ID of the experiment (DCS vertex ID) */
  id: Scalars['ID']['output'];
  /** The marketplace experiment configuration */
  marketplaceExperimentConfig: Array<MarketplaceExperimentConfig>;
  /** The MVES experiment associated with this DPB experiment */
  mvesExperimentId?: Maybe<Scalars['String']['output']>;
  /** The product line  experiment belongs to */
  productLine: ProductLine2;
  /** The program name experiment belongs to */
  program: Program;
  status: Scalars['String']['output'];
  /** The ISO timestamp of when the experiment was last updated */
  updatedAt: Scalars['String']['output'];
  /** The alias of the user that last updated the experiment */
  updatedBy: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type DpExperimentDetailsV2Interface = {
  /** The ISO timestamp of when the experiment was created */
  createdAt: Scalars['String']['output'];
  /** The alias of the user that created the experiment */
  createdBy: Scalars['String']['output'];
  /** The type of experiment - MVT | AB */
  experimentType: Scalars['String']['output'];
  /** The ID of the experiment (DCS vertex ID) */
  id: Scalars['ID']['output'];
  /** The marketplace experiment configuration */
  marketplaceExperimentConfig: Array<MarketplaceExperimentConfig>;
  /** The MVES experiment associated with this DPB experiment */
  mvesExperimentId?: Maybe<Scalars['String']['output']>;
  /** The product line  experiment belongs to */
  productLine: ProductLine2;
  /** The program name experiment belongs to */
  program: Program;
  status: Scalars['String']['output'];
  /** The ISO timestamp of when the experiment was last updated */
  updatedAt: Scalars['String']['output'];
  /** The alias of the user that last updated the experiment */
  updatedBy: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export enum DpExperimentFeatures {
  FeatureBullet = 'FEATURE_BULLET',
  LandingImage = 'LANDING_IMAGE',
  Title = 'TITLE'
}

export type DpExperimentGeneratedExperimentContentContextInput = {
  /** Audience for content */
  audience: Scalars['String']['input'];
  /** Emphases for generated content */
  highlight: Scalars['String']['input'];
  /** Number of pieces of content */
  quantity: Scalars['Int']['input'];
  /** Temperature for model */
  temperature: Scalars['Float']['input'];
  /** Themes to influence generation */
  theme: Scalars['String']['input'];
  /** Top P for model */
  top_p: Scalars['Float']['input'];
};

export type DpExperimentGeneratedExperimentContentResponse = {
  __typename?: 'DpExperimentGeneratedExperimentContentResponse';
  /** Error message in case content could not be generated */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Generated content */
  generatedContent?: Maybe<Array<Scalars['String']['output']>>;
};

export type DpExperimentHashResponse = {
  __typename?: 'DpExperimentHashResponse';
  /** hash of an experiment */
  hash?: Maybe<Scalars['String']['output']>;
};

export enum DpExperimentStatus {
  Activated = 'Activated',
  ActivationError = 'ActivationError',
  Archived = 'Archived',
  Deactivated = 'Deactivated',
  Deleted = 'Deleted',
  Draft = 'Draft',
  PublishError = 'PublishError',
  PublishInProgress = 'PublishInProgress',
  Published = 'Published',
  Scheduled = 'Scheduled',
  ValidationError = 'ValidationError',
  ValidationInProgress = 'ValidationInProgress'
}

export enum DpExperimentType {
  Ab = 'AB',
  Mvt = 'MVT'
}

export type DpExperimentVariantInterface = {
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  /** Whether or not this variant has been previewed */
  previewed: Scalars['Boolean']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  /** Unique ID used in the sort key for variant items */
  uniqueReferenceId: Scalars['ID']['output'];
  /** The ISO timestamp of when this variant was last updated */
  updatedAt: Scalars['String']['output'];
  /** The alias of the user that last updated this variant */
  updatedBy: Scalars['String']['output'];
  /** The ID of the variant - V1 (control), V2, V3, etc */
  variantId: Scalars['Int']['output'];
  /** The name of the variant group provided by user */
  variantName?: Maybe<Scalars['String']['output']>;
  /** The latest version of this variant */
  version: Scalars['Int']['output'];
};

export type DpExperimentVariantInterfaceV2 = {
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  /** The locale for the bullets strings */
  locale: Scalars['String']['output'];
  /** Whether or not this variant has been previewed */
  previewed: Scalars['Boolean']['output'];
  /** The status of this variant */
  status?: Maybe<DpExperimentVariantStatus>;
  /** Unique ID of the variant item */
  uniqueReferenceId: Scalars['ID']['output'];
  /** The ISO timestamp of when this variant was last updated */
  updatedAt: Scalars['String']['output'];
  /** The alias of the user that last updated this variant */
  updatedBy: Scalars['String']['output'];
  /** The ID of the variant group */
  variantId: Scalars['ID']['output'];
  /** The name of the variant group provided by user */
  variantName: Scalars['String']['output'];
  /** Order/The ID of the variant - V1 (control), V2, V3, etc */
  variantPosition: Scalars['Int']['output'];
};

export enum DpExperimentVariantStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Deleted = 'DELETED',
  Draft = 'DRAFT'
}

export enum DpLandingImagePlatform {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export type DpLandingImageVariant = DpExperimentVariantInterface & DpLandingImageVariantInterface & {
  __typename?: 'DpLandingImageVariant';
  /** The Journeys asset ID of this image */
  assetId: Scalars['String']['output'];
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  /** The media central variant for this image (e.g. MX01) */
  mcVariant?: Maybe<Scalars['String']['output']>;
  /** The platform this image was uploaded for */
  platform: DpLandingImagePlatform;
  /** Whether or not this variant has been previewed */
  previewed: Scalars['Boolean']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  /** The shipment ID returned from media central after publishing this image */
  shipmentId?: Maybe<Scalars['String']['output']>;
  /** Unique ID used in the sort key for variant items */
  uniqueReferenceId: Scalars['ID']['output'];
  /** The ISO timestamp of when this variant was last updated */
  updatedAt: Scalars['String']['output'];
  /** The alias of the user that last updated this variant */
  updatedBy: Scalars['String']['output'];
  /** An optional URL to the image to be used */
  url?: Maybe<Scalars['String']['output']>;
  /** The ID of the variant - V1 (control), V2, V3, etc */
  variantId: Scalars['Int']['output'];
  /** The name of the variant group provided by user */
  variantName?: Maybe<Scalars['String']['output']>;
  /** The latest version of this variant */
  version: Scalars['Int']['output'];
};

export type DpLandingImageVariantInput = {
  /** The ASIN that the variant is being configured for */
  asin: Scalars['String']['input'];
  /** The Journeys asset ID of this image */
  assetId: Scalars['String']['input'];
  /** The media central variant for this image (e.g. MX01) */
  mcVariant: Scalars['String']['input'];
  /** The platform this image was uploaded for */
  platform: DpLandingImagePlatform;
  /** Whether or not this variant has been previewed */
  previewed?: Scalars['Boolean']['input'];
  /** Whether this image has been removed on the UI */
  removed: Scalars['Boolean']['input'];
  /** Shipment ID returned from Wharf after publishing */
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID used in the sort key for variant items */
  uniqueReferenceId?: InputMaybe<Scalars['String']['input']>;
  /** An optional URL to the image to be used */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the variant - V1 (control), V2, V3, etc */
  variantId: Scalars['Int']['input'];
};

export type DpLandingImageVariantInputV2 = {
  /** An optional image alternative text to be used */
  altText?: InputMaybe<Scalars['String']['input']>;
  /** The ASIN that the variant is being configured for */
  asin: Scalars['String']['input'];
  /** The ID of the asset for the variant */
  assetId: Scalars['String']['input'];
  /** The locale for the bullets strings */
  locale: Scalars['String']['input'];
  /** The platform this image was uploaded for */
  platform: DpLandingImagePlatform;
  /** An optional URL to the image to be used */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the variant group */
  variantId: Scalars['ID']['input'];
  /** The name of the variant */
  variantName: Scalars['String']['input'];
  /** The ID of the variant - V1 (control), V2, V3, etc */
  variantPosition: Scalars['Int']['input'];
};

export type DpLandingImageVariantInterface = {
  /** The Journeys asset ID of this image */
  assetId: Scalars['String']['output'];
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  /** The media central variant for this image (e.g. MX01) */
  mcVariant?: Maybe<Scalars['String']['output']>;
  /** The platform this image was uploaded for */
  platform: DpLandingImagePlatform;
  /** Whether or not this variant has been previewed */
  previewed: Scalars['Boolean']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  /** The shipment ID returned from media central after publishing this image */
  shipmentId?: Maybe<Scalars['String']['output']>;
  /** Unique ID used in the sort key for variant items */
  uniqueReferenceId: Scalars['ID']['output'];
  /** The ISO timestamp of when this variant was last updated */
  updatedAt: Scalars['String']['output'];
  /** The alias of the user that last updated this variant */
  updatedBy: Scalars['String']['output'];
  /** An optional URL to the image to be used */
  url?: Maybe<Scalars['String']['output']>;
  /** The ID of the variant - V1 (control), V2, V3, etc */
  variantId: Scalars['Int']['output'];
  /** The name of the variant group provided by user */
  variantName?: Maybe<Scalars['String']['output']>;
  /** The latest version of this variant */
  version: Scalars['Int']['output'];
};

export type DpLandingImageVariantV2 = DpExperimentVariantInterfaceV2 & {
  __typename?: 'DpLandingImageVariantV2';
  /** The Journeys asset ID of this image */
  assetId: Scalars['String']['output'];
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  /** The locale for the bullets strings */
  locale: Scalars['String']['output'];
  /** The media central variant for this image (e.g. MX01) */
  mcVariant?: Maybe<Scalars['String']['output']>;
  /** The platform this image was uploaded for */
  platform: DpLandingImagePlatform;
  /** Whether or not this variant has been previewed */
  previewed: Scalars['Boolean']['output'];
  /** The shipment ID returned from media central after publishing this image */
  shipmentId?: Maybe<Scalars['String']['output']>;
  /** The status of this variant */
  status?: Maybe<DpExperimentVariantStatus>;
  /** Unique ID of the variant item */
  uniqueReferenceId: Scalars['ID']['output'];
  /** The ISO timestamp of when this variant was last updated */
  updatedAt: Scalars['String']['output'];
  /** The alias of the user that last updated this variant */
  updatedBy: Scalars['String']['output'];
  /** An optional URL to the image to be used */
  url?: Maybe<Scalars['String']['output']>;
  /** The ID of the variant group */
  variantId: Scalars['ID']['output'];
  /** The name of the variant group provided by user */
  variantName: Scalars['String']['output'];
  /** Order/The ID of the variant - V1 (control), V2, V3, etc */
  variantPosition: Scalars['Int']['output'];
};

export type DpPublishResult = {
  __typename?: 'DpPublishResult';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  result: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DpPublishResultInput = {
  result: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
};

export type DpStructuredTitleVariant = DpExperimentVariantInterface & {
  __typename?: 'DpStructuredTitleVariant';
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  /** The locale for the structured title */
  locale: Scalars['String']['output'];
  /** Whether or not this variant has been previewed */
  previewed: Scalars['Boolean']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  /** The title differentor strings for this variant */
  titleDifferentiators: Array<Scalars['String']['output']>;
  /** The title identification string for this variant */
  titleIdentification: Scalars['String']['output'];
  /** Unique ID used in the sort key for variant items */
  uniqueReferenceId: Scalars['ID']['output'];
  /** The ISO timestamp of when this variant was last updated */
  updatedAt: Scalars['String']['output'];
  /** The alias of the user that last updated this variant */
  updatedBy: Scalars['String']['output'];
  /** The ID of the variant - V1 (control), V2, V3, etc */
  variantId: Scalars['Int']['output'];
  /** The name of the variant group provided by user */
  variantName?: Maybe<Scalars['String']['output']>;
  /** The latest version of this variant */
  version: Scalars['Int']['output'];
};

export type DpStructuredTitleVariantInput = {
  /** The ASIN that the variant is being configured for */
  asin: Scalars['String']['input'];
  /** The locale for the structured title */
  locale: Scalars['String']['input'];
  /** Whether or not this variant has been previewed */
  previewed?: Scalars['Boolean']['input'];
  /** The title differentiators strings for this variant */
  titleDifferentiators: Array<Scalars['String']['input']>;
  /** The title identification string for this variant */
  titleIdentification: Scalars['String']['input'];
  /** Unique ID used in the sort key for variant items */
  uniqueReferenceId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the variant - V1 (control), V2, V3, etc */
  variantId: Scalars['Int']['input'];
};

export type DpTitleVariant = DpExperimentVariantInterface & {
  __typename?: 'DpTitleVariant';
  /** Whether the title was generated by AI */
  genaiTitleString?: Maybe<Scalars['Boolean']['output']>;
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  /** The locale for the title string */
  locale: Scalars['String']['output'];
  /** Whether or not this variant has been previewed */
  previewed: Scalars['Boolean']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  /** The title string value for this variant */
  titleString: Scalars['String']['output'];
  /** Unique ID used in the sort key for variant items */
  uniqueReferenceId: Scalars['ID']['output'];
  /** The ISO timestamp of when this variant was last updated */
  updatedAt: Scalars['String']['output'];
  /** The alias of the user that last updated this variant */
  updatedBy: Scalars['String']['output'];
  /** The ID of the variant - V1 (control), V2, V3, etc */
  variantId: Scalars['Int']['output'];
  /** The name of the variant group provided by user */
  variantName?: Maybe<Scalars['String']['output']>;
  /** The latest version of this variant */
  version: Scalars['Int']['output'];
};

export type DpTitleVariantInput = {
  /** The ASIN that the variant is being configured for */
  asin: Scalars['String']['input'];
  /** Whether the title was generated by AI */
  genaiTitleString?: InputMaybe<Scalars['Boolean']['input']>;
  /** The locale for the title string */
  locale: Scalars['String']['input'];
  /** Whether or not this variant has been previewed */
  previewed?: Scalars['Boolean']['input'];
  /** The title string value for this variant */
  titleString: Scalars['String']['input'];
  /** Unique ID used in the sort key for variant items */
  uniqueReferenceId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the variant - V1 (control), V2, V3, etc */
  variantId: Scalars['Int']['input'];
};

export type DpTitleVariantInputV2 = {
  /** The ASIN that the variant is being configured for */
  asin: Scalars['String']['input'];
  /** The locale for the title string */
  locale: Scalars['String']['input'];
  /** The title string value for this variant */
  titleString: Scalars['String']['input'];
  /** The ID of the variant group */
  variantId: Scalars['ID']['input'];
  /** The name of the variant */
  variantName: Scalars['String']['input'];
  /** The ID of the variant - V1 (control), V2, V3, etc */
  variantPosition: Scalars['Int']['input'];
};

export type DpTitleVariantV2 = DpExperimentVariantInterfaceV2 & {
  __typename?: 'DpTitleVariantV2';
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  /** The locale for the bullets strings */
  locale: Scalars['String']['output'];
  /** Whether or not this variant has been previewed */
  previewed: Scalars['Boolean']['output'];
  /** The status of this variant */
  status?: Maybe<DpExperimentVariantStatus>;
  /** The title string value for this variant */
  titleString: Scalars['String']['output'];
  /** Unique ID of the variant item */
  uniqueReferenceId: Scalars['ID']['output'];
  /** The ISO timestamp of when this variant was last updated */
  updatedAt: Scalars['String']['output'];
  /** The alias of the user that last updated this variant */
  updatedBy: Scalars['String']['output'];
  /** The ID of the variant group */
  variantId: Scalars['ID']['output'];
  /** The name of the variant group provided by user */
  variantName: Scalars['String']['output'];
  /** Order/The ID of the variant - V1 (control), V2, V3, etc */
  variantPosition: Scalars['Int']['output'];
};

export type DpVariantDeleteInputV2 = {
  /** The feature that the variant is being deleted from */
  featureName: DpExperimentFeatures;
  /** The ID of the variant */
  variantId: Scalars['String']['input'];
};

export type DropExperimentResponse = {
  __typename?: 'DropExperimentResponse';
  /** The id of the dropped experiment */
  id?: Maybe<Scalars['String']['output']>;
};

export type EchoString = {
  __typename?: 'EchoString';
  string?: Maybe<Scalars['String']['output']>;
};

/** Contains marketplace specific data for placement eligibility criteria for a Journeys placement. */
export type EligibilityCriteriaMarketplace = {
  __typename?: 'EligibilityCriteriaMarketplace';
  /** List of ASINs to which this placement is scheduled */
  asins?: Maybe<Array<Scalars['String']['output']>>;
  /** List of IDs of browse nodes to which this placement is scheduled */
  browseNodes?: Maybe<Array<Scalars['String']['output']>>;
  /** List of Bullseye segment IDs. A customer must *not* be in one of these segments to see the placement. */
  bullseyeExcludes: Array<Scalars['BullseyeSegmentID']['output']>;
  /** List of Bullseye segment IDs. A customer must be in one of these segments to see the placement. */
  bullseyeIncludes: Array<Scalars['BullseyeSegmentID']['output']>;
  /** List of category node IDs to which this placement is scheduled, used for landing page */
  categoryNode?: Maybe<Array<Scalars['String']['output']>>;
  /** List of DDS ASIN groups to which this placement is scheduled */
  ddsAsinGroups?: Maybe<Array<Scalars['String']['output']>>;
  /** Marketplace this data applies to (e.g. US, CA). */
  marketplace: Scalars['String']['output'];
  /** List of PageIds required by SPP mini page */
  subscriptionProductPageIds?: Maybe<Array<Scalars['String']['output']>>;
  timeRange?: Maybe<TrafficDateRange>;
};

/** Contains marketplace specific data for placement eligibility criteria for a Journeys placement. */
export type EligibilityCriteriaMarketplaceInput = {
  /** List of ASINs to which this placement is scheduled */
  asins?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of IDs of browse nodes to which this placement is scheduled */
  browseNodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of Bullseye segment IDs. A customer must *not* be in one of these segments to see the placement. */
  bullseyeExcludes: Array<Scalars['BullseyeSegmentID']['input']>;
  /** List of Bullseye segment IDs. A customer must be in one of these segments to see the placement. */
  bullseyeIncludes: Array<Scalars['BullseyeSegmentID']['input']>;
  /** List of category node IDs to which this placement is scheduled, used for landing page */
  categoryNode?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of DDS ASIN groups to which this placement is scheduled */
  ddsAsinGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Marketplace this data applies to (e.g. US, CA). */
  marketplace: Scalars['String']['input'];
  /** List of PageIds required by SPP mini page */
  subscriptionProductPageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  timeRange?: InputMaybe<TrafficDateRangeInput>;
};

/** Contains platform specific data for placement eligibility criteria for a Journeys placement. */
export type EligibilityCriteriaPlatform = {
  __typename?: 'EligibilityCriteriaPlatform';
  /** Platform this data applies to (e.g. DESKTOP, MOBILE). */
  platform: Scalars['String']['output'];
  /** Which slots this platform will target. Does not necessarily correspond to the exact slots it will appear on when rendered. */
  slots: Array<Scalars['String']['output']>;
  useDefault?: Maybe<Scalars['Boolean']['output']>;
};

/** Contains platform specific data for placement eligibility criteria for a Journeys placement. */
export type EligibilityCriteriaPlatformInput = {
  /** Platform this data applies to (e.g. DESKTOP, MOBILE). */
  platform: Scalars['String']['input'];
  /** Which slots this platform will target. Does not necessarily correspond to the exact slots it will appear on when rendered. */
  slots?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, the slots field value will use default values from the campaign placement defaults. */
  useDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmptyCampaignMutationResponse = {
  __typename?: 'EmptyCampaignMutationResponse';
  status?: Maybe<Scalars['String']['output']>;
};

/** When ASIN/Marketplace not found in Journeys */
export type ErrorAsinMarketplaceNotFound = {
  __typename?: 'ErrorASINMarketplaceNotFound';
  errorMessage: Scalars['String']['output'];
};

export type EventInput = {
  /** parentEventId of the symphony event */
  parentEventId: Scalars['String']['input'];
  /** timezone selected for the event */
  timezone: Scalars['String']['input'];
};

export type ExistingTrafficCampaignFlavorInput = {
  /** Whether this flavor is still active and visible on the UI */
  active: Scalars['Boolean']['input'];
  /** Journeys form values for this flavor */
  content: Scalars['JSON']['input'];
  /** Name for Symphony creative. */
  creativeName?: InputMaybe<Scalars['String']['input']>;
  /** Flag to auto-generate creative name. Uses campaign name in generation regardless of campaign-name-generation. */
  hasGeneratedName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique ID of this flavor */
  id: Scalars['ID']['input'];
  /** Combined liveState for the flavor. Only supports MCC campaigns. */
  liveState?: InputMaybe<LiveStateType>;
  /** Form inputs for this flavor's scheduling config. */
  scheduling: TrafficFlavorSchedulingInfoInput;
  /** Combined status of this flavors creative and placements. Only supports MCC campaigns. */
  status?: InputMaybe<CampaignState>;
  /** Used by some campaign types to differentiate between flavors with same platform and locale */
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type ExperimentAsinMetadata = {
  __typename?: 'ExperimentAsinMetadata';
  /** Whether the parent ASIN for this experiment is a Devices ASIN */
  isDevicesExperiment: Scalars['Boolean']['output'];
};

export type Fia = JourneysAssetInterface & {
  __typename?: 'FIA';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dimensions?: Maybe<Dimensions>;
  id: Scalars['ID']['output'];
  mediacentralurl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  qaStatus?: Maybe<QaStatusFilterEnum>;
  s3signedurl?: Maybe<Scalars['String']['output']>;
  /** Asset type as returned by JAM (e.g., "FIA", "MediaAsset") */
  type: Scalars['String']['output'];
};

/** Dimension input for a field */
export type FieldDimensionInput = {
  position?: InputMaybe<FieldPositionInput>;
  size?: InputMaybe<FieldSizeInput>;
};

/** Position input for a field */
export type FieldPositionInput = {
  left?: InputMaybe<Scalars['Int']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
};

/** Size input for a field */
export type FieldSizeInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Styling input for a field (including size, color, font, etc) */
export type FieldStyleInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type FileMetadata = {
  __typename?: 'FileMetadata';
  height?: Maybe<Scalars['Int']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originalFileName?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedBy?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type FilterColumnInputType = {
  campaignType?: InputMaybe<Array<Scalars['String']['input']>>;
  createdBy?: InputMaybe<Array<Scalars['String']['input']>>;
  language?: InputMaybe<Array<Scalars['String']['input']>>;
  liveness?: InputMaybe<Array<Scalars['String']['input']>>;
  platform?: InputMaybe<Array<Scalars['String']['input']>>;
  productLine?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FilterOption = {
  __typename?: 'FilterOption';
  count: Scalars['Int']['output'];
  option: Scalars['String']['output'];
};

export type FilterOptionValuesType = {
  __typename?: 'FilterOptionValuesType';
  campaignType: Array<Scalars['String']['output']>;
  createdBy: Array<Scalars['String']['output']>;
  language: Array<Scalars['String']['output']>;
  liveness: Array<Scalars['String']['output']>;
  platform: Array<Scalars['String']['output']>;
  productLine: Array<Scalars['String']['output']>;
  status: Array<Scalars['String']['output']>;
};

/** Represents a flattened image asset (FIA) */
export type FlattenedImageAsset = {
  __typename?: 'FlattenedImageAsset';
  /** height of the FIA asset */
  height?: Maybe<Scalars['Int']['output']>;
  /** The DCS vertex ID of the FIA node */
  id: Scalars['ID']['output'];
  /** name of the FIA asset */
  name?: Maybe<Scalars['String']['output']>;
  /** s3 signed URL to the FIA asset */
  s3SignedUrl?: Maybe<Scalars['String']['output']>;
  /** width of the FIA asset */
  width?: Maybe<Scalars['Int']['output']>;
};

export type GenerateAltTextInput = {
  /** The asset ID for which to generate alt text */
  assetId: Scalars['String']['input'];
  /** The language code for which to generate alt text (e.g. en_US) */
  language: Scalars['String']['input'];
  /** The name of the product associated with the asset */
  productName: Scalars['String']['input'];
};

export type GenerateAltTextOutput = {
  __typename?: 'GenerateAltTextOutput';
  /** The generated alt text for the image */
  altText: Scalars['String']['output'];
};

export type GenerateAssetsResponse = {
  __typename?: 'GenerateAssetsResponse';
  /** The AssetGroup that was generated */
  assetGroup: AssetGroup;
};

export type GetAssetsByIdsInput = {
  /** array of assetIds for which the s3SignedUrl needs to be fetched */
  assetIds: Array<Scalars['String']['input']>;
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
};

export type GetAssetsByIdsOutput = {
  __typename?: 'GetAssetsByIdsOutput';
  assets: Array<AssetSearchResult>;
  /** errors encountered while fetching the s3SignedUrl */
  errors: Array<Scalars['String']['output']>;
};

export type GetFbKeywordRecsInput = {
  /** Proxy deviceProgram list which will be used to generate search keyword recommendation. Current maximum devicePrograms is 3.  */
  devicePrograms: Array<Scalars['String']['input']>;
  /** List of keyword types to filter recommendations */
  keywordTypes: Array<Scalars['String']['input']>;
  /** The marketplace (country code e.g. US) to where devicePrograms are */
  marketplace: Scalars['String']['input'];
};

export type GetFbKeywordRecsResponse = {
  __typename?: 'GetFBKeywordRecsResponse';
  /** Expiration Date for Presigned URL */
  expirationDate: Scalars['DateTime']['output'];
  /** The S3 Presigned URL of the keyword recommendations */
  keywordRecsUrl: Scalars['String']['output'];
};

export type GetHistoryViewBundlesRequest = {
  endDate: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
};

export type GetHistoryViewBundlesResponse = {
  __typename?: 'GetHistoryViewBundlesResponse';
  bundleEntities: Array<BundleEntityOutput>;
  totalEntries: Scalars['Int']['output'];
};

export type ImageFields = {
  __typename?: 'ImageFields';
  altText: Scalars['String']['output'];
  autoGenerateLowResImagePath: Scalars['Boolean']['output'];
  highResAsset: AssetModel;
  lowResAsset?: Maybe<AssetModel>;
};

export type ImageVariant = BaseVariant & {
  __typename?: 'ImageVariant';
  value: ImageFields;
  variantId: Scalars['ID']['output'];
};

export type ImportTrafficEventInput = {
  /** Array of events to import */
  events: Array<EventInput>;
  /** projectId of the traffic-project linked to the symphony event */
  projectId: Scalars['String']['input'];
  /** Realm of the symphony-event */
  realm: SymphonyRealm;
};

export type ImportTrafficEventOutput = {
  __typename?: 'ImportTrafficEventOutput';
  /** The cloned TrafficProject with all the cloned source campaigns, assets and event(if present) */
  project: TrafficProject;
};

export type InitialPlacementValues = {
  __typename?: 'InitialPlacementValues';
  /** Initial container type values */
  containerType?: Maybe<Array<PageTypeEnum>>;
  /** Initial customer options value */
  customerOptions?: Maybe<CustomerOptionsEnum>;
  /** Initial guarantee value */
  guarantee?: Maybe<Scalars['Int']['output']>;
  /** Initial page type value */
  pageType?: Maybe<PageTypeEnum>;
  /** Initial scheduling default value */
  schedulingDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Initial desktop slots */
  slotsDesktop?: Maybe<Array<Scalars['String']['output']>>;
  /** Initial mobile slots */
  slotsMobile?: Maybe<Array<Scalars['String']['output']>>;
  /** Initial platform agnostic slots */
  slotsPlatformAgnostic?: Maybe<Array<Scalars['String']['output']>>;
  /** Initial variant criteria */
  variantCriteria?: Maybe<Array<PlacementGroupVariantCriteria>>;
  /** Initial weblab name */
  weblabName?: Maybe<Scalars['String']['output']>;
  /** Initial weblab treatment */
  weblabTreatment?: Maybe<Scalars['String']['output']>;
};

export type InitialPlacementValuesInput = {
  /** Initial container type values */
  containerType?: InputMaybe<Array<PageTypeEnum>>;
  /** Initial customer options value */
  customerOptions?: InputMaybe<Scalars['String']['input']>;
  /** Initial guarantee value */
  guarantee?: InputMaybe<Scalars['Int']['input']>;
  /** Initial page type value */
  pageType?: InputMaybe<PageTypeEnum>;
  /** Initial scheduling default value */
  schedulingDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Initial desktop slots */
  slotsDesktop?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Initial mobile slots */
  slotsMobile?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Initial platform agnostic slots */
  slotsPlatformAgnostic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Initial variant criteria */
  variantCriteria?: InputMaybe<Array<PlacementGroupVariantCriteriaInput>>;
  /** Initial weblab name */
  weblabName?: InputMaybe<Scalars['String']['input']>;
  /** Initial weblab treatment */
  weblabTreatment?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an ASIN with either missing attributes or resolution error */
export type InvalidAsinWithMissingAttributes = {
  __typename?: 'InvalidAsinWithMissingAttributes';
  /** Resolved ASIN object, or null if not found */
  asinObject?: Maybe<Asin>;
  /** Error information, present only if ASIN could not be resolved */
  error?: Maybe<AsinResolutionError>;
  /** List of missing attributes grouped by language, if ASIN is resolved */
  missingAttributes?: Maybe<Array<MissingAttributesByLanguage>>;
};

export type JagFilterBaseInput = {
  /** JAG IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Project IDs */
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type JagFilterInput = {
  /** has QA comment */
  hasQaComment?: InputMaybe<Scalars['Boolean']['input']>;
  /** JAG IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** JAG name */
  jagName?: InputMaybe<Scalars['String']['input']>;
  /** Locales like "US English" */
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Marketplace IDs */
  marketplaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Project IDs */
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** QA statuses */
  qaStatuses?: InputMaybe<Array<QaStatusFilterEnum>>;
  /** TemplateVariant IDs */
  templateVariantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type JagMetadata = {
  __typename?: 'JAGMetadata';
  jagId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type JagState = {
  __typename?: 'JAGState';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
};

/** Input for a JSON field */
export type JsonFieldCreateInput = {
  /** Dimension input for this field */
  dimension?: InputMaybe<FieldDimensionInput>;
  json?: InputMaybe<Scalars['JSON']['input']>;
  /** Name of the field to set */
  name: Scalars['String']['input'];
  /** Styling input for this field */
  style?: InputMaybe<FieldStyleInput>;
};

/** Input for a JSON field */
export type JsonFieldInput = {
  /** Dimension input for this field */
  dimension?: InputMaybe<FieldDimensionInput>;
  json?: InputMaybe<Scalars['JSON']['input']>;
  /** Layered Image Asset IDs to set this field on */
  layeredImageAssetIds: Array<Scalars['String']['input']>;
  /** Name of the field to set */
  name: Scalars['String']['input'];
  /** Styling input for this field */
  style?: InputMaybe<FieldStyleInput>;
};

/** this are the global Job level errors encountered when you upload, for example the entire job failed  */
export type JobError = {
  __typename?: 'JobError';
  errorMessage: Scalars['String']['output'];
};

export type JobInterface = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the job */
  id: Scalars['ID']['output'];
  status: JobStatus;
};

/** The different types of date filters. */
export enum JobStatus {
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Created = 'CREATED',
  Errored = 'ERRORED',
  InProgress = 'IN_PROGRESS',
  TimedOut = 'TIMED_OUT'
}

export type Jobs = BulkAtfJob | BulkPublishJob | BulkPublishV2Job | MccTransitionJob;

export type JourneysAsset = Fia | MediaAsset;

export type JourneysAssetGroup = {
  __typename?: 'JourneysAssetGroup';
  assets: Array<JourneysAsset>;
  jagMetadata?: Maybe<JagMetadata>;
};

export type JourneysAssetGroupFilterOptionValuesType = {
  __typename?: 'JourneysAssetGroupFilterOptionValuesType';
  hasQaComment: Array<Scalars['Boolean']['output']>;
  locale: Array<Scalars['String']['output']>;
  marketplace: Array<Scalars['String']['output']>;
  qaStatus: Array<QaStatusFilterEnum>;
  templateVariant: Array<TemplateVariant>;
};

export type JourneysAssetInterface = {
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dimensions?: Maybe<Dimensions>;
  id: Scalars['ID']['output'];
  mediacentralurl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  qaStatus?: Maybe<QaStatusFilterEnum>;
  s3signedurl?: Maybe<Scalars['String']['output']>;
  /** Asset type as returned by JAM (e.g., "FIA", "MediaAsset") */
  type: Scalars['String']['output'];
};

export type JourneysAssetSearchFilterOptions = {
  assetType?: InputMaybe<Array<JourneysAssetType>>;
  platform?: InputMaybe<Array<Scalars['String']['input']>>;
  productLine?: InputMaybe<Array<Scalars['String']['input']>>;
  program?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<JourneysAssetTag>>;
};

export type JourneysAssetSearchInput = {
  dateModified?: InputMaybe<DateRangeInput>;
  filterOptions?: InputMaybe<JourneysAssetSearchFilterOptions>;
  /** Starting index for pagination */
  from?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  searchType: JourneysAssetSearchType;
  /** Ending index for pagination */
  to?: InputMaybe<Scalars['Int']['input']>;
  visibleToAll?: Scalars['Boolean']['input'];
};

export type JourneysAssetSearchResult = {
  __typename?: 'JourneysAssetSearchResult';
  assetGroups: Array<JourneysAssetGroup>;
  /** Starting index for this page */
  from?: Maybe<Scalars['Int']['output']>;
  /** Ending index for this page */
  to?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export enum JourneysAssetSearchType {
  AssetSearchAcrossProject = 'ASSET_SEARCH_ACROSS_PROJECT',
  AssetSearchWithinProject = 'ASSET_SEARCH_WITHIN_PROJECT'
}

export enum JourneysAssetTag {
  AiGenerated = 'AI_GENERATED',
  Archived = 'ARCHIVED',
  QaApproved = 'QA_APPROVED'
}

export enum JourneysAssetType {
  ComponentImage = 'COMPONENT_IMAGE',
  Fia = 'FIA',
  MediaAsset = 'MediaAsset',
  UserUploaded = 'USER_UPLOADED'
}

export type LiaInput = {
  booleanFields?: InputMaybe<Array<BooleanFieldCreateInput>>;
  jsonFields?: InputMaybe<Array<JsonFieldCreateInput>>;
  /** Locale for this LIA */
  locale: Scalars['ID']['input'];
  /** Marketplace for this LIA */
  marketplaceId: Scalars['ID']['input'];
  numberFields?: InputMaybe<Array<NumberFieldCreateInput>>;
  /** Platform */
  templateGroupVariantId: Scalars['ID']['input'];
  textFields?: InputMaybe<Array<TextFieldCreateInput>>;
};

export type LastPublishedPricingInput = {
  asin: Scalars['String']['input'];
  infoTypes: Array<PricingInfoInput>;
  isLaunchPermOn?: Scalars['Boolean']['input'];
  marketplace: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
};

export type LastPublishedSlateVersionsInput = {
  asin: Scalars['String']['input'];
  /** optional boolean that will be passed in */
  isLaunchPermOn?: Scalars['Boolean']['input'];
  marketplace: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  slates: Array<SlateImageInput>;
};

export type LastPublishedVersionsInput = {
  asin: Scalars['String']['input'];
  attributes: Array<DpAttributeInput>;
  isLaunchPermOn?: Scalars['Boolean']['input'];
  marketplace: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
};

/** A representation of a LIA */
export type LayeredImageAsset = Content & {
  __typename?: 'LayeredImageAsset';
  field?: Maybe<LayeredImageAssetField>;
  fields?: Maybe<Array<LayeredImageAssetField>>;
  /** A representation of a FIA */
  flattenedImageAsset?: Maybe<FlattenedImageAsset>;
  id: Scalars['ID']['output'];
  locale: Locale;
  /** Display name of the locale and marketplace combination */
  localeDisplayName?: Maybe<Scalars['String']['output']>;
  marketplace: Marketplace;
  reviews: Array<QaReview>;
  templateVariant: TemplateVariant;
};


/** A representation of a LIA */
export type LayeredImageAssetFieldArgs = {
  name: Scalars['String']['input'];
};

export type LayeredImageAssetEdge = {
  __typename?: 'LayeredImageAssetEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: LayeredImageAsset;
};

/** A single field for a layered image asset (LIA) */
export type LayeredImageAssetField = AssetFieldDimensionBase & AssetFieldStyleBase & LayeredImageAssetFieldBase & {
  __typename?: 'LayeredImageAssetField';
  /** The content of the field */
  content?: Maybe<LayeredImageAssetFieldContent>;
  dimension?: Maybe<AssetFieldDimension>;
  /** The DCS vertex ID of the field */
  id: Scalars['ID']['output'];
  /** The name of the field */
  name: Scalars['String']['output'];
  style?: Maybe<AssetFieldStyle>;
};

export type LayeredImageAssetFieldBase = {
  /** The DCS vertex ID of the field */
  id: Scalars['ID']['output'];
  /** The name of the field */
  name: Scalars['String']['output'];
};

/** The union of different content types for a field */
export type LayeredImageAssetFieldContent = AssetBoolean | AssetJson | AssetNumber | AssetText;

export type LayeredImageAssetsFilterInput = {
  /** has QA comment */
  hasQaComment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Layered Image Asset IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Locales like "US English" */
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Marketplace IDs */
  marketplaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** QA statuses */
  qaStatuses?: InputMaybe<Array<QaStatusFilterEnum>>;
  /** TemplateVariant IDs */
  templateVariantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type LdapPermission = {
  __typename?: 'LdapPermission';
  action: Scalars['String']['output'];
  ldapGroups: Array<Scalars['String']['output']>;
};

export type LivePreviewConfiguration = {
  __typename?: 'LivePreviewConfiguration';
  /** Whether this campaign uses MARS widget architecture (only used when supportsLivePreview is true) */
  isMarsWidget?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to preserve existing styles during live preview (only used when supportsLivePreview is true) */
  keepProvidedStyles?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this campaign requires AUI JavaScript library (only used when supportsLivePreview is true) */
  needsAuiJs?: Maybe<Scalars['Boolean']['output']>;
  /** Whether live preview is supported. Must be explicitly true or false. */
  supportsLivePreview: Scalars['Boolean']['output'];
  /** Whether this campaign supports platform-specific overrides (only used when supportsLivePreview is true) */
  supportsPlatformOverride?: Maybe<Scalars['Boolean']['output']>;
};

export type LivePreviewConfigurationInput = {
  /** Whether this campaign uses MARS widget architecture (only used when supportsLivePreview is true) */
  isMarsWidget?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to preserve existing styles during live preview (only used when supportsLivePreview is true) */
  keepProvidedStyles?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this campaign requires AUI JavaScript library (only used when supportsLivePreview is true) */
  needsAuiJs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether live preview is supported. Must be explicitly true or false. */
  supportsLivePreview: Scalars['Boolean']['input'];
  /** Whether this campaign supports platform-specific overrides (only used when supportsLivePreview is true) */
  supportsPlatformOverride?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LiveStateType {
  Expired = 'EXPIRED',
  Live = 'LIVE',
  MixedLive = 'MIXED_LIVE',
  Mvt = 'MVT',
  NotApproved = 'NOT_APPROVED',
  NotAvailable = 'NOT_AVAILABLE',
  NotRequested = 'NOT_REQUESTED',
  NotYetLive = 'NOT_YET_LIVE'
}

export type Locale = {
  __typename?: 'Locale';
  /** Locale display value (e.g. "en_US") */
  display: Scalars['String']['output'];
  /** Locale id (e.g. "en_US") */
  id: Scalars['ID']['output'];
};

export type MccTransitionJob = JobInterface & {
  __typename?: 'MCCTransitionJob';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the job */
  id: Scalars['ID']['output'];
  /** The metadata associated with the MCCTransitionJob */
  metadata?: Maybe<MccTransitionMetadata>;
  status: JobStatus;
};

export type MccTransitionMetadata = {
  __typename?: 'MCCTransitionMetadata';
  campaign?: Maybe<TrafficCampaign>;
};

export type MvtCombination = {
  __typename?: 'MVTCombination';
  dimensionVariantList: Array<DimensionVariantKey>;
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isExcluded?: Maybe<Scalars['Boolean']['output']>;
};

export type MvtCombinationInput = {
  dimensionVariantList: Array<DimensionVariantKeyInput>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isExcluded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MvtExperimentDetail = {
  __typename?: 'MVTExperimentDetail';
  experimentId: Scalars['ID']['output'];
  metricUrl?: Maybe<Scalars['String']['output']>;
  placementId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export type MvtExperimentDetailInput = {
  experimentId: Scalars['ID']['input'];
  metricUrl?: InputMaybe<Scalars['String']['input']>;
  placementId: Scalars['String']['input'];
  status: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type MvtExperimentInfo = {
  __typename?: 'MVTExperimentInfo';
  combinations: Array<MvtCombination>;
  dimensions: Array<DimensionInfo>;
  experimentList?: Maybe<Array<MvtExperimentDetail>>;
};

export type MvtExperimentInfoInput = {
  combinations: Array<MvtCombinationInput>;
  dimensions: Array<DimensionInfoInput>;
  experimentList?: InputMaybe<Array<MvtExperimentDetailInput>>;
};

export enum MvtExperimentState {
  Activated = 'ACTIVATED',
  ActivationFailureRollingBack = 'ACTIVATION_FAILURE_ROLLING_BACK',
  ActivationInProgress = 'ACTIVATION_IN_PROGRESS',
  ActivationRolledBack = 'ACTIVATION_ROLLED_BACK',
  CleanedUp = 'CLEANED_UP',
  CleanUpFailed = 'CLEAN_UP_FAILED',
  CleanUpInProgress = 'CLEAN_UP_IN_PROGRESS',
  DatasetUploadInternalFailure = 'DATASET_UPLOAD_INTERNAL_FAILURE',
  DatasetUploadInProgress = 'DATASET_UPLOAD_IN_PROGRESS',
  Deactivated = 'DEACTIVATED',
  DeactivationInProgress = 'DEACTIVATION_IN_PROGRESS',
  Draft = 'DRAFT',
  DraftNotValid = 'DRAFT_NOT_VALID',
  DraftValid = 'DRAFT_VALID',
  ErrorDuringActivationRollback = 'ERROR_DURING_ACTIVATION_ROLLBACK',
  PendingCleanUp = 'PENDING_CLEAN_UP',
  ReadyForActivation = 'READY_FOR_ACTIVATION',
  ReadyForDeactivation = 'READY_FOR_DEACTIVATION',
  Succeeded = 'SUCCEEDED'
}

/** A representation of a Marketplace */
export type Marketplace = {
  __typename?: 'Marketplace';
  /** Short hand representation of the marketplace (e.g. US) */
  country: Scalars['String']['output'];
  /** Marketplace vertex ID from DCS */
  id: Scalars['ID']['output'];
  /** The launch gating threshold (in hours). */
  launchDateThreshold: Scalars['Int']['output'];
  locales: MarketplaceLocales_Connection;
  /** Obfuscated marketplace ID (e.g. ATVPDKIKX0DER) */
  obfuscatedMarketplaceId: Scalars['String']['output'];
};


/** A representation of a Marketplace */
export type MarketplaceLocalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type MarketplaceEdge = {
  __typename?: 'MarketplaceEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: Marketplace;
};

export type MarketplaceExperimentConfig = MarketplaceExperimentConfigInterface & {
  __typename?: 'MarketplaceExperimentConfig';
  /** The activation date for the experiment */
  activationDate?: Maybe<Scalars['String']['output']>;
  /** The ASIN experiment configuration */
  asinConfigs: Array<AsinExperimentConfig>;
  /** For contextual MVT experiments only, the bullseye segments for the cohorts of the experiment */
  bullseyeSegments?: Maybe<Array<BullseyeSegmentInfoV2>>;
  /** The contextual cohort type "SET" or "PARTITION" */
  contextualCohortType?: Maybe<DpExperimentContextualCohortType>;
  /** The deactivation date for the experiment */
  deactivationDate?: Maybe<Scalars['String']['output']>;
  /** The ID of the experiment (DCS vertex ID) */
  id: Scalars['ID']['output'];
  /** The Iotalab experiment ID for the marketplace in the MVES experiment */
  iotalabReferenceId?: Maybe<Scalars['String']['output']>;
  /** The locale(s) for the marketplace where the experiment is being conducted */
  locales: Array<Scalars['String']['output']>;
  marketplace: Marketplace;
  /** The primary ASIN for the experiment */
  primaryAsin: Scalars['String']['output'];
  /** The prior active marketplace experiment configuration */
  priorConfig?: Maybe<MarketplaceExperimentConfig>;
  status: Scalars['String']['output'];
  /** Validation errors from MVES */
  validationErrors?: Maybe<Array<Scalars['String']['output']>>;
};

export type MarketplaceExperimentConfigInterface = {
  /** The activation date for the experiment */
  activationDate?: Maybe<Scalars['String']['output']>;
  /** The ASIN experiment configuration */
  asinConfigs: Array<AsinExperimentConfig>;
  /** For contextual MVT experiments only, the bullseye segments for the cohorts of the experiment */
  bullseyeSegments?: Maybe<Array<BullseyeSegmentInfoV2>>;
  /** The contextual cohort type "SET" or "PARTITION" */
  contextualCohortType?: Maybe<DpExperimentContextualCohortType>;
  /** The deactivation date for the experiment */
  deactivationDate?: Maybe<Scalars['String']['output']>;
  /** The ID of the experiment (DCS vertex ID) */
  id: Scalars['ID']['output'];
  /** The Iotalab experiment ID for the marketplace in the MVES experiment */
  iotalabReferenceId?: Maybe<Scalars['String']['output']>;
  /** The locale(s) for the marketplace where the experiment is being conducted */
  locales: Array<Scalars['String']['output']>;
  marketplace: Marketplace;
  /** The primary ASIN for the experiment */
  primaryAsin: Scalars['String']['output'];
  status: Scalars['String']['output'];
  /** Validation errors from MVES */
  validationErrors?: Maybe<Array<Scalars['String']['output']>>;
};

export type MarketplaceExperimentInput = {
  /** The ASINs for the experiment */
  asins: Array<Scalars['String']['input']>;
  /** For contextual MVT experiments, the bullseye segments for the cohorts of the experiment */
  bullseyeSegments?: InputMaybe<Array<BullseyeSegmentInfoInputV2>>;
  /** The contextual cohort type "SET" or "PARTITION" */
  contextualCohortType?: InputMaybe<DpExperimentContextualCohortType>;
  /** The locale(s) for the marketplace where the experiment is being conducted */
  locales: Array<Scalars['String']['input']>;
  /** The marketplace where the experiment is being conducted */
  marketplaceId: Scalars['String']['input'];
  /** The primary ASIN for the experiment */
  primaryAsin: Scalars['String']['input'];
};

export type MarketplaceLocales_Connection = {
  __typename?: 'MarketplaceLocales_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<MarketplaceLocales_Edge>;
  /** Flattened list of Locale type */
  nodes: Array<Locale>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MarketplaceLocales_Edge = {
  __typename?: 'MarketplaceLocales_Edge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** Display name of the locale and marketplace combination */
  displayName?: Maybe<Scalars['String']['output']>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: Locale;
};

export type MarsWidgetDefinition = {
  arguments: Scalars['JSON']['input'];
  deviceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  marketplaceID: Scalars['String']['input'];
  slateToken?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  widgetName: Scalars['String']['input'];
  widgetVersion: Scalars['String']['input'];
};

export type MediaAsset = JourneysAssetInterface & {
  __typename?: 'MediaAsset';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dimensions?: Maybe<Dimensions>;
  id: Scalars['ID']['output'];
  mediacentralurl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  qaStatus?: Maybe<QaStatusFilterEnum>;
  s3signedurl?: Maybe<Scalars['String']['output']>;
  /** Asset type as returned by JAM (e.g., "FIA", "MediaAsset") */
  type: Scalars['String']['output'];
};

/** Represents a Media Asset */
export type MediaAssetNode = {
  __typename?: 'MediaAssetNode';
  copiedFromAssetId: Scalars['String']['output'];
  device?: Maybe<Array<Scalars['String']['output']>>;
  fileMetadata: FileMetadata;
  id: Scalars['ID']['output'];
  mediaCentralUpload: MediaCentralUpload;
  /** Projects associated with the media asset */
  projects: MediaAssetNodeProjects_Connection;
  tags: Array<Tag>;
  visibleToAll?: Maybe<Scalars['Boolean']['output']>;
};


/** Represents a Media Asset */
export type MediaAssetNodeProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type MediaAssetNodeProjects_Connection = {
  __typename?: 'MediaAssetNodeProjects_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<TrafficProjectEdge>;
  /** Flattened list of TrafficProject type */
  nodes: Array<TrafficProject>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MediaCentralUpload = {
  __typename?: 'MediaCentralUpload';
  jobId?: Maybe<Scalars['String']['output']>;
  mediaCentralUrl?: Maybe<Scalars['String']['output']>;
  publishSubstate?: Maybe<Scalars['String']['output']>;
  publishSuccess?: Maybe<Scalars['Boolean']['output']>;
  shipmentId?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedBy?: Maybe<Scalars['String']['output']>;
  wharfId?: Maybe<Scalars['String']['output']>;
};

export type MerchandizedBundleConfig = MerchandizedBundleConfigInterface & {
  __typename?: 'MerchandizedBundleConfig';
  /** The merchandized config id */
  id: Scalars['ID']['output'];
  /** Time at which the Merchandized bundle config was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this Merchandized bundle config */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  /** The merchandized config version modified time */
  modifiedAt: Scalars['String']['output'];
  /** The merchandized config version modified person */
  modifiedBy: Scalars['String']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  /** The merchandized config details */
  value: MerchandizedBundleConfigInfo;
  /** The latest version of this Merchandized bundle config */
  version: Scalars['Int']['output'];
};

export type MerchandizedBundleConfigInfo = {
  __typename?: 'MerchandizedBundleConfigInfo';
  /** The asin type of this configuration. */
  asinTypes?: Maybe<Array<AsinTypes>>;
  /** This is bullseye Id for the targeting this configuration */
  bullseye?: Maybe<Scalars['String']['output']>;
  bundleConfigs: Array<MerchandizedBundleConfigs>;
  /** The language support this configuration */
  language: Array<Scalars['String']['output']>;
  /** The variation name of this configuration. */
  variationName?: Maybe<Scalars['String']['output']>;
  weblab: MerchandizedBundleWeblab;
};

export type MerchandizedBundleConfigInfoInput = {
  /** The asin type of this configuration. */
  asinTypes?: InputMaybe<Array<AsinTypes>>;
  /** This is bullseye Id for the targeting this configuration */
  bullseye?: InputMaybe<Scalars['String']['input']>;
  bundleConfigs: Array<MerchandizedBundleConfigsInput>;
  /** List of the asins for which the config should be deleted. */
  deletedBundleConfigAsins?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The language support this configuration has. */
  language: Array<Scalars['String']['input']>;
  /** The variation name of this configuration. */
  variationName?: InputMaybe<Scalars['String']['input']>;
  weblab: MerchandizedBundleWeblabInput;
};

export type MerchandizedBundleConfigInterface = {
  /** The merchandized config id */
  id: Scalars['ID']['output'];
  /** Time at which the Merchandized bundle config was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this Merchandized bundle config */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  /** The merchandized config version modified time */
  modifiedAt: Scalars['String']['output'];
  /** The merchandized config version modified person */
  modifiedBy: Scalars['String']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  /** The merchandized config details */
  value: MerchandizedBundleConfigInfo;
  /** The latest version of this Merchandized bundle config */
  version: Scalars['Int']['output'];
};

export type MerchandizedBundleConfigs = {
  __typename?: 'MerchandizedBundleConfigs';
  bundles: Array<MerchandizedBundles>;
  /** The device detail page obsfucated ASIN for which this configuration will be enabled. */
  detailPageAsin?: Maybe<Scalars['String']['output']>;
};

export type MerchandizedBundleConfigsInput = {
  bundles: Array<MerchandizedBundlesInput>;
  detailPageAsin?: InputMaybe<Scalars['String']['input']>;
};

export type MerchandizedBundleFailure = MerchandizedBundleFailureInterface & {
  __typename?: 'MerchandizedBundleFailure';
  id: Scalars['ID']['output'];
  /** The reason the saving for this merchandized bundle config failed. */
  reason?: Maybe<Scalars['String']['output']>;
};

export type MerchandizedBundleFailureInterface = {
  id: Scalars['ID']['output'];
  /** The reason the saving for this merchandized bundle config failed. */
  reason?: Maybe<Scalars['String']['output']>;
};

export type MerchandizedBundleInput = {
  /** nullable id which is a unique id for the configuration */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The merchandized config details */
  value: MerchandizedBundleConfigInfoInput;
  /** The most recent version number that you, the client, have for this merchandized config. If you are creating a new Merchandized bundle config, pass zero for the version. */
  version: Scalars['Int']['input'];
};

export type MerchandizedBundleMutationResponse = {
  __typename?: 'MerchandizedBundleMutationResponse';
  failed: Array<MerchandizedBundleFailure>;
  succeeded: Array<MerchandizedBundleConfig>;
};

export type MerchandizedBundleShortTitle = {
  __typename?: 'MerchandizedBundleShortTitle';
  /** Language locale for the short title. example en_US, en_IN */
  locale?: Maybe<Scalars['String']['output']>;
  /** Short title */
  title?: Maybe<Scalars['String']['output']>;
};

export type MerchandizedBundleShortTitleInput = {
  /** Language locale for the short title. example en_US, en_IN */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Short title */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MerchandizedBundleWeblab = {
  __typename?: 'MerchandizedBundleWeblab';
  /** Date from this configuration will be valid */
  validDateFrom?: Maybe<Scalars['String']['output']>;
  /** Date till this configuration will be valid */
  validDateTo?: Maybe<Scalars['String']['output']>;
  /** The weblab name for which this configuration is enabled */
  weblabName?: Maybe<Scalars['String']['output']>;
  /** The weblab treatment for which this configuration is enabled */
  weblabTreatment?: Maybe<Scalars['String']['output']>;
};

export type MerchandizedBundleWeblabInput = {
  /** Date from this configuration will be valid */
  validDateFrom?: InputMaybe<Scalars['String']['input']>;
  /** Date till this configuration will be valid */
  validDateTo?: InputMaybe<Scalars['String']['input']>;
  /** The weblab name for which this configuration is enabled */
  weblabName?: InputMaybe<Scalars['String']['input']>;
  /** The weblab treatment for which this configuration is enabled */
  weblabTreatment?: InputMaybe<Scalars['String']['input']>;
};

export type MerchandizedBundles = {
  __typename?: 'MerchandizedBundles';
  /** Obsfucated ASIN */
  asin?: Maybe<Scalars['String']['output']>;
  shortTitle: Array<MerchandizedBundleShortTitle>;
};

export type MerchandizedBundlesInput = {
  /** Obsfucated ASIN */
  asin?: InputMaybe<Scalars['String']['input']>;
  shortTitle: Array<MerchandizedBundleShortTitleInput>;
};

export type MergeAssetGroupChangesResponse = {
  __typename?: 'MergeAssetGroupChangesResponse';
  /** The AssetGroup that was merged */
  assetGroup: AssetGroup;
};

/** The role of a message sender */
export enum MessageRole {
  Assistant = 'ASSISTANT',
  User = 'USER'
}

export type MissingAttributesByLanguage = {
  __typename?: 'MissingAttributesByLanguage';
  /** List of attribute keys that are missing for this language. */
  attributes: Array<Scalars['String']['output']>;
  /** The language code (e.g., "en_US", "es_US"). */
  language: Scalars['String']['output'];
};

export type ModifyTrafficCampaignFlavorInput = {
  /** Updated flavor data */
  flavor: ExistingTrafficCampaignFlavorInput;
  /** ID of the TrafficCampaign to update */
  id: Scalars['ID']['input'];
  /** Name of this TrafficCampaign */
  name: Scalars['String']['input'];
  /** ID of the TrafficProject containing this TrafficCampaign */
  projectId: Scalars['ID']['input'];
  /** Version of the schema used to store this campaign's data */
  schemaVersion: Scalars['Int']['input'];
  /** Expected current version of the TrafficCampaign */
  version: Scalars['Int']['input'];
};

export type MpAsinQueryObject = {
  /** The asin of the product. */
  asin: Scalars['String']['input'];
  /** A marketplace for the product. */
  marketplace: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateMVESExperiment: CommonMutationResponse;
  /** Approve the given campaign via Step Function. */
  approveCampaign: EmptyCampaignMutationResponse;
  approveTrafficCampaignFlavor: TrafficCampaign;
  /** @deprecated Deprecate after BTF conversion. */
  approveTrafficCampaignPlacements: TrafficCampaign;
  /** Archive a campaign. This sets isArchived to true */
  archiveCampaign: SaveCampaignMutationResponse;
  /** Archives traffic campaigns. This sets isArchived to true */
  archiveOrRestoreTrafficCampaigns: ArchiveOrRestoreTrafficCampaignsMutationResponse;
  /** Rename an asset and return the updated asset object */
  assetRename: AssetRenameResponse;
  backfillPermissions: BackfillPermissionsMutationResponse;
  batchPreviewVariants: CommonMutationResponse;
  /** Create multiple assets and return the S3 signed URL to PUT the image file to. This expects that you will PUT the image file to that URL immediately after calling this. */
  bulkCreateAsset: Array<BulkCreateAssetMutationResponse>;
  /** Bulk creates Traffic Projects. This mutation is only supported for use in integration testing. */
  bulkCreateTrafficProjects: Array<TrafficProject>;
  /** Bulk deletes a list of TrafficProjects. This mutation is only supported for use in integration testing. */
  bulkDeleteTrafficProjects: BulkDeleteTrafficProjectsMutationResponse;
  /** Start a bulk publish job and return the job details */
  bulkPublishAttributes: BulkPublishResponse;
  /** Bulk publish assets to Media central for all flavors in a MCC */
  bulkPublishCampaignAssets: PublishCampaignAssetsMutationResponse;
  bulkSaveSlates: Array<BulkSaveSlatesMutationResponse>;
  cancelApprovalForTrafficCampaignFlavor: TrafficCampaign;
  /** Cancel approval request sent to CBR for the given campaign via Step Function. */
  cancelApproveCampaign: EmptyCampaignMutationResponse;
  /** Clone the campaign with the given dataId. Returns the cloned campaigns new dataId. */
  cloneCampaign: CloneCampaignMutationResponse;
  /** Clone an existing JAG with a new name. Returns the newly created JAG. */
  cloneJAG: AssetGroup;
  /** Clone multiple existing JAGs. Returns the newly created JAGs. */
  cloneJAGs: CloneJaGsResponse;
  /** Clones TrafficCampaign */
  cloneTrafficCampaign: CloneTrafficCampaignOutput;
  /** Clones trafficProject */
  cloneTrafficProject: CloneTrafficProjectOutput;
  /** Copies an asset to a specified Journeys project. New Asset ID is randomly generated.  */
  copyAsset: CreateAssetMutationResponse;
  copyDetailPage: DpCopyMutationResponse;
  /** Create an asset and return the S3 signed URL to PUT the image file to. This expects that you will PUT the image file to that URL immediately after calling this. */
  createAsset: CreateAssetMutationResponse;
  /** Create a new bulk atf job */
  createBulkAtfJob: CreateBulkAtfJobMutationResponse;
  /** Create a new bulk publishing job */
  createBulkPublishJob: CreateBulkPublishJobMutationResponse;
  /** Create a new bunlde using the DBM service with the given form values. Returns the bundle entity. */
  createBundle: CreateBundleResponse;
  /** Creates a dynamo record which is used to get slate variants that are selected during bundle creation and use those variants to copy the slates in DevicesAsinCentralIngestion state machine */
  createBundleSlateVariantsRecord: SaveBundleSlateVariantsResponse;
  /** Create a campaign in DPB with the given form values. Returns the new campaign. */
  createCampaign: SaveCampaignMutationResponse;
  createCampaignConfiguration: CampaignConfigurationMutationResponse;
  createExperiment: CreateOrUpdateExperimentMutationResponse;
  createExperimentV2: CreateExperimentV2MutationResponse;
  /** Create a JAG with given arguments. Returns the created JAG. */
  createJAG: AssetGroup;
  /** Create a new MCC transition job */
  createMCCTransitionJob: CreateMccTransitionJobMutationResponse;
  createOrUpdateBulletsVariant: CreateOrUpdateBulletsVariantMutationResponse;
  createOrUpdateBulletsVariantV2: CreateOrUpdateVariantMutationResponse;
  createOrUpdateLandingImageVariant: CreateOrUpdateLandingImageVariantMutationResponse;
  createOrUpdateLandingImageVariantV2: CreateOrUpdateVariantMutationResponse;
  createOrUpdateStructuredTitleVariant: CreateOrUpdateStructuredTitleVariantMutationResponse;
  createOrUpdateTitleVariant: CreateOrUpdateTitleVariantMutationResponse;
  createOrUpdateTitleVariantV2: CreateOrUpdateVariantMutationResponse;
  createPermissions: PermissionsMutationResponse;
  /** Create advanced preview session for full page preview */
  createPreviewSession: CreatePreviewSessionOutput;
  createProducts: CreateProductsMutationResponse;
  /** Creates a content QA comment in DCS */
  createQAComment: QaCommentResponse;
  /** Creates a content QA review in DCS */
  createQAReview: QaReviewResponse;
  createTrafficCampaign: TrafficCampaign;
  createTrafficCampaignFlavor: TrafficCampaign;
  /** Create a TrafficProject given an optional name argument. Returns the created TrafficProject. */
  createTrafficProject: TrafficProject;
  deactivateExperimentV2: UpdateExperimentV2MutationResponse;
  deactivateOrDeleteExperiment: DeactivateOrDeleteExperimentMutationResponse;
  deleteBulletsVariant: CommonMutationResponse;
  deleteCampaignConfiguration: CampaignConfigurationDeleteResponse;
  deleteExperimentByExperimentIdV2: DropExperimentResponse;
  deleteExperimentByProgramV2: DropExperimentResponse;
  deleteLandingImageVariant: CommonMutationResponse;
  deletePermissions: DeletePermissionsMutationResponse;
  /** Delete a preview session for a given previewer. Returns the id of the deleted previewer. If the session does not exist or already expired, the id is returned and you can assume it was deleted. */
  deletePreviewSessions: Array<DeletePreviewSessionResult>;
  deleteProduct: DeleteProductMutationResponse;
  deleteStructuredTitleVariant: CommonMutationResponse;
  deleteTitleVariant: CommonMutationResponse;
  /** Delete a TrafficProject. This mutation is only supported for use in integration testing. */
  deleteTrafficProject: DeleteTrafficProjectMutationResponse;
  deleteVariantsV2: CreateOrUpdateVariantMutationResponse;
  /** Discards any of your workspace related changes for a given Asset Group */
  discardAssetGroupChanges: DiscardAssetGroupChangesResponse;
  /** Duplicate an experiment and all associated variants */
  duplicateExperiment: DpDuplicateExperimentResponse;
  fetchAndUpdateExperimentSummaryInfo: SummaryInfo;
  /** Generates assets for a given AssetGroup */
  generateAssets: GenerateAssetsResponse;
  importTrafficEvent: ImportTrafficEventOutput;
  /** Merges your workspace related changes for a given AssetGroup into the shared AssetGroup */
  mergeAssetGroupChanges: MergeAssetGroupChangesResponse;
  /** Paste JAGs from one project to another */
  pasteJAGs: PasteJaGsResponse;
  /** Pastes the input campaign Ids from sourceProject to destination project */
  pasteTrafficCampaignsToDifferentProject: PasteTrafficCampaignsToDifferentProjectOutput;
  publishAsset: PublishAssetMutationResponse;
  publishAttributes: DpAttributesMutationResponse;
  /** Publish the campaign via Step Function. */
  publishCampaign: EmptyCampaignMutationResponse;
  publishExperimentV2: DpExperimentDetailsV2;
  publishPricing: PublishPricingInfoMutationResponse;
  publishSlateImage: PublishSlateMutationResponse;
  publishSlatePlaceholders: PublishSlatePlaceholdersMutationResponse;
  publishTrafficCampaignFlavor: TrafficCampaign;
  publishTrafficCampaignFlavors: TrafficCampaign;
  /** Removes a content QA comment in DCS */
  removeQAComment: QaRemoveCommentResponse;
  /** Removes a content QA review in DCS */
  removeQAReview: QaRemoveReviewResponse;
  /** @deprecated Use the SaveTrafficCampaign mutation instead. */
  removeTrafficCampaignFlavor: TrafficCampaign;
  /** @deprecated Use assetRename mutation instead */
  renameAsset: CommonMutationResponse;
  /** Renames an Asset Group */
  renameAssetGroup: RenameAssetGroupResponse;
  /** Renames a TrafficProject, given the project's ID and new name. Returns the renamed TrafficProject. */
  renameTrafficProject: TrafficProject;
  requestApprovalForTrafficCampaignFlavor: TrafficCampaign;
  /** Request approval from CBR for the given campaign via Step Function. */
  requestApproveCampaign: EmptyCampaignMutationResponse;
  /** Restore a campaign that has been archived. This sets isArchived to false */
  restoreCampaign: SaveCampaignMutationResponse;
  /** Saves and generates assets for a given AssetGroup */
  saveAndGenerateAssets: SaveAndGenerateAssetsResponse;
  /** Saves your workspace related changes for a given AssetGroup into the shared AssetGroup */
  saveAssetChanges: SaveAssetChangesResponse;
  saveAttributes: DpAttributesMutationResponse;
  /** Update a campaign with the given form values. Returns new userVersion */
  saveCampaign: SaveCampaignMutationResponse;
  saveMerchandizedBundles: MerchandizedBundleMutationResponse;
  savePricing: SavePricingInfoMutationResponse;
  saveSlates: SaveSlatesMutationResponse;
  /** Updates TrafficCampaign and associated flavors. Supports adding, updating, and de-activating flavors. */
  saveTrafficCampaign: SaveTrafficCampaignOutput;
  /** @deprecated Use the SaveTrafficCampaign mutation instead. */
  saveTrafficCampaignFlavor: TrafficCampaign;
  scheduleExperimentV2: UpdateExperimentV2MutationResponse;
  /** Send a message to an existing conversation or retry with existing history */
  sendMessage: SendMessageResponse;
  /** Set fields on LIA(s) within a AssetGroup. Returns the updated AssetGroup. */
  setAssetFields: AssetGroup;
  /** Shares a backfilled trafficProject if it exists. Returns the shared journeys ProjectItem. */
  shareBackfilledTrafficProject: Project;
  /** Shares a TrafficProject with the provided LDAP groups and users. Returns TrafficProject. */
  shareTrafficProject: TrafficProject;
  startAssetIntakeSession: StartAssetIntakeSessionMutationResponse;
  /** Start a new conversation with specified prompt configuration */
  startConversation: SendMessageResponse;
  startPublishExperiment: CommonMutationResponse;
  /** This will deactivate experiment & suspendAllCampaigns. */
  suspendCampaign: EmptyCampaignMutationResponse;
  /** This will deactivate experiment & suspendAllCampaigns. */
  suspendPlacement: EmptyCampaignMutationResponse;
  suspendTrafficCampaignFlavor: TrafficCampaign;
  /** @deprecated Deprecate after BTF conversion. */
  suspendTrafficCampaignPlacements: TrafficCampaign;
  /** @deprecated Use the createMCCTransitionJob async transition process instead */
  transitionTrafficCampaignCreatives: TrafficCampaign;
  /** @deprecated Use the createMCCTransitionJob async transition process instead */
  transitionTrafficCampaignFlavors: TrafficCampaign;
  /** @deprecated Use the createMCCTransitionJob async transition process instead */
  transitionTrafficCampaignPlacements: TrafficCampaign;
  updateCampaignConfiguration: CampaignConfigurationMutationResponse;
  updateExperiment: CreateOrUpdateExperimentMutationResponse;
  updateExperimentV2: UpdateExperimentV2MutationResponse;
  /** Updates a content QA comment in DCS */
  updateQAComment: QaCommentResponse;
  /** Updates a content QA review in DCS */
  updateQAReview: QaReviewResponse;
  validatePublishedPricing: ValidatePublishedPricingInfoMutationResponse;
};


export type MutationActivateMvesExperimentArgs = {
  activationDate?: Scalars['String']['input'];
  deactivationDate?: Scalars['String']['input'];
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
};


export type MutationApproveCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationApproveTrafficCampaignFlavorArgs = {
  input: TrafficFlavorApprovalStateTransitionInput;
};


export type MutationApproveTrafficCampaignPlacementsArgs = {
  input: TrafficPlacementStateTransitionInput;
};


export type MutationArchiveCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  userVersion: Scalars['Int']['input'];
};


export type MutationArchiveOrRestoreTrafficCampaignsArgs = {
  input: ArchiveOrRestoreTrafficCampaignsInput;
};


export type MutationAssetRenameArgs = {
  input: AssetRenameInput;
};


export type MutationBatchPreviewVariantsArgs = {
  asin: Scalars['String']['input'];
  dpbExperimentId: Scalars['ID']['input'];
};


export type MutationBulkCreateAssetArgs = {
  input: Array<BulkCreateAssetInput>;
};


export type MutationBulkCreateTrafficProjectsArgs = {
  input: Array<BulkTrafficCreateProjectInput>;
};


export type MutationBulkDeleteTrafficProjectsArgs = {
  projectIds: Array<Scalars['String']['input']>;
};


export type MutationBulkPublishAttributesArgs = {
  input: BulkPublishInput;
};


export type MutationBulkPublishCampaignAssetsArgs = {
  input: Array<PublishCampaignAssetInput>;
};


export type MutationBulkSaveSlatesArgs = {
  input: Array<SaveSlatesInput>;
};


export type MutationCancelApprovalForTrafficCampaignFlavorArgs = {
  input: TrafficFlavorStateTransitionInput;
};


export type MutationCancelApproveCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationCloneCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  newCampaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationCloneJagArgs = {
  name: Scalars['String']['input'];
  sourceJagId: Scalars['ID']['input'];
};


export type MutationCloneJaGsArgs = {
  namePrefix?: InputMaybe<Scalars['String']['input']>;
  sourceJagIds: Array<Scalars['ID']['input']>;
};


export type MutationCloneTrafficCampaignArgs = {
  input: CloneTrafficCampaignInput;
};


export type MutationCloneTrafficProjectArgs = {
  input: CloneTrafficProjectInput;
};


export type MutationCopyAssetArgs = {
  assetId: Scalars['ID']['input'];
  destinationProjectId: Scalars['ID']['input'];
};


export type MutationCopyDetailPageArgs = {
  input: CopyDpInput;
};


export type MutationCreateAssetArgs = {
  input: CreateAssetInput;
};


export type MutationCreateBulkAtfJobArgs = {
  fileName: Scalars['String']['input'];
};


export type MutationCreateBulkPublishJobArgs = {
  input: CreateBulkPublishJobInput;
};


export type MutationCreateBundleArgs = {
  input: CreateBundleRequest;
};


export type MutationCreateBundleSlateVariantsRecordArgs = {
  input: SaveBundleSlateVariantsInput;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateCampaignConfigurationArgs = {
  input: CreateCampaignConfigurationInput;
};


export type MutationCreateExperimentArgs = {
  input: DpExperimentDetailsCreateInput;
};


export type MutationCreateExperimentV2Args = {
  input: DpExperimentDetailsCreateInputV2;
};


export type MutationCreateJagArgs = {
  layeredImageAssets?: InputMaybe<Array<LiaInput>>;
  name?: Scalars['String']['input'];
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  templateGroupId: Scalars['ID']['input'];
};


export type MutationCreateMccTransitionJobArgs = {
  input: TransitionTrafficCampaignInput;
};


export type MutationCreateOrUpdateBulletsVariantArgs = {
  dpbExperimentId: Scalars['ID']['input'];
  variant: DpBulletsVariantInput;
};


export type MutationCreateOrUpdateBulletsVariantV2Args = {
  experimentId: Scalars['ID']['input'];
  marketplaceId: Scalars['String']['input'];
  variants: Array<DpBulletsVariantInputV2>;
};


export type MutationCreateOrUpdateLandingImageVariantArgs = {
  dpbExperimentId: Scalars['ID']['input'];
  variant: DpLandingImageVariantInput;
};


export type MutationCreateOrUpdateLandingImageVariantV2Args = {
  experimentId: Scalars['ID']['input'];
  marketplaceId: Scalars['String']['input'];
  variants: Array<DpLandingImageVariantInputV2>;
};


export type MutationCreateOrUpdateStructuredTitleVariantArgs = {
  dpbExperimentId: Scalars['ID']['input'];
  variant: DpStructuredTitleVariantInput;
};


export type MutationCreateOrUpdateTitleVariantArgs = {
  dpbExperimentId: Scalars['ID']['input'];
  variant: DpTitleVariantInput;
};


export type MutationCreateOrUpdateTitleVariantV2Args = {
  experimentId: Scalars['ID']['input'];
  marketplaceId: Scalars['String']['input'];
  variants: Array<DpTitleVariantInputV2>;
};


export type MutationCreatePermissionsArgs = {
  input: Array<PermissionsInput>;
};


export type MutationCreatePreviewSessionArgs = {
  input: CreatePreviewSessionInput;
};


export type MutationCreateProductsArgs = {
  input: Array<CreateProductInput>;
};


export type MutationCreateQaCommentArgs = {
  input: CreateQaCommentInput;
};


export type MutationCreateQaReviewArgs = {
  input: CreateQaReviewInput;
};


export type MutationCreateTrafficCampaignArgs = {
  input: CreateTrafficCampaignInput;
};


export type MutationCreateTrafficCampaignFlavorArgs = {
  input: CreateTrafficCampaignFlavorInput;
};


export type MutationCreateTrafficProjectArgs = {
  buildEvent?: Scalars['Boolean']['input'];
  name?: Scalars['String']['input'];
};


export type MutationDeactivateExperimentV2Args = {
  input: DpExperimentDetailsDeactivateInputV2;
};


export type MutationDeactivateOrDeleteExperimentArgs = {
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
};


export type MutationDeleteBulletsVariantArgs = {
  asin: Scalars['String']['input'];
  dpbExperimentId: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  uniqueReferenceId: Scalars['ID']['input'];
};


export type MutationDeleteCampaignConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExperimentByExperimentIdV2Args = {
  experimentId: Scalars['ID']['input'];
};


export type MutationDeleteExperimentByProgramV2Args = {
  locale: Scalars['String']['input'];
  marketplaceId: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationDeleteLandingImageVariantArgs = {
  asin: Scalars['String']['input'];
  dpbExperimentId: Scalars['ID']['input'];
  platform: DpLandingImagePlatform;
  uniqueReferenceId: Scalars['ID']['input'];
};


export type MutationDeletePermissionsArgs = {
  input: Array<DeletePermissionsInput>;
};


export type MutationDeletePreviewSessionsArgs = {
  obfuscatedPreviewerIds: Array<Scalars['String']['input']>;
  realm: SymphonyRealm;
};


export type MutationDeleteProductArgs = {
  productId: Scalars['String']['input'];
};


export type MutationDeleteStructuredTitleVariantArgs = {
  asin: Scalars['String']['input'];
  dpbExperimentId: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  uniqueReferenceId: Scalars['ID']['input'];
};


export type MutationDeleteTitleVariantArgs = {
  asin: Scalars['String']['input'];
  dpbExperimentId: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  uniqueReferenceId: Scalars['ID']['input'];
};


export type MutationDeleteTrafficProjectArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteVariantsV2Args = {
  experimentId: Scalars['ID']['input'];
  marketplaceId: Scalars['ID']['input'];
  variants: Array<DpVariantDeleteInputV2>;
};


export type MutationDiscardAssetGroupChangesArgs = {
  assetGroupId: Scalars['ID']['input'];
};


export type MutationDuplicateExperimentArgs = {
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
};


export type MutationFetchAndUpdateExperimentSummaryInfoArgs = {
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
  mvtExperimentId: Scalars['ID']['input'];
};


export type MutationGenerateAssetsArgs = {
  assetGroupId: Scalars['ID']['input'];
};


export type MutationImportTrafficEventArgs = {
  input: ImportTrafficEventInput;
};


export type MutationMergeAssetGroupChangesArgs = {
  assetGroupId: Scalars['ID']['input'];
};


export type MutationPasteJaGsArgs = {
  input: PasteJaGsInput;
};


export type MutationPasteTrafficCampaignsToDifferentProjectArgs = {
  input: PasteTrafficCampaignsToDifferentProjectInput;
};


export type MutationPublishAssetArgs = {
  input: AssetPublishRequest;
};


export type MutationPublishAttributesArgs = {
  input: PublishAttributesInput;
};


export type MutationPublishCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationPublishExperimentV2Args = {
  input: DpExperimentDetailsPublishInputV2;
};


export type MutationPublishPricingArgs = {
  input: PublishPricingInfoInput;
};


export type MutationPublishSlateImageArgs = {
  input: SlatePublishInput;
};


export type MutationPublishSlatePlaceholdersArgs = {
  input: SlatePlaceholderPublishInput;
};


export type MutationPublishTrafficCampaignFlavorArgs = {
  id: Scalars['ID']['input'];
  input: TrafficCreativePublishInput;
  projectId: Scalars['ID']['input'];
};


export type MutationPublishTrafficCampaignFlavorsArgs = {
  id: Scalars['ID']['input'];
  input: Array<TrafficCreativePublishInput>;
  projectId: Scalars['ID']['input'];
};


export type MutationRemoveQaCommentArgs = {
  commentId: Scalars['ID']['input'];
};


export type MutationRemoveQaReviewArgs = {
  reviewId: Scalars['ID']['input'];
};


export type MutationRemoveTrafficCampaignFlavorArgs = {
  input: RemoveTrafficCampaignFlavorInput;
};


export type MutationRenameAssetArgs = {
  input: RenameAssetInput;
};


export type MutationRenameAssetGroupArgs = {
  assetGroupId: Scalars['ID']['input'];
  newName: Scalars['String']['input'];
  rvn: Scalars['Int']['input'];
};


export type MutationRenameTrafficProjectArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationRequestApprovalForTrafficCampaignFlavorArgs = {
  input: TrafficFlavorStateTransitionInput;
};


export type MutationRequestApproveCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationRestoreCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  userVersion: Scalars['Int']['input'];
};


export type MutationSaveAndGenerateAssetsArgs = {
  assetGroupId: Scalars['ID']['input'];
};


export type MutationSaveAssetChangesArgs = {
  assetGroupId: Scalars['ID']['input'];
};


export type MutationSaveAttributesArgs = {
  input: SaveAttributesInput;
};


export type MutationSaveCampaignArgs = {
  input: SaveCampaignInput;
};


export type MutationSaveMerchandizedBundlesArgs = {
  input: SaveMerchandizedBundleInput;
};


export type MutationSavePricingArgs = {
  input: SavePricingInfoInput;
};


export type MutationSaveSlatesArgs = {
  input: SaveSlatesInput;
};


export type MutationSaveTrafficCampaignArgs = {
  input: SaveTrafficCampaignInput;
};


export type MutationSaveTrafficCampaignFlavorArgs = {
  input: ModifyTrafficCampaignFlavorInput;
};


export type MutationScheduleExperimentV2Args = {
  input: DpExperimentDetailsScheduleInputV2;
};


export type MutationSendMessageArgs = {
  correlationId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  sessionIdentifier: Scalars['String']['input'];
};


export type MutationSetAssetFieldsArgs = {
  input: SetAssetFieldInput;
};


export type MutationShareBackfilledTrafficProjectArgs = {
  groups: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  people: Array<TrafficProjectUserInput>;
};


export type MutationShareTrafficProjectArgs = {
  groups: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  people: Array<TrafficProjectUserInput>;
};


export type MutationStartAssetIntakeSessionArgs = {
  input: StartAssetIntakeSessionInput;
};


export type MutationStartConversationArgs = {
  assetIds: Array<Scalars['String']['input']>;
  correlationId: Scalars['String']['input'];
  promptName: Scalars['String']['input'];
  variables?: InputMaybe<Array<PromptVariableInput>>;
};


export type MutationStartPublishExperimentArgs = {
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
};


export type MutationSuspendCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationSuspendPlacementArgs = {
  campaignId: Scalars['ID']['input'];
  placementId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationSuspendTrafficCampaignFlavorArgs = {
  input: TrafficFlavorStateTransitionInput;
};


export type MutationSuspendTrafficCampaignPlacementsArgs = {
  input: TrafficPlacementStateTransitionInput;
};


export type MutationTransitionTrafficCampaignCreativesArgs = {
  input: TransitionTrafficCampaignCreativesInput;
};


export type MutationTransitionTrafficCampaignFlavorsArgs = {
  input: TransitionTrafficCampaignFlavorsInput;
};


export type MutationTransitionTrafficCampaignPlacementsArgs = {
  input: TransitionTrafficCampaignPlacementsInput;
};


export type MutationUpdateCampaignConfigurationArgs = {
  input: UpdateCampaignConfigurationInput;
};


export type MutationUpdateExperimentArgs = {
  dpbExperimentId: Scalars['ID']['input'];
  experiment: DpExperimentDetailsUpdateInput;
  experimentType: Scalars['String']['input'];
};


export type MutationUpdateExperimentV2Args = {
  input: DpExperimentDetailsUpdateInputV2;
};


export type MutationUpdateQaCommentArgs = {
  input: UpdateQaCommentInput;
};


export type MutationUpdateQaReviewArgs = {
  input: UpdateQaReviewInput;
};


export type MutationValidatePublishedPricingArgs = {
  input: ValidatePublishedPricingInfoInput;
};

/** All mutation responses should implement this interface */
export type MutationResponse = {
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type MvesExperimentStatus = {
  __typename?: 'MvesExperimentStatus';
  /** The experimentId as stored in MVES */
  mvesExperimentId: Scalars['String']['output'];
  /** The status of the MVT experiment in MVES */
  status: Scalars['String']['output'];
};

export type NewTrafficCampaignFlavorInput = {
  /** Whether this flavor is still active and visible on the UI */
  active: Scalars['Boolean']['input'];
  /** Journeys form values for this flavor */
  content: Scalars['JSON']['input'];
  /** Name for Symphony creative. */
  creativeName?: InputMaybe<Scalars['String']['input']>;
  /** Flag to auto-generate creative name. Uses campaign name in generation regardless of campaign-name-generation. */
  hasGeneratedName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Combined liveState for the flavor. Only supports MCC campaigns. */
  liveState?: InputMaybe<LiveStateType>;
  /** Form inputs for this flavor's scheduling config. */
  scheduling: TrafficFlavorSchedulingInfoInput;
  /** Combined status of this flavors creative and placements. Only supports MCC campaigns. */
  status?: InputMaybe<CampaignState>;
  /** Used by some campaign types to differentiate between flavors with same platform and locale */
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** Input for a number field */
export type NumberFieldCreateInput = {
  /** Dimension input for this field */
  dimension?: InputMaybe<FieldDimensionInput>;
  /** Name of the field to set */
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Float']['input']>;
  /** Styling input for this field */
  style?: InputMaybe<FieldStyleInput>;
};

/** Input for a number field */
export type NumberFieldInput = {
  /** Dimension input for this field */
  dimension?: InputMaybe<FieldDimensionInput>;
  /** Layered Image Asset IDs to set this field on */
  layeredImageAssetIds: Array<Scalars['String']['input']>;
  /** Name of the field to set */
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Float']['input']>;
  /** Styling input for this field */
  style?: InputMaybe<FieldStyleInput>;
};

export enum ObjectStateType {
  Approved = 'Approved',
  Loading = 'Loading',
  PermissionDenied = 'PERMISSION_DENIED',
  Suspended = 'Suspended',
  Unapproved = 'Unapproved'
}

export type OverviewConfiguration = {
  __typename?: 'OverviewConfiguration';
  /** Configuration for auto-naming functionality */
  autoNaming: AutoNamingConfiguration;
};

export type OverviewConfigurationInput = {
  /** Configuration for auto-naming functionality */
  autoNaming: AutoNamingConfigurationInput;
};

/** PageInfo cursor, as defined in https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor corresponding to the last nodes in edges. Null if the connection is empty. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Used to indicate whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Used to indicate whether more edges exist prior to the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor corresponding to the first nodes in edges. Null if the connection is empty. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Page types where a campaign could be displayed */
export enum PageTypeEnum {
  Browse = 'BROWSE',
  Detail = 'DETAIL',
  Detailaw = 'DETAILAW',
  Events = 'EVENTS',
  Gateway = 'GATEWAY',
  Landingaw = 'LANDINGAW',
  Metis = 'METIS',
  Monera = 'MONERA',
  Personalizationpage = 'PERSONALIZATIONPAGE',
  Search = 'SEARCH',
  Searchaw = 'SEARCHAW'
}

export enum PartiallyApprovedType {
  No = 'NO',
  NotRequested = 'NOT_REQUESTED',
  Yes = 'YES'
}

export type PasteJaGsInput = {
  /** ID of the destination project where JAGs will be pasted */
  destinationProjectId: Scalars['ID']['input'];
  /** User-friendly IDs of the JAGs to paste */
  jagIds: Array<Scalars['ID']['input']>;
  /** ID of the source project containing the JAGs */
  sourceProjectId: Scalars['ID']['input'];
};

export type PasteJaGsResponse = {
  __typename?: 'PasteJAGsResponse';
  assetGroups: Array<AssetGroup>;
};

export type PasteTrafficCampaignsToDifferentProjectInput = {
  /** The list of campaignIds to be copied from the sourceProject into destination project  */
  campaignIds: Array<Scalars['ID']['input']>;
  /** Id of the destination project */
  destinationProjectId: Scalars['ID']['input'];
  /** ID of the source project */
  sourceProjectId: Scalars['ID']['input'];
};

export type PasteTrafficCampaignsToDifferentProjectOutput = {
  __typename?: 'PasteTrafficCampaignsToDifferentProjectOutput';
  /** List of errors encountered */
  errors: Array<Scalars['String']['output']>;
  /** True if operation completed successfully with no errors */
  success: Scalars['Boolean']['output'];
};

export type Permission = {
  __typename?: 'Permission';
  action: Scalars['String']['output'];
  person: Person;
  user: Scalars['String']['output'];
};

export type PermissionMutationResponseObject = {
  __typename?: 'PermissionMutationResponseObject';
  asin: Scalars['String']['output'];
  marketplace: Scalars['String']['output'];
  permissionsGroup: PermissionsLdapGroups;
};

export type PermissionsInput = {
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
  permissionsGroup: PermissionsLdapGroupsInput;
};

export type PermissionsLdapGroups = {
  __typename?: 'PermissionsLdapGroups';
  /** ldap group for checking permissions to publish attributes and pricing */
  attributesAndPricing: Array<Scalars['String']['output']>;
  /** ldap group for checking permissions to publish campaigns and slates */
  campaignsAndSlates: Array<Scalars['String']['output']>;
};

export type PermissionsLdapGroupsInput = {
  /** ldap group for checking permissions to publish attributes and pricing */
  attributesAndPricing: Array<Scalars['String']['input']>;
  /** ldap group for checking permissions to publish campaigns and slates */
  campaignsAndSlates: Array<Scalars['String']['input']>;
};

export type PermissionsMutationResponse = MutationResponse & {
  __typename?: 'PermissionsMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  permissions: Array<PermissionMutationResponseObject>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type Person = {
  __typename?: 'Person';
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type Placement = {
  __typename?: 'Placement';
  additionalExcludes?: Maybe<Scalars['JSON']['output']>;
  additionalIncludes?: Maybe<Scalars['JSON']['output']>;
  asins?: Maybe<Array<Scalars['String']['output']>>;
  browseNodes?: Maybe<Array<Scalars['String']['output']>>;
  bullseyeExcludes?: Maybe<Array<Scalars['Int']['output']>>;
  bullseyeIncludes?: Maybe<Array<Scalars['Int']['output']>>;
  categoryNode?: Maybe<Array<Scalars['String']['output']>>;
  customerTargeting: Scalars['String']['output'];
  deviceTypes?: Maybe<Array<Scalars['String']['output']>>;
  event?: Maybe<PlacementEventData>;
  guarantee?: Maybe<Scalars['Int']['output']>;
  impressionsDaysTimeout?: Maybe<Scalars['Int']['output']>;
  impressionsLimit?: Maybe<Scalars['Int']['output']>;
  kothOrGuarantee: Scalars['String']['output'];
  languages?: Maybe<Array<Scalars['String']['output']>>;
  lastActivePlacementHash?: Maybe<Scalars['String']['output']>;
  mvtAssignmentId?: Maybe<Scalars['String']['output']>;
  mvtName?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  pageType?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  scheduleType?: Maybe<Scalars['String']['output']>;
  slot?: Maybe<Scalars['String']['output']>;
  /** The placement state. Based on Symphony status, if the campaign is published. */
  state: CampaignState;
  symphonyPreviewUrl: Scalars['String']['output'];
  timeRange: DateRange;
  uiId: Scalars['String']['output'];
  weblabName?: Maybe<Scalars['String']['output']>;
  weblabTreatment?: Maybe<Scalars['String']['output']>;
};

/** What placement component to show in the campaign UI */
export type PlacementComponent = {
  __typename?: 'PlacementComponent';
  component: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
};

/** What placement components to show in the campaign UI */
export type PlacementComponentInput = {
  component: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};

/** Placement defaults variant specific placement values */
export type PlacementDefaultVariantCriteria = {
  __typename?: 'PlacementDefaultVariantCriteria';
  impressions?: Maybe<TrafficCampaignPlacementDefaultImpression>;
  /** Which slots to target for this specific variant. */
  slots: Array<Scalars['String']['output']>;
  /** variant id, must be unique within this array */
  variantId: Scalars['String']['output'];
};

/** Placement defaults variant specific placement values input */
export type PlacementDefaultVariantCriteriaInput = {
  impressions?: InputMaybe<TrafficCampaignPlacementDefaultImpressionInput>;
  /** Which slots to target for this specific variant. */
  slots: Array<Scalars['String']['input']>;
  /** variant id, must be unique within this array */
  variantId: Scalars['String']['input'];
};

/** This is the event data that gets added to placements that are associated with events. */
export type PlacementEventData = {
  __typename?: 'PlacementEventData';
  childEventId?: Maybe<Scalars['String']['output']>;
  elemId: Scalars['String']['output'];
};

/** This is the event data that gets added to placements that are associated with events. */
export type PlacementEventDataInput = {
  childEventId?: InputMaybe<Scalars['String']['input']>;
  elemId: Scalars['String']['input'];
};

/** Contains scheduling data: platform, language, and marketplace for placement group propagation logic in multi-platform campaigns */
export type PlacementGroupSchedulingInfo = {
  __typename?: 'PlacementGroupSchedulingInfo';
  /** ASINs to which this placement is scheduled */
  flavorId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier consisting of flavor scheduling language and marketplace ie. es_US_US. Used to index multi-platform flavors using values present on flavors */
  locale?: Maybe<Scalars['String']['output']>;
  /** List of IDs of browse nodes to which this placement is scheduled */
  platforms?: Maybe<Array<Scalars['String']['output']>>;
};

/** Contains scheduling data: platform, language, and marketpace for placement group progagation logic in multi-platform campaigns */
export type PlacementGroupSchedulingInfoInput = {
  /** ASINs to which this placement is scheduled */
  flavorId?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier consisting of flavor scheduling language and marketplace ie. es_US_US. Used to index multi-platform flavors using values present on flavors */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** List of IDs of browse nodes to which this placement is scheduled */
  platforms?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Placement group variant specific placement values */
export type PlacementGroupVariantCriteria = {
  __typename?: 'PlacementGroupVariantCriteria';
  impressions?: Maybe<TrafficCampaignPlacementImpression>;
  /** Which slots to target for this specific variant. */
  slots: Array<Scalars['String']['output']>;
  /** If true, the slots field value will use default values from the campaign placement defaults. */
  useDefaultSlot: Scalars['Boolean']['output'];
  /** variant id, must be unique within this array */
  variantId: Scalars['String']['output'];
};

/** Placement group variant specific placement values input */
export type PlacementGroupVariantCriteriaInput = {
  impressions?: InputMaybe<TrafficCampaignPlacementImpressionInput>;
  /** Which slots to target for this specific variant. */
  slots: Array<Scalars['String']['input']>;
  /** If true, the slots field value will use default values from the campaign placement defaults. */
  useDefaultSlot: Scalars['Boolean']['input'];
  /** variant id, must be unique within this array */
  variantId: Scalars['String']['input'];
};

export type PlacementInput = {
  additionalExcludes?: InputMaybe<Scalars['JSON']['input']>;
  additionalIncludes?: InputMaybe<Scalars['JSON']['input']>;
  asins?: InputMaybe<Array<Scalars['String']['input']>>;
  browseNodes?: InputMaybe<Array<Scalars['String']['input']>>;
  bullseyeExcludes?: InputMaybe<Array<Scalars['Int']['input']>>;
  bullseyeIncludes?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryNode?: InputMaybe<Array<Scalars['String']['input']>>;
  customerTargeting: Scalars['String']['input'];
  deviceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  event?: InputMaybe<PlacementEventDataInput>;
  guarantee?: InputMaybe<Scalars['Int']['input']>;
  impressionsDaysTimeout?: InputMaybe<Scalars['Int']['input']>;
  impressionsLimit?: InputMaybe<Scalars['Int']['input']>;
  kothOrGuarantee: Scalars['String']['input'];
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastActivePlacementHash?: InputMaybe<Scalars['String']['input']>;
  mvtAssignmentId?: InputMaybe<Scalars['String']['input']>;
  mvtName?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  pageType?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  scheduleType?: InputMaybe<Scalars['String']['input']>;
  slot?: InputMaybe<Scalars['String']['input']>;
  timeRange?: InputMaybe<DateRangeInputDeprecated>;
  uiId: Scalars['String']['input'];
  weblabName?: InputMaybe<Scalars['String']['input']>;
  weblabTreatment?: InputMaybe<Scalars['String']['input']>;
};

export type PlacementsSectionConfig = {
  __typename?: 'PlacementsSectionConfig';
  /** Customer options selections for targeting specific customer groups */
  customerOptions: CustomerOptionsConfigEnum;
  /** Whether impression capping is per variant */
  impressionCappingPerVariant?: Maybe<Scalars['Boolean']['output']>;
  /** Default values for new placements */
  initialPlacementValues?: Maybe<InitialPlacementValues>;
  /** Record of boolean flags indicating which placement components are enabled */
  placementComponents: Array<PlacementComponent>;
  /** Whether placement defaults are enabled for this campaign type */
  placementDefaultsEnabled: Scalars['Boolean']['output'];
  /** Configuration for slot options, either standard or variant-based */
  slotOptions: SlotOptionsUnion;
};

export type PlacementsSectionConfigInput = {
  /** Customer options selections for targeting specific customer groups */
  customerOptions: CustomerOptionsConfigEnum;
  /** Whether impression capping is per variant */
  impressionCappingPerVariant?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default values for new placements */
  initialPlacementValues?: InputMaybe<InitialPlacementValuesInput>;
  /** Record of boolean flags indicating which placement components are enabled */
  placementComponents: Array<PlacementComponentInput>;
  /** Whether placement defaults are enabled for this campaign type */
  placementDefaultsEnabled: Scalars['Boolean']['input'];
  /** Configuration for slot options, either standard or variant-based */
  slotOptions: SlotOptionsUnionInput;
};

export type PreviewPlacementEligibilityCriteriaRule = {
  /** targeting rules for the preview placement */
  excludes?: InputMaybe<Scalars['JSON']['input']>;
  /** targeting rules for the preview placement */
  includes: Scalars['JSON']['input'];
};

export type PreviewPlacementInput = {
  /** creative id that helps to figure out to which content this placement connects to */
  creativeId: Scalars['String']['input'];
  /** targeting rules for the preview placement */
  eligibilityCriteriaRule: PreviewPlacementEligibilityCriteriaRule;
  /** links in the preview placements */
  links: Scalars['JSON']['input'];
};

export type PreviewPlacementOutput = {
  __typename?: 'PreviewPlacementOutput';
  /** creative id that helps to figure out to which content this placement connects to */
  creativeId?: Maybe<Scalars['String']['output']>;
  /** links in the preview placements */
  links?: Maybe<Scalars['JSON']['output']>;
  /** targeting rules for the preview placement */
  rule?: Maybe<Scalars['String']['output']>;
};

export type PreviewSessionData = {
  __typename?: 'PreviewSessionData';
  /** added bullseye */
  addedBullseye2?: Maybe<Array<Scalars['BullseyeSegmentID']['output']>>;
  /** placements that are added in the preview session */
  previewPlacements?: Maybe<Array<PreviewPlacementOutput>>;
  /** preview time */
  previewTime?: Maybe<Scalars['String']['output']>;
  /** removed bullseye */
  removedBullseye2?: Maybe<Array<Scalars['BullseyeSegmentID']['output']>>;
};

export type PreviewSessionDataInput = {
  /** added bullseye */
  addedBullseye2: Array<Scalars['BullseyeSegmentID']['input']>;
  /** preview time */
  previewTime: Scalars['String']['input'];
  /** removed bullseye */
  removedBullseye2: Array<Scalars['BullseyeSegmentID']['input']>;
};

/** The different types of pricing information that we store. */
export enum PricingEnum {
  Currency = 'currency',
  OurPrice = 'ourPrice',
  OurPriceWithTax = 'ourPriceWithTax'
}

export type PricingInfo = PricingInfoInterface & {
  __typename?: 'PricingInfo';
  infoType: PricingEnum;
  /** Time at which the pricing element was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this pricing element */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  modifiedAt: Scalars['String']['output'];
  modifiedBy: Scalars['String']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  value: Scalars['String']['output'];
  /** The latest version of this attribute */
  version: Scalars['Int']['output'];
};

export type PricingInfoCopyFailure = PricingInfoFailureInterface & {
  __typename?: 'PricingInfoCopyFailure';
  /** The ASIN associated with the copy failure */
  asin: Scalars['String']['output'];
  infoType: PricingEnum;
  /** The reason the saving for this pricing info failed. */
  reason: Scalars['String']['output'];
};

export type PricingInfoCopyResponse = PricingInfoInterface & {
  __typename?: 'PricingInfoCopyResponse';
  /** The ASIN that the pricing info was copied too */
  asin: Scalars['String']['output'];
  infoType: PricingEnum;
  /** Time at which the pricing element was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this pricing element */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  modifiedAt: Scalars['String']['output'];
  modifiedBy: Scalars['String']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  value: Scalars['String']['output'];
  /** The latest version of this attribute */
  version: Scalars['Int']['output'];
};

export type PricingInfoFailureInterface = {
  infoType: PricingEnum;
  /** The reason the saving for this pricing info failed. */
  reason: Scalars['String']['output'];
};

export type PricingInfoInput = {
  infoType: PricingEnum;
  value: Scalars['String']['input'];
  /** The most recent version number that you, the client, have for this pricing info. If you are creating a new pricing info, pass zero for the version. */
  version: Scalars['Int']['input'];
};

export type PricingInfoInterface = {
  infoType: PricingEnum;
  /** Time at which the pricing element was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this pricing element */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  modifiedAt: Scalars['String']['output'];
  modifiedBy: Scalars['String']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  value: Scalars['String']['output'];
  /** The latest version of this attribute */
  version: Scalars['Int']['output'];
};

export type Product = {
  __typename?: 'Product';
  /** ACGs for Symphony preview */
  accessControlGroups: Array<Scalars['String']['output']>;
  /** BGs for Symphony preview */
  businessGroupsIds: Array<Scalars['String']['output']>;
  detailPages: Array<DetailPage>;
  ghostProjects: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ProductIdAndProductNameError = {
  __typename?: 'ProductIdAndProductNameError';
  /** The asin of the product. */
  asin: Scalars['String']['output'];
  /** An error message if the user doesn't have access to the Detail Page or something elsewent wrong such as the not finding the Detail Page. */
  error?: Maybe<Scalars['String']['output']>;
  /** A marketplace for the product. */
  marketplace: Scalars['String']['output'];
};

export type ProductIdAndProductNameQueryResponse = ProductIdAndProductNameError | ProductIdAndProductNameStatus;

export type ProductIdAndProductNameStatus = {
  __typename?: 'ProductIdAndProductNameStatus';
  /** The asin of the product. */
  asin: Scalars['String']['output'];
  /** A marketplace for the product. */
  marketplace: Scalars['String']['output'];
  products: Product;
};

export type ProductIdQueryResponse = {
  __typename?: 'ProductIdQueryResponse';
  /** Error code if there was an error */
  code?: Maybe<Scalars['String']['output']>;
  /** Extra debugging info if there was an error. */
  detail?: Maybe<Scalars['String']['output']>;
  /** An error message if the user doesn't have access to the Detail Page or something elsewent wrong such as the not finding the Detail Page. */
  error?: Maybe<Scalars['String']['output']>;
  /** The product ID, if one was found. */
  productId?: Maybe<Scalars['String']['output']>;
};

export type ProductIdsToProgramsOutput = {
  __typename?: 'ProductIdsToProgramsOutput';
  programs: Array<Program>;
};

export enum ProductLine {
  Alf = 'ALF',
  Apo = 'APO',
  Aucc = 'AUCC',
  Accessories = 'Accessories',
  AmazonFresh = 'AmazonFresh',
  AmazonKidsPlus = 'AmazonKidsPlus',
  AmazonPharmacy = 'AmazonPharmacy',
  Blink = 'BLINK',
  CaJourneys = 'CAJourneys',
  Coro = 'CORO',
  CertifiedRefurb = 'CertifiedRefurb',
  Dash = 'DASH',
  Eero = 'EERO',
  Eink = 'EINK',
  EmergingDevices = 'EmergingDevices',
  F3Mint = 'F3MINT',
  Fsn = 'FSN',
  Ftv1P = 'FTV1P',
  Ftv3P = 'FTV3P',
  FireTv = 'FireTV',
  Gwaf = 'GWAF',
  GwAmazonBasics = 'GWAmazonBasics',
  GwAmazonFresh = 'GWAmazonFresh',
  GwAmazonGo = 'GWAmazonGo',
  GwAmazonKidsPlus = 'GWAmazonKidsPlus',
  GwBooks = 'GWBooks',
  GwBrightBuy = 'GWBrightBuy',
  GwConsumablesPrivateBrands = 'GWConsumablesPrivateBrands',
  GwDeals = 'GWDeals',
  GwDevicesAudioCloudComputing = 'GWDevicesAudioCloudComputing',
  GwDevicesCrossCategory = 'GWDevicesCrossCategory',
  GwDevicesHealthAndWellness = 'GWDevicesHealthAndWellness',
  GwDevicesTradeIn = 'GWDevicesTradeIn',
  GwDevicesXpl = 'GWDevicesXPL',
  GwDigitalVideo = 'GWDigitalVideo',
  GwDiscoTech = 'GWDiscoTech',
  GwEvents = 'GWEvents',
  GwGatewayTeam = 'GWGatewayTeam',
  GwGiftCards = 'GWGiftCards',
  GwGrocery = 'GWGrocery',
  Gwhi = 'GWHI',
  GwHandmade = 'GWHandmade',
  GwHome = 'GWHome',
  GwHomePrivateBrands = 'GWHomePrivateBrands',
  Gwlg = 'GWLG',
  Gwma = 'GWMA',
  Gwmx = 'GWMX',
  GwMediaCrossCategory = 'GWMediaCrossCategory',
  Gwpw = 'GWPW',
  GwPrimeNow = 'GWPrimeNow',
  GwSoftlinesPrivateBrands = 'GWSoftlinesPrivateBrands',
  GwSoftware = 'GWSoftware',
  Gwtr = 'GWTR',
  GwTools = 'GWTools',
  GwTradeIn = 'GWTradeIn',
  GwVideoGames = 'GWVideoGames',
  GwWholeFoodsMarket = 'GWWholeFoodsMarket',
  Ha = 'HA',
  Hw = 'HW',
  HealthConditionsProgram = 'HealthConditionsProgram',
  Install = 'INSTALL',
  Misc = 'Misc',
  OneMedicalMembership = 'OneMedicalMembership',
  OneMedicalPpv = 'OneMedicalPPV',
  PaeMarketing = 'PAEMarketing',
  Phone = 'Phone',
  PrimeAir = 'PrimeAir',
  Ring = 'RING',
  RingSmartLighting = 'Ring_Smart_Lighting',
  Sh = 'SH',
  Smp = 'SMP',
  SitemerchHi = 'SitemerchHI',
  SitemerchLg = 'SitemerchLG',
  Tab = 'TAB',
  Tempo = 'Tempo',
  Vicc = 'VICC',
  ViCcBlink = 'ViCC_Blink',
  ViCcEero = 'ViCC_Eero',
  ViCcRing = 'ViCC_Ring',
  Xpl = 'XPL',
  Zephyr = 'ZEPHYR'
}

/** A representation of Devices ProductLine */
export type ProductLine2 = {
  __typename?: 'ProductLine2';
  asins: ProductLine2Asins_Connection;
  /** The product line vertex id in DCS */
  id: Scalars['ID']['output'];
  /** The ProductLine name from PPLS */
  name: Scalars['String']['output'];
  /** The ProductLine ID from PPLS */
  productLineId: Scalars['String']['output'];
  programs: ProductLine2Programs_Connection;
};


/** A representation of Devices ProductLine */
export type ProductLine2AsinsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AsinFilterInput>;
  first: Scalars['Int']['input'];
  sortOptions?: InputMaybe<Array<AsinSortInput>>;
};


/** A representation of Devices ProductLine */
export type ProductLine2ProgramsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProgramFilterInput>;
  first: Scalars['Int']['input'];
  sortOptions?: InputMaybe<Array<ProgramSortInput>>;
};

export type ProductLine2Asins_Connection = {
  __typename?: 'ProductLine2Asins_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<AsinEdge>;
  /** Flattened list of ASIN type */
  nodes: Array<Asin>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductLine2Edge = {
  __typename?: 'ProductLine2Edge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: ProductLine2;
};

export type ProductLine2Programs_Connection = {
  __typename?: 'ProductLine2Programs_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<ProgramEdge>;
  /** Flattened list of Program type */
  nodes: Array<Program>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductLineFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  marketplaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum ProductLineSortEnum {
  Name = 'name'
}

export type ProductLineSortInput = {
  direction?: InputMaybe<SortDirectionEnum>;
  field: ProductLineSortEnum;
};

/** A representation of Devices Program */
export type Program = {
  __typename?: 'Program';
  asins: ProgramAsins_Connection;
  /** The program vertex id associated to the Program */
  id: Scalars['ID']['output'];
  /** The Program name from PPLS */
  name: Scalars['String']['output'];
  /** The Program ID from PPLS */
  programId: Scalars['String']['output'];
};


/** A representation of Devices Program */
export type ProgramAsinsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AsinFilterInput>;
  first: Scalars['Int']['input'];
  sortOptions?: InputMaybe<Array<AsinSortInput>>;
};

export type ProgramAsins_Connection = {
  __typename?: 'ProgramAsins_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<AsinEdge>;
  /** Flattened list of ASIN type */
  nodes: Array<Asin>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProgramEdge = {
  __typename?: 'ProgramEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: Program;
};

export type ProgramFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  marketplaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Find programs containing each name provided (e.g. ["Blink", "Lotus"] will find programs with "Blink" and "Lotus" in the name) */
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  productLineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProgramInfo = {
  __typename?: 'ProgramInfo';
  /** The unique identifier of the program */
  id: Scalars['String']['output'];
  /** The display name of the program */
  name: Scalars['String']['output'];
};

export enum ProgramSortEnum {
  Name = 'name'
}

export type ProgramSortInput = {
  direction?: InputMaybe<SortDirectionEnum>;
  field: ProgramSortEnum;
};

export type Project = {
  __typename?: 'Project';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  intent?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt: Scalars['String']['output'];
  modifiedBy: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Boolean']['output']>;
  permissions: Array<ProjectPermission>;
  public: Scalars['String']['output'];
  settings?: Maybe<ProjectSettings>;
  state: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type ProjectAssetsInput = {
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
};

export type ProjectEvent = {
  __typename?: 'ProjectEvent';
  accessControlGroup?: Maybe<Scalars['String']['output']>;
  businessGroup?: Maybe<Scalars['String']['output']>;
  childEvents: Array<ChildEvent>;
  name?: Maybe<Scalars['String']['output']>;
  parentEventId?: Maybe<Scalars['String']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type ProjectEventQueryResponse = {
  __typename?: 'ProjectEventQueryResponse';
  projectEvent?: Maybe<ProjectEvent>;
};

export type ProjectPermission = BindlePermission | LdapPermission | Permission;

export type ProjectSettings = {
  __typename?: 'ProjectSettings';
  eventId: Scalars['String']['output'];
};

export type PromptVariableInput = {
  /** The variable key name */
  key: Scalars['String']['input'];
  /** The variable value */
  value: Scalars['String']['input'];
};

export type PublishAssetMutationResponse = MutationResponse & {
  __typename?: 'PublishAssetMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** List of assetIds that failed to publish */
  failed: Array<AssetPublishObject>;
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** List of assetIds that were successful */
  succeeded: Array<AssetPublishObject>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type PublishAttributesInput = {
  asin: Scalars['String']['input'];
  attributes: Array<DpAttributeInput>;
  /** optional boolean that will be passed in */
  isLaunchPermOn?: Scalars['Boolean']['input'];
  marketplace: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  /** Whether to publish using data augmenter instead of retail merchant */
  useDataAugmenter?: Scalars['Boolean']['input'];
};

export type PublishCampaignAssetInput = {
  /** Pass a specification of the assets you want to publish. You may have multiple AssetPublishConfig with the same assetId but with different dimensions. E.g. if you're publishing an auto-generated low-res asset along with the high-res one. */
  assets: Array<AssetPublishConfig>;
  /** Pass your campaign's language setting. The language determines the OrgUnit that the assets are published to. */
  language: Scalars['String']['input'];
  /** Pass your campaign's product line setting. This determines the folder in MC that the images are published to. */
  productLine?: InputMaybe<ProductLine>;
  /** The project ID that contains the campaign that you are attempting to publish assets. If not provided, the project ID will be inferred from the asset(s) attempting to be published. */
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type PublishCampaignAssetsMutationResponse = MutationResponse & {
  __typename?: 'PublishCampaignAssetsMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** Assets that failed to publish */
  failed: Array<CampaignAssetPublishResult>;
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Assets the published successfully */
  succeeded: Array<CampaignAssetPublishResult>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type PublishPricingInfoFailure = {
  __typename?: 'PublishPricingInfoFailure';
  infoType: PricingEnum;
  /** The reason the publishing for this pricing info failed. */
  reason: Scalars['String']['output'];
};

export type PublishPricingInfoInput = {
  asin: Scalars['ID']['input'];
  /** optional boolean that will be passed in */
  isLaunchPermOn?: Scalars['Boolean']['input'];
  marketplace: Scalars['String']['input'];
  pricingInfo: Array<PricingInfoInput>;
  productId: Scalars['ID']['input'];
};

export type PublishPricingInfoMutationResponse = MutationResponse & {
  __typename?: 'PublishPricingInfoMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  failed: Array<PublishPricingInfoFailure>;
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  succeeded: Array<PricingInfo>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type PublishSlateMutationResponse = MutationResponse & {
  __typename?: 'PublishSlateMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  failed: Array<SlateImageFailure>;
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  shipmentId?: Maybe<Scalars['String']['output']>;
  succeeded: Array<SlateImage>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type PublishSlatePlaceholdersMutationResponse = MutationResponse & {
  __typename?: 'PublishSlatePlaceholdersMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  failed: Array<Scalars['String']['output']>;
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  shipmentId?: Maybe<Scalars['String']['output']>;
  succeeded: Array<Scalars['String']['output']>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

/** Publishing status enumeration */
export enum PublishStatusEnum {
  Draft = 'DRAFT',
  DraftWithActive = 'DRAFT_WITH_ACTIVE',
  Published = 'PUBLISHED',
  PublishFailed = 'PUBLISH_FAILED',
  PublishPending = 'PUBLISH_PENDING'
}

export type PublishingConfiguration = {
  __typename?: 'PublishingConfiguration';
  /** Key that maps to a creative name prefix override function */
  creativeNamePrefixOverrideKey?: Maybe<Scalars['String']['output']>;
  /** Widget type for publishing transformation. "Declarative" widgets nest their content in an "arguments" item */
  widgetType?: Maybe<WidgetType>;
};

export type PublishingConfigurationInput = {
  /** Key that maps to a creative name prefix override function */
  creativeNamePrefixOverrideKey?: InputMaybe<Scalars['String']['input']>;
  /** Widget type for publishing transformation. "Declarative" widgets nest their content in an "arguments" item */
  widgetType?: InputMaybe<WidgetType>;
};

export type QaComment = {
  __typename?: 'QAComment';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** QA comment ID */
  id: Scalars['ID']['output'];
  /** Review being commented on */
  review: QaReview;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type QaCommentConnection = {
  __typename?: 'QACommentConnection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<QaCommentEdge>;
  /** Flattened list of QAComment type */
  nodes: Array<QaComment>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
};

export type QaCommentEdge = {
  __typename?: 'QACommentEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: QaComment;
};

export type QaCommentResponse = {
  __typename?: 'QACommentResponse';
  comment: QaComment;
};

export type QaRemoveCommentResponse = {
  __typename?: 'QARemoveCommentResponse';
  review: QaReview;
};

export type QaRemoveReviewResponse = {
  __typename?: 'QARemoveReviewResponse';
  content: Content;
};

export type QaReview = {
  __typename?: 'QAReview';
  comment?: Maybe<Scalars['String']['output']>;
  /** Content being reviewed */
  content: Content;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** QA review ID */
  id: Scalars['ID']['output'];
  replies: QaCommentConnection;
  status?: Maybe<QaStatusEnum>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};


export type QaReviewRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QaReviewResponse = {
  __typename?: 'QAReviewResponse';
  review: QaReview;
};

export enum QaStatusFilterEnum {
  Approved = 'APPROVED',
  NotReviewed = 'NOT_REVIEWED',
  Rejected = 'REJECTED'
}

export enum QaStatusEnum {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type Query = {
  __typename?: 'Query';
  BullseyeSegmentStatuses: Array<BullseyeSegmentsQueryResult>;
  /** @deprecated This query is deprecated and exists for  for Vue app compatibility. Use the new `ComponentDetailsV2Query` instead */
  ComponentDetails: ComponentDetailsQueryResponse;
  JAGs: QueryJaGs_Connection;
  /** Get catalog image urls for this ASIN and its variational ASINs */
  asinToCatalogImageUrlsMap: AsinToCatalogImageUrlsMap;
  asins: QueryAsins_Connection;
  /** Get assets across all projects */
  assets: AssetsOffsetPage;
  /**
   * Get assets
   * @deprecated This is a query structured for Vue app compatibility. Use "assets" or "projectAssets" queries for
   *     any new work.
   */
  assetsSearch: AssetSearchResponses;
  /** Get the attributes for a DP that DPB has saved in DDB */
  attributes: Array<DpAttribute>;
  bulkAtfQuery: BulkAtfQueryResponse;
  bulkPublishPreview: QueryBulkPublishPreview_Connection;
  /** Get slate images for a list of DPs */
  bulkSlates: Array<BulkSlateImageResponse>;
  /** Get bundle component of an ASIN */
  bundleInfo: BundleInfo;
  /** Get list of programs and ASINs by marketplace for bundle manager */
  bundleManagerPrograms: Array<BundleManagerProgram>;
  campaign: Campaign;
  campaignConfigurations: CampaignConfigurationConnection;
  /** Returns all traffic and legacy (including MVT) campaigns for a given project id. */
  campaigns: QueryCampaigns_Connection;
  checkASINAccess: AsinAccessResponse;
  componentDetailsV2: ComponentDetailsV2QueryResponse;
  /** Get conversations with filtering and pagination */
  conversations: QueryConversations_Connection;
  detailPageStatus: DetailPageStatusQueryResponse;
  /** Get a detail page experiment by ID */
  dpExperiment: DpExperimentDetails;
  /** Get a detail page experiment by ID */
  dpExperimentV2: DpExperimentDetailsV2;
  /** Get all detail page experiments */
  dpExperiments: Array<DpExperimentDetails>;
  /** Get all detail page experiments using DCS as a data source */
  dpExperimentsV2: Array<DpExperimentDetailsV2>;
  /** Get the Echo message from DBM Service */
  echoMessage: EchoString;
  /** Get ASIN-related metadata about the experiment */
  experimentAsinMetadata: ExperimentAsinMetadata;
  fbKeywordRecs: GetFbKeywordRecsResponse;
  /** Generate alt text for an image using Bedrock AI */
  generateAltText: GenerateAltTextOutput;
  /** Generate experimental content */
  generateExperimentContent: DpExperimentGeneratedExperimentContentResponse;
  /** Get the assets with the S3SignedURL for the assetIDs in the request */
  getAssetsByIds: GetAssetsByIdsOutput;
  /** Fetch the content status from bridge service. */
  getContentStatus: StatusSummary;
  /** Calls the GetHistoryViewBundles DBM API. Returns all bundles for the user within the last 90 days */
  getHistoryViewBundles: GetHistoryViewBundlesResponse;
  /** Get the list of previewers */
  getListPreviewers: Array<SymphonyPreviewer>;
  /** Get Users from PAPI */
  getPapiUsers: Array<PapiUser>;
  /** Fetch the placement status from bridge service. */
  getPlacementStatus: StatusSummary;
  /** Hash a dp experiment and any variants that belong to it */
  hashExperiment: DpExperimentHashResponse;
  /** @deprecated Use jobs instead */
  job: Jobs;
  jobs: Array<Jobs>;
  /** Search Journeys assets based on the given input parameters from opensearch */
  journeysAssets: JourneysAssetSearchResult;
  /** Get the last published version of the pricing element */
  lastPublishedPricing: Array<PricingInfo>;
  /** Get the last published version of the attribute */
  lastPublishedSlateVersions: Array<SlateImage>;
  /** Get the last published version of the attribute */
  lastPublishedVersions: Array<DpAttribute>;
  /** Fetch a single media asset by ID */
  mediaAsset: MediaAssetNode;
  /** Get the merchandized bundle config for a DP that DPB has saved in DDB */
  merchandizedBundles: Array<MerchandizedBundleConfig>;
  /** Get the catalog feature bullets for asins */
  mvesCatalogFeatureBullets: AsinAndCatalogFeatureBullets;
  /** Get the catalog feature bullets for multiple asins */
  mvesCatalogFeatureBulletsForAsins: Array<AsinAndCatalogFeatureBullets>;
  /** Get the catalog title for asins */
  mvesCatalogTitle: AsinAndCatalogTitle;
  /** Get the catalog title for asins */
  mvesCatalogTitles: Array<AsinAndCatalogTitle>;
  /** Get the MVES Experiment Status for a DPB Experiment */
  mvesExperimentStatus: Array<MvesExperimentStatus>;
  /** Get the LEFT and RGHT variant URLs for multiple asins */
  mvesVariantImagesForAsins: Array<AsinAndCatalogVariantImages>;
  /** Get the variational asins for an asin */
  mvesVariationalAsins: Array<AsinAndCatalogTitleWithParentFlag>;
  /** Get pricing info for a DP */
  pricing: Array<PricingInfo>;
  product: Product;
  productIdAndProductNameForBulkImage: Array<ProductIdAndProductNameQueryResponse>;
  productIdForDetailPage: ProductIdQueryResponse;
  /** Converts DPB Product IDs to DCS Programs */
  productIdsToPrograms: ProductIdsToProgramsOutput;
  productLines: QueryProductLines_Connection;
  programs: QueryPrograms_Connection;
  project: Project;
  /** Get assets in a project */
  projectAssets: Array<AssetSearchResult>;
  projectEvent: ProjectEventQueryResponse;
  projectPermissions: Permissions;
  realms: QueryRealms_Connection;
  /** Fetch the primary view of a MaRs widget from MaRs service. */
  renderMarsWidget: RenderMarsWidgetResponse;
  /** Get slate images for a DP */
  slates: Array<SlateImage>;
  symphonyInfo: Array<SymphonyInfo>;
  templateGroups: QueryTemplateGroups_Connection;
  trafficAssetSearch: QueryTrafficAssetSearch_Connection;
  trafficCampaign: TrafficCampaign;
  /** Get a single TrafficProject by ID. */
  trafficProject: TrafficProject;
  trafficProjectSearch: QueryTrafficProjectSearch_Connection;
  user?: Maybe<User>;
  /** Get the landing image, title, structured title, and bullet variants for a DP experiment */
  variants: DpExperimentAsinVariants;
  /** Get the landing image, title, structured title, and bullet variants for a DP experiment for multiple ASINs */
  variantsMap: DpExperimentAsinVariantsMap;
  /** Get the variational asin hierarchy for an asin */
  variationalAsinHierarchy: Array<VariationalAsin>;
};


export type QueryBullseyeSegmentStatusesArgs = {
  ids: Array<Scalars['BullseyeSegmentID']['input']>;
  realm: Scalars['String']['input'];
};


export type QueryComponentDetailsArgs = {
  input: ComponentDetailsInput;
};


export type QueryJaGsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters: JagFilterInput;
  first: Scalars['Int']['input'];
};


export type QueryAsinToCatalogImageUrlsMapArgs = {
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
};


export type QueryAsinsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AsinFilterInput>;
  first: Scalars['Int']['input'];
  sortOptions?: InputMaybe<Array<AsinSortInput>>;
};


export type QueryAssetsArgs = {
  input: AssetsQueryInput;
};


export type QueryAssetsSearchArgs = {
  input: AssetSearchRequest;
};


export type QueryAttributesArgs = {
  asin: Scalars['String']['input'];
  isLaunchPermOn?: Scalars['Boolean']['input'];
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  marketplace: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBulkAtfQueryArgs = {
  asins: Array<Scalars['String']['input']>;
  attributes: BulkAtfQueryInput;
  marketplaces_languages: Array<Scalars['String']['input']>;
  pricing_fields: Array<Scalars['String']['input']>;
};


export type QueryBulkPublishPreviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<BulkPublishPreviewInput>;
  first: Scalars['Int']['input'];
};


export type QueryBulkSlatesArgs = {
  input: Array<BulkSlatesQueryObject>;
};


export type QueryBundleInfoArgs = {
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
};


export type QueryBundleManagerProgramsArgs = {
  marketplace?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryCampaignConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
  sortOptions?: SortOptions;
};


export type QueryCheckAsinAccessArgs = {
  input: AsinAccessInput;
};


export type QueryComponentDetailsV2Args = {
  input: ComponentDetailsInput;
};


export type QueryConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  correlationId: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryDetailPageStatusArgs = {
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
};


export type QueryDpExperimentArgs = {
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
};


export type QueryDpExperimentV2Args = {
  experimentId: Scalars['ID']['input'];
};


export type QueryEchoMessageArgs = {
  message: Scalars['String']['input'];
};


export type QueryExperimentAsinMetadataArgs = {
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
};


export type QueryFbKeywordRecsArgs = {
  input: GetFbKeywordRecsInput;
};


export type QueryGenerateAltTextArgs = {
  input: GenerateAltTextInput;
};


export type QueryGenerateExperimentContentArgs = {
  asin: Scalars['String']['input'];
  context: DpExperimentGeneratedExperimentContentContextInput;
  locale: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
  variantType: Scalars['String']['input'];
};


export type QueryGetAssetsByIdsArgs = {
  input: GetAssetsByIdsInput;
};


export type QueryGetContentStatusArgs = {
  campaignStatus: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  minimal: Scalars['Boolean']['input'];
  realm: Scalars['String']['input'];
};


export type QueryGetHistoryViewBundlesArgs = {
  input: GetHistoryViewBundlesRequest;
};


export type QueryGetListPreviewersArgs = {
  realm: Scalars['String']['input'];
};


export type QueryGetPapiUsersArgs = {
  query: Scalars['String']['input'];
};


export type QueryGetPlacementStatusArgs = {
  id: Scalars['String']['input'];
  minimal: Scalars['Boolean']['input'];
  realm: Scalars['String']['input'];
};


export type QueryHashExperimentArgs = {
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
};


export type QueryJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryJourneysAssetsArgs = {
  input: JourneysAssetSearchInput;
};


export type QueryLastPublishedPricingArgs = {
  input: LastPublishedPricingInput;
};


export type QueryLastPublishedSlateVersionsArgs = {
  input: LastPublishedSlateVersionsInput;
};


export type QueryLastPublishedVersionsArgs = {
  input: LastPublishedVersionsInput;
};


export type QueryMediaAssetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMerchandizedBundlesArgs = {
  keys: Array<Scalars['String']['input']>;
  marketplace: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
};


export type QueryMvesCatalogFeatureBulletsArgs = {
  asin: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
};


export type QueryMvesCatalogFeatureBulletsForAsinsArgs = {
  asinList: Array<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
};


export type QueryMvesCatalogTitleArgs = {
  asin: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
};


export type QueryMvesCatalogTitlesArgs = {
  asinList: Array<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
};


export type QueryMvesExperimentStatusArgs = {
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
};


export type QueryMvesVariantImagesForAsinsArgs = {
  asinList: Array<Scalars['String']['input']>;
  marketplace: Scalars['String']['input'];
};


export type QueryMvesVariationalAsinsArgs = {
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
};


export type QueryPricingArgs = {
  asin: Scalars['String']['input'];
  isLaunchPermOn?: Scalars['Boolean']['input'];
  marketplace: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
};


export type QueryProductArgs = {
  asin?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  marketplace: Scalars['String']['input'];
};


export type QueryProductIdAndProductNameForBulkImageArgs = {
  input: Array<MpAsinQueryObject>;
};


export type QueryProductIdForDetailPageArgs = {
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
};


export type QueryProductIdsToProgramsArgs = {
  productIds: Array<Scalars['String']['input']>;
};


export type QueryProductLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductLineFilterInput>;
  first: Scalars['Int']['input'];
  sortOptions?: InputMaybe<Array<ProductLineSortInput>>;
};


export type QueryProgramsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProgramFilterInput>;
  first: Scalars['Int']['input'];
  sortOptions?: InputMaybe<Array<ProgramSortInput>>;
};


export type QueryProjectArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectAssetsArgs = {
  input: ProjectAssetsInput;
};


export type QueryProjectEventArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectPermissionsArgs = {
  action: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type QueryRealmsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryRenderMarsWidgetArgs = {
  currencyCode: Scalars['String']['input'];
  language: Scalars['String']['input'];
  widget: MarsWidgetDefinition;
};


export type QuerySlatesArgs = {
  asin: Scalars['String']['input'];
  isLaunchPermOn?: Scalars['Boolean']['input'];
  marketplace: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
};


export type QuerySymphonyInfoArgs = {
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryTemplateGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryTrafficAssetSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filterOptions?: InputMaybe<TrafficAssetSearchFilterOptions>;
  first: Scalars['Int']['input'];
  maxHeight?: Scalars['Int']['input'];
  query?: Scalars['String']['input'];
  visibleToAll?: Scalars['Boolean']['input'];
};


export type QueryTrafficCampaignArgs = {
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryTrafficProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTrafficProjectSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: TrafficProjectSearchFilterInput;
  first: Scalars['Int']['input'];
  query?: Scalars['String']['input'];
  searchType: TrafficProjectSearchType;
  sort?: Array<TrafficProjectSearchSortInput>;
};


export type QueryVariantsArgs = {
  asin: Scalars['String']['input'];
  dpbExperimentId: Scalars['ID']['input'];
};


export type QueryVariantsMapArgs = {
  asins: Array<Scalars['String']['input']>;
  dpbExperimentId: Scalars['ID']['input'];
};


export type QueryVariationalAsinHierarchyArgs = {
  asins: Array<Scalars['String']['input']>;
  getTitles: Scalars['Boolean']['input'];
  marketplace: Scalars['String']['input'];
};

export type QueryAsins_Connection = {
  __typename?: 'QueryAsins_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<AsinEdge>;
  launchGatingInfo: Array<AsinLaunchGatingInfo>;
  /** Flattened list of ASIN type */
  nodes: Array<Asin>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QueryBulkPublishPreview_Connection = {
  __typename?: 'QueryBulkPublishPreview_Connection';
  /** List of unique programs associated with the selected ASINs */
  availablePrograms: Array<ProgramInfo>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<DpAttributeEdge>;
  /** ASINs that are missing attributes or failed to resolve */
  invalidAsins: Array<InvalidAsinWithMissingAttributes>;
  /** Flattened list of DpAttribute type */
  nodes: Array<DpAttribute>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  /** Total number of attributes after language filtering, before pagination and marketplace filtering */
  totalAttributesBeingPreviewed: Scalars['Int']['output'];
  /** Total number of attributes not in draft state after language filtering, before optional filters */
  totalAttributesNotInDraft: Scalars['Int']['output'];
};

export type QueryCampaigns_Connection = {
  __typename?: 'QueryCampaigns_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<CampaignEdge>;
  /** Flattened list of Campaign type */
  nodes: Array<Campaign>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QueryConversations_Connection = {
  __typename?: 'QueryConversations_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<ChatConversationEdge>;
  /** Flattened list of ChatConversation type */
  nodes: Array<ChatConversation>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QueryJaGs_Connection = {
  __typename?: 'QueryJAGs_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<AssetGroupEdge>;
  jagFilterOptionValues: JourneysAssetGroupFilterOptionValuesType;
  /** Flattened list of AssetGroup type */
  nodes: Array<AssetGroup>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};


export type QueryJaGs_ConnectionJagFilterOptionValuesArgs = {
  filters: JagFilterBaseInput;
};

export type QueryProductLines_Connection = {
  __typename?: 'QueryProductLines_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<ProductLine2Edge>;
  /** Flattened list of ProductLine2 type */
  nodes: Array<ProductLine2>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QueryPrograms_Connection = {
  __typename?: 'QueryPrograms_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<ProgramEdge>;
  /** Flattened list of Program type */
  nodes: Array<Program>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QueryRealms_Connection = {
  __typename?: 'QueryRealms_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<RealmEdge>;
  /** Flattened list of Realm type */
  nodes: Array<Realm>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QueryTemplateGroups_Connection = {
  __typename?: 'QueryTemplateGroups_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<TemplateGroupEdge>;
  /** Flattened list of TemplateGroup type */
  nodes: Array<TemplateGroup>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QueryTrafficAssetSearch_Connection = {
  __typename?: 'QueryTrafficAssetSearch_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<TrafficAssetEdge>;
  filterOptions: TrafficAssetSearchFilters;
  /** Flattened list of TrafficAsset type */
  nodes: Array<TrafficAsset>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QueryTrafficProjectSearch_Connection = {
  __typename?: 'QueryTrafficProjectSearch_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<TrafficProjectEdge>;
  filterOptions: TrafficProjectSearchFilters;
  /** Flattened list of TrafficProject type */
  nodes: Array<TrafficProject>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Realm = {
  __typename?: 'Realm';
  /** Realm value */
  display: Scalars['String']['output'];
  /** Realm id */
  id: Scalars['ID']['output'];
  marketplaces: RealmMarketplaces_Connection;
};


export type RealmMarketplacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type RealmEdge = {
  __typename?: 'RealmEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: Realm;
};

export type RealmMarketplaces_Connection = {
  __typename?: 'RealmMarketplaces_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<MarketplaceEdge>;
  /** Flattened list of Marketplace type */
  nodes: Array<Marketplace>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefTag = {
  __typename?: 'RefTag';
  additionalText?: Maybe<Scalars['String']['output']>;
  autoGenerate?: Maybe<Scalars['Boolean']['output']>;
  eventShortName?: Maybe<Scalars['String']['output']>;
  productLine?: Maybe<Scalars['String']['output']>;
  programShortName?: Maybe<Scalars['String']['output']>;
  slot?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type RemoveQaCommentInput = {
  commentId: Scalars['ID']['input'];
};

export type RemoveQaReviewInput = {
  reviewId: Scalars['ID']['input'];
};

export type RemoveTrafficCampaignFlavorInput = {
  /** ID of the TrafficCampaignFlavor to be removed */
  flavorId: Scalars['ID']['input'];
  /** ID of the TrafficCampaign to update */
  id: Scalars['ID']['input'];
  /** Name of this TrafficCampaign */
  name: Scalars['String']['input'];
  /** ID of the TrafficProject containing this TrafficCampaign */
  projectId: Scalars['ID']['input'];
  /** Version of the schema used to store this campaign's data */
  schemaVersion: Scalars['Int']['input'];
  /** Expected current version of the TrafficCampaign */
  version: Scalars['Int']['input'];
};

export type RenameAssetGroupResponse = {
  __typename?: 'RenameAssetGroupResponse';
  /** The AssetGroup that was renamed */
  assetGroup: AssetGroup;
};

export type RenameAssetInput = {
  assetId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type RenderMarsWidgetResponse = {
  __typename?: 'RenderMarsWidgetResponse';
  /** htmlFragments returned by MaRs service */
  htmlFragments: Scalars['String']['output'];
};

export type RowErrorUnion = AttributeOrPricingErrors | ErrorAsinMarketplaceNotFound;

export type RowResults = {
  __typename?: 'RowResults';
  asin: Scalars['String']['output'];
  marketplace: Scalars['String']['output'];
  rowErrors?: Maybe<Array<RowErrorUnion>>;
  rowNumber: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type SaveAndGenerateAssetsResponse = {
  __typename?: 'SaveAndGenerateAssetsResponse';
  /** The AssetGroup that was saved and generated */
  assetGroup: AssetGroup;
};

export type SaveAssetChangesResponse = {
  __typename?: 'SaveAssetChangesResponse';
  /** The AssetGroup that was saved */
  assetGroup: AssetGroup;
};

export type SaveAttributesInput = {
  asin: Scalars['ID']['input'];
  attributes: Array<DpAttributeInput>;
  /** optional boolean that will be passed in */
  isLaunchPermOn?: Scalars['Boolean']['input'];
  marketplace: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
};

export type SaveBundleSlateVariantsInput = {
  /** base ASIn that is used to create the bundle */
  baseAsin: Scalars['String']['input'];
  /** component ASINs that are added to the based ASIN while creating a bundle */
  componentAsins: Array<Scalars['String']['input']>;
  /** marketplace ID in which the bundle ASIN is getting created */
  obfuscatedMarketplaceId: Scalars['String']['input'];
  /** selected variants while creating the bundle which are used to copy slates of selected variant */
  variants: Array<Scalars['String']['input']>;
};

export type SaveBundleSlateVariantsResponse = {
  __typename?: 'SaveBundleSlateVariantsResponse';
  /** base ASIn that is used to create the bundle */
  baseAsin: Scalars['String']['output'];
  /** component ASINs that are added to the based ASIN while creating a bundle */
  componentAsins: Array<Scalars['String']['output']>;
  /** marketplace ID in which the bundle ASIN is getting created */
  obfuscatedMarketplaceId: Scalars['String']['output'];
  /** selected variants while creating the bundle which are used to copy slates of selected variant */
  variants: Array<Scalars['String']['output']>;
};

export type SaveCampaignInput = {
  accessControlGroup?: InputMaybe<Scalars['String']['input']>;
  additionalName?: InputMaybe<Scalars['String']['input']>;
  alexaEnabled?: InputMaybe<Scalars['String']['input']>;
  businessGroup?: InputMaybe<Scalars['String']['input']>;
  /** Pass the version of your campaign type here. If you update your frontend code, you can compare this version you receive from the server to the version in your code to see if the campaign needs to be upgraded. */
  campaignTypeVersion: Scalars['String']['input'];
  /** The dynamic content, controlled by the specific campaign type. Whatever the campaign needs to save, it should store in this object. */
  content?: InputMaybe<Scalars['JSON']['input']>;
  eventShortName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  intent?: InputMaybe<Scalars['String']['input']>;
  isAutoGenerateCreativeName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the campaign valid and ready to publish to Symphony */
  isCampaignValid: Scalars['Boolean']['input'];
  /** Pass as true if the JSON property order in your Symphony content is significant in deep comparison of old content versus new content. The only known use-case for this so far is for the MaRS Comp Chart widget, which uses the order of JSON props to determine the order of products. Setting this to true will make the comparison of content compare the literal string values of symphonyContent you pass. Defaults to false, which means the comparison will deep parse your content into JSON and compare it insensitive to prop order. */
  isPropertyOrderSignificantInSymphonyContent?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastActiveContentHash?: InputMaybe<Scalars['String']['input']>;
  mvtExperimentInfo?: InputMaybe<MvtExperimentInfoInput>;
  placements: Array<PlacementInput>;
  productLine?: InputMaybe<Scalars['String']['input']>;
  program?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  /** The MP config (called "backendPt" in Vue app). If the componentName in this changes, that will trigger Journeys to send Content to Symphony. */
  publishConfig?: InputMaybe<Scalars['JSON']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The Symphony content that the campaign type has generated for this campaign. This should be an object of type {[key: string]: string}. */
  symphonyContent?: InputMaybe<Scalars['JSON']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** The version for optimistic locking. */
  userVersion: Scalars['Int']['input'];
};

export type SaveCampaignMutationResponse = {
  __typename?: 'SaveCampaignMutationResponse';
  campaign: Campaign;
};

export type SaveMerchandizedBundleInput = {
  /** This is two character codes/country code, example - US, CA */
  marketplace: Scalars['String']['input'];
  merchandizedBundleConfig: Array<MerchandizedBundleInput>;
  /** This is unique id for the program which this configuration is created */
  programId: Scalars['ID']['input'];
};

export type SavePricingInfoFailure = PricingInfoFailureInterface & {
  __typename?: 'SavePricingInfoFailure';
  infoType: PricingEnum;
  /** The reason the saving for this pricing info failed. */
  reason: Scalars['String']['output'];
};

export type SavePricingInfoInput = {
  asin: Scalars['ID']['input'];
  /** optional boolean that will be passed in */
  isLaunchPermOn?: Scalars['Boolean']['input'];
  marketplace: Scalars['String']['input'];
  pricingInfo: Array<PricingInfoInput>;
  productId: Scalars['ID']['input'];
};

export type SavePricingInfoMutationResponse = MutationResponse & {
  __typename?: 'SavePricingInfoMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  failed: Array<SavePricingInfoFailure>;
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  succeeded: Array<PricingInfo>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type SaveSlatesInput = {
  asin: Scalars['ID']['input'];
  /** optional boolean that will be passed in */
  isLaunchPermOn?: Scalars['Boolean']['input'];
  marketplace: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  slates: Array<SlateImageInput>;
};

export type SaveSlatesMutationResponse = MutationResponse & {
  __typename?: 'SaveSlatesMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  failed: Array<SlateImageFailure>;
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  succeeded: Array<SlateImage>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type SaveTrafficCampaignFlavorInput = {
  /** Whether this flavor is still active and visible on the UI */
  active: Scalars['Boolean']['input'];
  /** Journeys form values for this flavor */
  content: Scalars['JSON']['input'];
  /** Name for Symphony creative. Ignore this value if hasGeneratedName is true. */
  creativeName?: InputMaybe<Scalars['String']['input']>;
  /** Flag to auto-generate creative name. Uses campaign name in generation regardless of campaign-name-generation. */
  hasGeneratedName?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the TrafficCampaign flavor */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Form inputs for this flavor's scheduling config. */
  scheduling: TrafficFlavorSchedulingInfoInput;
  /** Used by some campaign types to differentiate between flavors with same platform and locale */
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** Sets TrafficCampaign fields. If flavors is nullable, will skip updating flavors. */
export type SaveTrafficCampaignInput = {
  common?: InputMaybe<TrafficCampaignCommonInput>;
  flavors?: InputMaybe<Array<SaveTrafficCampaignFlavorInput>>;
  /** Global campaign-wide content applied to all flavors */
  globalContent?: InputMaybe<Scalars['JSON']['input']>;
  /** ID of the TrafficCampaign to update */
  id: Scalars['ID']['input'];
  /** Name of this TrafficCampaign */
  name: Scalars['String']['input'];
  placements?: InputMaybe<TrafficCampaignPlacementInput>;
  /** ID of the TrafficProject containing this TrafficCampaign */
  projectId: Scalars['ID']['input'];
  /** Version of the schema used to store this campaign's data */
  schemaVersion: Scalars['Int']['input'];
  varSharing?: InputMaybe<TrafficCampaignVariableSharingInput>;
  /** Expected current version of the TrafficCampaign */
  version: Scalars['Int']['input'];
};

export type SaveTrafficCampaignOutput = {
  __typename?: 'SaveTrafficCampaignOutput';
  campaign: TrafficCampaign;
};

export type ScopedSlotOption = {
  __typename?: 'ScopedSlotOption';
  /** Marketplace scope or DEFAULT */
  scope: Scalars['String']['output'];
  /** Platform-specific slots */
  variantSlots: Array<VariantSlot>;
};

export type ScopedSlotOptionInput = {
  /** Marketplace scope or DEFAULT */
  scope: Scalars['String']['input'];
  /** Platform-specific slots */
  variantSlots: Array<VariantSlotInput>;
};

export type ScopedVariantSlotOption = {
  __typename?: 'ScopedVariantSlotOption';
  /** Marketplace scope or DEFAULT */
  scope: Scalars['String']['output'];
  /** Variant-specific slots */
  variantSlots: Array<VariantSlot>;
};

export type ScopedVariantSlotOptionInput = {
  /** Marketplace scope or DEFAULT */
  scope: Scalars['String']['input'];
  /** Variant-specific slots */
  variantSlots: Array<VariantSlotInput>;
};

export type SeeMoreDetail = {
  __typename?: 'SeeMoreDetail';
  destinationUrl: DestinationUrl;
  textVariants: Array<StringVariant>;
};

/** Response from sending a message */
export type SendMessageResponse = {
  __typename?: 'SendMessageResponse';
  /** The updated conversation */
  conversation: ChatConversation;
};

/** Input for setting fields on Layered Image Assets (LIAs) within an AssetGroup */
export type SetAssetFieldInput = {
  /** Asset Group ID to update */
  assetGroupId: Scalars['ID']['input'];
  booleanFields?: InputMaybe<Array<BooleanFieldInput>>;
  jsonFields?: InputMaybe<Array<JsonFieldInput>>;
  numberFields?: InputMaybe<Array<NumberFieldInput>>;
  /** Asset Group current record version number */
  rvn: Scalars['Int']['input'];
  textFields?: InputMaybe<Array<TextFieldInput>>;
};

export type SharingOptions = {
  __typename?: 'SharingOptions';
  /** If true, platform-based sharing options will be disabled for this campaign type */
  disablePlatformSharing?: Maybe<Scalars['Boolean']['output']>;
};

export type SharingOptionsInput = {
  /** If true, platform-based sharing options will be disabled for this campaign type */
  disablePlatformSharing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShipmentIdRecord = {
  __typename?: 'ShipmentIdRecord';
  /** the corresponding assetId for the asset published in this shipment */
  assetId: Scalars['String']['output'];
  /** Org unit the shipmentId relates to */
  orgUnit: Scalars['String']['output'];
  /** boolean to keep track of publish success for this shipment */
  publishSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** the shipmentId */
  shipmentId: Scalars['String']['output'];
  uploadedAt: Scalars['String']['output'];
  uploadedBy: Scalars['String']['output'];
};

export type SingleImageCardContent = {
  __typename?: 'SingleImageCardContent';
  asset: AssetDetail;
  headline: Array<StringVariant>;
  seeMore?: Maybe<SeeMoreDetail>;
};

export type SlateImage = SlateImageInterface & {
  __typename?: 'SlateImage';
  assetId?: Maybe<Scalars['String']['output']>;
  /** The filename for the slate image to be shown on publishModal */
  filename?: Maybe<Scalars['String']['output']>;
  /** set if corresponding shipmentId has success on it */
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  modifiedAt: Scalars['String']['output'];
  modifiedBy: Scalars['String']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  /** Whether this slate image has been removed from the UI. */
  removed: Scalars['Boolean']['output'];
  /** The shipmentId for the createMediaAsync call on the asset */
  shipmentId?: Maybe<Scalars['String']['output']>;
  /** S3 signed GET URL for the image in Journeys asset bucket. */
  url: Scalars['String']['output'];
  /** The slate image's position on the Detail Page, e.g. MAIN, LEFT, RGHT, PT01, etc. */
  variant: Scalars['String']['output'];
  /** The latest version of this attribute */
  version: Scalars['Int']['output'];
  /** wharf asset Id returned from CreateMediaAsync */
  wharfAssetId?: Maybe<Scalars['String']['output']>;
};

export type SlateImageCopyFailure = SlateImageFailureInterface & {
  __typename?: 'SlateImageCopyFailure';
  /** The ASIN associated with the copy failure */
  asin: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

export type SlateImageCopyResponse = SlateImageInterface & {
  __typename?: 'SlateImageCopyResponse';
  /** The ASIN that the slate was copied too */
  asin: Scalars['String']['output'];
  assetId?: Maybe<Scalars['String']['output']>;
  /** The filename for the slate image to be shown on publishModal */
  filename?: Maybe<Scalars['String']['output']>;
  /** set if corresponding shipmentId has success on it */
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  modifiedAt: Scalars['String']['output'];
  modifiedBy: Scalars['String']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  /** Whether this slate image has been removed from the UI. */
  removed: Scalars['Boolean']['output'];
  /** The shipmentId for the createMediaAsync call on the asset */
  shipmentId?: Maybe<Scalars['String']['output']>;
  /** S3 signed GET URL for the image in Journeys asset bucket. */
  url: Scalars['String']['output'];
  /** The slate image's position on the Detail Page, e.g. MAIN, LEFT, RGHT, PT01, etc. */
  variant: Scalars['String']['output'];
  /** The latest version of this attribute */
  version: Scalars['Int']['output'];
  /** wharf asset Id returned from CreateMediaAsync */
  wharfAssetId?: Maybe<Scalars['String']['output']>;
};

export type SlateImageFailure = SlateImageFailureInterface & {
  __typename?: 'SlateImageFailure';
  reason: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

export type SlateImageFailureInterface = {
  reason: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

export type SlateImageInput = {
  /** A Journeys asset ID for this slate image. */
  assetId?: InputMaybe<Scalars['String']['input']>;
  /** Whether this slate image has been removed from the UI. */
  removed: Scalars['Boolean']['input'];
  /** S3 signed GET URL for the image in Journeys asset bucket. */
  url: Scalars['String']['input'];
  /** The slate image's position on the Detail Page, e.g. MAIN, LEFT, RGHT, PT01, etc. */
  variant: Scalars['String']['input'];
  /** The most recent version number that you, the client, have for this slate. If you are creating a new slate, pass zero for the version. */
  version: Scalars['Int']['input'];
  /** wharf asset Id returned from CreateMediaAsync */
  wharfAssetId?: InputMaybe<Scalars['String']['input']>;
};

export type SlateImageInterface = {
  assetId?: Maybe<Scalars['String']['output']>;
  /** The filename for the slate image to be shown on publishModal */
  filename?: Maybe<Scalars['String']['output']>;
  /** set if corresponding shipmentId has success on it */
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  /** Time at which the attributes was published last */
  lastPublishedDate?: Maybe<Scalars['String']['output']>;
  /** The latest version of this attribute */
  lastPublishedVersion?: Maybe<Scalars['Int']['output']>;
  modifiedAt: Scalars['String']['output'];
  modifiedBy: Scalars['String']['output'];
  /** Result from publish attempt */
  publishResult?: Maybe<DpPublishResult>;
  /** Whether this slate image has been removed from the UI. */
  removed: Scalars['Boolean']['output'];
  /** The shipmentId for the createMediaAsync call on the asset */
  shipmentId?: Maybe<Scalars['String']['output']>;
  /** S3 signed GET URL for the image in Journeys asset bucket. */
  url: Scalars['String']['output'];
  /** The slate image's position on the Detail Page, e.g. MAIN, LEFT, RGHT, PT01, etc. */
  variant: Scalars['String']['output'];
  /** The latest version of this attribute */
  version: Scalars['Int']['output'];
  /** wharf asset Id returned from CreateMediaAsync */
  wharfAssetId?: Maybe<Scalars['String']['output']>;
};

export type SlateImageVersion = {
  __typename?: 'SlateImageVersion';
  variant: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type SlatePlaceholderPublishInput = {
  asin: Scalars['String']['input'];
  isLaunchPermOn?: Scalars['Boolean']['input'];
  marketplaceId: Scalars['Int']['input'];
  merchantId: Scalars['String']['input'];
  ou: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  /** List of variants to target for placeholder publishing */
  variants: Array<Scalars['String']['input']>;
  /** List of variant sizes (can be "square" or "elongated"). Use elongated for 1200x1920 and square for 500x500. If this value is null, "square" is assumed. */
  variantsSize?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SlatePublishInput = {
  asin: Scalars['String']['input'];
  /** optional boolean that will be passed in */
  isLaunchPermOn?: Scalars['Boolean']['input'];
  marketplaceId: Scalars['Int']['input'];
  merchantId: Scalars['String']['input'];
  ou: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  slateImages: Array<SlateImageInput>;
};

export type SlatePublishRequest = {
  slateImage: SlateImageInput;
};

export type SlotOptionsUnion = StandardSlotOptions | VariantSlotOptions;

export type SlotOptionsUnionInput = {
  /** Standard slot options */
  standard?: InputMaybe<Array<ScopedSlotOptionInput>>;
  /** Variant-based slot options */
  variant?: InputMaybe<Array<ScopedVariantSlotOptionInput>>;
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SortDirectionEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export type StandardSlotOptions = {
  __typename?: 'StandardSlotOptions';
  /** List of scoped slot options */
  standard: Array<ScopedSlotOption>;
};

export type StartAssetIntakeSessionInput = {
  /** The Journeys project ID that you're starting this asset intake session for. */
  projectId: Scalars['String']['input'];
};

export type StartAssetIntakeSessionMutationResponse = MutationResponse & {
  __typename?: 'StartAssetIntakeSessionMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
  /** A presigned URL that a client can make a PUT request to to upload an asset zip file. */
  uploadUrl: Scalars['String']['output'];
};

export type StatusSummary = {
  __typename?: 'StatusSummary';
  active?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  liveState: LiveStateType;
  objectState?: Maybe<ObjectStateType>;
  partiallyApproved: PartiallyApprovedType;
  workflowId?: Maybe<Scalars['String']['output']>;
  workflowState?: Maybe<WorkflowStateType>;
};

export type StringVariant = BaseVariant & {
  __typename?: 'StringVariant';
  value: Scalars['String']['output'];
  variantId: Scalars['ID']['output'];
};

export type SummaryInfo = {
  __typename?: 'SummaryInfo';
  /** The last time a summary was generated for the experiment */
  lastUpdateDateTime?: Maybe<Scalars['String']['output']>;
  /** A url to the summary of the experiment in quip */
  quipUrl?: Maybe<Scalars['String']['output']>;
};

export type SymphonyEligibilityCriteria = {
  __typename?: 'SymphonyEligibilityCriteria';
  /** Symphony-ready map of eligibility criteria exclusion rules; these should match real PTC keys and values */
  excludes: Scalars['JSON']['output'];
  /** Symphony-ready map of eligibility criteria inclusion rules; these should match real PTC keys and values */
  includes: Scalars['JSON']['output'];
};

export type SymphonyEligibilityCriteriaInput = {
  /** Symphony-ready map of eligibility criteria exclusion rules; these should match real PTC keys and values */
  excludes: Scalars['JSON']['input'];
  /** Symphony-ready map of eligibility criteria inclusion rules; these should match real PTC keys and values */
  includes: Scalars['JSON']['input'];
};

export type SymphonyInfo = {
  __typename?: 'SymphonyInfo';
  lastUpdatedHash: Scalars['String']['output'];
  mvtCombinationId?: Maybe<Scalars['String']['output']>;
  placementMapping: Array<SymphonyPlacementMapping>;
  status?: Maybe<CampaignState>;
  symphonyCreativeId: Scalars['String']['output'];
};

export type SymphonyInfoInput = {
  campaignId: Scalars['String']['input'];
  combinationId?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedHash: Scalars['String']['input'];
  placementMapping: Array<SymphonyPlacementMappingInput>;
  status?: InputMaybe<CampaignState>;
  symphonyCreativeId: Scalars['String']['input'];
};

export type SymphonyPlacementMapping = {
  __typename?: 'SymphonyPlacementMapping';
  lastUpdatedHash: Scalars['String']['output'];
  placementUiId: Scalars['String']['output'];
  symphonyPlacementId: Scalars['String']['output'];
  symphonyPreviewURL: Scalars['String']['output'];
};

export type SymphonyPreviewUrl = {
  __typename?: 'SymphonyPreviewUrl';
  platform: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SymphonyPreviewer = {
  __typename?: 'SymphonyPreviewer';
  /** The date and time when the previewer was created */
  created?: Maybe<Scalars['Date']['output']>;
  /** The user who created the previewer */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The customer ID associated with the previewer */
  customerId: Scalars['String']['output'];
  /** Indicates whether the previewer has been deleted or not */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** name for the previewer */
  label?: Maybe<Scalars['String']['output']>;
  /** The date and time when the previewer was last modified */
  lastModified?: Maybe<Scalars['Date']['output']>;
  /** The user who last modified the previewer */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** The username of the previewer */
  username: Scalars['String']['output'];
};

export enum SymphonyRealm {
  Cn = 'CN',
  Eu = 'EU',
  Fe = 'FE',
  Na = 'NA',
  Test = 'TEST'
}

export type Tag = {
  __typename?: 'Tag';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TemplateGroup = {
  __typename?: 'TemplateGroup';
  createdAt: Scalars['DateTime']['output'];
  /** TemplateGroup ID */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  templateVariants: TemplateGroupTemplateVariants_Connection;
};


export type TemplateGroupTemplateVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type TemplateGroupEdge = {
  __typename?: 'TemplateGroupEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: TemplateGroup;
};

export enum TemplateGroupIds {
  HerotatorV1 = 'herotator_v1',
  Wd_4packV1 = 'wd_4pack_v1'
}

export type TemplateGroupTemplateVariants_Connection = {
  __typename?: 'TemplateGroupTemplateVariants_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<TemplateVariantEdge>;
  /** Flattened list of TemplateVariant type */
  nodes: Array<TemplateVariant>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum TemplateGroupVariantIds {
  HerotatorDesktopV1 = 'herotator_desktop_v1',
  HerotatorMobileV1 = 'herotator_mobile_v1',
  Wd_4packMobileV1 = 'wd_4pack_mobile_v1'
}

export type TemplateVariant = {
  __typename?: 'TemplateVariant';
  height: Scalars['Int']['output'];
  /** TemplateVariant ID */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** file size limitation in KB */
  sizeMaximum?: Maybe<Scalars['Int']['output']>;
  width: Scalars['Int']['output'];
};

export type TemplateVariantEdge = {
  __typename?: 'TemplateVariantEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: TemplateVariant;
};

/** Input for a text field */
export type TextFieldCreateInput = {
  /** Dimension input for this field */
  dimension?: InputMaybe<FieldDimensionInput>;
  /** Name of the field to set */
  name: Scalars['String']['input'];
  /** Styling input for this field */
  style?: InputMaybe<FieldStyleInput>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Input for a text field */
export type TextFieldInput = {
  /** Dimension input for this field */
  dimension?: InputMaybe<FieldDimensionInput>;
  /** Layered Image Asset IDs to set this field on */
  layeredImageAssetIds: Array<Scalars['String']['input']>;
  /** Name of the field to set */
  name: Scalars['String']['input'];
  /** Styling input for this field */
  style?: InputMaybe<FieldStyleInput>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type TrafficAsset = AssetInterface & {
  __typename?: 'TrafficAsset';
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** composite id ex(jnid:projectId1-jaid:assetId1) */
  assetId: Scalars['String']['output'];
  assetMetadata?: Maybe<AssetMetadata>;
  device?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  docId: Scalars['String']['output'];
  docName?: Maybe<Scalars['String']['output']>;
  isPublishedMap?: Maybe<Scalars['JSON']['output']>;
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mediaCentralUrls?: Maybe<Scalars['JSON']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  modifiedBy: Scalars['String']['output'];
  modifiedDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** S3 signed url for fullsize asset. Not affected by maxHeight or maxWidth properties. */
  originalAssetS3Get?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  productLine?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  s3SignedUrlGet?: Maybe<Scalars['String']['output']>;
  s3SignedUrlPut?: Maybe<Scalars['String']['output']>;
  /** Size in bytes */
  size?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  /**  The type string here is an artifact of Java serialization. It will besomething like com.amazon.amazonjourneyslambda.lambda.dto.JourneysAssetSearchResult */
  type?: Maybe<Scalars['String']['output']>;
  /** Timestamp in Milliseconds */
  uploadedAt: Scalars['Float']['output'];
  uploadedBy: Scalars['String']['output'];
};

export type TrafficAssetConnection = {
  __typename?: 'TrafficAssetConnection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<TrafficAssetEdge>;
  /** Flattened list of TrafficAsset type */
  nodes: Array<TrafficAsset>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
};

export type TrafficAssetEdge = {
  __typename?: 'TrafficAssetEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: TrafficAsset;
};

export type TrafficAssetSearchFilterOptions = {
  /** A list of device tags to filter by */
  device?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of W x L dimensions to filter by. */
  dimension?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of product line tags to filter by */
  productLine?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list user aliases to filter by */
  uploadedBy?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TrafficAssetSearchFilters = {
  __typename?: 'TrafficAssetSearchFilters';
  device: Array<TrafficSearchFilterOption>;
  dimension: Array<TrafficSearchFilterOption>;
  productLine: Array<TrafficSearchFilterOption>;
  uploadedBy: Array<TrafficSearchFilterOption>;
};

/** The Journeys marketing building block for generating site traffic. Contains the content to be shown to customers and describes when and where it appears on Amazon. */
export type TrafficCampaign = {
  __typename?: 'TrafficCampaign';
  /** Common data applied to all flavors */
  common?: Maybe<TrafficCampaignCommonData>;
  /** Campaign configuration if this campaign is configuration driven. */
  configuration?: Maybe<CampaignConfiguration>;
  /** Timestamp at which this TrafficCampaign was first created */
  createdAt: Scalars['String']['output'];
  /** Amazon alias of user that created this TrafficCampaign */
  createdBy: Scalars['String']['output'];
  flavors: Array<TrafficCampaignFlavor>;
  /** Global campaign-wide content applied to all flavors */
  globalContent?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  /** Boolean value to identify whether the TrafficCampaign is archived or not */
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** The liveState of the campaign, can also be a backfilled Journeys or MVT campaign */
  liveState?: Maybe<LiveStateType>;
  /** Timestamp at which this TrafficCampaign was last modified */
  modifiedAt: Scalars['String']['output'];
  /** Amazon alias of last user to modify this TrafficCampaign */
  modifiedBy: Scalars['String']['output'];
  /** User-defined name of this campaign */
  name: Scalars['String']['output'];
  /** Common placement metadata applied to flavors */
  placements?: Maybe<TrafficCampaignPlacementData>;
  /** Reference to the TrafficProject to which this campaign belongs */
  project: TrafficProject;
  /** The campaign type schema used by this campaign's data (e.g., herotator or content grid) */
  schema: Scalars['String']['output'];
  /** Most recently used version of this campaign's schema. Should be upgraded by the frontend when necessary. */
  schemaVersion: Scalars['Int']['output'];
  /** Combined status of all placements and creatives */
  status: CampaignState;
  /** thumbnailURL for the entire TrafficCampaign */
  thumbnailURL?: Maybe<Scalars['String']['output']>;
  /** Variable sharing state information */
  varSharing?: Maybe<TrafficCampaignVariableSharing>;
  /** Most recently seen version of this TrafficCampaign */
  version: Scalars['Int']['output'];
};


/** The Journeys marketing building block for generating site traffic. Contains the content to be shown to customers and describes when and where it appears on Amazon. */
export type TrafficCampaignLiveStateArgs = {
  loadFromSymphony?: Scalars['Boolean']['input'];
};


/** The Journeys marketing building block for generating site traffic. Contains the content to be shown to customers and describes when and where it appears on Amazon. */
export type TrafficCampaignStatusArgs = {
  loadFromSymphony?: Scalars['Boolean']['input'];
};

export type TrafficCampaignAutoNameData = {
  __typename?: 'TrafficCampaignAutoNameData';
  additionalText?: Maybe<Scalars['String']['output']>;
  alexaEnabled?: Maybe<Scalars['String']['output']>;
  creativeType?: Maybe<Scalars['String']['output']>;
  eventShortName?: Maybe<Scalars['String']['output']>;
  isAutoGenerated?: Maybe<Scalars['Boolean']['output']>;
  pageType?: Maybe<Scalars['String']['output']>;
  program?: Maybe<Scalars['String']['output']>;
  slot?: Maybe<Scalars['String']['output']>;
  widgetName?: Maybe<Scalars['String']['output']>;
};

export type TrafficCampaignAutoNameInput = {
  additionalText?: InputMaybe<Scalars['String']['input']>;
  alexaEnabled?: InputMaybe<Scalars['String']['input']>;
  creativeType?: InputMaybe<Scalars['String']['input']>;
  eventShortName?: InputMaybe<Scalars['String']['input']>;
  isAutoGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  pageType?: InputMaybe<Scalars['String']['input']>;
  program?: InputMaybe<Scalars['String']['input']>;
  slot?: InputMaybe<Scalars['String']['input']>;
};

export type TrafficCampaignCommonData = {
  __typename?: 'TrafficCampaignCommonData';
  accessControlGroup: Scalars['String']['output'];
  /** Data to auto-generate campaign name */
  autoName?: Maybe<TrafficCampaignAutoNameData>;
  businessGroup: Scalars['String']['output'];
  marketingType: Scalars['String']['output'];
  mocarObjective?: Maybe<Scalars['String']['output']>;
  /** Used to pick or suggest BG and ACG values */
  productLine: Scalars['String']['output'];
  /** Associated programs sub group for campaign */
  programSubGroup?: Maybe<Scalars['String']['output']>;
  /** List of associated programs for campaign */
  programs?: Maybe<Array<Scalars['String']['output']>>;
  reason: Scalars['String']['output'];
};

export type TrafficCampaignCommonInput = {
  accessControlGroup: Scalars['String']['input'];
  autoName?: InputMaybe<TrafficCampaignAutoNameInput>;
  businessGroup: Scalars['String']['input'];
  marketingType: Scalars['String']['input'];
  mocarObjective?: InputMaybe<Scalars['String']['input']>;
  /** Used to pick or suggest BG and ACG values */
  productLine: Scalars['String']['input'];
  /** Associated programs sub group for campaign */
  programSubGroup?: InputMaybe<Scalars['String']['input']>;
  /** List of associated programs for campaign */
  programs?: InputMaybe<Array<Scalars['String']['input']>>;
  reason: Scalars['String']['input'];
};

export type TrafficCampaignEdge = {
  __typename?: 'TrafficCampaignEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: TrafficCampaign;
};

/** Represents common placement data across flavors. This metadata is used to produce placements for the individual flavors. */
export type TrafficCampaignEligibilityCriteria = {
  __typename?: 'TrafficCampaignEligibilityCriteria';
  /** An "escape hatch" property. Include raw extra eligibility *exclusion* criteria to be passed through. */
  additionalExcludes: Scalars['JSON']['output'];
  /** An "escape hatch" property. Include raw extra eligibility *inclusion* criteria to be passed through. */
  additionalIncludes: Scalars['JSON']['output'];
  /** List of ASINs to which this placement is scheduled */
  asins: Array<Scalars['String']['output']>;
  /** List of IDs of browse nodes to which this placement is scheduled */
  browseNodes: Array<Scalars['String']['output']>;
  /** If true, the bullseye includes and excludes fields value will use default values from the campaign placement defaults. */
  bullseyeDefault?: Maybe<Scalars['Boolean']['output']>;
  /** List of category node IDs to which this placement is scheduled, used for landing page */
  categoryNode?: Maybe<Array<Scalars['String']['output']>>;
  containerId?: Maybe<Scalars['JSON']['output']>;
  containerType?: Maybe<Scalars['JSON']['output']>;
  /** Whether to target recognized or unrecognized customers. */
  customerOptions: CustomerOptions;
  /** List of DDS ASIN groups to which this placement is scheduled */
  ddsAsinGroups?: Maybe<Array<Scalars['String']['output']>>;
  deviceTypes: Array<Scalars['String']['output']>;
  /** List of event pages for event campaigns. */
  eventPages?: Maybe<Array<Scalars['String']['output']>>;
  impressions?: Maybe<TrafficCampaignPlacementImpression>;
  impressionsDefault?: Maybe<Scalars['Boolean']['output']>;
  /** List of keywords for Search campaigns. */
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  /** Marketplace specific eligibility criteria. */
  marketplaceCriteria?: Maybe<Array<EligibilityCriteriaMarketplace>>;
  mvtAssignmentId?: Maybe<Scalars['String']['output']>;
  /** Name of MVT experiment */
  mvtName?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  pageType?: Maybe<Scalars['String']['output']>;
  /** Platform specific eligibility criteria. */
  platformCriteria?: Maybe<Array<EligibilityCriteriaPlatform>>;
  scheduleType?: Maybe<Scalars['String']['output']>;
  schedulingDefault?: Maybe<Scalars['Boolean']['output']>;
  /** List of PageIds required by SPP mini page */
  subscriptionProductPageIds?: Maybe<Array<Scalars['String']['output']>>;
  timeRange?: Maybe<TrafficDateRange>;
  timeRangeDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Placement group variant specific placement values */
  variantCriteria?: Maybe<Array<PlacementGroupVariantCriteria>>;
  weblab?: Maybe<TrafficCampaignPlacementWeblab>;
  /** Widget group to which this placement is scheduled, used for whole personalization page */
  widgetGroup?: Maybe<Scalars['String']['output']>;
};

/** Common eligibility criteria that will be implicitly applied to flavors based on platform and language matches. */
export type TrafficCampaignEligibilityCriteriaInput = {
  /** An "escape hatch" property. Include raw extra eligibility *exclusion* criteria to be passed through. */
  additionalExcludes: Scalars['JSON']['input'];
  /** An "escape hatch" property. Include raw extra eligibility *inclusion* criteria to be passed through. */
  additionalIncludes: Scalars['JSON']['input'];
  /** List of ASINs to which this placement is scheduled */
  asins: Array<Scalars['String']['input']>;
  /** List of IDs of browse nodes to which this placement is scheduled */
  browseNodes: Array<Scalars['String']['input']>;
  /** If true, the bullseye includes and excludes fields value will use default values from the campaign placement defaults. */
  bullseyeDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of category node IDs to which this placement is scheduled, used for landing page */
  categoryNode?: InputMaybe<Array<Scalars['String']['input']>>;
  containerId?: InputMaybe<Scalars['JSON']['input']>;
  containerType?: InputMaybe<Scalars['JSON']['input']>;
  /** Whether to target recognized or unrecognized customers. */
  customerOptions: CustomerOptions;
  /** List of DDS ASIN groups to which this placement is scheduled */
  ddsAsinGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceTypes: Array<Scalars['String']['input']>;
  /** List of event pages for event campaigns. */
  eventPages?: InputMaybe<Array<Scalars['String']['input']>>;
  impressions?: InputMaybe<TrafficCampaignPlacementImpressionInput>;
  impressionsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of keywords for Search campaigns. */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Marketplace specific eligibility criteria. */
  marketplaceCriteria?: InputMaybe<Array<EligibilityCriteriaMarketplaceInput>>;
  mvtAssignmentId?: InputMaybe<Scalars['String']['input']>;
  /** Name of MVT experiment */
  mvtName?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  pageType?: InputMaybe<Scalars['String']['input']>;
  /** Platform specific eligibility criteria. */
  platformCriteria?: InputMaybe<Array<EligibilityCriteriaPlatformInput>>;
  scheduleType?: InputMaybe<Scalars['String']['input']>;
  schedulingDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of PageIds required by SPP mini page */
  subscriptionProductPageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  symphonyPreviewUrl?: InputMaybe<Scalars['String']['input']>;
  timeRange?: InputMaybe<TrafficDateRangeInput>;
  timeRangeDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Placement group variant specific placement values input */
  variantCriteria?: InputMaybe<Array<PlacementGroupVariantCriteriaInput>>;
  weblab?: InputMaybe<TrafficCampaignPlacementWeblabInput>;
  weblabDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Widget group to which this placement is scheduled, used for whole personalization page */
  widgetGroup?: InputMaybe<Scalars['String']['input']>;
};

export type TrafficCampaignFlavor = {
  __typename?: 'TrafficCampaignFlavor';
  /** Whether this flavor is still active and visible on the UI */
  active: Scalars['Boolean']['output'];
  /** Journeys form values for this flavor */
  content: Scalars['JSON']['output'];
  /** Name for Symphony creative. */
  creativeName?: Maybe<Scalars['String']['output']>;
  /** Flag to auto-generate creative name. Uses campaign name in generation regardless of campaign-name-generation. */
  hasGeneratedName?: Maybe<Scalars['Boolean']['output']>;
  /** Unique ID of this flavor */
  id: Scalars['ID']['output'];
  /** Combined liveState for the flavor. Only supports MCC campaigns. */
  liveState?: Maybe<LiveStateType>;
  scheduling: TrafficCampaignSchedulingInfo;
  /** Combined status of this flavors creative and placements. Only supports MCC campaigns. */
  status?: Maybe<CampaignState>;
  /** Metadata describing the Symphony objects created for this flavor */
  symphony: TrafficFlavorSymphonyMetadata;
  /** Used by some campaign types to differentiate between flavors with same platform and locale */
  variant?: Maybe<Scalars['String']['output']>;
};

/** Desired end state for flavors */
export enum TrafficCampaignFlavorStateType {
  Approve = 'approve',
  CancelApprovalRequest = 'cancelApprovalRequest',
  RejectApproval = 'rejectApproval',
  RequestApproval = 'requestApproval',
  Suspend = 'suspend'
}

/** Placement data used by traffic campaign flavors. */
export type TrafficCampaignPlacement = {
  __typename?: 'TrafficCampaignPlacement';
  eligibilityCriteria: TrafficEligibilityCriteria;
  /** Special Symphony field required when creating a placement. When KoTH is enabled, this value is 0 */
  guarantee: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** The placement group ID that generated this flavor placement */
  placementGroupId?: Maybe<Scalars['String']['output']>;
};

export type TrafficCampaignPlacementData = {
  __typename?: 'TrafficCampaignPlacementData';
  /** Default values that can be used in placement groups. */
  defaults?: Maybe<TrafficCampaignPlacementDefaults>;
  /** Common placement metadata shared applied to flavors */
  groups?: Maybe<Array<TrafficPlacementGroup>>;
};

export type TrafficCampaignPlacementDefaultImpression = {
  __typename?: 'TrafficCampaignPlacementDefaultImpression';
  daysTimeout?: Maybe<Scalars['Int']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
};

export type TrafficCampaignPlacementDefaultImpressionInput = {
  daysTimeout?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type TrafficCampaignPlacementDefaultInput = {
  /** Default list of ASINs to which this placement is scheduled */
  asins?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Default list of IDs of browse nodes to which this placement is scheduled */
  browseNodes?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryNode?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Default list of DDS ASIN groups to which this placement is scheduled */
  ddsAsinGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of event pages for event campaigns. */
  eventPages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Default impressions capping and limits. */
  impressions?: InputMaybe<TrafficCampaignPlacementDefaultImpressionInput>;
  /** Default marketplace specific eligibility criteria. */
  marketplaceCriteria?: InputMaybe<Array<EligibilityCriteriaMarketplaceInput>>;
  scheduleType?: InputMaybe<Scalars['String']['input']>;
  /** Which slots DESKTOP placements target. */
  slotsDesktop?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Which slots MOBILE placements target. */
  slotsMobile?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Which slots PLATFORM_AGNOSTIC placements target. */
  slotsPlatformAgnostic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of PageIds required by SPP mini page */
  subscriptionProductPageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  timeRange?: InputMaybe<TrafficDateRangeInput>;
  /** Placement defaults variant specific placement values input */
  variantCriteria?: InputMaybe<Array<PlacementDefaultVariantCriteriaInput>>;
  /** Default weblab name and treatment. */
  weblab?: InputMaybe<TrafficCampaignPlacementDefaultWeblabInput>;
};

export type TrafficCampaignPlacementDefaultWeblab = {
  __typename?: 'TrafficCampaignPlacementDefaultWeblab';
  /** Name of weblab required to see this placement. */
  name?: Maybe<Scalars['String']['output']>;
  /** Specifies which treatment of the weblab is needed to see the placement. */
  treatment?: Maybe<Scalars['String']['output']>;
};

export type TrafficCampaignPlacementDefaultWeblabInput = {
  /** Name of weblab required to see this placement. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specifies which treatment of the weblab is needed to see the placement. */
  treatment?: InputMaybe<Scalars['String']['input']>;
};

export type TrafficCampaignPlacementDefaults = {
  __typename?: 'TrafficCampaignPlacementDefaults';
  /** Default list of ASINs to which this placement is scheduled */
  asins?: Maybe<Array<Scalars['String']['output']>>;
  /** Default list of IDs of browse nodes to which this placement is scheduled */
  browseNodes?: Maybe<Array<Scalars['String']['output']>>;
  categoryNode?: Maybe<Array<Scalars['String']['output']>>;
  /** Default list of DDS ASIN groups to which this placement is scheduled */
  ddsAsinGroups?: Maybe<Array<Scalars['String']['output']>>;
  /** List of event pages for event campaigns. */
  eventPages?: Maybe<Array<Scalars['String']['output']>>;
  /** Default impressions capping and limits. */
  impressions?: Maybe<TrafficCampaignPlacementDefaultImpression>;
  /** Default marketplace specific eligibility criteria. */
  marketplaceCriteria?: Maybe<Array<EligibilityCriteriaMarketplace>>;
  scheduleType?: Maybe<Scalars['String']['output']>;
  /** Which slots DESKTOP placements target. */
  slotsDesktop?: Maybe<Array<Scalars['String']['output']>>;
  /** Which slots MOBILE placements target. */
  slotsMobile?: Maybe<Array<Scalars['String']['output']>>;
  /** Which slots PLATFORM_AGNOSTIC placements target. */
  slotsPlatformAgnostic?: Maybe<Array<Scalars['String']['output']>>;
  /** List of PageIds required by SPP mini page */
  subscriptionProductPageIds?: Maybe<Array<Scalars['String']['output']>>;
  timeRange?: Maybe<TrafficDateRange>;
  /** Placement defaults variant specific placement values */
  variantCriteria?: Maybe<Array<PlacementDefaultVariantCriteria>>;
  /** Default weblab name and treatment. */
  weblab?: Maybe<TrafficCampaignPlacementDefaultWeblab>;
};

export type TrafficCampaignPlacementImpression = {
  __typename?: 'TrafficCampaignPlacementImpression';
  daysTimeout?: Maybe<Scalars['Int']['output']>;
  daysTimeoutDefault?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  limitDefault?: Maybe<Scalars['Boolean']['output']>;
};

export type TrafficCampaignPlacementImpressionInput = {
  daysTimeout?: InputMaybe<Scalars['Int']['input']>;
  daysTimeoutDefault?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrafficCampaignPlacementInput = {
  /** Default field values that can be used by placement groups. */
  defaults?: InputMaybe<TrafficCampaignPlacementDefaultInput>;
  /** Campaign level placements that will be applied to flavors. If you provide any campaign-level placements, those will override any placements defined at the flavor level. */
  groups?: InputMaybe<Array<TrafficPlacementGroupInput>>;
};

export type TrafficCampaignPlacementWeblab = {
  __typename?: 'TrafficCampaignPlacementWeblab';
  /** Name of weblab required to see this placement. */
  name?: Maybe<Scalars['String']['output']>;
  nameDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies which treatment of the weblab is needed to see the placement. */
  treatment?: Maybe<Scalars['String']['output']>;
  treatmentDefault?: Maybe<Scalars['Boolean']['output']>;
};

export type TrafficCampaignPlacementWeblabInput = {
  /** Name of weblab required to see this placement. */
  name?: InputMaybe<Scalars['String']['input']>;
  nameDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specifies which treatment of the weblab is needed to see the placement. */
  treatment?: InputMaybe<Scalars['String']['input']>;
  treatmentDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrafficCampaignSchedulingInfo = {
  __typename?: 'TrafficCampaignSchedulingInfo';
  /** @deprecated now stored on TrafficCampaigns */
  accessControlGroup: Scalars['String']['output'];
  /** @deprecated now stored on TrafficCampaigns */
  businessGroup: Scalars['String']['output'];
  /** Event associated with this campaign flavor. Only required if this campaign is under an event */
  event?: Maybe<TrafficEvent>;
  language: Scalars['String']['output'];
  /** @deprecated now stored on TrafficCampaigns */
  marketingType: Scalars['String']['output'];
  /** e.g.: "US", "CA", etc. */
  marketplace: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  placements: Array<TrafficCampaignPlacement>;
  platform: Scalars['String']['output'];
  /**
   * Used to pick or suggest BG and ACG values
   * @deprecated now stored on TrafficCampaigns
   */
  productLine: Scalars['String']['output'];
  /** @deprecated now stored on TrafficCampaigns */
  reason: Scalars['String']['output'];
};

export type TrafficCampaignSchedulingInfoInput = {
  accessControlGroup: Scalars['String']['input'];
  businessGroup: Scalars['String']['input'];
  /** ID of the event containing this flavor's creative */
  eventId?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
  marketingType: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  placements?: InputMaybe<TrafficCampaignPlacementInput>;
  platform: Scalars['String']['input'];
  /** Used to pick or suggest BG and ACG values */
  productLine: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type TrafficCampaignVariableSharing = {
  __typename?: 'TrafficCampaignVariableSharing';
  /** DMCC var sharing override map */
  dmccOverrideMap?: Maybe<Scalars['JSON']['output']>;
  /** Used to track actively edited field in form. Gets cleared when the form loads */
  inlineEditorMeta: Scalars['JSON']['output'];
  /** main var sharing source of truth */
  sharedVarsMap: Scalars['JSON']['output'];
};

export type TrafficCampaignVariableSharingInput = {
  /** DMCC var sharing override map */
  dmccOverrideMap?: InputMaybe<Scalars['JSON']['input']>;
  /** Used to track actively edited field in form. Gets cleared when the form loads */
  inlineEditorMeta: Scalars['JSON']['input'];
  /** main var sharing source of truth */
  sharedVarsMap: Scalars['JSON']['input'];
};

/** How traffic campaigns are to be sorted */
export enum TrafficCampaignsSortByInput {
  CreatedBy = 'createdBy',
  Language = 'language',
  Liveness = 'liveness',
  ModifiedAt = 'modifiedAt',
  Name = 'name',
  Platform = 'platform',
  ProductLine = 'productLine',
  Status = 'status'
}

export type TrafficCampaingsSortOptionsInput = {
  ascending: Scalars['Boolean']['input'];
  sortBy: TrafficCampaignsSortByInput;
};

export type TrafficCreativePlacementPublishInput = {
  guarantee: Scalars['Int']['input'];
  /** Internal ID referencing the placement associated with this publish request */
  id: Scalars['ID']['input'];
  /** Eligibility rules to pass through to Symphony */
  rules: SymphonyEligibilityCriteriaInput;
  /** Desired end state for this placement */
  state: Scalars['String']['input'];
};

export type TrafficCreativePublishInput = {
  /** Symphony component to be used in the publish request */
  component: TrafficFlavorSymphonyComponentInput;
  content: Scalars['JSON']['input'];
  /** ID of the parent event */
  eventId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the flavor related to this publish request */
  flavorId: Scalars['ID']['input'];
  /** Language that old content is stored under, needs to be nullified */
  languageToRemove?: InputMaybe<Scalars['String']['input']>;
  /** Set of inputs for each desired active placement. If a placement previously published to Symphony is not included in this array, the existing placement will be suspended (no longer considered active). */
  placements: Array<TrafficCreativePlacementPublishInput>;
  /** Realm in which this creative should be published */
  realm: SymphonyRealm;
};

export type TrafficCustomDateRange = TrafficDateRangeInterface & {
  __typename?: 'TrafficCustomDateRange';
  /** Whether this date range is a custom date range or a date range belonging to an event */
  dateRangeType: TrafficDateRangeTypeName;
  /** The end of the date range, or null if there is no end. Uses the ISO 8601 extended format, see the ECMAScript spec: https://tc39.es/ecma262/#sec-date-time-string-format */
  end?: Maybe<Scalars['String']['output']>;
  /** The beginning of the date range. Uses the ISO 8601 extended format, see the ECMAScript spec: https://tc39.es/ecma262/#sec-date-time-string-format */
  start?: Maybe<Scalars['String']['output']>;
};

export type TrafficDateRange = TrafficCustomDateRange | TrafficEmptyDateRange | TrafficEventDateRange;

export enum TrafficDateRangeCustomTypeName {
  TrafficCustomDateRange = 'TrafficCustomDateRange'
}

export enum TrafficDateRangeEmptyTypeName {
  TrafficEmptyDateRange = 'TrafficEmptyDateRange'
}

export enum TrafficDateRangeEventTypeName {
  TrafficEventDateRange = 'TrafficEventDateRange'
}

export type TrafficDateRangeInput = {
  /** Whether this date range is a custom date range or a date range belonging to an event */
  dateRangeType: TrafficDateRangeTypeName;
  /** This date range's unique ID (elemId). Only present if this date range is part of an Event. */
  elemId?: InputMaybe<Scalars['ID']['input']>;
  /** The end of the date range, or null if there is no end. Uses the ISO 8601 extended format, see the ECMAScript spec: https://tc39.es/ecma262/#sec-date-time-string-format */
  end?: InputMaybe<Scalars['String']['input']>;
  /** The beginning of the date range. Uses the ISO 8601 extended format, see the ECMAScript spec: https://tc39.es/ecma262/#sec-date-time-string-format */
  start?: InputMaybe<Scalars['String']['input']>;
};

export type TrafficDateRangeInterface = {
  /** The end of the date range, or null if there is no end. Uses the ISO 8601 extended format, see the ECMAScript spec: https://tc39.es/ecma262/#sec-date-time-string-format */
  end?: Maybe<Scalars['String']['output']>;
  /** The beginning of the date range. Uses the ISO 8601 extended format, see the ECMAScript spec: https://tc39.es/ecma262/#sec-date-time-string-format */
  start?: Maybe<Scalars['String']['output']>;
};

export enum TrafficDateRangeTypeName {
  TrafficCustomDateRange = 'TrafficCustomDateRange',
  TrafficEmptyDateRange = 'TrafficEmptyDateRange',
  TrafficEventDateRange = 'TrafficEventDateRange'
}

/** Represents eligibility criteria for a flavor. */
export type TrafficEligibilityCriteria = {
  __typename?: 'TrafficEligibilityCriteria';
  /** An "escape hatch" property. Include raw extra eligibility *exclusion* criteria to be passed through. */
  additionalExcludes: Scalars['JSON']['output'];
  /** An "escape hatch" property. Include raw extra eligibility *inclusion* criteria to be passed through. */
  additionalIncludes: Scalars['JSON']['output'];
  /** List of ASINs to which this placement is scheduled */
  asins: Array<Scalars['String']['output']>;
  /** List of IDs of browse nodes to which this placement is scheduled */
  browseNodes: Array<Scalars['String']['output']>;
  /** List of Bullseye segment IDs. A customer must *not* be in one of these segments to see the placement. */
  bullseyeExcludes: Array<Scalars['BullseyeSegmentID']['output']>;
  /** List of Bullseye segment IDs. A customer must be in one of these segments to see the placement. */
  bullseyeIncludes: Array<Scalars['BullseyeSegmentID']['output']>;
  /** List of category node IDs to which this placement is scheduled, used for landing page */
  categoryNode?: Maybe<Array<Scalars['String']['output']>>;
  containerId?: Maybe<Scalars['JSON']['output']>;
  containerType?: Maybe<Scalars['JSON']['output']>;
  /** List of DDS ASIN groups to which this placement is scheduled */
  ddsAsinGroups?: Maybe<Array<Scalars['String']['output']>>;
  deviceTypes: Array<Scalars['String']['output']>;
  /** List of event pages for event campaigns. */
  eventPages?: Maybe<Array<Scalars['String']['output']>>;
  impressionsDaysTimeout?: Maybe<Scalars['Int']['output']>;
  impressionsLimit?: Maybe<Scalars['Int']['output']>;
  /** List of keywords for Search campaigns. */
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  /** List of languages this placement should include. */
  languages: Array<Scalars['String']['output']>;
  mvtAssignmentId?: Maybe<Scalars['String']['output']>;
  /** Name of MVT experiment */
  mvtName?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  pageType?: Maybe<Scalars['String']['output']>;
  /** Platform to which this placement is scheduled. Only applicable to truly multi-platform campaign types. */
  platform?: Maybe<Scalars['String']['output']>;
  /** Whether to target recognized or unrecognized customers. */
  recognizedOrUnrecognized: Scalars['String']['output'];
  scheduleType?: Maybe<Scalars['String']['output']>;
  /** Which slots this placement targets. Does not necessarily correspond to the exact slots it will appear on when rendered. */
  slots: Array<Scalars['String']['output']>;
  /** List of PageIds required by SPP mini page */
  subscriptionProductPageIds?: Maybe<Array<Scalars['String']['output']>>;
  timeRange: TrafficDateRange;
  /** Name of weblab required to see this placement. */
  weblabName?: Maybe<Scalars['String']['output']>;
  /** Required when a weblab name is given. Specifies which treatment of the weblab is needed to see the placement. */
  weblabTreatment?: Maybe<Scalars['String']['output']>;
  /** Widget group to which this placement is scheduled, used for whole personalization page */
  widgetGroup?: Maybe<Scalars['String']['output']>;
};

export type TrafficEmptyDateRange = TrafficDateRangeInterface & {
  __typename?: 'TrafficEmptyDateRange';
  /** Whether this date range is a custom date range or a date range belonging to an event */
  dateRangeType: TrafficDateRangeTypeName;
  /** The end of the date range, or null if there is no end. Uses the ISO 8601 extended format, see the ECMAScript spec: https://tc39.es/ecma262/#sec-date-time-string-format */
  end?: Maybe<Scalars['String']['output']>;
  /** The beginning of the date range. Uses the ISO 8601 extended format, see the ECMAScript spec: https://tc39.es/ecma262/#sec-date-time-string-format */
  start?: Maybe<Scalars['String']['output']>;
};

export type TrafficErrorSchema = {
  __typename?: 'TrafficErrorSchema';
  /** An ISO 8601 string indicating when the error occured. */
  createdAt: Scalars['String']['output'];
  /** The source of the error. */
  errorType: Scalars['String']['output'];
  /** A raw error message. */
  message: Scalars['String']['output'];
  /** The ID of the Traffic object error source */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** A user-friendly message or user suggestion for the error */
  userFriendlyMessage?: Maybe<Scalars['String']['output']>;
};

export type TrafficEvent = TrafficEventImportedFromSymphony | TrafficEventJourneysCreated;

/** Currently this is a representation of the ChildEvent on the shim Traffic Project Event. */
export type TrafficEventDateRange = TrafficDateRangeInterface & {
  __typename?: 'TrafficEventDateRange';
  /** Symphony event ID. Set when the child event has been published to Symphony. Valid value can only be found in TrafficProjectEvent but not placement */
  childEventId?: Maybe<Scalars['String']['output']>;
  /** Whether this date range is a custom date range or a date range belonging to an event */
  dateRangeType: TrafficDateRangeTypeName;
  /** If this date range is tied to a child event, this is the ID of that child event. If this campaign falls under an event, but the date range is custom, then the value of this field will be "CUSTOM". */
  elemId: Scalars['ID']['output'];
  /** The end of the date range, or null if there is no end. Uses the ISO 8601 extended format, see the ECMAScript spec: https://tc39.es/ecma262/#sec-date-time-string-format */
  end?: Maybe<Scalars['String']['output']>;
  /** The beginning of the date range. Uses the ISO 8601 extended format, see the ECMAScript spec: https://tc39.es/ecma262/#sec-date-time-string-format */
  start?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TrafficEventImportedFromSymphony = TrafficEventInterface & {
  __typename?: 'TrafficEventImportedFromSymphony';
  /** accessControlGroup linked to event */
  accessControlGroup?: Maybe<Scalars['String']['output']>;
  /** businessControlGroup linked to the event */
  businessControlGroup?: Maybe<Scalars['String']['output']>;
  /** the symphony state of the event returned */
  lifecycleState?: Maybe<TrafficEventStatesTypeName>;
  name?: Maybe<Scalars['String']['output']>;
  /** Symphony event ID. Exists when event is published to Symphony. */
  parentEventId?: Maybe<Scalars['String']['output']>;
  /** Sometimes called "child events", these are date ranges usable by campaigns within this event. */
  ranges: Array<TrafficEventDateRange>;
  realm?: Maybe<SymphonyRealm>;
  /** timezone for the selected event */
  timezone?: Maybe<Scalars['String']['output']>;
};

export type TrafficEventInterface = {
  /** the symphony state of the event returned */
  lifecycleState?: Maybe<TrafficEventStatesTypeName>;
  name?: Maybe<Scalars['String']['output']>;
  /** Symphony event ID. Exists when event is published to Symphony. */
  parentEventId?: Maybe<Scalars['String']['output']>;
  /** Sometimes called "child events", these are date ranges usable by campaigns within this event. */
  ranges: Array<TrafficEventDateRange>;
  realm?: Maybe<SymphonyRealm>;
};

export type TrafficEventJourneysCreated = TrafficEventInterface & {
  __typename?: 'TrafficEventJourneysCreated';
  /** the symphony state of the event returned */
  lifecycleState?: Maybe<TrafficEventStatesTypeName>;
  name?: Maybe<Scalars['String']['output']>;
  /** Symphony event ID. Exists when event is published to Symphony. */
  parentEventId?: Maybe<Scalars['String']['output']>;
  /** Sometimes called "child events", these are date ranges usable by campaigns within this event. */
  ranges: Array<TrafficEventDateRange>;
  realm?: Maybe<SymphonyRealm>;
};

export enum TrafficEventStatesTypeName {
  Approved = 'Approved',
  Suspended = 'Suspended',
  Unapproved = 'Unapproved'
}

export type TrafficFlavorApprovalStateTransitionInput = {
  /** ID of the flavor related to this state transition request */
  flavorId: Scalars['ID']['input'];
  /** ID of the TrafficCampaign containing the flavor for this request */
  id: Scalars['ID']['input'];
  /** ID of the TrafficProject containing the TrafficCampaign related to this request */
  projectId: Scalars['ID']['input'];
  /** Whether this approval should bypass manual approval. If true, this will effectively take care of the request for approval and approval in a single step. If false, this will assume you've already requested for approval. Usually reserved for non-gateway campaigns. */
  skipManualApproval?: Scalars['Boolean']['input'];
};

export type TrafficFlavorEligibilityCriteriaInput = {
  /** An "escape hatch" property. Include raw extra eligibility *exclusion* criteria to be passed through. */
  additionalExcludes: Scalars['JSON']['input'];
  /** An "escape hatch" property. Include raw extra eligibility *inclusion* criteria to be passed through. */
  additionalIncludes: Scalars['JSON']['input'];
  /** List of ASINs to which this placement is scheduled */
  asins: Array<Scalars['String']['input']>;
  /** List of IDs of browse nodes to which this placement is scheduled */
  browseNodes: Array<Scalars['String']['input']>;
  /** List of Bullseye segment IDs. A customer must *not* be in one of these segments to see the placement. */
  bullseyeExcludes: Array<Scalars['BullseyeSegmentID']['input']>;
  /** List of Bullseye segment IDs. A customer must be in one of these segments to see the placement. */
  bullseyeIncludes: Array<Scalars['BullseyeSegmentID']['input']>;
  /** List of category node IDs to which this placement is scheduled, used for landing page */
  categoryNode?: InputMaybe<Array<Scalars['String']['input']>>;
  containerId?: InputMaybe<Scalars['JSON']['input']>;
  containerType?: InputMaybe<Scalars['JSON']['input']>;
  /** List of DDS ASIN groups to which this placement is scheduled */
  ddsAsinGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceTypes: Array<Scalars['String']['input']>;
  /** List of event pages for event campaigns. */
  eventPages?: InputMaybe<Array<Scalars['String']['input']>>;
  impressionsDaysTimeout?: InputMaybe<Scalars['Int']['input']>;
  impressionsLimit?: InputMaybe<Scalars['Int']['input']>;
  /** List of keywords for Search campaigns. */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of languages this placement should include. */
  languages: Array<Scalars['String']['input']>;
  mvtAssignmentId?: InputMaybe<Scalars['String']['input']>;
  /** Name of MVT experiment */
  mvtName?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  pageType?: InputMaybe<Scalars['String']['input']>;
  /** Platform to which this placement is scheduled. Only applicable to truly multi-platform campaign types. */
  platform?: InputMaybe<Scalars['String']['input']>;
  /** Whether to target recognized or unrecognized customers. */
  recognizedOrUnrecognized: Scalars['String']['input'];
  scheduleType?: InputMaybe<Scalars['String']['input']>;
  schedulingDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Which slots this placement targets. Does not necessarily correspond to the exact slots it will appear on when rendered. */
  slots: Array<Scalars['String']['input']>;
  /** List of PageIds required by SPP mini page */
  subscriptionProductPageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  symphonyPreviewUrl?: InputMaybe<Scalars['String']['input']>;
  timeRange: TrafficDateRangeInput;
  /** Name of weblab required to see this placement. */
  weblabName?: InputMaybe<Scalars['String']['input']>;
  /** Required when a weblab name is given. Specifies which treatment of the weblab is needed to see the placement. */
  weblabTreatment?: InputMaybe<Scalars['String']['input']>;
  /** Widget group to which this placement is scheduled, used for whole personalization page */
  widgetGroup?: InputMaybe<Scalars['String']['input']>;
};

/** Placement value related to a Traffic Campaign flavor, used for both create and save operations. */
export type TrafficFlavorPlacementInput = {
  eligibilityCriteria: TrafficFlavorEligibilityCriteriaInput;
  /** Special Symphony field required when creating a placement. When KoTH is enabled, this value is 0 */
  guarantee: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Placement group ID that generated this flavor placement. */
  placementGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type TrafficFlavorPlacementSymphonyConfig = {
  __typename?: 'TrafficFlavorPlacementSymphonyConfig';
  /** Eligibility criteria used in the last published version of this placement */
  eligibilityCriteria: SymphonyEligibilityCriteria;
  /** Number that describes this placement's last published guarantee percentage. When KoTH is enabled, this value is 0 */
  guarantee: Scalars['Int']['output'];
};

export type TrafficFlavorSchedulingInfoInput = {
  accessControlGroup: Scalars['String']['input'];
  businessGroup: Scalars['String']['input'];
  /** ID of the event containing this flavor's creative */
  eventId?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
  marketingType: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  /** Placements set directly on the flavor. If using the TrafficCampaign placements to manage placements, you should not include this field. */
  placements?: InputMaybe<Array<TrafficFlavorPlacementInput>>;
  platform: Scalars['String']['input'];
  /** Used to pick or suggest BG and ACG values */
  productLine: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type TrafficFlavorStateTransitionInput = {
  /** ID of the flavor related to this state transition request */
  flavorId: Scalars['ID']['input'];
  /** ID of the TrafficCampaign containing the flavor for this request */
  id: Scalars['ID']['input'];
  /** ID of the TrafficProject containing the TrafficCampaign related to this request */
  projectId: Scalars['ID']['input'];
};

export type TrafficFlavorSymphonyComponent = {
  __typename?: 'TrafficFlavorSymphonyComponent';
  /** Canonical name of the Symphony component to use for this flavor's creative */
  name: Scalars['String']['output'];
  /** Hardcoded namespace associated with this Symphony component */
  namespace: Scalars['String']['output'];
  /** Semantic version for this Symphony component */
  version: Scalars['String']['output'];
};

export type TrafficFlavorSymphonyComponentInput = {
  /** Canonical name of the Symphony component to use for this flavor's creative */
  name: Scalars['String']['input'];
  /** Hardcoded namespace associated with this Symphony component */
  namespace: Scalars['String']['input'];
  /** Semantic version for this Symphony component */
  version: Scalars['String']['input'];
};

export type TrafficFlavorSymphonyMetadata = TrafficFlavorSymphonyMetadataDraft | TrafficFlavorSymphonyMetadataPublished;

export type TrafficFlavorSymphonyMetadataDraft = {
  __typename?: 'TrafficFlavorSymphonyMetadataDraft';
  /** Errors related to the flavor. */
  errors?: Maybe<Array<TrafficErrorSchema>>;
  /** Whether this flavor has ever been published */
  published: Scalars['Boolean']['output'];
};

export type TrafficFlavorSymphonyMetadataPublished = {
  __typename?: 'TrafficFlavorSymphonyMetadataPublished';
  /** Symphony component used in the most recent publish operation. Determines what arguments must be passed to Symphony */
  component: TrafficFlavorSymphonyComponent;
  /** Snapshot of the content most recently published to Symphony. Originally generated by the frontend */
  content: Scalars['JSON']['output'];
  creatives: Array<TrafficSymphonyCreative>;
  /** Errors related to the flavor. */
  errors?: Maybe<Array<TrafficErrorSchema>>;
  /** Timestamp created at the time of the most recent successful publish */
  lastPublishedAt: Scalars['String']['output'];
  /** User who initiated the most recent successful publish */
  lastPublishedBy: Scalars['String']['output'];
  /** Version of the campaign at the time of the most recent successful publish */
  lastPublishedVersion: Scalars['Int']['output'];
  /** Whether this flavor has ever been published */
  published: Scalars['Boolean']['output'];
};

/** Placement data used by traffic campaigns and applied to individual flavors. */
export type TrafficPlacementGroup = {
  __typename?: 'TrafficPlacementGroup';
  eligibilityCriteria: TrafficCampaignEligibilityCriteria;
  flavorIds: Array<Scalars['String']['output']>;
  /** Special Symphony field required when creating a placement. When KoTH is enabled, this value is 0 */
  guarantee: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  scheduling?: Maybe<Array<PlacementGroupSchedulingInfo>>;
};

export type TrafficPlacementGroupInput = {
  eligibilityCriteria: TrafficCampaignEligibilityCriteriaInput;
  /** Flavor ID or index that this placement applies to. If flavor has not been saved yet, you can reference the index of the flavor in the flavors array. */
  flavorIds?: Array<Scalars['String']['input']>;
  /** Special Symphony field required when creating a placement. When KoTH is enabled, this value is 0 */
  guarantee: Scalars['Int']['input'];
  /** Provide an ID to update an existing placement or leave blank to create a new placement. */
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scheduling?: InputMaybe<Array<PlacementGroupSchedulingInfoInput>>;
};

export type TrafficPlacementStateTransitionInput = {
  /** ID of the flavor related to this state transition request */
  flavorId: Scalars['ID']['input'];
  /** ID of the TrafficCampaign containing the flavor for this request */
  id: Scalars['ID']['input'];
  /** IDs of the TrafficCampaignPlacements related to this state transition */
  placementIds: Array<Scalars['ID']['input']>;
  /** ID of the TrafficProject containing the TrafficCampaign related to this request */
  projectId: Scalars['ID']['input'];
};

/** Container used to organize and control access to traffic campaigns. */
export type TrafficProject = {
  __typename?: 'TrafficProject';
  assets: TrafficAssetConnection;
  campaigns: TrafficProjectCampaigns_Connection;
  /** Timestamp at which this TrafficProject was first created */
  createdAt: Scalars['String']['output'];
  /** Amazon alias of user that created this TrafficProject */
  createdBy: Scalars['String']['output'];
  /** Events associated with this TrafficProject (through the related ghost project). */
  events?: Maybe<Array<TrafficEvent>>;
  id: Scalars['ID']['output'];
  /** Timestamp at which this TrafficProject was last modified */
  modifiedAt: Scalars['String']['output'];
  /** Amazon alias of last user to modify this TrafficProject */
  modifiedBy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permissions: Array<TrafficProjectPermission>;
  /** Most recently seen version of this TrafficProject */
  version: Scalars['Int']['output'];
};


/** Container used to organize and control access to traffic campaigns. */
export type TrafficProjectAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


/** Container used to organize and control access to traffic campaigns. */
export type TrafficProjectCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterByView?: CampaignFilterByViewInput;
  filterColumnMap?: InputMaybe<FilterColumnInputType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeLegacy?: Scalars['Boolean']['input'];
  includeRelatedProgramGhostProjects?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortOptions?: TrafficCampaingsSortOptionsInput;
};

export type TrafficProjectBindlePermission = TrafficProjectPermissionInterface & {
  __typename?: 'TrafficProjectBindlePermission';
  id: Scalars['String']['output'];
  permissionType: TrafficProjectPermissionType;
  resourceName: Scalars['String']['output'];
};

export type TrafficProjectCampaigns_Connection = {
  __typename?: 'TrafficProjectCampaigns_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<TrafficCampaignEdge>;
  filterOptionValues: FilterOptionValuesType;
  /** Flattened list of TrafficCampaign type */
  nodes: Array<TrafficCampaign>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TrafficProjectEdge = {
  __typename?: 'TrafficProjectEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String']['output'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: TrafficProject;
};

export type TrafficProjectLdapPermission = TrafficProjectPermissionInterface & {
  __typename?: 'TrafficProjectLdapPermission';
  action: Scalars['String']['output'];
  ldapGroup: Scalars['String']['output'];
  permissionType: TrafficProjectPermissionType;
};

export type TrafficProjectPermission = TrafficProjectBindlePermission | TrafficProjectLdapPermission | TrafficProjectUserPermission;

export type TrafficProjectPermissionInterface = {
  permissionType: TrafficProjectPermissionType;
};

export enum TrafficProjectPermissionType {
  TrafficProjectBindlePermission = 'TrafficProjectBindlePermission',
  TrafficProjectLdapPermission = 'TrafficProjectLdapPermission',
  TrafficProjectUserPermission = 'TrafficProjectUserPermission'
}

export type TrafficProjectSearchFilterInput = {
  createdBy?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TrafficProjectSearchFilters = {
  __typename?: 'TrafficProjectSearchFilters';
  createdBy: Array<FilterOption>;
};

export type TrafficProjectSearchSortInput = {
  direction: SortDirection;
  field: TrafficProjectSortFields;
};

/** What project type to search for. */
export enum TrafficProjectSearchType {
  OwnerSearch = 'OWNER_SEARCH',
  SharedSearch = 'SHARED_SEARCH'
}

/** Supported sort fields for Traffic Project search. */
export enum TrafficProjectSortFields {
  CreatedAt = 'createdAt',
  ModifiedAt = 'modifiedAt',
  Name = 'name'
}

export type TrafficProjectUser = {
  __typename?: 'TrafficProjectUser';
  alias: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type TrafficProjectUserInput = {
  alias: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type TrafficProjectUserPermission = TrafficProjectPermissionInterface & {
  __typename?: 'TrafficProjectUserPermission';
  action: Scalars['String']['output'];
  permissionType: TrafficProjectPermissionType;
  user: TrafficProjectUser;
};

export type TrafficSearchFilterOption = {
  __typename?: 'TrafficSearchFilterOption';
  count: Scalars['Int']['output'];
  option: Scalars['String']['output'];
};

/** Journeys-centric representation of an individual content object (aka "resource bundle") in a Symphony creative */
export type TrafficSymphonyContent = {
  __typename?: 'TrafficSymphonyContent';
  /** Errors related to the content. */
  errors?: Maybe<Array<TrafficErrorSchema>>;
  /** Internal ID associated with this placement. Similarly to the TrafficSymphonyCreative, we keep our own ID to track orphaned placements (e.g., ones deleted from the UI after they've already been published) */
  id: Scalars['ID']['output'];
  /** Locale code (e.g., "en-US") associated with this content / resource bundle */
  locale: Scalars['String']['output'];
  /** Symphony-provided content ID. Always equal to the creative ID, but kept here anyway in case that changes */
  symphonyId: Scalars['String']['output'];
};

/** Journeys-centric representation of a Symphony creative */
export type TrafficSymphonyCreative = {
  __typename?: 'TrafficSymphonyCreative';
  /** Whether this creative is in use by this campaign */
  active: Scalars['Boolean']['output'];
  /** The Content objects tied to this creative */
  contents: Array<TrafficSymphonyContent>;
  /** Errors related to the creative. */
  errors?: Maybe<Array<TrafficErrorSchema>>;
  /** Internal ID associated with this creative. We separate our ID from Symphony's so we can gracefully handle orphaned creatives (e.g., creatives left behind when changing a campaign's realm) */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Symphony placements tied to this creative */
  placements: Array<TrafficSymphonyPlacement>;
  /** Realm in which this creative was published */
  realm: SymphonyRealm;
  /** Symphony status for this creative */
  status?: Maybe<StatusSummary>;
  /** ID provided by Symphony for this creative */
  symphonyId: Scalars['String']['output'];
  /** Optionally generated preview URL for this creative's content */
  symphonyPreviewUrl?: Maybe<Scalars['String']['output']>;
};

/** Journeys-centric representation of a Symphony placement. Can't exist outside the context of a creative. */
export type TrafficSymphonyPlacement = {
  __typename?: 'TrafficSymphonyPlacement';
  /** Whether this creative is in use by this campaign */
  active: Scalars['Boolean']['output'];
  /** Errors related to the placement. */
  errors?: Maybe<Array<TrafficErrorSchema>>;
  /** Internal ID associated with this placement. Similarly to , we keep our own ID to track orphaned placements (e.g., ones deleted from the UI after they've already been published) */
  id: Scalars['ID']['output'];
  /** The TrafficCampaignPlacement this Symphony placement represents */
  relatedPlacement: TrafficCampaignPlacement;
  /** Symphony status for this placement */
  status?: Maybe<StatusSummary>;
  /** ID provided by Symphony for this placement */
  symphonyId: Scalars['String']['output'];
};

export type TransitionTrafficCampaignCreativesInput = {
  /** An array of flavorIds to be modified by the function */
  flavorIds: Array<Scalars['String']['input']>;
  /** ID of the TrafficCampaign containing the flavor for this request */
  id: Scalars['ID']['input'];
  /** ID of the TrafficProject containing the TrafficCampaign related to this request */
  projectId: Scalars['ID']['input'];
  /** Whether this transition should bypass manual approval. If true, this will effectively take care of the request for approval and approval in a single step. If false, this will assume you've already requested for approval. Usually reserved for non-gateway campaigns. */
  skipManualApproval?: Scalars['Boolean']['input'];
  /** Desired state for all flavors(suspend, approve, etc) */
  state: TrafficCampaignFlavorStateType;
};

export type TransitionTrafficCampaignFlavorConfigurationInput = {
  /** The ID of the flavor to be transitioned. */
  flavorId: Scalars['String']['input'];
  /** An array of placements to include in the transition. If null, then all placements are include */
  placementIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether to skip content transitions for this transition. If true, this will skip content transitions for all flavors in this request. If false, this will skip content transitions for the flavors in this request. */
  skipContent?: Scalars['Boolean']['input'];
};

export type TransitionTrafficCampaignFlavorsInput = {
  /** An array of flavorIds to be modified by the function */
  flavorIds: Array<Scalars['String']['input']>;
  /** ID of the TrafficCampaign containing the flavor for this request */
  id: Scalars['ID']['input'];
  /** ID of the TrafficProject containing the TrafficCampaign related to this request */
  projectId: Scalars['ID']['input'];
  /** Whether this transition should bypass manual approval. If true, this will effectively take care of the request for approval and approval in a single step. If false, this will assume you've already requested for approval. Usually reserved for non-gateway campaigns. */
  skipManualApproval?: Scalars['Boolean']['input'];
  /** Desired state for all flavors(suspend, approve, etc) */
  state: TrafficCampaignFlavorStateType;
};

export type TransitionTrafficCampaignInput = {
  /** ID of the TrafficCampaign */
  campaignId: Scalars['ID']['input'];
  /** A list of flavor transition configurations to execute */
  flavorConfigurations?: InputMaybe<Array<TransitionTrafficCampaignFlavorConfigurationInput>>;
  /** ID of the TrafficProject containing the TrafficCampaign related to this request */
  projectId: Scalars['ID']['input'];
  /** Whether this transition should bypass manual approval. If true, this will effectively take care of the request for approval and approval in a single step. If false, this will assume you've already requested for approval. Usually reserved for non-gateway campaigns. */
  skipManualApproval?: Scalars['Boolean']['input'];
  /** Desired state for all targeted flavors. */
  state: TrafficCampaignFlavorStateType;
};

export type TransitionTrafficCampaignPlacementsInput = {
  /** An array of flavorIds to be modified by the function */
  flavorIds: Array<Scalars['String']['input']>;
  /** ID of the TrafficCampaign containing the flavor for this request */
  id: Scalars['ID']['input'];
  /** An array of placement IDs to be modified by the function */
  placementsToInclude: Array<Scalars['String']['input']>;
  /** ID of the TrafficProject containing the TrafficCampaign related to this request */
  projectId: Scalars['ID']['input'];
  /** Whether this transition should bypass manual approval. If true, this will effectively take care of the request for approval and approval in a single step. If false, this will assume you've already requested for approval. Usually reserved for non-gateway campaigns. */
  skipManualApproval?: Scalars['Boolean']['input'];
  /** Desired state for all flavors(suspend, approve, etc) */
  state: TrafficCampaignFlavorStateType;
};

export type UpdateCampaignConfigurationInput = {
  /** Human readable campaign ID */
  campaignId?: InputMaybe<Scalars['String']['input']>;
  /** Information about the component  used in this configuration */
  componentInfos?: InputMaybe<Array<ComponentInfoVariantInput>>;
  /** Configuration for the campaign content */
  contentConfiguration?: InputMaybe<ContentConfigurationInput>;
  /** Array of feature groups for feature toggling */
  featureGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether this campaign supports multiple platform flavors */
  hasMultiPlatformFlavors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique identifier for the campaign configuration */
  id: Scalars['ID']['input'];
  /** Whether this is a Multi-Creative Campaign configuration */
  isMCC?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this campaign is platform agnostic */
  isPlatformAgnostic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration for live preview */
  livePreviewConfiguration?: InputMaybe<LivePreviewConfigurationInput>;
  /** Display name for the campaign */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Configuration for the overview section of the campaign */
  overviewConfiguration?: InputMaybe<OverviewConfigurationInput>;
  /** The type of page where the campaign will be displayed */
  pageType?: InputMaybe<PageTypeEnum>;
  /** Configuration for the placements section of the campaign */
  placementsSection?: InputMaybe<PlacementsSectionConfigInput>;
  /** Configuration for publishing to Symphony */
  publishing?: InputMaybe<PublishingConfigurationInput>;
  /** Whether this campaign requires Customer Behavior Reports */
  requiresCBR?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this campaign requires Mocar integration */
  requiresMocar?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration options for variable sharing behavior */
  sharingOptions?: InputMaybe<SharingOptionsInput>;
  /** Short name for the campaign */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Current version of the campaign configuration for optimistic concurrency control */
  version: Scalars['Int']['input'];
};

export type UpdateExperimentV2MutationResponse = CreateOrUpdateExperimentV2MutationResponseInterface & {
  __typename?: 'UpdateExperimentV2MutationResponse';
  /** The created or updated experiment */
  experiment?: Maybe<DpExperimentDetailsV2>;
};

export type UpdateQaCommentInput = {
  comment: Scalars['String']['input'];
  commentId: Scalars['ID']['input'];
};

export type UpdateQaReviewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  reviewId: Scalars['ID']['input'];
  status?: InputMaybe<QaStatusEnum>;
};

/** Type for storing the results after upload */
export type UploadJobResult = {
  __typename?: 'UploadJobResult';
  jobError?: Maybe<JobError>;
  rowResults: Array<RowResults>;
  totalRowCount: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  alias: Scalars['String']['output'];
  email: Scalars['String']['output'];
  groups: Array<Scalars['String']['output']>;
};

export type ValidatePublishedPricingInfoInput = {
  asin: Scalars['ID']['input'];
  marketplace: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
};

export type ValidatePublishedPricingInfoMutationResponse = MutationResponse & {
  __typename?: 'ValidatePublishedPricingInfoMutationResponse';
  /** Represents the status of the mutation, like an HTTP status code. */
  code: Scalars['String']['output'];
  /** Human-readable string describing the result of the mutation. You could display thisin the UI. */
  message: Scalars['String']['output'];
  publishedPricingInfos?: Maybe<Array<PricingInfo>>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type VariantSlot = {
  __typename?: 'VariantSlot';
  /** Slots for this variant */
  slots: Array<Scalars['String']['output']>;
  /** Name of the variant */
  variant: Scalars['String']['output'];
};

export type VariantSlotInput = {
  /** Slots for this variant */
  slots: Array<Scalars['String']['input']>;
  /** Name of the variant */
  variant: Scalars['String']['input'];
};

export type VariantSlotOptions = {
  __typename?: 'VariantSlotOptions';
  /** List of scoped variant slot options */
  variant: Array<ScopedVariantSlotOption>;
};

export type VariationalAsin = {
  __typename?: 'VariationalAsin';
  asin: Scalars['String']['output'];
  childAsins?: Maybe<Array<VariationalAsin>>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Widget type for publishing transformation. "Declarative" widgets nest their content in an "arguments" item */
export enum WidgetType {
  Declarative = 'declarative',
  Generic = 'generic'
}

export enum WorkflowStateType {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED'
}

export type BulkTrafficCreateProjectInput = {
  /** Determines if a Symphony Event should be asssociated with the project */
  buildEvent?: Scalars['Boolean']['input'];
  /** Title of the TrafficProject being created */
  name?: Scalars['String']['input'];
};

export type ComponentInt = {
  __typename?: 'componentInt';
  asin: Scalars['String']['output'];
  data: Scalars['Int']['output'];
};

export type ComponentString = {
  __typename?: 'componentString';
  asin: Scalars['String']['output'];
  data: Scalars['String']['output'];
};

export type PapiUser = {
  __typename?: 'papiUser';
  /** The Amazon user's business title */
  businessTitle?: Maybe<Scalars['String']['output']>;
  /** The first name of the user */
  firstName: Scalars['String']['output'];
  /** The last name of the user */
  lastName: Scalars['String']['output'];
  /** The Amazon login of the user */
  login: Scalars['String']['output'];
};

export type Permissions = {
  __typename?: 'permissions';
  hasPermission: Scalars['Boolean']['output'];
};

export type SortOptions = {
  ascending: Scalars['Boolean']['input'];
  sortBy: CampaignSortByOptionsInput;
};

export type SymphonyPlacementMappingInput = {
  lastUpdatedHash: Scalars['String']['input'];
  placementUiId: Scalars['String']['input'];
  symphonyPlacementId: Scalars['String']['input'];
  symphonyPreviewURL?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateAltTextQueryVariables = Exact<{
  input: GenerateAltTextInput;
}>;


export type GenerateAltTextQuery = { __typename?: 'Query', generateAltText: { __typename?: 'GenerateAltTextOutput', altText: string } };

export type ProductLineSelectFragment = { __typename?: 'ProductLine2', id: string, name: string };

export type ProgramSelectFragment = { __typename?: 'Program', id: string, name: string };

export type ListPreviewersQueryVariables = Exact<{
  realm: Scalars['String']['input'];
}>;


export type ListPreviewersQuery = { __typename?: 'Query', getListPreviewers: Array<{ __typename?: 'SymphonyPreviewer', username: string, customerId: string }> };

export type DeletePreviewSessionsMutationVariables = Exact<{
  obfuscatedPreviewerIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  realm: SymphonyRealm;
}>;


export type DeletePreviewSessionsMutation = { __typename?: 'Mutation', deletePreviewSessions: Array<{ __typename?: 'DeletePreviewSessionError', message: string } | { __typename?: 'DeletedPreviewSession', obfuscatedPreviewerId: string }> };

export type CreatePreviewSessionMutationVariables = Exact<{
  input: CreatePreviewSessionInput;
}>;


export type CreatePreviewSessionMutation = { __typename?: 'Mutation', createPreviewSession: { __typename?: 'CreatePreviewSessionOutput', username?: string | null, previewerId?: string | null, startTime: string, expiryTime: string, data: { __typename?: 'PreviewSessionData', addedBullseye2?: Array<any> | null, removedBullseye2?: Array<any> | null, previewTime?: string | null, previewPlacements?: Array<{ __typename?: 'PreviewPlacementOutput', creativeId?: string | null, rule?: string | null, links?: any | null }> | null } } };

export type AsinTableCellFragment = { __typename?: 'ASIN', asin: string, productId?: string | null, marketplace: { __typename?: 'Marketplace', id: string, country: string }, program?: { __typename?: 'Program', id: string, name: string, programId: string } | null };

export type AlvAsinsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filters?: InputMaybe<AsinFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
  sortOptions?: InputMaybe<Array<AsinSortInput> | AsinSortInput>;
}>;


export type AlvAsinsQuery = { __typename?: 'Query', asins: { __typename?: 'QueryAsins_Connection', totalCount: number, nodes: Array<{ __typename?: 'ASIN', announceDate?: any | null, description?: string | null, id: string, thumbnailURL?: string | null, type: string, asin: string, productId?: string | null, productLine?: { __typename?: 'ProductLine2', id: string, name: string } | null, marketplace: { __typename?: 'Marketplace', id: string, country: string }, program?: { __typename?: 'Program', id: string, name: string, programId: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type AlvProductLinesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filters?: InputMaybe<ProductLineFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
  sortOptions?: InputMaybe<Array<ProductLineSortInput> | ProductLineSortInput>;
}>;


export type AlvProductLinesQuery = { __typename?: 'Query', productLines: { __typename?: 'QueryProductLines_Connection', nodes: Array<{ __typename?: 'ProductLine2', id: string, name: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type AlvProgramsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filters?: InputMaybe<ProgramFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
  sortOptions?: InputMaybe<Array<ProgramSortInput> | ProgramSortInput>;
}>;


export type AlvProgramsQuery = { __typename?: 'Query', programs: { __typename?: 'QueryPrograms_Connection', nodes: Array<{ __typename?: 'Program', id: string, name: string, programId: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type BulkPublishJobResultFragment = { __typename?: 'BulkPublishJob', id: string, status: JobStatus, metadata: { __typename?: 'BulkPublishMetadata', results: Array<{ __typename?: 'BulkPublishAsinResult', asinVertexId: string, status: BulkPublishAsinStatus, error?: { __typename?: 'BulkPublishAsinError', message: string, type: BulkPublishAsinErrorType } | null }> } };

export type CreateBulkPublishJobMutationVariables = Exact<{
  input: CreateBulkPublishJobInput;
}>;


export type CreateBulkPublishJobMutation = { __typename?: 'Mutation', createBulkPublishJob: { __typename?: 'CreateBulkPublishJobMutationResponse', job: { __typename?: 'BulkPublishJob', id: string, status: JobStatus } } };

export type BulkPublishJobQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type BulkPublishJobQuery = { __typename?: 'Query', job: { __typename?: 'BulkAtfJob' } | { __typename?: 'BulkPublishJob', id: string, status: JobStatus, metadata: { __typename?: 'BulkPublishMetadata', results: Array<{ __typename?: 'BulkPublishAsinResult', asinVertexId: string, status: BulkPublishAsinStatus, error?: { __typename?: 'BulkPublishAsinError', message: string, type: BulkPublishAsinErrorType } | null }> } } | { __typename?: 'BulkPublishV2Job' } | { __typename?: 'MCCTransitionJob' } };

export type JagNameFragment = { __typename?: 'AssetGroup', name: string };

export type TrafficProjectNameFragment = { __typename?: 'TrafficProject', name: string };

export type CreateJagBreadcrumbInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CreateJagBreadcrumbInfoQuery = { __typename?: 'Query', trafficProject: { __typename?: 'TrafficProject', name: string } };

export type JasFormBreadcrumbInfoQueryVariables = Exact<{
  filters: JagFilterInput;
  id: Scalars['ID']['input'];
}>;


export type JasFormBreadcrumbInfoQuery = { __typename?: 'Query', JAGs: { __typename?: 'QueryJAGs_Connection', nodes: Array<{ __typename?: 'AssetGroup', name: string }> }, trafficProject: { __typename?: 'TrafficProject', name: string } };

export type AssetsQueryVariables = Exact<{
  input: AssetsQueryInput;
}>;


export type AssetsQuery = { __typename?: 'Query', assets: { __typename?: 'AssetsOffsetPage', from: number, to: number, numberOfResults: number, assets: Array<{ __typename?: 'AssetSearchResult', archived?: boolean | null, assetId: string, device?: Array<string | null> | null, docId: string, docName?: string | null, isPublishedMap?: any | null, mediaCentralUrls?: any | null, modifiedBy: string, modifiedDate: string, name: string, platform?: string | null, productLine?: Array<string | null> | null, originalAssetS3Get?: string | null, s3SignedUrlGet?: string | null, s3SignedUrlPut?: string | null, size?: number | null, tags?: Array<string | null> | null, thumbnail?: string | null, uploadedAt: number, uploadedBy: string, assetMetadata?: { __typename?: 'AssetMetadata', height?: number | null, width?: number | null } | null }> } };

export type AssetFieldsFragment = { __typename?: 'AssetSearchResult', archived?: boolean | null, assetId: string, device?: Array<string | null> | null, docId: string, docName?: string | null, isPublishedMap?: any | null, mediaCentralUrls?: any | null, modifiedBy: string, modifiedDate: string, name: string, platform?: string | null, productLine?: Array<string | null> | null, originalAssetS3Get?: string | null, s3SignedUrlGet?: string | null, s3SignedUrlPut?: string | null, size?: number | null, tags?: Array<string | null> | null, thumbnail?: string | null, uploadedAt: number, uploadedBy: string, assetMetadata?: { __typename?: 'AssetMetadata', height?: number | null, width?: number | null } | null };

export type AssetQueryVariables = Exact<{
  input: AssetSearchRequest;
}>;


export type AssetQuery = { __typename?: 'Query', assetsSearch: { __typename?: 'AssetSearchResponses', results: Array<{ __typename?: 'AssetSearchResponse', searchResults: Array<{ __typename?: 'AssetSearchResult', archived?: boolean | null, assetId: string, device?: Array<string | null> | null, docId: string, docName?: string | null, isPublishedMap?: any | null, mediaCentralUrls?: any | null, modifiedBy: string, modifiedDate: string, name: string, platform?: string | null, productLine?: Array<string | null> | null, originalAssetS3Get?: string | null, s3SignedUrlGet?: string | null, s3SignedUrlPut?: string | null, size?: number | null, tags?: Array<string | null> | null, thumbnail?: string | null, uploadedAt: number, uploadedBy: string, assetMetadata?: { __typename?: 'AssetMetadata', height?: number | null, width?: number | null } | null } | null> } | null> } };

export type CopyAssetMutationVariables = Exact<{
  assetId: Scalars['ID']['input'];
  destinationProjectId: Scalars['ID']['input'];
}>;


export type CopyAssetMutation = { __typename?: 'Mutation', copyAsset: { __typename?: 'CreateAssetMutationResponse', message: string, code: string, success: boolean, asset: { __typename?: 'AssetSearchResult', archived?: boolean | null, assetId: string, device?: Array<string | null> | null, docId: string, docName?: string | null, isPublishedMap?: any | null, mediaCentralUrls?: any | null, modifiedBy: string, modifiedDate: string, name: string, platform?: string | null, productLine?: Array<string | null> | null, originalAssetS3Get?: string | null, s3SignedUrlGet?: string | null, s3SignedUrlPut?: string | null, size?: number | null, tags?: Array<string | null> | null, thumbnail?: string | null, uploadedAt: number, uploadedBy: string, assetMetadata?: { __typename?: 'AssetMetadata', height?: number | null, width?: number | null } | null } } };

export type CreateAssetMutationVariables = Exact<{
  input: CreateAssetInput;
}>;


export type CreateAssetMutation = { __typename?: 'Mutation', createAsset: { __typename?: 'CreateAssetMutationResponse', message: string, code: string, success: boolean, asset: { __typename?: 'AssetSearchResult', archived?: boolean | null, assetId: string, device?: Array<string | null> | null, docId: string, docName?: string | null, isPublishedMap?: any | null, mediaCentralUrls?: any | null, modifiedBy: string, modifiedDate: string, name: string, platform?: string | null, productLine?: Array<string | null> | null, originalAssetS3Get?: string | null, s3SignedUrlGet?: string | null, s3SignedUrlPut?: string | null, size?: number | null, tags?: Array<string | null> | null, thumbnail?: string | null, uploadedAt: number, uploadedBy: string, assetMetadata?: { __typename?: 'AssetMetadata', height?: number | null, width?: number | null } | null } } };

export type ProjectAssetsByIdsQueryVariables = Exact<{
  input: GetAssetsByIdsInput;
}>;


export type ProjectAssetsByIdsQuery = { __typename?: 'Query', getAssetsByIds: { __typename?: 'GetAssetsByIdsOutput', assets: Array<{ __typename?: 'AssetSearchResult', archived?: boolean | null, assetId: string, device?: Array<string | null> | null, docId: string, docName?: string | null, isPublishedMap?: any | null, mediaCentralUrls?: any | null, modifiedBy: string, modifiedDate: string, name: string, platform?: string | null, productLine?: Array<string | null> | null, originalAssetS3Get?: string | null, s3SignedUrlGet?: string | null, s3SignedUrlPut?: string | null, size?: number | null, tags?: Array<string | null> | null, thumbnail?: string | null, uploadedAt: number, uploadedBy: string, assetMetadata?: { __typename?: 'AssetMetadata', height?: number | null, width?: number | null } | null }> } };

export type ProjectAssetQueryVariables = Exact<{
  input: ProjectAssetsInput;
}>;


export type ProjectAssetQuery = { __typename?: 'Query', projectAssets: Array<{ __typename?: 'AssetSearchResult', archived?: boolean | null, assetId: string, device?: Array<string | null> | null, docId: string, docName?: string | null, isPublishedMap?: any | null, mediaCentralUrls?: any | null, modifiedBy: string, modifiedDate: string, name: string, platform?: string | null, productLine?: Array<string | null> | null, originalAssetS3Get?: string | null, s3SignedUrlGet?: string | null, s3SignedUrlPut?: string | null, size?: number | null, tags?: Array<string | null> | null, thumbnail?: string | null, uploadedAt: number, uploadedBy: string, assetMetadata?: { __typename?: 'AssetMetadata', height?: number | null, width?: number | null } | null }> };

export type RenameAssetMutationVariables = Exact<{
  input: RenameAssetInput;
}>;


export type RenameAssetMutation = { __typename?: 'Mutation', renameAsset: { __typename?: 'CommonMutationResponse', message: string, code: string, success: boolean } };

export type StartAssetIntakeSessionMutationVariables = Exact<{
  input: StartAssetIntakeSessionInput;
}>;


export type StartAssetIntakeSessionMutation = { __typename?: 'Mutation', startAssetIntakeSession: { __typename?: 'StartAssetIntakeSessionMutationResponse', code: string, success: boolean, message: string, uploadUrl: string } };

export type BulkAtfQueryVariables = Exact<{
  asins: Array<Scalars['String']['input']> | Scalars['String']['input'];
  marketplacesLanguages: Array<Scalars['String']['input']> | Scalars['String']['input'];
  attributes: BulkAtfQueryInput;
  pricingFields: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BulkAtfQuery = { __typename?: 'Query', bulkAtfQuery: { __typename?: 'BulkAtfQueryResponse', url: string, errors: { __typename?: 'BulkAtfQueryErrors', asinMissAllMp: Array<string>, permissionDenied: Array<string> } } };

export type BulkAtfJobDetailsFragment = { __typename?: 'BulkAtfJob', id: string, status: JobStatus, metadata?: { __typename?: 'BulkAtfMetadata', bulkPublishExecutionIdList?: Array<string> | null, results?: { __typename?: 'UploadJobResult', totalRowCount: number, jobError?: { __typename?: 'JobError', errorMessage: string } | null, rowResults: Array<{ __typename?: 'RowResults', asin: string, marketplace: string, rowNumber: number, success: boolean, rowErrors?: Array<{ __typename?: 'AttributeOrPricingErrors', name: string, value: string, errorType: ColumnErrorType, errorMessage: string } | { __typename?: 'ErrorASINMarketplaceNotFound', errorMessage: string }> | null }> } | null } | null };

export type CreateJobMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;


export type CreateJobMutation = { __typename?: 'Mutation', createBulkAtfJob: { __typename?: 'CreateBulkAtfJobMutationResponse', uploadUrl: string, job: { __typename?: 'BulkAtfJob', id: string, status: JobStatus } } };

export type JobStatusQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type JobStatusQuery = { __typename?: 'Query', job: { __typename?: 'BulkAtfJob', id: string, status: JobStatus, metadata?: { __typename?: 'BulkAtfMetadata', bulkPublishExecutionIdList?: Array<string> | null, results?: { __typename?: 'UploadJobResult', totalRowCount: number, jobError?: { __typename?: 'JobError', errorMessage: string } | null, rowResults: Array<{ __typename?: 'RowResults', asin: string, marketplace: string, rowNumber: number, success: boolean, rowErrors?: Array<{ __typename?: 'AttributeOrPricingErrors', name: string, value: string, errorType: ColumnErrorType, errorMessage: string } | { __typename?: 'ErrorASINMarketplaceNotFound', errorMessage: string }> | null }> } | null } | null } | { __typename?: 'BulkPublishJob' } | { __typename?: 'BulkPublishV2Job' } | { __typename?: 'MCCTransitionJob' } };

export type BulkAtfJobsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type BulkAtfJobsQuery = { __typename?: 'Query', jobs: Array<{ __typename?: 'BulkAtfJob', id: string, status: JobStatus, metadata?: { __typename?: 'BulkAtfMetadata', bulkPublishExecutionIdList?: Array<string> | null, results?: { __typename?: 'UploadJobResult', totalRowCount: number, jobError?: { __typename?: 'JobError', errorMessage: string } | null, rowResults: Array<{ __typename?: 'RowResults', asin: string, marketplace: string, rowNumber: number, success: boolean, rowErrors?: Array<{ __typename?: 'AttributeOrPricingErrors', name: string, value: string, errorType: ColumnErrorType, errorMessage: string } | { __typename?: 'ErrorASINMarketplaceNotFound', errorMessage: string }> | null }> } | null } | null } | { __typename?: 'BulkPublishJob' } | { __typename?: 'BulkPublishV2Job' } | { __typename?: 'MCCTransitionJob' }> };

export type BulkPublishAttributesMutationVariables = Exact<{
  input: BulkPublishInput;
}>;


export type BulkPublishAttributesMutation = { __typename?: 'Mutation', bulkPublishAttributes: { __typename?: 'BulkPublishResponse', jobId: string, totalAsinsAttemptedToPublish: number, totalAttributesAttemptedToPublish: number } };

export type BulkpublishJobsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type BulkpublishJobsQuery = { __typename?: 'Query', jobs: Array<{ __typename?: 'BulkAtfJob' } | { __typename?: 'BulkPublishJob' } | { __typename?: 'BulkPublishV2Job', id: string, status: JobStatus, createdAt?: any | null, metadata?: { __typename?: 'BulkPublishV2Metadata', successfulResults?: Array<{ __typename?: 'BulkPublishV2StateMachineOutputAsinItem', asin: { __typename?: 'ASIN', asin: string, marketplace: { __typename?: 'Marketplace', country: string } }, attributes: Array<{ __typename?: 'DpAttributeWithError', key: string, value: any, language: string }> }> | null, failedResults?: Array<{ __typename?: 'BulkPublishV2StateMachineOutputAsinItem', asin: { __typename?: 'ASIN', asin: string, marketplace: { __typename?: 'Marketplace', country: string } }, attributes: Array<{ __typename?: 'DpAttributeWithError', key: string, value: any, language: string, error?: { __typename?: 'BulkPublishV2Error', error: any } | null }>, error?: { __typename?: 'BulkPublishV2Error', error: any } | null }> | null } | null } | { __typename?: 'MCCTransitionJob' }> };

export type BulkPublishPreviewQueryVariables = Exact<{
  filters?: InputMaybe<BulkPublishPreviewInput>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type BulkPublishPreviewQuery = { __typename?: 'Query', bulkPublishPreview: { __typename?: 'QueryBulkPublishPreview_Connection', totalAttributesBeingPreviewed: number, totalAttributesNotInDraft: number, edges: Array<{ __typename?: 'DpAttributeEdge', cursor: string, node: { __typename?: 'DpAttribute', key: string, language: string, value: any, modifiedBy: string, modifiedAt: string, version: number, removed: boolean, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, issues?: Array<any> | null, publishResult?: { __typename?: 'DpPublishResult', status?: string | null, result: string, success: boolean } | null, asinObject?: { __typename?: 'ASIN', id: string, asin: string, marketplace: { __typename?: 'Marketplace', country: string }, program?: { __typename?: 'Program', programId: string, name: string } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, availablePrograms: Array<{ __typename?: 'ProgramInfo', id: string, name: string }>, invalidAsins: Array<{ __typename?: 'InvalidAsinWithMissingAttributes', asinObject?: { __typename?: 'ASIN', id: string, asin: string, marketplace: { __typename?: 'Marketplace', country: string } } | null, missingAttributes?: Array<{ __typename?: 'MissingAttributesByLanguage', language: string, attributes: Array<string> }> | null, error?: { __typename?: 'AsinResolutionError', asin: string, marketplace: string, message: string } | null }> } };

export type VariantUrlNamesFragment = { __typename?: 'BulkSlateImageResponse', asin: string, marketplace: string, productId: string, slates: Array<{ __typename?: 'SlateImage', assetId?: string | null, variant: string, version: number, url: string }> };

export type BulkSlatesQueryVariables = Exact<{
  inputs: Array<BulkSlatesQueryObject> | BulkSlatesQueryObject;
}>;


export type BulkSlatesQuery = { __typename?: 'Query', bulkSlates: Array<{ __typename?: 'BulkSlateImageResponse', asin: string, marketplace: string, productId: string, slates: Array<{ __typename?: 'SlateImage', assetId?: string | null, variant: string, version: number, url: string }> }> };

export type BulkCreateAssetMutationVariables = Exact<{
  input: Array<BulkCreateAssetInput> | BulkCreateAssetInput;
}>;


export type BulkCreateAssetMutation = { __typename?: 'Mutation', bulkCreateAsset: Array<{ __typename?: 'BulkCreateAssetMutationResponse', message: string, code: string, success: boolean, id: string, asset: { __typename?: 'AssetSearchResult', archived?: boolean | null, assetId: string, device?: Array<string | null> | null, docId: string, docName?: string | null, isPublishedMap?: any | null, mediaCentralUrls?: any | null, modifiedBy: string, modifiedDate: string, name: string, platform?: string | null, productLine?: Array<string | null> | null, originalAssetS3Get?: string | null, s3SignedUrlGet?: string | null, s3SignedUrlPut?: string | null, size?: number | null, tags?: Array<string | null> | null, thumbnail?: string | null, uploadedAt: number, uploadedBy: string, assetMetadata?: { __typename?: 'AssetMetadata', height?: number | null, width?: number | null } | null } }> };

export type BulkSaveSlatesMutationVariables = Exact<{
  input: Array<SaveSlatesInput> | SaveSlatesInput;
}>;


export type BulkSaveSlatesMutation = { __typename?: 'Mutation', bulkSaveSlates: Array<{ __typename?: 'BulkSaveSlatesMutationResponse', code: string, message: string, success: boolean, asin: string, marketplace: string, succeeded: Array<{ __typename?: 'SlateImage', assetId?: string | null, url: string, filename?: string | null, modifiedAt: string, modifiedBy: string, variant: string, version: number, removed: boolean, lastPublishedDate?: string | null, lastPublishedVersion?: number | null }>, failed: Array<{ __typename?: 'SlateImageFailure', reason: string, variant: string }> }> };

export type ProductIdNameFieldsSegmentFragment = { __typename?: 'ProductIdAndProductNameStatus', asin: string, marketplace: string, products: { __typename?: 'Product', id: string, title: string, ghostProjects: Array<string>, businessGroupsIds: Array<string>, accessControlGroups: Array<string>, detailPages: Array<{ __typename?: 'DetailPage', title: string, marketplace: string, merchantId?: string | null, asin: string, image?: string | null, permissionsGroup?: { __typename?: 'PermissionsLdapGroups', attributesAndPricing: Array<string>, campaignsAndSlates: Array<string> } | null }> } };

export type ProductIdNameFieldsErrorFragment = { __typename?: 'ProductIdAndProductNameError', asin: string, marketplace: string, error?: string | null };

export type ProductIdAndProductNameForBulkImageQueryVariables = Exact<{
  inputs: Array<MpAsinQueryObject> | MpAsinQueryObject;
}>;


export type ProductIdAndProductNameForBulkImageQuery = { __typename?: 'Query', productIdAndProductNameForBulkImage: Array<{ __typename?: 'ProductIdAndProductNameError', asin: string, marketplace: string, error?: string | null } | { __typename?: 'ProductIdAndProductNameStatus', asin: string, marketplace: string, products: { __typename?: 'Product', id: string, title: string, ghostProjects: Array<string>, businessGroupsIds: Array<string>, accessControlGroups: Array<string>, detailPages: Array<{ __typename?: 'DetailPage', title: string, marketplace: string, merchantId?: string | null, asin: string, image?: string | null, permissionsGroup?: { __typename?: 'PermissionsLdapGroups', attributesAndPricing: Array<string>, campaignsAndSlates: Array<string> } | null }> } }> };

export type AsinsForBundleManagerQueryVariables = Exact<{
  marketplace: Scalars['String']['input'];
  programName: Scalars['String']['input'];
}>;


export type AsinsForBundleManagerQuery = { __typename?: 'Query', bundleManagerPrograms: Array<{ __typename?: 'BundleManagerProgram', asins: Array<{ __typename?: 'BundleManagerAsin', asin: string, deviceName: string }> }> };

export type CreateBundleMutationVariables = Exact<{
  input: CreateBundleRequest;
}>;


export type CreateBundleMutation = { __typename?: 'Mutation', createBundle: { __typename?: 'CreateBundleResponse', bundleEntities: Array<{ __typename?: 'BundleEntityOutput', id: string, submissionDate: string, status: string, errorRecord: Array<string>, bundleForm: { __typename?: 'BundleRequestOutput', title: string, autoGeneratedCreativeName: boolean, bindingType: string } }> } };

export type EchoMessageQueryVariables = Exact<{
  message: Scalars['String']['input'];
}>;


export type EchoMessageQuery = { __typename?: 'Query', echoMessage: { __typename?: 'EchoString', string?: string | null } };

export type ProgramsForBundleManagerQueryVariables = Exact<{
  marketplace: Scalars['String']['input'];
}>;


export type ProgramsForBundleManagerQuery = { __typename?: 'Query', bundleManagerPrograms: Array<{ __typename?: 'BundleManagerProgram', programId: string, programName: string }> };

export type ApproveCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type ApproveCampaignMutation = { __typename?: 'Mutation', approveCampaign: { __typename?: 'EmptyCampaignMutationResponse', status?: string | null } };

export type ArchiveCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  userVersion: Scalars['Int']['input'];
}>;


export type ArchiveCampaignMutation = { __typename?: 'Mutation', archiveCampaign: { __typename?: 'SaveCampaignMutationResponse', campaign: { __typename?: 'Campaign', isArchived?: boolean | null, userVersion: number } } };

export type CampaignFieldsFragment = { __typename?: 'Campaign', accessControlGroup?: string | null, additionalName?: string | null, alexaEnabled?: string | null, businessGroup?: string | null, createdAt: string, createdBy: string, campaignTypeVersion: string, content: any, errors: Array<string>, eventShortName?: string | null, id: string, intent?: string | null, isArchived?: boolean | null, isAutoGenerateCreativeName?: boolean | null, isLocked?: boolean | null, isMVT?: boolean | null, language?: string | null, modifiedAt: string, modifiedBy: string, languageOptions: Array<string>, liveState: LiveStateType, productLine?: string | null, program?: string | null, projectId: string, reason?: string | null, state: CampaignState, tags: Array<string>, title: string, typeId: string, useReactAppUrl?: boolean | null, userVersion: number, mvtExperimentInfo?: { __typename?: 'MVTExperimentInfo', combinations: Array<{ __typename?: 'MVTCombination', id: string, isDefault?: boolean | null, isExcluded?: boolean | null, dimensionVariantList: Array<{ __typename?: 'DimensionVariantKey', dimensionName: string, variantName: string }> }>, dimensions: Array<{ __typename?: 'DimensionInfo', name: string, variants: Array<string> }>, experimentList?: Array<{ __typename?: 'MVTExperimentDetail', experimentId: string, metricUrl?: string | null, placementId: string, status: string }> | null } | null, placements: Array<{ __typename?: 'Placement', additionalExcludes?: any | null, additionalIncludes?: any | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, bullseyeExcludes?: Array<number> | null, bullseyeIncludes?: Array<number> | null, categoryNode?: Array<string> | null, customerTargeting: string, deviceTypes?: Array<string> | null, guarantee?: number | null, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, kothOrGuarantee: string, languages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, platform?: string | null, scheduleType?: string | null, slot?: string | null, state: CampaignState, symphonyPreviewUrl: string, uiId: string, weblabName?: string | null, weblabTreatment?: string | null, event?: { __typename?: 'PlacementEventData', childEventId?: string | null, elemId: string } | null, timeRange: { __typename?: 'DateRange', start: string, end: string } }>, symphonyInfo?: Array<{ __typename?: 'SymphonyInfo', mvtCombinationId?: string | null, symphonyCreativeId: string, lastUpdatedHash: string, placementMapping: Array<{ __typename?: 'SymphonyPlacementMapping', placementUiId: string, symphonyPlacementId: string, symphonyPreviewURL: string, lastUpdatedHash: string }> }> | null };

export type CampaignQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type CampaignQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', accessControlGroup?: string | null, additionalName?: string | null, alexaEnabled?: string | null, businessGroup?: string | null, createdAt: string, createdBy: string, campaignTypeVersion: string, content: any, errors: Array<string>, eventShortName?: string | null, id: string, intent?: string | null, isArchived?: boolean | null, isAutoGenerateCreativeName?: boolean | null, isLocked?: boolean | null, isMVT?: boolean | null, language?: string | null, modifiedAt: string, modifiedBy: string, languageOptions: Array<string>, liveState: LiveStateType, productLine?: string | null, program?: string | null, projectId: string, reason?: string | null, state: CampaignState, tags: Array<string>, title: string, typeId: string, useReactAppUrl?: boolean | null, userVersion: number, mvtExperimentInfo?: { __typename?: 'MVTExperimentInfo', combinations: Array<{ __typename?: 'MVTCombination', id: string, isDefault?: boolean | null, isExcluded?: boolean | null, dimensionVariantList: Array<{ __typename?: 'DimensionVariantKey', dimensionName: string, variantName: string }> }>, dimensions: Array<{ __typename?: 'DimensionInfo', name: string, variants: Array<string> }>, experimentList?: Array<{ __typename?: 'MVTExperimentDetail', experimentId: string, metricUrl?: string | null, placementId: string, status: string }> | null } | null, placements: Array<{ __typename?: 'Placement', additionalExcludes?: any | null, additionalIncludes?: any | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, bullseyeExcludes?: Array<number> | null, bullseyeIncludes?: Array<number> | null, categoryNode?: Array<string> | null, customerTargeting: string, deviceTypes?: Array<string> | null, guarantee?: number | null, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, kothOrGuarantee: string, languages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, platform?: string | null, scheduleType?: string | null, slot?: string | null, state: CampaignState, symphonyPreviewUrl: string, uiId: string, weblabName?: string | null, weblabTreatment?: string | null, event?: { __typename?: 'PlacementEventData', childEventId?: string | null, elemId: string } | null, timeRange: { __typename?: 'DateRange', start: string, end: string } }>, symphonyInfo?: Array<{ __typename?: 'SymphonyInfo', mvtCombinationId?: string | null, symphonyCreativeId: string, lastUpdatedHash: string, placementMapping: Array<{ __typename?: 'SymphonyPlacementMapping', placementUiId: string, symphonyPlacementId: string, symphonyPreviewURL: string, lastUpdatedHash: string }> }> | null } };

export type CancelApproveCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type CancelApproveCampaignMutation = { __typename?: 'Mutation', cancelApproveCampaign: { __typename?: 'EmptyCampaignMutationResponse', status?: string | null } };

export type CloneCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  newCampaignId: Scalars['ID']['input'];
}>;


export type CloneCampaignMutation = { __typename?: 'Mutation', cloneCampaign: { __typename?: 'CloneCampaignMutationResponse', id: string } };

export type CreateCampaignMutationVariables = Exact<{
  input: CreateCampaignInput;
}>;


export type CreateCampaignMutation = { __typename?: 'Mutation', createCampaign: { __typename?: 'SaveCampaignMutationResponse', campaign: { __typename?: 'Campaign', accessControlGroup?: string | null, additionalName?: string | null, alexaEnabled?: string | null, businessGroup?: string | null, createdAt: string, createdBy: string, campaignTypeVersion: string, content: any, errors: Array<string>, eventShortName?: string | null, id: string, intent?: string | null, isArchived?: boolean | null, isAutoGenerateCreativeName?: boolean | null, isLocked?: boolean | null, isMVT?: boolean | null, language?: string | null, modifiedAt: string, modifiedBy: string, languageOptions: Array<string>, liveState: LiveStateType, productLine?: string | null, program?: string | null, projectId: string, reason?: string | null, state: CampaignState, tags: Array<string>, title: string, typeId: string, useReactAppUrl?: boolean | null, userVersion: number, mvtExperimentInfo?: { __typename?: 'MVTExperimentInfo', combinations: Array<{ __typename?: 'MVTCombination', id: string, isDefault?: boolean | null, isExcluded?: boolean | null, dimensionVariantList: Array<{ __typename?: 'DimensionVariantKey', dimensionName: string, variantName: string }> }>, dimensions: Array<{ __typename?: 'DimensionInfo', name: string, variants: Array<string> }>, experimentList?: Array<{ __typename?: 'MVTExperimentDetail', experimentId: string, metricUrl?: string | null, placementId: string, status: string }> | null } | null, placements: Array<{ __typename?: 'Placement', additionalExcludes?: any | null, additionalIncludes?: any | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, bullseyeExcludes?: Array<number> | null, bullseyeIncludes?: Array<number> | null, categoryNode?: Array<string> | null, customerTargeting: string, deviceTypes?: Array<string> | null, guarantee?: number | null, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, kothOrGuarantee: string, languages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, platform?: string | null, scheduleType?: string | null, slot?: string | null, state: CampaignState, symphonyPreviewUrl: string, uiId: string, weblabName?: string | null, weblabTreatment?: string | null, event?: { __typename?: 'PlacementEventData', childEventId?: string | null, elemId: string } | null, timeRange: { __typename?: 'DateRange', start: string, end: string } }>, symphonyInfo?: Array<{ __typename?: 'SymphonyInfo', mvtCombinationId?: string | null, symphonyCreativeId: string, lastUpdatedHash: string, placementMapping: Array<{ __typename?: 'SymphonyPlacementMapping', placementUiId: string, symphonyPlacementId: string, symphonyPreviewURL: string, lastUpdatedHash: string }> }> | null } } };

export type ProjectEventQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectEventQuery = { __typename?: 'Query', projectEvent: { __typename?: 'ProjectEventQueryResponse', projectEvent?: { __typename?: 'ProjectEvent', name?: string | null, parentEventId?: string | null, realm?: string | null, businessGroup?: string | null, accessControlGroup?: string | null, timezone?: string | null, childEvents: Array<{ __typename?: 'ChildEvent', childEventId?: string | null, elemId: string, title?: string | null, start?: string | null, end?: string | null }> } | null } };

export type ProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, createdAt: string, createdBy: string, modifiedAt: string, modifiedBy: string, intent?: boolean | null, name?: string | null, parentId?: boolean | null, public: string, state: string, version: number, template?: string | null, permissions: Array<{ __typename?: 'BindlePermission', resourceName: string, id: string } | { __typename?: 'LdapPermission', action: string, ldapGroups: Array<string> } | { __typename?: 'Permission', action: string, user: string, person: { __typename?: 'Person', email?: string | null, firstName: string, lastName: string } }>, settings?: { __typename?: 'ProjectSettings', eventId: string } | null } };

export type PublishCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type PublishCampaignMutation = { __typename?: 'Mutation', publishCampaign: { __typename?: 'EmptyCampaignMutationResponse', status?: string | null } };

export type RequestApproveCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type RequestApproveCampaignMutation = { __typename?: 'Mutation', requestApproveCampaign: { __typename?: 'EmptyCampaignMutationResponse', status?: string | null } };

export type RestoreCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  userVersion: Scalars['Int']['input'];
}>;


export type RestoreCampaignMutation = { __typename?: 'Mutation', restoreCampaign: { __typename?: 'SaveCampaignMutationResponse', campaign: { __typename?: 'Campaign', isArchived?: boolean | null, userVersion: number } } };

export type SaveCampaignMutationVariables = Exact<{
  input: SaveCampaignInput;
}>;


export type SaveCampaignMutation = { __typename?: 'Mutation', saveCampaign: { __typename?: 'SaveCampaignMutationResponse', campaign: { __typename?: 'Campaign', accessControlGroup?: string | null, additionalName?: string | null, alexaEnabled?: string | null, businessGroup?: string | null, createdAt: string, createdBy: string, campaignTypeVersion: string, content: any, errors: Array<string>, eventShortName?: string | null, id: string, intent?: string | null, isArchived?: boolean | null, isAutoGenerateCreativeName?: boolean | null, isLocked?: boolean | null, isMVT?: boolean | null, language?: string | null, modifiedAt: string, modifiedBy: string, languageOptions: Array<string>, liveState: LiveStateType, productLine?: string | null, program?: string | null, projectId: string, reason?: string | null, state: CampaignState, tags: Array<string>, title: string, typeId: string, useReactAppUrl?: boolean | null, userVersion: number, mvtExperimentInfo?: { __typename?: 'MVTExperimentInfo', combinations: Array<{ __typename?: 'MVTCombination', id: string, isDefault?: boolean | null, isExcluded?: boolean | null, dimensionVariantList: Array<{ __typename?: 'DimensionVariantKey', dimensionName: string, variantName: string }> }>, dimensions: Array<{ __typename?: 'DimensionInfo', name: string, variants: Array<string> }>, experimentList?: Array<{ __typename?: 'MVTExperimentDetail', experimentId: string, metricUrl?: string | null, placementId: string, status: string }> | null } | null, placements: Array<{ __typename?: 'Placement', additionalExcludes?: any | null, additionalIncludes?: any | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, bullseyeExcludes?: Array<number> | null, bullseyeIncludes?: Array<number> | null, categoryNode?: Array<string> | null, customerTargeting: string, deviceTypes?: Array<string> | null, guarantee?: number | null, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, kothOrGuarantee: string, languages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, platform?: string | null, scheduleType?: string | null, slot?: string | null, state: CampaignState, symphonyPreviewUrl: string, uiId: string, weblabName?: string | null, weblabTreatment?: string | null, event?: { __typename?: 'PlacementEventData', childEventId?: string | null, elemId: string } | null, timeRange: { __typename?: 'DateRange', start: string, end: string } }>, symphonyInfo?: Array<{ __typename?: 'SymphonyInfo', mvtCombinationId?: string | null, symphonyCreativeId: string, lastUpdatedHash: string, placementMapping: Array<{ __typename?: 'SymphonyPlacementMapping', placementUiId: string, symphonyPlacementId: string, symphonyPreviewURL: string, lastUpdatedHash: string }> }> | null } } };

export type SuspendCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type SuspendCampaignMutation = { __typename?: 'Mutation', suspendCampaign: { __typename?: 'EmptyCampaignMutationResponse', status?: string | null } };

export type SuspendPlacementMutationVariables = Exact<{
  placementId: Scalars['ID']['input'];
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type SuspendPlacementMutation = { __typename?: 'Mutation', suspendPlacement: { __typename?: 'EmptyCampaignMutationResponse', status?: string | null } };

export type SymphonyInfoQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type SymphonyInfoQuery = { __typename?: 'Query', symphonyInfo: Array<{ __typename?: 'SymphonyInfo', mvtCombinationId?: string | null, symphonyCreativeId: string, placementMapping: Array<{ __typename?: 'SymphonyPlacementMapping', placementUiId: string, symphonyPlacementId: string, symphonyPreviewURL: string }> }> };

export type AttributeFieldsFragment = { __typename?: 'DpAttribute', key: string, language: string, value: any, version: number, modifiedAt: string, modifiedBy: string, issues?: Array<any> | null, removed: boolean, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, publishResult?: { __typename?: 'DpPublishResult', status?: string | null, success: boolean, result: string } | null };

export type AttributesQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  marketplace: Scalars['String']['input'];
  asin: Scalars['String']['input'];
  isLaunchPermOn: Scalars['Boolean']['input'];
}>;


export type AttributesQuery = { __typename?: 'Query', attributes: Array<{ __typename?: 'DpAttribute', key: string, language: string, value: any, version: number, modifiedAt: string, modifiedBy: string, issues?: Array<any> | null, removed: boolean, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, publishResult?: { __typename?: 'DpPublishResult', status?: string | null, success: boolean, result: string } | null }> };

export type BundleInfoTabTypeFragment = { __typename: 'ComponentAsin', programName?: string | null };

export type ProductFieldsFragment = { __typename?: 'Product', id: string, title: string, ghostProjects: Array<string>, businessGroupsIds: Array<string>, accessControlGroups: Array<string>, detailPages: Array<{ __typename?: 'DetailPage', title: string, marketplace: string, merchantId?: string | null, asin: string, image?: string | null, permissionsGroup?: { __typename?: 'PermissionsLdapGroups', attributesAndPricing: Array<string>, campaignsAndSlates: Array<string> } | null }> };

export type ProductQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  marketplace: Scalars['String']['input'];
  asin?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, title: string, ghostProjects: Array<string>, businessGroupsIds: Array<string>, accessControlGroups: Array<string>, detailPages: Array<{ __typename?: 'DetailPage', title: string, marketplace: string, merchantId?: string | null, asin: string, image?: string | null, permissionsGroup?: { __typename?: 'PermissionsLdapGroups', attributesAndPricing: Array<string>, campaignsAndSlates: Array<string> } | null }> } };

export type DetailPageQueryVariables = Exact<{
  asin: Scalars['String']['input'];
  filters?: InputMaybe<AsinFilterInput>;
  first: Scalars['Int']['input'];
  isLaunchPermOn: Scalars['Boolean']['input'];
  marketplace: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
}>;


export type DetailPageQuery = { __typename?: 'Query', asins: { __typename?: 'QueryAsins_Connection', nodes: Array<{ __typename?: 'ASIN', id: string, announceDate?: any | null, asin: string, program?: { __typename?: 'Program', name: string, programId: string } | null, launchGating: { __typename?: 'ASINLaunchGating', attributeChecked: AsinLaunchGatingAttributeEnum, beyondLaunchDate: boolean, withinLaunchDate: boolean, launchDateThreshold: number, gatingAsin?: string | null }, canPublishSlates: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string }, canPublishPricingAttributes: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string }, canPublishConfidentialAttributes: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string }, canPublishNonConfidentialAttributes: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string }, canPublishSensitiveAttributes: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string } }> }, attributes: Array<{ __typename?: 'DpAttribute', key: string, language: string, value: any, version: number, modifiedAt: string, modifiedBy: string, issues?: Array<any> | null, removed: boolean, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, publishResult?: { __typename?: 'DpPublishResult', status?: string | null, success: boolean, result: string } | null }>, bundleInfo: { __typename?: 'BundleAsins' } | { __typename: 'ComponentAsin', programName?: string | null }, detailPageStatus: { __typename?: 'DetailPageStatusQueryResponse', status: PublishStatusEnum, productId?: string | null, error?: string | null, code?: string | null }, product: { __typename?: 'Product', id: string, title: string, ghostProjects: Array<string>, businessGroupsIds: Array<string>, accessControlGroups: Array<string>, detailPages: Array<{ __typename?: 'DetailPage', title: string, marketplace: string, merchantId?: string | null, asin: string, image?: string | null, permissionsGroup?: { __typename?: 'PermissionsLdapGroups', attributesAndPricing: Array<string>, campaignsAndSlates: Array<string> } | null }> } };

export type DetailPageStatusFieldsFragment = { __typename?: 'DetailPageStatusQueryResponse', status: PublishStatusEnum, productId?: string | null, error?: string | null, code?: string | null };

export type DetailPageStatusQueryVariables = Exact<{
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
}>;


export type DetailPageStatusQuery = { __typename?: 'Query', detailPageStatus: { __typename?: 'DetailPageStatusQueryResponse', status: PublishStatusEnum, productId?: string | null, error?: string | null, code?: string | null } };

export type DetailPageTabsContainerProductFragment = { __typename?: 'Product', id: string, detailPages: Array<{ __typename?: 'DetailPage', title: string, merchantId?: string | null, asin: string, image?: string | null, permissionsGroup?: { __typename?: 'PermissionsLdapGroups', attributesAndPricing: Array<string>, campaignsAndSlates: Array<string> } | null }> };

export type DetailPageTabsContainerAsinFragment = { __typename?: 'ASIN', id: string, announceDate?: any | null, asin: string, launchGating: { __typename?: 'ASINLaunchGating', attributeChecked: AsinLaunchGatingAttributeEnum, beyondLaunchDate: boolean, withinLaunchDate: boolean, launchDateThreshold: number, gatingAsin?: string | null }, canPublishSlates: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string }, canPublishPricingAttributes: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string }, canPublishConfidentialAttributes: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string }, canPublishNonConfidentialAttributes: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string }, canPublishSensitiveAttributes: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string } };

export type AttributesTabAsinFragment = { __typename?: 'ASIN', asin: string, canPublishConfidentialAttributes: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string }, canPublishNonConfidentialAttributes: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string }, canPublishSensitiveAttributes: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string } };

export type LastPublishedVersionsQueryVariables = Exact<{
  input: LastPublishedVersionsInput;
}>;


export type LastPublishedVersionsQuery = { __typename?: 'Query', lastPublishedVersions: Array<{ __typename?: 'DpAttribute', key: string, language: string, value: any, version: number, modifiedAt: string, modifiedBy: string, removed: boolean, lastPublishedVersion?: number | null, lastPublishedDate?: string | null }> };

export type PublishAttributesMutationVariables = Exact<{
  input: PublishAttributesInput;
}>;


export type PublishAttributesMutation = { __typename?: 'Mutation', publishAttributes: { __typename?: 'DpAttributesMutationResponse', code: string, message: string, success: boolean, succeeded: Array<{ __typename?: 'DpAttribute', key: string, language: string, version: number, value: any, modifiedAt: string, modifiedBy: string, removed: boolean, lastPublishedVersion?: number | null, lastPublishedDate?: string | null }>, failed: Array<{ __typename?: 'DpAttributeFailure', key: string, reason: string }> } };

export type SaveAttributesMutationVariables = Exact<{
  input: SaveAttributesInput;
}>;


export type SaveAttributesMutation = { __typename?: 'Mutation', saveAttributes: { __typename?: 'DpAttributesMutationResponse', code: string, message: string, success: boolean, succeeded: Array<{ __typename?: 'DpAttribute', key: string, language: string, value: any, version: number, modifiedAt: string, modifiedBy: string, removed: boolean, lastPublishedDate?: string | null, lastPublishedVersion?: number | null }>, failed: Array<{ __typename?: 'DpAttributeFailure', key: string, reason: string }>, asin?: { __typename?: 'ASIN', id: string, launchGating: { __typename?: 'ASINLaunchGating', attributeChecked: AsinLaunchGatingAttributeEnum, beyondLaunchDate: boolean, withinLaunchDate: boolean, launchDateThreshold: number, gatingAsin?: string | null } } | null } };

export type BundleAsinsFragment = { __typename: 'BundleAsins', bundleAsins: Array<{ __typename?: 'BundleAsin', bundleAsin: string, bundleName: string, image?: string | null, otherComponents: Array<string> }> };

export type ComponentAsinFragment = { __typename: 'ComponentAsin', bundleBaseComponent: Array<string>, bundleComponents: Array<string>, programName?: string | null, componentDescription: Array<{ __typename?: 'componentString', asin: string, data: string }>, componentQuantity: Array<{ __typename?: 'componentInt', asin: string, data: number }>, componentImage: Array<{ __typename?: 'componentString', asin: string, data: string }> };

export type BundleInfoTabQueryVariables = Exact<{
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
}>;


export type BundleInfoTabQuery = { __typename?: 'Query', bundleInfo: { __typename: 'BundleAsins', bundleAsins: Array<{ __typename?: 'BundleAsin', bundleAsin: string, bundleName: string, image?: string | null, otherComponents: Array<string> }> } | { __typename: 'ComponentAsin', bundleBaseComponent: Array<string>, bundleComponents: Array<string>, programName?: string | null, componentDescription: Array<{ __typename?: 'componentString', asin: string, data: string }>, componentQuantity: Array<{ __typename?: 'componentInt', asin: string, data: number }>, componentImage: Array<{ __typename?: 'componentString', asin: string, data: string }> } };

export type CampaignConfigIdFragment = { __typename?: 'CampaignConfiguration', id: string };

export type CampaignConfigIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type CampaignConfigIdsQuery = { __typename?: 'Query', campaignConfigurations: { __typename?: 'CampaignConfigurationConnection', nodes: Array<{ __typename?: 'CampaignConfiguration', id: string }> } };

export type TrafficCampaignRowFragment = { __typename?: 'TrafficCampaign', id: string, name: string, status: CampaignState, createdBy: string, schema: string, isArchived?: boolean | null, liveState?: LiveStateType | null, project: { __typename?: 'TrafficProject', id: string }, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', productLine: string, platform: string, language: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', scheduleType?: string | null, asins: Array<string>, platform?: string | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange' } | { __typename?: 'TrafficEventDateRange' } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', status?: { __typename?: 'StatusSummary', liveState: LiveStateType } | null }> } }> };

export type CampaignsTabTrafficProjectInfoFragment = { __typename?: 'TrafficProject', id: string, name: string, modifiedBy: string, modifiedAt: string, createdBy: string, createdAt: string, campaigns: { __typename?: 'TrafficProjectCampaigns_Connection', nodes: Array<{ __typename?: 'TrafficCampaign', id: string, name: string, status: CampaignState, createdBy: string, schema: string, isArchived?: boolean | null, liveState?: LiveStateType | null, project: { __typename?: 'TrafficProject', id: string }, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', productLine: string, platform: string, language: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', scheduleType?: string | null, asins: Array<string>, platform?: string | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange' } | { __typename?: 'TrafficEventDateRange' } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', status?: { __typename?: 'StatusSummary', liveState: LiveStateType } | null }> } }> }> } };

export type CampaignsTabTrafficProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  filterByView: CampaignFilterByViewInput;
}>;


export type CampaignsTabTrafficProjectQuery = { __typename?: 'Query', trafficProject: { __typename?: 'TrafficProject', id: string, name: string, modifiedBy: string, modifiedAt: string, createdBy: string, createdAt: string, campaigns: { __typename?: 'TrafficProjectCampaigns_Connection', nodes: Array<{ __typename?: 'TrafficCampaign', id: string, name: string, status: CampaignState, createdBy: string, schema: string, isArchived?: boolean | null, liveState?: LiveStateType | null, project: { __typename?: 'TrafficProject', id: string }, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', productLine: string, platform: string, language: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', scheduleType?: string | null, asins: Array<string>, platform?: string | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange' } | { __typename?: 'TrafficEventDateRange' } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', status?: { __typename?: 'StatusSummary', liveState: LiveStateType } | null }> } }> }> } } };

export type CopyDetailPageMutationVariables = Exact<{
  input: CopyDpInput;
}>;


export type CopyDetailPageMutation = { __typename?: 'Mutation', copyDetailPage: { __typename?: 'DpCopyMutationResponse', code: string, message: string, success: boolean, campaignCopyErrors: Array<string>, attributesSucceeded: Array<{ __typename?: 'DpAttributeCopyResponse', asin: string, key: string }>, attributesFailed: Array<{ __typename?: 'DpAttributeCopyFailure', asin: string, key: string, reason: string }>, pricingSucceeded: Array<{ __typename?: 'PricingInfoCopyResponse', asin: string, infoType: PricingEnum }>, pricingFailed: Array<{ __typename?: 'PricingInfoCopyFailure', asin: string, infoType: PricingEnum, reason: string }>, slatesSucceeded: Array<{ __typename?: 'SlateImageCopyResponse', asin: string, variant: string }>, slatesFailed: Array<{ __typename?: 'SlateImageCopyFailure', asin: string, variant: string, reason: string }> } };

export type AsinAccessQueryVariables = Exact<{
  input: AsinAccessInput;
}>;


export type AsinAccessQuery = { __typename?: 'Query', checkASINAccess: { __typename?: 'ASINAccessResponse', succeeded: Array<string>, failed: Array<string> } };

export type DpDataQueryVariables = Exact<{
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
}>;


export type DpDataQuery = { __typename?: 'Query', attributes: Array<{ __typename?: 'DpAttribute', key: string, value: any, removed: boolean, version: number, language: string }>, slates: Array<{ __typename?: 'SlateImage', assetId?: string | null, variant: string, removed: boolean }>, pricing: Array<{ __typename?: 'PricingInfo', infoType: PricingEnum, value: string }> };

export type LastPublishedPricingQueryVariables = Exact<{
  input: LastPublishedPricingInput;
}>;


export type LastPublishedPricingQuery = { __typename?: 'Query', lastPublishedPricing: Array<{ __typename?: 'PricingInfo', infoType: PricingEnum, value: string, version: number, modifiedAt: string, modifiedBy: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null }> };

export type PricingQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  marketplace: Scalars['String']['input'];
  asin: Scalars['String']['input'];
  isLaunchPermOn: Scalars['Boolean']['input'];
}>;


export type PricingQuery = { __typename?: 'Query', pricing: Array<{ __typename?: 'PricingInfo', modifiedAt: string, modifiedBy: string, version: number, infoType: PricingEnum, value: string, lastPublishedDate?: string | null, lastPublishedVersion?: number | null, publishResult?: { __typename?: 'DpPublishResult', status?: string | null, success: boolean, result: string } | null }> };

export type PricingTabAsinFragment = { __typename?: 'ASIN', asin: string, canPublishPricingAttributes: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string }, canPublishConfidentialAttributes: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string } };

export type PublishPricingMutationVariables = Exact<{
  input: PublishPricingInfoInput;
}>;


export type PublishPricingMutation = { __typename?: 'Mutation', publishPricing: { __typename?: 'PublishPricingInfoMutationResponse', code: string, message: string, success: boolean, succeeded: Array<{ __typename?: 'PricingInfo', modifiedAt: string, modifiedBy: string, version: number, infoType: PricingEnum, value: string, lastPublishedDate?: string | null, lastPublishedVersion?: number | null }>, failed: Array<{ __typename?: 'PublishPricingInfoFailure', reason: string, infoType: PricingEnum }> } };

export type SavePricingMutationVariables = Exact<{
  input: SavePricingInfoInput;
}>;


export type SavePricingMutation = { __typename?: 'Mutation', savePricing: { __typename?: 'SavePricingInfoMutationResponse', code: string, message: string, success: boolean, succeeded: Array<{ __typename?: 'PricingInfo', modifiedAt: string, modifiedBy: string, version: number, infoType: PricingEnum, value: string, lastPublishedDate?: string | null, lastPublishedVersion?: number | null }>, failed: Array<{ __typename?: 'SavePricingInfoFailure', reason: string, infoType: PricingEnum }> } };

export type ValidatePublishedPricingMutationVariables = Exact<{
  input: ValidatePublishedPricingInfoInput;
}>;


export type ValidatePublishedPricingMutation = { __typename?: 'Mutation', validatePublishedPricing: { __typename?: 'ValidatePublishedPricingInfoMutationResponse', code: string, success: boolean, message: string, publishedPricingInfos?: Array<{ __typename?: 'PricingInfo', infoType: PricingEnum, value: string }> | null } };

export type LastPublishedSlateVersionsQueryVariables = Exact<{
  input: LastPublishedSlateVersionsInput;
}>;


export type LastPublishedSlateVersionsQuery = { __typename?: 'Query', lastPublishedSlateVersions: Array<{ __typename?: 'SlateImage', variant: string, assetId?: string | null, filename?: string | null, url: string, version: number, modifiedAt: string, modifiedBy: string, removed: boolean, lastPublishedVersion?: number | null, lastPublishedDate?: string | null }> };

export type PublishSlatePlaceholdersMutationVariables = Exact<{
  input: SlatePlaceholderPublishInput;
}>;


export type PublishSlatePlaceholdersMutation = { __typename?: 'Mutation', publishSlatePlaceholders: { __typename?: 'PublishSlatePlaceholdersMutationResponse', code: string, success: boolean, message: string, shipmentId?: string | null, succeeded: Array<string>, failed: Array<string> } };

export type PublishSlatesMutationVariables = Exact<{
  input: SlatePublishInput;
}>;


export type PublishSlatesMutation = { __typename?: 'Mutation', publishSlateImage: { __typename?: 'PublishSlateMutationResponse', code: string, success: boolean, message: string, shipmentId?: string | null, succeeded: Array<{ __typename?: 'SlateImage', assetId?: string | null, url: string, filename?: string | null, modifiedAt: string, modifiedBy: string, lastPublishedDate?: string | null, lastPublishedVersion?: number | null, variant: string, version: number, removed: boolean }>, failed: Array<{ __typename?: 'SlateImageFailure', reason: string, variant: string }> } };

export type SaveSlatesMutationVariables = Exact<{
  input: SaveSlatesInput;
}>;


export type SaveSlatesMutation = { __typename?: 'Mutation', saveSlates: { __typename?: 'SaveSlatesMutationResponse', code: string, message: string, success: boolean, succeeded: Array<{ __typename?: 'SlateImage', assetId?: string | null, url: string, filename?: string | null, modifiedAt: string, modifiedBy: string, variant: string, version: number, removed: boolean, lastPublishedDate?: string | null, lastPublishedVersion?: number | null }>, failed: Array<{ __typename?: 'SlateImageFailure', reason: string, variant: string }> } };

export type SlatesQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  marketplace: Scalars['String']['input'];
  asin: Scalars['String']['input'];
  isLaunchPermOn: Scalars['Boolean']['input'];
}>;


export type SlatesQuery = { __typename?: 'Query', slates: Array<{ __typename?: 'SlateImage', assetId?: string | null, modifiedAt: string, modifiedBy: string, variant: string, filename?: string | null, lastPublishedDate?: string | null, lastPublishedVersion?: number | null, shipmentId?: string | null, version: number, url: string, isPublished?: boolean | null, removed: boolean, publishResult?: { __typename?: 'DpPublishResult', result: string, success: boolean } | null }> };

export type SlatesTabAsinFragment = { __typename?: 'ASIN', asin: string, canPublishSlates: { __typename?: 'CanActAllowedResponse', allowed: boolean } | { __typename?: 'CanActDisallowedResponse', allowed: boolean, reason: string } };

export type DeactivateOrDeleteExperimentMutationVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
}>;


export type DeactivateOrDeleteExperimentMutation = { __typename?: 'Mutation', deactivateOrDeleteExperiment: { __typename?: 'DeactivateOrDeleteExperimentMutationResponse', code: string, message: string, success: boolean, experiment?: { __typename?: 'DpExperimentDetails', activationDate?: string | null, deactivationDate?: string | null, dpbExperimentId: string, experimentType: string, mvesExperimentIds?: any | null, name: string, status: string, updatedAt: string, updatedBy: string } | null } };

export type FetchAndUpdateExperimentSummaryInfoMutationVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
  mvtExperimentId: Scalars['ID']['input'];
}>;


export type FetchAndUpdateExperimentSummaryInfoMutation = { __typename?: 'Mutation', fetchAndUpdateExperimentSummaryInfo: { __typename?: 'SummaryInfo', quipUrl?: string | null, lastUpdateDateTime?: string | null } };

export type UpdateExperimentDetailsMutationVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
  experiment: DpExperimentDetailsUpdateInput;
}>;


export type UpdateExperimentDetailsMutation = { __typename?: 'Mutation', updateExperiment: { __typename?: 'CreateOrUpdateExperimentMutationResponse', code: string, message: string, success: boolean, experiment?: { __typename?: 'DpExperimentDetails', activationDate?: string | null, deactivationDate?: string | null, contextualCohortType?: string | null, controlConfigurationType?: string | null, hashDimension?: string | null, createdAt: string, createdBy: string, description?: string | null, dpbExperimentId: string, experimentType: string, locales: Array<string>, marketplaces: Array<string>, mvesExperimentIds?: any | null, name: string, primaryAsin?: string | null, status: string, updatedAt: string, updatedBy: string, variationalAsins?: Array<string> | null, bullseyeSegments?: Array<{ __typename?: 'BullseyeSegmentInfo', segmentId: string, position: number, titleExclusions?: Array<number> | null, bulletExclusions?: Array<number> | null, landingImageExclusions?: Array<number> | null }> | null } | null } };

export type StartPublishExperimentMutationVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
}>;


export type StartPublishExperimentMutation = { __typename?: 'Mutation', startPublishExperiment: { __typename?: 'CommonMutationResponse', code: string, message: string, success: boolean } };

export type ActivateMvesExperimentMutationVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
  experimentActivationDate: Scalars['String']['input'];
  experimentDeactivationDate: Scalars['String']['input'];
}>;


export type ActivateMvesExperimentMutation = { __typename?: 'Mutation', activateMVESExperiment: { __typename?: 'CommonMutationResponse', code: string, message: string, success: boolean } };

export type BatchPreviewVariantsMutationVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  asin: Scalars['String']['input'];
}>;


export type BatchPreviewVariantsMutation = { __typename?: 'Mutation', batchPreviewVariants: { __typename?: 'CommonMutationResponse', code: string, message: string, success: boolean } };

export type DpExperimentAsinVariantsMapQueryVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  asins: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DpExperimentAsinVariantsMapQuery = { __typename?: 'Query', variantsMap: { __typename?: 'DpExperimentAsinVariantsMap', asinToVariantsMap?: any | null } };

export type CreateOrUpdateBulletsVariantMutationVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  variant: DpBulletsVariantInput;
}>;


export type CreateOrUpdateBulletsVariantMutation = { __typename?: 'Mutation', createOrUpdateBulletsVariant: { __typename?: 'CreateOrUpdateBulletsVariantMutationResponse', code: string, message: string, success: boolean, variant: { __typename?: 'DpBulletsVariant', lastPublishedDate?: string | null, lastPublishedVersion?: number | null, previewed: boolean, uniqueReferenceId: string, updatedAt: string, updatedBy: string, variantId: number, version: number, locale: string, bulletStrings: Array<string>, genaiBulletStrings?: Array<boolean> | null, publishResult?: { __typename?: 'DpPublishResult', result: string, status?: string | null, success: boolean } | null } } };

export type DeleteBulletsVariantMutationVariables = Exact<{
  asin: Scalars['String']['input'];
  dpbExperimentId: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  uniqueReferenceId: Scalars['ID']['input'];
}>;


export type DeleteBulletsVariantMutation = { __typename?: 'Mutation', deleteBulletsVariant: { __typename?: 'CommonMutationResponse', code: string, message: string, success: boolean } };

export type CreateOrUpdateLandingImageVariantMutationVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  variant: DpLandingImageVariantInput;
}>;


export type CreateOrUpdateLandingImageVariantMutation = { __typename?: 'Mutation', createOrUpdateLandingImageVariant: { __typename?: 'CreateOrUpdateLandingImageVariantMutationResponse', code: string, message: string, success: boolean, variant: { __typename?: 'DpLandingImageVariant', lastPublishedDate?: string | null, lastPublishedVersion?: number | null, previewed: boolean, uniqueReferenceId: string, updatedAt: string, updatedBy: string, variantId: number, version: number, assetId: string, mcVariant?: string | null, platform: DpLandingImagePlatform, shipmentId?: string | null, url?: string | null, publishResult?: { __typename?: 'DpPublishResult', result: string, status?: string | null, success: boolean } | null } } };

export type DeleteLandingImageVariantMutationVariables = Exact<{
  asin: Scalars['String']['input'];
  dpbExperimentId: Scalars['ID']['input'];
  platform: DpLandingImagePlatform;
  uniqueReferenceId: Scalars['ID']['input'];
}>;


export type DeleteLandingImageVariantMutation = { __typename?: 'Mutation', deleteLandingImageVariant: { __typename?: 'CommonMutationResponse', code: string, message: string, success: boolean } };

export type CreateOrUpdateTitleVariantMutationVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  variant: DpTitleVariantInput;
}>;


export type CreateOrUpdateTitleVariantMutation = { __typename?: 'Mutation', createOrUpdateTitleVariant: { __typename?: 'CreateOrUpdateTitleVariantMutationResponse', code: string, message: string, success: boolean, variant: { __typename?: 'DpTitleVariant', lastPublishedDate?: string | null, lastPublishedVersion?: number | null, previewed: boolean, uniqueReferenceId: string, updatedAt: string, updatedBy: string, variantId: number, version: number, locale: string, titleString: string, genaiTitleString?: boolean | null, publishResult?: { __typename?: 'DpPublishResult', result: string, status?: string | null, success: boolean } | null } } };

export type DeleteTitleVariantMutationVariables = Exact<{
  asin: Scalars['String']['input'];
  dpbExperimentId: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  uniqueReferenceId: Scalars['ID']['input'];
}>;


export type DeleteTitleVariantMutation = { __typename?: 'Mutation', deleteTitleVariant: { __typename?: 'CommonMutationResponse', code: string, message: string, success: boolean } };

export type TitleVariantDataFragment = { __typename?: 'DpTitleVariant', lastPublishedDate?: string | null, lastPublishedVersion?: number | null, previewed: boolean, uniqueReferenceId: string, updatedAt: string, updatedBy: string, variantId: number, version: number, locale: string, titleString: string, genaiTitleString?: boolean | null, publishResult?: { __typename?: 'DpPublishResult', result: string, status?: string | null, success: boolean } | null };

export type BulletsVariantDataFragment = { __typename?: 'DpBulletsVariant', lastPublishedDate?: string | null, lastPublishedVersion?: number | null, previewed: boolean, uniqueReferenceId: string, updatedAt: string, updatedBy: string, variantId: number, version: number, locale: string, bulletStrings: Array<string>, genaiBulletStrings?: Array<boolean> | null, publishResult?: { __typename?: 'DpPublishResult', result: string, status?: string | null, success: boolean } | null };

export type LandingImageVariantDataFragment = { __typename?: 'DpLandingImageVariant', lastPublishedDate?: string | null, lastPublishedVersion?: number | null, previewed: boolean, uniqueReferenceId: string, updatedAt: string, updatedBy: string, variantId: number, version: number, assetId: string, mcVariant?: string | null, platform: DpLandingImagePlatform, shipmentId?: string | null, url?: string | null, publishResult?: { __typename?: 'DpPublishResult', result: string, status?: string | null, success: boolean } | null };

export type DpExperimentAsinVariantsQueryVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  asin: Scalars['String']['input'];
}>;


export type DpExperimentAsinVariantsQuery = { __typename?: 'Query', variants: { __typename?: 'DpExperimentAsinVariants', titles: Array<{ __typename?: 'DpTitleVariant', lastPublishedDate?: string | null, lastPublishedVersion?: number | null, previewed: boolean, uniqueReferenceId: string, updatedAt: string, updatedBy: string, variantId: number, version: number, locale: string, titleString: string, genaiTitleString?: boolean | null, publishResult?: { __typename?: 'DpPublishResult', result: string, status?: string | null, success: boolean } | null }>, bullets: Array<{ __typename?: 'DpBulletsVariant', lastPublishedDate?: string | null, lastPublishedVersion?: number | null, previewed: boolean, uniqueReferenceId: string, updatedAt: string, updatedBy: string, variantId: number, version: number, locale: string, bulletStrings: Array<string>, genaiBulletStrings?: Array<boolean> | null, publishResult?: { __typename?: 'DpPublishResult', result: string, status?: string | null, success: boolean } | null }>, landingImages: Array<{ __typename?: 'DpLandingImageVariant', lastPublishedDate?: string | null, lastPublishedVersion?: number | null, previewed: boolean, uniqueReferenceId: string, updatedAt: string, updatedBy: string, variantId: number, version: number, assetId: string, mcVariant?: string | null, platform: DpLandingImagePlatform, shipmentId?: string | null, url?: string | null, publishResult?: { __typename?: 'DpPublishResult', result: string, status?: string | null, success: boolean } | null }> } };

export type AsinToCatalogImageUrlsMapQueryVariables = Exact<{
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
}>;


export type AsinToCatalogImageUrlsMapQuery = { __typename?: 'Query', asinToCatalogImageUrlsMap: { __typename?: 'AsinToCatalogImageUrlsMap', asinToCatalogImageUrlsMap?: any | null } };

export type ExperimentAsinMetadataQueryVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
}>;


export type ExperimentAsinMetadataQuery = { __typename?: 'Query', experimentAsinMetadata: { __typename?: 'ExperimentAsinMetadata', isDevicesExperiment: boolean } };

export type DpExperimentAsinsQueryVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
}>;


export type DpExperimentAsinsQuery = { __typename?: 'Query', dpExperiment: { __typename?: 'DpExperimentDetails', primaryAsin?: string | null, variationalAsins?: Array<string> | null } };

export type MvesCatalogFeatureBulletsForAsinsQueryVariables = Exact<{
  asinList: Array<Scalars['String']['input']> | Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type MvesCatalogFeatureBulletsForAsinsQuery = { __typename?: 'Query', mvesCatalogFeatureBulletsForAsins: Array<{ __typename?: 'AsinAndCatalogFeatureBullets', asin: string, featureBullets: Array<string> }> };

export type MvesCatalogImageVariantForAsinsQueryVariables = Exact<{
  asinList: Array<Scalars['String']['input']> | Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
}>;


export type MvesCatalogImageVariantForAsinsQuery = { __typename?: 'Query', mvesVariantImagesForAsins: Array<{ __typename?: 'AsinAndCatalogVariantImages', asin: string, images?: any | null }> };

export type MvesCatalogTitlesQueryVariables = Exact<{
  asinList: Array<Scalars['String']['input']> | Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type MvesCatalogTitlesQuery = { __typename?: 'Query', mvesCatalogTitles: Array<{ __typename?: 'AsinAndCatalogTitle', asin: string, title: string, marketplace: string, locale: string }> };

export type AsinsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filters?: InputMaybe<AsinFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AsinsQuery = { __typename?: 'Query', asins: { __typename?: 'QueryAsins_Connection', totalCount: number, nodes: Array<{ __typename?: 'ASIN', asin: string, party: string, type: string, description?: string | null, marketplace: { __typename?: 'Marketplace', id: string, obfuscatedMarketplaceId: string, country: string }, program?: { __typename?: 'Program', id: string, name: string } | null, productLine?: { __typename?: 'ProductLine2', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type ProductLinesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filters?: InputMaybe<ProductLineFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductLinesQuery = { __typename?: 'Query', productLines: { __typename?: 'QueryProductLines_Connection', totalCount: number, nodes: Array<{ __typename?: 'ProductLine2', id: string, name: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type ProgramsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filters?: InputMaybe<ProgramFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProgramsQuery = { __typename?: 'Query', programs: { __typename?: 'QueryPrograms_Connection', totalCount: number, nodes: Array<{ __typename?: 'Program', id: string, name: string, programId: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type VariationalAsinHierarchyQueryVariables = Exact<{
  asins: Array<Scalars['String']['input']> | Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
  getTitles: Scalars['Boolean']['input'];
}>;


export type VariationalAsinHierarchyQuery = { __typename?: 'Query', variationalAsinHierarchy: Array<{ __typename?: 'VariationalAsin', asin: string, title?: string | null, childAsins?: Array<{ __typename?: 'VariationalAsin', asin: string, title?: string | null, childAsins?: Array<{ __typename?: 'VariationalAsin', asin: string, title?: string | null }> | null }> | null }> };

export type CreateExperimentMutationVariables = Exact<{
  input: DpExperimentDetailsCreateInput;
}>;


export type CreateExperimentMutation = { __typename?: 'Mutation', createExperiment: { __typename?: 'CreateOrUpdateExperimentMutationResponse', code: string, message: string, success: boolean, experiment?: { __typename?: 'DpExperimentDetails', dpbExperimentId: string, experimentType: string, name: string } | null } };

export type CreateExperimentV2MutationVariables = Exact<{
  input: DpExperimentDetailsCreateInputV2;
}>;


export type CreateExperimentV2Mutation = { __typename?: 'Mutation', createExperimentV2: { __typename?: 'CreateExperimentV2MutationResponse', experimentExists: boolean, experiment?: { __typename?: 'DpExperimentDetailsV2', id: string, experimentType: string } | null } };

export type CumulativeGainMetricsQueryVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type CumulativeGainMetricsQuery = { __typename?: 'Query', dpExperiment: { __typename?: 'DpExperimentDetails', cumulativeGainMetrics?: Array<{ __typename?: 'CumulativeGainMetric', context?: string | null, combination: string, date: string, experimentId: string, impressionCount: number, lowerBoundPCG: number, meanPCG: number, pvaluePCG: number, successCount: number, treatment: string, upperBoundPCG: number, totalSuccessCount: number, totalImpressionCount: number, rank?: number | null }> | null } };

export type DeactivateExperimentV2MutationVariables = Exact<{
  input: DpExperimentDetailsDeactivateInputV2;
}>;


export type DeactivateExperimentV2Mutation = { __typename?: 'Mutation', deactivateExperimentV2: { __typename?: 'UpdateExperimentV2MutationResponse', experiment?: { __typename?: 'DpExperimentDetailsV2', id: string, experimentType: string, updatedAt: string, updatedBy: string, createdAt: string, createdBy: string, status: string, version: number, program: { __typename?: 'Program', id: string, programId: string, name: string }, productLine: { __typename?: 'ProductLine2', id: string, productLineId: string, name: string }, marketplaceExperimentConfig: Array<{ __typename?: 'MarketplaceExperimentConfig', id: string, locales: Array<string>, activationDate?: string | null, deactivationDate?: string | null, primaryAsin: string, contextualCohortType?: DpExperimentContextualCohortType | null, status: string, marketplace: { __typename?: 'Marketplace', id: string, obfuscatedMarketplaceId: string, country: string }, asinConfigs: Array<{ __typename?: 'AsinExperimentConfig', asin: string, asinConfigId: string, featureVariants: { __typename?: 'DpExperimentAsinVariantsV2', titles: Array<{ __typename?: 'DpTitleVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, locale: string, titleString: string }>, bullets: Array<{ __typename?: 'DpBulletsVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, locale: string, bulletStrings: Array<string> }>, landingImages: Array<{ __typename?: 'DpLandingImageVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, assetId: string, url?: string | null, platform: DpLandingImagePlatform, mcVariant?: string | null, locale: string, shipmentId?: string | null }> } }>, bullseyeSegments?: Array<{ __typename?: 'BullseyeSegmentInfoV2', bullseyeSegmentId: string, position: number, titleExclusions?: Array<number> | null, bulletExclusions?: Array<number> | null, landingImageExclusions?: Array<number> | null }> | null }> } | null } };

export type DeleteFeatureVariantV2MutationVariables = Exact<{
  experimentId: Scalars['ID']['input'];
  marketplaceId: Scalars['ID']['input'];
  variants: Array<DpVariantDeleteInputV2> | DpVariantDeleteInputV2;
}>;


export type DeleteFeatureVariantV2Mutation = { __typename?: 'Mutation', deleteVariantsV2: { __typename?: 'CreateOrUpdateVariantMutationResponse', asinConfigs: Array<{ __typename?: 'AsinExperimentConfig', asin: string, asinConfigId: string, featureVariants: { __typename?: 'DpExperimentAsinVariantsV2', titles: Array<{ __typename?: 'DpTitleVariantV2', variantId: string, variantPosition: number, uniqueReferenceId: string, locale: string, titleString: string }> } }> } };

export type DpExperimentGenerateExperimentContentQueryVariables = Exact<{
  marketplace: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  asin: Scalars['String']['input'];
  variantType: Scalars['String']['input'];
  context: DpExperimentGeneratedExperimentContentContextInput;
}>;


export type DpExperimentGenerateExperimentContentQuery = { __typename?: 'Query', generateExperimentContent: { __typename?: 'DpExperimentGeneratedExperimentContentResponse', generatedContent?: Array<string> | null, errorMessage?: string | null } };

export type HashExperimentQueryVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
}>;


export type HashExperimentQuery = { __typename?: 'Query', hashExperiment: { __typename?: 'DpExperimentHashResponse', hash?: string | null } };

export type DpExperimentQueryVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
}>;


export type DpExperimentQuery = { __typename?: 'Query', dpExperiment: { __typename?: 'DpExperimentDetails', activationDate?: string | null, deactivationDate?: string | null, contextualCohortType?: string | null, controlConfigurationType?: string | null, hashDimension?: string | null, createdAt: string, createdBy: string, description?: string | null, dpbExperimentId: string, experimentType: string, locales: Array<string>, marketplaces: Array<string>, mvesExperimentIds?: any | null, mvesPublishResults?: any | null, name: string, primaryAsin?: string | null, isPrimaryParent?: boolean | null, status: string, updatedAt: string, updatedBy: string, variationalAsins?: Array<string> | null, lastPublishedExperimentHash?: string | null, summaryInfos?: any | null, mvesIotalabId?: string | null, bullseyeSegments?: Array<{ __typename?: 'BullseyeSegmentInfo', segmentId: string, position: number, titleExclusions?: Array<number> | null, bulletExclusions?: Array<number> | null, landingImageExclusions?: Array<number> | null, combination?: boolean | null }> | null } };

export type DpExperimentV2QueryVariables = Exact<{
  experimentId: Scalars['ID']['input'];
}>;


export type DpExperimentV2Query = { __typename?: 'Query', dpExperimentV2: { __typename?: 'DpExperimentDetailsV2', id: string, experimentType: string, updatedAt: string, updatedBy: string, createdAt: string, createdBy: string, status: string, version: number, mvesExperimentId?: string | null, program: { __typename?: 'Program', id: string, programId: string, name: string }, productLine: { __typename?: 'ProductLine2', id: string, productLineId: string, name: string }, marketplaceExperimentConfig: Array<{ __typename?: 'MarketplaceExperimentConfig', contextualCohortType?: DpExperimentContextualCohortType | null, status: string, validationErrors?: Array<string> | null, iotalabReferenceId?: string | null, id: string, locales: Array<string>, primaryAsin: string, activationDate?: string | null, deactivationDate?: string | null, priorConfig?: { __typename?: 'MarketplaceExperimentConfig', iotalabReferenceId?: string | null, id: string, locales: Array<string>, primaryAsin: string, contextualCohortType?: DpExperimentContextualCohortType | null, activationDate?: string | null, deactivationDate?: string | null, status: string, marketplace: { __typename?: 'Marketplace', id: string, obfuscatedMarketplaceId: string, country: string }, asinConfigs: Array<{ __typename?: 'AsinExperimentConfig', asin: string, asinConfigId: string, featureVariants: { __typename?: 'DpExperimentAsinVariantsV2', titles: Array<{ __typename?: 'DpTitleVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, locale: string, titleString: string, status?: DpExperimentVariantStatus | null }>, bullets: Array<{ __typename?: 'DpBulletsVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, locale: string, bulletStrings: Array<string>, status?: DpExperimentVariantStatus | null }>, landingImages: Array<{ __typename?: 'DpLandingImageVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, assetId: string, url?: string | null, platform: DpLandingImagePlatform, mcVariant?: string | null, locale: string, shipmentId?: string | null, status?: DpExperimentVariantStatus | null }> } }>, bullseyeSegments?: Array<{ __typename?: 'BullseyeSegmentInfoV2', bullseyeSegmentId: string, position: number, titleExclusions?: Array<number> | null, bulletExclusions?: Array<number> | null, landingImageExclusions?: Array<number> | null }> | null } | null, bullseyeSegments?: Array<{ __typename?: 'BullseyeSegmentInfoV2', bullseyeSegmentId: string, position: number, titleExclusions?: Array<number> | null, bulletExclusions?: Array<number> | null, landingImageExclusions?: Array<number> | null }> | null, marketplace: { __typename?: 'Marketplace', id: string, obfuscatedMarketplaceId: string, country: string }, asinConfigs: Array<{ __typename?: 'AsinExperimentConfig', asin: string, asinConfigId: string, featureVariants: { __typename?: 'DpExperimentAsinVariantsV2', titles: Array<{ __typename?: 'DpTitleVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, locale: string, titleString: string, status?: DpExperimentVariantStatus | null }>, bullets: Array<{ __typename?: 'DpBulletsVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, locale: string, bulletStrings: Array<string>, status?: DpExperimentVariantStatus | null }>, landingImages: Array<{ __typename?: 'DpLandingImageVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, assetId: string, url?: string | null, platform: DpLandingImagePlatform, mcVariant?: string | null, locale: string, shipmentId?: string | null, status?: DpExperimentVariantStatus | null }> } }> }> } };

export type DpExperimentsQueryVariables = Exact<{ [key: string]: never; }>;


export type DpExperimentsQuery = { __typename?: 'Query', dpExperiments: Array<{ __typename?: 'DpExperimentDetails', productLine?: string | null, program?: string | null, primaryAsin?: string | null, activationDate?: string | null, deactivationDate?: string | null, createdAt: string, createdBy: string, description?: string | null, dpbExperimentId: string, experimentType: string, marketplaces: Array<string>, locales: Array<string>, name: string, status: string, updatedAt: string, updatedBy: string, mvesExperimentIds?: any | null }> };

export type DpExperimentsV2QueryVariables = Exact<{ [key: string]: never; }>;


export type DpExperimentsV2Query = { __typename?: 'Query', dpExperimentsV2: Array<{ __typename?: 'DpExperimentDetailsV2', id: string, version: number, status: string, experimentType: string, createdAt: string, createdBy: string, updatedAt: string, updatedBy: string, program: { __typename?: 'Program', id: string, programId: string, name: string }, productLine: { __typename?: 'ProductLine2', id: string, name: string, productLineId: string }, marketplaceExperimentConfig: Array<{ __typename?: 'MarketplaceExperimentConfig', id: string, locales: Array<string>, primaryAsin: string, contextualCohortType?: DpExperimentContextualCohortType | null, activationDate?: string | null, deactivationDate?: string | null, status: string, marketplace: { __typename?: 'Marketplace', id: string, obfuscatedMarketplaceId: string, country: string }, asinConfigs: Array<{ __typename?: 'AsinExperimentConfig', asin: string, asinConfigId: string }> }> }> };

export type DuplicateExperimentMutationVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
}>;


export type DuplicateExperimentMutation = { __typename?: 'Mutation', duplicateExperiment: { __typename?: 'DpDuplicateExperimentResponse', dpbExperimentId?: string | null, experimentType?: string | null, code: string, message: string, success: boolean } };

export type MarketplaceExperimentConfigFragmentFragment = { __typename?: 'MarketplaceExperimentConfig', id: string, locales: Array<string>, primaryAsin: string, contextualCohortType?: DpExperimentContextualCohortType | null, activationDate?: string | null, deactivationDate?: string | null, status: string, marketplace: { __typename?: 'Marketplace', id: string, obfuscatedMarketplaceId: string, country: string }, asinConfigs: Array<{ __typename?: 'AsinExperimentConfig', asin: string, asinConfigId: string, featureVariants: { __typename?: 'DpExperimentAsinVariantsV2', titles: Array<{ __typename?: 'DpTitleVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, locale: string, titleString: string, status?: DpExperimentVariantStatus | null }>, bullets: Array<{ __typename?: 'DpBulletsVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, locale: string, bulletStrings: Array<string>, status?: DpExperimentVariantStatus | null }>, landingImages: Array<{ __typename?: 'DpLandingImageVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, assetId: string, url?: string | null, platform: DpLandingImagePlatform, mcVariant?: string | null, locale: string, shipmentId?: string | null, status?: DpExperimentVariantStatus | null }> } }>, bullseyeSegments?: Array<{ __typename?: 'BullseyeSegmentInfoV2', bullseyeSegmentId: string, position: number, titleExclusions?: Array<number> | null, bulletExclusions?: Array<number> | null, landingImageExclusions?: Array<number> | null }> | null };

export type MvesCatalogFeatureBulletsQueryVariables = Exact<{
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type MvesCatalogFeatureBulletsQuery = { __typename?: 'Query', mvesCatalogFeatureBullets: { __typename?: 'AsinAndCatalogFeatureBullets', featureBullets: Array<string> } };

export type MvesCatalogTitleQueryVariables = Exact<{
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type MvesCatalogTitleQuery = { __typename?: 'Query', mvesCatalogTitle: { __typename?: 'AsinAndCatalogTitle', title: string, locale: string, marketplace: string } };

export type MvesIotalabIdQueryVariables = Exact<{
  dpbExperimentId: Scalars['ID']['input'];
  experimentType: Scalars['String']['input'];
}>;


export type MvesIotalabIdQuery = { __typename?: 'Query', dpExperiment: { __typename?: 'DpExperimentDetails', mvesIotalabId?: string | null } };

export type MvesVariationalAsinsQueryVariables = Exact<{
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
}>;


export type MvesVariationalAsinsQuery = { __typename?: 'Query', mvesVariationalAsins: Array<{ __typename?: 'AsinAndCatalogTitleWithParentFlag', asin: string, title: string, isParent: boolean }> };

export type PublishExperimentV2MutationVariables = Exact<{
  input: DpExperimentDetailsPublishInputV2;
}>;


export type PublishExperimentV2Mutation = { __typename?: 'Mutation', publishExperimentV2: { __typename?: 'DpExperimentDetailsV2', id: string, experimentType: string, updatedAt: string, updatedBy: string, createdAt: string, createdBy: string, status: string, version: number, program: { __typename?: 'Program', id: string, programId: string, name: string }, productLine: { __typename?: 'ProductLine2', id: string, productLineId: string, name: string }, marketplaceExperimentConfig: Array<{ __typename?: 'MarketplaceExperimentConfig', id: string, locales: Array<string>, activationDate?: string | null, deactivationDate?: string | null, primaryAsin: string, contextualCohortType?: DpExperimentContextualCohortType | null, status: string, marketplace: { __typename?: 'Marketplace', id: string, obfuscatedMarketplaceId: string, country: string }, asinConfigs: Array<{ __typename?: 'AsinExperimentConfig', asin: string, asinConfigId: string, featureVariants: { __typename?: 'DpExperimentAsinVariantsV2', titles: Array<{ __typename?: 'DpTitleVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, locale: string, titleString: string }>, bullets: Array<{ __typename?: 'DpBulletsVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, locale: string, bulletStrings: Array<string> }>, landingImages: Array<{ __typename?: 'DpLandingImageVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, assetId: string, url?: string | null, platform: DpLandingImagePlatform, mcVariant?: string | null, locale: string, shipmentId?: string | null }> } }>, bullseyeSegments?: Array<{ __typename?: 'BullseyeSegmentInfoV2', bullseyeSegmentId: string, position: number, titleExclusions?: Array<number> | null, bulletExclusions?: Array<number> | null, landingImageExclusions?: Array<number> | null }> | null }> } };

export type UpdateBulletVariantMutationV2MutationVariables = Exact<{
  experimentId: Scalars['ID']['input'];
  marketplaceId: Scalars['String']['input'];
  variants: Array<DpBulletsVariantInputV2> | DpBulletsVariantInputV2;
}>;


export type UpdateBulletVariantMutationV2Mutation = { __typename?: 'Mutation', createOrUpdateBulletsVariantV2: { __typename?: 'CreateOrUpdateVariantMutationResponse', asinConfigs: Array<{ __typename?: 'AsinExperimentConfig', asin: string, asinConfigId: string, featureVariants: { __typename?: 'DpExperimentAsinVariantsV2', bullets: Array<{ __typename?: 'DpBulletsVariantV2', variantId: string, variantPosition: number, uniqueReferenceId: string, locale: string, bulletStrings: Array<string> }> } }> } };

export type UpdateImageVariantMutationV2MutationVariables = Exact<{
  experimentId: Scalars['ID']['input'];
  marketplaceId: Scalars['String']['input'];
  variants: Array<DpLandingImageVariantInputV2> | DpLandingImageVariantInputV2;
}>;


export type UpdateImageVariantMutationV2Mutation = { __typename?: 'Mutation', createOrUpdateLandingImageVariantV2: { __typename?: 'CreateOrUpdateVariantMutationResponse', asinConfigs: Array<{ __typename?: 'AsinExperimentConfig', asin: string, asinConfigId: string, featureVariants: { __typename?: 'DpExperimentAsinVariantsV2', landingImages: Array<{ __typename?: 'DpLandingImageVariantV2', assetId: string, url?: string | null, platform: DpLandingImagePlatform }> } }> } };

export type UpdateExperimentV2MutationVariables = Exact<{
  input: DpExperimentDetailsUpdateInputV2;
}>;


export type UpdateExperimentV2Mutation = { __typename?: 'Mutation', updateExperimentV2: { __typename?: 'UpdateExperimentV2MutationResponse', experiment?: { __typename?: 'DpExperimentDetailsV2', id: string, experimentType: string, updatedAt: string, updatedBy: string, createdAt: string, createdBy: string, status: string, version: number, program: { __typename?: 'Program', id: string, programId: string, name: string }, productLine: { __typename?: 'ProductLine2', id: string, productLineId: string, name: string }, marketplaceExperimentConfig: Array<{ __typename?: 'MarketplaceExperimentConfig', locales: Array<string>, activationDate?: string | null, deactivationDate?: string | null, primaryAsin: string, contextualCohortType?: DpExperimentContextualCohortType | null, status: string, marketplace: { __typename?: 'Marketplace', id: string, obfuscatedMarketplaceId: string, country: string }, asinConfigs: Array<{ __typename?: 'AsinExperimentConfig', asin: string, asinConfigId: string, featureVariants: { __typename?: 'DpExperimentAsinVariantsV2', titles: Array<{ __typename?: 'DpTitleVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, locale: string, titleString: string }>, bullets: Array<{ __typename?: 'DpBulletsVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, locale: string, bulletStrings: Array<string> }>, landingImages: Array<{ __typename?: 'DpLandingImageVariantV2', variantId: string, variantPosition: number, variantName: string, uniqueReferenceId: string, updatedBy: string, updatedAt: string, lastPublishedVersion?: number | null, lastPublishedDate?: string | null, previewed: boolean, assetId: string, url?: string | null, platform: DpLandingImagePlatform, mcVariant?: string | null, locale: string, shipmentId?: string | null }> } }>, bullseyeSegments?: Array<{ __typename?: 'BullseyeSegmentInfoV2', bullseyeSegmentId: string, position: number, titleExclusions?: Array<number> | null, bulletExclusions?: Array<number> | null, landingImageExclusions?: Array<number> | null }> | null }> } | null } };

export type UpdateTitleVariantMutationV2MutationVariables = Exact<{
  experimentId: Scalars['ID']['input'];
  marketplaceId: Scalars['String']['input'];
  variants: Array<DpTitleVariantInputV2> | DpTitleVariantInputV2;
}>;


export type UpdateTitleVariantMutationV2Mutation = { __typename?: 'Mutation', createOrUpdateTitleVariantV2: { __typename?: 'CreateOrUpdateVariantMutationResponse', asinConfigs: Array<{ __typename?: 'AsinExperimentConfig', asin: string, asinConfigId: string, featureVariants: { __typename?: 'DpExperimentAsinVariantsV2', titles: Array<{ __typename?: 'DpTitleVariantV2', variantId: string, variantPosition: number, uniqueReferenceId: string, locale: string, titleString: string }> } }> } };

export type JourneysRedirectHandlerQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  campaignId: Scalars['ID']['input'];
}>;


export type JourneysRedirectHandlerQuery = { __typename?: 'Query', trafficCampaign: { __typename?: 'TrafficCampaign', id: string, schema: string } };

export type TwisterPlusAsinsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filters?: InputMaybe<AsinFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TwisterPlusAsinsQuery = { __typename?: 'Query', asins: { __typename?: 'QueryAsins_Connection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes: Array<{ __typename?: 'ASIN', id: string, asin: string, description?: string | null, party: string, type: string, marketplace: { __typename?: 'Marketplace', id: string, obfuscatedMarketplaceId: string, country: string }, program?: { __typename?: 'Program', id: string, name: string } | null, productLine?: { __typename?: 'ProductLine2', id: string, name: string } | null }> } };

export type BundleAsinsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filters?: InputMaybe<AsinFilterInput>;
  bundlesFirst2: Scalars['Int']['input'];
}>;


export type BundleAsinsQuery = { __typename?: 'Query', asins: { __typename?: 'QueryAsins_Connection', nodes: Array<{ __typename?: 'ASIN', standaloneAsin: string, bundles: { __typename?: 'ASINBundles_Connection', nodes: Array<{ __typename?: 'ASIN', id: string, asin: string, description?: string | null, type: string }> } }> } };

export type MerchandizedBundlesQueryVariables = Exact<{
  marketplace: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
  keys: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MerchandizedBundlesQuery = { __typename?: 'Query', merchandizedBundles: Array<{ __typename?: 'MerchandizedBundleConfig', id: string, lastPublishedDate?: string | null, lastPublishedVersion?: number | null, modifiedAt: string, modifiedBy: string, version: number, publishResult?: { __typename?: 'DpPublishResult', status?: string | null, result: string, errors?: Array<string> | null, success: boolean } | null, value: { __typename?: 'MerchandizedBundleConfigInfo', asinTypes?: Array<AsinTypes> | null, bullseye?: string | null, language: Array<string>, variationName?: string | null, bundleConfigs: Array<{ __typename?: 'MerchandizedBundleConfigs', detailPageAsin?: string | null, bundles: Array<{ __typename?: 'MerchandizedBundles', asin?: string | null, shortTitle: Array<{ __typename?: 'MerchandizedBundleShortTitle', locale?: string | null, title?: string | null }> }> }>, weblab: { __typename?: 'MerchandizedBundleWeblab', weblabTreatment?: string | null, weblabName?: string | null, validDateTo?: string | null, validDateFrom?: string | null } } }> };

export type ProductIdsToProgramsQueryVariables = Exact<{
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ProductIdsToProgramsQuery = { __typename?: 'Query', productIdsToPrograms: { __typename?: 'ProductIdsToProgramsOutput', programs: Array<{ __typename?: 'Program', id: string, name: string, programId: string }> } };

export type SaveMerchandizedBundlesMutationVariables = Exact<{
  input: SaveMerchandizedBundleInput;
}>;


export type SaveMerchandizedBundlesMutation = { __typename?: 'Mutation', saveMerchandizedBundles: { __typename?: 'MerchandizedBundleMutationResponse', failed: Array<{ __typename?: 'MerchandizedBundleFailure', reason?: string | null, id: string }>, succeeded: Array<{ __typename?: 'MerchandizedBundleConfig', id: string, lastPublishedDate?: string | null, lastPublishedVersion?: number | null, modifiedAt: string, modifiedBy: string, version: number, publishResult?: { __typename?: 'DpPublishResult', success: boolean, status?: string | null, result: string, errors?: Array<string> | null } | null, value: { __typename?: 'MerchandizedBundleConfigInfo', asinTypes?: Array<AsinTypes> | null, variationName?: string | null, language: Array<string>, bullseye?: string | null, weblab: { __typename?: 'MerchandizedBundleWeblab', weblabTreatment?: string | null, weblabName?: string | null, validDateTo?: string | null, validDateFrom?: string | null }, bundleConfigs: Array<{ __typename?: 'MerchandizedBundleConfigs', detailPageAsin?: string | null, bundles: Array<{ __typename?: 'MerchandizedBundles', asin?: string | null, shortTitle: Array<{ __typename?: 'MerchandizedBundleShortTitle', locale?: string | null, title?: string | null }> }> }> } }> } };

export type TcPreviewCampaignFragment = { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, schemaVersion: number, thumbnailURL?: string | null, globalContent?: any | null, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', active: boolean, id: string, content: any, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, language: string, platform: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', scheduleType?: string | null, asins: Array<string>, slots: Array<string>, platform?: string | null, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, additionalIncludes: any, additionalExcludes: any, categoryNode?: Array<string> | null, containerId?: any | null, containerType?: any | null, languages: Array<string>, pageId?: string | null, pageType?: string | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> } }>, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string } | null };

export type TcPreviewFlavorFragment = { __typename?: 'TrafficCampaignFlavor', active: boolean, id: string, content: any, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, language: string, platform: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', scheduleType?: string | null, asins: Array<string>, slots: Array<string>, platform?: string | null, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, additionalIncludes: any, additionalExcludes: any, categoryNode?: Array<string> | null, containerId?: any | null, containerType?: any | null, languages: Array<string>, pageId?: string | null, pageType?: string | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> } };

export type TcPreviewPlacementFragment = { __typename?: 'TrafficCampaignPlacement', id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', scheduleType?: string | null, asins: Array<string>, slots: Array<string>, platform?: string | null, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, additionalIncludes: any, additionalExcludes: any, categoryNode?: Array<string> | null, containerId?: any | null, containerType?: any | null, languages: Array<string>, pageId?: string | null, pageType?: string | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } };

export type TcPreviewEligibilityCriteriaFragment = { __typename?: 'TrafficEligibilityCriteria', scheduleType?: string | null, asins: Array<string>, slots: Array<string>, platform?: string | null, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, additionalIncludes: any, additionalExcludes: any, categoryNode?: Array<string> | null, containerId?: any | null, containerType?: any | null, languages: Array<string>, pageId?: string | null, pageType?: string | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } };

export type TrafficCampaignsForProductQueryVariables = Exact<{
  trafficProjectId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  includeRelatedProgramGhostProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TrafficCampaignsForProductQuery = { __typename?: 'Query', trafficProject: { __typename?: 'TrafficProject', id: string, campaigns: { __typename?: 'TrafficProjectCampaigns_Connection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes: Array<{ __typename?: 'TrafficCampaign', id: string, name: string, schema: string, schemaVersion: number, thumbnailURL?: string | null, globalContent?: any | null, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', active: boolean, id: string, content: any, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, language: string, platform: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', scheduleType?: string | null, asins: Array<string>, slots: Array<string>, platform?: string | null, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, additionalIncludes: any, additionalExcludes: any, categoryNode?: Array<string> | null, containerId?: any | null, containerType?: any | null, languages: Array<string>, pageId?: string | null, pageType?: string | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> } }>, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string } | null }> } } };

export type PlvProgramsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filters?: InputMaybe<ProgramFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
  sortOptions?: InputMaybe<Array<ProgramSortInput> | ProgramSortInput>;
}>;


export type PlvProgramsQuery = { __typename?: 'Query', programs: { __typename?: 'QueryPrograms_Connection', totalCount: number, nodes: Array<{ __typename?: 'Program', id: string, name: string, programId: string, asins: { __typename?: 'ProgramAsins_Connection', totalCount: number } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type NavigateToAsinSearchProductIdErrorFragment = { __typename?: 'ProductIdQueryResponse', error?: string | null, code?: string | null };

export type NavigateToAsinSearchProductIdQueryVariables = Exact<{
  marketplace: Scalars['String']['input'];
  asin: Scalars['String']['input'];
}>;


export type NavigateToAsinSearchProductIdQuery = { __typename?: 'Query', productIdForDetailPage: { __typename?: 'ProductIdQueryResponse', productId?: string | null, error?: string | null, code?: string | null } };

export type NavigateToProgramSelectFragment = { __typename?: 'Program', id: string, name: string, programId: string };

export type NavigateToProgramSelectProgramsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filters?: InputMaybe<ProgramFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type NavigateToProgramSelectProgramsQuery = { __typename?: 'Query', programs: { __typename?: 'QueryPrograms_Connection', totalCount: number, edges: Array<{ __typename?: 'ProgramEdge', node: { __typename?: 'Program', id: string, name: string, programId: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type ProductIdForDetailPageQueryVariables = Exact<{
  marketplace: Scalars['String']['input'];
  asin: Scalars['String']['input'];
}>;


export type ProductIdForDetailPageQuery = { __typename?: 'Query', productIdForDetailPage: { __typename?: 'ProductIdQueryResponse', detail?: string | null, error?: string | null, productId?: string | null, code?: string | null } };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', alias: string, email: string, groups: Array<string> } | null };

export type ImportTrafficEventMutationVariables = Exact<{
  input: ImportTrafficEventInput;
}>;


export type ImportTrafficEventMutation = { __typename?: 'Mutation', importTrafficEvent: { __typename?: 'ImportTrafficEventOutput', project: { __typename?: 'TrafficProject', id: string, events?: Array<{ __typename?: 'TrafficEventImportedFromSymphony', parentEventId?: string | null, realm?: SymphonyRealm | null, name?: string | null, timezone?: string | null, businessControlGroup?: string | null, accessControlGroup?: string | null, ranges: Array<{ __typename?: 'TrafficEventDateRange', elemId: string, dateRangeType: TrafficDateRangeTypeName, childEventId?: string | null, title?: string | null, start?: string | null, end?: string | null }> } | { __typename?: 'TrafficEventJourneysCreated', parentEventId?: string | null, realm?: SymphonyRealm | null, name?: string | null, ranges: Array<{ __typename?: 'TrafficEventDateRange', elemId: string, dateRangeType: TrafficDateRangeTypeName, childEventId?: string | null, title?: string | null, start?: string | null, end?: string | null }> }> | null } } };

export type CloneJagMutationVariables = Exact<{
  sourceJagId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type CloneJagMutation = { __typename?: 'Mutation', cloneJAG: { __typename?: 'AssetGroup', id: string, name: string } };

export type PasteJaGsMutationVariables = Exact<{
  input: PasteJaGsInput;
}>;


export type PasteJaGsMutation = { __typename?: 'Mutation', pasteJAGs: { __typename?: 'PasteJAGsResponse', assetGroups: Array<{ __typename?: 'AssetGroup', id: string, name: string }> } };

export type CloneJaGsMutationVariables = Exact<{
  sourceJagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  namePrefix?: InputMaybe<Scalars['String']['input']>;
}>;


export type CloneJaGsMutation = { __typename?: 'Mutation', cloneJAGs: { __typename?: 'CloneJAGsResponse', assetGroups: Array<{ __typename?: 'AssetGroup', id: string, name: string }> } };

export type JagListViewFragment = { __typename?: 'AssetGroup', id: string, name: string, rvn: number, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string, templateGroup: { __typename?: 'TemplateGroup', name: string }, layeredImageAssets: { __typename?: 'AssetGroupLayeredImageAssets_Connection', marketplaces: Array<{ __typename?: 'Marketplace', id: string, locales: { __typename?: 'MarketplaceLocales_Connection', edges: Array<{ __typename?: 'MarketplaceLocales_Edge', displayName?: string | null, node: { __typename?: 'Locale', id: string } }> } }>, nodes: Array<{ __typename?: 'LayeredImageAsset', id: string, marketplace: { __typename?: 'Marketplace', id: string }, locale: { __typename?: 'Locale', id: string, display: string }, reviews: Array<{ __typename?: 'QAReview', id: string, status?: QaStatusEnum | null, comment?: string | null }> }> } };

export type GetJagsQueryVariables = Exact<{
  filters: JagFilterInput;
  baseFilters: JagFilterBaseInput;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetJagsQuery = { __typename?: 'Query', JAGs: { __typename?: 'QueryJAGs_Connection', totalCount: number, jagFilterOptionValues: { __typename?: 'JourneysAssetGroupFilterOptionValuesType', hasQaComment: Array<boolean>, locale: Array<string>, qaStatus: Array<QaStatusFilterEnum> }, nodes: Array<{ __typename?: 'AssetGroup', id: string, name: string, rvn: number, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string, templateGroup: { __typename?: 'TemplateGroup', name: string }, layeredImageAssets: { __typename?: 'AssetGroupLayeredImageAssets_Connection', marketplaces: Array<{ __typename?: 'Marketplace', id: string, locales: { __typename?: 'MarketplaceLocales_Connection', edges: Array<{ __typename?: 'MarketplaceLocales_Edge', displayName?: string | null, node: { __typename?: 'Locale', id: string } }> } }>, nodes: Array<{ __typename?: 'LayeredImageAsset', id: string, marketplace: { __typename?: 'Marketplace', id: string }, locale: { __typename?: 'Locale', id: string, display: string }, reviews: Array<{ __typename?: 'QAReview', id: string, status?: QaStatusEnum | null, comment?: string | null }> }> } }> } };

export type CloneTrafficProjectMutationVariables = Exact<{
  input: CloneTrafficProjectInput;
}>;


export type CloneTrafficProjectMutation = { __typename?: 'Mutation', cloneTrafficProject: { __typename?: 'CloneTrafficProjectOutput', project: { __typename?: 'TrafficProject', id: string } } };

export type ProjectFragment = { __typename?: 'TrafficProject', id: string, name: string };

export type TpPageTopBarQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TpPageTopBarQuery = { __typename?: 'Query', trafficProject: { __typename?: 'TrafficProject', id: string, name: string, createdBy: string } };

export type RenameTrafficProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameTrafficProjectMutation = { __typename?: 'Mutation', renameTrafficProject: { __typename?: 'TrafficProject', id: string, name: string } };

export type LdapGroupSelectFragment = { __typename?: 'TrafficProjectLdapPermission', action: string, ldapGroup: string, permissionType: TrafficProjectPermissionType };

export type LdapPermissionsTablePermissionFragment = { __typename?: 'TrafficProjectLdapPermission', action: string, ldapGroup: string, permissionType: TrafficProjectPermissionType };

export type LdapPermissionsTableRowPermissionLdapDataFragment = { __typename?: 'TrafficProjectLdapPermission', action: string, ldapGroup: string };

export type LdapPermissionRowLdapGroupNameCellDataFragment = { __typename?: 'TrafficProjectLdapPermission', ldapGroup: string };

export type ProjectPermissionsQueryVariables = Exact<{
  trafficProjectId: Scalars['ID']['input'];
}>;


export type ProjectPermissionsQuery = { __typename?: 'Query', trafficProject: { __typename?: 'TrafficProject', id: string, createdBy: string, permissions: Array<{ __typename?: 'TrafficProjectBindlePermission' } | { __typename?: 'TrafficProjectLdapPermission', action: string, ldapGroup: string, permissionType: TrafficProjectPermissionType } | { __typename?: 'TrafficProjectUserPermission', action: string, permissionType: TrafficProjectPermissionType, user: { __typename?: 'TrafficProjectUser', firstName: string, lastName: string, alias: string } }> } };

export type UpdateTrafficProjectPermissionsMutationVariables = Exact<{
  shareTrafficProjectId: Scalars['ID']['input'];
  groups: Array<Scalars['String']['input']> | Scalars['String']['input'];
  people: Array<TrafficProjectUserInput> | TrafficProjectUserInput;
}>;


export type UpdateTrafficProjectPermissionsMutation = { __typename?: 'Mutation', shareTrafficProject: { __typename?: 'TrafficProject', id: string, createdBy: string, permissions: Array<{ __typename?: 'TrafficProjectBindlePermission' } | { __typename?: 'TrafficProjectLdapPermission', action: string, ldapGroup: string, permissionType: TrafficProjectPermissionType } | { __typename?: 'TrafficProjectUserPermission', action: string, permissionType: TrafficProjectPermissionType, user: { __typename?: 'TrafficProjectUser', firstName: string, lastName: string, alias: string } }> } };

export type TpShareModalDataFragment = { __typename?: 'TrafficProject', id: string, createdBy: string, permissions: Array<{ __typename?: 'TrafficProjectBindlePermission' } | { __typename?: 'TrafficProjectLdapPermission', action: string, ldapGroup: string, permissionType: TrafficProjectPermissionType } | { __typename?: 'TrafficProjectUserPermission', action: string, permissionType: TrafficProjectPermissionType, user: { __typename?: 'TrafficProjectUser', firstName: string, lastName: string, alias: string } }> };

export type TpShareModalProjectDataFragment = { __typename?: 'TrafficProject', id: string, createdBy: string };

export type TpShareModalUserDataFragment = { __typename?: 'User', alias: string };

export type TpShareModalUserPermissionFragment = { __typename?: 'TrafficProjectUserPermission', action: string, permissionType: TrafficProjectPermissionType, user: { __typename?: 'TrafficProjectUser', firstName: string, lastName: string, alias: string } };

export type TpShareModalLdapPermissionFragment = { __typename?: 'TrafficProjectLdapPermission', action: string, ldapGroup: string, permissionType: TrafficProjectPermissionType };

export type PapiSearchFieldPapiUserFragment = { __typename?: 'papiUser', login: string, firstName: string, lastName: string, businessTitle?: string | null };

export type PapiSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type PapiSearchQuery = { __typename?: 'Query', getPapiUsers: Array<{ __typename?: 'papiUser', login: string, firstName: string, lastName: string, businessTitle?: string | null }> };

export type PapiSearchFieldPapiUserSuggestionFragment = { __typename?: 'papiUser', firstName: string, lastName: string, login: string, businessTitle?: string | null };

export type UsersTableRowUserDataFragment = { __typename?: 'TrafficProjectUser', firstName: string, lastName: string, alias: string };

export type UsersTableRowProjectDataFragment = { __typename?: 'TrafficProject', createdBy: string };

export type UsersTableRowUserPermissionDataFragment = { __typename?: 'TrafficProjectUserPermission', action: string };

export type UsersPermissionTableRowUserNameCellFragment = { __typename?: 'TrafficProjectUser', firstName: string, lastName: string, alias: string };

export type UsersPermissionTableRowUserAliasCellFragment = { __typename?: 'TrafficProjectUser', alias: string };

export type PermissionTablePermissionActionCellFragment = { __typename?: 'TrafficProjectUserPermission', action: string };

export type PermissionTablePermissionActionUserDataFragment = { __typename?: 'TrafficProjectUser', alias: string };

export type PermissionTablePermissionActionCellProjectDataFragment = { __typename?: 'TrafficProject', createdBy: string };

export type UsersPermissionTableUserPermissionFragment = { __typename?: 'TrafficProjectUserPermission', action: string, permissionType: TrafficProjectPermissionType, user: { __typename?: 'TrafficProjectUser', firstName: string, lastName: string, alias: string } };

export type UsersTableUserFragment = { __typename?: 'TrafficProjectUser', alias: string };

export type UserTableProjectDataFragment = { __typename?: 'TrafficProject', createdBy: string };

export type TrafficProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TrafficProjectQuery = { __typename?: 'Query', trafficProject: { __typename?: 'TrafficProject', id: string, name: string, events?: Array<{ __typename?: 'TrafficEventImportedFromSymphony', parentEventId?: string | null, realm?: SymphonyRealm | null, name?: string | null, timezone?: string | null, businessControlGroup?: string | null, accessControlGroup?: string | null, ranges: Array<{ __typename?: 'TrafficEventDateRange', elemId: string, dateRangeType: TrafficDateRangeTypeName, childEventId?: string | null, title?: string | null, start?: string | null, end?: string | null }> } | { __typename?: 'TrafficEventJourneysCreated', parentEventId?: string | null, realm?: SymphonyRealm | null, name?: string | null, ranges: Array<{ __typename?: 'TrafficEventDateRange', elemId: string, dateRangeType: TrafficDateRangeTypeName, childEventId?: string | null, title?: string | null, start?: string | null, end?: string | null }> }> | null } };

export type TpEventFragment = { __typename?: 'TrafficProject', events?: Array<{ __typename?: 'TrafficEventImportedFromSymphony', parentEventId?: string | null, realm?: SymphonyRealm | null, name?: string | null, timezone?: string | null, businessControlGroup?: string | null, accessControlGroup?: string | null, ranges: Array<{ __typename?: 'TrafficEventDateRange', elemId: string, dateRangeType: TrafficDateRangeTypeName, childEventId?: string | null, title?: string | null, start?: string | null, end?: string | null }> } | { __typename?: 'TrafficEventJourneysCreated', parentEventId?: string | null, realm?: SymphonyRealm | null, name?: string | null, ranges: Array<{ __typename?: 'TrafficEventDateRange', elemId: string, dateRangeType: TrafficDateRangeTypeName, childEventId?: string | null, title?: string | null, start?: string | null, end?: string | null }> }> | null };

export type CreateTrafficProjectMutationVariables = Exact<{
  name: Scalars['String']['input'];
  buildEvent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateTrafficProjectMutation = { __typename?: 'Mutation', createTrafficProject: { __typename?: 'TrafficProject', id: string } };

export type ProjectsTableToolbarFragment = { __typename?: 'QueryTrafficProjectSearch_Connection', filterOptions: { __typename?: 'TrafficProjectSearchFilters', createdBy: Array<{ __typename?: 'FilterOption', option: string, count: number }> } };

export type TrafficProjectsTableDataFragment = { __typename?: 'TrafficProject', id: string, name: string, modifiedBy: string, modifiedAt: string, createdBy: string, createdAt: string, assets: { __typename?: 'TrafficAssetConnection', edges: Array<{ __typename?: 'TrafficAssetEdge', node: { __typename?: 'TrafficAsset', thumbnail?: string | null } }> } };

export type TrafficProjectsListSearchQueryVariables = Exact<{
  searchType: TrafficProjectSearchType;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort: Array<TrafficProjectSearchSortInput> | TrafficProjectSearchSortInput;
  filter: TrafficProjectSearchFilterInput;
}>;


export type TrafficProjectsListSearchQuery = { __typename?: 'Query', sharedFilterOptions: { __typename?: 'QueryTrafficProjectSearch_Connection', filterOptions: { __typename?: 'TrafficProjectSearchFilters', createdBy: Array<{ __typename?: 'FilterOption', option: string, count: number }> } }, trafficProjectSearch: { __typename?: 'QueryTrafficProjectSearch_Connection', totalCount: number, edges: Array<{ __typename?: 'TrafficProjectEdge', node: { __typename?: 'TrafficProject', id: string, name: string, modifiedBy: string, modifiedAt: string, createdBy: string, createdAt: string, assets: { __typename?: 'TrafficAssetConnection', edges: Array<{ __typename?: 'TrafficAssetEdge', node: { __typename?: 'TrafficAsset', thumbnail?: string | null } }> } } }> } };

export type EligibilityCriteriaMarketplaceFragment = { __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null };

export type TrafficCampaignPlacementDefaultsFragment = { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null };

export type TrafficCampaignEligibilityCriteriaFragment = { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null };

export type TrafficPlacementGroupFragment = { __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } };

export type TpCampaignPlacementsInfoFragment = { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null };

export type SuspendTrafficCampaignPlacementsMutationVariables = Exact<{
  input: TrafficPlacementStateTransitionInput;
}>;


export type SuspendTrafficCampaignPlacementsMutation = { __typename?: 'Mutation', suspendTrafficCampaignPlacements: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type TpCampaignPlacementsFragment = { __typename?: 'TrafficCampaign', id: string, project: { __typename?: 'TrafficProject', id: string }, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', accessControlGroup: string, businessGroup: string, language: string, marketingType: string, marketplace: string, pageId: string, platform: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, slots: Array<string>, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean } }> };

export type TrafficCampaignPlacementFragment = { __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, slots: Array<string>, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } };

export type TpCampaignSchedulingInfoFragment = { __typename?: 'TrafficCampaignSchedulingInfo', accessControlGroup: string, businessGroup: string, language: string, marketingType: string, marketplace: string, pageId: string, platform: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, slots: Array<string>, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> };

export type TpCampaignPlacementStatusFragment = { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', objectState?: ObjectStateType | null, workflowId?: string | null, workflowState?: WorkflowStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType, liveState: LiveStateType } | null }> }> };

export type PublishedAssetResultFragment = { __typename?: 'CampaignAssetPublishResult', folderPath: string, orgUnit: string, extension: string, publicUrl: string, url: string, assetId: string, dimension?: { __typename?: 'Dimension', height: number, width: number } | null };

export type PublishTpAssetsMutationVariables = Exact<{
  input: Array<PublishCampaignAssetInput> | PublishCampaignAssetInput;
}>;


export type PublishTpAssetsMutation = { __typename?: 'Mutation', bulkPublishCampaignAssets: { __typename?: 'PublishCampaignAssetsMutationResponse', success: boolean, message: string, succeeded: Array<{ __typename?: 'CampaignAssetPublishResult', folderPath: string, orgUnit: string, extension: string, publicUrl: string, url: string, assetId: string, dimension?: { __typename?: 'Dimension', height: number, width: number } | null }> } };

export type TpCampaignRequiredFormFlavorFragment = { __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, creativeName?: string | null, hasGeneratedName?: boolean | null, content: any, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', accessControlGroup: string, businessGroup: string, language: string, marketingType: string, marketplace: string, pageId: string, platform: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, slots: Array<string>, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } };

export type TpCampaignRequiredFormFieldsFragment = { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, creativeName?: string | null, hasGeneratedName?: boolean | null, content: any, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', accessControlGroup: string, businessGroup: string, language: string, marketingType: string, marketplace: string, pageId: string, platform: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, slots: Array<string>, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null };

export type TrafficCampaignPageFragment = { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, configuration?: { __typename?: 'CampaignConfiguration', id: string, name: string, shortName: string, version: number, featureGroups?: Array<string> | null, pageType: PageTypeEnum, isMCC: boolean, requiresCBR: boolean, hasMultiPlatformFlavors: boolean, isPlatformAgnostic?: boolean | null, requiresMocar: boolean, contentConfiguration: { __typename?: 'ContentConfiguration', jsonSchema: any, uiSchema?: any | null, customValidate?: string | null }, componentInfos: Array<{ __typename?: 'ComponentInfoVariant', variant: string, componentInfo: { __typename?: 'ComponentInfo', name: string, namespace: string, version: string } }>, placementsSection: { __typename?: 'PlacementsSectionConfig', customerOptions: CustomerOptionsConfigEnum, placementDefaultsEnabled: boolean, placementComponents: Array<{ __typename?: 'PlacementComponent', component: string, enabled: boolean }>, initialPlacementValues?: { __typename?: 'InitialPlacementValues', schedulingDefault?: boolean | null, pageType?: PageTypeEnum | null } | null, slotOptions: { __typename?: 'StandardSlotOptions', standard: Array<{ __typename?: 'ScopedSlotOption', scope: string, variantSlots: Array<{ __typename?: 'VariantSlot', variant: string, slots: Array<string> }> }> } | { __typename?: 'VariantSlotOptions', variant: Array<{ __typename?: 'ScopedVariantSlotOption', scope: string, variantSlots: Array<{ __typename?: 'VariantSlot', variant: string, slots: Array<string> }> }> } }, sharingOptions?: { __typename?: 'SharingOptions', disablePlatformSharing?: boolean | null } | null, overviewConfiguration?: { __typename?: 'OverviewConfiguration', autoNaming: { __typename?: 'AutoNamingConfiguration', supportedInputs: any } } | null, publishing?: { __typename?: 'PublishingConfiguration', creativeNamePrefixOverrideKey?: string | null, widgetType?: WidgetType | null } | null, livePreviewConfiguration?: { __typename?: 'LivePreviewConfiguration', supportsLivePreview: boolean, isMarsWidget?: boolean | null, keepProvidedStyles?: boolean | null, needsAuiJs?: boolean | null, supportsPlatformOverride?: boolean | null } | null } | null, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string, name: string } };

export type TrafficProjectCampaignPageQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  campaignId: Scalars['ID']['input'];
}>;


export type TrafficProjectCampaignPageQuery = { __typename?: 'Query', trafficCampaign: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, project: { __typename?: 'TrafficProject', id: string, name: string, events?: Array<{ __typename?: 'TrafficEventImportedFromSymphony', parentEventId?: string | null, realm?: SymphonyRealm | null, name?: string | null, timezone?: string | null, businessControlGroup?: string | null, accessControlGroup?: string | null, ranges: Array<{ __typename?: 'TrafficEventDateRange', elemId: string, dateRangeType: TrafficDateRangeTypeName, childEventId?: string | null, title?: string | null, start?: string | null, end?: string | null }> } | { __typename?: 'TrafficEventJourneysCreated', parentEventId?: string | null, realm?: SymphonyRealm | null, name?: string | null, ranges: Array<{ __typename?: 'TrafficEventDateRange', elemId: string, dateRangeType: TrafficDateRangeTypeName, childEventId?: string | null, title?: string | null, start?: string | null, end?: string | null }> }> | null }, configuration?: { __typename?: 'CampaignConfiguration', id: string, name: string, shortName: string, version: number, featureGroups?: Array<string> | null, pageType: PageTypeEnum, isMCC: boolean, requiresCBR: boolean, hasMultiPlatformFlavors: boolean, isPlatformAgnostic?: boolean | null, requiresMocar: boolean, contentConfiguration: { __typename?: 'ContentConfiguration', jsonSchema: any, uiSchema?: any | null, customValidate?: string | null }, componentInfos: Array<{ __typename?: 'ComponentInfoVariant', variant: string, componentInfo: { __typename?: 'ComponentInfo', name: string, namespace: string, version: string } }>, placementsSection: { __typename?: 'PlacementsSectionConfig', customerOptions: CustomerOptionsConfigEnum, placementDefaultsEnabled: boolean, placementComponents: Array<{ __typename?: 'PlacementComponent', component: string, enabled: boolean }>, initialPlacementValues?: { __typename?: 'InitialPlacementValues', schedulingDefault?: boolean | null, pageType?: PageTypeEnum | null } | null, slotOptions: { __typename?: 'StandardSlotOptions', standard: Array<{ __typename?: 'ScopedSlotOption', scope: string, variantSlots: Array<{ __typename?: 'VariantSlot', variant: string, slots: Array<string> }> }> } | { __typename?: 'VariantSlotOptions', variant: Array<{ __typename?: 'ScopedVariantSlotOption', scope: string, variantSlots: Array<{ __typename?: 'VariantSlot', variant: string, slots: Array<string> }> }> } }, sharingOptions?: { __typename?: 'SharingOptions', disablePlatformSharing?: boolean | null } | null, overviewConfiguration?: { __typename?: 'OverviewConfiguration', autoNaming: { __typename?: 'AutoNamingConfiguration', supportedInputs: any } } | null, publishing?: { __typename?: 'PublishingConfiguration', creativeNamePrefixOverrideKey?: string | null, widgetType?: WidgetType | null } | null, livePreviewConfiguration?: { __typename?: 'LivePreviewConfiguration', supportsLivePreview: boolean, isMarsWidget?: boolean | null, keepProvidedStyles?: boolean | null, needsAuiJs?: boolean | null, supportsPlatformOverride?: boolean | null } | null } | null, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null } };

export type TrafficProjectNewCampaignPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  campaignType: Scalars['ID']['input'];
}>;


export type TrafficProjectNewCampaignPageQuery = { __typename?: 'Query', trafficProject: { __typename?: 'TrafficProject', id: string, name: string, events?: Array<{ __typename?: 'TrafficEventImportedFromSymphony', parentEventId?: string | null, realm?: SymphonyRealm | null, name?: string | null, timezone?: string | null, businessControlGroup?: string | null, accessControlGroup?: string | null, ranges: Array<{ __typename?: 'TrafficEventDateRange', elemId: string, dateRangeType: TrafficDateRangeTypeName, childEventId?: string | null, title?: string | null, start?: string | null, end?: string | null }> } | { __typename?: 'TrafficEventJourneysCreated', parentEventId?: string | null, realm?: SymphonyRealm | null, name?: string | null, ranges: Array<{ __typename?: 'TrafficEventDateRange', elemId: string, dateRangeType: TrafficDateRangeTypeName, childEventId?: string | null, title?: string | null, start?: string | null, end?: string | null }> }> | null }, campaignConfigurations: { __typename?: 'CampaignConfigurationConnection', nodes: Array<{ __typename?: 'CampaignConfiguration', id: string, name: string, shortName: string, version: number, featureGroups?: Array<string> | null, pageType: PageTypeEnum, isMCC: boolean, requiresCBR: boolean, hasMultiPlatformFlavors: boolean, isPlatformAgnostic?: boolean | null, requiresMocar: boolean, contentConfiguration: { __typename?: 'ContentConfiguration', jsonSchema: any, uiSchema?: any | null, customValidate?: string | null }, componentInfos: Array<{ __typename?: 'ComponentInfoVariant', variant: string, componentInfo: { __typename?: 'ComponentInfo', name: string, namespace: string, version: string } }>, placementsSection: { __typename?: 'PlacementsSectionConfig', customerOptions: CustomerOptionsConfigEnum, placementDefaultsEnabled: boolean, placementComponents: Array<{ __typename?: 'PlacementComponent', component: string, enabled: boolean }>, initialPlacementValues?: { __typename?: 'InitialPlacementValues', schedulingDefault?: boolean | null, pageType?: PageTypeEnum | null } | null, slotOptions: { __typename?: 'StandardSlotOptions', standard: Array<{ __typename?: 'ScopedSlotOption', scope: string, variantSlots: Array<{ __typename?: 'VariantSlot', variant: string, slots: Array<string> }> }> } | { __typename?: 'VariantSlotOptions', variant: Array<{ __typename?: 'ScopedVariantSlotOption', scope: string, variantSlots: Array<{ __typename?: 'VariantSlot', variant: string, slots: Array<string> }> }> } }, sharingOptions?: { __typename?: 'SharingOptions', disablePlatformSharing?: boolean | null } | null, overviewConfiguration?: { __typename?: 'OverviewConfiguration', autoNaming: { __typename?: 'AutoNamingConfiguration', supportedInputs: any } } | null, publishing?: { __typename?: 'PublishingConfiguration', creativeNamePrefixOverrideKey?: string | null, widgetType?: WidgetType | null } | null, livePreviewConfiguration?: { __typename?: 'LivePreviewConfiguration', supportsLivePreview: boolean, isMarsWidget?: boolean | null, keepProvidedStyles?: boolean | null, needsAuiJs?: boolean | null, supportsPlatformOverride?: boolean | null } | null }> } };

export type TpCampaignNavBarFragment = { __typename?: 'TrafficCampaign', id: string, name: string, project: { __typename?: 'TrafficProject', id: string, name: string } };

export type FlavorContentEditorFragment = { __typename?: 'TrafficCampaignFlavor', content: any, variant?: string | null };

export type TpCampaignSidebarFragment = { __typename?: 'TrafficCampaign', id: string, isArchived?: boolean | null, modifiedAt: string, globalContent?: any | null, version: number, schema: string, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, name: string, createdBy: string, project: { __typename?: 'TrafficProject', id: string }, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null }> } }>, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null };

export type ApproveTrafficCampaignFlavorMutationVariables = Exact<{
  input: TrafficFlavorApprovalStateTransitionInput;
}>;


export type ApproveTrafficCampaignFlavorMutation = { __typename?: 'Mutation', approveTrafficCampaignFlavor: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type ApproveTrafficCampaignFlavorsMutationVariables = Exact<{
  input: TransitionTrafficCampaignFlavorsInput;
}>;


export type ApproveTrafficCampaignFlavorsMutation = { __typename?: 'Mutation', transitionTrafficCampaignFlavors: { __typename?: 'TrafficCampaign', status: CampaignState, id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type TpCampaignApproveAllButtonFragment = { __typename?: 'TrafficCampaign', createdBy: string, id: string, schema: string, status: CampaignState, project: { __typename?: 'TrafficProject', id: string }, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', active: boolean, id: string, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', status?: { __typename?: 'StatusSummary', objectState?: ObjectStateType | null, workflowState?: WorkflowStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType, liveState: LiveStateType } | null }> } }> };

export type TpCampaignArchiveMenuItemFragment = { __typename?: 'TrafficCampaign', id: string, isArchived?: boolean | null, status: CampaignState, version: number, project: { __typename?: 'TrafficProject', id: string } };

type ConversationFragment_ChatConversationPending_Fragment = { __typename?: 'ChatConversationPending', id: string, correlationId: string };

type ConversationFragment_ChatConversationReady_Fragment = { __typename?: 'ChatConversationReady', id: string, correlationId: string, messages: Array<{ __typename?: 'ChatMessage', content: string, role: MessageRole, timestamp: any }> };

export type ConversationFragmentFragment = ConversationFragment_ChatConversationPending_Fragment | ConversationFragment_ChatConversationReady_Fragment;

export type ConversationsQueryVariables = Exact<{
  correlationId: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ConversationsQuery = { __typename?: 'Query', conversations: { __typename?: 'QueryConversations_Connection', totalCount: number, edges: Array<{ __typename?: 'ChatConversationEdge', cursor: string, node: { __typename?: 'ChatConversationPending', id: string, correlationId: string, messages: Array<{ __typename?: 'ChatMessage', content: string, role: MessageRole, timestamp: any }> } | { __typename?: 'ChatConversationReady', id: string, correlationId: string, messages: Array<{ __typename?: 'ChatMessage', content: string, role: MessageRole, timestamp: any }> } }> } };

export type MessageFragmentFragment = { __typename?: 'ChatMessage', content: string, role: MessageRole, timestamp: any };

export type SendMessageMutationVariables = Exact<{
  correlationId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  sessionIdentifier: Scalars['String']['input'];
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage: { __typename?: 'SendMessageResponse', conversation: { __typename?: 'ChatConversationPending', id: string, correlationId: string } | { __typename?: 'ChatConversationReady', id: string, correlationId: string, messages: Array<{ __typename?: 'ChatMessage', content: string, role: MessageRole, timestamp: any }> } } };

export type StartConversationMutationVariables = Exact<{
  assetIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  correlationId: Scalars['String']['input'];
  promptName: Scalars['String']['input'];
  variables?: InputMaybe<Array<PromptVariableInput> | PromptVariableInput>;
}>;


export type StartConversationMutation = { __typename?: 'Mutation', startConversation: { __typename?: 'SendMessageResponse', conversation: { __typename?: 'ChatConversationPending', id: string, correlationId: string } | { __typename?: 'ChatConversationReady', id: string, correlationId: string, messages: Array<{ __typename?: 'ChatMessage', content: string, role: MessageRole, timestamp: any }> } } };

export type CancelTrafficCampaignApprovalsMutationVariables = Exact<{
  input: TransitionTrafficCampaignFlavorsInput;
}>;


export type CancelTrafficCampaignApprovalsMutation = { __typename?: 'Mutation', transitionTrafficCampaignFlavors: { __typename?: 'TrafficCampaign', status: CampaignState, id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type TpCampaignCancelApprovalsButtonFragment = { __typename?: 'TrafficCampaign', id: string, schema: string, status: CampaignState, project: { __typename?: 'TrafficProject', id: string }, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', active: boolean, id: string, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', status?: { __typename?: 'StatusSummary', objectState?: ObjectStateType | null, workflowState?: WorkflowStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType, liveState: LiveStateType } | null }> } }> };

export type CloneTrafficCampaignMutationVariables = Exact<{
  input: CloneTrafficCampaignInput;
}>;


export type CloneTrafficCampaignMutation = { __typename?: 'Mutation', cloneTrafficCampaign: { __typename?: 'CloneTrafficCampaignOutput', campaign: { __typename?: 'TrafficCampaign', id: string, name: string, project: { __typename?: 'TrafficProject', id: string } } } };

export type TpCampaignCloneButtonFragment = { __typename?: 'TrafficCampaign', id: string, project: { __typename?: 'TrafficProject', id: string } };

export type TpCampaignOpenInSymphonyButtonFragment = { __typename?: 'TrafficCampaign', flavors: Array<{ __typename?: 'TrafficCampaignFlavor', symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string }> } }> };

export type TpCampaignPreviewInSymphonyButtonFragment = { __typename?: 'TrafficCampaign', flavors: Array<{ __typename?: 'TrafficCampaignFlavor', scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string> } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', symphonyPreviewUrl?: string | null }> } }> };

export type PublishTrafficCampaignFlavorsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: Array<TrafficCreativePublishInput> | TrafficCreativePublishInput;
}>;


export type PublishTrafficCampaignFlavorsMutation = { __typename?: 'Mutation', publishTrafficCampaignFlavors: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type PublishTrafficCampaignFlavorMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TrafficCreativePublishInput;
}>;


export type PublishTrafficCampaignFlavorMutation = { __typename?: 'Mutation', publishTrafficCampaignFlavor: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type TpCampaignPublishButtonFragment = { __typename?: 'TrafficCampaign', id: string, schema: string, name: string, globalContent?: any | null, project: { __typename?: 'TrafficProject', id: string }, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', active: boolean, id: string, content: any, creativeName?: string | null, variant?: string | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', accessControlGroup: string, businessGroup: string, language: string, marketingType: string, marketplace: string, pageId: string, platform: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, slots: Array<string>, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', status?: { __typename?: 'StatusSummary', workflowId?: string | null, workflowState?: WorkflowStateType | null } | null }> } }> };

export type AsinPsldCheckQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filters?: InputMaybe<AsinFilterInput>;
  includeMissingAnnounceDate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AsinPsldCheckQuery = { __typename?: 'Query', asins: { __typename?: 'QueryAsins_Connection', totalCount: number, launchGatingInfo: Array<{ __typename?: 'ASINLaunchGatingInfo', marketplace: { __typename?: 'Marketplace', id: string, country: string, launchDateThreshold: number }, gatingAsins: { __typename?: 'ASINLaunchGatingInfoGatingAsins_Connection', totalCount: number, nodes: Array<{ __typename?: 'ASIN', id: string, announceDate?: any | null, asin: string }> } }>, nodes: Array<{ __typename?: 'ASIN', id: string }> } };

export type PsldCheckQueryVariables = Exact<{
  asin: Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
  keys: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type PsldCheckQuery = { __typename?: 'Query', attributes: Array<{ __typename?: 'DpAttribute', key: string, value: any }>, asins: { __typename?: 'QueryAsins_Connection', nodes: Array<{ __typename?: 'ASIN', id: string, launchGating: { __typename?: 'ASINLaunchGating', attributeChecked: AsinLaunchGatingAttributeEnum, beyondLaunchDate: boolean, withinLaunchDate: boolean, launchDateThreshold: number, gatingAsin?: string | null } }> } };

export type RejectTrafficCampaignFlavorsMutationVariables = Exact<{
  input: TransitionTrafficCampaignFlavorsInput;
}>;


export type RejectTrafficCampaignFlavorsMutation = { __typename?: 'Mutation', transitionTrafficCampaignFlavors: { __typename?: 'TrafficCampaign', status: CampaignState, id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type TpCampaignRejectAllButtonFragment = { __typename?: 'TrafficCampaign', id: string, schema: string, status: CampaignState, project: { __typename?: 'TrafficProject', id: string }, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', active: boolean, id: string, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', status?: { __typename?: 'StatusSummary', objectState?: ObjectStateType | null, workflowState?: WorkflowStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType, liveState: LiveStateType } | null }> } }> };

export type RequestApprovalForTrafficCampaignFlavorsMutationVariables = Exact<{
  input: TransitionTrafficCampaignFlavorsInput;
}>;


export type RequestApprovalForTrafficCampaignFlavorsMutation = { __typename?: 'Mutation', transitionTrafficCampaignFlavors: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string, name: string } } };

export type TpCampaignRequestApprovalsButtonFragment = { __typename?: 'TrafficCampaign', id: string, schema: string, project: { __typename?: 'TrafficProject', id: string }, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', active: boolean, id: string, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', status?: { __typename?: 'StatusSummary', objectState?: ObjectStateType | null, workflowState?: WorkflowStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType, liveState: LiveStateType } | null }> } }> };

export type SaveTrafficCampaignMutationVariables = Exact<{
  input: SaveTrafficCampaignInput;
}>;


export type SaveTrafficCampaignMutation = { __typename?: 'Mutation', saveTrafficCampaign: { __typename?: 'SaveTrafficCampaignOutput', campaign: { __typename?: 'TrafficCampaign', name: string, id: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } } };

export type TpCampaignSaveButtonFragment = { __typename?: 'TrafficCampaign', id: string, isArchived?: boolean | null, modifiedAt: string, globalContent?: any | null, version: number, schema: string, schemaVersion: number, status: CampaignState, project: { __typename?: 'TrafficProject', id: string }, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', accessControlGroup: string, businessGroup: string, language: string, marketingType: string, marketplace: string, pageId: string, platform: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, slots: Array<string>, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean } }>, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null };

export type CreateTrafficCampaignMutationVariables = Exact<{
  input: CreateTrafficCampaignInput;
}>;


export type CreateTrafficCampaignMutation = { __typename?: 'Mutation', createTrafficCampaign: { __typename?: 'TrafficCampaign', createdAt: string, createdBy: string, globalContent?: any | null, id: string, modifiedAt: string, modifiedBy: string, name: string, schema: string, schemaVersion: number, thumbnailURL?: string | null, version: number, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', active: boolean, id: string }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, project: { __typename?: 'TrafficProject', name: string, id: string } } };

export type TpCampaignSidebarBadgesFragment = { __typename?: 'TrafficCampaign', status: CampaignState, isArchived?: boolean | null, liveState?: LiveStateType | null, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', status?: { __typename?: 'StatusSummary', liveState: LiveStateType } | null }> } }> };

export type SuspendTrafficCampaignFlavorMutationVariables = Exact<{
  input: TrafficFlavorStateTransitionInput;
}>;


export type SuspendTrafficCampaignFlavorMutation = { __typename?: 'Mutation', suspendTrafficCampaignFlavor: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type SuspendTrafficCampaignFlavorsMutationVariables = Exact<{
  input: TransitionTrafficCampaignFlavorsInput;
}>;


export type SuspendTrafficCampaignFlavorsMutation = { __typename?: 'Mutation', transitionTrafficCampaignFlavors: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type TpCampaignSuspendAllButtonFragment = { __typename?: 'TrafficCampaign', id: string, schema: string, project: { __typename?: 'TrafficProject', id: string }, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', active: boolean, id: string, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', status?: { __typename?: 'StatusSummary', objectState?: ObjectStateType | null, workflowState?: WorkflowStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType, liveState: LiveStateType } | null }> } }> };

export type GetTrafficCampaignCountQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTrafficCampaignCountQuery = { __typename?: 'Query', trafficProject: { __typename?: 'TrafficProject', id: string, campaigns: { __typename?: 'TrafficProjectCampaigns_Connection', totalCount: number } } };

export type FlavorStatusBadgeFragment = { __typename?: 'TrafficCampaignFlavor', id: string, status?: CampaignState | null, liveState?: LiveStateType | null };

export type ApproveMcTrafficCampaignFlavorsMutationVariables = Exact<{
  input: TransitionTrafficCampaignFlavorsInput;
}>;


export type ApproveMcTrafficCampaignFlavorsMutation = { __typename?: 'Mutation', transitionTrafficCampaignFlavors: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type RejectMcTrafficCampaignFlavorsMutationVariables = Exact<{
  input: TransitionTrafficCampaignFlavorsInput;
}>;


export type RejectMcTrafficCampaignFlavorsMutation = { __typename?: 'Mutation', transitionTrafficCampaignFlavors: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type SuspendMcTrafficCampaignFlavorsMutationVariables = Exact<{
  input: TransitionTrafficCampaignFlavorsInput;
}>;


export type SuspendMcTrafficCampaignFlavorsMutation = { __typename?: 'Mutation', transitionTrafficCampaignFlavors: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type RequestCbrApprovalMcTrafficCampaignFlavorsMutationVariables = Exact<{
  input: TransitionTrafficCampaignFlavorsInput;
}>;


export type RequestCbrApprovalMcTrafficCampaignFlavorsMutation = { __typename?: 'Mutation', transitionTrafficCampaignFlavors: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type CancelCbrApprovalRequestMcTrafficCampaignFlavorsMutationVariables = Exact<{
  input: TransitionTrafficCampaignFlavorsInput;
}>;


export type CancelCbrApprovalRequestMcTrafficCampaignFlavorsMutation = { __typename?: 'Mutation', transitionTrafficCampaignFlavors: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type ApproveMcTrafficCampaignCreativesMutationVariables = Exact<{
  input: TransitionTrafficCampaignCreativesInput;
}>;


export type ApproveMcTrafficCampaignCreativesMutation = { __typename?: 'Mutation', transitionTrafficCampaignCreatives: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type RejectMcTrafficCampaignCreativesMutationVariables = Exact<{
  input: TransitionTrafficCampaignCreativesInput;
}>;


export type RejectMcTrafficCampaignCreativesMutation = { __typename?: 'Mutation', transitionTrafficCampaignCreatives: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type SuspendMcTrafficCampaignCreativesMutationVariables = Exact<{
  input: TransitionTrafficCampaignCreativesInput;
}>;


export type SuspendMcTrafficCampaignCreativesMutation = { __typename?: 'Mutation', transitionTrafficCampaignCreatives: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type RequestCbrApprovalMcTrafficCampaignCreativesMutationVariables = Exact<{
  input: TransitionTrafficCampaignCreativesInput;
}>;


export type RequestCbrApprovalMcTrafficCampaignCreativesMutation = { __typename?: 'Mutation', transitionTrafficCampaignCreatives: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type CancelCbrApprovalRequestMcTrafficCampaignCreativesMutationVariables = Exact<{
  input: TransitionTrafficCampaignCreativesInput;
}>;


export type CancelCbrApprovalRequestMcTrafficCampaignCreativesMutation = { __typename?: 'Mutation', transitionTrafficCampaignCreatives: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type ApproveMcTrafficCampaignPlacementsMutationVariables = Exact<{
  input: TransitionTrafficCampaignPlacementsInput;
}>;


export type ApproveMcTrafficCampaignPlacementsMutation = { __typename?: 'Mutation', transitionTrafficCampaignPlacements: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type RejectMcTrafficCampaignPlacementsMutationVariables = Exact<{
  input: TransitionTrafficCampaignPlacementsInput;
}>;


export type RejectMcTrafficCampaignPlacementsMutation = { __typename?: 'Mutation', transitionTrafficCampaignPlacements: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type SuspendMcTrafficCampaignPlacementsMutationVariables = Exact<{
  input: TransitionTrafficCampaignPlacementsInput;
}>;


export type SuspendMcTrafficCampaignPlacementsMutation = { __typename?: 'Mutation', transitionTrafficCampaignPlacements: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type RequestCbrApprovalMcTrafficCampaignPlacementsMutationVariables = Exact<{
  input: TransitionTrafficCampaignPlacementsInput;
}>;


export type RequestCbrApprovalMcTrafficCampaignPlacementsMutation = { __typename?: 'Mutation', transitionTrafficCampaignPlacements: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type CancelCbrApprovalRequestMcTrafficCampaignPlacementsMutationVariables = Exact<{
  input: TransitionTrafficCampaignPlacementsInput;
}>;


export type CancelCbrApprovalRequestMcTrafficCampaignPlacementsMutation = { __typename?: 'Mutation', transitionTrafficCampaignPlacements: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type CreateTransitionJobMutationVariables = Exact<{
  input: TransitionTrafficCampaignInput;
}>;


export type CreateTransitionJobMutation = { __typename?: 'Mutation', createMCCTransitionJob: { __typename?: 'CreateMCCTransitionJobMutationResponse', job: { __typename?: 'MCCTransitionJob', id: string, status: JobStatus } } };

export type JobTransitionStatusQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type JobTransitionStatusQuery = { __typename?: 'Query', job: { __typename?: 'BulkAtfJob' } | { __typename?: 'BulkPublishJob' } | { __typename?: 'BulkPublishV2Job' } | { __typename?: 'MCCTransitionJob', status: JobStatus, id: string, metadata?: { __typename?: 'MCCTransitionMetadata', campaign?: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, configuration?: { __typename?: 'CampaignConfiguration', id: string, name: string, shortName: string, version: number, featureGroups?: Array<string> | null, pageType: PageTypeEnum, isMCC: boolean, requiresCBR: boolean, hasMultiPlatformFlavors: boolean, isPlatformAgnostic?: boolean | null, requiresMocar: boolean, contentConfiguration: { __typename?: 'ContentConfiguration', jsonSchema: any, uiSchema?: any | null, customValidate?: string | null }, componentInfos: Array<{ __typename?: 'ComponentInfoVariant', variant: string, componentInfo: { __typename?: 'ComponentInfo', name: string, namespace: string, version: string } }>, placementsSection: { __typename?: 'PlacementsSectionConfig', customerOptions: CustomerOptionsConfigEnum, placementDefaultsEnabled: boolean, placementComponents: Array<{ __typename?: 'PlacementComponent', component: string, enabled: boolean }>, initialPlacementValues?: { __typename?: 'InitialPlacementValues', schedulingDefault?: boolean | null, pageType?: PageTypeEnum | null } | null, slotOptions: { __typename?: 'StandardSlotOptions', standard: Array<{ __typename?: 'ScopedSlotOption', scope: string, variantSlots: Array<{ __typename?: 'VariantSlot', variant: string, slots: Array<string> }> }> } | { __typename?: 'VariantSlotOptions', variant: Array<{ __typename?: 'ScopedVariantSlotOption', scope: string, variantSlots: Array<{ __typename?: 'VariantSlot', variant: string, slots: Array<string> }> }> } }, sharingOptions?: { __typename?: 'SharingOptions', disablePlatformSharing?: boolean | null } | null, overviewConfiguration?: { __typename?: 'OverviewConfiguration', autoNaming: { __typename?: 'AutoNamingConfiguration', supportedInputs: any } } | null, publishing?: { __typename?: 'PublishingConfiguration', creativeNamePrefixOverrideKey?: string | null, widgetType?: WidgetType | null } | null, livePreviewConfiguration?: { __typename?: 'LivePreviewConfiguration', supportsLivePreview: boolean, isMarsWidget?: boolean | null, keepProvidedStyles?: boolean | null, needsAuiJs?: boolean | null, supportsPlatformOverride?: boolean | null } | null } | null, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string, name: string } } | null } | null } };

export type TpCampaignSummaryFragment = { __typename?: 'TrafficCampaign', status: CampaignState };

type BullseyeSegmentDataRow_BullseyeSegmentError_Fragment = { __typename?: 'BullseyeSegmentError', id: string, type: string, message: string };

type BullseyeSegmentDataRow_BullseyeSegmentStatus_Fragment = { __typename?: 'BullseyeSegmentStatus', id: string, yesSize?: number | null, name: string, onlineStatus?: string | null, segmentStatus: string };

export type BullseyeSegmentDataRowFragment = BullseyeSegmentDataRow_BullseyeSegmentError_Fragment | BullseyeSegmentDataRow_BullseyeSegmentStatus_Fragment;

export type BullseyeSegmentDataRowSegmentFragment = { __typename?: 'BullseyeSegmentStatus', id: string, yesSize?: number | null, name: string, onlineStatus?: string | null, segmentStatus: string };

export type BullseyeDataSegmentDataRowErrorFragment = { __typename?: 'BullseyeSegmentError', id: string, type: string, message: string };

export type SummaryTableErrorFragment = { __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null };

export type DraftFlavorSummaryTableErrorsFragment = { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null };

export type PublishedFlavorSummaryTableErrorsFragment = { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }> }> };

export type SummaryTableBullseyeQueryVariables = Exact<{
  bullseyeSegmentIds: Array<Scalars['BullseyeSegmentID']['input']> | Scalars['BullseyeSegmentID']['input'];
  bullseyeSegmentRealm: Scalars['String']['input'];
}>;


export type SummaryTableBullseyeQuery = { __typename?: 'Query', BullseyeSegmentStatuses: Array<{ __typename?: 'BullseyeSegmentError', id: string, type: string, message: string } | { __typename?: 'BullseyeSegmentStatus', id: string, yesSize?: number | null, name: string, onlineStatus?: string | null, segmentStatus: string }> };

export type CampaignConfigLabelsFragment = { __typename?: 'CampaignConfiguration', id: string, name: string, isMCC: boolean };

export type CampaignConfigLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type CampaignConfigLabelsQuery = { __typename?: 'Query', campaignConfigurations: { __typename?: 'CampaignConfigurationConnection', nodes: Array<{ __typename?: 'CampaignConfiguration', id: string, name: string, isMCC: boolean }> } };

export type TrafficCampaignsFilterOptionValuesFragment = { __typename?: 'TrafficProjectCampaigns_Connection', filterOptionValues: { __typename?: 'FilterOptionValuesType', platform: Array<string>, productLine: Array<string>, createdBy: Array<string>, campaignType: Array<string>, language: Array<string>, status: Array<string>, liveness: Array<string> } };

export type ArchiveOrRestoreTrafficCampaignsMutationVariables = Exact<{
  input: ArchiveOrRestoreTrafficCampaignsInput;
}>;


export type ArchiveOrRestoreTrafficCampaignsMutation = { __typename?: 'Mutation', archiveOrRestoreTrafficCampaigns: { __typename?: 'ArchiveOrRestoreTrafficCampaignsMutationResponse', campaigns: Array<{ __typename?: 'TrafficCampaign', id: string }> } };

export type ArchiveOrRestoreTrafficCampaignMccMutationVariables = Exact<{
  input: ArchiveOrRestoreTrafficCampaignsInput;
}>;


export type ArchiveOrRestoreTrafficCampaignMccMutation = { __typename?: 'Mutation', archiveOrRestoreTrafficCampaigns: { __typename?: 'ArchiveOrRestoreTrafficCampaignsMutationResponse', campaigns: Array<{ __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } }> } };

export type PasteTrafficCampaignsToDifferentProjectMutationVariables = Exact<{
  input: PasteTrafficCampaignsToDifferentProjectInput;
}>;


export type PasteTrafficCampaignsToDifferentProjectMutation = { __typename?: 'Mutation', pasteTrafficCampaignsToDifferentProject: { __typename?: 'PasteTrafficCampaignsToDifferentProjectOutput', success: boolean } };

export type TrafficCampaignsTableDataFragment = { __typename?: 'TrafficCampaign', id: string, name: string, modifiedAt: string, createdBy: string, schema: string, schemaVersion: number, version: number, status: CampaignState, isArchived?: boolean | null, liveState?: LiveStateType | null, thumbnailURL?: string | null, globalContent?: any | null, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, content: any, active: boolean, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', accessControlGroup: string, businessGroup: string, language: string, marketingType: string, marketplace: string, pageId: string, platform: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, slots: Array<string>, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean } }>, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', productLine: string, accessControlGroup: string, businessGroup: string, marketingType: string, reason: string, mocarObjective?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null } | null } | null, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null };

export type TrafficCampaignsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sortOptions: TrafficCampaingsSortOptionsInput;
  includeLegacy: Scalars['Boolean']['input'];
  filterByView: CampaignFilterByViewInput;
  filterColumnMap: FilterColumnInputType;
  loadFromSymphony?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TrafficCampaignsQuery = { __typename?: 'Query', trafficProject: { __typename?: 'TrafficProject', id: string, campaigns: { __typename?: 'TrafficProjectCampaigns_Connection', totalCount: number, edges: Array<{ __typename?: 'TrafficCampaignEdge', cursor: string, node: { __typename?: 'TrafficCampaign', id: string, name: string, modifiedAt: string, createdBy: string, schema: string, schemaVersion: number, version: number, status: CampaignState, isArchived?: boolean | null, liveState?: LiveStateType | null, thumbnailURL?: string | null, globalContent?: any | null, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, content: any, active: boolean, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', accessControlGroup: string, businessGroup: string, language: string, marketingType: string, marketplace: string, pageId: string, platform: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, slots: Array<string>, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean } }>, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', productLine: string, accessControlGroup: string, businessGroup: string, marketingType: string, reason: string, mocarObjective?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null } | null } | null, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, filterOptionValues: { __typename?: 'FilterOptionValuesType', platform: Array<string>, productLine: Array<string>, createdBy: Array<string>, campaignType: Array<string>, language: Array<string>, status: Array<string>, liveness: Array<string> } }, events?: Array<{ __typename?: 'TrafficEventImportedFromSymphony', parentEventId?: string | null, realm?: SymphonyRealm | null, name?: string | null, timezone?: string | null, businessControlGroup?: string | null, accessControlGroup?: string | null, ranges: Array<{ __typename?: 'TrafficEventDateRange', elemId: string, dateRangeType: TrafficDateRangeTypeName, childEventId?: string | null, title?: string | null, start?: string | null, end?: string | null }> } | { __typename?: 'TrafficEventJourneysCreated', parentEventId?: string | null, realm?: SymphonyRealm | null, name?: string | null, ranges: Array<{ __typename?: 'TrafficEventDateRange', elemId: string, dateRangeType: TrafficDateRangeTypeName, childEventId?: string | null, title?: string | null, start?: string | null, end?: string | null }> }> | null } };

export type TrafficCampaignStatusBadgeDataFragment = { __typename?: 'TrafficCampaign', id: string, status: CampaignState, liveState?: LiveStateType | null, isArchived?: boolean | null };

export type TrafficCampaignStatusBadgeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type TrafficCampaignStatusBadgeQuery = { __typename?: 'Query', trafficCampaign: { __typename?: 'TrafficCampaign', id: string, status: CampaignState, liveState?: LiveStateType | null, isArchived?: boolean | null } };

export type RequestApprovalTrafficCampaignPlacementsMutationVariables = Exact<{
  input: TransitionTrafficCampaignPlacementsInput;
}>;


export type RequestApprovalTrafficCampaignPlacementsMutation = { __typename?: 'Mutation', transitionTrafficCampaignPlacements: { __typename?: 'TrafficCampaign', id: string, name: string, schema: string, thumbnailURL?: string | null, globalContent?: any | null, isArchived?: boolean | null, modifiedAt: string, version: number, schemaVersion: number, status: CampaignState, liveState?: LiveStateType | null, createdBy: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, content: any, creativeName?: string | null, hasGeneratedName?: boolean | null, variant?: string | null, status?: CampaignState | null, liveState?: LiveStateType | null, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string, platform: string, accessControlGroup: string, businessGroup: string, language: string, marketingType: string, pageId: string, productLine: string, reason: string, placements: Array<{ __typename?: 'TrafficCampaignPlacement', guarantee: number, placementGroupId?: string | null, id: string, eligibilityCriteria: { __typename?: 'TrafficEligibilityCriteria', slots: Array<string>, additionalExcludes: any, additionalIncludes: any, asins: Array<string>, browseNodes: Array<string>, bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, categoryNode?: Array<string> | null, widgetGroup?: string | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, impressionsDaysTimeout?: number | null, impressionsLimit?: number | null, languages: Array<string>, mvtAssignmentId?: string | null, mvtName?: string | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, pageId?: string | null, pageType?: string | null, platform?: string | null, recognizedOrUnrecognized: string, scheduleType?: string | null, weblabName?: string | null, weblabTreatment?: string | null, keywords?: Array<string> | null, timeRange: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, childEventId?: string | null, elemId: string } } }> }, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', realm: SymphonyRealm, symphonyId: string, symphonyPreviewUrl?: string | null, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, contents: Array<{ __typename?: 'TrafficSymphonyContent', id: string, symphonyId: string, locale: string, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, placements: Array<{ __typename?: 'TrafficSymphonyPlacement', relatedPlacement: { __typename?: 'TrafficCampaignPlacement', id: string, placementGroupId?: string | null }, status?: { __typename?: 'StatusSummary', liveState: LiveStateType, workflowId?: string | null, workflowState?: WorkflowStateType | null, objectState?: ObjectStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType } | null, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null }>, errors?: Array<{ __typename?: 'TrafficErrorSchema', message: string, errorType: string, createdAt: string, sourceId?: string | null, userFriendlyMessage?: string | null }> | null } }>, placements?: { __typename?: 'TrafficCampaignPlacementData', defaults?: { __typename?: 'TrafficCampaignPlacementDefaults', asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, eventPages?: Array<string> | null, slotsDesktop?: Array<string> | null, slotsMobile?: Array<string> | null, slotsPlatformAgnostic?: Array<string> | null, scheduleType?: string | null, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementDefaultVariantCriteria', slots: Array<string>, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementDefaultImpression', limit?: number | null, daysTimeout?: number | null } | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementDefaultWeblab', name?: string | null, treatment?: string | null } | null } | null, groups?: Array<{ __typename?: 'TrafficPlacementGroup', flavorIds: Array<string>, guarantee: number, id: string, name?: string | null, scheduling?: Array<{ __typename?: 'PlacementGroupSchedulingInfo', flavorId?: string | null, locale?: string | null, platforms?: Array<string> | null }> | null, eligibilityCriteria: { __typename?: 'TrafficCampaignEligibilityCriteria', additionalExcludes: any, additionalIncludes: any, asins: Array<string>, bullseyeDefault?: boolean | null, browseNodes: Array<string>, categoryNode?: Array<string> | null, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, containerId?: any | null, containerType?: any | null, deviceTypes: Array<string>, keywords?: Array<string> | null, eventPages?: Array<string> | null, mvtAssignmentId?: string | null, mvtName?: string | null, pageId?: string | null, pageType?: string | null, customerOptions: CustomerOptions, scheduleType?: string | null, schedulingDefault?: boolean | null, timeRangeDefault?: boolean | null, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null, marketplaceCriteria?: Array<{ __typename?: 'EligibilityCriteriaMarketplace', bullseyeExcludes: Array<any>, bullseyeIncludes: Array<any>, marketplace: string, ddsAsinGroups?: Array<string> | null, subscriptionProductPageIds?: Array<string> | null, asins?: Array<string> | null, browseNodes?: Array<string> | null, categoryNode?: Array<string> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null }> | null, variantCriteria?: Array<{ __typename?: 'PlacementGroupVariantCriteria', slots: Array<string>, useDefaultSlot: boolean, variantId: string, impressions?: { __typename?: 'TrafficCampaignPlacementImpression', limit?: number | null, daysTimeout?: number | null, limitDefault?: boolean | null, daysTimeoutDefault?: boolean | null } | null }> | null, platformCriteria?: Array<{ __typename?: 'EligibilityCriteriaPlatform', platform: string, slots: Array<string>, useDefault?: boolean | null }> | null, timeRange?: { __typename?: 'TrafficCustomDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEmptyDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null } | { __typename?: 'TrafficEventDateRange', dateRangeType: TrafficDateRangeTypeName, start?: string | null, end?: string | null, elemId: string } | null, weblab?: { __typename?: 'TrafficCampaignPlacementWeblab', name?: string | null, treatment?: string | null, nameDefault?: boolean | null, treatmentDefault?: boolean | null } | null } }> | null } | null, varSharing?: { __typename?: 'TrafficCampaignVariableSharing', sharedVarsMap: any, inlineEditorMeta: any, dmccOverrideMap?: any | null } | null, common?: { __typename?: 'TrafficCampaignCommonData', accessControlGroup: string, businessGroup: string, marketingType: string, mocarObjective?: string | null, productLine: string, reason: string, programs?: Array<string> | null, programSubGroup?: string | null, autoName?: { __typename?: 'TrafficCampaignAutoNameData', additionalText?: string | null, alexaEnabled?: string | null, creativeType?: string | null, eventShortName?: string | null, isAutoGenerated?: boolean | null, program?: string | null, slot?: string | null, pageType?: string | null } | null } | null, project: { __typename?: 'TrafficProject', id: string } } };

export type MccRequestApprovalPlacementsButtonFragment = { __typename?: 'TrafficCampaign', id: string, schema: string, project: { __typename?: 'TrafficProject', id: string }, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', active: boolean, id: string, symphony: { __typename?: 'TrafficFlavorSymphonyMetadataDraft', published: boolean } | { __typename?: 'TrafficFlavorSymphonyMetadataPublished', published: boolean, creatives: Array<{ __typename?: 'TrafficSymphonyCreative', status?: { __typename?: 'StatusSummary', objectState?: ObjectStateType | null, workflowState?: WorkflowStateType | null, active?: boolean | null, errors?: Array<string> | null, partiallyApproved: PartiallyApprovedType, liveState: LiveStateType } | null }> }, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', placements: Array<{ __typename?: 'TrafficCampaignPlacement', id: string }> } }> };

export type ValidateFlavorContentConfigurationFragment = { __typename?: 'ContentConfiguration', jsonSchema: any };

export type AsinsForProgramQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filters?: InputMaybe<AsinFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
  sortOptions?: InputMaybe<Array<AsinSortInput> | AsinSortInput>;
}>;


export type AsinsForProgramQuery = { __typename?: 'Query', asins: { __typename?: 'QueryAsins_Connection', totalCount: number, nodes: Array<{ __typename?: 'ASIN', asin: string }> } };

export type MetadataForAsinsQueryVariables = Exact<{
  asinList: Array<Scalars['String']['input']> | Scalars['String']['input'];
  marketplace: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type MetadataForAsinsQuery = { __typename?: 'Query', mvesCatalogTitles: Array<{ __typename?: 'AsinAndCatalogTitle', title: string }>, mvesVariantImagesForAsins: Array<{ __typename?: 'AsinAndCatalogVariantImages', images?: any | null }> };

export type FbKeywordRecsQueryVariables = Exact<{
  input: GetFbKeywordRecsInput;
}>;


export type FbKeywordRecsQuery = { __typename?: 'Query', fbKeywordRecs: { __typename?: 'GetFBKeywordRecsResponse', keywordRecsUrl: string, expirationDate: any } };

export type ProgramsForMarketplaceQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filters?: InputMaybe<ProgramFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
  sortOptions?: InputMaybe<Array<ProgramSortInput> | ProgramSortInput>;
}>;


export type ProgramsForMarketplaceQuery = { __typename?: 'Query', programs: { __typename?: 'QueryPrograms_Connection', nodes: Array<{ __typename?: 'Program', id: string, name: string, programId: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type GetAssetsByIdsQueryVariables = Exact<{
  input: GetAssetsByIdsInput;
}>;


export type GetAssetsByIdsQuery = { __typename?: 'Query', getAssetsByIds: { __typename?: 'GetAssetsByIdsOutput', errors: Array<string>, assets: Array<{ __typename?: 'AssetSearchResult', assetId: string, s3SignedUrlGet?: string | null, thumbnail?: string | null, name: string }> } };

export type ComponentDetailsV2QueryVariables = Exact<{
  input: ComponentDetailsInput;
}>;


export type ComponentDetailsV2Query = { __typename?: 'Query', componentDetailsV2: { __typename?: 'ComponentDetailsV2QueryResponse', componentVersion: string, componentNamespace: string, componentName: string } };

export type CampaignConfigProviderCampaignFragment = { __typename?: 'CampaignConfiguration', id: string, name: string, shortName: string, version: number, featureGroups?: Array<string> | null, pageType: PageTypeEnum, isMCC: boolean, requiresCBR: boolean, hasMultiPlatformFlavors: boolean, isPlatformAgnostic?: boolean | null, requiresMocar: boolean, contentConfiguration: { __typename?: 'ContentConfiguration', jsonSchema: any, uiSchema?: any | null, customValidate?: string | null }, componentInfos: Array<{ __typename?: 'ComponentInfoVariant', variant: string, componentInfo: { __typename?: 'ComponentInfo', name: string, namespace: string, version: string } }>, placementsSection: { __typename?: 'PlacementsSectionConfig', customerOptions: CustomerOptionsConfigEnum, placementDefaultsEnabled: boolean, placementComponents: Array<{ __typename?: 'PlacementComponent', component: string, enabled: boolean }>, initialPlacementValues?: { __typename?: 'InitialPlacementValues', schedulingDefault?: boolean | null, pageType?: PageTypeEnum | null } | null, slotOptions: { __typename?: 'StandardSlotOptions', standard: Array<{ __typename?: 'ScopedSlotOption', scope: string, variantSlots: Array<{ __typename?: 'VariantSlot', variant: string, slots: Array<string> }> }> } | { __typename?: 'VariantSlotOptions', variant: Array<{ __typename?: 'ScopedVariantSlotOption', scope: string, variantSlots: Array<{ __typename?: 'VariantSlot', variant: string, slots: Array<string> }> }> } }, sharingOptions?: { __typename?: 'SharingOptions', disablePlatformSharing?: boolean | null } | null, overviewConfiguration?: { __typename?: 'OverviewConfiguration', autoNaming: { __typename?: 'AutoNamingConfiguration', supportedInputs: any } } | null, publishing?: { __typename?: 'PublishingConfiguration', creativeNamePrefixOverrideKey?: string | null, widgetType?: WidgetType | null } | null, livePreviewConfiguration?: { __typename?: 'LivePreviewConfiguration', supportsLivePreview: boolean, isMarsWidget?: boolean | null, keepProvidedStyles?: boolean | null, needsAuiJs?: boolean | null, supportsPlatformOverride?: boolean | null } | null };

export type CampaignConfigProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type CampaignConfigProviderQuery = { __typename?: 'Query', campaignConfigurations: { __typename?: 'CampaignConfigurationConnection', nodes: Array<{ __typename?: 'CampaignConfiguration', id: string, name: string, shortName: string, version: number, featureGroups?: Array<string> | null, pageType: PageTypeEnum, isMCC: boolean, requiresCBR: boolean, hasMultiPlatformFlavors: boolean, isPlatformAgnostic?: boolean | null, requiresMocar: boolean, contentConfiguration: { __typename?: 'ContentConfiguration', jsonSchema: any, uiSchema?: any | null, customValidate?: string | null }, componentInfos: Array<{ __typename?: 'ComponentInfoVariant', variant: string, componentInfo: { __typename?: 'ComponentInfo', name: string, namespace: string, version: string } }>, placementsSection: { __typename?: 'PlacementsSectionConfig', customerOptions: CustomerOptionsConfigEnum, placementDefaultsEnabled: boolean, placementComponents: Array<{ __typename?: 'PlacementComponent', component: string, enabled: boolean }>, initialPlacementValues?: { __typename?: 'InitialPlacementValues', schedulingDefault?: boolean | null, pageType?: PageTypeEnum | null } | null, slotOptions: { __typename?: 'StandardSlotOptions', standard: Array<{ __typename?: 'ScopedSlotOption', scope: string, variantSlots: Array<{ __typename?: 'VariantSlot', variant: string, slots: Array<string> }> }> } | { __typename?: 'VariantSlotOptions', variant: Array<{ __typename?: 'ScopedVariantSlotOption', scope: string, variantSlots: Array<{ __typename?: 'VariantSlot', variant: string, slots: Array<string> }> }> } }, sharingOptions?: { __typename?: 'SharingOptions', disablePlatformSharing?: boolean | null } | null, overviewConfiguration?: { __typename?: 'OverviewConfiguration', autoNaming: { __typename?: 'AutoNamingConfiguration', supportedInputs: any } } | null, publishing?: { __typename?: 'PublishingConfiguration', creativeNamePrefixOverrideKey?: string | null, widgetType?: WidgetType | null } | null, livePreviewConfiguration?: { __typename?: 'LivePreviewConfiguration', supportsLivePreview: boolean, isMarsWidget?: boolean | null, keepProvidedStyles?: boolean | null, needsAuiJs?: boolean | null, supportsPlatformOverride?: boolean | null } | null }> } };

export type CampaignConfigsDropdownListFragment = { __typename?: 'CampaignConfiguration', id: string, name: string, pageType: PageTypeEnum, featureGroups?: Array<string> | null, isMCC: boolean };

export type CampaignConfigsDropdownListQueryVariables = Exact<{ [key: string]: never; }>;


export type CampaignConfigsDropdownListQuery = { __typename?: 'Query', campaignConfigurations: { __typename?: 'CampaignConfigurationConnection', nodes: Array<{ __typename?: 'CampaignConfiguration', id: string, name: string, pageType: PageTypeEnum, featureGroups?: Array<string> | null, isMCC: boolean }> } };

export type UseIsCampaignLockedFragment = { __typename?: 'TrafficCampaign', status: CampaignState };

export type UseCampaignUserCbrPermissionsFragment = { __typename?: 'TrafficCampaign', flavors: Array<{ __typename?: 'TrafficCampaignFlavor', active: boolean, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string } }> };

export type UseUserCanApproveOrRejectFlavorsFragment = { __typename?: 'TrafficCampaign', createdBy: string, schema: string, flavors: Array<{ __typename?: 'TrafficCampaignFlavor', id: string, active: boolean, scheduling: { __typename?: 'TrafficCampaignSchedulingInfo', marketplace: string } }> };

export type RenderMarsWidgetQueryVariables = Exact<{
  currencyCode: Scalars['String']['input'];
  language: Scalars['String']['input'];
  widget: MarsWidgetDefinition;
}>;


export type RenderMarsWidgetQuery = { __typename?: 'Query', renderMarsWidget: { __typename?: 'RenderMarsWidgetResponse', htmlFragments: string } };

export type TpAssetMapFragment = { __typename?: 'AssetSearchResult', assetId: string, s3SignedUrlGet?: string | null, mediaCentralUrls?: any | null, isPublishedMap?: any | null };

export type GetTpAssetMapQueryVariables = Exact<{
  input: AssetSearchRequest;
}>;


export type GetTpAssetMapQuery = { __typename?: 'Query', assetsSearch: { __typename?: 'AssetSearchResponses', results: Array<{ __typename?: 'AssetSearchResponse', searchResults: Array<{ __typename?: 'AssetSearchResult', assetId: string, s3SignedUrlGet?: string | null, mediaCentralUrls?: any | null, isPublishedMap?: any | null } | null> } | null> } };

export type WithinLaunchDateFragment = { __typename?: 'ASIN', id: string, launchGating: { __typename?: 'ASINLaunchGating', attributeChecked: AsinLaunchGatingAttributeEnum, beyondLaunchDate: boolean, withinLaunchDate: boolean, launchDateThreshold: number, gatingAsin?: string | null } };

export const ProductLineSelectFragmentDoc = gql`
    fragment ProductLineSelect on ProductLine2 {
  id
  name
}
    `;
export const ProgramSelectFragmentDoc = gql`
    fragment ProgramSelect on Program {
  id
  name
}
    `;
export const AsinTableCellFragmentDoc = gql`
    fragment AsinTableCell on ASIN {
  asin
  productId
  marketplace {
    id
    country
  }
  program {
    id
    name
    programId
  }
}
    `;
export const BulkPublishJobResultFragmentDoc = gql`
    fragment BulkPublishJobResult on BulkPublishJob {
  id
  status
  metadata {
    results {
      asinVertexId
      status
      error {
        message
        type
      }
    }
  }
}
    `;
export const JagNameFragmentDoc = gql`
    fragment jagName on AssetGroup {
  name
}
    `;
export const TrafficProjectNameFragmentDoc = gql`
    fragment trafficProjectName on TrafficProject {
  name
}
    `;
export const AssetFieldsFragmentDoc = gql`
    fragment AssetFields on AssetSearchResult {
  archived
  assetId
  assetMetadata {
    height
    width
  }
  device
  docId
  docName
  isPublishedMap
  mediaCentralUrls
  modifiedBy
  modifiedDate
  name
  platform
  productLine
  originalAssetS3Get
  s3SignedUrlGet
  s3SignedUrlPut
  size
  tags
  thumbnail
  uploadedAt
  uploadedBy
}
    `;
export const BulkAtfJobDetailsFragmentDoc = gql`
    fragment BulkAtfJobDetails on BulkAtfJob {
  id
  status
  metadata {
    results {
      jobError {
        errorMessage
      }
      rowResults {
        asin
        marketplace
        rowErrors {
          ... on ErrorASINMarketplaceNotFound {
            errorMessage
          }
          ... on AttributeOrPricingErrors {
            name
            value
            errorType
            errorMessage
          }
        }
        rowNumber
        success
      }
      totalRowCount
    }
    bulkPublishExecutionIdList
  }
}
    `;
export const VariantUrlNamesFragmentDoc = gql`
    fragment VariantUrlNames on BulkSlateImageResponse {
  asin
  marketplace
  productId
  slates {
    assetId
    variant
    version
    url
  }
}
    `;
export const ProductIdNameFieldsSegmentFragmentDoc = gql`
    fragment ProductIdNameFieldsSegment on ProductIdAndProductNameStatus {
  asin
  marketplace
  products {
    id
    title
    ghostProjects
    businessGroupsIds
    accessControlGroups
    detailPages {
      title
      marketplace
      merchantId
      asin
      image
      permissionsGroup {
        attributesAndPricing
        campaignsAndSlates
      }
    }
  }
}
    `;
export const ProductIdNameFieldsErrorFragmentDoc = gql`
    fragment ProductIdNameFieldsError on ProductIdAndProductNameError {
  asin
  marketplace
  error
}
    `;
export const CampaignFieldsFragmentDoc = gql`
    fragment CampaignFields on Campaign {
  accessControlGroup
  additionalName
  alexaEnabled
  businessGroup
  createdAt
  createdBy
  campaignTypeVersion
  content
  errors
  eventShortName
  id
  intent
  isArchived
  isAutoGenerateCreativeName
  isLocked
  isMVT
  language
  modifiedAt
  modifiedBy
  languageOptions
  liveState
  mvtExperimentInfo {
    combinations {
      dimensionVariantList {
        dimensionName
        variantName
      }
      id
      isDefault
      isExcluded
    }
    dimensions {
      name
      variants
    }
    experimentList {
      experimentId
      metricUrl
      placementId
      status
    }
  }
  placements {
    additionalExcludes
    additionalIncludes
    asins
    browseNodes
    bullseyeExcludes
    bullseyeIncludes
    categoryNode
    customerTargeting
    deviceTypes
    event {
      childEventId
      elemId
    }
    guarantee
    impressionsDaysTimeout
    impressionsLimit
    kothOrGuarantee
    languages
    mvtAssignmentId
    mvtName
    pageId
    pageType
    platform
    scheduleType
    slot
    state
    symphonyPreviewUrl
    timeRange {
      start
      end
    }
    uiId
    weblabName
    weblabTreatment
  }
  productLine
  program
  projectId
  reason
  state
  symphonyInfo {
    mvtCombinationId
    placementMapping {
      placementUiId
      symphonyPlacementId
      symphonyPreviewURL
      lastUpdatedHash
    }
    symphonyCreativeId
    lastUpdatedHash
  }
  tags
  title
  typeId
  useReactAppUrl
  userVersion
}
    `;
export const AttributeFieldsFragmentDoc = gql`
    fragment AttributeFields on DpAttribute {
  key
  language
  value
  version
  modifiedAt
  modifiedBy
  issues
  removed
  lastPublishedVersion
  lastPublishedDate
  publishResult {
    status
    success
    result
  }
}
    `;
export const BundleInfoTabTypeFragmentDoc = gql`
    fragment BundleInfoTabType on ComponentAsin {
  programName
  __typename
}
    `;
export const ProductFieldsFragmentDoc = gql`
    fragment ProductFields on Product {
  id
  title
  ghostProjects
  businessGroupsIds
  accessControlGroups
  detailPages {
    title
    marketplace
    merchantId
    asin
    image
    permissionsGroup {
      attributesAndPricing
      campaignsAndSlates
    }
  }
}
    `;
export const DetailPageStatusFieldsFragmentDoc = gql`
    fragment DetailPageStatusFields on DetailPageStatusQueryResponse {
  status
  productId
  error
  code
}
    `;
export const DetailPageTabsContainerProductFragmentDoc = gql`
    fragment detailPageTabsContainerProduct on Product {
  id
  detailPages {
    title
    merchantId
    asin
    image
    permissionsGroup {
      attributesAndPricing
      campaignsAndSlates
    }
  }
}
    `;
export const WithinLaunchDateFragmentDoc = gql`
    fragment WithinLaunchDate on ASIN {
  id
  launchGating {
    attributeChecked
    beyondLaunchDate
    withinLaunchDate
    launchDateThreshold
    gatingAsin
  }
}
    `;
export const SlatesTabAsinFragmentDoc = gql`
    fragment SlatesTabAsin on ASIN {
  asin
  canPublishSlates: canAct(action: PublishSlates) {
    ... on CanActAllowedResponse {
      allowed
    }
    ... on CanActDisallowedResponse {
      allowed
      reason
    }
  }
}
    `;
export const PricingTabAsinFragmentDoc = gql`
    fragment PricingTabAsin on ASIN {
  asin
  canPublishPricingAttributes: canAct(action: PublishPricing) {
    ... on CanActAllowedResponse {
      allowed
    }
    ... on CanActDisallowedResponse {
      allowed
      reason
    }
  }
  canPublishConfidentialAttributes: canAct(action: PublishConfidentialAttributes) {
    ... on CanActAllowedResponse {
      allowed
    }
    ... on CanActDisallowedResponse {
      allowed
      reason
    }
  }
}
    `;
export const AttributesTabAsinFragmentDoc = gql`
    fragment AttributesTabAsin on ASIN {
  asin
  canPublishConfidentialAttributes: canAct(action: PublishConfidentialAttributes) {
    ... on CanActAllowedResponse {
      allowed
    }
    ... on CanActDisallowedResponse {
      allowed
      reason
    }
  }
  canPublishNonConfidentialAttributes: canAct(
    action: PublishNonConfidentialAttributes
  ) {
    ... on CanActAllowedResponse {
      allowed
    }
    ... on CanActDisallowedResponse {
      allowed
      reason
    }
  }
  canPublishSensitiveAttributes: canAct(action: PublishSensitiveAttributes) {
    ... on CanActAllowedResponse {
      allowed
    }
    ... on CanActDisallowedResponse {
      allowed
      reason
    }
  }
}
    `;
export const DetailPageTabsContainerAsinFragmentDoc = gql`
    fragment DetailPageTabsContainerAsin on ASIN {
  id
  announceDate
  asin
  ...WithinLaunchDate
  ...SlatesTabAsin
  ...PricingTabAsin
  ...AttributesTabAsin
}
    ${WithinLaunchDateFragmentDoc}
${SlatesTabAsinFragmentDoc}
${PricingTabAsinFragmentDoc}
${AttributesTabAsinFragmentDoc}`;
export const BundleAsinsFragmentDoc = gql`
    fragment BundleAsins on BundleAsins {
  bundleAsins {
    bundleAsin
    bundleName
    image
    otherComponents
  }
  __typename
}
    `;
export const ComponentAsinFragmentDoc = gql`
    fragment ComponentAsin on ComponentAsin {
  bundleBaseComponent
  bundleComponents
  componentDescription {
    asin
    data
  }
  componentQuantity {
    asin
    data
  }
  componentImage {
    asin
    data
  }
  programName
  __typename
}
    `;
export const CampaignConfigIdFragmentDoc = gql`
    fragment CampaignConfigId on CampaignConfiguration {
  id
}
    `;
export const TrafficCampaignRowFragmentDoc = gql`
    fragment TrafficCampaignRow on TrafficCampaign {
  id
  name
  status
  createdBy
  schema
  isArchived
  liveState
  project {
    ... on TrafficProject {
      id
    }
  }
  flavors {
    id
    scheduling {
      productLine
      platform
      language
      placements {
        eligibilityCriteria {
          scheduleType
          asins
          platform
          timeRange {
            ... on TrafficCustomDateRange {
              dateRangeType
              start
              end
            }
          }
        }
      }
    }
    symphony {
      ... on TrafficFlavorSymphonyMetadataDraft {
        published
      }
      ... on TrafficFlavorSymphonyMetadataPublished {
        creatives {
          status {
            liveState
          }
        }
        published
      }
    }
  }
}
    `;
export const CampaignsTabTrafficProjectInfoFragmentDoc = gql`
    fragment CampaignsTabTrafficProjectInfo on TrafficProject {
  id
  name
  modifiedBy
  modifiedAt
  createdBy
  createdAt
  campaigns(first: 200, filterByView: $filterByView) {
    nodes {
      ...TrafficCampaignRow
    }
  }
}
    ${TrafficCampaignRowFragmentDoc}`;
export const TitleVariantDataFragmentDoc = gql`
    fragment titleVariantData on DpTitleVariant {
  lastPublishedDate
  lastPublishedVersion
  previewed
  publishResult {
    result
    status
    success
  }
  uniqueReferenceId
  updatedAt
  updatedBy
  variantId
  version
  locale
  titleString
  genaiTitleString
}
    `;
export const BulletsVariantDataFragmentDoc = gql`
    fragment bulletsVariantData on DpBulletsVariant {
  lastPublishedDate
  lastPublishedVersion
  previewed
  publishResult {
    result
    status
    success
  }
  uniqueReferenceId
  updatedAt
  updatedBy
  variantId
  version
  locale
  bulletStrings
  genaiBulletStrings
}
    `;
export const LandingImageVariantDataFragmentDoc = gql`
    fragment landingImageVariantData on DpLandingImageVariant {
  lastPublishedDate
  lastPublishedVersion
  previewed
  publishResult {
    result
    status
    success
  }
  uniqueReferenceId
  updatedAt
  updatedBy
  variantId
  version
  assetId
  mcVariant
  platform
  shipmentId
  url
}
    `;
export const MarketplaceExperimentConfigFragmentFragmentDoc = gql`
    fragment marketplaceExperimentConfigFragment on MarketplaceExperimentConfig {
  id
  marketplace {
    id
    obfuscatedMarketplaceId
    country
  }
  locales
  primaryAsin
  asinConfigs {
    asin
    asinConfigId
    featureVariants {
      titles {
        variantId
        variantPosition
        variantName
        uniqueReferenceId
        updatedBy
        updatedAt
        lastPublishedVersion
        lastPublishedDate
        previewed
        locale
        titleString
        status
      }
      bullets {
        variantId
        variantPosition
        variantName
        uniqueReferenceId
        updatedBy
        updatedAt
        lastPublishedVersion
        lastPublishedDate
        previewed
        locale
        bulletStrings
        status
      }
      landingImages {
        variantId
        variantPosition
        variantName
        uniqueReferenceId
        updatedBy
        updatedAt
        lastPublishedVersion
        lastPublishedDate
        previewed
        assetId
        url
        platform
        mcVariant
        locale
        shipmentId
        status
      }
    }
  }
  contextualCohortType
  bullseyeSegments {
    bullseyeSegmentId
    position
    titleExclusions
    bulletExclusions
    landingImageExclusions
  }
  activationDate
  deactivationDate
  status
}
    `;
export const TcPreviewEligibilityCriteriaFragmentDoc = gql`
    fragment TCPreviewEligibilityCriteria on TrafficEligibilityCriteria {
  scheduleType
  asins
  slots
  platform
  browseNodes
  bullseyeExcludes
  bullseyeIncludes
  additionalIncludes
  additionalExcludes
  timeRange {
    ... on TrafficCustomDateRange {
      dateRangeType
      start
      end
    }
    ... on TrafficEventDateRange {
      dateRangeType
      start
      end
      childEventId
      elemId
    }
    ... on TrafficEmptyDateRange {
      dateRangeType
      start
      end
    }
  }
  categoryNode
  containerId
  containerType
  languages
  pageId
  pageType
}
    `;
export const TcPreviewPlacementFragmentDoc = gql`
    fragment TCPreviewPlacement on TrafficCampaignPlacement {
  id
  eligibilityCriteria {
    ...TCPreviewEligibilityCriteria
  }
}
    ${TcPreviewEligibilityCriteriaFragmentDoc}`;
export const TcPreviewFlavorFragmentDoc = gql`
    fragment TCPreviewFlavor on TrafficCampaignFlavor {
  active
  id
  content
  scheduling {
    marketplace
    language
    platform
    placements {
      ...TCPreviewPlacement
    }
  }
}
    ${TcPreviewPlacementFragmentDoc}`;
export const TcPreviewCampaignFragmentDoc = gql`
    fragment TCPreviewCampaign on TrafficCampaign {
  id
  name
  schema
  schemaVersion
  thumbnailURL
  globalContent
  flavors {
    ...TCPreviewFlavor
  }
  varSharing {
    sharedVarsMap
    inlineEditorMeta
    dmccOverrideMap
  }
  common {
    accessControlGroup
    businessGroup
    marketingType
    mocarObjective
    productLine
    reason
  }
}
    ${TcPreviewFlavorFragmentDoc}`;
export const NavigateToAsinSearchProductIdErrorFragmentDoc = gql`
    fragment NavigateToASINSearchProductIDError on ProductIdQueryResponse {
  error
  code
}
    `;
export const NavigateToProgramSelectFragmentDoc = gql`
    fragment NavigateToProgramSelect on Program {
  id
  name
  programId
}
    `;
export const JagListViewFragmentDoc = gql`
    fragment JagListView on AssetGroup {
  id
  name
  rvn
  createdAt
  createdBy
  updatedAt
  updatedBy
  templateGroup {
    name
  }
  layeredImageAssets(first: $first) {
    marketplaces {
      id
      locales(first: $first) {
        edges {
          displayName
          node {
            id
          }
        }
      }
    }
    nodes {
      id
      marketplace {
        id
      }
      locale {
        id
        display
      }
      reviews {
        id
        status
        comment
      }
    }
  }
}
    `;
export const ProjectFragmentDoc = gql`
    fragment Project on TrafficProject {
  id
  name
}
    `;
export const LdapGroupSelectFragmentDoc = gql`
    fragment LDAPGroupSelect on TrafficProjectLdapPermission {
  action
  ldapGroup
  permissionType
}
    `;
export const LdapPermissionsTablePermissionFragmentDoc = gql`
    fragment LDAPPermissionsTablePermission on TrafficProjectLdapPermission {
  action
  ldapGroup
  permissionType
}
    `;
export const LdapPermissionsTableRowPermissionLdapDataFragmentDoc = gql`
    fragment LDAPPermissionsTableRowPermissionLDAPData on TrafficProjectLdapPermission {
  action
  ldapGroup
}
    `;
export const LdapPermissionRowLdapGroupNameCellDataFragmentDoc = gql`
    fragment LDAPPermissionRowLDAPGroupNameCellData on TrafficProjectLdapPermission {
  ldapGroup
}
    `;
export const TpShareModalProjectDataFragmentDoc = gql`
    fragment TPShareModalProjectData on TrafficProject {
  id
  createdBy
}
    `;
export const TpShareModalUserPermissionFragmentDoc = gql`
    fragment TPShareModalUserPermission on TrafficProjectUserPermission {
  action
  user {
    firstName
    lastName
    alias
  }
  permissionType
}
    `;
export const TpShareModalLdapPermissionFragmentDoc = gql`
    fragment TPShareModalLDAPPermission on TrafficProjectLdapPermission {
  action
  ldapGroup
  permissionType
}
    `;
export const TpShareModalDataFragmentDoc = gql`
    fragment TPShareModalData on TrafficProject {
  ...TPShareModalProjectData
  permissions {
    ...TPShareModalUserPermission
    ...TPShareModalLDAPPermission
  }
}
    ${TpShareModalProjectDataFragmentDoc}
${TpShareModalUserPermissionFragmentDoc}
${TpShareModalLdapPermissionFragmentDoc}`;
export const TpShareModalUserDataFragmentDoc = gql`
    fragment TPShareModalUserData on User {
  alias
}
    `;
export const PapiSearchFieldPapiUserSuggestionFragmentDoc = gql`
    fragment PAPISearchFieldPAPIUserSuggestion on papiUser {
  firstName
  lastName
  login
  businessTitle
}
    `;
export const PapiSearchFieldPapiUserFragmentDoc = gql`
    fragment PAPISearchFieldPAPIUser on papiUser {
  login
  ...PAPISearchFieldPAPIUserSuggestion
}
    ${PapiSearchFieldPapiUserSuggestionFragmentDoc}`;
export const UsersPermissionTableRowUserNameCellFragmentDoc = gql`
    fragment UsersPermissionTableRowUserNameCell on TrafficProjectUser {
  firstName
  lastName
  alias
}
    `;
export const UsersPermissionTableRowUserAliasCellFragmentDoc = gql`
    fragment UsersPermissionTableRowUserAliasCell on TrafficProjectUser {
  alias
}
    `;
export const UsersTableRowUserDataFragmentDoc = gql`
    fragment UsersTableRowUserData on TrafficProjectUser {
  firstName
  lastName
  alias
  ...UsersPermissionTableRowUserNameCell
  ...UsersPermissionTableRowUserAliasCell
}
    ${UsersPermissionTableRowUserNameCellFragmentDoc}
${UsersPermissionTableRowUserAliasCellFragmentDoc}`;
export const UsersTableRowProjectDataFragmentDoc = gql`
    fragment UsersTableRowProjectData on TrafficProject {
  createdBy
}
    `;
export const UsersTableRowUserPermissionDataFragmentDoc = gql`
    fragment UsersTableRowUserPermissionData on TrafficProjectUserPermission {
  action
}
    `;
export const PermissionTablePermissionActionCellFragmentDoc = gql`
    fragment PermissionTablePermissionActionCell on TrafficProjectUserPermission {
  action
}
    `;
export const PermissionTablePermissionActionUserDataFragmentDoc = gql`
    fragment PermissionTablePermissionActionUserData on TrafficProjectUser {
  alias
}
    `;
export const PermissionTablePermissionActionCellProjectDataFragmentDoc = gql`
    fragment PermissionTablePermissionActionCellProjectData on TrafficProject {
  createdBy
}
    `;
export const UsersPermissionTableUserPermissionFragmentDoc = gql`
    fragment UsersPermissionTableUserPermission on TrafficProjectUserPermission {
  action
  user {
    firstName
    lastName
    alias
  }
  permissionType
}
    `;
export const UsersTableUserFragmentDoc = gql`
    fragment UsersTableUser on TrafficProjectUser {
  alias
}
    `;
export const UserTableProjectDataFragmentDoc = gql`
    fragment UserTableProjectData on TrafficProject {
  createdBy
}
    `;
export const TpEventFragmentDoc = gql`
    fragment TPEvent on TrafficProject {
  events {
    ... on TrafficEventJourneysCreated {
      parentEventId
      realm
      name
      ranges {
        elemId
        dateRangeType
        childEventId
        title
        start
        end
      }
    }
    ... on TrafficEventImportedFromSymphony {
      parentEventId
      realm
      name
      ranges {
        elemId
        dateRangeType
        childEventId
        title
        start
        end
      }
      timezone
      businessControlGroup
      accessControlGroup
    }
  }
}
    `;
export const ProjectsTableToolbarFragmentDoc = gql`
    fragment ProjectsTableToolbar on QueryTrafficProjectSearch_Connection {
  filterOptions {
    createdBy {
      option
      count
    }
  }
}
    `;
export const TrafficProjectsTableDataFragmentDoc = gql`
    fragment trafficProjectsTableData on TrafficProject {
  id
  name
  modifiedBy
  modifiedAt
  createdBy
  createdAt
  assets(first: 1) {
    edges {
      node {
        thumbnail
      }
    }
  }
}
    `;
export const TrafficCampaignPlacementFragmentDoc = gql`
    fragment TrafficCampaignPlacement on TrafficCampaignPlacement {
  eligibilityCriteria {
    additionalExcludes
    additionalIncludes
    asins
    browseNodes
    bullseyeExcludes
    bullseyeIncludes
    categoryNode
    widgetGroup
    containerId
    containerType
    deviceTypes
    impressionsDaysTimeout
    impressionsLimit
    languages
    mvtAssignmentId
    mvtName
    ddsAsinGroups
    subscriptionProductPageIds
    pageId
    pageType
    platform
    recognizedOrUnrecognized
    scheduleType
    slots
    timeRange {
      ... on TrafficCustomDateRange {
        dateRangeType
        start
        end
      }
      ... on TrafficEventDateRange {
        dateRangeType
        start
        end
        childEventId
        elemId
      }
      ... on TrafficEmptyDateRange {
        dateRangeType
        start
        end
      }
    }
    weblabName
    weblabTreatment
    keywords
  }
  guarantee
  placementGroupId
  id
}
    `;
export const TpCampaignSchedulingInfoFragmentDoc = gql`
    fragment TPCampaignSchedulingInfo on TrafficCampaignSchedulingInfo {
  accessControlGroup
  businessGroup
  language
  marketingType
  marketplace
  pageId
  placements {
    ...TrafficCampaignPlacement
  }
  platform
  productLine
  reason
}
    ${TrafficCampaignPlacementFragmentDoc}`;
export const TpCampaignPlacementsFragmentDoc = gql`
    fragment TPCampaignPlacements on TrafficCampaign {
  id
  project {
    id
  }
  flavors {
    id
    scheduling {
      ...TPCampaignSchedulingInfo
    }
    symphony {
      ... on TrafficFlavorSymphonyMetadataDraft {
        published
      }
      ... on TrafficFlavorSymphonyMetadataPublished {
        published
      }
    }
  }
}
    ${TpCampaignSchedulingInfoFragmentDoc}`;
export const PublishedAssetResultFragmentDoc = gql`
    fragment publishedAssetResult on CampaignAssetPublishResult {
  folderPath
  orgUnit
  extension
  publicUrl
  url
  assetId
  dimension {
    height
    width
  }
}
    `;
export const TpCampaignSaveButtonFragmentDoc = gql`
    fragment TPCampaignSaveButton on TrafficCampaign {
  id
  isArchived
  modifiedAt
  project {
    id
  }
  globalContent
  version
  schema
  schemaVersion
  status
  flavors {
    id
    active
    content
    creativeName
    hasGeneratedName
    scheduling {
      ...TPCampaignSchedulingInfo
    }
    symphony {
      ... on TrafficFlavorSymphonyMetadataDraft {
        published
      }
      ... on TrafficFlavorSymphonyMetadataPublished {
        published
      }
    }
    variant
  }
  common {
    accessControlGroup
    businessGroup
    marketingType
    mocarObjective
    productLine
    reason
  }
  varSharing {
    sharedVarsMap
    inlineEditorMeta
    dmccOverrideMap
  }
}
    ${TpCampaignSchedulingInfoFragmentDoc}`;
export const TpCampaignSidebarBadgesFragmentDoc = gql`
    fragment TPCampaignSidebarBadges on TrafficCampaign {
  flavors {
    symphony {
      ... on TrafficFlavorSymphonyMetadataDraft {
        published
      }
      ... on TrafficFlavorSymphonyMetadataPublished {
        creatives {
          status {
            liveState
          }
        }
        published
      }
    }
  }
  status
  isArchived
  liveState
}
    `;
export const TpCampaignPublishButtonFragmentDoc = gql`
    fragment TPCampaignPublishButton on TrafficCampaign {
  id
  schema
  name
  project {
    id
  }
  globalContent
  flavors {
    active
    id
    content
    creativeName
    scheduling {
      ...TPCampaignSchedulingInfo
    }
    symphony {
      ... on TrafficFlavorSymphonyMetadataDraft {
        published
      }
      ... on TrafficFlavorSymphonyMetadataPublished {
        published
        creatives {
          status {
            workflowId
            workflowState
          }
        }
      }
    }
    variant
  }
}
    ${TpCampaignSchedulingInfoFragmentDoc}`;
export const TpCampaignOpenInSymphonyButtonFragmentDoc = gql`
    fragment TPCampaignOpenInSymphonyButton on TrafficCampaign {
  flavors {
    symphony {
      ... on TrafficFlavorSymphonyMetadataDraft {
        published
      }
      ... on TrafficFlavorSymphonyMetadataPublished {
        published
        creatives {
          realm
          symphonyId
        }
      }
    }
  }
}
    `;
export const UseIsCampaignLockedFragmentDoc = gql`
    fragment useIsCampaignLocked on TrafficCampaign {
  status
}
    `;
export const TpCampaignApproveAllButtonFragmentDoc = gql`
    fragment TPCampaignApproveAllButton on TrafficCampaign {
  ...useIsCampaignLocked
  createdBy
  id
  schema
  project {
    id
  }
  flavors {
    active
    id
    scheduling {
      marketplace
    }
    symphony {
      ... on TrafficFlavorSymphonyMetadataDraft {
        published
      }
      ... on TrafficFlavorSymphonyMetadataPublished {
        published
        creatives {
          status {
            objectState
            workflowState
            active
            errors
            partiallyApproved
            liveState
          }
        }
      }
    }
  }
}
    ${UseIsCampaignLockedFragmentDoc}`;
export const TpCampaignPreviewInSymphonyButtonFragmentDoc = gql`
    fragment TPCampaignPreviewInSymphonyButton on TrafficCampaign {
  flavors {
    scheduling {
      marketplace
      platform
      placements {
        eligibilityCriteria {
          slots
        }
      }
    }
    symphony {
      ... on TrafficFlavorSymphonyMetadataDraft {
        published
      }
      ... on TrafficFlavorSymphonyMetadataPublished {
        published
        creatives {
          symphonyPreviewUrl
        }
      }
    }
  }
}
    `;
export const TpCampaignSuspendAllButtonFragmentDoc = gql`
    fragment TPCampaignSuspendAllButton on TrafficCampaign {
  id
  schema
  project {
    id
  }
  flavors {
    active
    id
    symphony {
      ... on TrafficFlavorSymphonyMetadataDraft {
        published
      }
      ... on TrafficFlavorSymphonyMetadataPublished {
        published
        creatives {
          status {
            objectState
            workflowState
            active
            errors
            partiallyApproved
            liveState
          }
        }
      }
    }
  }
}
    `;
export const TpCampaignCloneButtonFragmentDoc = gql`
    fragment TPCampaignCloneButton on TrafficCampaign {
  id
  project {
    id
  }
}
    `;
export const TpCampaignSidebarFragmentDoc = gql`
    fragment TPCampaignSidebar on TrafficCampaign {
  ...TPCampaignSaveButton
  ...TPCampaignSidebarBadges
  ...TPCampaignPublishButton
  ...TPCampaignOpenInSymphonyButton
  ...TPCampaignApproveAllButton
  ...TPCampaignPreviewInSymphonyButton
  ...TPCampaignSuspendAllButton
  ...TPCampaignCloneButton
}
    ${TpCampaignSaveButtonFragmentDoc}
${TpCampaignSidebarBadgesFragmentDoc}
${TpCampaignPublishButtonFragmentDoc}
${TpCampaignOpenInSymphonyButtonFragmentDoc}
${TpCampaignApproveAllButtonFragmentDoc}
${TpCampaignPreviewInSymphonyButtonFragmentDoc}
${TpCampaignSuspendAllButtonFragmentDoc}
${TpCampaignCloneButtonFragmentDoc}`;
export const FlavorContentEditorFragmentDoc = gql`
    fragment FlavorContentEditor on TrafficCampaignFlavor {
  content
  variant
}
    `;
export const FlavorStatusBadgeFragmentDoc = gql`
    fragment FlavorStatusBadge on TrafficCampaignFlavor {
  id
  status
  liveState
}
    `;
export const TpCampaignPlacementStatusFragmentDoc = gql`
    fragment TPCampaignPlacementStatus on TrafficFlavorSymphonyMetadataPublished {
  ... on TrafficFlavorSymphonyMetadataPublished {
    published
    creatives {
      contents {
        id
        symphonyId
        locale
      }
      placements {
        relatedPlacement {
          id
          placementGroupId
        }
        status {
          objectState
          workflowId
          workflowState
          active
          errors
          partiallyApproved
          liveState
        }
      }
    }
  }
}
    `;
export const SummaryTableErrorFragmentDoc = gql`
    fragment SummaryTableError on TrafficErrorSchema {
  message
  errorType
  createdAt
  sourceId
  userFriendlyMessage
}
    `;
export const DraftFlavorSummaryTableErrorsFragmentDoc = gql`
    fragment DraftFlavorSummaryTableErrors on TrafficFlavorSymphonyMetadataDraft {
  published
  errors {
    ...SummaryTableError
  }
}
    ${SummaryTableErrorFragmentDoc}`;
export const PublishedFlavorSummaryTableErrorsFragmentDoc = gql`
    fragment PublishedFlavorSummaryTableErrors on TrafficFlavorSymphonyMetadataPublished {
  published
  errors {
    ...SummaryTableError
  }
  creatives {
    errors {
      ...SummaryTableError
    }
    contents {
      errors {
        ...SummaryTableError
      }
    }
    placements {
      errors {
        ...SummaryTableError
      }
    }
  }
}
    ${SummaryTableErrorFragmentDoc}`;
export const TpCampaignRequiredFormFlavorFragmentDoc = gql`
    fragment TPCampaignRequiredFormFlavor on TrafficCampaignFlavor {
  id
  active
  creativeName
  hasGeneratedName
  ...FlavorContentEditor
  ...FlavorStatusBadge
  scheduling {
    ...TPCampaignSchedulingInfo
  }
  symphony {
    ...TPCampaignPlacementStatus
    ...DraftFlavorSummaryTableErrors
    ...PublishedFlavorSummaryTableErrors
  }
}
    ${FlavorContentEditorFragmentDoc}
${FlavorStatusBadgeFragmentDoc}
${TpCampaignSchedulingInfoFragmentDoc}
${TpCampaignPlacementStatusFragmentDoc}
${DraftFlavorSummaryTableErrorsFragmentDoc}
${PublishedFlavorSummaryTableErrorsFragmentDoc}`;
export const EligibilityCriteriaMarketplaceFragmentDoc = gql`
    fragment EligibilityCriteriaMarketplace on EligibilityCriteriaMarketplace {
  bullseyeExcludes
  bullseyeIncludes
  marketplace
  ddsAsinGroups
  subscriptionProductPageIds
  asins
  browseNodes
  categoryNode
  timeRange {
    ... on TrafficCustomDateRange {
      dateRangeType
      start
      end
    }
    ... on TrafficEventDateRange {
      dateRangeType
      start
      end
      elemId
    }
    ... on TrafficEmptyDateRange {
      dateRangeType
      start
      end
    }
  }
}
    `;
export const TrafficCampaignPlacementDefaultsFragmentDoc = gql`
    fragment TrafficCampaignPlacementDefaults on TrafficCampaignPlacementDefaults {
  asins
  browseNodes
  categoryNode
  ddsAsinGroups
  subscriptionProductPageIds
  eventPages
  impressions {
    limit
    daysTimeout
  }
  slotsDesktop
  slotsMobile
  slotsPlatformAgnostic
  scheduleType
  marketplaceCriteria {
    ...EligibilityCriteriaMarketplace
  }
  variantCriteria {
    ... on PlacementDefaultVariantCriteria {
      slots
      variantId
      impressions {
        limit
        daysTimeout
      }
    }
  }
  timeRange {
    ... on TrafficCustomDateRange {
      dateRangeType
      start
      end
    }
    ... on TrafficEventDateRange {
      dateRangeType
      start
      end
      elemId
    }
    ... on TrafficEmptyDateRange {
      dateRangeType
      start
      end
    }
  }
  weblab {
    name
    treatment
  }
}
    ${EligibilityCriteriaMarketplaceFragmentDoc}`;
export const TrafficCampaignEligibilityCriteriaFragmentDoc = gql`
    fragment TrafficCampaignEligibilityCriteria on TrafficCampaignEligibilityCriteria {
  additionalExcludes
  additionalIncludes
  asins
  bullseyeDefault
  browseNodes
  categoryNode
  ddsAsinGroups
  subscriptionProductPageIds
  containerId
  containerType
  deviceTypes
  keywords
  eventPages
  impressions {
    limit
    daysTimeout
    limitDefault
    daysTimeoutDefault
  }
  marketplaceCriteria {
    ...EligibilityCriteriaMarketplace
  }
  variantCriteria {
    ... on PlacementGroupVariantCriteria {
      slots
      useDefaultSlot
      variantId
      impressions {
        limit
        daysTimeout
        limitDefault
        daysTimeoutDefault
      }
    }
  }
  mvtAssignmentId
  mvtName
  pageId
  pageType
  platformCriteria {
    platform
    slots
    useDefault
  }
  customerOptions
  scheduleType
  schedulingDefault
  timeRange {
    ... on TrafficCustomDateRange {
      dateRangeType
      start
      end
    }
    ... on TrafficEventDateRange {
      dateRangeType
      start
      end
      elemId
    }
    ... on TrafficEmptyDateRange {
      dateRangeType
      start
      end
    }
  }
  timeRangeDefault
  weblab {
    name
    treatment
    nameDefault
    treatmentDefault
  }
}
    ${EligibilityCriteriaMarketplaceFragmentDoc}`;
export const TrafficPlacementGroupFragmentDoc = gql`
    fragment TrafficPlacementGroup on TrafficPlacementGroup {
  flavorIds
  guarantee
  id
  name
  scheduling {
    ... on PlacementGroupSchedulingInfo {
      flavorId
      locale
      platforms
    }
  }
  eligibilityCriteria {
    ...TrafficCampaignEligibilityCriteria
  }
}
    ${TrafficCampaignEligibilityCriteriaFragmentDoc}`;
export const TpCampaignPlacementsInfoFragmentDoc = gql`
    fragment TPCampaignPlacementsInfo on TrafficCampaignPlacementData {
  defaults {
    ...TrafficCampaignPlacementDefaults
  }
  groups {
    ...TrafficPlacementGroup
  }
}
    ${TrafficCampaignPlacementDefaultsFragmentDoc}
${TrafficPlacementGroupFragmentDoc}`;
export const TpCampaignRequiredFormFieldsFragmentDoc = gql`
    fragment TPCampaignRequiredFormFields on TrafficCampaign {
  id
  name
  schema
  thumbnailURL
  globalContent
  flavors {
    ...TPCampaignRequiredFormFlavor
  }
  placements {
    ...TPCampaignPlacementsInfo
  }
  varSharing {
    sharedVarsMap
    inlineEditorMeta
    dmccOverrideMap
  }
  common {
    accessControlGroup
    autoName {
      additionalText
      alexaEnabled
      creativeType
      eventShortName
      isAutoGenerated
      program
      slot
      pageType
    }
    businessGroup
    marketingType
    mocarObjective
    productLine
    reason
    programs
    programSubGroup
  }
}
    ${TpCampaignRequiredFormFlavorFragmentDoc}
${TpCampaignPlacementsInfoFragmentDoc}`;
export const TpCampaignNavBarFragmentDoc = gql`
    fragment TPCampaignNavBar on TrafficCampaign {
  id
  name
  project {
    id
    name
  }
}
    `;
export const TpCampaignSummaryFragmentDoc = gql`
    fragment TPCampaignSummary on TrafficCampaign {
  ...useIsCampaignLocked
}
    ${UseIsCampaignLockedFragmentDoc}`;
export const ValidateFlavorContentConfigurationFragmentDoc = gql`
    fragment ValidateFlavorContentConfiguration on ContentConfiguration {
  jsonSchema
}
    `;
export const CampaignConfigProviderCampaignFragmentDoc = gql`
    fragment CampaignConfigProviderCampaign on CampaignConfiguration {
  id
  name
  shortName
  version
  featureGroups
  pageType
  contentConfiguration {
    ...ValidateFlavorContentConfiguration
    jsonSchema
    uiSchema
    customValidate
  }
  componentInfos {
    variant
    componentInfo {
      name
      namespace
      version
    }
  }
  placementsSection {
    customerOptions
    placementComponents {
      component
      enabled
    }
    placementDefaultsEnabled
    initialPlacementValues {
      schedulingDefault
      pageType
    }
    slotOptions {
      ... on StandardSlotOptions {
        standard {
          scope
          variantSlots {
            variant
            slots
          }
        }
      }
      ... on VariantSlotOptions {
        variant {
          scope
          variantSlots {
            variant
            slots
          }
        }
      }
    }
  }
  isMCC
  requiresCBR
  hasMultiPlatformFlavors
  isPlatformAgnostic
  requiresMocar
  sharingOptions {
    disablePlatformSharing
  }
  overviewConfiguration {
    autoNaming {
      supportedInputs
    }
  }
  publishing {
    creativeNamePrefixOverrideKey
    widgetType
  }
  livePreviewConfiguration {
    supportsLivePreview
    isMarsWidget
    keepProvidedStyles
    needsAuiJs
    supportsPlatformOverride
  }
}
    ${ValidateFlavorContentConfigurationFragmentDoc}`;
export const TrafficCampaignPageFragmentDoc = gql`
    fragment TrafficCampaignPage on TrafficCampaign {
  ...TPCampaignSidebar
  ...TPCampaignRequiredFormFields
  ...TPCampaignNavBar
  ...TPCampaignSummary
  configuration {
    ...CampaignConfigProviderCampaign
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}
${TpCampaignNavBarFragmentDoc}
${TpCampaignSummaryFragmentDoc}
${CampaignConfigProviderCampaignFragmentDoc}`;
export const TpCampaignArchiveMenuItemFragmentDoc = gql`
    fragment TPCampaignArchiveMenuItem on TrafficCampaign {
  id
  isArchived
  status
  project {
    id
  }
  version
}
    `;
export const MessageFragmentFragmentDoc = gql`
    fragment MessageFragment on ChatMessage {
  content
  role
  timestamp
}
    `;
export const ConversationFragmentFragmentDoc = gql`
    fragment ConversationFragment on ChatConversation {
  ... on ChatConversationReady {
    id
    correlationId
    messages {
      ...MessageFragment
    }
  }
  ... on ChatConversationPending {
    id
    correlationId
  }
}
    ${MessageFragmentFragmentDoc}`;
export const TpCampaignCancelApprovalsButtonFragmentDoc = gql`
    fragment TPCampaignCancelApprovalsButton on TrafficCampaign {
  ...useIsCampaignLocked
  id
  schema
  project {
    id
  }
  flavors {
    active
    id
    symphony {
      ... on TrafficFlavorSymphonyMetadataDraft {
        published
      }
      ... on TrafficFlavorSymphonyMetadataPublished {
        published
        creatives {
          status {
            objectState
            workflowState
            active
            errors
            partiallyApproved
            liveState
          }
        }
      }
    }
  }
}
    ${UseIsCampaignLockedFragmentDoc}`;
export const TpCampaignRejectAllButtonFragmentDoc = gql`
    fragment TPCampaignRejectAllButton on TrafficCampaign {
  ...useIsCampaignLocked
  id
  schema
  project {
    id
  }
  flavors {
    active
    id
    symphony {
      ... on TrafficFlavorSymphonyMetadataDraft {
        published
      }
      ... on TrafficFlavorSymphonyMetadataPublished {
        published
        creatives {
          status {
            objectState
            workflowState
            active
            errors
            partiallyApproved
            liveState
          }
        }
      }
    }
  }
}
    ${UseIsCampaignLockedFragmentDoc}`;
export const TpCampaignRequestApprovalsButtonFragmentDoc = gql`
    fragment TPCampaignRequestApprovalsButton on TrafficCampaign {
  id
  schema
  project {
    id
  }
  flavors {
    active
    id
    symphony {
      ... on TrafficFlavorSymphonyMetadataDraft {
        published
      }
      ... on TrafficFlavorSymphonyMetadataPublished {
        published
        creatives {
          status {
            objectState
            workflowState
            active
            errors
            partiallyApproved
            liveState
          }
        }
      }
    }
  }
}
    `;
export const BullseyeSegmentDataRowSegmentFragmentDoc = gql`
    fragment BullseyeSegmentDataRowSegment on BullseyeSegmentStatus {
  id
  yesSize
  name
  onlineStatus
  segmentStatus
}
    `;
export const BullseyeDataSegmentDataRowErrorFragmentDoc = gql`
    fragment BullseyeDataSegmentDataRowError on BullseyeSegmentError {
  id
  type
  message
}
    `;
export const BullseyeSegmentDataRowFragmentDoc = gql`
    fragment BullseyeSegmentDataRow on BullseyeSegmentsQueryResult {
  ... on BullseyeSegmentStatus {
    ...BullseyeSegmentDataRowSegment
  }
  ... on BullseyeSegmentError {
    ...BullseyeDataSegmentDataRowError
  }
}
    ${BullseyeSegmentDataRowSegmentFragmentDoc}
${BullseyeDataSegmentDataRowErrorFragmentDoc}`;
export const CampaignConfigLabelsFragmentDoc = gql`
    fragment CampaignConfigLabels on CampaignConfiguration {
  id
  name
  isMCC
}
    `;
export const TrafficCampaignsFilterOptionValuesFragmentDoc = gql`
    fragment TrafficCampaignsFilterOptionValues on TrafficProjectCampaigns_Connection {
  filterOptionValues {
    platform
    productLine
    createdBy
    campaignType
    language
    status
    liveness
  }
}
    `;
export const TrafficCampaignsTableDataFragmentDoc = gql`
    fragment TrafficCampaignsTableData on TrafficCampaign {
  id
  name
  modifiedAt
  createdBy
  schema
  schemaVersion
  version
  status(loadFromSymphony: $loadFromSymphony)
  isArchived
  liveState(loadFromSymphony: $loadFromSymphony)
  thumbnailURL
  globalContent
  flavors {
    id
    content
    active
    creativeName
    hasGeneratedName
    scheduling {
      ...TPCampaignSchedulingInfo
    }
    symphony {
      ... on TrafficFlavorSymphonyMetadataDraft {
        published
      }
      ... on TrafficFlavorSymphonyMetadataPublished {
        published
      }
    }
    variant
  }
  varSharing {
    sharedVarsMap
    inlineEditorMeta
    dmccOverrideMap
  }
  common {
    productLine
    accessControlGroup
    businessGroup
    marketingType
    reason
    mocarObjective
    autoName {
      additionalText
      alexaEnabled
      creativeType
      eventShortName
      isAutoGenerated
      program
      slot
    }
  }
  placements {
    ...TPCampaignPlacementsInfo
  }
}
    ${TpCampaignSchedulingInfoFragmentDoc}
${TpCampaignPlacementsInfoFragmentDoc}`;
export const TrafficCampaignStatusBadgeDataFragmentDoc = gql`
    fragment TrafficCampaignStatusBadgeData on TrafficCampaign {
  id
  status
  liveState
  isArchived
}
    `;
export const MccRequestApprovalPlacementsButtonFragmentDoc = gql`
    fragment MCCRequestApprovalPlacementsButton on TrafficCampaign {
  id
  schema
  project {
    id
  }
  flavors {
    active
    id
    symphony {
      ... on TrafficFlavorSymphonyMetadataDraft {
        published
      }
      ... on TrafficFlavorSymphonyMetadataPublished {
        published
        creatives {
          status {
            objectState
            workflowState
            active
            errors
            partiallyApproved
            liveState
          }
        }
      }
    }
    scheduling {
      ... on TrafficCampaignSchedulingInfo {
        placements {
          id
        }
      }
    }
  }
}
    `;
export const CampaignConfigsDropdownListFragmentDoc = gql`
    fragment CampaignConfigsDropdownList on CampaignConfiguration {
  id
  name
  pageType
  featureGroups
  isMCC
}
    `;
export const UseCampaignUserCbrPermissionsFragmentDoc = gql`
    fragment useCampaignUserCBRPermissions on TrafficCampaign {
  flavors {
    active
    scheduling {
      marketplace
    }
  }
}
    `;
export const UseUserCanApproveOrRejectFlavorsFragmentDoc = gql`
    fragment useUserCanApproveOrRejectFlavors on TrafficCampaign {
  ...useCampaignUserCBRPermissions
  createdBy
  schema
  flavors {
    id
    scheduling {
      marketplace
    }
  }
}
    ${UseCampaignUserCbrPermissionsFragmentDoc}`;
export const TpAssetMapFragmentDoc = gql`
    fragment TPAssetMap on AssetSearchResult {
  assetId
  s3SignedUrlGet
  mediaCentralUrls
  isPublishedMap
}
    `;
export const GenerateAltTextDocument = gql`
    query GenerateAltText($input: GenerateAltTextInput!) {
  generateAltText(input: $input) {
    altText
  }
}
    `;

/**
 * __useGenerateAltTextQuery__
 *
 * To run a query within a React component, call `useGenerateAltTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateAltTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateAltTextQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateAltTextQuery(baseOptions: Apollo.QueryHookOptions<GenerateAltTextQuery, GenerateAltTextQueryVariables> & ({ variables: GenerateAltTextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateAltTextQuery, GenerateAltTextQueryVariables>(GenerateAltTextDocument, options);
      }
export function useGenerateAltTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateAltTextQuery, GenerateAltTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateAltTextQuery, GenerateAltTextQueryVariables>(GenerateAltTextDocument, options);
        }
// @ts-ignore
export function useGenerateAltTextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GenerateAltTextQuery, GenerateAltTextQueryVariables>): Apollo.UseSuspenseQueryResult<GenerateAltTextQuery, GenerateAltTextQueryVariables>;
export function useGenerateAltTextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateAltTextQuery, GenerateAltTextQueryVariables>): Apollo.UseSuspenseQueryResult<GenerateAltTextQuery | undefined, GenerateAltTextQueryVariables>;
export function useGenerateAltTextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateAltTextQuery, GenerateAltTextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateAltTextQuery, GenerateAltTextQueryVariables>(GenerateAltTextDocument, options);
        }
export type GenerateAltTextQueryHookResult = ReturnType<typeof useGenerateAltTextQuery>;
export type GenerateAltTextLazyQueryHookResult = ReturnType<typeof useGenerateAltTextLazyQuery>;
export type GenerateAltTextSuspenseQueryHookResult = ReturnType<typeof useGenerateAltTextSuspenseQuery>;
export type GenerateAltTextQueryResult = Apollo.QueryResult<GenerateAltTextQuery, GenerateAltTextQueryVariables>;
export const ListPreviewersDocument = gql`
    query ListPreviewers($realm: String!) {
  getListPreviewers(realm: $realm) {
    username
    customerId
  }
}
    `;

/**
 * __useListPreviewersQuery__
 *
 * To run a query within a React component, call `useListPreviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPreviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPreviewersQuery({
 *   variables: {
 *      realm: // value for 'realm'
 *   },
 * });
 */
export function useListPreviewersQuery(baseOptions: Apollo.QueryHookOptions<ListPreviewersQuery, ListPreviewersQueryVariables> & ({ variables: ListPreviewersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPreviewersQuery, ListPreviewersQueryVariables>(ListPreviewersDocument, options);
      }
export function useListPreviewersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPreviewersQuery, ListPreviewersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPreviewersQuery, ListPreviewersQueryVariables>(ListPreviewersDocument, options);
        }
// @ts-ignore
export function useListPreviewersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListPreviewersQuery, ListPreviewersQueryVariables>): Apollo.UseSuspenseQueryResult<ListPreviewersQuery, ListPreviewersQueryVariables>;
export function useListPreviewersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPreviewersQuery, ListPreviewersQueryVariables>): Apollo.UseSuspenseQueryResult<ListPreviewersQuery | undefined, ListPreviewersQueryVariables>;
export function useListPreviewersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPreviewersQuery, ListPreviewersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPreviewersQuery, ListPreviewersQueryVariables>(ListPreviewersDocument, options);
        }
export type ListPreviewersQueryHookResult = ReturnType<typeof useListPreviewersQuery>;
export type ListPreviewersLazyQueryHookResult = ReturnType<typeof useListPreviewersLazyQuery>;
export type ListPreviewersSuspenseQueryHookResult = ReturnType<typeof useListPreviewersSuspenseQuery>;
export type ListPreviewersQueryResult = Apollo.QueryResult<ListPreviewersQuery, ListPreviewersQueryVariables>;
export const DeletePreviewSessionsDocument = gql`
    mutation DeletePreviewSessions($obfuscatedPreviewerIds: [String!]!, $realm: SymphonyRealm!) {
  deletePreviewSessions(
    obfuscatedPreviewerIds: $obfuscatedPreviewerIds
    realm: $realm
  ) {
    ... on DeletedPreviewSession {
      obfuscatedPreviewerId
    }
    ... on DeletePreviewSessionError {
      message
    }
  }
}
    `;
export type DeletePreviewSessionsMutationFn = Apollo.MutationFunction<DeletePreviewSessionsMutation, DeletePreviewSessionsMutationVariables>;

/**
 * __useDeletePreviewSessionsMutation__
 *
 * To run a mutation, you first call `useDeletePreviewSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePreviewSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePreviewSessionsMutation, { data, loading, error }] = useDeletePreviewSessionsMutation({
 *   variables: {
 *      obfuscatedPreviewerIds: // value for 'obfuscatedPreviewerIds'
 *      realm: // value for 'realm'
 *   },
 * });
 */
export function useDeletePreviewSessionsMutation(baseOptions?: Apollo.MutationHookOptions<DeletePreviewSessionsMutation, DeletePreviewSessionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePreviewSessionsMutation, DeletePreviewSessionsMutationVariables>(DeletePreviewSessionsDocument, options);
      }
export type DeletePreviewSessionsMutationHookResult = ReturnType<typeof useDeletePreviewSessionsMutation>;
export type DeletePreviewSessionsMutationResult = Apollo.MutationResult<DeletePreviewSessionsMutation>;
export type DeletePreviewSessionsMutationOptions = Apollo.BaseMutationOptions<DeletePreviewSessionsMutation, DeletePreviewSessionsMutationVariables>;
export const CreatePreviewSessionDocument = gql`
    mutation CreatePreviewSession($input: CreatePreviewSessionInput!) {
  createPreviewSession(input: $input) {
    username
    previewerId
    startTime
    expiryTime
    data {
      addedBullseye2
      removedBullseye2
      previewTime
      previewPlacements {
        creativeId
        rule
        links
      }
    }
  }
}
    `;
export type CreatePreviewSessionMutationFn = Apollo.MutationFunction<CreatePreviewSessionMutation, CreatePreviewSessionMutationVariables>;

/**
 * __useCreatePreviewSessionMutation__
 *
 * To run a mutation, you first call `useCreatePreviewSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreviewSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreviewSessionMutation, { data, loading, error }] = useCreatePreviewSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePreviewSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePreviewSessionMutation, CreatePreviewSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePreviewSessionMutation, CreatePreviewSessionMutationVariables>(CreatePreviewSessionDocument, options);
      }
export type CreatePreviewSessionMutationHookResult = ReturnType<typeof useCreatePreviewSessionMutation>;
export type CreatePreviewSessionMutationResult = Apollo.MutationResult<CreatePreviewSessionMutation>;
export type CreatePreviewSessionMutationOptions = Apollo.BaseMutationOptions<CreatePreviewSessionMutation, CreatePreviewSessionMutationVariables>;
export const AlvAsinsDocument = gql`
    query ALVAsins($first: Int!, $filters: AsinFilterInput, $after: String, $sortOptions: [ASINSortInput!]) {
  asins(
    first: $first
    filters: $filters
    after: $after
    sortOptions: $sortOptions
  ) {
    nodes {
      ...AsinTableCell
      announceDate
      description
      id
      productLine {
        id
        name
      }
      thumbnailURL
      type
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    ${AsinTableCellFragmentDoc}`;

/**
 * __useAlvAsinsQuery__
 *
 * To run a query within a React component, call `useAlvAsinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlvAsinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlvAsinsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      sortOptions: // value for 'sortOptions'
 *   },
 * });
 */
export function useAlvAsinsQuery(baseOptions: Apollo.QueryHookOptions<AlvAsinsQuery, AlvAsinsQueryVariables> & ({ variables: AlvAsinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlvAsinsQuery, AlvAsinsQueryVariables>(AlvAsinsDocument, options);
      }
export function useAlvAsinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlvAsinsQuery, AlvAsinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlvAsinsQuery, AlvAsinsQueryVariables>(AlvAsinsDocument, options);
        }
// @ts-ignore
export function useAlvAsinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AlvAsinsQuery, AlvAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<AlvAsinsQuery, AlvAsinsQueryVariables>;
export function useAlvAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlvAsinsQuery, AlvAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<AlvAsinsQuery | undefined, AlvAsinsQueryVariables>;
export function useAlvAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlvAsinsQuery, AlvAsinsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlvAsinsQuery, AlvAsinsQueryVariables>(AlvAsinsDocument, options);
        }
export type AlvAsinsQueryHookResult = ReturnType<typeof useAlvAsinsQuery>;
export type AlvAsinsLazyQueryHookResult = ReturnType<typeof useAlvAsinsLazyQuery>;
export type AlvAsinsSuspenseQueryHookResult = ReturnType<typeof useAlvAsinsSuspenseQuery>;
export type AlvAsinsQueryResult = Apollo.QueryResult<AlvAsinsQuery, AlvAsinsQueryVariables>;
export const AlvProductLinesDocument = gql`
    query ALVProductLines($first: Int!, $filters: ProductLineFilterInput, $after: String, $sortOptions: [ProductLineSortInput!]) {
  productLines(
    first: $first
    filters: $filters
    after: $after
    sortOptions: $sortOptions
  ) {
    nodes {
      id
      name
    }
    pageInfo {
      hasNextPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useAlvProductLinesQuery__
 *
 * To run a query within a React component, call `useAlvProductLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlvProductLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlvProductLinesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      sortOptions: // value for 'sortOptions'
 *   },
 * });
 */
export function useAlvProductLinesQuery(baseOptions: Apollo.QueryHookOptions<AlvProductLinesQuery, AlvProductLinesQueryVariables> & ({ variables: AlvProductLinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlvProductLinesQuery, AlvProductLinesQueryVariables>(AlvProductLinesDocument, options);
      }
export function useAlvProductLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlvProductLinesQuery, AlvProductLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlvProductLinesQuery, AlvProductLinesQueryVariables>(AlvProductLinesDocument, options);
        }
// @ts-ignore
export function useAlvProductLinesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AlvProductLinesQuery, AlvProductLinesQueryVariables>): Apollo.UseSuspenseQueryResult<AlvProductLinesQuery, AlvProductLinesQueryVariables>;
export function useAlvProductLinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlvProductLinesQuery, AlvProductLinesQueryVariables>): Apollo.UseSuspenseQueryResult<AlvProductLinesQuery | undefined, AlvProductLinesQueryVariables>;
export function useAlvProductLinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlvProductLinesQuery, AlvProductLinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlvProductLinesQuery, AlvProductLinesQueryVariables>(AlvProductLinesDocument, options);
        }
export type AlvProductLinesQueryHookResult = ReturnType<typeof useAlvProductLinesQuery>;
export type AlvProductLinesLazyQueryHookResult = ReturnType<typeof useAlvProductLinesLazyQuery>;
export type AlvProductLinesSuspenseQueryHookResult = ReturnType<typeof useAlvProductLinesSuspenseQuery>;
export type AlvProductLinesQueryResult = Apollo.QueryResult<AlvProductLinesQuery, AlvProductLinesQueryVariables>;
export const AlvProgramsDocument = gql`
    query ALVPrograms($first: Int!, $filters: ProgramFilterInput, $after: String, $sortOptions: [ProgramSortInput!]) {
  programs(
    first: $first
    filters: $filters
    after: $after
    sortOptions: $sortOptions
  ) {
    nodes {
      id
      name
      programId
    }
    pageInfo {
      hasNextPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useAlvProgramsQuery__
 *
 * To run a query within a React component, call `useAlvProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlvProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlvProgramsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      sortOptions: // value for 'sortOptions'
 *   },
 * });
 */
export function useAlvProgramsQuery(baseOptions: Apollo.QueryHookOptions<AlvProgramsQuery, AlvProgramsQueryVariables> & ({ variables: AlvProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlvProgramsQuery, AlvProgramsQueryVariables>(AlvProgramsDocument, options);
      }
export function useAlvProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlvProgramsQuery, AlvProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlvProgramsQuery, AlvProgramsQueryVariables>(AlvProgramsDocument, options);
        }
// @ts-ignore
export function useAlvProgramsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AlvProgramsQuery, AlvProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<AlvProgramsQuery, AlvProgramsQueryVariables>;
export function useAlvProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlvProgramsQuery, AlvProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<AlvProgramsQuery | undefined, AlvProgramsQueryVariables>;
export function useAlvProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlvProgramsQuery, AlvProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlvProgramsQuery, AlvProgramsQueryVariables>(AlvProgramsDocument, options);
        }
export type AlvProgramsQueryHookResult = ReturnType<typeof useAlvProgramsQuery>;
export type AlvProgramsLazyQueryHookResult = ReturnType<typeof useAlvProgramsLazyQuery>;
export type AlvProgramsSuspenseQueryHookResult = ReturnType<typeof useAlvProgramsSuspenseQuery>;
export type AlvProgramsQueryResult = Apollo.QueryResult<AlvProgramsQuery, AlvProgramsQueryVariables>;
export const CreateBulkPublishJobDocument = gql`
    mutation CreateBulkPublishJob($input: CreateBulkPublishJobInput!) {
  createBulkPublishJob(input: $input) {
    job {
      id
      status
    }
  }
}
    `;
export type CreateBulkPublishJobMutationFn = Apollo.MutationFunction<CreateBulkPublishJobMutation, CreateBulkPublishJobMutationVariables>;

/**
 * __useCreateBulkPublishJobMutation__
 *
 * To run a mutation, you first call `useCreateBulkPublishJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkPublishJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkPublishJobMutation, { data, loading, error }] = useCreateBulkPublishJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBulkPublishJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateBulkPublishJobMutation, CreateBulkPublishJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBulkPublishJobMutation, CreateBulkPublishJobMutationVariables>(CreateBulkPublishJobDocument, options);
      }
export type CreateBulkPublishJobMutationHookResult = ReturnType<typeof useCreateBulkPublishJobMutation>;
export type CreateBulkPublishJobMutationResult = Apollo.MutationResult<CreateBulkPublishJobMutation>;
export type CreateBulkPublishJobMutationOptions = Apollo.BaseMutationOptions<CreateBulkPublishJobMutation, CreateBulkPublishJobMutationVariables>;
export const BulkPublishJobDocument = gql`
    query BulkPublishJob($jobId: ID!) {
  job(id: $jobId) {
    ...BulkPublishJobResult
  }
}
    ${BulkPublishJobResultFragmentDoc}`;

/**
 * __useBulkPublishJobQuery__
 *
 * To run a query within a React component, call `useBulkPublishJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkPublishJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkPublishJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useBulkPublishJobQuery(baseOptions: Apollo.QueryHookOptions<BulkPublishJobQuery, BulkPublishJobQueryVariables> & ({ variables: BulkPublishJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkPublishJobQuery, BulkPublishJobQueryVariables>(BulkPublishJobDocument, options);
      }
export function useBulkPublishJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkPublishJobQuery, BulkPublishJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkPublishJobQuery, BulkPublishJobQueryVariables>(BulkPublishJobDocument, options);
        }
// @ts-ignore
export function useBulkPublishJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BulkPublishJobQuery, BulkPublishJobQueryVariables>): Apollo.UseSuspenseQueryResult<BulkPublishJobQuery, BulkPublishJobQueryVariables>;
export function useBulkPublishJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkPublishJobQuery, BulkPublishJobQueryVariables>): Apollo.UseSuspenseQueryResult<BulkPublishJobQuery | undefined, BulkPublishJobQueryVariables>;
export function useBulkPublishJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkPublishJobQuery, BulkPublishJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BulkPublishJobQuery, BulkPublishJobQueryVariables>(BulkPublishJobDocument, options);
        }
export type BulkPublishJobQueryHookResult = ReturnType<typeof useBulkPublishJobQuery>;
export type BulkPublishJobLazyQueryHookResult = ReturnType<typeof useBulkPublishJobLazyQuery>;
export type BulkPublishJobSuspenseQueryHookResult = ReturnType<typeof useBulkPublishJobSuspenseQuery>;
export type BulkPublishJobQueryResult = Apollo.QueryResult<BulkPublishJobQuery, BulkPublishJobQueryVariables>;
export const CreateJagBreadcrumbInfoDocument = gql`
    query createJagBreadcrumbInfo($id: ID!) {
  trafficProject(id: $id) {
    ...trafficProjectName
  }
}
    ${TrafficProjectNameFragmentDoc}`;

/**
 * __useCreateJagBreadcrumbInfoQuery__
 *
 * To run a query within a React component, call `useCreateJagBreadcrumbInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateJagBreadcrumbInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateJagBreadcrumbInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateJagBreadcrumbInfoQuery(baseOptions: Apollo.QueryHookOptions<CreateJagBreadcrumbInfoQuery, CreateJagBreadcrumbInfoQueryVariables> & ({ variables: CreateJagBreadcrumbInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateJagBreadcrumbInfoQuery, CreateJagBreadcrumbInfoQueryVariables>(CreateJagBreadcrumbInfoDocument, options);
      }
export function useCreateJagBreadcrumbInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateJagBreadcrumbInfoQuery, CreateJagBreadcrumbInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateJagBreadcrumbInfoQuery, CreateJagBreadcrumbInfoQueryVariables>(CreateJagBreadcrumbInfoDocument, options);
        }
// @ts-ignore
export function useCreateJagBreadcrumbInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateJagBreadcrumbInfoQuery, CreateJagBreadcrumbInfoQueryVariables>): Apollo.UseSuspenseQueryResult<CreateJagBreadcrumbInfoQuery, CreateJagBreadcrumbInfoQueryVariables>;
export function useCreateJagBreadcrumbInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateJagBreadcrumbInfoQuery, CreateJagBreadcrumbInfoQueryVariables>): Apollo.UseSuspenseQueryResult<CreateJagBreadcrumbInfoQuery | undefined, CreateJagBreadcrumbInfoQueryVariables>;
export function useCreateJagBreadcrumbInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateJagBreadcrumbInfoQuery, CreateJagBreadcrumbInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateJagBreadcrumbInfoQuery, CreateJagBreadcrumbInfoQueryVariables>(CreateJagBreadcrumbInfoDocument, options);
        }
export type CreateJagBreadcrumbInfoQueryHookResult = ReturnType<typeof useCreateJagBreadcrumbInfoQuery>;
export type CreateJagBreadcrumbInfoLazyQueryHookResult = ReturnType<typeof useCreateJagBreadcrumbInfoLazyQuery>;
export type CreateJagBreadcrumbInfoSuspenseQueryHookResult = ReturnType<typeof useCreateJagBreadcrumbInfoSuspenseQuery>;
export type CreateJagBreadcrumbInfoQueryResult = Apollo.QueryResult<CreateJagBreadcrumbInfoQuery, CreateJagBreadcrumbInfoQueryVariables>;
export const JasFormBreadcrumbInfoDocument = gql`
    query jasFormBreadcrumbInfo($filters: JAGFilterInput!, $id: ID!) {
  JAGs(filters: $filters, first: 100) {
    nodes {
      ...jagName
    }
  }
  trafficProject(id: $id) {
    ...trafficProjectName
  }
}
    ${JagNameFragmentDoc}
${TrafficProjectNameFragmentDoc}`;

/**
 * __useJasFormBreadcrumbInfoQuery__
 *
 * To run a query within a React component, call `useJasFormBreadcrumbInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useJasFormBreadcrumbInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJasFormBreadcrumbInfoQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJasFormBreadcrumbInfoQuery(baseOptions: Apollo.QueryHookOptions<JasFormBreadcrumbInfoQuery, JasFormBreadcrumbInfoQueryVariables> & ({ variables: JasFormBreadcrumbInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JasFormBreadcrumbInfoQuery, JasFormBreadcrumbInfoQueryVariables>(JasFormBreadcrumbInfoDocument, options);
      }
export function useJasFormBreadcrumbInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JasFormBreadcrumbInfoQuery, JasFormBreadcrumbInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JasFormBreadcrumbInfoQuery, JasFormBreadcrumbInfoQueryVariables>(JasFormBreadcrumbInfoDocument, options);
        }
// @ts-ignore
export function useJasFormBreadcrumbInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JasFormBreadcrumbInfoQuery, JasFormBreadcrumbInfoQueryVariables>): Apollo.UseSuspenseQueryResult<JasFormBreadcrumbInfoQuery, JasFormBreadcrumbInfoQueryVariables>;
export function useJasFormBreadcrumbInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JasFormBreadcrumbInfoQuery, JasFormBreadcrumbInfoQueryVariables>): Apollo.UseSuspenseQueryResult<JasFormBreadcrumbInfoQuery | undefined, JasFormBreadcrumbInfoQueryVariables>;
export function useJasFormBreadcrumbInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JasFormBreadcrumbInfoQuery, JasFormBreadcrumbInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JasFormBreadcrumbInfoQuery, JasFormBreadcrumbInfoQueryVariables>(JasFormBreadcrumbInfoDocument, options);
        }
export type JasFormBreadcrumbInfoQueryHookResult = ReturnType<typeof useJasFormBreadcrumbInfoQuery>;
export type JasFormBreadcrumbInfoLazyQueryHookResult = ReturnType<typeof useJasFormBreadcrumbInfoLazyQuery>;
export type JasFormBreadcrumbInfoSuspenseQueryHookResult = ReturnType<typeof useJasFormBreadcrumbInfoSuspenseQuery>;
export type JasFormBreadcrumbInfoQueryResult = Apollo.QueryResult<JasFormBreadcrumbInfoQuery, JasFormBreadcrumbInfoQueryVariables>;
export const AssetsDocument = gql`
    query Assets($input: AssetsQueryInput!) {
  assets(input: $input) {
    from
    to
    numberOfResults
    assets {
      ...AssetFields
    }
  }
}
    ${AssetFieldsFragmentDoc}`;

/**
 * __useAssetsQuery__
 *
 * To run a query within a React component, call `useAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssetsQuery(baseOptions: Apollo.QueryHookOptions<AssetsQuery, AssetsQueryVariables> & ({ variables: AssetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetsQuery, AssetsQueryVariables>(AssetsDocument, options);
      }
export function useAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetsQuery, AssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetsQuery, AssetsQueryVariables>(AssetsDocument, options);
        }
// @ts-ignore
export function useAssetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssetsQuery, AssetsQueryVariables>): Apollo.UseSuspenseQueryResult<AssetsQuery, AssetsQueryVariables>;
export function useAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssetsQuery, AssetsQueryVariables>): Apollo.UseSuspenseQueryResult<AssetsQuery | undefined, AssetsQueryVariables>;
export function useAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssetsQuery, AssetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssetsQuery, AssetsQueryVariables>(AssetsDocument, options);
        }
export type AssetsQueryHookResult = ReturnType<typeof useAssetsQuery>;
export type AssetsLazyQueryHookResult = ReturnType<typeof useAssetsLazyQuery>;
export type AssetsSuspenseQueryHookResult = ReturnType<typeof useAssetsSuspenseQuery>;
export type AssetsQueryResult = Apollo.QueryResult<AssetsQuery, AssetsQueryVariables>;
export const AssetDocument = gql`
    query Asset($input: AssetSearchRequest!) {
  assetsSearch(input: $input) {
    results {
      searchResults {
        ...AssetFields
      }
    }
  }
}
    ${AssetFieldsFragmentDoc}`;

/**
 * __useAssetQuery__
 *
 * To run a query within a React component, call `useAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssetQuery(baseOptions: Apollo.QueryHookOptions<AssetQuery, AssetQueryVariables> & ({ variables: AssetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetQuery, AssetQueryVariables>(AssetDocument, options);
      }
export function useAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetQuery, AssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetQuery, AssetQueryVariables>(AssetDocument, options);
        }
// @ts-ignore
export function useAssetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssetQuery, AssetQueryVariables>): Apollo.UseSuspenseQueryResult<AssetQuery, AssetQueryVariables>;
export function useAssetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssetQuery, AssetQueryVariables>): Apollo.UseSuspenseQueryResult<AssetQuery | undefined, AssetQueryVariables>;
export function useAssetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssetQuery, AssetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssetQuery, AssetQueryVariables>(AssetDocument, options);
        }
export type AssetQueryHookResult = ReturnType<typeof useAssetQuery>;
export type AssetLazyQueryHookResult = ReturnType<typeof useAssetLazyQuery>;
export type AssetSuspenseQueryHookResult = ReturnType<typeof useAssetSuspenseQuery>;
export type AssetQueryResult = Apollo.QueryResult<AssetQuery, AssetQueryVariables>;
export const CopyAssetDocument = gql`
    mutation CopyAsset($assetId: ID!, $destinationProjectId: ID!) {
  copyAsset(assetId: $assetId, destinationProjectId: $destinationProjectId) {
    message
    code
    success
    asset {
      ...AssetFields
    }
  }
}
    ${AssetFieldsFragmentDoc}`;
export type CopyAssetMutationFn = Apollo.MutationFunction<CopyAssetMutation, CopyAssetMutationVariables>;

/**
 * __useCopyAssetMutation__
 *
 * To run a mutation, you first call `useCopyAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyAssetMutation, { data, loading, error }] = useCopyAssetMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      destinationProjectId: // value for 'destinationProjectId'
 *   },
 * });
 */
export function useCopyAssetMutation(baseOptions?: Apollo.MutationHookOptions<CopyAssetMutation, CopyAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyAssetMutation, CopyAssetMutationVariables>(CopyAssetDocument, options);
      }
export type CopyAssetMutationHookResult = ReturnType<typeof useCopyAssetMutation>;
export type CopyAssetMutationResult = Apollo.MutationResult<CopyAssetMutation>;
export type CopyAssetMutationOptions = Apollo.BaseMutationOptions<CopyAssetMutation, CopyAssetMutationVariables>;
export const CreateAssetDocument = gql`
    mutation CreateAsset($input: CreateAssetInput!) {
  createAsset(input: $input) {
    message
    code
    success
    asset {
      ...AssetFields
    }
  }
}
    ${AssetFieldsFragmentDoc}`;
export type CreateAssetMutationFn = Apollo.MutationFunction<CreateAssetMutation, CreateAssetMutationVariables>;

/**
 * __useCreateAssetMutation__
 *
 * To run a mutation, you first call `useCreateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetMutation, { data, loading, error }] = useCreateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssetMutation, CreateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssetMutation, CreateAssetMutationVariables>(CreateAssetDocument, options);
      }
export type CreateAssetMutationHookResult = ReturnType<typeof useCreateAssetMutation>;
export type CreateAssetMutationResult = Apollo.MutationResult<CreateAssetMutation>;
export type CreateAssetMutationOptions = Apollo.BaseMutationOptions<CreateAssetMutation, CreateAssetMutationVariables>;
export const ProjectAssetsByIdsDocument = gql`
    query ProjectAssetsByIds($input: GetAssetsByIdsInput!) {
  getAssetsByIds(input: $input) {
    assets {
      ...AssetFields
    }
  }
}
    ${AssetFieldsFragmentDoc}`;

/**
 * __useProjectAssetsByIdsQuery__
 *
 * To run a query within a React component, call `useProjectAssetsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectAssetsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAssetsByIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectAssetsByIdsQuery(baseOptions: Apollo.QueryHookOptions<ProjectAssetsByIdsQuery, ProjectAssetsByIdsQueryVariables> & ({ variables: ProjectAssetsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectAssetsByIdsQuery, ProjectAssetsByIdsQueryVariables>(ProjectAssetsByIdsDocument, options);
      }
export function useProjectAssetsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectAssetsByIdsQuery, ProjectAssetsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectAssetsByIdsQuery, ProjectAssetsByIdsQueryVariables>(ProjectAssetsByIdsDocument, options);
        }
// @ts-ignore
export function useProjectAssetsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectAssetsByIdsQuery, ProjectAssetsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectAssetsByIdsQuery, ProjectAssetsByIdsQueryVariables>;
export function useProjectAssetsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectAssetsByIdsQuery, ProjectAssetsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectAssetsByIdsQuery | undefined, ProjectAssetsByIdsQueryVariables>;
export function useProjectAssetsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectAssetsByIdsQuery, ProjectAssetsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectAssetsByIdsQuery, ProjectAssetsByIdsQueryVariables>(ProjectAssetsByIdsDocument, options);
        }
export type ProjectAssetsByIdsQueryHookResult = ReturnType<typeof useProjectAssetsByIdsQuery>;
export type ProjectAssetsByIdsLazyQueryHookResult = ReturnType<typeof useProjectAssetsByIdsLazyQuery>;
export type ProjectAssetsByIdsSuspenseQueryHookResult = ReturnType<typeof useProjectAssetsByIdsSuspenseQuery>;
export type ProjectAssetsByIdsQueryResult = Apollo.QueryResult<ProjectAssetsByIdsQuery, ProjectAssetsByIdsQueryVariables>;
export const ProjectAssetDocument = gql`
    query ProjectAsset($input: ProjectAssetsInput!) {
  projectAssets(input: $input) {
    ...AssetFields
  }
}
    ${AssetFieldsFragmentDoc}`;

/**
 * __useProjectAssetQuery__
 *
 * To run a query within a React component, call `useProjectAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAssetQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectAssetQuery(baseOptions: Apollo.QueryHookOptions<ProjectAssetQuery, ProjectAssetQueryVariables> & ({ variables: ProjectAssetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectAssetQuery, ProjectAssetQueryVariables>(ProjectAssetDocument, options);
      }
export function useProjectAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectAssetQuery, ProjectAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectAssetQuery, ProjectAssetQueryVariables>(ProjectAssetDocument, options);
        }
// @ts-ignore
export function useProjectAssetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectAssetQuery, ProjectAssetQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectAssetQuery, ProjectAssetQueryVariables>;
export function useProjectAssetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectAssetQuery, ProjectAssetQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectAssetQuery | undefined, ProjectAssetQueryVariables>;
export function useProjectAssetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectAssetQuery, ProjectAssetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectAssetQuery, ProjectAssetQueryVariables>(ProjectAssetDocument, options);
        }
export type ProjectAssetQueryHookResult = ReturnType<typeof useProjectAssetQuery>;
export type ProjectAssetLazyQueryHookResult = ReturnType<typeof useProjectAssetLazyQuery>;
export type ProjectAssetSuspenseQueryHookResult = ReturnType<typeof useProjectAssetSuspenseQuery>;
export type ProjectAssetQueryResult = Apollo.QueryResult<ProjectAssetQuery, ProjectAssetQueryVariables>;
export const RenameAssetDocument = gql`
    mutation RenameAsset($input: RenameAssetInput!) {
  renameAsset(input: $input) {
    message
    code
    success
  }
}
    `;
export type RenameAssetMutationFn = Apollo.MutationFunction<RenameAssetMutation, RenameAssetMutationVariables>;

/**
 * __useRenameAssetMutation__
 *
 * To run a mutation, you first call `useRenameAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameAssetMutation, { data, loading, error }] = useRenameAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameAssetMutation(baseOptions?: Apollo.MutationHookOptions<RenameAssetMutation, RenameAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameAssetMutation, RenameAssetMutationVariables>(RenameAssetDocument, options);
      }
export type RenameAssetMutationHookResult = ReturnType<typeof useRenameAssetMutation>;
export type RenameAssetMutationResult = Apollo.MutationResult<RenameAssetMutation>;
export type RenameAssetMutationOptions = Apollo.BaseMutationOptions<RenameAssetMutation, RenameAssetMutationVariables>;
export const StartAssetIntakeSessionDocument = gql`
    mutation StartAssetIntakeSession($input: StartAssetIntakeSessionInput!) {
  startAssetIntakeSession(input: $input) {
    code
    success
    message
    uploadUrl
  }
}
    `;
export type StartAssetIntakeSessionMutationFn = Apollo.MutationFunction<StartAssetIntakeSessionMutation, StartAssetIntakeSessionMutationVariables>;

/**
 * __useStartAssetIntakeSessionMutation__
 *
 * To run a mutation, you first call `useStartAssetIntakeSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAssetIntakeSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAssetIntakeSessionMutation, { data, loading, error }] = useStartAssetIntakeSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartAssetIntakeSessionMutation(baseOptions?: Apollo.MutationHookOptions<StartAssetIntakeSessionMutation, StartAssetIntakeSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAssetIntakeSessionMutation, StartAssetIntakeSessionMutationVariables>(StartAssetIntakeSessionDocument, options);
      }
export type StartAssetIntakeSessionMutationHookResult = ReturnType<typeof useStartAssetIntakeSessionMutation>;
export type StartAssetIntakeSessionMutationResult = Apollo.MutationResult<StartAssetIntakeSessionMutation>;
export type StartAssetIntakeSessionMutationOptions = Apollo.BaseMutationOptions<StartAssetIntakeSessionMutation, StartAssetIntakeSessionMutationVariables>;
export const BulkAtfDocument = gql`
    query BulkAtf($asins: [String!]!, $marketplacesLanguages: [String!]!, $attributes: BulkAtfQueryInput!, $pricingFields: [String!]!) {
  bulkAtfQuery(
    asins: $asins
    marketplaces_languages: $marketplacesLanguages
    attributes: $attributes
    pricing_fields: $pricingFields
  ) {
    errors {
      asinMissAllMp
      permissionDenied
    }
    url
  }
}
    `;

/**
 * __useBulkAtfQuery__
 *
 * To run a query within a React component, call `useBulkAtfQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkAtfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkAtfQuery({
 *   variables: {
 *      asins: // value for 'asins'
 *      marketplacesLanguages: // value for 'marketplacesLanguages'
 *      attributes: // value for 'attributes'
 *      pricingFields: // value for 'pricingFields'
 *   },
 * });
 */
export function useBulkAtfQuery(baseOptions: Apollo.QueryHookOptions<BulkAtfQuery, BulkAtfQueryVariables> & ({ variables: BulkAtfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkAtfQuery, BulkAtfQueryVariables>(BulkAtfDocument, options);
      }
export function useBulkAtfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkAtfQuery, BulkAtfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkAtfQuery, BulkAtfQueryVariables>(BulkAtfDocument, options);
        }
// @ts-ignore
export function useBulkAtfSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BulkAtfQuery, BulkAtfQueryVariables>): Apollo.UseSuspenseQueryResult<BulkAtfQuery, BulkAtfQueryVariables>;
export function useBulkAtfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkAtfQuery, BulkAtfQueryVariables>): Apollo.UseSuspenseQueryResult<BulkAtfQuery | undefined, BulkAtfQueryVariables>;
export function useBulkAtfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkAtfQuery, BulkAtfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BulkAtfQuery, BulkAtfQueryVariables>(BulkAtfDocument, options);
        }
export type BulkAtfQueryHookResult = ReturnType<typeof useBulkAtfQuery>;
export type BulkAtfLazyQueryHookResult = ReturnType<typeof useBulkAtfLazyQuery>;
export type BulkAtfSuspenseQueryHookResult = ReturnType<typeof useBulkAtfSuspenseQuery>;
export type BulkAtfQueryResult = Apollo.QueryResult<BulkAtfQuery, BulkAtfQueryVariables>;
export const CreateJobDocument = gql`
    mutation CreateJob($fileName: String!) {
  createBulkAtfJob(fileName: $fileName) {
    uploadUrl
    job {
      ... on BulkAtfJob {
        id
        status
      }
    }
  }
}
    `;
export type CreateJobMutationFn = Apollo.MutationFunction<CreateJobMutation, CreateJobMutationVariables>;

/**
 * __useCreateJobMutation__
 *
 * To run a mutation, you first call `useCreateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobMutation, { data, loading, error }] = useCreateJobMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useCreateJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobMutation, CreateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobMutation, CreateJobMutationVariables>(CreateJobDocument, options);
      }
export type CreateJobMutationHookResult = ReturnType<typeof useCreateJobMutation>;
export type CreateJobMutationResult = Apollo.MutationResult<CreateJobMutation>;
export type CreateJobMutationOptions = Apollo.BaseMutationOptions<CreateJobMutation, CreateJobMutationVariables>;
export const JobStatusDocument = gql`
    query JobStatus($jobId: ID!) {
  job(id: $jobId) {
    ... on BulkAtfJob {
      ...BulkAtfJobDetails
    }
  }
}
    ${BulkAtfJobDetailsFragmentDoc}`;

/**
 * __useJobStatusQuery__
 *
 * To run a query within a React component, call `useJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useJobStatusQuery(baseOptions: Apollo.QueryHookOptions<JobStatusQuery, JobStatusQueryVariables> & ({ variables: JobStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobStatusQuery, JobStatusQueryVariables>(JobStatusDocument, options);
      }
export function useJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobStatusQuery, JobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobStatusQuery, JobStatusQueryVariables>(JobStatusDocument, options);
        }
// @ts-ignore
export function useJobStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobStatusQuery, JobStatusQueryVariables>): Apollo.UseSuspenseQueryResult<JobStatusQuery, JobStatusQueryVariables>;
export function useJobStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStatusQuery, JobStatusQueryVariables>): Apollo.UseSuspenseQueryResult<JobStatusQuery | undefined, JobStatusQueryVariables>;
export function useJobStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStatusQuery, JobStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobStatusQuery, JobStatusQueryVariables>(JobStatusDocument, options);
        }
export type JobStatusQueryHookResult = ReturnType<typeof useJobStatusQuery>;
export type JobStatusLazyQueryHookResult = ReturnType<typeof useJobStatusLazyQuery>;
export type JobStatusSuspenseQueryHookResult = ReturnType<typeof useJobStatusSuspenseQuery>;
export type JobStatusQueryResult = Apollo.QueryResult<JobStatusQuery, JobStatusQueryVariables>;
export const BulkAtfJobsDocument = gql`
    query BulkAtfJobs($ids: [ID!]) {
  jobs(ids: $ids, types: ["BulkAtfJob"]) {
    ... on BulkAtfJob {
      ...BulkAtfJobDetails
    }
  }
}
    ${BulkAtfJobDetailsFragmentDoc}`;

/**
 * __useBulkAtfJobsQuery__
 *
 * To run a query within a React component, call `useBulkAtfJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkAtfJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkAtfJobsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkAtfJobsQuery(baseOptions?: Apollo.QueryHookOptions<BulkAtfJobsQuery, BulkAtfJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkAtfJobsQuery, BulkAtfJobsQueryVariables>(BulkAtfJobsDocument, options);
      }
export function useBulkAtfJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkAtfJobsQuery, BulkAtfJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkAtfJobsQuery, BulkAtfJobsQueryVariables>(BulkAtfJobsDocument, options);
        }
// @ts-ignore
export function useBulkAtfJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BulkAtfJobsQuery, BulkAtfJobsQueryVariables>): Apollo.UseSuspenseQueryResult<BulkAtfJobsQuery, BulkAtfJobsQueryVariables>;
export function useBulkAtfJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkAtfJobsQuery, BulkAtfJobsQueryVariables>): Apollo.UseSuspenseQueryResult<BulkAtfJobsQuery | undefined, BulkAtfJobsQueryVariables>;
export function useBulkAtfJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkAtfJobsQuery, BulkAtfJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BulkAtfJobsQuery, BulkAtfJobsQueryVariables>(BulkAtfJobsDocument, options);
        }
export type BulkAtfJobsQueryHookResult = ReturnType<typeof useBulkAtfJobsQuery>;
export type BulkAtfJobsLazyQueryHookResult = ReturnType<typeof useBulkAtfJobsLazyQuery>;
export type BulkAtfJobsSuspenseQueryHookResult = ReturnType<typeof useBulkAtfJobsSuspenseQuery>;
export type BulkAtfJobsQueryResult = Apollo.QueryResult<BulkAtfJobsQuery, BulkAtfJobsQueryVariables>;
export const BulkPublishAttributesDocument = gql`
    mutation BulkPublishAttributes($input: BulkPublishInput!) {
  bulkPublishAttributes(input: $input) {
    jobId
    totalAsinsAttemptedToPublish
    totalAttributesAttemptedToPublish
  }
}
    `;
export type BulkPublishAttributesMutationFn = Apollo.MutationFunction<BulkPublishAttributesMutation, BulkPublishAttributesMutationVariables>;

/**
 * __useBulkPublishAttributesMutation__
 *
 * To run a mutation, you first call `useBulkPublishAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkPublishAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkPublishAttributesMutation, { data, loading, error }] = useBulkPublishAttributesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkPublishAttributesMutation(baseOptions?: Apollo.MutationHookOptions<BulkPublishAttributesMutation, BulkPublishAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkPublishAttributesMutation, BulkPublishAttributesMutationVariables>(BulkPublishAttributesDocument, options);
      }
export type BulkPublishAttributesMutationHookResult = ReturnType<typeof useBulkPublishAttributesMutation>;
export type BulkPublishAttributesMutationResult = Apollo.MutationResult<BulkPublishAttributesMutation>;
export type BulkPublishAttributesMutationOptions = Apollo.BaseMutationOptions<BulkPublishAttributesMutation, BulkPublishAttributesMutationVariables>;
export const BulkpublishJobsDocument = gql`
    query BulkpublishJobs($ids: [ID!]) {
  jobs(ids: $ids, types: ["BulkPublishV2Job"]) {
    ... on BulkPublishV2Job {
      id
      status
      createdAt
      metadata {
        ... on BulkPublishV2Metadata {
          successfulResults {
            asin {
              asin
              marketplace {
                country
              }
            }
            attributes {
              key
              value
              language
            }
          }
          failedResults {
            asin {
              asin
              marketplace {
                country
              }
            }
            attributes {
              key
              value
              language
              error {
                error
              }
            }
            error {
              error
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBulkpublishJobsQuery__
 *
 * To run a query within a React component, call `useBulkpublishJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkpublishJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkpublishJobsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkpublishJobsQuery(baseOptions?: Apollo.QueryHookOptions<BulkpublishJobsQuery, BulkpublishJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkpublishJobsQuery, BulkpublishJobsQueryVariables>(BulkpublishJobsDocument, options);
      }
export function useBulkpublishJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkpublishJobsQuery, BulkpublishJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkpublishJobsQuery, BulkpublishJobsQueryVariables>(BulkpublishJobsDocument, options);
        }
// @ts-ignore
export function useBulkpublishJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BulkpublishJobsQuery, BulkpublishJobsQueryVariables>): Apollo.UseSuspenseQueryResult<BulkpublishJobsQuery, BulkpublishJobsQueryVariables>;
export function useBulkpublishJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkpublishJobsQuery, BulkpublishJobsQueryVariables>): Apollo.UseSuspenseQueryResult<BulkpublishJobsQuery | undefined, BulkpublishJobsQueryVariables>;
export function useBulkpublishJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkpublishJobsQuery, BulkpublishJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BulkpublishJobsQuery, BulkpublishJobsQueryVariables>(BulkpublishJobsDocument, options);
        }
export type BulkpublishJobsQueryHookResult = ReturnType<typeof useBulkpublishJobsQuery>;
export type BulkpublishJobsLazyQueryHookResult = ReturnType<typeof useBulkpublishJobsLazyQuery>;
export type BulkpublishJobsSuspenseQueryHookResult = ReturnType<typeof useBulkpublishJobsSuspenseQuery>;
export type BulkpublishJobsQueryResult = Apollo.QueryResult<BulkpublishJobsQuery, BulkpublishJobsQueryVariables>;
export const BulkPublishPreviewDocument = gql`
    query bulkPublishPreview($filters: BulkPublishPreviewInput, $first: Int!, $after: String) {
  bulkPublishPreview(filters: $filters, first: $first, after: $after) {
    edges {
      node {
        key
        language
        value
        modifiedBy
        modifiedAt
        version
        removed
        lastPublishedVersion
        lastPublishedDate
        publishResult {
          status
          result
          success
        }
        issues
        asinObject {
          id
          asin
          marketplace {
            country
          }
          program {
            programId
            name
          }
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalAttributesBeingPreviewed
    totalAttributesNotInDraft
    availablePrograms {
      id
      name
    }
    invalidAsins {
      asinObject {
        id
        asin
        marketplace {
          country
        }
      }
      missingAttributes {
        language
        attributes
      }
      error {
        asin
        marketplace
        message
      }
    }
  }
}
    `;

/**
 * __useBulkPublishPreviewQuery__
 *
 * To run a query within a React component, call `useBulkPublishPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkPublishPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkPublishPreviewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useBulkPublishPreviewQuery(baseOptions: Apollo.QueryHookOptions<BulkPublishPreviewQuery, BulkPublishPreviewQueryVariables> & ({ variables: BulkPublishPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkPublishPreviewQuery, BulkPublishPreviewQueryVariables>(BulkPublishPreviewDocument, options);
      }
export function useBulkPublishPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkPublishPreviewQuery, BulkPublishPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkPublishPreviewQuery, BulkPublishPreviewQueryVariables>(BulkPublishPreviewDocument, options);
        }
// @ts-ignore
export function useBulkPublishPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BulkPublishPreviewQuery, BulkPublishPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<BulkPublishPreviewQuery, BulkPublishPreviewQueryVariables>;
export function useBulkPublishPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkPublishPreviewQuery, BulkPublishPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<BulkPublishPreviewQuery | undefined, BulkPublishPreviewQueryVariables>;
export function useBulkPublishPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkPublishPreviewQuery, BulkPublishPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BulkPublishPreviewQuery, BulkPublishPreviewQueryVariables>(BulkPublishPreviewDocument, options);
        }
export type BulkPublishPreviewQueryHookResult = ReturnType<typeof useBulkPublishPreviewQuery>;
export type BulkPublishPreviewLazyQueryHookResult = ReturnType<typeof useBulkPublishPreviewLazyQuery>;
export type BulkPublishPreviewSuspenseQueryHookResult = ReturnType<typeof useBulkPublishPreviewSuspenseQuery>;
export type BulkPublishPreviewQueryResult = Apollo.QueryResult<BulkPublishPreviewQuery, BulkPublishPreviewQueryVariables>;
export const BulkSlatesDocument = gql`
    query bulkSlates($inputs: [BulkSlatesQueryObject!]!) {
  bulkSlates(input: $inputs) {
    ...VariantUrlNames
  }
}
    ${VariantUrlNamesFragmentDoc}`;

/**
 * __useBulkSlatesQuery__
 *
 * To run a query within a React component, call `useBulkSlatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkSlatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkSlatesQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useBulkSlatesQuery(baseOptions: Apollo.QueryHookOptions<BulkSlatesQuery, BulkSlatesQueryVariables> & ({ variables: BulkSlatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkSlatesQuery, BulkSlatesQueryVariables>(BulkSlatesDocument, options);
      }
export function useBulkSlatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkSlatesQuery, BulkSlatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkSlatesQuery, BulkSlatesQueryVariables>(BulkSlatesDocument, options);
        }
// @ts-ignore
export function useBulkSlatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BulkSlatesQuery, BulkSlatesQueryVariables>): Apollo.UseSuspenseQueryResult<BulkSlatesQuery, BulkSlatesQueryVariables>;
export function useBulkSlatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkSlatesQuery, BulkSlatesQueryVariables>): Apollo.UseSuspenseQueryResult<BulkSlatesQuery | undefined, BulkSlatesQueryVariables>;
export function useBulkSlatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkSlatesQuery, BulkSlatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BulkSlatesQuery, BulkSlatesQueryVariables>(BulkSlatesDocument, options);
        }
export type BulkSlatesQueryHookResult = ReturnType<typeof useBulkSlatesQuery>;
export type BulkSlatesLazyQueryHookResult = ReturnType<typeof useBulkSlatesLazyQuery>;
export type BulkSlatesSuspenseQueryHookResult = ReturnType<typeof useBulkSlatesSuspenseQuery>;
export type BulkSlatesQueryResult = Apollo.QueryResult<BulkSlatesQuery, BulkSlatesQueryVariables>;
export const BulkCreateAssetDocument = gql`
    mutation BulkCreateAsset($input: [BulkCreateAssetInput!]!) {
  bulkCreateAsset(input: $input) {
    message
    code
    success
    asset {
      ...AssetFields
    }
    id
  }
}
    ${AssetFieldsFragmentDoc}`;
export type BulkCreateAssetMutationFn = Apollo.MutationFunction<BulkCreateAssetMutation, BulkCreateAssetMutationVariables>;

/**
 * __useBulkCreateAssetMutation__
 *
 * To run a mutation, you first call `useBulkCreateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateAssetMutation, { data, loading, error }] = useBulkCreateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkCreateAssetMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateAssetMutation, BulkCreateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCreateAssetMutation, BulkCreateAssetMutationVariables>(BulkCreateAssetDocument, options);
      }
export type BulkCreateAssetMutationHookResult = ReturnType<typeof useBulkCreateAssetMutation>;
export type BulkCreateAssetMutationResult = Apollo.MutationResult<BulkCreateAssetMutation>;
export type BulkCreateAssetMutationOptions = Apollo.BaseMutationOptions<BulkCreateAssetMutation, BulkCreateAssetMutationVariables>;
export const BulkSaveSlatesDocument = gql`
    mutation BulkSaveSlates($input: [SaveSlatesInput!]!) {
  bulkSaveSlates(input: $input) {
    code
    message
    success
    succeeded {
      assetId
      url
      filename
      modifiedAt
      modifiedBy
      variant
      version
      removed
      lastPublishedDate
      lastPublishedVersion
    }
    failed {
      reason
      variant
    }
    asin
    marketplace
  }
}
    `;
export type BulkSaveSlatesMutationFn = Apollo.MutationFunction<BulkSaveSlatesMutation, BulkSaveSlatesMutationVariables>;

/**
 * __useBulkSaveSlatesMutation__
 *
 * To run a mutation, you first call `useBulkSaveSlatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkSaveSlatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkSaveSlatesMutation, { data, loading, error }] = useBulkSaveSlatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkSaveSlatesMutation(baseOptions?: Apollo.MutationHookOptions<BulkSaveSlatesMutation, BulkSaveSlatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkSaveSlatesMutation, BulkSaveSlatesMutationVariables>(BulkSaveSlatesDocument, options);
      }
export type BulkSaveSlatesMutationHookResult = ReturnType<typeof useBulkSaveSlatesMutation>;
export type BulkSaveSlatesMutationResult = Apollo.MutationResult<BulkSaveSlatesMutation>;
export type BulkSaveSlatesMutationOptions = Apollo.BaseMutationOptions<BulkSaveSlatesMutation, BulkSaveSlatesMutationVariables>;
export const ProductIdAndProductNameForBulkImageDocument = gql`
    query productIdAndProductNameForBulkImage($inputs: [MpAsinQueryObject!]!) {
  productIdAndProductNameForBulkImage(input: $inputs) {
    ... on ProductIdAndProductNameStatus {
      ...ProductIdNameFieldsSegment
    }
    ... on ProductIdAndProductNameError {
      ...ProductIdNameFieldsError
    }
  }
}
    ${ProductIdNameFieldsSegmentFragmentDoc}
${ProductIdNameFieldsErrorFragmentDoc}`;

/**
 * __useProductIdAndProductNameForBulkImageQuery__
 *
 * To run a query within a React component, call `useProductIdAndProductNameForBulkImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductIdAndProductNameForBulkImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductIdAndProductNameForBulkImageQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useProductIdAndProductNameForBulkImageQuery(baseOptions: Apollo.QueryHookOptions<ProductIdAndProductNameForBulkImageQuery, ProductIdAndProductNameForBulkImageQueryVariables> & ({ variables: ProductIdAndProductNameForBulkImageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductIdAndProductNameForBulkImageQuery, ProductIdAndProductNameForBulkImageQueryVariables>(ProductIdAndProductNameForBulkImageDocument, options);
      }
export function useProductIdAndProductNameForBulkImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductIdAndProductNameForBulkImageQuery, ProductIdAndProductNameForBulkImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductIdAndProductNameForBulkImageQuery, ProductIdAndProductNameForBulkImageQueryVariables>(ProductIdAndProductNameForBulkImageDocument, options);
        }
// @ts-ignore
export function useProductIdAndProductNameForBulkImageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductIdAndProductNameForBulkImageQuery, ProductIdAndProductNameForBulkImageQueryVariables>): Apollo.UseSuspenseQueryResult<ProductIdAndProductNameForBulkImageQuery, ProductIdAndProductNameForBulkImageQueryVariables>;
export function useProductIdAndProductNameForBulkImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductIdAndProductNameForBulkImageQuery, ProductIdAndProductNameForBulkImageQueryVariables>): Apollo.UseSuspenseQueryResult<ProductIdAndProductNameForBulkImageQuery | undefined, ProductIdAndProductNameForBulkImageQueryVariables>;
export function useProductIdAndProductNameForBulkImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductIdAndProductNameForBulkImageQuery, ProductIdAndProductNameForBulkImageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductIdAndProductNameForBulkImageQuery, ProductIdAndProductNameForBulkImageQueryVariables>(ProductIdAndProductNameForBulkImageDocument, options);
        }
export type ProductIdAndProductNameForBulkImageQueryHookResult = ReturnType<typeof useProductIdAndProductNameForBulkImageQuery>;
export type ProductIdAndProductNameForBulkImageLazyQueryHookResult = ReturnType<typeof useProductIdAndProductNameForBulkImageLazyQuery>;
export type ProductIdAndProductNameForBulkImageSuspenseQueryHookResult = ReturnType<typeof useProductIdAndProductNameForBulkImageSuspenseQuery>;
export type ProductIdAndProductNameForBulkImageQueryResult = Apollo.QueryResult<ProductIdAndProductNameForBulkImageQuery, ProductIdAndProductNameForBulkImageQueryVariables>;
export const AsinsForBundleManagerDocument = gql`
    query AsinsForBundleManager($marketplace: String!, $programName: String!) {
  bundleManagerPrograms(marketplace: $marketplace, programName: $programName) {
    asins(marketplace: $marketplace) {
      asin
      deviceName
    }
  }
}
    `;

/**
 * __useAsinsForBundleManagerQuery__
 *
 * To run a query within a React component, call `useAsinsForBundleManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsinsForBundleManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsinsForBundleManagerQuery({
 *   variables: {
 *      marketplace: // value for 'marketplace'
 *      programName: // value for 'programName'
 *   },
 * });
 */
export function useAsinsForBundleManagerQuery(baseOptions: Apollo.QueryHookOptions<AsinsForBundleManagerQuery, AsinsForBundleManagerQueryVariables> & ({ variables: AsinsForBundleManagerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsinsForBundleManagerQuery, AsinsForBundleManagerQueryVariables>(AsinsForBundleManagerDocument, options);
      }
export function useAsinsForBundleManagerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsinsForBundleManagerQuery, AsinsForBundleManagerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsinsForBundleManagerQuery, AsinsForBundleManagerQueryVariables>(AsinsForBundleManagerDocument, options);
        }
// @ts-ignore
export function useAsinsForBundleManagerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AsinsForBundleManagerQuery, AsinsForBundleManagerQueryVariables>): Apollo.UseSuspenseQueryResult<AsinsForBundleManagerQuery, AsinsForBundleManagerQueryVariables>;
export function useAsinsForBundleManagerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AsinsForBundleManagerQuery, AsinsForBundleManagerQueryVariables>): Apollo.UseSuspenseQueryResult<AsinsForBundleManagerQuery | undefined, AsinsForBundleManagerQueryVariables>;
export function useAsinsForBundleManagerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AsinsForBundleManagerQuery, AsinsForBundleManagerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AsinsForBundleManagerQuery, AsinsForBundleManagerQueryVariables>(AsinsForBundleManagerDocument, options);
        }
export type AsinsForBundleManagerQueryHookResult = ReturnType<typeof useAsinsForBundleManagerQuery>;
export type AsinsForBundleManagerLazyQueryHookResult = ReturnType<typeof useAsinsForBundleManagerLazyQuery>;
export type AsinsForBundleManagerSuspenseQueryHookResult = ReturnType<typeof useAsinsForBundleManagerSuspenseQuery>;
export type AsinsForBundleManagerQueryResult = Apollo.QueryResult<AsinsForBundleManagerQuery, AsinsForBundleManagerQueryVariables>;
export const CreateBundleDocument = gql`
    mutation createBundle($input: CreateBundleRequest!) {
  createBundle(input: $input) {
    bundleEntities {
      id
      bundleForm {
        title
        autoGeneratedCreativeName
        bindingType
      }
      submissionDate
      status
      errorRecord
    }
  }
}
    `;
export type CreateBundleMutationFn = Apollo.MutationFunction<CreateBundleMutation, CreateBundleMutationVariables>;

/**
 * __useCreateBundleMutation__
 *
 * To run a mutation, you first call `useCreateBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBundleMutation, { data, loading, error }] = useCreateBundleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBundleMutation(baseOptions?: Apollo.MutationHookOptions<CreateBundleMutation, CreateBundleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBundleMutation, CreateBundleMutationVariables>(CreateBundleDocument, options);
      }
export type CreateBundleMutationHookResult = ReturnType<typeof useCreateBundleMutation>;
export type CreateBundleMutationResult = Apollo.MutationResult<CreateBundleMutation>;
export type CreateBundleMutationOptions = Apollo.BaseMutationOptions<CreateBundleMutation, CreateBundleMutationVariables>;
export const EchoMessageDocument = gql`
    query EchoMessage($message: String!) {
  echoMessage(message: $message) {
    string
  }
}
    `;

/**
 * __useEchoMessageQuery__
 *
 * To run a query within a React component, call `useEchoMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEchoMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEchoMessageQuery({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useEchoMessageQuery(baseOptions: Apollo.QueryHookOptions<EchoMessageQuery, EchoMessageQueryVariables> & ({ variables: EchoMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EchoMessageQuery, EchoMessageQueryVariables>(EchoMessageDocument, options);
      }
export function useEchoMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EchoMessageQuery, EchoMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EchoMessageQuery, EchoMessageQueryVariables>(EchoMessageDocument, options);
        }
// @ts-ignore
export function useEchoMessageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EchoMessageQuery, EchoMessageQueryVariables>): Apollo.UseSuspenseQueryResult<EchoMessageQuery, EchoMessageQueryVariables>;
export function useEchoMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EchoMessageQuery, EchoMessageQueryVariables>): Apollo.UseSuspenseQueryResult<EchoMessageQuery | undefined, EchoMessageQueryVariables>;
export function useEchoMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EchoMessageQuery, EchoMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EchoMessageQuery, EchoMessageQueryVariables>(EchoMessageDocument, options);
        }
export type EchoMessageQueryHookResult = ReturnType<typeof useEchoMessageQuery>;
export type EchoMessageLazyQueryHookResult = ReturnType<typeof useEchoMessageLazyQuery>;
export type EchoMessageSuspenseQueryHookResult = ReturnType<typeof useEchoMessageSuspenseQuery>;
export type EchoMessageQueryResult = Apollo.QueryResult<EchoMessageQuery, EchoMessageQueryVariables>;
export const ProgramsForBundleManagerDocument = gql`
    query ProgramsForBundleManager($marketplace: String!) {
  bundleManagerPrograms(marketplace: $marketplace) {
    programId
    programName
  }
}
    `;

/**
 * __useProgramsForBundleManagerQuery__
 *
 * To run a query within a React component, call `useProgramsForBundleManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramsForBundleManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramsForBundleManagerQuery({
 *   variables: {
 *      marketplace: // value for 'marketplace'
 *   },
 * });
 */
export function useProgramsForBundleManagerQuery(baseOptions: Apollo.QueryHookOptions<ProgramsForBundleManagerQuery, ProgramsForBundleManagerQueryVariables> & ({ variables: ProgramsForBundleManagerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramsForBundleManagerQuery, ProgramsForBundleManagerQueryVariables>(ProgramsForBundleManagerDocument, options);
      }
export function useProgramsForBundleManagerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramsForBundleManagerQuery, ProgramsForBundleManagerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramsForBundleManagerQuery, ProgramsForBundleManagerQueryVariables>(ProgramsForBundleManagerDocument, options);
        }
// @ts-ignore
export function useProgramsForBundleManagerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProgramsForBundleManagerQuery, ProgramsForBundleManagerQueryVariables>): Apollo.UseSuspenseQueryResult<ProgramsForBundleManagerQuery, ProgramsForBundleManagerQueryVariables>;
export function useProgramsForBundleManagerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramsForBundleManagerQuery, ProgramsForBundleManagerQueryVariables>): Apollo.UseSuspenseQueryResult<ProgramsForBundleManagerQuery | undefined, ProgramsForBundleManagerQueryVariables>;
export function useProgramsForBundleManagerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramsForBundleManagerQuery, ProgramsForBundleManagerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramsForBundleManagerQuery, ProgramsForBundleManagerQueryVariables>(ProgramsForBundleManagerDocument, options);
        }
export type ProgramsForBundleManagerQueryHookResult = ReturnType<typeof useProgramsForBundleManagerQuery>;
export type ProgramsForBundleManagerLazyQueryHookResult = ReturnType<typeof useProgramsForBundleManagerLazyQuery>;
export type ProgramsForBundleManagerSuspenseQueryHookResult = ReturnType<typeof useProgramsForBundleManagerSuspenseQuery>;
export type ProgramsForBundleManagerQueryResult = Apollo.QueryResult<ProgramsForBundleManagerQuery, ProgramsForBundleManagerQueryVariables>;
export const ApproveCampaignDocument = gql`
    mutation approveCampaign($campaignId: ID!, $projectId: ID!) {
  approveCampaign(campaignId: $campaignId, projectId: $projectId) {
    status
  }
}
    `;
export type ApproveCampaignMutationFn = Apollo.MutationFunction<ApproveCampaignMutation, ApproveCampaignMutationVariables>;

/**
 * __useApproveCampaignMutation__
 *
 * To run a mutation, you first call `useApproveCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveCampaignMutation, { data, loading, error }] = useApproveCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useApproveCampaignMutation(baseOptions?: Apollo.MutationHookOptions<ApproveCampaignMutation, ApproveCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveCampaignMutation, ApproveCampaignMutationVariables>(ApproveCampaignDocument, options);
      }
export type ApproveCampaignMutationHookResult = ReturnType<typeof useApproveCampaignMutation>;
export type ApproveCampaignMutationResult = Apollo.MutationResult<ApproveCampaignMutation>;
export type ApproveCampaignMutationOptions = Apollo.BaseMutationOptions<ApproveCampaignMutation, ApproveCampaignMutationVariables>;
export const ArchiveCampaignDocument = gql`
    mutation archiveCampaign($campaignId: ID!, $projectId: ID!, $userVersion: Int!) {
  archiveCampaign(
    campaignId: $campaignId
    projectId: $projectId
    userVersion: $userVersion
  ) {
    campaign {
      isArchived
      userVersion
    }
  }
}
    `;
export type ArchiveCampaignMutationFn = Apollo.MutationFunction<ArchiveCampaignMutation, ArchiveCampaignMutationVariables>;

/**
 * __useArchiveCampaignMutation__
 *
 * To run a mutation, you first call `useArchiveCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCampaignMutation, { data, loading, error }] = useArchiveCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      projectId: // value for 'projectId'
 *      userVersion: // value for 'userVersion'
 *   },
 * });
 */
export function useArchiveCampaignMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCampaignMutation, ArchiveCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCampaignMutation, ArchiveCampaignMutationVariables>(ArchiveCampaignDocument, options);
      }
export type ArchiveCampaignMutationHookResult = ReturnType<typeof useArchiveCampaignMutation>;
export type ArchiveCampaignMutationResult = Apollo.MutationResult<ArchiveCampaignMutation>;
export type ArchiveCampaignMutationOptions = Apollo.BaseMutationOptions<ArchiveCampaignMutation, ArchiveCampaignMutationVariables>;
export const CampaignDocument = gql`
    query Campaign($campaignId: ID!, $projectId: ID!) {
  campaign(campaignId: $campaignId, projectId: $projectId) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;

/**
 * __useCampaignQuery__
 *
 * To run a query within a React component, call `useCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCampaignQuery(baseOptions: Apollo.QueryHookOptions<CampaignQuery, CampaignQueryVariables> & ({ variables: CampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
      }
export function useCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
// @ts-ignore
export function useCampaignSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampaignQuery, CampaignQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignQuery, CampaignQueryVariables>;
export function useCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignQuery, CampaignQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignQuery | undefined, CampaignQueryVariables>;
export function useCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export type CampaignQueryHookResult = ReturnType<typeof useCampaignQuery>;
export type CampaignLazyQueryHookResult = ReturnType<typeof useCampaignLazyQuery>;
export type CampaignSuspenseQueryHookResult = ReturnType<typeof useCampaignSuspenseQuery>;
export type CampaignQueryResult = Apollo.QueryResult<CampaignQuery, CampaignQueryVariables>;
export const CancelApproveCampaignDocument = gql`
    mutation cancelApproveCampaign($campaignId: ID!, $projectId: ID!) {
  cancelApproveCampaign(campaignId: $campaignId, projectId: $projectId) {
    status
  }
}
    `;
export type CancelApproveCampaignMutationFn = Apollo.MutationFunction<CancelApproveCampaignMutation, CancelApproveCampaignMutationVariables>;

/**
 * __useCancelApproveCampaignMutation__
 *
 * To run a mutation, you first call `useCancelApproveCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelApproveCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelApproveCampaignMutation, { data, loading, error }] = useCancelApproveCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCancelApproveCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CancelApproveCampaignMutation, CancelApproveCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelApproveCampaignMutation, CancelApproveCampaignMutationVariables>(CancelApproveCampaignDocument, options);
      }
export type CancelApproveCampaignMutationHookResult = ReturnType<typeof useCancelApproveCampaignMutation>;
export type CancelApproveCampaignMutationResult = Apollo.MutationResult<CancelApproveCampaignMutation>;
export type CancelApproveCampaignMutationOptions = Apollo.BaseMutationOptions<CancelApproveCampaignMutation, CancelApproveCampaignMutationVariables>;
export const CloneCampaignDocument = gql`
    mutation cloneCampaign($campaignId: ID!, $projectId: ID!, $newCampaignId: ID!) {
  cloneCampaign(
    campaignId: $campaignId
    projectId: $projectId
    newCampaignId: $newCampaignId
  ) {
    id
  }
}
    `;
export type CloneCampaignMutationFn = Apollo.MutationFunction<CloneCampaignMutation, CloneCampaignMutationVariables>;

/**
 * __useCloneCampaignMutation__
 *
 * To run a mutation, you first call `useCloneCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneCampaignMutation, { data, loading, error }] = useCloneCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      projectId: // value for 'projectId'
 *      newCampaignId: // value for 'newCampaignId'
 *   },
 * });
 */
export function useCloneCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CloneCampaignMutation, CloneCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneCampaignMutation, CloneCampaignMutationVariables>(CloneCampaignDocument, options);
      }
export type CloneCampaignMutationHookResult = ReturnType<typeof useCloneCampaignMutation>;
export type CloneCampaignMutationResult = Apollo.MutationResult<CloneCampaignMutation>;
export type CloneCampaignMutationOptions = Apollo.BaseMutationOptions<CloneCampaignMutation, CloneCampaignMutationVariables>;
export const CreateCampaignDocument = gql`
    mutation createCampaign($input: CreateCampaignInput!) {
  createCampaign(input: $input) {
    campaign {
      ...CampaignFields
    }
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type CreateCampaignMutationFn = Apollo.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignMutation, CreateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument, options);
      }
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = Apollo.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = Apollo.BaseMutationOptions<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const ProjectEventDocument = gql`
    query projectEvent($projectId: ID!) {
  projectEvent(projectId: $projectId) {
    projectEvent {
      name
      parentEventId
      realm
      businessGroup
      accessControlGroup
      timezone
      childEvents {
        childEventId
        elemId
        title
        start
        end
      }
    }
  }
}
    `;

/**
 * __useProjectEventQuery__
 *
 * To run a query within a React component, call `useProjectEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectEventQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectEventQuery(baseOptions: Apollo.QueryHookOptions<ProjectEventQuery, ProjectEventQueryVariables> & ({ variables: ProjectEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectEventQuery, ProjectEventQueryVariables>(ProjectEventDocument, options);
      }
export function useProjectEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectEventQuery, ProjectEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectEventQuery, ProjectEventQueryVariables>(ProjectEventDocument, options);
        }
// @ts-ignore
export function useProjectEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectEventQuery, ProjectEventQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectEventQuery, ProjectEventQueryVariables>;
export function useProjectEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectEventQuery, ProjectEventQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectEventQuery | undefined, ProjectEventQueryVariables>;
export function useProjectEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectEventQuery, ProjectEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectEventQuery, ProjectEventQueryVariables>(ProjectEventDocument, options);
        }
export type ProjectEventQueryHookResult = ReturnType<typeof useProjectEventQuery>;
export type ProjectEventLazyQueryHookResult = ReturnType<typeof useProjectEventLazyQuery>;
export type ProjectEventSuspenseQueryHookResult = ReturnType<typeof useProjectEventSuspenseQuery>;
export type ProjectEventQueryResult = Apollo.QueryResult<ProjectEventQuery, ProjectEventQueryVariables>;
export const ProjectDocument = gql`
    query project($projectId: ID!) {
  project(projectId: $projectId) {
    id
    createdAt
    createdBy
    modifiedAt
    modifiedBy
    intent
    name
    parentId
    permissions {
      ... on Permission {
        action
        person {
          email
          firstName
          lastName
        }
        user
      }
      ... on LdapPermission {
        action
        ldapGroups
      }
      ... on BindlePermission {
        resourceName
        id
      }
    }
    public
    settings {
      eventId
    }
    state
    version
    template
  }
}
    `;

/**
 * __useProjectQuery__
 *
 * To run a query within a React component, call `useProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectQuery, ProjectQueryVariables> & ({ variables: ProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
      }
export function useProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
        }
// @ts-ignore
export function useProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectQuery, ProjectQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectQuery, ProjectQueryVariables>;
export function useProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectQuery, ProjectQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectQuery | undefined, ProjectQueryVariables>;
export function useProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
        }
export type ProjectQueryHookResult = ReturnType<typeof useProjectQuery>;
export type ProjectLazyQueryHookResult = ReturnType<typeof useProjectLazyQuery>;
export type ProjectSuspenseQueryHookResult = ReturnType<typeof useProjectSuspenseQuery>;
export type ProjectQueryResult = Apollo.QueryResult<ProjectQuery, ProjectQueryVariables>;
export const PublishCampaignDocument = gql`
    mutation publishCampaign($campaignId: ID!, $projectId: ID!) {
  publishCampaign(campaignId: $campaignId, projectId: $projectId) {
    status
  }
}
    `;
export type PublishCampaignMutationFn = Apollo.MutationFunction<PublishCampaignMutation, PublishCampaignMutationVariables>;

/**
 * __usePublishCampaignMutation__
 *
 * To run a mutation, you first call `usePublishCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishCampaignMutation, { data, loading, error }] = usePublishCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePublishCampaignMutation(baseOptions?: Apollo.MutationHookOptions<PublishCampaignMutation, PublishCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishCampaignMutation, PublishCampaignMutationVariables>(PublishCampaignDocument, options);
      }
export type PublishCampaignMutationHookResult = ReturnType<typeof usePublishCampaignMutation>;
export type PublishCampaignMutationResult = Apollo.MutationResult<PublishCampaignMutation>;
export type PublishCampaignMutationOptions = Apollo.BaseMutationOptions<PublishCampaignMutation, PublishCampaignMutationVariables>;
export const RequestApproveCampaignDocument = gql`
    mutation requestApproveCampaign($campaignId: ID!, $projectId: ID!) {
  requestApproveCampaign(campaignId: $campaignId, projectId: $projectId) {
    status
  }
}
    `;
export type RequestApproveCampaignMutationFn = Apollo.MutationFunction<RequestApproveCampaignMutation, RequestApproveCampaignMutationVariables>;

/**
 * __useRequestApproveCampaignMutation__
 *
 * To run a mutation, you first call `useRequestApproveCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestApproveCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestApproveCampaignMutation, { data, loading, error }] = useRequestApproveCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRequestApproveCampaignMutation(baseOptions?: Apollo.MutationHookOptions<RequestApproveCampaignMutation, RequestApproveCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestApproveCampaignMutation, RequestApproveCampaignMutationVariables>(RequestApproveCampaignDocument, options);
      }
export type RequestApproveCampaignMutationHookResult = ReturnType<typeof useRequestApproveCampaignMutation>;
export type RequestApproveCampaignMutationResult = Apollo.MutationResult<RequestApproveCampaignMutation>;
export type RequestApproveCampaignMutationOptions = Apollo.BaseMutationOptions<RequestApproveCampaignMutation, RequestApproveCampaignMutationVariables>;
export const RestoreCampaignDocument = gql`
    mutation restoreCampaign($campaignId: ID!, $projectId: ID!, $userVersion: Int!) {
  restoreCampaign(
    campaignId: $campaignId
    projectId: $projectId
    userVersion: $userVersion
  ) {
    campaign {
      isArchived
      userVersion
    }
  }
}
    `;
export type RestoreCampaignMutationFn = Apollo.MutationFunction<RestoreCampaignMutation, RestoreCampaignMutationVariables>;

/**
 * __useRestoreCampaignMutation__
 *
 * To run a mutation, you first call `useRestoreCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCampaignMutation, { data, loading, error }] = useRestoreCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      projectId: // value for 'projectId'
 *      userVersion: // value for 'userVersion'
 *   },
 * });
 */
export function useRestoreCampaignMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCampaignMutation, RestoreCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCampaignMutation, RestoreCampaignMutationVariables>(RestoreCampaignDocument, options);
      }
export type RestoreCampaignMutationHookResult = ReturnType<typeof useRestoreCampaignMutation>;
export type RestoreCampaignMutationResult = Apollo.MutationResult<RestoreCampaignMutation>;
export type RestoreCampaignMutationOptions = Apollo.BaseMutationOptions<RestoreCampaignMutation, RestoreCampaignMutationVariables>;
export const SaveCampaignDocument = gql`
    mutation saveCampaign($input: SaveCampaignInput!) {
  saveCampaign(input: $input) {
    campaign {
      ...CampaignFields
    }
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type SaveCampaignMutationFn = Apollo.MutationFunction<SaveCampaignMutation, SaveCampaignMutationVariables>;

/**
 * __useSaveCampaignMutation__
 *
 * To run a mutation, you first call `useSaveCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCampaignMutation, { data, loading, error }] = useSaveCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCampaignMutation(baseOptions?: Apollo.MutationHookOptions<SaveCampaignMutation, SaveCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCampaignMutation, SaveCampaignMutationVariables>(SaveCampaignDocument, options);
      }
export type SaveCampaignMutationHookResult = ReturnType<typeof useSaveCampaignMutation>;
export type SaveCampaignMutationResult = Apollo.MutationResult<SaveCampaignMutation>;
export type SaveCampaignMutationOptions = Apollo.BaseMutationOptions<SaveCampaignMutation, SaveCampaignMutationVariables>;
export const SuspendCampaignDocument = gql`
    mutation suspendCampaign($campaignId: ID!, $projectId: ID!) {
  suspendCampaign(campaignId: $campaignId, projectId: $projectId) {
    status
  }
}
    `;
export type SuspendCampaignMutationFn = Apollo.MutationFunction<SuspendCampaignMutation, SuspendCampaignMutationVariables>;

/**
 * __useSuspendCampaignMutation__
 *
 * To run a mutation, you first call `useSuspendCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendCampaignMutation, { data, loading, error }] = useSuspendCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSuspendCampaignMutation(baseOptions?: Apollo.MutationHookOptions<SuspendCampaignMutation, SuspendCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendCampaignMutation, SuspendCampaignMutationVariables>(SuspendCampaignDocument, options);
      }
export type SuspendCampaignMutationHookResult = ReturnType<typeof useSuspendCampaignMutation>;
export type SuspendCampaignMutationResult = Apollo.MutationResult<SuspendCampaignMutation>;
export type SuspendCampaignMutationOptions = Apollo.BaseMutationOptions<SuspendCampaignMutation, SuspendCampaignMutationVariables>;
export const SuspendPlacementDocument = gql`
    mutation suspendPlacement($placementId: ID!, $campaignId: ID!, $projectId: ID!) {
  suspendPlacement(
    placementId: $placementId
    campaignId: $campaignId
    projectId: $projectId
  ) {
    status
  }
}
    `;
export type SuspendPlacementMutationFn = Apollo.MutationFunction<SuspendPlacementMutation, SuspendPlacementMutationVariables>;

/**
 * __useSuspendPlacementMutation__
 *
 * To run a mutation, you first call `useSuspendPlacementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendPlacementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendPlacementMutation, { data, loading, error }] = useSuspendPlacementMutation({
 *   variables: {
 *      placementId: // value for 'placementId'
 *      campaignId: // value for 'campaignId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSuspendPlacementMutation(baseOptions?: Apollo.MutationHookOptions<SuspendPlacementMutation, SuspendPlacementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendPlacementMutation, SuspendPlacementMutationVariables>(SuspendPlacementDocument, options);
      }
export type SuspendPlacementMutationHookResult = ReturnType<typeof useSuspendPlacementMutation>;
export type SuspendPlacementMutationResult = Apollo.MutationResult<SuspendPlacementMutation>;
export type SuspendPlacementMutationOptions = Apollo.BaseMutationOptions<SuspendPlacementMutation, SuspendPlacementMutationVariables>;
export const SymphonyInfoDocument = gql`
    query SymphonyInfo($campaignId: ID!, $projectId: ID!) {
  symphonyInfo(campaignId: $campaignId, projectId: $projectId) {
    mvtCombinationId
    placementMapping {
      placementUiId
      symphonyPlacementId
      symphonyPreviewURL
    }
    symphonyCreativeId
  }
}
    `;

/**
 * __useSymphonyInfoQuery__
 *
 * To run a query within a React component, call `useSymphonyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSymphonyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSymphonyInfoQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSymphonyInfoQuery(baseOptions: Apollo.QueryHookOptions<SymphonyInfoQuery, SymphonyInfoQueryVariables> & ({ variables: SymphonyInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SymphonyInfoQuery, SymphonyInfoQueryVariables>(SymphonyInfoDocument, options);
      }
export function useSymphonyInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SymphonyInfoQuery, SymphonyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SymphonyInfoQuery, SymphonyInfoQueryVariables>(SymphonyInfoDocument, options);
        }
// @ts-ignore
export function useSymphonyInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SymphonyInfoQuery, SymphonyInfoQueryVariables>): Apollo.UseSuspenseQueryResult<SymphonyInfoQuery, SymphonyInfoQueryVariables>;
export function useSymphonyInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SymphonyInfoQuery, SymphonyInfoQueryVariables>): Apollo.UseSuspenseQueryResult<SymphonyInfoQuery | undefined, SymphonyInfoQueryVariables>;
export function useSymphonyInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SymphonyInfoQuery, SymphonyInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SymphonyInfoQuery, SymphonyInfoQueryVariables>(SymphonyInfoDocument, options);
        }
export type SymphonyInfoQueryHookResult = ReturnType<typeof useSymphonyInfoQuery>;
export type SymphonyInfoLazyQueryHookResult = ReturnType<typeof useSymphonyInfoLazyQuery>;
export type SymphonyInfoSuspenseQueryHookResult = ReturnType<typeof useSymphonyInfoSuspenseQuery>;
export type SymphonyInfoQueryResult = Apollo.QueryResult<SymphonyInfoQuery, SymphonyInfoQueryVariables>;
export const AttributesDocument = gql`
    query Attributes($productId: ID!, $marketplace: String!, $asin: String!, $isLaunchPermOn: Boolean!) {
  attributes(
    productId: $productId
    marketplace: $marketplace
    asin: $asin
    isLaunchPermOn: $isLaunchPermOn
  ) {
    ...AttributeFields
  }
}
    ${AttributeFieldsFragmentDoc}`;

/**
 * __useAttributesQuery__
 *
 * To run a query within a React component, call `useAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributesQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      marketplace: // value for 'marketplace'
 *      asin: // value for 'asin'
 *      isLaunchPermOn: // value for 'isLaunchPermOn'
 *   },
 * });
 */
export function useAttributesQuery(baseOptions: Apollo.QueryHookOptions<AttributesQuery, AttributesQueryVariables> & ({ variables: AttributesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributesQuery, AttributesQueryVariables>(AttributesDocument, options);
      }
export function useAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributesQuery, AttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributesQuery, AttributesQueryVariables>(AttributesDocument, options);
        }
// @ts-ignore
export function useAttributesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AttributesQuery, AttributesQueryVariables>): Apollo.UseSuspenseQueryResult<AttributesQuery, AttributesQueryVariables>;
export function useAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttributesQuery, AttributesQueryVariables>): Apollo.UseSuspenseQueryResult<AttributesQuery | undefined, AttributesQueryVariables>;
export function useAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttributesQuery, AttributesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AttributesQuery, AttributesQueryVariables>(AttributesDocument, options);
        }
export type AttributesQueryHookResult = ReturnType<typeof useAttributesQuery>;
export type AttributesLazyQueryHookResult = ReturnType<typeof useAttributesLazyQuery>;
export type AttributesSuspenseQueryHookResult = ReturnType<typeof useAttributesSuspenseQuery>;
export type AttributesQueryResult = Apollo.QueryResult<AttributesQuery, AttributesQueryVariables>;
export const ProductDocument = gql`
    query Product($productId: ID!, $marketplace: String!, $asin: String) {
  product(id: $productId, marketplace: $marketplace, asin: $asin) {
    ...ProductFields
  }
}
    ${ProductFieldsFragmentDoc}`;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      marketplace: // value for 'marketplace'
 *      asin: // value for 'asin'
 *   },
 * });
 */
export function useProductQuery(baseOptions: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables> & ({ variables: ProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
// @ts-ignore
export function useProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductQuery, ProductQueryVariables>): Apollo.UseSuspenseQueryResult<ProductQuery, ProductQueryVariables>;
export function useProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductQuery, ProductQueryVariables>): Apollo.UseSuspenseQueryResult<ProductQuery | undefined, ProductQueryVariables>;
export function useProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductSuspenseQueryHookResult = ReturnType<typeof useProductSuspenseQuery>;
export type ProductQueryResult = Apollo.QueryResult<ProductQuery, ProductQueryVariables>;
export const DetailPageDocument = gql`
    query DetailPage($asin: String!, $filters: AsinFilterInput, $first: Int!, $isLaunchPermOn: Boolean!, $marketplace: String!, $productId: ID!) {
  asins(first: $first, filters: $filters) {
    nodes {
      ...DetailPageTabsContainerAsin
      program {
        name
        programId
      }
    }
  }
  attributes(
    asin: $asin
    isLaunchPermOn: $isLaunchPermOn
    marketplace: $marketplace
    productId: $productId
  ) {
    ...AttributeFields
  }
  bundleInfo(asin: $asin, marketplace: $marketplace) {
    ...BundleInfoTabType
  }
  detailPageStatus(asin: $asin, marketplace: $marketplace) {
    ...DetailPageStatusFields
  }
  product(id: $productId, marketplace: $marketplace) {
    ...ProductFields
  }
}
    ${DetailPageTabsContainerAsinFragmentDoc}
${AttributeFieldsFragmentDoc}
${BundleInfoTabTypeFragmentDoc}
${DetailPageStatusFieldsFragmentDoc}
${ProductFieldsFragmentDoc}`;

/**
 * __useDetailPageQuery__
 *
 * To run a query within a React component, call `useDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailPageQuery({
 *   variables: {
 *      asin: // value for 'asin'
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      isLaunchPermOn: // value for 'isLaunchPermOn'
 *      marketplace: // value for 'marketplace'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useDetailPageQuery(baseOptions: Apollo.QueryHookOptions<DetailPageQuery, DetailPageQueryVariables> & ({ variables: DetailPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetailPageQuery, DetailPageQueryVariables>(DetailPageDocument, options);
      }
export function useDetailPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetailPageQuery, DetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetailPageQuery, DetailPageQueryVariables>(DetailPageDocument, options);
        }
// @ts-ignore
export function useDetailPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DetailPageQuery, DetailPageQueryVariables>): Apollo.UseSuspenseQueryResult<DetailPageQuery, DetailPageQueryVariables>;
export function useDetailPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DetailPageQuery, DetailPageQueryVariables>): Apollo.UseSuspenseQueryResult<DetailPageQuery | undefined, DetailPageQueryVariables>;
export function useDetailPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DetailPageQuery, DetailPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DetailPageQuery, DetailPageQueryVariables>(DetailPageDocument, options);
        }
export type DetailPageQueryHookResult = ReturnType<typeof useDetailPageQuery>;
export type DetailPageLazyQueryHookResult = ReturnType<typeof useDetailPageLazyQuery>;
export type DetailPageSuspenseQueryHookResult = ReturnType<typeof useDetailPageSuspenseQuery>;
export type DetailPageQueryResult = Apollo.QueryResult<DetailPageQuery, DetailPageQueryVariables>;
export const DetailPageStatusDocument = gql`
    query DetailPageStatus($asin: String!, $marketplace: String!) {
  detailPageStatus(asin: $asin, marketplace: $marketplace) {
    ...DetailPageStatusFields
  }
}
    ${DetailPageStatusFieldsFragmentDoc}`;

/**
 * __useDetailPageStatusQuery__
 *
 * To run a query within a React component, call `useDetailPageStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailPageStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailPageStatusQuery({
 *   variables: {
 *      asin: // value for 'asin'
 *      marketplace: // value for 'marketplace'
 *   },
 * });
 */
export function useDetailPageStatusQuery(baseOptions: Apollo.QueryHookOptions<DetailPageStatusQuery, DetailPageStatusQueryVariables> & ({ variables: DetailPageStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetailPageStatusQuery, DetailPageStatusQueryVariables>(DetailPageStatusDocument, options);
      }
export function useDetailPageStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetailPageStatusQuery, DetailPageStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetailPageStatusQuery, DetailPageStatusQueryVariables>(DetailPageStatusDocument, options);
        }
// @ts-ignore
export function useDetailPageStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DetailPageStatusQuery, DetailPageStatusQueryVariables>): Apollo.UseSuspenseQueryResult<DetailPageStatusQuery, DetailPageStatusQueryVariables>;
export function useDetailPageStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DetailPageStatusQuery, DetailPageStatusQueryVariables>): Apollo.UseSuspenseQueryResult<DetailPageStatusQuery | undefined, DetailPageStatusQueryVariables>;
export function useDetailPageStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DetailPageStatusQuery, DetailPageStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DetailPageStatusQuery, DetailPageStatusQueryVariables>(DetailPageStatusDocument, options);
        }
export type DetailPageStatusQueryHookResult = ReturnType<typeof useDetailPageStatusQuery>;
export type DetailPageStatusLazyQueryHookResult = ReturnType<typeof useDetailPageStatusLazyQuery>;
export type DetailPageStatusSuspenseQueryHookResult = ReturnType<typeof useDetailPageStatusSuspenseQuery>;
export type DetailPageStatusQueryResult = Apollo.QueryResult<DetailPageStatusQuery, DetailPageStatusQueryVariables>;
export const LastPublishedVersionsDocument = gql`
    query LastPublishedVersions($input: LastPublishedVersionsInput!) {
  lastPublishedVersions(input: $input) {
    key
    language
    value
    version
    modifiedAt
    modifiedBy
    removed
    lastPublishedVersion
    lastPublishedDate
  }
}
    `;

/**
 * __useLastPublishedVersionsQuery__
 *
 * To run a query within a React component, call `useLastPublishedVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastPublishedVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastPublishedVersionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLastPublishedVersionsQuery(baseOptions: Apollo.QueryHookOptions<LastPublishedVersionsQuery, LastPublishedVersionsQueryVariables> & ({ variables: LastPublishedVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastPublishedVersionsQuery, LastPublishedVersionsQueryVariables>(LastPublishedVersionsDocument, options);
      }
export function useLastPublishedVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastPublishedVersionsQuery, LastPublishedVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastPublishedVersionsQuery, LastPublishedVersionsQueryVariables>(LastPublishedVersionsDocument, options);
        }
// @ts-ignore
export function useLastPublishedVersionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LastPublishedVersionsQuery, LastPublishedVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<LastPublishedVersionsQuery, LastPublishedVersionsQueryVariables>;
export function useLastPublishedVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LastPublishedVersionsQuery, LastPublishedVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<LastPublishedVersionsQuery | undefined, LastPublishedVersionsQueryVariables>;
export function useLastPublishedVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LastPublishedVersionsQuery, LastPublishedVersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LastPublishedVersionsQuery, LastPublishedVersionsQueryVariables>(LastPublishedVersionsDocument, options);
        }
export type LastPublishedVersionsQueryHookResult = ReturnType<typeof useLastPublishedVersionsQuery>;
export type LastPublishedVersionsLazyQueryHookResult = ReturnType<typeof useLastPublishedVersionsLazyQuery>;
export type LastPublishedVersionsSuspenseQueryHookResult = ReturnType<typeof useLastPublishedVersionsSuspenseQuery>;
export type LastPublishedVersionsQueryResult = Apollo.QueryResult<LastPublishedVersionsQuery, LastPublishedVersionsQueryVariables>;
export const PublishAttributesDocument = gql`
    mutation PublishAttributes($input: PublishAttributesInput!) {
  publishAttributes(input: $input) {
    code
    message
    success
    succeeded {
      key
      language
      version
      value
      modifiedAt
      modifiedBy
      removed
      lastPublishedVersion
      lastPublishedDate
    }
    failed {
      key
      reason
    }
  }
}
    `;
export type PublishAttributesMutationFn = Apollo.MutationFunction<PublishAttributesMutation, PublishAttributesMutationVariables>;

/**
 * __usePublishAttributesMutation__
 *
 * To run a mutation, you first call `usePublishAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishAttributesMutation, { data, loading, error }] = usePublishAttributesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishAttributesMutation(baseOptions?: Apollo.MutationHookOptions<PublishAttributesMutation, PublishAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishAttributesMutation, PublishAttributesMutationVariables>(PublishAttributesDocument, options);
      }
export type PublishAttributesMutationHookResult = ReturnType<typeof usePublishAttributesMutation>;
export type PublishAttributesMutationResult = Apollo.MutationResult<PublishAttributesMutation>;
export type PublishAttributesMutationOptions = Apollo.BaseMutationOptions<PublishAttributesMutation, PublishAttributesMutationVariables>;
export const SaveAttributesDocument = gql`
    mutation SaveAttributes($input: SaveAttributesInput!) {
  saveAttributes(input: $input) {
    code
    message
    success
    succeeded {
      key
      language
      value
      version
      modifiedAt
      modifiedBy
      removed
      lastPublishedDate
      lastPublishedVersion
    }
    failed {
      key
      reason
    }
    asin {
      ...WithinLaunchDate
    }
  }
}
    ${WithinLaunchDateFragmentDoc}`;
export type SaveAttributesMutationFn = Apollo.MutationFunction<SaveAttributesMutation, SaveAttributesMutationVariables>;

/**
 * __useSaveAttributesMutation__
 *
 * To run a mutation, you first call `useSaveAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAttributesMutation, { data, loading, error }] = useSaveAttributesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAttributesMutation(baseOptions?: Apollo.MutationHookOptions<SaveAttributesMutation, SaveAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAttributesMutation, SaveAttributesMutationVariables>(SaveAttributesDocument, options);
      }
export type SaveAttributesMutationHookResult = ReturnType<typeof useSaveAttributesMutation>;
export type SaveAttributesMutationResult = Apollo.MutationResult<SaveAttributesMutation>;
export type SaveAttributesMutationOptions = Apollo.BaseMutationOptions<SaveAttributesMutation, SaveAttributesMutationVariables>;
export const BundleInfoTabDocument = gql`
    query BundleInfoTab($asin: String!, $marketplace: String!) {
  bundleInfo(asin: $asin, marketplace: $marketplace) {
    ...BundleAsins
    ...ComponentAsin
  }
}
    ${BundleAsinsFragmentDoc}
${ComponentAsinFragmentDoc}`;

/**
 * __useBundleInfoTabQuery__
 *
 * To run a query within a React component, call `useBundleInfoTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useBundleInfoTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBundleInfoTabQuery({
 *   variables: {
 *      asin: // value for 'asin'
 *      marketplace: // value for 'marketplace'
 *   },
 * });
 */
export function useBundleInfoTabQuery(baseOptions: Apollo.QueryHookOptions<BundleInfoTabQuery, BundleInfoTabQueryVariables> & ({ variables: BundleInfoTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BundleInfoTabQuery, BundleInfoTabQueryVariables>(BundleInfoTabDocument, options);
      }
export function useBundleInfoTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BundleInfoTabQuery, BundleInfoTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BundleInfoTabQuery, BundleInfoTabQueryVariables>(BundleInfoTabDocument, options);
        }
// @ts-ignore
export function useBundleInfoTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BundleInfoTabQuery, BundleInfoTabQueryVariables>): Apollo.UseSuspenseQueryResult<BundleInfoTabQuery, BundleInfoTabQueryVariables>;
export function useBundleInfoTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BundleInfoTabQuery, BundleInfoTabQueryVariables>): Apollo.UseSuspenseQueryResult<BundleInfoTabQuery | undefined, BundleInfoTabQueryVariables>;
export function useBundleInfoTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BundleInfoTabQuery, BundleInfoTabQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BundleInfoTabQuery, BundleInfoTabQueryVariables>(BundleInfoTabDocument, options);
        }
export type BundleInfoTabQueryHookResult = ReturnType<typeof useBundleInfoTabQuery>;
export type BundleInfoTabLazyQueryHookResult = ReturnType<typeof useBundleInfoTabLazyQuery>;
export type BundleInfoTabSuspenseQueryHookResult = ReturnType<typeof useBundleInfoTabSuspenseQuery>;
export type BundleInfoTabQueryResult = Apollo.QueryResult<BundleInfoTabQuery, BundleInfoTabQueryVariables>;
export const CampaignConfigIdsDocument = gql`
    query CampaignConfigIds {
  campaignConfigurations(first: 1000) {
    nodes {
      ...CampaignConfigId
    }
  }
}
    ${CampaignConfigIdFragmentDoc}`;

/**
 * __useCampaignConfigIdsQuery__
 *
 * To run a query within a React component, call `useCampaignConfigIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignConfigIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignConfigIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCampaignConfigIdsQuery(baseOptions?: Apollo.QueryHookOptions<CampaignConfigIdsQuery, CampaignConfigIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignConfigIdsQuery, CampaignConfigIdsQueryVariables>(CampaignConfigIdsDocument, options);
      }
export function useCampaignConfigIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignConfigIdsQuery, CampaignConfigIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignConfigIdsQuery, CampaignConfigIdsQueryVariables>(CampaignConfigIdsDocument, options);
        }
// @ts-ignore
export function useCampaignConfigIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampaignConfigIdsQuery, CampaignConfigIdsQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignConfigIdsQuery, CampaignConfigIdsQueryVariables>;
export function useCampaignConfigIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignConfigIdsQuery, CampaignConfigIdsQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignConfigIdsQuery | undefined, CampaignConfigIdsQueryVariables>;
export function useCampaignConfigIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignConfigIdsQuery, CampaignConfigIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignConfigIdsQuery, CampaignConfigIdsQueryVariables>(CampaignConfigIdsDocument, options);
        }
export type CampaignConfigIdsQueryHookResult = ReturnType<typeof useCampaignConfigIdsQuery>;
export type CampaignConfigIdsLazyQueryHookResult = ReturnType<typeof useCampaignConfigIdsLazyQuery>;
export type CampaignConfigIdsSuspenseQueryHookResult = ReturnType<typeof useCampaignConfigIdsSuspenseQuery>;
export type CampaignConfigIdsQueryResult = Apollo.QueryResult<CampaignConfigIdsQuery, CampaignConfigIdsQueryVariables>;
export const CampaignsTabTrafficProjectDocument = gql`
    query CampaignsTabTrafficProject($id: ID!, $filterByView: CampaignFilterByViewInput!) {
  trafficProject(id: $id) {
    ...CampaignsTabTrafficProjectInfo
  }
}
    ${CampaignsTabTrafficProjectInfoFragmentDoc}`;

/**
 * __useCampaignsTabTrafficProjectQuery__
 *
 * To run a query within a React component, call `useCampaignsTabTrafficProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsTabTrafficProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsTabTrafficProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filterByView: // value for 'filterByView'
 *   },
 * });
 */
export function useCampaignsTabTrafficProjectQuery(baseOptions: Apollo.QueryHookOptions<CampaignsTabTrafficProjectQuery, CampaignsTabTrafficProjectQueryVariables> & ({ variables: CampaignsTabTrafficProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsTabTrafficProjectQuery, CampaignsTabTrafficProjectQueryVariables>(CampaignsTabTrafficProjectDocument, options);
      }
export function useCampaignsTabTrafficProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsTabTrafficProjectQuery, CampaignsTabTrafficProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsTabTrafficProjectQuery, CampaignsTabTrafficProjectQueryVariables>(CampaignsTabTrafficProjectDocument, options);
        }
// @ts-ignore
export function useCampaignsTabTrafficProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampaignsTabTrafficProjectQuery, CampaignsTabTrafficProjectQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignsTabTrafficProjectQuery, CampaignsTabTrafficProjectQueryVariables>;
export function useCampaignsTabTrafficProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignsTabTrafficProjectQuery, CampaignsTabTrafficProjectQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignsTabTrafficProjectQuery | undefined, CampaignsTabTrafficProjectQueryVariables>;
export function useCampaignsTabTrafficProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignsTabTrafficProjectQuery, CampaignsTabTrafficProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignsTabTrafficProjectQuery, CampaignsTabTrafficProjectQueryVariables>(CampaignsTabTrafficProjectDocument, options);
        }
export type CampaignsTabTrafficProjectQueryHookResult = ReturnType<typeof useCampaignsTabTrafficProjectQuery>;
export type CampaignsTabTrafficProjectLazyQueryHookResult = ReturnType<typeof useCampaignsTabTrafficProjectLazyQuery>;
export type CampaignsTabTrafficProjectSuspenseQueryHookResult = ReturnType<typeof useCampaignsTabTrafficProjectSuspenseQuery>;
export type CampaignsTabTrafficProjectQueryResult = Apollo.QueryResult<CampaignsTabTrafficProjectQuery, CampaignsTabTrafficProjectQueryVariables>;
export const CopyDetailPageDocument = gql`
    mutation CopyDetailPage($input: CopyDPInput!) {
  copyDetailPage(input: $input) {
    code
    message
    success
    attributesSucceeded {
      asin
      key
    }
    attributesFailed {
      asin
      key
      reason
    }
    pricingSucceeded {
      asin
      infoType
    }
    pricingFailed {
      asin
      infoType
      reason
    }
    slatesSucceeded {
      asin
      variant
    }
    slatesFailed {
      asin
      variant
      reason
    }
    campaignCopyErrors
  }
}
    `;
export type CopyDetailPageMutationFn = Apollo.MutationFunction<CopyDetailPageMutation, CopyDetailPageMutationVariables>;

/**
 * __useCopyDetailPageMutation__
 *
 * To run a mutation, you first call `useCopyDetailPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyDetailPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyDetailPageMutation, { data, loading, error }] = useCopyDetailPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyDetailPageMutation(baseOptions?: Apollo.MutationHookOptions<CopyDetailPageMutation, CopyDetailPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyDetailPageMutation, CopyDetailPageMutationVariables>(CopyDetailPageDocument, options);
      }
export type CopyDetailPageMutationHookResult = ReturnType<typeof useCopyDetailPageMutation>;
export type CopyDetailPageMutationResult = Apollo.MutationResult<CopyDetailPageMutation>;
export type CopyDetailPageMutationOptions = Apollo.BaseMutationOptions<CopyDetailPageMutation, CopyDetailPageMutationVariables>;
export const AsinAccessDocument = gql`
    query AsinAccess($input: ASINAccessInput!) {
  checkASINAccess(input: $input) {
    succeeded
    failed
  }
}
    `;

/**
 * __useAsinAccessQuery__
 *
 * To run a query within a React component, call `useAsinAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsinAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsinAccessQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAsinAccessQuery(baseOptions: Apollo.QueryHookOptions<AsinAccessQuery, AsinAccessQueryVariables> & ({ variables: AsinAccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsinAccessQuery, AsinAccessQueryVariables>(AsinAccessDocument, options);
      }
export function useAsinAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsinAccessQuery, AsinAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsinAccessQuery, AsinAccessQueryVariables>(AsinAccessDocument, options);
        }
// @ts-ignore
export function useAsinAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AsinAccessQuery, AsinAccessQueryVariables>): Apollo.UseSuspenseQueryResult<AsinAccessQuery, AsinAccessQueryVariables>;
export function useAsinAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AsinAccessQuery, AsinAccessQueryVariables>): Apollo.UseSuspenseQueryResult<AsinAccessQuery | undefined, AsinAccessQueryVariables>;
export function useAsinAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AsinAccessQuery, AsinAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AsinAccessQuery, AsinAccessQueryVariables>(AsinAccessDocument, options);
        }
export type AsinAccessQueryHookResult = ReturnType<typeof useAsinAccessQuery>;
export type AsinAccessLazyQueryHookResult = ReturnType<typeof useAsinAccessLazyQuery>;
export type AsinAccessSuspenseQueryHookResult = ReturnType<typeof useAsinAccessSuspenseQuery>;
export type AsinAccessQueryResult = Apollo.QueryResult<AsinAccessQuery, AsinAccessQueryVariables>;
export const DpDataDocument = gql`
    query DpData($asin: String!, $marketplace: String!, $productId: ID!) {
  attributes(
    asin: $asin
    marketplace: $marketplace
    productId: $productId
    isLaunchPermOn: true
  ) {
    key
    value
    removed
    version
    language
  }
  slates(
    asin: $asin
    marketplace: $marketplace
    productId: $productId
    isLaunchPermOn: true
  ) {
    assetId
    variant
    removed
  }
  pricing(
    asin: $asin
    marketplace: $marketplace
    productId: $productId
    isLaunchPermOn: true
  ) {
    infoType
    value
  }
}
    `;

/**
 * __useDpDataQuery__
 *
 * To run a query within a React component, call `useDpDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDpDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDpDataQuery({
 *   variables: {
 *      asin: // value for 'asin'
 *      marketplace: // value for 'marketplace'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useDpDataQuery(baseOptions: Apollo.QueryHookOptions<DpDataQuery, DpDataQueryVariables> & ({ variables: DpDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DpDataQuery, DpDataQueryVariables>(DpDataDocument, options);
      }
export function useDpDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DpDataQuery, DpDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DpDataQuery, DpDataQueryVariables>(DpDataDocument, options);
        }
// @ts-ignore
export function useDpDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DpDataQuery, DpDataQueryVariables>): Apollo.UseSuspenseQueryResult<DpDataQuery, DpDataQueryVariables>;
export function useDpDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpDataQuery, DpDataQueryVariables>): Apollo.UseSuspenseQueryResult<DpDataQuery | undefined, DpDataQueryVariables>;
export function useDpDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpDataQuery, DpDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DpDataQuery, DpDataQueryVariables>(DpDataDocument, options);
        }
export type DpDataQueryHookResult = ReturnType<typeof useDpDataQuery>;
export type DpDataLazyQueryHookResult = ReturnType<typeof useDpDataLazyQuery>;
export type DpDataSuspenseQueryHookResult = ReturnType<typeof useDpDataSuspenseQuery>;
export type DpDataQueryResult = Apollo.QueryResult<DpDataQuery, DpDataQueryVariables>;
export const LastPublishedPricingDocument = gql`
    query LastPublishedPricing($input: LastPublishedPricingInput!) {
  lastPublishedPricing(input: $input) {
    infoType
    value
    version
    modifiedAt
    modifiedBy
    lastPublishedVersion
    lastPublishedDate
  }
}
    `;

/**
 * __useLastPublishedPricingQuery__
 *
 * To run a query within a React component, call `useLastPublishedPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastPublishedPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastPublishedPricingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLastPublishedPricingQuery(baseOptions: Apollo.QueryHookOptions<LastPublishedPricingQuery, LastPublishedPricingQueryVariables> & ({ variables: LastPublishedPricingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastPublishedPricingQuery, LastPublishedPricingQueryVariables>(LastPublishedPricingDocument, options);
      }
export function useLastPublishedPricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastPublishedPricingQuery, LastPublishedPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastPublishedPricingQuery, LastPublishedPricingQueryVariables>(LastPublishedPricingDocument, options);
        }
// @ts-ignore
export function useLastPublishedPricingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LastPublishedPricingQuery, LastPublishedPricingQueryVariables>): Apollo.UseSuspenseQueryResult<LastPublishedPricingQuery, LastPublishedPricingQueryVariables>;
export function useLastPublishedPricingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LastPublishedPricingQuery, LastPublishedPricingQueryVariables>): Apollo.UseSuspenseQueryResult<LastPublishedPricingQuery | undefined, LastPublishedPricingQueryVariables>;
export function useLastPublishedPricingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LastPublishedPricingQuery, LastPublishedPricingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LastPublishedPricingQuery, LastPublishedPricingQueryVariables>(LastPublishedPricingDocument, options);
        }
export type LastPublishedPricingQueryHookResult = ReturnType<typeof useLastPublishedPricingQuery>;
export type LastPublishedPricingLazyQueryHookResult = ReturnType<typeof useLastPublishedPricingLazyQuery>;
export type LastPublishedPricingSuspenseQueryHookResult = ReturnType<typeof useLastPublishedPricingSuspenseQuery>;
export type LastPublishedPricingQueryResult = Apollo.QueryResult<LastPublishedPricingQuery, LastPublishedPricingQueryVariables>;
export const PricingDocument = gql`
    query Pricing($productId: ID!, $marketplace: String!, $asin: String!, $isLaunchPermOn: Boolean!) {
  pricing(
    productId: $productId
    marketplace: $marketplace
    asin: $asin
    isLaunchPermOn: $isLaunchPermOn
  ) {
    modifiedAt
    modifiedBy
    version
    infoType
    value
    lastPublishedDate
    lastPublishedVersion
    publishResult {
      status
      success
      result
    }
  }
}
    `;

/**
 * __usePricingQuery__
 *
 * To run a query within a React component, call `usePricingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricingQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      marketplace: // value for 'marketplace'
 *      asin: // value for 'asin'
 *      isLaunchPermOn: // value for 'isLaunchPermOn'
 *   },
 * });
 */
export function usePricingQuery(baseOptions: Apollo.QueryHookOptions<PricingQuery, PricingQueryVariables> & ({ variables: PricingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PricingQuery, PricingQueryVariables>(PricingDocument, options);
      }
export function usePricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PricingQuery, PricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PricingQuery, PricingQueryVariables>(PricingDocument, options);
        }
// @ts-ignore
export function usePricingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PricingQuery, PricingQueryVariables>): Apollo.UseSuspenseQueryResult<PricingQuery, PricingQueryVariables>;
export function usePricingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PricingQuery, PricingQueryVariables>): Apollo.UseSuspenseQueryResult<PricingQuery | undefined, PricingQueryVariables>;
export function usePricingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PricingQuery, PricingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PricingQuery, PricingQueryVariables>(PricingDocument, options);
        }
export type PricingQueryHookResult = ReturnType<typeof usePricingQuery>;
export type PricingLazyQueryHookResult = ReturnType<typeof usePricingLazyQuery>;
export type PricingSuspenseQueryHookResult = ReturnType<typeof usePricingSuspenseQuery>;
export type PricingQueryResult = Apollo.QueryResult<PricingQuery, PricingQueryVariables>;
export const PublishPricingDocument = gql`
    mutation PublishPricing($input: PublishPricingInfoInput!) {
  publishPricing(input: $input) {
    code
    message
    success
    succeeded {
      modifiedAt
      modifiedBy
      version
      infoType
      value
      lastPublishedDate
      lastPublishedVersion
    }
    failed {
      reason
      infoType
    }
  }
}
    `;
export type PublishPricingMutationFn = Apollo.MutationFunction<PublishPricingMutation, PublishPricingMutationVariables>;

/**
 * __usePublishPricingMutation__
 *
 * To run a mutation, you first call `usePublishPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishPricingMutation, { data, loading, error }] = usePublishPricingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishPricingMutation(baseOptions?: Apollo.MutationHookOptions<PublishPricingMutation, PublishPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishPricingMutation, PublishPricingMutationVariables>(PublishPricingDocument, options);
      }
export type PublishPricingMutationHookResult = ReturnType<typeof usePublishPricingMutation>;
export type PublishPricingMutationResult = Apollo.MutationResult<PublishPricingMutation>;
export type PublishPricingMutationOptions = Apollo.BaseMutationOptions<PublishPricingMutation, PublishPricingMutationVariables>;
export const SavePricingDocument = gql`
    mutation SavePricing($input: SavePricingInfoInput!) {
  savePricing(input: $input) {
    code
    message
    success
    succeeded {
      modifiedAt
      modifiedBy
      version
      infoType
      value
      lastPublishedDate
      lastPublishedVersion
    }
    failed {
      reason
      infoType
    }
  }
}
    `;
export type SavePricingMutationFn = Apollo.MutationFunction<SavePricingMutation, SavePricingMutationVariables>;

/**
 * __useSavePricingMutation__
 *
 * To run a mutation, you first call `useSavePricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePricingMutation, { data, loading, error }] = useSavePricingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePricingMutation(baseOptions?: Apollo.MutationHookOptions<SavePricingMutation, SavePricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePricingMutation, SavePricingMutationVariables>(SavePricingDocument, options);
      }
export type SavePricingMutationHookResult = ReturnType<typeof useSavePricingMutation>;
export type SavePricingMutationResult = Apollo.MutationResult<SavePricingMutation>;
export type SavePricingMutationOptions = Apollo.BaseMutationOptions<SavePricingMutation, SavePricingMutationVariables>;
export const ValidatePublishedPricingDocument = gql`
    mutation ValidatePublishedPricing($input: ValidatePublishedPricingInfoInput!) {
  validatePublishedPricing(input: $input) {
    code
    success
    message
    publishedPricingInfos {
      infoType
      value
    }
  }
}
    `;
export type ValidatePublishedPricingMutationFn = Apollo.MutationFunction<ValidatePublishedPricingMutation, ValidatePublishedPricingMutationVariables>;

/**
 * __useValidatePublishedPricingMutation__
 *
 * To run a mutation, you first call `useValidatePublishedPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePublishedPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePublishedPricingMutation, { data, loading, error }] = useValidatePublishedPricingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidatePublishedPricingMutation(baseOptions?: Apollo.MutationHookOptions<ValidatePublishedPricingMutation, ValidatePublishedPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidatePublishedPricingMutation, ValidatePublishedPricingMutationVariables>(ValidatePublishedPricingDocument, options);
      }
export type ValidatePublishedPricingMutationHookResult = ReturnType<typeof useValidatePublishedPricingMutation>;
export type ValidatePublishedPricingMutationResult = Apollo.MutationResult<ValidatePublishedPricingMutation>;
export type ValidatePublishedPricingMutationOptions = Apollo.BaseMutationOptions<ValidatePublishedPricingMutation, ValidatePublishedPricingMutationVariables>;
export const LastPublishedSlateVersionsDocument = gql`
    query LastPublishedSlateVersions($input: LastPublishedSlateVersionsInput!) {
  lastPublishedSlateVersions(input: $input) {
    variant
    assetId
    filename
    url
    version
    modifiedAt
    modifiedBy
    removed
    lastPublishedVersion
    lastPublishedDate
  }
}
    `;

/**
 * __useLastPublishedSlateVersionsQuery__
 *
 * To run a query within a React component, call `useLastPublishedSlateVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastPublishedSlateVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastPublishedSlateVersionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLastPublishedSlateVersionsQuery(baseOptions: Apollo.QueryHookOptions<LastPublishedSlateVersionsQuery, LastPublishedSlateVersionsQueryVariables> & ({ variables: LastPublishedSlateVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastPublishedSlateVersionsQuery, LastPublishedSlateVersionsQueryVariables>(LastPublishedSlateVersionsDocument, options);
      }
export function useLastPublishedSlateVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastPublishedSlateVersionsQuery, LastPublishedSlateVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastPublishedSlateVersionsQuery, LastPublishedSlateVersionsQueryVariables>(LastPublishedSlateVersionsDocument, options);
        }
// @ts-ignore
export function useLastPublishedSlateVersionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LastPublishedSlateVersionsQuery, LastPublishedSlateVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<LastPublishedSlateVersionsQuery, LastPublishedSlateVersionsQueryVariables>;
export function useLastPublishedSlateVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LastPublishedSlateVersionsQuery, LastPublishedSlateVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<LastPublishedSlateVersionsQuery | undefined, LastPublishedSlateVersionsQueryVariables>;
export function useLastPublishedSlateVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LastPublishedSlateVersionsQuery, LastPublishedSlateVersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LastPublishedSlateVersionsQuery, LastPublishedSlateVersionsQueryVariables>(LastPublishedSlateVersionsDocument, options);
        }
export type LastPublishedSlateVersionsQueryHookResult = ReturnType<typeof useLastPublishedSlateVersionsQuery>;
export type LastPublishedSlateVersionsLazyQueryHookResult = ReturnType<typeof useLastPublishedSlateVersionsLazyQuery>;
export type LastPublishedSlateVersionsSuspenseQueryHookResult = ReturnType<typeof useLastPublishedSlateVersionsSuspenseQuery>;
export type LastPublishedSlateVersionsQueryResult = Apollo.QueryResult<LastPublishedSlateVersionsQuery, LastPublishedSlateVersionsQueryVariables>;
export const PublishSlatePlaceholdersDocument = gql`
    mutation PublishSlatePlaceholders($input: SlatePlaceholderPublishInput!) {
  publishSlatePlaceholders(input: $input) {
    code
    success
    message
    shipmentId
    succeeded
    failed
  }
}
    `;
export type PublishSlatePlaceholdersMutationFn = Apollo.MutationFunction<PublishSlatePlaceholdersMutation, PublishSlatePlaceholdersMutationVariables>;

/**
 * __usePublishSlatePlaceholdersMutation__
 *
 * To run a mutation, you first call `usePublishSlatePlaceholdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishSlatePlaceholdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishSlatePlaceholdersMutation, { data, loading, error }] = usePublishSlatePlaceholdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishSlatePlaceholdersMutation(baseOptions?: Apollo.MutationHookOptions<PublishSlatePlaceholdersMutation, PublishSlatePlaceholdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishSlatePlaceholdersMutation, PublishSlatePlaceholdersMutationVariables>(PublishSlatePlaceholdersDocument, options);
      }
export type PublishSlatePlaceholdersMutationHookResult = ReturnType<typeof usePublishSlatePlaceholdersMutation>;
export type PublishSlatePlaceholdersMutationResult = Apollo.MutationResult<PublishSlatePlaceholdersMutation>;
export type PublishSlatePlaceholdersMutationOptions = Apollo.BaseMutationOptions<PublishSlatePlaceholdersMutation, PublishSlatePlaceholdersMutationVariables>;
export const PublishSlatesDocument = gql`
    mutation PublishSlates($input: SlatePublishInput!) {
  publishSlateImage(input: $input) {
    code
    success
    message
    shipmentId
    succeeded {
      assetId
      url
      filename
      modifiedAt
      modifiedBy
      lastPublishedDate
      lastPublishedVersion
      variant
      version
      removed
    }
    failed {
      reason
      variant
    }
  }
}
    `;
export type PublishSlatesMutationFn = Apollo.MutationFunction<PublishSlatesMutation, PublishSlatesMutationVariables>;

/**
 * __usePublishSlatesMutation__
 *
 * To run a mutation, you first call `usePublishSlatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishSlatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishSlatesMutation, { data, loading, error }] = usePublishSlatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishSlatesMutation(baseOptions?: Apollo.MutationHookOptions<PublishSlatesMutation, PublishSlatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishSlatesMutation, PublishSlatesMutationVariables>(PublishSlatesDocument, options);
      }
export type PublishSlatesMutationHookResult = ReturnType<typeof usePublishSlatesMutation>;
export type PublishSlatesMutationResult = Apollo.MutationResult<PublishSlatesMutation>;
export type PublishSlatesMutationOptions = Apollo.BaseMutationOptions<PublishSlatesMutation, PublishSlatesMutationVariables>;
export const SaveSlatesDocument = gql`
    mutation SaveSlates($input: SaveSlatesInput!) {
  saveSlates(input: $input) {
    code
    message
    success
    succeeded {
      assetId
      url
      filename
      modifiedAt
      modifiedBy
      variant
      version
      removed
      lastPublishedDate
      lastPublishedVersion
    }
    failed {
      reason
      variant
    }
  }
}
    `;
export type SaveSlatesMutationFn = Apollo.MutationFunction<SaveSlatesMutation, SaveSlatesMutationVariables>;

/**
 * __useSaveSlatesMutation__
 *
 * To run a mutation, you first call `useSaveSlatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSlatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSlatesMutation, { data, loading, error }] = useSaveSlatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSlatesMutation(baseOptions?: Apollo.MutationHookOptions<SaveSlatesMutation, SaveSlatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSlatesMutation, SaveSlatesMutationVariables>(SaveSlatesDocument, options);
      }
export type SaveSlatesMutationHookResult = ReturnType<typeof useSaveSlatesMutation>;
export type SaveSlatesMutationResult = Apollo.MutationResult<SaveSlatesMutation>;
export type SaveSlatesMutationOptions = Apollo.BaseMutationOptions<SaveSlatesMutation, SaveSlatesMutationVariables>;
export const SlatesDocument = gql`
    query Slates($productId: ID!, $marketplace: String!, $asin: String!, $isLaunchPermOn: Boolean!) {
  slates(
    productId: $productId
    marketplace: $marketplace
    asin: $asin
    isLaunchPermOn: $isLaunchPermOn
  ) {
    assetId
    modifiedAt
    modifiedBy
    variant
    filename
    lastPublishedDate
    lastPublishedVersion
    publishResult {
      result
      success
    }
    shipmentId
    version
    url
    isPublished
    removed
  }
}
    `;

/**
 * __useSlatesQuery__
 *
 * To run a query within a React component, call `useSlatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlatesQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      marketplace: // value for 'marketplace'
 *      asin: // value for 'asin'
 *      isLaunchPermOn: // value for 'isLaunchPermOn'
 *   },
 * });
 */
export function useSlatesQuery(baseOptions: Apollo.QueryHookOptions<SlatesQuery, SlatesQueryVariables> & ({ variables: SlatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SlatesQuery, SlatesQueryVariables>(SlatesDocument, options);
      }
export function useSlatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SlatesQuery, SlatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SlatesQuery, SlatesQueryVariables>(SlatesDocument, options);
        }
// @ts-ignore
export function useSlatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SlatesQuery, SlatesQueryVariables>): Apollo.UseSuspenseQueryResult<SlatesQuery, SlatesQueryVariables>;
export function useSlatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SlatesQuery, SlatesQueryVariables>): Apollo.UseSuspenseQueryResult<SlatesQuery | undefined, SlatesQueryVariables>;
export function useSlatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SlatesQuery, SlatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SlatesQuery, SlatesQueryVariables>(SlatesDocument, options);
        }
export type SlatesQueryHookResult = ReturnType<typeof useSlatesQuery>;
export type SlatesLazyQueryHookResult = ReturnType<typeof useSlatesLazyQuery>;
export type SlatesSuspenseQueryHookResult = ReturnType<typeof useSlatesSuspenseQuery>;
export type SlatesQueryResult = Apollo.QueryResult<SlatesQuery, SlatesQueryVariables>;
export const DeactivateOrDeleteExperimentDocument = gql`
    mutation DeactivateOrDeleteExperiment($dpbExperimentId: ID!, $experimentType: String!) {
  deactivateOrDeleteExperiment(
    dpbExperimentId: $dpbExperimentId
    experimentType: $experimentType
  ) {
    code
    message
    success
    experiment {
      activationDate
      deactivationDate
      dpbExperimentId
      experimentType
      mvesExperimentIds
      name
      status
      updatedAt
      updatedBy
    }
  }
}
    `;
export type DeactivateOrDeleteExperimentMutationFn = Apollo.MutationFunction<DeactivateOrDeleteExperimentMutation, DeactivateOrDeleteExperimentMutationVariables>;

/**
 * __useDeactivateOrDeleteExperimentMutation__
 *
 * To run a mutation, you first call `useDeactivateOrDeleteExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateOrDeleteExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateOrDeleteExperimentMutation, { data, loading, error }] = useDeactivateOrDeleteExperimentMutation({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      experimentType: // value for 'experimentType'
 *   },
 * });
 */
export function useDeactivateOrDeleteExperimentMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateOrDeleteExperimentMutation, DeactivateOrDeleteExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateOrDeleteExperimentMutation, DeactivateOrDeleteExperimentMutationVariables>(DeactivateOrDeleteExperimentDocument, options);
      }
export type DeactivateOrDeleteExperimentMutationHookResult = ReturnType<typeof useDeactivateOrDeleteExperimentMutation>;
export type DeactivateOrDeleteExperimentMutationResult = Apollo.MutationResult<DeactivateOrDeleteExperimentMutation>;
export type DeactivateOrDeleteExperimentMutationOptions = Apollo.BaseMutationOptions<DeactivateOrDeleteExperimentMutation, DeactivateOrDeleteExperimentMutationVariables>;
export const FetchAndUpdateExperimentSummaryInfoDocument = gql`
    mutation fetchAndUpdateExperimentSummaryInfo($dpbExperimentId: ID!, $experimentType: String!, $mvtExperimentId: ID!) {
  fetchAndUpdateExperimentSummaryInfo(
    dpbExperimentId: $dpbExperimentId
    experimentType: $experimentType
    mvtExperimentId: $mvtExperimentId
  ) {
    quipUrl
    lastUpdateDateTime
  }
}
    `;
export type FetchAndUpdateExperimentSummaryInfoMutationFn = Apollo.MutationFunction<FetchAndUpdateExperimentSummaryInfoMutation, FetchAndUpdateExperimentSummaryInfoMutationVariables>;

/**
 * __useFetchAndUpdateExperimentSummaryInfoMutation__
 *
 * To run a mutation, you first call `useFetchAndUpdateExperimentSummaryInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchAndUpdateExperimentSummaryInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchAndUpdateExperimentSummaryInfoMutation, { data, loading, error }] = useFetchAndUpdateExperimentSummaryInfoMutation({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      experimentType: // value for 'experimentType'
 *      mvtExperimentId: // value for 'mvtExperimentId'
 *   },
 * });
 */
export function useFetchAndUpdateExperimentSummaryInfoMutation(baseOptions?: Apollo.MutationHookOptions<FetchAndUpdateExperimentSummaryInfoMutation, FetchAndUpdateExperimentSummaryInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FetchAndUpdateExperimentSummaryInfoMutation, FetchAndUpdateExperimentSummaryInfoMutationVariables>(FetchAndUpdateExperimentSummaryInfoDocument, options);
      }
export type FetchAndUpdateExperimentSummaryInfoMutationHookResult = ReturnType<typeof useFetchAndUpdateExperimentSummaryInfoMutation>;
export type FetchAndUpdateExperimentSummaryInfoMutationResult = Apollo.MutationResult<FetchAndUpdateExperimentSummaryInfoMutation>;
export type FetchAndUpdateExperimentSummaryInfoMutationOptions = Apollo.BaseMutationOptions<FetchAndUpdateExperimentSummaryInfoMutation, FetchAndUpdateExperimentSummaryInfoMutationVariables>;
export const UpdateExperimentDetailsDocument = gql`
    mutation UpdateExperimentDetails($dpbExperimentId: ID!, $experimentType: String!, $experiment: DpExperimentDetailsUpdateInput!) {
  updateExperiment(
    dpbExperimentId: $dpbExperimentId
    experimentType: $experimentType
    experiment: $experiment
  ) {
    code
    message
    success
    experiment {
      bullseyeSegments {
        segmentId
        position
        titleExclusions
        bulletExclusions
        landingImageExclusions
      }
      activationDate
      deactivationDate
      contextualCohortType
      controlConfigurationType
      hashDimension
      createdAt
      createdBy
      description
      dpbExperimentId
      experimentType
      locales
      marketplaces
      mvesExperimentIds
      name
      primaryAsin
      status
      updatedAt
      updatedBy
      variationalAsins
    }
  }
}
    `;
export type UpdateExperimentDetailsMutationFn = Apollo.MutationFunction<UpdateExperimentDetailsMutation, UpdateExperimentDetailsMutationVariables>;

/**
 * __useUpdateExperimentDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateExperimentDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExperimentDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExperimentDetailsMutation, { data, loading, error }] = useUpdateExperimentDetailsMutation({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      experimentType: // value for 'experimentType'
 *      experiment: // value for 'experiment'
 *   },
 * });
 */
export function useUpdateExperimentDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExperimentDetailsMutation, UpdateExperimentDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExperimentDetailsMutation, UpdateExperimentDetailsMutationVariables>(UpdateExperimentDetailsDocument, options);
      }
export type UpdateExperimentDetailsMutationHookResult = ReturnType<typeof useUpdateExperimentDetailsMutation>;
export type UpdateExperimentDetailsMutationResult = Apollo.MutationResult<UpdateExperimentDetailsMutation>;
export type UpdateExperimentDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateExperimentDetailsMutation, UpdateExperimentDetailsMutationVariables>;
export const StartPublishExperimentDocument = gql`
    mutation StartPublishExperiment($dpbExperimentId: ID!, $experimentType: String!) {
  startPublishExperiment(
    dpbExperimentId: $dpbExperimentId
    experimentType: $experimentType
  ) {
    code
    message
    success
  }
}
    `;
export type StartPublishExperimentMutationFn = Apollo.MutationFunction<StartPublishExperimentMutation, StartPublishExperimentMutationVariables>;

/**
 * __useStartPublishExperimentMutation__
 *
 * To run a mutation, you first call `useStartPublishExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPublishExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPublishExperimentMutation, { data, loading, error }] = useStartPublishExperimentMutation({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      experimentType: // value for 'experimentType'
 *   },
 * });
 */
export function useStartPublishExperimentMutation(baseOptions?: Apollo.MutationHookOptions<StartPublishExperimentMutation, StartPublishExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartPublishExperimentMutation, StartPublishExperimentMutationVariables>(StartPublishExperimentDocument, options);
      }
export type StartPublishExperimentMutationHookResult = ReturnType<typeof useStartPublishExperimentMutation>;
export type StartPublishExperimentMutationResult = Apollo.MutationResult<StartPublishExperimentMutation>;
export type StartPublishExperimentMutationOptions = Apollo.BaseMutationOptions<StartPublishExperimentMutation, StartPublishExperimentMutationVariables>;
export const ActivateMvesExperimentDocument = gql`
    mutation ActivateMVESExperiment($dpbExperimentId: ID!, $experimentType: String!, $experimentActivationDate: String!, $experimentDeactivationDate: String!) {
  activateMVESExperiment(
    dpbExperimentId: $dpbExperimentId
    experimentType: $experimentType
    activationDate: $experimentActivationDate
    deactivationDate: $experimentDeactivationDate
  ) {
    code
    message
    success
  }
}
    `;
export type ActivateMvesExperimentMutationFn = Apollo.MutationFunction<ActivateMvesExperimentMutation, ActivateMvesExperimentMutationVariables>;

/**
 * __useActivateMvesExperimentMutation__
 *
 * To run a mutation, you first call `useActivateMvesExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateMvesExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateMvesExperimentMutation, { data, loading, error }] = useActivateMvesExperimentMutation({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      experimentType: // value for 'experimentType'
 *      experimentActivationDate: // value for 'experimentActivationDate'
 *      experimentDeactivationDate: // value for 'experimentDeactivationDate'
 *   },
 * });
 */
export function useActivateMvesExperimentMutation(baseOptions?: Apollo.MutationHookOptions<ActivateMvesExperimentMutation, ActivateMvesExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateMvesExperimentMutation, ActivateMvesExperimentMutationVariables>(ActivateMvesExperimentDocument, options);
      }
export type ActivateMvesExperimentMutationHookResult = ReturnType<typeof useActivateMvesExperimentMutation>;
export type ActivateMvesExperimentMutationResult = Apollo.MutationResult<ActivateMvesExperimentMutation>;
export type ActivateMvesExperimentMutationOptions = Apollo.BaseMutationOptions<ActivateMvesExperimentMutation, ActivateMvesExperimentMutationVariables>;
export const BatchPreviewVariantsDocument = gql`
    mutation batchPreviewVariants($dpbExperimentId: ID!, $asin: String!) {
  batchPreviewVariants(dpbExperimentId: $dpbExperimentId, asin: $asin) {
    code
    message
    success
  }
}
    `;
export type BatchPreviewVariantsMutationFn = Apollo.MutationFunction<BatchPreviewVariantsMutation, BatchPreviewVariantsMutationVariables>;

/**
 * __useBatchPreviewVariantsMutation__
 *
 * To run a mutation, you first call `useBatchPreviewVariantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchPreviewVariantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchPreviewVariantsMutation, { data, loading, error }] = useBatchPreviewVariantsMutation({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      asin: // value for 'asin'
 *   },
 * });
 */
export function useBatchPreviewVariantsMutation(baseOptions?: Apollo.MutationHookOptions<BatchPreviewVariantsMutation, BatchPreviewVariantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchPreviewVariantsMutation, BatchPreviewVariantsMutationVariables>(BatchPreviewVariantsDocument, options);
      }
export type BatchPreviewVariantsMutationHookResult = ReturnType<typeof useBatchPreviewVariantsMutation>;
export type BatchPreviewVariantsMutationResult = Apollo.MutationResult<BatchPreviewVariantsMutation>;
export type BatchPreviewVariantsMutationOptions = Apollo.BaseMutationOptions<BatchPreviewVariantsMutation, BatchPreviewVariantsMutationVariables>;
export const DpExperimentAsinVariantsMapDocument = gql`
    query DpExperimentAsinVariantsMap($dpbExperimentId: ID!, $asins: [String!]!) {
  variantsMap(dpbExperimentId: $dpbExperimentId, asins: $asins) {
    asinToVariantsMap
  }
}
    `;

/**
 * __useDpExperimentAsinVariantsMapQuery__
 *
 * To run a query within a React component, call `useDpExperimentAsinVariantsMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useDpExperimentAsinVariantsMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDpExperimentAsinVariantsMapQuery({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      asins: // value for 'asins'
 *   },
 * });
 */
export function useDpExperimentAsinVariantsMapQuery(baseOptions: Apollo.QueryHookOptions<DpExperimentAsinVariantsMapQuery, DpExperimentAsinVariantsMapQueryVariables> & ({ variables: DpExperimentAsinVariantsMapQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DpExperimentAsinVariantsMapQuery, DpExperimentAsinVariantsMapQueryVariables>(DpExperimentAsinVariantsMapDocument, options);
      }
export function useDpExperimentAsinVariantsMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DpExperimentAsinVariantsMapQuery, DpExperimentAsinVariantsMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DpExperimentAsinVariantsMapQuery, DpExperimentAsinVariantsMapQueryVariables>(DpExperimentAsinVariantsMapDocument, options);
        }
// @ts-ignore
export function useDpExperimentAsinVariantsMapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DpExperimentAsinVariantsMapQuery, DpExperimentAsinVariantsMapQueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentAsinVariantsMapQuery, DpExperimentAsinVariantsMapQueryVariables>;
export function useDpExperimentAsinVariantsMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentAsinVariantsMapQuery, DpExperimentAsinVariantsMapQueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentAsinVariantsMapQuery | undefined, DpExperimentAsinVariantsMapQueryVariables>;
export function useDpExperimentAsinVariantsMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentAsinVariantsMapQuery, DpExperimentAsinVariantsMapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DpExperimentAsinVariantsMapQuery, DpExperimentAsinVariantsMapQueryVariables>(DpExperimentAsinVariantsMapDocument, options);
        }
export type DpExperimentAsinVariantsMapQueryHookResult = ReturnType<typeof useDpExperimentAsinVariantsMapQuery>;
export type DpExperimentAsinVariantsMapLazyQueryHookResult = ReturnType<typeof useDpExperimentAsinVariantsMapLazyQuery>;
export type DpExperimentAsinVariantsMapSuspenseQueryHookResult = ReturnType<typeof useDpExperimentAsinVariantsMapSuspenseQuery>;
export type DpExperimentAsinVariantsMapQueryResult = Apollo.QueryResult<DpExperimentAsinVariantsMapQuery, DpExperimentAsinVariantsMapQueryVariables>;
export const CreateOrUpdateBulletsVariantDocument = gql`
    mutation createOrUpdateBulletsVariant($dpbExperimentId: ID!, $variant: DpBulletsVariantInput!) {
  createOrUpdateBulletsVariant(
    dpbExperimentId: $dpbExperimentId
    variant: $variant
  ) {
    code
    message
    success
    variant {
      ...bulletsVariantData
    }
  }
}
    ${BulletsVariantDataFragmentDoc}`;
export type CreateOrUpdateBulletsVariantMutationFn = Apollo.MutationFunction<CreateOrUpdateBulletsVariantMutation, CreateOrUpdateBulletsVariantMutationVariables>;

/**
 * __useCreateOrUpdateBulletsVariantMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBulletsVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBulletsVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBulletsVariantMutation, { data, loading, error }] = useCreateOrUpdateBulletsVariantMutation({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useCreateOrUpdateBulletsVariantMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBulletsVariantMutation, CreateOrUpdateBulletsVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBulletsVariantMutation, CreateOrUpdateBulletsVariantMutationVariables>(CreateOrUpdateBulletsVariantDocument, options);
      }
export type CreateOrUpdateBulletsVariantMutationHookResult = ReturnType<typeof useCreateOrUpdateBulletsVariantMutation>;
export type CreateOrUpdateBulletsVariantMutationResult = Apollo.MutationResult<CreateOrUpdateBulletsVariantMutation>;
export type CreateOrUpdateBulletsVariantMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBulletsVariantMutation, CreateOrUpdateBulletsVariantMutationVariables>;
export const DeleteBulletsVariantDocument = gql`
    mutation deleteBulletsVariant($asin: String!, $dpbExperimentId: ID!, $locale: String!, $uniqueReferenceId: ID!) {
  deleteBulletsVariant(
    asin: $asin
    dpbExperimentId: $dpbExperimentId
    locale: $locale
    uniqueReferenceId: $uniqueReferenceId
  ) {
    code
    message
    success
  }
}
    `;
export type DeleteBulletsVariantMutationFn = Apollo.MutationFunction<DeleteBulletsVariantMutation, DeleteBulletsVariantMutationVariables>;

/**
 * __useDeleteBulletsVariantMutation__
 *
 * To run a mutation, you first call `useDeleteBulletsVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBulletsVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBulletsVariantMutation, { data, loading, error }] = useDeleteBulletsVariantMutation({
 *   variables: {
 *      asin: // value for 'asin'
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      locale: // value for 'locale'
 *      uniqueReferenceId: // value for 'uniqueReferenceId'
 *   },
 * });
 */
export function useDeleteBulletsVariantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBulletsVariantMutation, DeleteBulletsVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBulletsVariantMutation, DeleteBulletsVariantMutationVariables>(DeleteBulletsVariantDocument, options);
      }
export type DeleteBulletsVariantMutationHookResult = ReturnType<typeof useDeleteBulletsVariantMutation>;
export type DeleteBulletsVariantMutationResult = Apollo.MutationResult<DeleteBulletsVariantMutation>;
export type DeleteBulletsVariantMutationOptions = Apollo.BaseMutationOptions<DeleteBulletsVariantMutation, DeleteBulletsVariantMutationVariables>;
export const CreateOrUpdateLandingImageVariantDocument = gql`
    mutation createOrUpdateLandingImageVariant($dpbExperimentId: ID!, $variant: DpLandingImageVariantInput!) {
  createOrUpdateLandingImageVariant(
    dpbExperimentId: $dpbExperimentId
    variant: $variant
  ) {
    code
    message
    success
    variant {
      ...landingImageVariantData
    }
  }
}
    ${LandingImageVariantDataFragmentDoc}`;
export type CreateOrUpdateLandingImageVariantMutationFn = Apollo.MutationFunction<CreateOrUpdateLandingImageVariantMutation, CreateOrUpdateLandingImageVariantMutationVariables>;

/**
 * __useCreateOrUpdateLandingImageVariantMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateLandingImageVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateLandingImageVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateLandingImageVariantMutation, { data, loading, error }] = useCreateOrUpdateLandingImageVariantMutation({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useCreateOrUpdateLandingImageVariantMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateLandingImageVariantMutation, CreateOrUpdateLandingImageVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateLandingImageVariantMutation, CreateOrUpdateLandingImageVariantMutationVariables>(CreateOrUpdateLandingImageVariantDocument, options);
      }
export type CreateOrUpdateLandingImageVariantMutationHookResult = ReturnType<typeof useCreateOrUpdateLandingImageVariantMutation>;
export type CreateOrUpdateLandingImageVariantMutationResult = Apollo.MutationResult<CreateOrUpdateLandingImageVariantMutation>;
export type CreateOrUpdateLandingImageVariantMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateLandingImageVariantMutation, CreateOrUpdateLandingImageVariantMutationVariables>;
export const DeleteLandingImageVariantDocument = gql`
    mutation deleteLandingImageVariant($asin: String!, $dpbExperimentId: ID!, $platform: DpLandingImagePlatform!, $uniqueReferenceId: ID!) {
  deleteLandingImageVariant(
    asin: $asin
    dpbExperimentId: $dpbExperimentId
    platform: $platform
    uniqueReferenceId: $uniqueReferenceId
  ) {
    code
    message
    success
  }
}
    `;
export type DeleteLandingImageVariantMutationFn = Apollo.MutationFunction<DeleteLandingImageVariantMutation, DeleteLandingImageVariantMutationVariables>;

/**
 * __useDeleteLandingImageVariantMutation__
 *
 * To run a mutation, you first call `useDeleteLandingImageVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLandingImageVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLandingImageVariantMutation, { data, loading, error }] = useDeleteLandingImageVariantMutation({
 *   variables: {
 *      asin: // value for 'asin'
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      platform: // value for 'platform'
 *      uniqueReferenceId: // value for 'uniqueReferenceId'
 *   },
 * });
 */
export function useDeleteLandingImageVariantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLandingImageVariantMutation, DeleteLandingImageVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLandingImageVariantMutation, DeleteLandingImageVariantMutationVariables>(DeleteLandingImageVariantDocument, options);
      }
export type DeleteLandingImageVariantMutationHookResult = ReturnType<typeof useDeleteLandingImageVariantMutation>;
export type DeleteLandingImageVariantMutationResult = Apollo.MutationResult<DeleteLandingImageVariantMutation>;
export type DeleteLandingImageVariantMutationOptions = Apollo.BaseMutationOptions<DeleteLandingImageVariantMutation, DeleteLandingImageVariantMutationVariables>;
export const CreateOrUpdateTitleVariantDocument = gql`
    mutation createOrUpdateTitleVariant($dpbExperimentId: ID!, $variant: DpTitleVariantInput!) {
  createOrUpdateTitleVariant(dpbExperimentId: $dpbExperimentId, variant: $variant) {
    code
    message
    success
    variant {
      ...titleVariantData
    }
  }
}
    ${TitleVariantDataFragmentDoc}`;
export type CreateOrUpdateTitleVariantMutationFn = Apollo.MutationFunction<CreateOrUpdateTitleVariantMutation, CreateOrUpdateTitleVariantMutationVariables>;

/**
 * __useCreateOrUpdateTitleVariantMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateTitleVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateTitleVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateTitleVariantMutation, { data, loading, error }] = useCreateOrUpdateTitleVariantMutation({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useCreateOrUpdateTitleVariantMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateTitleVariantMutation, CreateOrUpdateTitleVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateTitleVariantMutation, CreateOrUpdateTitleVariantMutationVariables>(CreateOrUpdateTitleVariantDocument, options);
      }
export type CreateOrUpdateTitleVariantMutationHookResult = ReturnType<typeof useCreateOrUpdateTitleVariantMutation>;
export type CreateOrUpdateTitleVariantMutationResult = Apollo.MutationResult<CreateOrUpdateTitleVariantMutation>;
export type CreateOrUpdateTitleVariantMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateTitleVariantMutation, CreateOrUpdateTitleVariantMutationVariables>;
export const DeleteTitleVariantDocument = gql`
    mutation deleteTitleVariant($asin: String!, $dpbExperimentId: ID!, $locale: String!, $uniqueReferenceId: ID!) {
  deleteTitleVariant(
    asin: $asin
    dpbExperimentId: $dpbExperimentId
    locale: $locale
    uniqueReferenceId: $uniqueReferenceId
  ) {
    code
    message
    success
  }
}
    `;
export type DeleteTitleVariantMutationFn = Apollo.MutationFunction<DeleteTitleVariantMutation, DeleteTitleVariantMutationVariables>;

/**
 * __useDeleteTitleVariantMutation__
 *
 * To run a mutation, you first call `useDeleteTitleVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTitleVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTitleVariantMutation, { data, loading, error }] = useDeleteTitleVariantMutation({
 *   variables: {
 *      asin: // value for 'asin'
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      locale: // value for 'locale'
 *      uniqueReferenceId: // value for 'uniqueReferenceId'
 *   },
 * });
 */
export function useDeleteTitleVariantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTitleVariantMutation, DeleteTitleVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTitleVariantMutation, DeleteTitleVariantMutationVariables>(DeleteTitleVariantDocument, options);
      }
export type DeleteTitleVariantMutationHookResult = ReturnType<typeof useDeleteTitleVariantMutation>;
export type DeleteTitleVariantMutationResult = Apollo.MutationResult<DeleteTitleVariantMutation>;
export type DeleteTitleVariantMutationOptions = Apollo.BaseMutationOptions<DeleteTitleVariantMutation, DeleteTitleVariantMutationVariables>;
export const DpExperimentAsinVariantsDocument = gql`
    query DpExperimentAsinVariants($dpbExperimentId: ID!, $asin: String!) {
  variants(dpbExperimentId: $dpbExperimentId, asin: $asin) {
    titles {
      ...titleVariantData
    }
    bullets {
      ...bulletsVariantData
    }
    landingImages {
      ...landingImageVariantData
    }
  }
}
    ${TitleVariantDataFragmentDoc}
${BulletsVariantDataFragmentDoc}
${LandingImageVariantDataFragmentDoc}`;

/**
 * __useDpExperimentAsinVariantsQuery__
 *
 * To run a query within a React component, call `useDpExperimentAsinVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDpExperimentAsinVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDpExperimentAsinVariantsQuery({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      asin: // value for 'asin'
 *   },
 * });
 */
export function useDpExperimentAsinVariantsQuery(baseOptions: Apollo.QueryHookOptions<DpExperimentAsinVariantsQuery, DpExperimentAsinVariantsQueryVariables> & ({ variables: DpExperimentAsinVariantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DpExperimentAsinVariantsQuery, DpExperimentAsinVariantsQueryVariables>(DpExperimentAsinVariantsDocument, options);
      }
export function useDpExperimentAsinVariantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DpExperimentAsinVariantsQuery, DpExperimentAsinVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DpExperimentAsinVariantsQuery, DpExperimentAsinVariantsQueryVariables>(DpExperimentAsinVariantsDocument, options);
        }
// @ts-ignore
export function useDpExperimentAsinVariantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DpExperimentAsinVariantsQuery, DpExperimentAsinVariantsQueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentAsinVariantsQuery, DpExperimentAsinVariantsQueryVariables>;
export function useDpExperimentAsinVariantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentAsinVariantsQuery, DpExperimentAsinVariantsQueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentAsinVariantsQuery | undefined, DpExperimentAsinVariantsQueryVariables>;
export function useDpExperimentAsinVariantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentAsinVariantsQuery, DpExperimentAsinVariantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DpExperimentAsinVariantsQuery, DpExperimentAsinVariantsQueryVariables>(DpExperimentAsinVariantsDocument, options);
        }
export type DpExperimentAsinVariantsQueryHookResult = ReturnType<typeof useDpExperimentAsinVariantsQuery>;
export type DpExperimentAsinVariantsLazyQueryHookResult = ReturnType<typeof useDpExperimentAsinVariantsLazyQuery>;
export type DpExperimentAsinVariantsSuspenseQueryHookResult = ReturnType<typeof useDpExperimentAsinVariantsSuspenseQuery>;
export type DpExperimentAsinVariantsQueryResult = Apollo.QueryResult<DpExperimentAsinVariantsQuery, DpExperimentAsinVariantsQueryVariables>;
export const AsinToCatalogImageUrlsMapDocument = gql`
    query AsinToCatalogImageUrlsMap($asin: String!, $marketplace: String!) {
  asinToCatalogImageUrlsMap(asin: $asin, marketplace: $marketplace) {
    asinToCatalogImageUrlsMap
  }
}
    `;

/**
 * __useAsinToCatalogImageUrlsMapQuery__
 *
 * To run a query within a React component, call `useAsinToCatalogImageUrlsMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsinToCatalogImageUrlsMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsinToCatalogImageUrlsMapQuery({
 *   variables: {
 *      asin: // value for 'asin'
 *      marketplace: // value for 'marketplace'
 *   },
 * });
 */
export function useAsinToCatalogImageUrlsMapQuery(baseOptions: Apollo.QueryHookOptions<AsinToCatalogImageUrlsMapQuery, AsinToCatalogImageUrlsMapQueryVariables> & ({ variables: AsinToCatalogImageUrlsMapQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsinToCatalogImageUrlsMapQuery, AsinToCatalogImageUrlsMapQueryVariables>(AsinToCatalogImageUrlsMapDocument, options);
      }
export function useAsinToCatalogImageUrlsMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsinToCatalogImageUrlsMapQuery, AsinToCatalogImageUrlsMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsinToCatalogImageUrlsMapQuery, AsinToCatalogImageUrlsMapQueryVariables>(AsinToCatalogImageUrlsMapDocument, options);
        }
// @ts-ignore
export function useAsinToCatalogImageUrlsMapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AsinToCatalogImageUrlsMapQuery, AsinToCatalogImageUrlsMapQueryVariables>): Apollo.UseSuspenseQueryResult<AsinToCatalogImageUrlsMapQuery, AsinToCatalogImageUrlsMapQueryVariables>;
export function useAsinToCatalogImageUrlsMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AsinToCatalogImageUrlsMapQuery, AsinToCatalogImageUrlsMapQueryVariables>): Apollo.UseSuspenseQueryResult<AsinToCatalogImageUrlsMapQuery | undefined, AsinToCatalogImageUrlsMapQueryVariables>;
export function useAsinToCatalogImageUrlsMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AsinToCatalogImageUrlsMapQuery, AsinToCatalogImageUrlsMapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AsinToCatalogImageUrlsMapQuery, AsinToCatalogImageUrlsMapQueryVariables>(AsinToCatalogImageUrlsMapDocument, options);
        }
export type AsinToCatalogImageUrlsMapQueryHookResult = ReturnType<typeof useAsinToCatalogImageUrlsMapQuery>;
export type AsinToCatalogImageUrlsMapLazyQueryHookResult = ReturnType<typeof useAsinToCatalogImageUrlsMapLazyQuery>;
export type AsinToCatalogImageUrlsMapSuspenseQueryHookResult = ReturnType<typeof useAsinToCatalogImageUrlsMapSuspenseQuery>;
export type AsinToCatalogImageUrlsMapQueryResult = Apollo.QueryResult<AsinToCatalogImageUrlsMapQuery, AsinToCatalogImageUrlsMapQueryVariables>;
export const ExperimentAsinMetadataDocument = gql`
    query ExperimentAsinMetadata($dpbExperimentId: ID!, $experimentType: String!) {
  experimentAsinMetadata(
    dpbExperimentId: $dpbExperimentId
    experimentType: $experimentType
  ) {
    isDevicesExperiment
  }
}
    `;

/**
 * __useExperimentAsinMetadataQuery__
 *
 * To run a query within a React component, call `useExperimentAsinMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentAsinMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentAsinMetadataQuery({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      experimentType: // value for 'experimentType'
 *   },
 * });
 */
export function useExperimentAsinMetadataQuery(baseOptions: Apollo.QueryHookOptions<ExperimentAsinMetadataQuery, ExperimentAsinMetadataQueryVariables> & ({ variables: ExperimentAsinMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperimentAsinMetadataQuery, ExperimentAsinMetadataQueryVariables>(ExperimentAsinMetadataDocument, options);
      }
export function useExperimentAsinMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperimentAsinMetadataQuery, ExperimentAsinMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperimentAsinMetadataQuery, ExperimentAsinMetadataQueryVariables>(ExperimentAsinMetadataDocument, options);
        }
// @ts-ignore
export function useExperimentAsinMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExperimentAsinMetadataQuery, ExperimentAsinMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<ExperimentAsinMetadataQuery, ExperimentAsinMetadataQueryVariables>;
export function useExperimentAsinMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperimentAsinMetadataQuery, ExperimentAsinMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<ExperimentAsinMetadataQuery | undefined, ExperimentAsinMetadataQueryVariables>;
export function useExperimentAsinMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperimentAsinMetadataQuery, ExperimentAsinMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExperimentAsinMetadataQuery, ExperimentAsinMetadataQueryVariables>(ExperimentAsinMetadataDocument, options);
        }
export type ExperimentAsinMetadataQueryHookResult = ReturnType<typeof useExperimentAsinMetadataQuery>;
export type ExperimentAsinMetadataLazyQueryHookResult = ReturnType<typeof useExperimentAsinMetadataLazyQuery>;
export type ExperimentAsinMetadataSuspenseQueryHookResult = ReturnType<typeof useExperimentAsinMetadataSuspenseQuery>;
export type ExperimentAsinMetadataQueryResult = Apollo.QueryResult<ExperimentAsinMetadataQuery, ExperimentAsinMetadataQueryVariables>;
export const DpExperimentAsinsDocument = gql`
    query DpExperimentAsins($dpbExperimentId: ID!, $experimentType: String!) {
  dpExperiment(dpbExperimentId: $dpbExperimentId, experimentType: $experimentType) {
    primaryAsin
    variationalAsins
  }
}
    `;

/**
 * __useDpExperimentAsinsQuery__
 *
 * To run a query within a React component, call `useDpExperimentAsinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDpExperimentAsinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDpExperimentAsinsQuery({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      experimentType: // value for 'experimentType'
 *   },
 * });
 */
export function useDpExperimentAsinsQuery(baseOptions: Apollo.QueryHookOptions<DpExperimentAsinsQuery, DpExperimentAsinsQueryVariables> & ({ variables: DpExperimentAsinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DpExperimentAsinsQuery, DpExperimentAsinsQueryVariables>(DpExperimentAsinsDocument, options);
      }
export function useDpExperimentAsinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DpExperimentAsinsQuery, DpExperimentAsinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DpExperimentAsinsQuery, DpExperimentAsinsQueryVariables>(DpExperimentAsinsDocument, options);
        }
// @ts-ignore
export function useDpExperimentAsinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DpExperimentAsinsQuery, DpExperimentAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentAsinsQuery, DpExperimentAsinsQueryVariables>;
export function useDpExperimentAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentAsinsQuery, DpExperimentAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentAsinsQuery | undefined, DpExperimentAsinsQueryVariables>;
export function useDpExperimentAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentAsinsQuery, DpExperimentAsinsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DpExperimentAsinsQuery, DpExperimentAsinsQueryVariables>(DpExperimentAsinsDocument, options);
        }
export type DpExperimentAsinsQueryHookResult = ReturnType<typeof useDpExperimentAsinsQuery>;
export type DpExperimentAsinsLazyQueryHookResult = ReturnType<typeof useDpExperimentAsinsLazyQuery>;
export type DpExperimentAsinsSuspenseQueryHookResult = ReturnType<typeof useDpExperimentAsinsSuspenseQuery>;
export type DpExperimentAsinsQueryResult = Apollo.QueryResult<DpExperimentAsinsQuery, DpExperimentAsinsQueryVariables>;
export const MvesCatalogFeatureBulletsForAsinsDocument = gql`
    query MvesCatalogFeatureBulletsForAsins($asinList: [String!]!, $marketplace: String!, $locale: String!) {
  mvesCatalogFeatureBulletsForAsins(
    asinList: $asinList
    marketplace: $marketplace
    locale: $locale
  ) {
    asin
    featureBullets
  }
}
    `;

/**
 * __useMvesCatalogFeatureBulletsForAsinsQuery__
 *
 * To run a query within a React component, call `useMvesCatalogFeatureBulletsForAsinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvesCatalogFeatureBulletsForAsinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvesCatalogFeatureBulletsForAsinsQuery({
 *   variables: {
 *      asinList: // value for 'asinList'
 *      marketplace: // value for 'marketplace'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useMvesCatalogFeatureBulletsForAsinsQuery(baseOptions: Apollo.QueryHookOptions<MvesCatalogFeatureBulletsForAsinsQuery, MvesCatalogFeatureBulletsForAsinsQueryVariables> & ({ variables: MvesCatalogFeatureBulletsForAsinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvesCatalogFeatureBulletsForAsinsQuery, MvesCatalogFeatureBulletsForAsinsQueryVariables>(MvesCatalogFeatureBulletsForAsinsDocument, options);
      }
export function useMvesCatalogFeatureBulletsForAsinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvesCatalogFeatureBulletsForAsinsQuery, MvesCatalogFeatureBulletsForAsinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvesCatalogFeatureBulletsForAsinsQuery, MvesCatalogFeatureBulletsForAsinsQueryVariables>(MvesCatalogFeatureBulletsForAsinsDocument, options);
        }
// @ts-ignore
export function useMvesCatalogFeatureBulletsForAsinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvesCatalogFeatureBulletsForAsinsQuery, MvesCatalogFeatureBulletsForAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<MvesCatalogFeatureBulletsForAsinsQuery, MvesCatalogFeatureBulletsForAsinsQueryVariables>;
export function useMvesCatalogFeatureBulletsForAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MvesCatalogFeatureBulletsForAsinsQuery, MvesCatalogFeatureBulletsForAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<MvesCatalogFeatureBulletsForAsinsQuery | undefined, MvesCatalogFeatureBulletsForAsinsQueryVariables>;
export function useMvesCatalogFeatureBulletsForAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MvesCatalogFeatureBulletsForAsinsQuery, MvesCatalogFeatureBulletsForAsinsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvesCatalogFeatureBulletsForAsinsQuery, MvesCatalogFeatureBulletsForAsinsQueryVariables>(MvesCatalogFeatureBulletsForAsinsDocument, options);
        }
export type MvesCatalogFeatureBulletsForAsinsQueryHookResult = ReturnType<typeof useMvesCatalogFeatureBulletsForAsinsQuery>;
export type MvesCatalogFeatureBulletsForAsinsLazyQueryHookResult = ReturnType<typeof useMvesCatalogFeatureBulletsForAsinsLazyQuery>;
export type MvesCatalogFeatureBulletsForAsinsSuspenseQueryHookResult = ReturnType<typeof useMvesCatalogFeatureBulletsForAsinsSuspenseQuery>;
export type MvesCatalogFeatureBulletsForAsinsQueryResult = Apollo.QueryResult<MvesCatalogFeatureBulletsForAsinsQuery, MvesCatalogFeatureBulletsForAsinsQueryVariables>;
export const MvesCatalogImageVariantForAsinsDocument = gql`
    query MvesCatalogImageVariantForAsins($asinList: [String!]!, $marketplace: String!) {
  mvesVariantImagesForAsins(asinList: $asinList, marketplace: $marketplace) {
    asin
    images
  }
}
    `;

/**
 * __useMvesCatalogImageVariantForAsinsQuery__
 *
 * To run a query within a React component, call `useMvesCatalogImageVariantForAsinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvesCatalogImageVariantForAsinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvesCatalogImageVariantForAsinsQuery({
 *   variables: {
 *      asinList: // value for 'asinList'
 *      marketplace: // value for 'marketplace'
 *   },
 * });
 */
export function useMvesCatalogImageVariantForAsinsQuery(baseOptions: Apollo.QueryHookOptions<MvesCatalogImageVariantForAsinsQuery, MvesCatalogImageVariantForAsinsQueryVariables> & ({ variables: MvesCatalogImageVariantForAsinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvesCatalogImageVariantForAsinsQuery, MvesCatalogImageVariantForAsinsQueryVariables>(MvesCatalogImageVariantForAsinsDocument, options);
      }
export function useMvesCatalogImageVariantForAsinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvesCatalogImageVariantForAsinsQuery, MvesCatalogImageVariantForAsinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvesCatalogImageVariantForAsinsQuery, MvesCatalogImageVariantForAsinsQueryVariables>(MvesCatalogImageVariantForAsinsDocument, options);
        }
// @ts-ignore
export function useMvesCatalogImageVariantForAsinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvesCatalogImageVariantForAsinsQuery, MvesCatalogImageVariantForAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<MvesCatalogImageVariantForAsinsQuery, MvesCatalogImageVariantForAsinsQueryVariables>;
export function useMvesCatalogImageVariantForAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MvesCatalogImageVariantForAsinsQuery, MvesCatalogImageVariantForAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<MvesCatalogImageVariantForAsinsQuery | undefined, MvesCatalogImageVariantForAsinsQueryVariables>;
export function useMvesCatalogImageVariantForAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MvesCatalogImageVariantForAsinsQuery, MvesCatalogImageVariantForAsinsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvesCatalogImageVariantForAsinsQuery, MvesCatalogImageVariantForAsinsQueryVariables>(MvesCatalogImageVariantForAsinsDocument, options);
        }
export type MvesCatalogImageVariantForAsinsQueryHookResult = ReturnType<typeof useMvesCatalogImageVariantForAsinsQuery>;
export type MvesCatalogImageVariantForAsinsLazyQueryHookResult = ReturnType<typeof useMvesCatalogImageVariantForAsinsLazyQuery>;
export type MvesCatalogImageVariantForAsinsSuspenseQueryHookResult = ReturnType<typeof useMvesCatalogImageVariantForAsinsSuspenseQuery>;
export type MvesCatalogImageVariantForAsinsQueryResult = Apollo.QueryResult<MvesCatalogImageVariantForAsinsQuery, MvesCatalogImageVariantForAsinsQueryVariables>;
export const MvesCatalogTitlesDocument = gql`
    query MvesCatalogTitles($asinList: [String!]!, $marketplace: String!, $locale: String!) {
  mvesCatalogTitles(
    asinList: $asinList
    marketplace: $marketplace
    locale: $locale
  ) {
    asin
    title
    marketplace
    locale
  }
}
    `;

/**
 * __useMvesCatalogTitlesQuery__
 *
 * To run a query within a React component, call `useMvesCatalogTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvesCatalogTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvesCatalogTitlesQuery({
 *   variables: {
 *      asinList: // value for 'asinList'
 *      marketplace: // value for 'marketplace'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useMvesCatalogTitlesQuery(baseOptions: Apollo.QueryHookOptions<MvesCatalogTitlesQuery, MvesCatalogTitlesQueryVariables> & ({ variables: MvesCatalogTitlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvesCatalogTitlesQuery, MvesCatalogTitlesQueryVariables>(MvesCatalogTitlesDocument, options);
      }
export function useMvesCatalogTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvesCatalogTitlesQuery, MvesCatalogTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvesCatalogTitlesQuery, MvesCatalogTitlesQueryVariables>(MvesCatalogTitlesDocument, options);
        }
// @ts-ignore
export function useMvesCatalogTitlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvesCatalogTitlesQuery, MvesCatalogTitlesQueryVariables>): Apollo.UseSuspenseQueryResult<MvesCatalogTitlesQuery, MvesCatalogTitlesQueryVariables>;
export function useMvesCatalogTitlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MvesCatalogTitlesQuery, MvesCatalogTitlesQueryVariables>): Apollo.UseSuspenseQueryResult<MvesCatalogTitlesQuery | undefined, MvesCatalogTitlesQueryVariables>;
export function useMvesCatalogTitlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MvesCatalogTitlesQuery, MvesCatalogTitlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvesCatalogTitlesQuery, MvesCatalogTitlesQueryVariables>(MvesCatalogTitlesDocument, options);
        }
export type MvesCatalogTitlesQueryHookResult = ReturnType<typeof useMvesCatalogTitlesQuery>;
export type MvesCatalogTitlesLazyQueryHookResult = ReturnType<typeof useMvesCatalogTitlesLazyQuery>;
export type MvesCatalogTitlesSuspenseQueryHookResult = ReturnType<typeof useMvesCatalogTitlesSuspenseQuery>;
export type MvesCatalogTitlesQueryResult = Apollo.QueryResult<MvesCatalogTitlesQuery, MvesCatalogTitlesQueryVariables>;
export const AsinsDocument = gql`
    query Asins($first: Int!, $filters: AsinFilterInput, $after: String) {
  asins(first: $first, filters: $filters, after: $after) {
    nodes {
      asin
      party
      type
      description
      marketplace {
        id
        obfuscatedMarketplaceId
        country
      }
      program {
        id
        name
      }
      productLine {
        id
        name
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useAsinsQuery__
 *
 * To run a query within a React component, call `useAsinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsinsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAsinsQuery(baseOptions: Apollo.QueryHookOptions<AsinsQuery, AsinsQueryVariables> & ({ variables: AsinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsinsQuery, AsinsQueryVariables>(AsinsDocument, options);
      }
export function useAsinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsinsQuery, AsinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsinsQuery, AsinsQueryVariables>(AsinsDocument, options);
        }
// @ts-ignore
export function useAsinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AsinsQuery, AsinsQueryVariables>): Apollo.UseSuspenseQueryResult<AsinsQuery, AsinsQueryVariables>;
export function useAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AsinsQuery, AsinsQueryVariables>): Apollo.UseSuspenseQueryResult<AsinsQuery | undefined, AsinsQueryVariables>;
export function useAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AsinsQuery, AsinsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AsinsQuery, AsinsQueryVariables>(AsinsDocument, options);
        }
export type AsinsQueryHookResult = ReturnType<typeof useAsinsQuery>;
export type AsinsLazyQueryHookResult = ReturnType<typeof useAsinsLazyQuery>;
export type AsinsSuspenseQueryHookResult = ReturnType<typeof useAsinsSuspenseQuery>;
export type AsinsQueryResult = Apollo.QueryResult<AsinsQuery, AsinsQueryVariables>;
export const ProductLinesDocument = gql`
    query ProductLines($first: Int!, $filters: ProductLineFilterInput, $after: String) {
  productLines(first: $first, filters: $filters, after: $after) {
    nodes {
      id
      name
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useProductLinesQuery__
 *
 * To run a query within a React component, call `useProductLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductLinesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useProductLinesQuery(baseOptions: Apollo.QueryHookOptions<ProductLinesQuery, ProductLinesQueryVariables> & ({ variables: ProductLinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductLinesQuery, ProductLinesQueryVariables>(ProductLinesDocument, options);
      }
export function useProductLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductLinesQuery, ProductLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductLinesQuery, ProductLinesQueryVariables>(ProductLinesDocument, options);
        }
// @ts-ignore
export function useProductLinesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductLinesQuery, ProductLinesQueryVariables>): Apollo.UseSuspenseQueryResult<ProductLinesQuery, ProductLinesQueryVariables>;
export function useProductLinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductLinesQuery, ProductLinesQueryVariables>): Apollo.UseSuspenseQueryResult<ProductLinesQuery | undefined, ProductLinesQueryVariables>;
export function useProductLinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductLinesQuery, ProductLinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductLinesQuery, ProductLinesQueryVariables>(ProductLinesDocument, options);
        }
export type ProductLinesQueryHookResult = ReturnType<typeof useProductLinesQuery>;
export type ProductLinesLazyQueryHookResult = ReturnType<typeof useProductLinesLazyQuery>;
export type ProductLinesSuspenseQueryHookResult = ReturnType<typeof useProductLinesSuspenseQuery>;
export type ProductLinesQueryResult = Apollo.QueryResult<ProductLinesQuery, ProductLinesQueryVariables>;
export const ProgramsDocument = gql`
    query Programs($first: Int!, $filters: ProgramFilterInput, $after: String) {
  programs(first: $first, filters: $filters, after: $after) {
    nodes {
      id
      name
      programId
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useProgramsQuery__
 *
 * To run a query within a React component, call `useProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useProgramsQuery(baseOptions: Apollo.QueryHookOptions<ProgramsQuery, ProgramsQueryVariables> & ({ variables: ProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
      }
export function useProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
        }
// @ts-ignore
export function useProgramsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProgramsQuery, ProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<ProgramsQuery, ProgramsQueryVariables>;
export function useProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramsQuery, ProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<ProgramsQuery | undefined, ProgramsQueryVariables>;
export function useProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
        }
export type ProgramsQueryHookResult = ReturnType<typeof useProgramsQuery>;
export type ProgramsLazyQueryHookResult = ReturnType<typeof useProgramsLazyQuery>;
export type ProgramsSuspenseQueryHookResult = ReturnType<typeof useProgramsSuspenseQuery>;
export type ProgramsQueryResult = Apollo.QueryResult<ProgramsQuery, ProgramsQueryVariables>;
export const VariationalAsinHierarchyDocument = gql`
    query VariationalAsinHierarchy($asins: [String!]!, $marketplace: String!, $getTitles: Boolean!) {
  variationalAsinHierarchy(
    asins: $asins
    marketplace: $marketplace
    getTitles: $getTitles
  ) {
    asin
    title
    childAsins {
      asin
      title
      childAsins {
        asin
        title
      }
    }
  }
}
    `;

/**
 * __useVariationalAsinHierarchyQuery__
 *
 * To run a query within a React component, call `useVariationalAsinHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useVariationalAsinHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVariationalAsinHierarchyQuery({
 *   variables: {
 *      asins: // value for 'asins'
 *      marketplace: // value for 'marketplace'
 *      getTitles: // value for 'getTitles'
 *   },
 * });
 */
export function useVariationalAsinHierarchyQuery(baseOptions: Apollo.QueryHookOptions<VariationalAsinHierarchyQuery, VariationalAsinHierarchyQueryVariables> & ({ variables: VariationalAsinHierarchyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VariationalAsinHierarchyQuery, VariationalAsinHierarchyQueryVariables>(VariationalAsinHierarchyDocument, options);
      }
export function useVariationalAsinHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VariationalAsinHierarchyQuery, VariationalAsinHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VariationalAsinHierarchyQuery, VariationalAsinHierarchyQueryVariables>(VariationalAsinHierarchyDocument, options);
        }
// @ts-ignore
export function useVariationalAsinHierarchySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VariationalAsinHierarchyQuery, VariationalAsinHierarchyQueryVariables>): Apollo.UseSuspenseQueryResult<VariationalAsinHierarchyQuery, VariationalAsinHierarchyQueryVariables>;
export function useVariationalAsinHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VariationalAsinHierarchyQuery, VariationalAsinHierarchyQueryVariables>): Apollo.UseSuspenseQueryResult<VariationalAsinHierarchyQuery | undefined, VariationalAsinHierarchyQueryVariables>;
export function useVariationalAsinHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VariationalAsinHierarchyQuery, VariationalAsinHierarchyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VariationalAsinHierarchyQuery, VariationalAsinHierarchyQueryVariables>(VariationalAsinHierarchyDocument, options);
        }
export type VariationalAsinHierarchyQueryHookResult = ReturnType<typeof useVariationalAsinHierarchyQuery>;
export type VariationalAsinHierarchyLazyQueryHookResult = ReturnType<typeof useVariationalAsinHierarchyLazyQuery>;
export type VariationalAsinHierarchySuspenseQueryHookResult = ReturnType<typeof useVariationalAsinHierarchySuspenseQuery>;
export type VariationalAsinHierarchyQueryResult = Apollo.QueryResult<VariationalAsinHierarchyQuery, VariationalAsinHierarchyQueryVariables>;
export const CreateExperimentDocument = gql`
    mutation CreateExperiment($input: DpExperimentDetailsCreateInput!) {
  createExperiment(input: $input) {
    code
    message
    success
    experiment {
      dpbExperimentId
      experimentType
      name
    }
  }
}
    `;
export type CreateExperimentMutationFn = Apollo.MutationFunction<CreateExperimentMutation, CreateExperimentMutationVariables>;

/**
 * __useCreateExperimentMutation__
 *
 * To run a mutation, you first call `useCreateExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExperimentMutation, { data, loading, error }] = useCreateExperimentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExperimentMutation(baseOptions?: Apollo.MutationHookOptions<CreateExperimentMutation, CreateExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExperimentMutation, CreateExperimentMutationVariables>(CreateExperimentDocument, options);
      }
export type CreateExperimentMutationHookResult = ReturnType<typeof useCreateExperimentMutation>;
export type CreateExperimentMutationResult = Apollo.MutationResult<CreateExperimentMutation>;
export type CreateExperimentMutationOptions = Apollo.BaseMutationOptions<CreateExperimentMutation, CreateExperimentMutationVariables>;
export const CreateExperimentV2Document = gql`
    mutation CreateExperimentV2($input: DpExperimentDetailsCreateInputV2!) {
  createExperimentV2(input: $input) {
    experiment {
      id
      experimentType
    }
    experimentExists
  }
}
    `;
export type CreateExperimentV2MutationFn = Apollo.MutationFunction<CreateExperimentV2Mutation, CreateExperimentV2MutationVariables>;

/**
 * __useCreateExperimentV2Mutation__
 *
 * To run a mutation, you first call `useCreateExperimentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExperimentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExperimentV2Mutation, { data, loading, error }] = useCreateExperimentV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExperimentV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateExperimentV2Mutation, CreateExperimentV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExperimentV2Mutation, CreateExperimentV2MutationVariables>(CreateExperimentV2Document, options);
      }
export type CreateExperimentV2MutationHookResult = ReturnType<typeof useCreateExperimentV2Mutation>;
export type CreateExperimentV2MutationResult = Apollo.MutationResult<CreateExperimentV2Mutation>;
export type CreateExperimentV2MutationOptions = Apollo.BaseMutationOptions<CreateExperimentV2Mutation, CreateExperimentV2MutationVariables>;
export const CumulativeGainMetricsDocument = gql`
    query CumulativeGainMetrics($dpbExperimentId: ID!, $experimentType: String!, $startDate: String!, $endDate: String!) {
  dpExperiment(dpbExperimentId: $dpbExperimentId, experimentType: $experimentType) {
    cumulativeGainMetrics(startDate: $startDate, endDate: $endDate) {
      context
      combination
      date
      experimentId
      impressionCount
      lowerBoundPCG
      meanPCG
      pvaluePCG
      successCount
      treatment
      upperBoundPCG
      totalSuccessCount
      totalImpressionCount
      rank
    }
  }
}
    `;

/**
 * __useCumulativeGainMetricsQuery__
 *
 * To run a query within a React component, call `useCumulativeGainMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCumulativeGainMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCumulativeGainMetricsQuery({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      experimentType: // value for 'experimentType'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCumulativeGainMetricsQuery(baseOptions: Apollo.QueryHookOptions<CumulativeGainMetricsQuery, CumulativeGainMetricsQueryVariables> & ({ variables: CumulativeGainMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CumulativeGainMetricsQuery, CumulativeGainMetricsQueryVariables>(CumulativeGainMetricsDocument, options);
      }
export function useCumulativeGainMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CumulativeGainMetricsQuery, CumulativeGainMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CumulativeGainMetricsQuery, CumulativeGainMetricsQueryVariables>(CumulativeGainMetricsDocument, options);
        }
// @ts-ignore
export function useCumulativeGainMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CumulativeGainMetricsQuery, CumulativeGainMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<CumulativeGainMetricsQuery, CumulativeGainMetricsQueryVariables>;
export function useCumulativeGainMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CumulativeGainMetricsQuery, CumulativeGainMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<CumulativeGainMetricsQuery | undefined, CumulativeGainMetricsQueryVariables>;
export function useCumulativeGainMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CumulativeGainMetricsQuery, CumulativeGainMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CumulativeGainMetricsQuery, CumulativeGainMetricsQueryVariables>(CumulativeGainMetricsDocument, options);
        }
export type CumulativeGainMetricsQueryHookResult = ReturnType<typeof useCumulativeGainMetricsQuery>;
export type CumulativeGainMetricsLazyQueryHookResult = ReturnType<typeof useCumulativeGainMetricsLazyQuery>;
export type CumulativeGainMetricsSuspenseQueryHookResult = ReturnType<typeof useCumulativeGainMetricsSuspenseQuery>;
export type CumulativeGainMetricsQueryResult = Apollo.QueryResult<CumulativeGainMetricsQuery, CumulativeGainMetricsQueryVariables>;
export const DeactivateExperimentV2Document = gql`
    mutation DeactivateExperimentV2($input: DpExperimentDetailsDeactivateInputV2!) {
  deactivateExperimentV2(input: $input) {
    experiment {
      id
      program {
        id
        programId
        name
      }
      experimentType
      updatedAt
      updatedBy
      createdAt
      createdBy
      status
      version
      productLine {
        id
        productLineId
        name
      }
      marketplaceExperimentConfig {
        id
        marketplace {
          id
          obfuscatedMarketplaceId
          country
        }
        locales
        activationDate
        deactivationDate
        primaryAsin
        asinConfigs {
          asin
          asinConfigId
          featureVariants {
            titles {
              variantId
              variantPosition
              variantName
              uniqueReferenceId
              updatedBy
              updatedAt
              lastPublishedVersion
              lastPublishedDate
              previewed
              locale
              titleString
            }
            bullets {
              variantId
              variantPosition
              variantName
              uniqueReferenceId
              updatedBy
              updatedAt
              lastPublishedVersion
              lastPublishedDate
              previewed
              locale
              bulletStrings
            }
            landingImages {
              variantId
              variantPosition
              variantName
              uniqueReferenceId
              updatedBy
              updatedAt
              lastPublishedVersion
              lastPublishedDate
              previewed
              assetId
              url
              platform
              mcVariant
              locale
              shipmentId
            }
          }
        }
        bullseyeSegments {
          bullseyeSegmentId
          position
          titleExclusions
          bulletExclusions
          landingImageExclusions
        }
        contextualCohortType
        status
      }
    }
  }
}
    `;
export type DeactivateExperimentV2MutationFn = Apollo.MutationFunction<DeactivateExperimentV2Mutation, DeactivateExperimentV2MutationVariables>;

/**
 * __useDeactivateExperimentV2Mutation__
 *
 * To run a mutation, you first call `useDeactivateExperimentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateExperimentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateExperimentV2Mutation, { data, loading, error }] = useDeactivateExperimentV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateExperimentV2Mutation(baseOptions?: Apollo.MutationHookOptions<DeactivateExperimentV2Mutation, DeactivateExperimentV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateExperimentV2Mutation, DeactivateExperimentV2MutationVariables>(DeactivateExperimentV2Document, options);
      }
export type DeactivateExperimentV2MutationHookResult = ReturnType<typeof useDeactivateExperimentV2Mutation>;
export type DeactivateExperimentV2MutationResult = Apollo.MutationResult<DeactivateExperimentV2Mutation>;
export type DeactivateExperimentV2MutationOptions = Apollo.BaseMutationOptions<DeactivateExperimentV2Mutation, DeactivateExperimentV2MutationVariables>;
export const DeleteFeatureVariantV2Document = gql`
    mutation deleteFeatureVariantV2($experimentId: ID!, $marketplaceId: ID!, $variants: [DpVariantDeleteInputV2!]!) {
  deleteVariantsV2(
    experimentId: $experimentId
    marketplaceId: $marketplaceId
    variants: $variants
  ) {
    asinConfigs {
      asin
      asinConfigId
      featureVariants {
        titles {
          variantId
          variantPosition
          uniqueReferenceId
          locale
          titleString
        }
      }
    }
  }
}
    `;
export type DeleteFeatureVariantV2MutationFn = Apollo.MutationFunction<DeleteFeatureVariantV2Mutation, DeleteFeatureVariantV2MutationVariables>;

/**
 * __useDeleteFeatureVariantV2Mutation__
 *
 * To run a mutation, you first call `useDeleteFeatureVariantV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeatureVariantV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeatureVariantV2Mutation, { data, loading, error }] = useDeleteFeatureVariantV2Mutation({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *      marketplaceId: // value for 'marketplaceId'
 *      variants: // value for 'variants'
 *   },
 * });
 */
export function useDeleteFeatureVariantV2Mutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeatureVariantV2Mutation, DeleteFeatureVariantV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeatureVariantV2Mutation, DeleteFeatureVariantV2MutationVariables>(DeleteFeatureVariantV2Document, options);
      }
export type DeleteFeatureVariantV2MutationHookResult = ReturnType<typeof useDeleteFeatureVariantV2Mutation>;
export type DeleteFeatureVariantV2MutationResult = Apollo.MutationResult<DeleteFeatureVariantV2Mutation>;
export type DeleteFeatureVariantV2MutationOptions = Apollo.BaseMutationOptions<DeleteFeatureVariantV2Mutation, DeleteFeatureVariantV2MutationVariables>;
export const DpExperimentGenerateExperimentContentDocument = gql`
    query DpExperimentGenerateExperimentContent($marketplace: String!, $locale: String!, $asin: String!, $variantType: String!, $context: DpExperimentGeneratedExperimentContentContextInput!) {
  generateExperimentContent(
    marketplace: $marketplace
    locale: $locale
    asin: $asin
    variantType: $variantType
    context: $context
  ) {
    generatedContent
    errorMessage
  }
}
    `;

/**
 * __useDpExperimentGenerateExperimentContentQuery__
 *
 * To run a query within a React component, call `useDpExperimentGenerateExperimentContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDpExperimentGenerateExperimentContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDpExperimentGenerateExperimentContentQuery({
 *   variables: {
 *      marketplace: // value for 'marketplace'
 *      locale: // value for 'locale'
 *      asin: // value for 'asin'
 *      variantType: // value for 'variantType'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useDpExperimentGenerateExperimentContentQuery(baseOptions: Apollo.QueryHookOptions<DpExperimentGenerateExperimentContentQuery, DpExperimentGenerateExperimentContentQueryVariables> & ({ variables: DpExperimentGenerateExperimentContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DpExperimentGenerateExperimentContentQuery, DpExperimentGenerateExperimentContentQueryVariables>(DpExperimentGenerateExperimentContentDocument, options);
      }
export function useDpExperimentGenerateExperimentContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DpExperimentGenerateExperimentContentQuery, DpExperimentGenerateExperimentContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DpExperimentGenerateExperimentContentQuery, DpExperimentGenerateExperimentContentQueryVariables>(DpExperimentGenerateExperimentContentDocument, options);
        }
// @ts-ignore
export function useDpExperimentGenerateExperimentContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DpExperimentGenerateExperimentContentQuery, DpExperimentGenerateExperimentContentQueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentGenerateExperimentContentQuery, DpExperimentGenerateExperimentContentQueryVariables>;
export function useDpExperimentGenerateExperimentContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentGenerateExperimentContentQuery, DpExperimentGenerateExperimentContentQueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentGenerateExperimentContentQuery | undefined, DpExperimentGenerateExperimentContentQueryVariables>;
export function useDpExperimentGenerateExperimentContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentGenerateExperimentContentQuery, DpExperimentGenerateExperimentContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DpExperimentGenerateExperimentContentQuery, DpExperimentGenerateExperimentContentQueryVariables>(DpExperimentGenerateExperimentContentDocument, options);
        }
export type DpExperimentGenerateExperimentContentQueryHookResult = ReturnType<typeof useDpExperimentGenerateExperimentContentQuery>;
export type DpExperimentGenerateExperimentContentLazyQueryHookResult = ReturnType<typeof useDpExperimentGenerateExperimentContentLazyQuery>;
export type DpExperimentGenerateExperimentContentSuspenseQueryHookResult = ReturnType<typeof useDpExperimentGenerateExperimentContentSuspenseQuery>;
export type DpExperimentGenerateExperimentContentQueryResult = Apollo.QueryResult<DpExperimentGenerateExperimentContentQuery, DpExperimentGenerateExperimentContentQueryVariables>;
export const HashExperimentDocument = gql`
    query HashExperiment($dpbExperimentId: ID!, $experimentType: String!) {
  hashExperiment(
    dpbExperimentId: $dpbExperimentId
    experimentType: $experimentType
  ) {
    hash
  }
}
    `;

/**
 * __useHashExperimentQuery__
 *
 * To run a query within a React component, call `useHashExperimentQuery` and pass it any options that fit your needs.
 * When your component renders, `useHashExperimentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHashExperimentQuery({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      experimentType: // value for 'experimentType'
 *   },
 * });
 */
export function useHashExperimentQuery(baseOptions: Apollo.QueryHookOptions<HashExperimentQuery, HashExperimentQueryVariables> & ({ variables: HashExperimentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HashExperimentQuery, HashExperimentQueryVariables>(HashExperimentDocument, options);
      }
export function useHashExperimentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HashExperimentQuery, HashExperimentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HashExperimentQuery, HashExperimentQueryVariables>(HashExperimentDocument, options);
        }
// @ts-ignore
export function useHashExperimentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HashExperimentQuery, HashExperimentQueryVariables>): Apollo.UseSuspenseQueryResult<HashExperimentQuery, HashExperimentQueryVariables>;
export function useHashExperimentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HashExperimentQuery, HashExperimentQueryVariables>): Apollo.UseSuspenseQueryResult<HashExperimentQuery | undefined, HashExperimentQueryVariables>;
export function useHashExperimentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HashExperimentQuery, HashExperimentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HashExperimentQuery, HashExperimentQueryVariables>(HashExperimentDocument, options);
        }
export type HashExperimentQueryHookResult = ReturnType<typeof useHashExperimentQuery>;
export type HashExperimentLazyQueryHookResult = ReturnType<typeof useHashExperimentLazyQuery>;
export type HashExperimentSuspenseQueryHookResult = ReturnType<typeof useHashExperimentSuspenseQuery>;
export type HashExperimentQueryResult = Apollo.QueryResult<HashExperimentQuery, HashExperimentQueryVariables>;
export const DpExperimentDocument = gql`
    query DpExperiment($dpbExperimentId: ID!, $experimentType: String!) {
  dpExperiment(dpbExperimentId: $dpbExperimentId, experimentType: $experimentType) {
    bullseyeSegments {
      segmentId
      position
      titleExclusions
      bulletExclusions
      landingImageExclusions
      combination
    }
    activationDate
    deactivationDate
    contextualCohortType
    controlConfigurationType
    hashDimension
    createdAt
    createdBy
    description
    dpbExperimentId
    experimentType
    locales
    marketplaces
    mvesExperimentIds
    mvesPublishResults
    name
    primaryAsin
    isPrimaryParent
    status
    updatedAt
    updatedBy
    variationalAsins
    lastPublishedExperimentHash
    summaryInfos
    mvesIotalabId
  }
}
    `;

/**
 * __useDpExperimentQuery__
 *
 * To run a query within a React component, call `useDpExperimentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDpExperimentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDpExperimentQuery({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      experimentType: // value for 'experimentType'
 *   },
 * });
 */
export function useDpExperimentQuery(baseOptions: Apollo.QueryHookOptions<DpExperimentQuery, DpExperimentQueryVariables> & ({ variables: DpExperimentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DpExperimentQuery, DpExperimentQueryVariables>(DpExperimentDocument, options);
      }
export function useDpExperimentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DpExperimentQuery, DpExperimentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DpExperimentQuery, DpExperimentQueryVariables>(DpExperimentDocument, options);
        }
// @ts-ignore
export function useDpExperimentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DpExperimentQuery, DpExperimentQueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentQuery, DpExperimentQueryVariables>;
export function useDpExperimentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentQuery, DpExperimentQueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentQuery | undefined, DpExperimentQueryVariables>;
export function useDpExperimentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentQuery, DpExperimentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DpExperimentQuery, DpExperimentQueryVariables>(DpExperimentDocument, options);
        }
export type DpExperimentQueryHookResult = ReturnType<typeof useDpExperimentQuery>;
export type DpExperimentLazyQueryHookResult = ReturnType<typeof useDpExperimentLazyQuery>;
export type DpExperimentSuspenseQueryHookResult = ReturnType<typeof useDpExperimentSuspenseQuery>;
export type DpExperimentQueryResult = Apollo.QueryResult<DpExperimentQuery, DpExperimentQueryVariables>;
export const DpExperimentV2Document = gql`
    query DpExperimentV2($experimentId: ID!) {
  dpExperimentV2(experimentId: $experimentId) {
    id
    program {
      id
      programId
      name
    }
    experimentType
    updatedAt
    updatedBy
    createdAt
    createdBy
    status
    version
    mvesExperimentId
    productLine {
      id
      productLineId
      name
    }
    marketplaceExperimentConfig {
      ...marketplaceExperimentConfigFragment
      priorConfig {
        ...marketplaceExperimentConfigFragment
        iotalabReferenceId
      }
      bullseyeSegments {
        bullseyeSegmentId
        position
        titleExclusions
        bulletExclusions
        landingImageExclusions
      }
      contextualCohortType
      status
      validationErrors
      iotalabReferenceId
    }
  }
}
    ${MarketplaceExperimentConfigFragmentFragmentDoc}`;

/**
 * __useDpExperimentV2Query__
 *
 * To run a query within a React component, call `useDpExperimentV2Query` and pass it any options that fit your needs.
 * When your component renders, `useDpExperimentV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDpExperimentV2Query({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function useDpExperimentV2Query(baseOptions: Apollo.QueryHookOptions<DpExperimentV2Query, DpExperimentV2QueryVariables> & ({ variables: DpExperimentV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DpExperimentV2Query, DpExperimentV2QueryVariables>(DpExperimentV2Document, options);
      }
export function useDpExperimentV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DpExperimentV2Query, DpExperimentV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DpExperimentV2Query, DpExperimentV2QueryVariables>(DpExperimentV2Document, options);
        }
// @ts-ignore
export function useDpExperimentV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DpExperimentV2Query, DpExperimentV2QueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentV2Query, DpExperimentV2QueryVariables>;
export function useDpExperimentV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentV2Query, DpExperimentV2QueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentV2Query | undefined, DpExperimentV2QueryVariables>;
export function useDpExperimentV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentV2Query, DpExperimentV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DpExperimentV2Query, DpExperimentV2QueryVariables>(DpExperimentV2Document, options);
        }
export type DpExperimentV2QueryHookResult = ReturnType<typeof useDpExperimentV2Query>;
export type DpExperimentV2LazyQueryHookResult = ReturnType<typeof useDpExperimentV2LazyQuery>;
export type DpExperimentV2SuspenseQueryHookResult = ReturnType<typeof useDpExperimentV2SuspenseQuery>;
export type DpExperimentV2QueryResult = Apollo.QueryResult<DpExperimentV2Query, DpExperimentV2QueryVariables>;
export const DpExperimentsDocument = gql`
    query DpExperiments {
  dpExperiments {
    productLine
    program
    primaryAsin
    activationDate
    deactivationDate
    createdAt
    createdBy
    description
    dpbExperimentId
    experimentType
    marketplaces
    locales
    name
    status
    updatedAt
    updatedBy
    mvesExperimentIds
  }
}
    `;

/**
 * __useDpExperimentsQuery__
 *
 * To run a query within a React component, call `useDpExperimentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDpExperimentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDpExperimentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDpExperimentsQuery(baseOptions?: Apollo.QueryHookOptions<DpExperimentsQuery, DpExperimentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DpExperimentsQuery, DpExperimentsQueryVariables>(DpExperimentsDocument, options);
      }
export function useDpExperimentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DpExperimentsQuery, DpExperimentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DpExperimentsQuery, DpExperimentsQueryVariables>(DpExperimentsDocument, options);
        }
// @ts-ignore
export function useDpExperimentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DpExperimentsQuery, DpExperimentsQueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentsQuery, DpExperimentsQueryVariables>;
export function useDpExperimentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentsQuery, DpExperimentsQueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentsQuery | undefined, DpExperimentsQueryVariables>;
export function useDpExperimentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentsQuery, DpExperimentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DpExperimentsQuery, DpExperimentsQueryVariables>(DpExperimentsDocument, options);
        }
export type DpExperimentsQueryHookResult = ReturnType<typeof useDpExperimentsQuery>;
export type DpExperimentsLazyQueryHookResult = ReturnType<typeof useDpExperimentsLazyQuery>;
export type DpExperimentsSuspenseQueryHookResult = ReturnType<typeof useDpExperimentsSuspenseQuery>;
export type DpExperimentsQueryResult = Apollo.QueryResult<DpExperimentsQuery, DpExperimentsQueryVariables>;
export const DpExperimentsV2Document = gql`
    query DpExperimentsV2 {
  dpExperimentsV2 {
    id
    version
    status
    program {
      id
      programId
      name
    }
    productLine {
      id
      name
      productLineId
    }
    experimentType
    createdAt
    createdBy
    updatedAt
    updatedBy
    marketplaceExperimentConfig {
      id
      marketplace {
        id
        obfuscatedMarketplaceId
        country
      }
      locales
      primaryAsin
      asinConfigs {
        asin
        asinConfigId
      }
      contextualCohortType
      activationDate
      deactivationDate
      status
    }
  }
}
    `;

/**
 * __useDpExperimentsV2Query__
 *
 * To run a query within a React component, call `useDpExperimentsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useDpExperimentsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDpExperimentsV2Query({
 *   variables: {
 *   },
 * });
 */
export function useDpExperimentsV2Query(baseOptions?: Apollo.QueryHookOptions<DpExperimentsV2Query, DpExperimentsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DpExperimentsV2Query, DpExperimentsV2QueryVariables>(DpExperimentsV2Document, options);
      }
export function useDpExperimentsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DpExperimentsV2Query, DpExperimentsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DpExperimentsV2Query, DpExperimentsV2QueryVariables>(DpExperimentsV2Document, options);
        }
// @ts-ignore
export function useDpExperimentsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DpExperimentsV2Query, DpExperimentsV2QueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentsV2Query, DpExperimentsV2QueryVariables>;
export function useDpExperimentsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentsV2Query, DpExperimentsV2QueryVariables>): Apollo.UseSuspenseQueryResult<DpExperimentsV2Query | undefined, DpExperimentsV2QueryVariables>;
export function useDpExperimentsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DpExperimentsV2Query, DpExperimentsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DpExperimentsV2Query, DpExperimentsV2QueryVariables>(DpExperimentsV2Document, options);
        }
export type DpExperimentsV2QueryHookResult = ReturnType<typeof useDpExperimentsV2Query>;
export type DpExperimentsV2LazyQueryHookResult = ReturnType<typeof useDpExperimentsV2LazyQuery>;
export type DpExperimentsV2SuspenseQueryHookResult = ReturnType<typeof useDpExperimentsV2SuspenseQuery>;
export type DpExperimentsV2QueryResult = Apollo.QueryResult<DpExperimentsV2Query, DpExperimentsV2QueryVariables>;
export const DuplicateExperimentDocument = gql`
    mutation DuplicateExperiment($dpbExperimentId: ID!, $experimentType: String!) {
  duplicateExperiment(
    dpbExperimentId: $dpbExperimentId
    experimentType: $experimentType
  ) {
    dpbExperimentId
    experimentType
    code
    message
    success
  }
}
    `;
export type DuplicateExperimentMutationFn = Apollo.MutationFunction<DuplicateExperimentMutation, DuplicateExperimentMutationVariables>;

/**
 * __useDuplicateExperimentMutation__
 *
 * To run a mutation, you first call `useDuplicateExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateExperimentMutation, { data, loading, error }] = useDuplicateExperimentMutation({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      experimentType: // value for 'experimentType'
 *   },
 * });
 */
export function useDuplicateExperimentMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateExperimentMutation, DuplicateExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateExperimentMutation, DuplicateExperimentMutationVariables>(DuplicateExperimentDocument, options);
      }
export type DuplicateExperimentMutationHookResult = ReturnType<typeof useDuplicateExperimentMutation>;
export type DuplicateExperimentMutationResult = Apollo.MutationResult<DuplicateExperimentMutation>;
export type DuplicateExperimentMutationOptions = Apollo.BaseMutationOptions<DuplicateExperimentMutation, DuplicateExperimentMutationVariables>;
export const MvesCatalogFeatureBulletsDocument = gql`
    query MvesCatalogFeatureBullets($asin: String!, $marketplace: String!, $locale: String!) {
  mvesCatalogFeatureBullets(
    asin: $asin
    marketplace: $marketplace
    locale: $locale
  ) {
    featureBullets
  }
}
    `;

/**
 * __useMvesCatalogFeatureBulletsQuery__
 *
 * To run a query within a React component, call `useMvesCatalogFeatureBulletsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvesCatalogFeatureBulletsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvesCatalogFeatureBulletsQuery({
 *   variables: {
 *      asin: // value for 'asin'
 *      marketplace: // value for 'marketplace'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useMvesCatalogFeatureBulletsQuery(baseOptions: Apollo.QueryHookOptions<MvesCatalogFeatureBulletsQuery, MvesCatalogFeatureBulletsQueryVariables> & ({ variables: MvesCatalogFeatureBulletsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvesCatalogFeatureBulletsQuery, MvesCatalogFeatureBulletsQueryVariables>(MvesCatalogFeatureBulletsDocument, options);
      }
export function useMvesCatalogFeatureBulletsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvesCatalogFeatureBulletsQuery, MvesCatalogFeatureBulletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvesCatalogFeatureBulletsQuery, MvesCatalogFeatureBulletsQueryVariables>(MvesCatalogFeatureBulletsDocument, options);
        }
// @ts-ignore
export function useMvesCatalogFeatureBulletsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvesCatalogFeatureBulletsQuery, MvesCatalogFeatureBulletsQueryVariables>): Apollo.UseSuspenseQueryResult<MvesCatalogFeatureBulletsQuery, MvesCatalogFeatureBulletsQueryVariables>;
export function useMvesCatalogFeatureBulletsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MvesCatalogFeatureBulletsQuery, MvesCatalogFeatureBulletsQueryVariables>): Apollo.UseSuspenseQueryResult<MvesCatalogFeatureBulletsQuery | undefined, MvesCatalogFeatureBulletsQueryVariables>;
export function useMvesCatalogFeatureBulletsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MvesCatalogFeatureBulletsQuery, MvesCatalogFeatureBulletsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvesCatalogFeatureBulletsQuery, MvesCatalogFeatureBulletsQueryVariables>(MvesCatalogFeatureBulletsDocument, options);
        }
export type MvesCatalogFeatureBulletsQueryHookResult = ReturnType<typeof useMvesCatalogFeatureBulletsQuery>;
export type MvesCatalogFeatureBulletsLazyQueryHookResult = ReturnType<typeof useMvesCatalogFeatureBulletsLazyQuery>;
export type MvesCatalogFeatureBulletsSuspenseQueryHookResult = ReturnType<typeof useMvesCatalogFeatureBulletsSuspenseQuery>;
export type MvesCatalogFeatureBulletsQueryResult = Apollo.QueryResult<MvesCatalogFeatureBulletsQuery, MvesCatalogFeatureBulletsQueryVariables>;
export const MvesCatalogTitleDocument = gql`
    query MvesCatalogTitle($asin: String!, $marketplace: String!, $locale: String!) {
  mvesCatalogTitle(asin: $asin, marketplace: $marketplace, locale: $locale) {
    title
    locale
    marketplace
  }
}
    `;

/**
 * __useMvesCatalogTitleQuery__
 *
 * To run a query within a React component, call `useMvesCatalogTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvesCatalogTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvesCatalogTitleQuery({
 *   variables: {
 *      asin: // value for 'asin'
 *      marketplace: // value for 'marketplace'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useMvesCatalogTitleQuery(baseOptions: Apollo.QueryHookOptions<MvesCatalogTitleQuery, MvesCatalogTitleQueryVariables> & ({ variables: MvesCatalogTitleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvesCatalogTitleQuery, MvesCatalogTitleQueryVariables>(MvesCatalogTitleDocument, options);
      }
export function useMvesCatalogTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvesCatalogTitleQuery, MvesCatalogTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvesCatalogTitleQuery, MvesCatalogTitleQueryVariables>(MvesCatalogTitleDocument, options);
        }
// @ts-ignore
export function useMvesCatalogTitleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvesCatalogTitleQuery, MvesCatalogTitleQueryVariables>): Apollo.UseSuspenseQueryResult<MvesCatalogTitleQuery, MvesCatalogTitleQueryVariables>;
export function useMvesCatalogTitleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MvesCatalogTitleQuery, MvesCatalogTitleQueryVariables>): Apollo.UseSuspenseQueryResult<MvesCatalogTitleQuery | undefined, MvesCatalogTitleQueryVariables>;
export function useMvesCatalogTitleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MvesCatalogTitleQuery, MvesCatalogTitleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvesCatalogTitleQuery, MvesCatalogTitleQueryVariables>(MvesCatalogTitleDocument, options);
        }
export type MvesCatalogTitleQueryHookResult = ReturnType<typeof useMvesCatalogTitleQuery>;
export type MvesCatalogTitleLazyQueryHookResult = ReturnType<typeof useMvesCatalogTitleLazyQuery>;
export type MvesCatalogTitleSuspenseQueryHookResult = ReturnType<typeof useMvesCatalogTitleSuspenseQuery>;
export type MvesCatalogTitleQueryResult = Apollo.QueryResult<MvesCatalogTitleQuery, MvesCatalogTitleQueryVariables>;
export const MvesIotalabIdDocument = gql`
    query MvesIotalabId($dpbExperimentId: ID!, $experimentType: String!) {
  dpExperiment(dpbExperimentId: $dpbExperimentId, experimentType: $experimentType) {
    mvesIotalabId
  }
}
    `;

/**
 * __useMvesIotalabIdQuery__
 *
 * To run a query within a React component, call `useMvesIotalabIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvesIotalabIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvesIotalabIdQuery({
 *   variables: {
 *      dpbExperimentId: // value for 'dpbExperimentId'
 *      experimentType: // value for 'experimentType'
 *   },
 * });
 */
export function useMvesIotalabIdQuery(baseOptions: Apollo.QueryHookOptions<MvesIotalabIdQuery, MvesIotalabIdQueryVariables> & ({ variables: MvesIotalabIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvesIotalabIdQuery, MvesIotalabIdQueryVariables>(MvesIotalabIdDocument, options);
      }
export function useMvesIotalabIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvesIotalabIdQuery, MvesIotalabIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvesIotalabIdQuery, MvesIotalabIdQueryVariables>(MvesIotalabIdDocument, options);
        }
// @ts-ignore
export function useMvesIotalabIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvesIotalabIdQuery, MvesIotalabIdQueryVariables>): Apollo.UseSuspenseQueryResult<MvesIotalabIdQuery, MvesIotalabIdQueryVariables>;
export function useMvesIotalabIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MvesIotalabIdQuery, MvesIotalabIdQueryVariables>): Apollo.UseSuspenseQueryResult<MvesIotalabIdQuery | undefined, MvesIotalabIdQueryVariables>;
export function useMvesIotalabIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MvesIotalabIdQuery, MvesIotalabIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvesIotalabIdQuery, MvesIotalabIdQueryVariables>(MvesIotalabIdDocument, options);
        }
export type MvesIotalabIdQueryHookResult = ReturnType<typeof useMvesIotalabIdQuery>;
export type MvesIotalabIdLazyQueryHookResult = ReturnType<typeof useMvesIotalabIdLazyQuery>;
export type MvesIotalabIdSuspenseQueryHookResult = ReturnType<typeof useMvesIotalabIdSuspenseQuery>;
export type MvesIotalabIdQueryResult = Apollo.QueryResult<MvesIotalabIdQuery, MvesIotalabIdQueryVariables>;
export const MvesVariationalAsinsDocument = gql`
    query MvesVariationalAsins($asin: String!, $marketplace: String!) {
  mvesVariationalAsins(asin: $asin, marketplace: $marketplace) {
    asin
    title
    isParent
  }
}
    `;

/**
 * __useMvesVariationalAsinsQuery__
 *
 * To run a query within a React component, call `useMvesVariationalAsinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMvesVariationalAsinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMvesVariationalAsinsQuery({
 *   variables: {
 *      asin: // value for 'asin'
 *      marketplace: // value for 'marketplace'
 *   },
 * });
 */
export function useMvesVariationalAsinsQuery(baseOptions: Apollo.QueryHookOptions<MvesVariationalAsinsQuery, MvesVariationalAsinsQueryVariables> & ({ variables: MvesVariationalAsinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MvesVariationalAsinsQuery, MvesVariationalAsinsQueryVariables>(MvesVariationalAsinsDocument, options);
      }
export function useMvesVariationalAsinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MvesVariationalAsinsQuery, MvesVariationalAsinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MvesVariationalAsinsQuery, MvesVariationalAsinsQueryVariables>(MvesVariationalAsinsDocument, options);
        }
// @ts-ignore
export function useMvesVariationalAsinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MvesVariationalAsinsQuery, MvesVariationalAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<MvesVariationalAsinsQuery, MvesVariationalAsinsQueryVariables>;
export function useMvesVariationalAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MvesVariationalAsinsQuery, MvesVariationalAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<MvesVariationalAsinsQuery | undefined, MvesVariationalAsinsQueryVariables>;
export function useMvesVariationalAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MvesVariationalAsinsQuery, MvesVariationalAsinsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MvesVariationalAsinsQuery, MvesVariationalAsinsQueryVariables>(MvesVariationalAsinsDocument, options);
        }
export type MvesVariationalAsinsQueryHookResult = ReturnType<typeof useMvesVariationalAsinsQuery>;
export type MvesVariationalAsinsLazyQueryHookResult = ReturnType<typeof useMvesVariationalAsinsLazyQuery>;
export type MvesVariationalAsinsSuspenseQueryHookResult = ReturnType<typeof useMvesVariationalAsinsSuspenseQuery>;
export type MvesVariationalAsinsQueryResult = Apollo.QueryResult<MvesVariationalAsinsQuery, MvesVariationalAsinsQueryVariables>;
export const PublishExperimentV2Document = gql`
    mutation PublishExperimentV2($input: DpExperimentDetailsPublishInputV2!) {
  publishExperimentV2(input: $input) {
    id
    program {
      id
      programId
      name
    }
    experimentType
    updatedAt
    updatedBy
    createdAt
    createdBy
    status
    version
    productLine {
      id
      productLineId
      name
    }
    marketplaceExperimentConfig {
      id
      marketplace {
        id
        obfuscatedMarketplaceId
        country
      }
      locales
      activationDate
      deactivationDate
      primaryAsin
      asinConfigs {
        asin
        asinConfigId
        featureVariants {
          titles {
            variantId
            variantPosition
            variantName
            uniqueReferenceId
            updatedBy
            updatedAt
            lastPublishedVersion
            lastPublishedDate
            previewed
            locale
            titleString
          }
          bullets {
            variantId
            variantPosition
            variantName
            uniqueReferenceId
            updatedBy
            updatedAt
            lastPublishedVersion
            lastPublishedDate
            previewed
            locale
            bulletStrings
          }
          landingImages {
            variantId
            variantPosition
            variantName
            uniqueReferenceId
            updatedBy
            updatedAt
            lastPublishedVersion
            lastPublishedDate
            previewed
            assetId
            url
            platform
            mcVariant
            locale
            shipmentId
          }
        }
      }
      bullseyeSegments {
        bullseyeSegmentId
        position
        titleExclusions
        bulletExclusions
        landingImageExclusions
      }
      contextualCohortType
      status
    }
  }
}
    `;
export type PublishExperimentV2MutationFn = Apollo.MutationFunction<PublishExperimentV2Mutation, PublishExperimentV2MutationVariables>;

/**
 * __usePublishExperimentV2Mutation__
 *
 * To run a mutation, you first call `usePublishExperimentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishExperimentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishExperimentV2Mutation, { data, loading, error }] = usePublishExperimentV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishExperimentV2Mutation(baseOptions?: Apollo.MutationHookOptions<PublishExperimentV2Mutation, PublishExperimentV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishExperimentV2Mutation, PublishExperimentV2MutationVariables>(PublishExperimentV2Document, options);
      }
export type PublishExperimentV2MutationHookResult = ReturnType<typeof usePublishExperimentV2Mutation>;
export type PublishExperimentV2MutationResult = Apollo.MutationResult<PublishExperimentV2Mutation>;
export type PublishExperimentV2MutationOptions = Apollo.BaseMutationOptions<PublishExperimentV2Mutation, PublishExperimentV2MutationVariables>;
export const UpdateBulletVariantMutationV2Document = gql`
    mutation updateBulletVariantMutationV2($experimentId: ID!, $marketplaceId: String!, $variants: [DpBulletsVariantInputV2!]!) {
  createOrUpdateBulletsVariantV2(
    experimentId: $experimentId
    marketplaceId: $marketplaceId
    variants: $variants
  ) {
    asinConfigs {
      asin
      asinConfigId
      featureVariants {
        bullets {
          variantId
          variantPosition
          uniqueReferenceId
          locale
          bulletStrings
        }
      }
    }
  }
}
    `;
export type UpdateBulletVariantMutationV2MutationFn = Apollo.MutationFunction<UpdateBulletVariantMutationV2Mutation, UpdateBulletVariantMutationV2MutationVariables>;

/**
 * __useUpdateBulletVariantMutationV2Mutation__
 *
 * To run a mutation, you first call `useUpdateBulletVariantMutationV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBulletVariantMutationV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBulletVariantMutationV2Mutation, { data, loading, error }] = useUpdateBulletVariantMutationV2Mutation({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *      marketplaceId: // value for 'marketplaceId'
 *      variants: // value for 'variants'
 *   },
 * });
 */
export function useUpdateBulletVariantMutationV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateBulletVariantMutationV2Mutation, UpdateBulletVariantMutationV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBulletVariantMutationV2Mutation, UpdateBulletVariantMutationV2MutationVariables>(UpdateBulletVariantMutationV2Document, options);
      }
export type UpdateBulletVariantMutationV2MutationHookResult = ReturnType<typeof useUpdateBulletVariantMutationV2Mutation>;
export type UpdateBulletVariantMutationV2MutationResult = Apollo.MutationResult<UpdateBulletVariantMutationV2Mutation>;
export type UpdateBulletVariantMutationV2MutationOptions = Apollo.BaseMutationOptions<UpdateBulletVariantMutationV2Mutation, UpdateBulletVariantMutationV2MutationVariables>;
export const UpdateImageVariantMutationV2Document = gql`
    mutation updateImageVariantMutationV2($experimentId: ID!, $marketplaceId: String!, $variants: [DpLandingImageVariantInputV2!]!) {
  createOrUpdateLandingImageVariantV2(
    experimentId: $experimentId
    marketplaceId: $marketplaceId
    variants: $variants
  ) {
    asinConfigs {
      asin
      asinConfigId
      featureVariants {
        landingImages {
          assetId
          url
          platform
        }
      }
    }
  }
}
    `;
export type UpdateImageVariantMutationV2MutationFn = Apollo.MutationFunction<UpdateImageVariantMutationV2Mutation, UpdateImageVariantMutationV2MutationVariables>;

/**
 * __useUpdateImageVariantMutationV2Mutation__
 *
 * To run a mutation, you first call `useUpdateImageVariantMutationV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageVariantMutationV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageVariantMutationV2Mutation, { data, loading, error }] = useUpdateImageVariantMutationV2Mutation({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *      marketplaceId: // value for 'marketplaceId'
 *      variants: // value for 'variants'
 *   },
 * });
 */
export function useUpdateImageVariantMutationV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateImageVariantMutationV2Mutation, UpdateImageVariantMutationV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImageVariantMutationV2Mutation, UpdateImageVariantMutationV2MutationVariables>(UpdateImageVariantMutationV2Document, options);
      }
export type UpdateImageVariantMutationV2MutationHookResult = ReturnType<typeof useUpdateImageVariantMutationV2Mutation>;
export type UpdateImageVariantMutationV2MutationResult = Apollo.MutationResult<UpdateImageVariantMutationV2Mutation>;
export type UpdateImageVariantMutationV2MutationOptions = Apollo.BaseMutationOptions<UpdateImageVariantMutationV2Mutation, UpdateImageVariantMutationV2MutationVariables>;
export const UpdateExperimentV2Document = gql`
    mutation UpdateExperimentV2($input: DpExperimentDetailsUpdateInputV2!) {
  updateExperimentV2(input: $input) {
    experiment {
      id
      program {
        id
        programId
        name
      }
      experimentType
      updatedAt
      updatedBy
      createdAt
      createdBy
      status
      version
      productLine {
        id
        productLineId
        name
      }
      marketplaceExperimentConfig {
        marketplace {
          id
          obfuscatedMarketplaceId
          country
        }
        locales
        activationDate
        deactivationDate
        primaryAsin
        asinConfigs {
          asin
          asinConfigId
          featureVariants {
            titles {
              variantId
              variantPosition
              variantName
              uniqueReferenceId
              updatedBy
              updatedAt
              lastPublishedVersion
              lastPublishedDate
              previewed
              locale
              titleString
            }
            bullets {
              variantId
              variantPosition
              variantName
              uniqueReferenceId
              updatedBy
              updatedAt
              lastPublishedVersion
              lastPublishedDate
              previewed
              locale
              bulletStrings
            }
            landingImages {
              variantId
              variantPosition
              variantName
              uniqueReferenceId
              updatedBy
              updatedAt
              lastPublishedVersion
              lastPublishedDate
              previewed
              assetId
              url
              platform
              mcVariant
              locale
              shipmentId
            }
          }
        }
        bullseyeSegments {
          bullseyeSegmentId
          position
          titleExclusions
          bulletExclusions
          landingImageExclusions
        }
        contextualCohortType
        status
      }
    }
  }
}
    `;
export type UpdateExperimentV2MutationFn = Apollo.MutationFunction<UpdateExperimentV2Mutation, UpdateExperimentV2MutationVariables>;

/**
 * __useUpdateExperimentV2Mutation__
 *
 * To run a mutation, you first call `useUpdateExperimentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExperimentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExperimentV2Mutation, { data, loading, error }] = useUpdateExperimentV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExperimentV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateExperimentV2Mutation, UpdateExperimentV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExperimentV2Mutation, UpdateExperimentV2MutationVariables>(UpdateExperimentV2Document, options);
      }
export type UpdateExperimentV2MutationHookResult = ReturnType<typeof useUpdateExperimentV2Mutation>;
export type UpdateExperimentV2MutationResult = Apollo.MutationResult<UpdateExperimentV2Mutation>;
export type UpdateExperimentV2MutationOptions = Apollo.BaseMutationOptions<UpdateExperimentV2Mutation, UpdateExperimentV2MutationVariables>;
export const UpdateTitleVariantMutationV2Document = gql`
    mutation updateTitleVariantMutationV2($experimentId: ID!, $marketplaceId: String!, $variants: [DpTitleVariantInputV2!]!) {
  createOrUpdateTitleVariantV2(
    experimentId: $experimentId
    marketplaceId: $marketplaceId
    variants: $variants
  ) {
    asinConfigs {
      asin
      asinConfigId
      featureVariants {
        titles {
          variantId
          variantPosition
          uniqueReferenceId
          locale
          titleString
        }
      }
    }
  }
}
    `;
export type UpdateTitleVariantMutationV2MutationFn = Apollo.MutationFunction<UpdateTitleVariantMutationV2Mutation, UpdateTitleVariantMutationV2MutationVariables>;

/**
 * __useUpdateTitleVariantMutationV2Mutation__
 *
 * To run a mutation, you first call `useUpdateTitleVariantMutationV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTitleVariantMutationV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTitleVariantMutationV2Mutation, { data, loading, error }] = useUpdateTitleVariantMutationV2Mutation({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *      marketplaceId: // value for 'marketplaceId'
 *      variants: // value for 'variants'
 *   },
 * });
 */
export function useUpdateTitleVariantMutationV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateTitleVariantMutationV2Mutation, UpdateTitleVariantMutationV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTitleVariantMutationV2Mutation, UpdateTitleVariantMutationV2MutationVariables>(UpdateTitleVariantMutationV2Document, options);
      }
export type UpdateTitleVariantMutationV2MutationHookResult = ReturnType<typeof useUpdateTitleVariantMutationV2Mutation>;
export type UpdateTitleVariantMutationV2MutationResult = Apollo.MutationResult<UpdateTitleVariantMutationV2Mutation>;
export type UpdateTitleVariantMutationV2MutationOptions = Apollo.BaseMutationOptions<UpdateTitleVariantMutationV2Mutation, UpdateTitleVariantMutationV2MutationVariables>;
export const JourneysRedirectHandlerDocument = gql`
    query JourneysRedirectHandler($projectId: ID!, $campaignId: ID!) {
  trafficCampaign(id: $campaignId, projectId: $projectId) {
    id
    schema
  }
}
    `;

/**
 * __useJourneysRedirectHandlerQuery__
 *
 * To run a query within a React component, call `useJourneysRedirectHandlerQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneysRedirectHandlerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneysRedirectHandlerQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useJourneysRedirectHandlerQuery(baseOptions: Apollo.QueryHookOptions<JourneysRedirectHandlerQuery, JourneysRedirectHandlerQueryVariables> & ({ variables: JourneysRedirectHandlerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JourneysRedirectHandlerQuery, JourneysRedirectHandlerQueryVariables>(JourneysRedirectHandlerDocument, options);
      }
export function useJourneysRedirectHandlerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JourneysRedirectHandlerQuery, JourneysRedirectHandlerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JourneysRedirectHandlerQuery, JourneysRedirectHandlerQueryVariables>(JourneysRedirectHandlerDocument, options);
        }
// @ts-ignore
export function useJourneysRedirectHandlerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JourneysRedirectHandlerQuery, JourneysRedirectHandlerQueryVariables>): Apollo.UseSuspenseQueryResult<JourneysRedirectHandlerQuery, JourneysRedirectHandlerQueryVariables>;
export function useJourneysRedirectHandlerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JourneysRedirectHandlerQuery, JourneysRedirectHandlerQueryVariables>): Apollo.UseSuspenseQueryResult<JourneysRedirectHandlerQuery | undefined, JourneysRedirectHandlerQueryVariables>;
export function useJourneysRedirectHandlerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JourneysRedirectHandlerQuery, JourneysRedirectHandlerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JourneysRedirectHandlerQuery, JourneysRedirectHandlerQueryVariables>(JourneysRedirectHandlerDocument, options);
        }
export type JourneysRedirectHandlerQueryHookResult = ReturnType<typeof useJourneysRedirectHandlerQuery>;
export type JourneysRedirectHandlerLazyQueryHookResult = ReturnType<typeof useJourneysRedirectHandlerLazyQuery>;
export type JourneysRedirectHandlerSuspenseQueryHookResult = ReturnType<typeof useJourneysRedirectHandlerSuspenseQuery>;
export type JourneysRedirectHandlerQueryResult = Apollo.QueryResult<JourneysRedirectHandlerQuery, JourneysRedirectHandlerQueryVariables>;
export const TwisterPlusAsinsDocument = gql`
    query TwisterPlusAsins($first: Int!, $filters: AsinFilterInput, $after: String) {
  asins(first: $first, filters: $filters, after: $after) {
    pageInfo {
      endCursor
      hasNextPage
    }
    nodes {
      id
      asin
      description
      party
      type
      marketplace {
        id
        obfuscatedMarketplaceId
        country
      }
      program {
        id
        name
      }
      productLine {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTwisterPlusAsinsQuery__
 *
 * To run a query within a React component, call `useTwisterPlusAsinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTwisterPlusAsinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTwisterPlusAsinsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTwisterPlusAsinsQuery(baseOptions: Apollo.QueryHookOptions<TwisterPlusAsinsQuery, TwisterPlusAsinsQueryVariables> & ({ variables: TwisterPlusAsinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TwisterPlusAsinsQuery, TwisterPlusAsinsQueryVariables>(TwisterPlusAsinsDocument, options);
      }
export function useTwisterPlusAsinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TwisterPlusAsinsQuery, TwisterPlusAsinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TwisterPlusAsinsQuery, TwisterPlusAsinsQueryVariables>(TwisterPlusAsinsDocument, options);
        }
// @ts-ignore
export function useTwisterPlusAsinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TwisterPlusAsinsQuery, TwisterPlusAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<TwisterPlusAsinsQuery, TwisterPlusAsinsQueryVariables>;
export function useTwisterPlusAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TwisterPlusAsinsQuery, TwisterPlusAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<TwisterPlusAsinsQuery | undefined, TwisterPlusAsinsQueryVariables>;
export function useTwisterPlusAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TwisterPlusAsinsQuery, TwisterPlusAsinsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TwisterPlusAsinsQuery, TwisterPlusAsinsQueryVariables>(TwisterPlusAsinsDocument, options);
        }
export type TwisterPlusAsinsQueryHookResult = ReturnType<typeof useTwisterPlusAsinsQuery>;
export type TwisterPlusAsinsLazyQueryHookResult = ReturnType<typeof useTwisterPlusAsinsLazyQuery>;
export type TwisterPlusAsinsSuspenseQueryHookResult = ReturnType<typeof useTwisterPlusAsinsSuspenseQuery>;
export type TwisterPlusAsinsQueryResult = Apollo.QueryResult<TwisterPlusAsinsQuery, TwisterPlusAsinsQueryVariables>;
export const BundleAsinsDocument = gql`
    query BundleAsins($first: Int!, $filters: AsinFilterInput, $bundlesFirst2: Int!) {
  asins(first: $first, filters: $filters) {
    nodes {
      standaloneAsin: asin
      bundles(first: $bundlesFirst2) {
        nodes {
          id
          asin
          description
          type
        }
      }
    }
  }
}
    `;

/**
 * __useBundleAsinsQuery__
 *
 * To run a query within a React component, call `useBundleAsinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBundleAsinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBundleAsinsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      bundlesFirst2: // value for 'bundlesFirst2'
 *   },
 * });
 */
export function useBundleAsinsQuery(baseOptions: Apollo.QueryHookOptions<BundleAsinsQuery, BundleAsinsQueryVariables> & ({ variables: BundleAsinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BundleAsinsQuery, BundleAsinsQueryVariables>(BundleAsinsDocument, options);
      }
export function useBundleAsinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BundleAsinsQuery, BundleAsinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BundleAsinsQuery, BundleAsinsQueryVariables>(BundleAsinsDocument, options);
        }
// @ts-ignore
export function useBundleAsinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BundleAsinsQuery, BundleAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<BundleAsinsQuery, BundleAsinsQueryVariables>;
export function useBundleAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BundleAsinsQuery, BundleAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<BundleAsinsQuery | undefined, BundleAsinsQueryVariables>;
export function useBundleAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BundleAsinsQuery, BundleAsinsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BundleAsinsQuery, BundleAsinsQueryVariables>(BundleAsinsDocument, options);
        }
export type BundleAsinsQueryHookResult = ReturnType<typeof useBundleAsinsQuery>;
export type BundleAsinsLazyQueryHookResult = ReturnType<typeof useBundleAsinsLazyQuery>;
export type BundleAsinsSuspenseQueryHookResult = ReturnType<typeof useBundleAsinsSuspenseQuery>;
export type BundleAsinsQueryResult = Apollo.QueryResult<BundleAsinsQuery, BundleAsinsQueryVariables>;
export const MerchandizedBundlesDocument = gql`
    query MerchandizedBundles($marketplace: String!, $programId: ID!, $keys: [String!]!) {
  merchandizedBundles(
    marketplace: $marketplace
    programId: $programId
    keys: $keys
  ) {
    id
    lastPublishedDate
    lastPublishedVersion
    modifiedAt
    modifiedBy
    publishResult {
      status
      result
      errors
      success
    }
    value {
      asinTypes
      bullseye
      bundleConfigs {
        detailPageAsin
        bundles {
          asin
          shortTitle {
            locale
            title
          }
        }
      }
      language
      variationName
      weblab {
        weblabTreatment
        weblabName
        validDateTo
        validDateFrom
      }
    }
    version
  }
}
    `;

/**
 * __useMerchandizedBundlesQuery__
 *
 * To run a query within a React component, call `useMerchandizedBundlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchandizedBundlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchandizedBundlesQuery({
 *   variables: {
 *      marketplace: // value for 'marketplace'
 *      programId: // value for 'programId'
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useMerchandizedBundlesQuery(baseOptions: Apollo.QueryHookOptions<MerchandizedBundlesQuery, MerchandizedBundlesQueryVariables> & ({ variables: MerchandizedBundlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchandizedBundlesQuery, MerchandizedBundlesQueryVariables>(MerchandizedBundlesDocument, options);
      }
export function useMerchandizedBundlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchandizedBundlesQuery, MerchandizedBundlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchandizedBundlesQuery, MerchandizedBundlesQueryVariables>(MerchandizedBundlesDocument, options);
        }
// @ts-ignore
export function useMerchandizedBundlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchandizedBundlesQuery, MerchandizedBundlesQueryVariables>): Apollo.UseSuspenseQueryResult<MerchandizedBundlesQuery, MerchandizedBundlesQueryVariables>;
export function useMerchandizedBundlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchandizedBundlesQuery, MerchandizedBundlesQueryVariables>): Apollo.UseSuspenseQueryResult<MerchandizedBundlesQuery | undefined, MerchandizedBundlesQueryVariables>;
export function useMerchandizedBundlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchandizedBundlesQuery, MerchandizedBundlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchandizedBundlesQuery, MerchandizedBundlesQueryVariables>(MerchandizedBundlesDocument, options);
        }
export type MerchandizedBundlesQueryHookResult = ReturnType<typeof useMerchandizedBundlesQuery>;
export type MerchandizedBundlesLazyQueryHookResult = ReturnType<typeof useMerchandizedBundlesLazyQuery>;
export type MerchandizedBundlesSuspenseQueryHookResult = ReturnType<typeof useMerchandizedBundlesSuspenseQuery>;
export type MerchandizedBundlesQueryResult = Apollo.QueryResult<MerchandizedBundlesQuery, MerchandizedBundlesQueryVariables>;
export const ProductIdsToProgramsDocument = gql`
    query ProductIdsToPrograms($productIds: [String!]!) {
  productIdsToPrograms(productIds: $productIds) {
    programs {
      id
      name
      programId
    }
  }
}
    `;

/**
 * __useProductIdsToProgramsQuery__
 *
 * To run a query within a React component, call `useProductIdsToProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductIdsToProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductIdsToProgramsQuery({
 *   variables: {
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useProductIdsToProgramsQuery(baseOptions: Apollo.QueryHookOptions<ProductIdsToProgramsQuery, ProductIdsToProgramsQueryVariables> & ({ variables: ProductIdsToProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductIdsToProgramsQuery, ProductIdsToProgramsQueryVariables>(ProductIdsToProgramsDocument, options);
      }
export function useProductIdsToProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductIdsToProgramsQuery, ProductIdsToProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductIdsToProgramsQuery, ProductIdsToProgramsQueryVariables>(ProductIdsToProgramsDocument, options);
        }
// @ts-ignore
export function useProductIdsToProgramsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductIdsToProgramsQuery, ProductIdsToProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<ProductIdsToProgramsQuery, ProductIdsToProgramsQueryVariables>;
export function useProductIdsToProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductIdsToProgramsQuery, ProductIdsToProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<ProductIdsToProgramsQuery | undefined, ProductIdsToProgramsQueryVariables>;
export function useProductIdsToProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductIdsToProgramsQuery, ProductIdsToProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductIdsToProgramsQuery, ProductIdsToProgramsQueryVariables>(ProductIdsToProgramsDocument, options);
        }
export type ProductIdsToProgramsQueryHookResult = ReturnType<typeof useProductIdsToProgramsQuery>;
export type ProductIdsToProgramsLazyQueryHookResult = ReturnType<typeof useProductIdsToProgramsLazyQuery>;
export type ProductIdsToProgramsSuspenseQueryHookResult = ReturnType<typeof useProductIdsToProgramsSuspenseQuery>;
export type ProductIdsToProgramsQueryResult = Apollo.QueryResult<ProductIdsToProgramsQuery, ProductIdsToProgramsQueryVariables>;
export const SaveMerchandizedBundlesDocument = gql`
    mutation SaveMerchandizedBundles($input: SaveMerchandizedBundleInput!) {
  saveMerchandizedBundles(input: $input) {
    failed {
      reason
      id
    }
    succeeded {
      id
      lastPublishedDate
      lastPublishedVersion
      modifiedAt
      modifiedBy
      publishResult {
        success
        status
        result
        errors
      }
      value {
        asinTypes
        weblab {
          weblabTreatment
          weblabName
          validDateTo
          validDateFrom
        }
        variationName
        language
        bundleConfigs {
          bundles {
            shortTitle {
              locale
              title
            }
            asin
          }
          detailPageAsin
        }
        bullseye
      }
      version
    }
  }
}
    `;
export type SaveMerchandizedBundlesMutationFn = Apollo.MutationFunction<SaveMerchandizedBundlesMutation, SaveMerchandizedBundlesMutationVariables>;

/**
 * __useSaveMerchandizedBundlesMutation__
 *
 * To run a mutation, you first call `useSaveMerchandizedBundlesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMerchandizedBundlesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMerchandizedBundlesMutation, { data, loading, error }] = useSaveMerchandizedBundlesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMerchandizedBundlesMutation(baseOptions?: Apollo.MutationHookOptions<SaveMerchandizedBundlesMutation, SaveMerchandizedBundlesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMerchandizedBundlesMutation, SaveMerchandizedBundlesMutationVariables>(SaveMerchandizedBundlesDocument, options);
      }
export type SaveMerchandizedBundlesMutationHookResult = ReturnType<typeof useSaveMerchandizedBundlesMutation>;
export type SaveMerchandizedBundlesMutationResult = Apollo.MutationResult<SaveMerchandizedBundlesMutation>;
export type SaveMerchandizedBundlesMutationOptions = Apollo.BaseMutationOptions<SaveMerchandizedBundlesMutation, SaveMerchandizedBundlesMutationVariables>;
export const TrafficCampaignsForProductDocument = gql`
    query TrafficCampaignsForProduct($trafficProjectId: ID!, $first: Int, $includeRelatedProgramGhostProjects: Boolean) {
  trafficProject(id: $trafficProjectId) {
    id
    campaigns(
      first: $first
      includeRelatedProgramGhostProjects: $includeRelatedProgramGhostProjects
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        ...TCPreviewCampaign
      }
    }
  }
}
    ${TcPreviewCampaignFragmentDoc}`;

/**
 * __useTrafficCampaignsForProductQuery__
 *
 * To run a query within a React component, call `useTrafficCampaignsForProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficCampaignsForProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficCampaignsForProductQuery({
 *   variables: {
 *      trafficProjectId: // value for 'trafficProjectId'
 *      first: // value for 'first'
 *      includeRelatedProgramGhostProjects: // value for 'includeRelatedProgramGhostProjects'
 *   },
 * });
 */
export function useTrafficCampaignsForProductQuery(baseOptions: Apollo.QueryHookOptions<TrafficCampaignsForProductQuery, TrafficCampaignsForProductQueryVariables> & ({ variables: TrafficCampaignsForProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficCampaignsForProductQuery, TrafficCampaignsForProductQueryVariables>(TrafficCampaignsForProductDocument, options);
      }
export function useTrafficCampaignsForProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficCampaignsForProductQuery, TrafficCampaignsForProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficCampaignsForProductQuery, TrafficCampaignsForProductQueryVariables>(TrafficCampaignsForProductDocument, options);
        }
// @ts-ignore
export function useTrafficCampaignsForProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrafficCampaignsForProductQuery, TrafficCampaignsForProductQueryVariables>): Apollo.UseSuspenseQueryResult<TrafficCampaignsForProductQuery, TrafficCampaignsForProductQueryVariables>;
export function useTrafficCampaignsForProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrafficCampaignsForProductQuery, TrafficCampaignsForProductQueryVariables>): Apollo.UseSuspenseQueryResult<TrafficCampaignsForProductQuery | undefined, TrafficCampaignsForProductQueryVariables>;
export function useTrafficCampaignsForProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrafficCampaignsForProductQuery, TrafficCampaignsForProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrafficCampaignsForProductQuery, TrafficCampaignsForProductQueryVariables>(TrafficCampaignsForProductDocument, options);
        }
export type TrafficCampaignsForProductQueryHookResult = ReturnType<typeof useTrafficCampaignsForProductQuery>;
export type TrafficCampaignsForProductLazyQueryHookResult = ReturnType<typeof useTrafficCampaignsForProductLazyQuery>;
export type TrafficCampaignsForProductSuspenseQueryHookResult = ReturnType<typeof useTrafficCampaignsForProductSuspenseQuery>;
export type TrafficCampaignsForProductQueryResult = Apollo.QueryResult<TrafficCampaignsForProductQuery, TrafficCampaignsForProductQueryVariables>;
export const PlvProgramsDocument = gql`
    query PLVPrograms($first: Int!, $filters: ProgramFilterInput, $after: String, $sortOptions: [ProgramSortInput!]) {
  programs(
    first: $first
    filters: $filters
    after: $after
    sortOptions: $sortOptions
  ) {
    totalCount
    nodes {
      id
      name
      programId
      asins(first: 0) {
        totalCount
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __usePlvProgramsQuery__
 *
 * To run a query within a React component, call `usePlvProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlvProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlvProgramsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      sortOptions: // value for 'sortOptions'
 *   },
 * });
 */
export function usePlvProgramsQuery(baseOptions: Apollo.QueryHookOptions<PlvProgramsQuery, PlvProgramsQueryVariables> & ({ variables: PlvProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlvProgramsQuery, PlvProgramsQueryVariables>(PlvProgramsDocument, options);
      }
export function usePlvProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlvProgramsQuery, PlvProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlvProgramsQuery, PlvProgramsQueryVariables>(PlvProgramsDocument, options);
        }
// @ts-ignore
export function usePlvProgramsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlvProgramsQuery, PlvProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<PlvProgramsQuery, PlvProgramsQueryVariables>;
export function usePlvProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlvProgramsQuery, PlvProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<PlvProgramsQuery | undefined, PlvProgramsQueryVariables>;
export function usePlvProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlvProgramsQuery, PlvProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlvProgramsQuery, PlvProgramsQueryVariables>(PlvProgramsDocument, options);
        }
export type PlvProgramsQueryHookResult = ReturnType<typeof usePlvProgramsQuery>;
export type PlvProgramsLazyQueryHookResult = ReturnType<typeof usePlvProgramsLazyQuery>;
export type PlvProgramsSuspenseQueryHookResult = ReturnType<typeof usePlvProgramsSuspenseQuery>;
export type PlvProgramsQueryResult = Apollo.QueryResult<PlvProgramsQuery, PlvProgramsQueryVariables>;
export const NavigateToAsinSearchProductIdDocument = gql`
    query NavigateToASINSearchProductID($marketplace: String!, $asin: String!) {
  productIdForDetailPage(marketplace: $marketplace, asin: $asin) {
    ...NavigateToASINSearchProductIDError
    productId
    error
    code
  }
}
    ${NavigateToAsinSearchProductIdErrorFragmentDoc}`;

/**
 * __useNavigateToAsinSearchProductIdQuery__
 *
 * To run a query within a React component, call `useNavigateToAsinSearchProductIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigateToAsinSearchProductIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigateToAsinSearchProductIdQuery({
 *   variables: {
 *      marketplace: // value for 'marketplace'
 *      asin: // value for 'asin'
 *   },
 * });
 */
export function useNavigateToAsinSearchProductIdQuery(baseOptions: Apollo.QueryHookOptions<NavigateToAsinSearchProductIdQuery, NavigateToAsinSearchProductIdQueryVariables> & ({ variables: NavigateToAsinSearchProductIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigateToAsinSearchProductIdQuery, NavigateToAsinSearchProductIdQueryVariables>(NavigateToAsinSearchProductIdDocument, options);
      }
export function useNavigateToAsinSearchProductIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigateToAsinSearchProductIdQuery, NavigateToAsinSearchProductIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigateToAsinSearchProductIdQuery, NavigateToAsinSearchProductIdQueryVariables>(NavigateToAsinSearchProductIdDocument, options);
        }
// @ts-ignore
export function useNavigateToAsinSearchProductIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NavigateToAsinSearchProductIdQuery, NavigateToAsinSearchProductIdQueryVariables>): Apollo.UseSuspenseQueryResult<NavigateToAsinSearchProductIdQuery, NavigateToAsinSearchProductIdQueryVariables>;
export function useNavigateToAsinSearchProductIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NavigateToAsinSearchProductIdQuery, NavigateToAsinSearchProductIdQueryVariables>): Apollo.UseSuspenseQueryResult<NavigateToAsinSearchProductIdQuery | undefined, NavigateToAsinSearchProductIdQueryVariables>;
export function useNavigateToAsinSearchProductIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NavigateToAsinSearchProductIdQuery, NavigateToAsinSearchProductIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NavigateToAsinSearchProductIdQuery, NavigateToAsinSearchProductIdQueryVariables>(NavigateToAsinSearchProductIdDocument, options);
        }
export type NavigateToAsinSearchProductIdQueryHookResult = ReturnType<typeof useNavigateToAsinSearchProductIdQuery>;
export type NavigateToAsinSearchProductIdLazyQueryHookResult = ReturnType<typeof useNavigateToAsinSearchProductIdLazyQuery>;
export type NavigateToAsinSearchProductIdSuspenseQueryHookResult = ReturnType<typeof useNavigateToAsinSearchProductIdSuspenseQuery>;
export type NavigateToAsinSearchProductIdQueryResult = Apollo.QueryResult<NavigateToAsinSearchProductIdQuery, NavigateToAsinSearchProductIdQueryVariables>;
export const NavigateToProgramSelectProgramsDocument = gql`
    query NavigateToProgramSelectPrograms($first: Int!, $filters: ProgramFilterInput, $after: String) {
  programs(first: $first, filters: $filters, after: $after) {
    edges {
      node {
        ...NavigateToProgramSelect
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${NavigateToProgramSelectFragmentDoc}`;

/**
 * __useNavigateToProgramSelectProgramsQuery__
 *
 * To run a query within a React component, call `useNavigateToProgramSelectProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigateToProgramSelectProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigateToProgramSelectProgramsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useNavigateToProgramSelectProgramsQuery(baseOptions: Apollo.QueryHookOptions<NavigateToProgramSelectProgramsQuery, NavigateToProgramSelectProgramsQueryVariables> & ({ variables: NavigateToProgramSelectProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigateToProgramSelectProgramsQuery, NavigateToProgramSelectProgramsQueryVariables>(NavigateToProgramSelectProgramsDocument, options);
      }
export function useNavigateToProgramSelectProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigateToProgramSelectProgramsQuery, NavigateToProgramSelectProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigateToProgramSelectProgramsQuery, NavigateToProgramSelectProgramsQueryVariables>(NavigateToProgramSelectProgramsDocument, options);
        }
// @ts-ignore
export function useNavigateToProgramSelectProgramsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NavigateToProgramSelectProgramsQuery, NavigateToProgramSelectProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<NavigateToProgramSelectProgramsQuery, NavigateToProgramSelectProgramsQueryVariables>;
export function useNavigateToProgramSelectProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NavigateToProgramSelectProgramsQuery, NavigateToProgramSelectProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<NavigateToProgramSelectProgramsQuery | undefined, NavigateToProgramSelectProgramsQueryVariables>;
export function useNavigateToProgramSelectProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NavigateToProgramSelectProgramsQuery, NavigateToProgramSelectProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NavigateToProgramSelectProgramsQuery, NavigateToProgramSelectProgramsQueryVariables>(NavigateToProgramSelectProgramsDocument, options);
        }
export type NavigateToProgramSelectProgramsQueryHookResult = ReturnType<typeof useNavigateToProgramSelectProgramsQuery>;
export type NavigateToProgramSelectProgramsLazyQueryHookResult = ReturnType<typeof useNavigateToProgramSelectProgramsLazyQuery>;
export type NavigateToProgramSelectProgramsSuspenseQueryHookResult = ReturnType<typeof useNavigateToProgramSelectProgramsSuspenseQuery>;
export type NavigateToProgramSelectProgramsQueryResult = Apollo.QueryResult<NavigateToProgramSelectProgramsQuery, NavigateToProgramSelectProgramsQueryVariables>;
export const ProductIdForDetailPageDocument = gql`
    query ProductIdForDetailPage($marketplace: String!, $asin: String!) {
  productIdForDetailPage(marketplace: $marketplace, asin: $asin) {
    detail
    error
    productId
    code
  }
}
    `;

/**
 * __useProductIdForDetailPageQuery__
 *
 * To run a query within a React component, call `useProductIdForDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductIdForDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductIdForDetailPageQuery({
 *   variables: {
 *      marketplace: // value for 'marketplace'
 *      asin: // value for 'asin'
 *   },
 * });
 */
export function useProductIdForDetailPageQuery(baseOptions: Apollo.QueryHookOptions<ProductIdForDetailPageQuery, ProductIdForDetailPageQueryVariables> & ({ variables: ProductIdForDetailPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductIdForDetailPageQuery, ProductIdForDetailPageQueryVariables>(ProductIdForDetailPageDocument, options);
      }
export function useProductIdForDetailPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductIdForDetailPageQuery, ProductIdForDetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductIdForDetailPageQuery, ProductIdForDetailPageQueryVariables>(ProductIdForDetailPageDocument, options);
        }
// @ts-ignore
export function useProductIdForDetailPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductIdForDetailPageQuery, ProductIdForDetailPageQueryVariables>): Apollo.UseSuspenseQueryResult<ProductIdForDetailPageQuery, ProductIdForDetailPageQueryVariables>;
export function useProductIdForDetailPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductIdForDetailPageQuery, ProductIdForDetailPageQueryVariables>): Apollo.UseSuspenseQueryResult<ProductIdForDetailPageQuery | undefined, ProductIdForDetailPageQueryVariables>;
export function useProductIdForDetailPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductIdForDetailPageQuery, ProductIdForDetailPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductIdForDetailPageQuery, ProductIdForDetailPageQueryVariables>(ProductIdForDetailPageDocument, options);
        }
export type ProductIdForDetailPageQueryHookResult = ReturnType<typeof useProductIdForDetailPageQuery>;
export type ProductIdForDetailPageLazyQueryHookResult = ReturnType<typeof useProductIdForDetailPageLazyQuery>;
export type ProductIdForDetailPageSuspenseQueryHookResult = ReturnType<typeof useProductIdForDetailPageSuspenseQuery>;
export type ProductIdForDetailPageQueryResult = Apollo.QueryResult<ProductIdForDetailPageQuery, ProductIdForDetailPageQueryVariables>;
export const UserDocument = gql`
    query User {
  user @client {
    alias
    email
    groups
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
// @ts-ignore
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery | undefined, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const ImportTrafficEventDocument = gql`
    mutation ImportTrafficEvent($input: ImportTrafficEventInput!) {
  importTrafficEvent(input: $input) {
    project {
      id
      ...TPEvent
    }
  }
}
    ${TpEventFragmentDoc}`;
export type ImportTrafficEventMutationFn = Apollo.MutationFunction<ImportTrafficEventMutation, ImportTrafficEventMutationVariables>;

/**
 * __useImportTrafficEventMutation__
 *
 * To run a mutation, you first call `useImportTrafficEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportTrafficEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importTrafficEventMutation, { data, loading, error }] = useImportTrafficEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportTrafficEventMutation(baseOptions?: Apollo.MutationHookOptions<ImportTrafficEventMutation, ImportTrafficEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportTrafficEventMutation, ImportTrafficEventMutationVariables>(ImportTrafficEventDocument, options);
      }
export type ImportTrafficEventMutationHookResult = ReturnType<typeof useImportTrafficEventMutation>;
export type ImportTrafficEventMutationResult = Apollo.MutationResult<ImportTrafficEventMutation>;
export type ImportTrafficEventMutationOptions = Apollo.BaseMutationOptions<ImportTrafficEventMutation, ImportTrafficEventMutationVariables>;
export const CloneJagDocument = gql`
    mutation CloneJAG($sourceJagId: ID!, $name: String!) {
  cloneJAG(sourceJagId: $sourceJagId, name: $name) {
    id
    name
  }
}
    `;
export type CloneJagMutationFn = Apollo.MutationFunction<CloneJagMutation, CloneJagMutationVariables>;

/**
 * __useCloneJagMutation__
 *
 * To run a mutation, you first call `useCloneJagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneJagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneJagMutation, { data, loading, error }] = useCloneJagMutation({
 *   variables: {
 *      sourceJagId: // value for 'sourceJagId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCloneJagMutation(baseOptions?: Apollo.MutationHookOptions<CloneJagMutation, CloneJagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneJagMutation, CloneJagMutationVariables>(CloneJagDocument, options);
      }
export type CloneJagMutationHookResult = ReturnType<typeof useCloneJagMutation>;
export type CloneJagMutationResult = Apollo.MutationResult<CloneJagMutation>;
export type CloneJagMutationOptions = Apollo.BaseMutationOptions<CloneJagMutation, CloneJagMutationVariables>;
export const PasteJaGsDocument = gql`
    mutation PasteJAGs($input: PasteJAGsInput!) {
  pasteJAGs(input: $input) {
    assetGroups {
      id
      name
    }
  }
}
    `;
export type PasteJaGsMutationFn = Apollo.MutationFunction<PasteJaGsMutation, PasteJaGsMutationVariables>;

/**
 * __usePasteJaGsMutation__
 *
 * To run a mutation, you first call `usePasteJaGsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasteJaGsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pasteJaGsMutation, { data, loading, error }] = usePasteJaGsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasteJaGsMutation(baseOptions?: Apollo.MutationHookOptions<PasteJaGsMutation, PasteJaGsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasteJaGsMutation, PasteJaGsMutationVariables>(PasteJaGsDocument, options);
      }
export type PasteJaGsMutationHookResult = ReturnType<typeof usePasteJaGsMutation>;
export type PasteJaGsMutationResult = Apollo.MutationResult<PasteJaGsMutation>;
export type PasteJaGsMutationOptions = Apollo.BaseMutationOptions<PasteJaGsMutation, PasteJaGsMutationVariables>;
export const CloneJaGsDocument = gql`
    mutation CloneJAGs($sourceJagIds: [ID!]!, $namePrefix: String) {
  cloneJAGs(sourceJagIds: $sourceJagIds, namePrefix: $namePrefix) {
    assetGroups {
      id
      name
    }
  }
}
    `;
export type CloneJaGsMutationFn = Apollo.MutationFunction<CloneJaGsMutation, CloneJaGsMutationVariables>;

/**
 * __useCloneJaGsMutation__
 *
 * To run a mutation, you first call `useCloneJaGsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneJaGsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneJaGsMutation, { data, loading, error }] = useCloneJaGsMutation({
 *   variables: {
 *      sourceJagIds: // value for 'sourceJagIds'
 *      namePrefix: // value for 'namePrefix'
 *   },
 * });
 */
export function useCloneJaGsMutation(baseOptions?: Apollo.MutationHookOptions<CloneJaGsMutation, CloneJaGsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneJaGsMutation, CloneJaGsMutationVariables>(CloneJaGsDocument, options);
      }
export type CloneJaGsMutationHookResult = ReturnType<typeof useCloneJaGsMutation>;
export type CloneJaGsMutationResult = Apollo.MutationResult<CloneJaGsMutation>;
export type CloneJaGsMutationOptions = Apollo.BaseMutationOptions<CloneJaGsMutation, CloneJaGsMutationVariables>;
export const GetJagsDocument = gql`
    query getJags($filters: JAGFilterInput!, $baseFilters: JAGFilterBaseInput!, $first: Int!, $after: String) {
  JAGs(filters: $filters, first: $first, after: $after) {
    jagFilterOptionValues(filters: $baseFilters) {
      hasQaComment
      locale
      qaStatus
    }
    nodes {
      ...JagListView
    }
    totalCount
  }
}
    ${JagListViewFragmentDoc}`;

/**
 * __useGetJagsQuery__
 *
 * To run a query within a React component, call `useGetJagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJagsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      baseFilters: // value for 'baseFilters'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetJagsQuery(baseOptions: Apollo.QueryHookOptions<GetJagsQuery, GetJagsQueryVariables> & ({ variables: GetJagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJagsQuery, GetJagsQueryVariables>(GetJagsDocument, options);
      }
export function useGetJagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJagsQuery, GetJagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJagsQuery, GetJagsQueryVariables>(GetJagsDocument, options);
        }
// @ts-ignore
export function useGetJagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJagsQuery, GetJagsQueryVariables>): Apollo.UseSuspenseQueryResult<GetJagsQuery, GetJagsQueryVariables>;
export function useGetJagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJagsQuery, GetJagsQueryVariables>): Apollo.UseSuspenseQueryResult<GetJagsQuery | undefined, GetJagsQueryVariables>;
export function useGetJagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJagsQuery, GetJagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJagsQuery, GetJagsQueryVariables>(GetJagsDocument, options);
        }
export type GetJagsQueryHookResult = ReturnType<typeof useGetJagsQuery>;
export type GetJagsLazyQueryHookResult = ReturnType<typeof useGetJagsLazyQuery>;
export type GetJagsSuspenseQueryHookResult = ReturnType<typeof useGetJagsSuspenseQuery>;
export type GetJagsQueryResult = Apollo.QueryResult<GetJagsQuery, GetJagsQueryVariables>;
export const CloneTrafficProjectDocument = gql`
    mutation cloneTrafficProject($input: CloneTrafficProjectInput!) {
  cloneTrafficProject(input: $input) {
    project {
      id
    }
  }
}
    `;
export type CloneTrafficProjectMutationFn = Apollo.MutationFunction<CloneTrafficProjectMutation, CloneTrafficProjectMutationVariables>;

/**
 * __useCloneTrafficProjectMutation__
 *
 * To run a mutation, you first call `useCloneTrafficProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneTrafficProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneTrafficProjectMutation, { data, loading, error }] = useCloneTrafficProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneTrafficProjectMutation(baseOptions?: Apollo.MutationHookOptions<CloneTrafficProjectMutation, CloneTrafficProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneTrafficProjectMutation, CloneTrafficProjectMutationVariables>(CloneTrafficProjectDocument, options);
      }
export type CloneTrafficProjectMutationHookResult = ReturnType<typeof useCloneTrafficProjectMutation>;
export type CloneTrafficProjectMutationResult = Apollo.MutationResult<CloneTrafficProjectMutation>;
export type CloneTrafficProjectMutationOptions = Apollo.BaseMutationOptions<CloneTrafficProjectMutation, CloneTrafficProjectMutationVariables>;
export const TpPageTopBarDocument = gql`
    query TPPageTopBar($id: ID!) {
  trafficProject(id: $id) {
    ...Project
    ...TPShareModalProjectData
  }
}
    ${ProjectFragmentDoc}
${TpShareModalProjectDataFragmentDoc}`;

/**
 * __useTpPageTopBarQuery__
 *
 * To run a query within a React component, call `useTpPageTopBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useTpPageTopBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTpPageTopBarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTpPageTopBarQuery(baseOptions: Apollo.QueryHookOptions<TpPageTopBarQuery, TpPageTopBarQueryVariables> & ({ variables: TpPageTopBarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TpPageTopBarQuery, TpPageTopBarQueryVariables>(TpPageTopBarDocument, options);
      }
export function useTpPageTopBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TpPageTopBarQuery, TpPageTopBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TpPageTopBarQuery, TpPageTopBarQueryVariables>(TpPageTopBarDocument, options);
        }
// @ts-ignore
export function useTpPageTopBarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TpPageTopBarQuery, TpPageTopBarQueryVariables>): Apollo.UseSuspenseQueryResult<TpPageTopBarQuery, TpPageTopBarQueryVariables>;
export function useTpPageTopBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TpPageTopBarQuery, TpPageTopBarQueryVariables>): Apollo.UseSuspenseQueryResult<TpPageTopBarQuery | undefined, TpPageTopBarQueryVariables>;
export function useTpPageTopBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TpPageTopBarQuery, TpPageTopBarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TpPageTopBarQuery, TpPageTopBarQueryVariables>(TpPageTopBarDocument, options);
        }
export type TpPageTopBarQueryHookResult = ReturnType<typeof useTpPageTopBarQuery>;
export type TpPageTopBarLazyQueryHookResult = ReturnType<typeof useTpPageTopBarLazyQuery>;
export type TpPageTopBarSuspenseQueryHookResult = ReturnType<typeof useTpPageTopBarSuspenseQuery>;
export type TpPageTopBarQueryResult = Apollo.QueryResult<TpPageTopBarQuery, TpPageTopBarQueryVariables>;
export const RenameTrafficProjectDocument = gql`
    mutation RenameTrafficProject($id: ID!, $name: String!) {
  renameTrafficProject(id: $id, name: $name) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;
export type RenameTrafficProjectMutationFn = Apollo.MutationFunction<RenameTrafficProjectMutation, RenameTrafficProjectMutationVariables>;

/**
 * __useRenameTrafficProjectMutation__
 *
 * To run a mutation, you first call `useRenameTrafficProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameTrafficProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameTrafficProjectMutation, { data, loading, error }] = useRenameTrafficProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameTrafficProjectMutation(baseOptions?: Apollo.MutationHookOptions<RenameTrafficProjectMutation, RenameTrafficProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameTrafficProjectMutation, RenameTrafficProjectMutationVariables>(RenameTrafficProjectDocument, options);
      }
export type RenameTrafficProjectMutationHookResult = ReturnType<typeof useRenameTrafficProjectMutation>;
export type RenameTrafficProjectMutationResult = Apollo.MutationResult<RenameTrafficProjectMutation>;
export type RenameTrafficProjectMutationOptions = Apollo.BaseMutationOptions<RenameTrafficProjectMutation, RenameTrafficProjectMutationVariables>;
export const ProjectPermissionsDocument = gql`
    query ProjectPermissions($trafficProjectId: ID!) {
  trafficProject(id: $trafficProjectId) {
    ...TPShareModalData
  }
}
    ${TpShareModalDataFragmentDoc}`;

/**
 * __useProjectPermissionsQuery__
 *
 * To run a query within a React component, call `useProjectPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPermissionsQuery({
 *   variables: {
 *      trafficProjectId: // value for 'trafficProjectId'
 *   },
 * });
 */
export function useProjectPermissionsQuery(baseOptions: Apollo.QueryHookOptions<ProjectPermissionsQuery, ProjectPermissionsQueryVariables> & ({ variables: ProjectPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectPermissionsQuery, ProjectPermissionsQueryVariables>(ProjectPermissionsDocument, options);
      }
export function useProjectPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectPermissionsQuery, ProjectPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectPermissionsQuery, ProjectPermissionsQueryVariables>(ProjectPermissionsDocument, options);
        }
// @ts-ignore
export function useProjectPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectPermissionsQuery, ProjectPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectPermissionsQuery, ProjectPermissionsQueryVariables>;
export function useProjectPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectPermissionsQuery, ProjectPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectPermissionsQuery | undefined, ProjectPermissionsQueryVariables>;
export function useProjectPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectPermissionsQuery, ProjectPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectPermissionsQuery, ProjectPermissionsQueryVariables>(ProjectPermissionsDocument, options);
        }
export type ProjectPermissionsQueryHookResult = ReturnType<typeof useProjectPermissionsQuery>;
export type ProjectPermissionsLazyQueryHookResult = ReturnType<typeof useProjectPermissionsLazyQuery>;
export type ProjectPermissionsSuspenseQueryHookResult = ReturnType<typeof useProjectPermissionsSuspenseQuery>;
export type ProjectPermissionsQueryResult = Apollo.QueryResult<ProjectPermissionsQuery, ProjectPermissionsQueryVariables>;
export const UpdateTrafficProjectPermissionsDocument = gql`
    mutation UpdateTrafficProjectPermissions($shareTrafficProjectId: ID!, $groups: [String!]!, $people: [TrafficProjectUserInput!]!) {
  shareTrafficProject(
    id: $shareTrafficProjectId
    groups: $groups
    people: $people
  ) {
    ...TPShareModalData
  }
}
    ${TpShareModalDataFragmentDoc}`;
export type UpdateTrafficProjectPermissionsMutationFn = Apollo.MutationFunction<UpdateTrafficProjectPermissionsMutation, UpdateTrafficProjectPermissionsMutationVariables>;

/**
 * __useUpdateTrafficProjectPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateTrafficProjectPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrafficProjectPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrafficProjectPermissionsMutation, { data, loading, error }] = useUpdateTrafficProjectPermissionsMutation({
 *   variables: {
 *      shareTrafficProjectId: // value for 'shareTrafficProjectId'
 *      groups: // value for 'groups'
 *      people: // value for 'people'
 *   },
 * });
 */
export function useUpdateTrafficProjectPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrafficProjectPermissionsMutation, UpdateTrafficProjectPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrafficProjectPermissionsMutation, UpdateTrafficProjectPermissionsMutationVariables>(UpdateTrafficProjectPermissionsDocument, options);
      }
export type UpdateTrafficProjectPermissionsMutationHookResult = ReturnType<typeof useUpdateTrafficProjectPermissionsMutation>;
export type UpdateTrafficProjectPermissionsMutationResult = Apollo.MutationResult<UpdateTrafficProjectPermissionsMutation>;
export type UpdateTrafficProjectPermissionsMutationOptions = Apollo.BaseMutationOptions<UpdateTrafficProjectPermissionsMutation, UpdateTrafficProjectPermissionsMutationVariables>;
export const PapiSearchDocument = gql`
    query PAPISearch($query: String!) {
  getPapiUsers(query: $query) {
    ...PAPISearchFieldPAPIUser
  }
}
    ${PapiSearchFieldPapiUserFragmentDoc}`;

/**
 * __usePapiSearchQuery__
 *
 * To run a query within a React component, call `usePapiSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePapiSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePapiSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePapiSearchQuery(baseOptions: Apollo.QueryHookOptions<PapiSearchQuery, PapiSearchQueryVariables> & ({ variables: PapiSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiSearchQuery, PapiSearchQueryVariables>(PapiSearchDocument, options);
      }
export function usePapiSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiSearchQuery, PapiSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiSearchQuery, PapiSearchQueryVariables>(PapiSearchDocument, options);
        }
// @ts-ignore
export function usePapiSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PapiSearchQuery, PapiSearchQueryVariables>): Apollo.UseSuspenseQueryResult<PapiSearchQuery, PapiSearchQueryVariables>;
export function usePapiSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PapiSearchQuery, PapiSearchQueryVariables>): Apollo.UseSuspenseQueryResult<PapiSearchQuery | undefined, PapiSearchQueryVariables>;
export function usePapiSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PapiSearchQuery, PapiSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PapiSearchQuery, PapiSearchQueryVariables>(PapiSearchDocument, options);
        }
export type PapiSearchQueryHookResult = ReturnType<typeof usePapiSearchQuery>;
export type PapiSearchLazyQueryHookResult = ReturnType<typeof usePapiSearchLazyQuery>;
export type PapiSearchSuspenseQueryHookResult = ReturnType<typeof usePapiSearchSuspenseQuery>;
export type PapiSearchQueryResult = Apollo.QueryResult<PapiSearchQuery, PapiSearchQueryVariables>;
export const TrafficProjectDocument = gql`
    query TrafficProject($id: ID!) {
  trafficProject(id: $id) {
    id
    name
    ...TPEvent
  }
}
    ${TpEventFragmentDoc}`;

/**
 * __useTrafficProjectQuery__
 *
 * To run a query within a React component, call `useTrafficProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrafficProjectQuery(baseOptions: Apollo.QueryHookOptions<TrafficProjectQuery, TrafficProjectQueryVariables> & ({ variables: TrafficProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficProjectQuery, TrafficProjectQueryVariables>(TrafficProjectDocument, options);
      }
export function useTrafficProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficProjectQuery, TrafficProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficProjectQuery, TrafficProjectQueryVariables>(TrafficProjectDocument, options);
        }
// @ts-ignore
export function useTrafficProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrafficProjectQuery, TrafficProjectQueryVariables>): Apollo.UseSuspenseQueryResult<TrafficProjectQuery, TrafficProjectQueryVariables>;
export function useTrafficProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrafficProjectQuery, TrafficProjectQueryVariables>): Apollo.UseSuspenseQueryResult<TrafficProjectQuery | undefined, TrafficProjectQueryVariables>;
export function useTrafficProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrafficProjectQuery, TrafficProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrafficProjectQuery, TrafficProjectQueryVariables>(TrafficProjectDocument, options);
        }
export type TrafficProjectQueryHookResult = ReturnType<typeof useTrafficProjectQuery>;
export type TrafficProjectLazyQueryHookResult = ReturnType<typeof useTrafficProjectLazyQuery>;
export type TrafficProjectSuspenseQueryHookResult = ReturnType<typeof useTrafficProjectSuspenseQuery>;
export type TrafficProjectQueryResult = Apollo.QueryResult<TrafficProjectQuery, TrafficProjectQueryVariables>;
export const CreateTrafficProjectDocument = gql`
    mutation CreateTrafficProject($name: String!, $buildEvent: Boolean) {
  createTrafficProject(name: $name, buildEvent: $buildEvent) {
    id
  }
}
    `;
export type CreateTrafficProjectMutationFn = Apollo.MutationFunction<CreateTrafficProjectMutation, CreateTrafficProjectMutationVariables>;

/**
 * __useCreateTrafficProjectMutation__
 *
 * To run a mutation, you first call `useCreateTrafficProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrafficProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrafficProjectMutation, { data, loading, error }] = useCreateTrafficProjectMutation({
 *   variables: {
 *      name: // value for 'name'
 *      buildEvent: // value for 'buildEvent'
 *   },
 * });
 */
export function useCreateTrafficProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrafficProjectMutation, CreateTrafficProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrafficProjectMutation, CreateTrafficProjectMutationVariables>(CreateTrafficProjectDocument, options);
      }
export type CreateTrafficProjectMutationHookResult = ReturnType<typeof useCreateTrafficProjectMutation>;
export type CreateTrafficProjectMutationResult = Apollo.MutationResult<CreateTrafficProjectMutation>;
export type CreateTrafficProjectMutationOptions = Apollo.BaseMutationOptions<CreateTrafficProjectMutation, CreateTrafficProjectMutationVariables>;
export const TrafficProjectsListSearchDocument = gql`
    query TrafficProjectsListSearch($searchType: TrafficProjectSearchType!, $first: Int!, $after: String, $query: String, $sort: [TrafficProjectSearchSortInput!]!, $filter: TrafficProjectSearchFilterInput!) {
  sharedFilterOptions: trafficProjectSearch(searchType: SHARED_SEARCH, first: 1) {
    ...ProjectsTableToolbar
  }
  trafficProjectSearch(
    searchType: $searchType
    first: $first
    after: $after
    query: $query
    sort: $sort
    filter: $filter
  ) {
    totalCount
    edges {
      node {
        ...trafficProjectsTableData
      }
    }
  }
}
    ${ProjectsTableToolbarFragmentDoc}
${TrafficProjectsTableDataFragmentDoc}`;

/**
 * __useTrafficProjectsListSearchQuery__
 *
 * To run a query within a React component, call `useTrafficProjectsListSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficProjectsListSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficProjectsListSearchQuery({
 *   variables: {
 *      searchType: // value for 'searchType'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTrafficProjectsListSearchQuery(baseOptions: Apollo.QueryHookOptions<TrafficProjectsListSearchQuery, TrafficProjectsListSearchQueryVariables> & ({ variables: TrafficProjectsListSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficProjectsListSearchQuery, TrafficProjectsListSearchQueryVariables>(TrafficProjectsListSearchDocument, options);
      }
export function useTrafficProjectsListSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficProjectsListSearchQuery, TrafficProjectsListSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficProjectsListSearchQuery, TrafficProjectsListSearchQueryVariables>(TrafficProjectsListSearchDocument, options);
        }
// @ts-ignore
export function useTrafficProjectsListSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrafficProjectsListSearchQuery, TrafficProjectsListSearchQueryVariables>): Apollo.UseSuspenseQueryResult<TrafficProjectsListSearchQuery, TrafficProjectsListSearchQueryVariables>;
export function useTrafficProjectsListSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrafficProjectsListSearchQuery, TrafficProjectsListSearchQueryVariables>): Apollo.UseSuspenseQueryResult<TrafficProjectsListSearchQuery | undefined, TrafficProjectsListSearchQueryVariables>;
export function useTrafficProjectsListSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrafficProjectsListSearchQuery, TrafficProjectsListSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrafficProjectsListSearchQuery, TrafficProjectsListSearchQueryVariables>(TrafficProjectsListSearchDocument, options);
        }
export type TrafficProjectsListSearchQueryHookResult = ReturnType<typeof useTrafficProjectsListSearchQuery>;
export type TrafficProjectsListSearchLazyQueryHookResult = ReturnType<typeof useTrafficProjectsListSearchLazyQuery>;
export type TrafficProjectsListSearchSuspenseQueryHookResult = ReturnType<typeof useTrafficProjectsListSearchSuspenseQuery>;
export type TrafficProjectsListSearchQueryResult = Apollo.QueryResult<TrafficProjectsListSearchQuery, TrafficProjectsListSearchQueryVariables>;
export const SuspendTrafficCampaignPlacementsDocument = gql`
    mutation suspendTrafficCampaignPlacements($input: TrafficPlacementStateTransitionInput!) {
  suspendTrafficCampaignPlacements(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type SuspendTrafficCampaignPlacementsMutationFn = Apollo.MutationFunction<SuspendTrafficCampaignPlacementsMutation, SuspendTrafficCampaignPlacementsMutationVariables>;

/**
 * __useSuspendTrafficCampaignPlacementsMutation__
 *
 * To run a mutation, you first call `useSuspendTrafficCampaignPlacementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendTrafficCampaignPlacementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendTrafficCampaignPlacementsMutation, { data, loading, error }] = useSuspendTrafficCampaignPlacementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuspendTrafficCampaignPlacementsMutation(baseOptions?: Apollo.MutationHookOptions<SuspendTrafficCampaignPlacementsMutation, SuspendTrafficCampaignPlacementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendTrafficCampaignPlacementsMutation, SuspendTrafficCampaignPlacementsMutationVariables>(SuspendTrafficCampaignPlacementsDocument, options);
      }
export type SuspendTrafficCampaignPlacementsMutationHookResult = ReturnType<typeof useSuspendTrafficCampaignPlacementsMutation>;
export type SuspendTrafficCampaignPlacementsMutationResult = Apollo.MutationResult<SuspendTrafficCampaignPlacementsMutation>;
export type SuspendTrafficCampaignPlacementsMutationOptions = Apollo.BaseMutationOptions<SuspendTrafficCampaignPlacementsMutation, SuspendTrafficCampaignPlacementsMutationVariables>;
export const PublishTpAssetsDocument = gql`
    mutation publishTPAssets($input: [PublishCampaignAssetInput!]!) {
  bulkPublishCampaignAssets(input: $input) {
    success
    message
    succeeded {
      ...publishedAssetResult
    }
  }
}
    ${PublishedAssetResultFragmentDoc}`;
export type PublishTpAssetsMutationFn = Apollo.MutationFunction<PublishTpAssetsMutation, PublishTpAssetsMutationVariables>;

/**
 * __usePublishTpAssetsMutation__
 *
 * To run a mutation, you first call `usePublishTpAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishTpAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishTpAssetsMutation, { data, loading, error }] = usePublishTpAssetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishTpAssetsMutation(baseOptions?: Apollo.MutationHookOptions<PublishTpAssetsMutation, PublishTpAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishTpAssetsMutation, PublishTpAssetsMutationVariables>(PublishTpAssetsDocument, options);
      }
export type PublishTpAssetsMutationHookResult = ReturnType<typeof usePublishTpAssetsMutation>;
export type PublishTpAssetsMutationResult = Apollo.MutationResult<PublishTpAssetsMutation>;
export type PublishTpAssetsMutationOptions = Apollo.BaseMutationOptions<PublishTpAssetsMutation, PublishTpAssetsMutationVariables>;
export const TrafficProjectCampaignPageDocument = gql`
    query TrafficProjectCampaignPage($projectId: ID!, $campaignId: ID!) {
  trafficCampaign(id: $campaignId, projectId: $projectId) {
    ...TrafficCampaignPage
    project {
      ...TPEvent
    }
  }
}
    ${TrafficCampaignPageFragmentDoc}
${TpEventFragmentDoc}`;

/**
 * __useTrafficProjectCampaignPageQuery__
 *
 * To run a query within a React component, call `useTrafficProjectCampaignPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficProjectCampaignPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficProjectCampaignPageQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useTrafficProjectCampaignPageQuery(baseOptions: Apollo.QueryHookOptions<TrafficProjectCampaignPageQuery, TrafficProjectCampaignPageQueryVariables> & ({ variables: TrafficProjectCampaignPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficProjectCampaignPageQuery, TrafficProjectCampaignPageQueryVariables>(TrafficProjectCampaignPageDocument, options);
      }
export function useTrafficProjectCampaignPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficProjectCampaignPageQuery, TrafficProjectCampaignPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficProjectCampaignPageQuery, TrafficProjectCampaignPageQueryVariables>(TrafficProjectCampaignPageDocument, options);
        }
// @ts-ignore
export function useTrafficProjectCampaignPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrafficProjectCampaignPageQuery, TrafficProjectCampaignPageQueryVariables>): Apollo.UseSuspenseQueryResult<TrafficProjectCampaignPageQuery, TrafficProjectCampaignPageQueryVariables>;
export function useTrafficProjectCampaignPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrafficProjectCampaignPageQuery, TrafficProjectCampaignPageQueryVariables>): Apollo.UseSuspenseQueryResult<TrafficProjectCampaignPageQuery | undefined, TrafficProjectCampaignPageQueryVariables>;
export function useTrafficProjectCampaignPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrafficProjectCampaignPageQuery, TrafficProjectCampaignPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrafficProjectCampaignPageQuery, TrafficProjectCampaignPageQueryVariables>(TrafficProjectCampaignPageDocument, options);
        }
export type TrafficProjectCampaignPageQueryHookResult = ReturnType<typeof useTrafficProjectCampaignPageQuery>;
export type TrafficProjectCampaignPageLazyQueryHookResult = ReturnType<typeof useTrafficProjectCampaignPageLazyQuery>;
export type TrafficProjectCampaignPageSuspenseQueryHookResult = ReturnType<typeof useTrafficProjectCampaignPageSuspenseQuery>;
export type TrafficProjectCampaignPageQueryResult = Apollo.QueryResult<TrafficProjectCampaignPageQuery, TrafficProjectCampaignPageQueryVariables>;
export const TrafficProjectNewCampaignPageDocument = gql`
    query TrafficProjectNewCampaignPage($id: ID!, $campaignType: ID!) {
  trafficProject(id: $id) {
    id
    name
    ...TPEvent
  }
  campaignConfigurations(first: 1, ids: [$campaignType]) {
    nodes {
      ...CampaignConfigProviderCampaign
    }
  }
}
    ${TpEventFragmentDoc}
${CampaignConfigProviderCampaignFragmentDoc}`;

/**
 * __useTrafficProjectNewCampaignPageQuery__
 *
 * To run a query within a React component, call `useTrafficProjectNewCampaignPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficProjectNewCampaignPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficProjectNewCampaignPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      campaignType: // value for 'campaignType'
 *   },
 * });
 */
export function useTrafficProjectNewCampaignPageQuery(baseOptions: Apollo.QueryHookOptions<TrafficProjectNewCampaignPageQuery, TrafficProjectNewCampaignPageQueryVariables> & ({ variables: TrafficProjectNewCampaignPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficProjectNewCampaignPageQuery, TrafficProjectNewCampaignPageQueryVariables>(TrafficProjectNewCampaignPageDocument, options);
      }
export function useTrafficProjectNewCampaignPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficProjectNewCampaignPageQuery, TrafficProjectNewCampaignPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficProjectNewCampaignPageQuery, TrafficProjectNewCampaignPageQueryVariables>(TrafficProjectNewCampaignPageDocument, options);
        }
// @ts-ignore
export function useTrafficProjectNewCampaignPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrafficProjectNewCampaignPageQuery, TrafficProjectNewCampaignPageQueryVariables>): Apollo.UseSuspenseQueryResult<TrafficProjectNewCampaignPageQuery, TrafficProjectNewCampaignPageQueryVariables>;
export function useTrafficProjectNewCampaignPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrafficProjectNewCampaignPageQuery, TrafficProjectNewCampaignPageQueryVariables>): Apollo.UseSuspenseQueryResult<TrafficProjectNewCampaignPageQuery | undefined, TrafficProjectNewCampaignPageQueryVariables>;
export function useTrafficProjectNewCampaignPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrafficProjectNewCampaignPageQuery, TrafficProjectNewCampaignPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrafficProjectNewCampaignPageQuery, TrafficProjectNewCampaignPageQueryVariables>(TrafficProjectNewCampaignPageDocument, options);
        }
export type TrafficProjectNewCampaignPageQueryHookResult = ReturnType<typeof useTrafficProjectNewCampaignPageQuery>;
export type TrafficProjectNewCampaignPageLazyQueryHookResult = ReturnType<typeof useTrafficProjectNewCampaignPageLazyQuery>;
export type TrafficProjectNewCampaignPageSuspenseQueryHookResult = ReturnType<typeof useTrafficProjectNewCampaignPageSuspenseQuery>;
export type TrafficProjectNewCampaignPageQueryResult = Apollo.QueryResult<TrafficProjectNewCampaignPageQuery, TrafficProjectNewCampaignPageQueryVariables>;
export const ApproveTrafficCampaignFlavorDocument = gql`
    mutation approveTrafficCampaignFlavor($input: TrafficFlavorApprovalStateTransitionInput!) {
  approveTrafficCampaignFlavor(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type ApproveTrafficCampaignFlavorMutationFn = Apollo.MutationFunction<ApproveTrafficCampaignFlavorMutation, ApproveTrafficCampaignFlavorMutationVariables>;

/**
 * __useApproveTrafficCampaignFlavorMutation__
 *
 * To run a mutation, you first call `useApproveTrafficCampaignFlavorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTrafficCampaignFlavorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTrafficCampaignFlavorMutation, { data, loading, error }] = useApproveTrafficCampaignFlavorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveTrafficCampaignFlavorMutation(baseOptions?: Apollo.MutationHookOptions<ApproveTrafficCampaignFlavorMutation, ApproveTrafficCampaignFlavorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveTrafficCampaignFlavorMutation, ApproveTrafficCampaignFlavorMutationVariables>(ApproveTrafficCampaignFlavorDocument, options);
      }
export type ApproveTrafficCampaignFlavorMutationHookResult = ReturnType<typeof useApproveTrafficCampaignFlavorMutation>;
export type ApproveTrafficCampaignFlavorMutationResult = Apollo.MutationResult<ApproveTrafficCampaignFlavorMutation>;
export type ApproveTrafficCampaignFlavorMutationOptions = Apollo.BaseMutationOptions<ApproveTrafficCampaignFlavorMutation, ApproveTrafficCampaignFlavorMutationVariables>;
export const ApproveTrafficCampaignFlavorsDocument = gql`
    mutation approveTrafficCampaignFlavors($input: TransitionTrafficCampaignFlavorsInput!) {
  transitionTrafficCampaignFlavors(input: $input) {
    ...useIsCampaignLocked
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${UseIsCampaignLockedFragmentDoc}
${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type ApproveTrafficCampaignFlavorsMutationFn = Apollo.MutationFunction<ApproveTrafficCampaignFlavorsMutation, ApproveTrafficCampaignFlavorsMutationVariables>;

/**
 * __useApproveTrafficCampaignFlavorsMutation__
 *
 * To run a mutation, you first call `useApproveTrafficCampaignFlavorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTrafficCampaignFlavorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTrafficCampaignFlavorsMutation, { data, loading, error }] = useApproveTrafficCampaignFlavorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveTrafficCampaignFlavorsMutation(baseOptions?: Apollo.MutationHookOptions<ApproveTrafficCampaignFlavorsMutation, ApproveTrafficCampaignFlavorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveTrafficCampaignFlavorsMutation, ApproveTrafficCampaignFlavorsMutationVariables>(ApproveTrafficCampaignFlavorsDocument, options);
      }
export type ApproveTrafficCampaignFlavorsMutationHookResult = ReturnType<typeof useApproveTrafficCampaignFlavorsMutation>;
export type ApproveTrafficCampaignFlavorsMutationResult = Apollo.MutationResult<ApproveTrafficCampaignFlavorsMutation>;
export type ApproveTrafficCampaignFlavorsMutationOptions = Apollo.BaseMutationOptions<ApproveTrafficCampaignFlavorsMutation, ApproveTrafficCampaignFlavorsMutationVariables>;
export const ConversationsDocument = gql`
    query Conversations($correlationId: String!, $first: Int!, $ids: [ID!]) {
  conversations(correlationId: $correlationId, first: $first, ids: $ids) {
    edges {
      cursor
      node {
        ... on ChatConversationReady {
          id
          correlationId
          messages {
            content
            role
            timestamp
          }
        }
        ... on ChatConversationPending {
          id
          correlationId
          messages {
            content
            role
            timestamp
          }
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useConversationsQuery__
 *
 * To run a query within a React component, call `useConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationsQuery({
 *   variables: {
 *      correlationId: // value for 'correlationId'
 *      first: // value for 'first'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useConversationsQuery(baseOptions: Apollo.QueryHookOptions<ConversationsQuery, ConversationsQueryVariables> & ({ variables: ConversationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationsQuery, ConversationsQueryVariables>(ConversationsDocument, options);
      }
export function useConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationsQuery, ConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationsQuery, ConversationsQueryVariables>(ConversationsDocument, options);
        }
// @ts-ignore
export function useConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConversationsQuery, ConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<ConversationsQuery, ConversationsQueryVariables>;
export function useConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConversationsQuery, ConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<ConversationsQuery | undefined, ConversationsQueryVariables>;
export function useConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConversationsQuery, ConversationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConversationsQuery, ConversationsQueryVariables>(ConversationsDocument, options);
        }
export type ConversationsQueryHookResult = ReturnType<typeof useConversationsQuery>;
export type ConversationsLazyQueryHookResult = ReturnType<typeof useConversationsLazyQuery>;
export type ConversationsSuspenseQueryHookResult = ReturnType<typeof useConversationsSuspenseQuery>;
export type ConversationsQueryResult = Apollo.QueryResult<ConversationsQuery, ConversationsQueryVariables>;
export const SendMessageDocument = gql`
    mutation SendMessage($correlationId: String!, $message: String, $sessionIdentifier: String!) {
  sendMessage(
    correlationId: $correlationId
    message: $message
    sessionIdentifier: $sessionIdentifier
  ) {
    conversation {
      ...ConversationFragment
    }
  }
}
    ${ConversationFragmentFragmentDoc}`;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      correlationId: // value for 'correlationId'
 *      message: // value for 'message'
 *      sessionIdentifier: // value for 'sessionIdentifier'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const StartConversationDocument = gql`
    mutation StartConversation($assetIds: [String!]!, $correlationId: String!, $promptName: String!, $variables: [PromptVariableInput!]) {
  startConversation(
    assetIds: $assetIds
    correlationId: $correlationId
    promptName: $promptName
    variables: $variables
  ) {
    conversation {
      ...ConversationFragment
    }
  }
}
    ${ConversationFragmentFragmentDoc}`;
export type StartConversationMutationFn = Apollo.MutationFunction<StartConversationMutation, StartConversationMutationVariables>;

/**
 * __useStartConversationMutation__
 *
 * To run a mutation, you first call `useStartConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startConversationMutation, { data, loading, error }] = useStartConversationMutation({
 *   variables: {
 *      assetIds: // value for 'assetIds'
 *      correlationId: // value for 'correlationId'
 *      promptName: // value for 'promptName'
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useStartConversationMutation(baseOptions?: Apollo.MutationHookOptions<StartConversationMutation, StartConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartConversationMutation, StartConversationMutationVariables>(StartConversationDocument, options);
      }
export type StartConversationMutationHookResult = ReturnType<typeof useStartConversationMutation>;
export type StartConversationMutationResult = Apollo.MutationResult<StartConversationMutation>;
export type StartConversationMutationOptions = Apollo.BaseMutationOptions<StartConversationMutation, StartConversationMutationVariables>;
export const CancelTrafficCampaignApprovalsDocument = gql`
    mutation cancelTrafficCampaignApprovals($input: TransitionTrafficCampaignFlavorsInput!) {
  transitionTrafficCampaignFlavors(input: $input) {
    ...useIsCampaignLocked
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${UseIsCampaignLockedFragmentDoc}
${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type CancelTrafficCampaignApprovalsMutationFn = Apollo.MutationFunction<CancelTrafficCampaignApprovalsMutation, CancelTrafficCampaignApprovalsMutationVariables>;

/**
 * __useCancelTrafficCampaignApprovalsMutation__
 *
 * To run a mutation, you first call `useCancelTrafficCampaignApprovalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTrafficCampaignApprovalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTrafficCampaignApprovalsMutation, { data, loading, error }] = useCancelTrafficCampaignApprovalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelTrafficCampaignApprovalsMutation(baseOptions?: Apollo.MutationHookOptions<CancelTrafficCampaignApprovalsMutation, CancelTrafficCampaignApprovalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelTrafficCampaignApprovalsMutation, CancelTrafficCampaignApprovalsMutationVariables>(CancelTrafficCampaignApprovalsDocument, options);
      }
export type CancelTrafficCampaignApprovalsMutationHookResult = ReturnType<typeof useCancelTrafficCampaignApprovalsMutation>;
export type CancelTrafficCampaignApprovalsMutationResult = Apollo.MutationResult<CancelTrafficCampaignApprovalsMutation>;
export type CancelTrafficCampaignApprovalsMutationOptions = Apollo.BaseMutationOptions<CancelTrafficCampaignApprovalsMutation, CancelTrafficCampaignApprovalsMutationVariables>;
export const CloneTrafficCampaignDocument = gql`
    mutation CloneTrafficCampaign($input: CloneTrafficCampaignInput!) {
  cloneTrafficCampaign(input: $input) {
    campaign {
      id
      name
      project {
        id
      }
    }
  }
}
    `;
export type CloneTrafficCampaignMutationFn = Apollo.MutationFunction<CloneTrafficCampaignMutation, CloneTrafficCampaignMutationVariables>;

/**
 * __useCloneTrafficCampaignMutation__
 *
 * To run a mutation, you first call `useCloneTrafficCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneTrafficCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneTrafficCampaignMutation, { data, loading, error }] = useCloneTrafficCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneTrafficCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CloneTrafficCampaignMutation, CloneTrafficCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneTrafficCampaignMutation, CloneTrafficCampaignMutationVariables>(CloneTrafficCampaignDocument, options);
      }
export type CloneTrafficCampaignMutationHookResult = ReturnType<typeof useCloneTrafficCampaignMutation>;
export type CloneTrafficCampaignMutationResult = Apollo.MutationResult<CloneTrafficCampaignMutation>;
export type CloneTrafficCampaignMutationOptions = Apollo.BaseMutationOptions<CloneTrafficCampaignMutation, CloneTrafficCampaignMutationVariables>;
export const PublishTrafficCampaignFlavorsDocument = gql`
    mutation publishTrafficCampaignFlavors($projectId: ID!, $id: ID!, $input: [TrafficCreativePublishInput!]!) {
  publishTrafficCampaignFlavors(projectId: $projectId, id: $id, input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type PublishTrafficCampaignFlavorsMutationFn = Apollo.MutationFunction<PublishTrafficCampaignFlavorsMutation, PublishTrafficCampaignFlavorsMutationVariables>;

/**
 * __usePublishTrafficCampaignFlavorsMutation__
 *
 * To run a mutation, you first call `usePublishTrafficCampaignFlavorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishTrafficCampaignFlavorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishTrafficCampaignFlavorsMutation, { data, loading, error }] = usePublishTrafficCampaignFlavorsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishTrafficCampaignFlavorsMutation(baseOptions?: Apollo.MutationHookOptions<PublishTrafficCampaignFlavorsMutation, PublishTrafficCampaignFlavorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishTrafficCampaignFlavorsMutation, PublishTrafficCampaignFlavorsMutationVariables>(PublishTrafficCampaignFlavorsDocument, options);
      }
export type PublishTrafficCampaignFlavorsMutationHookResult = ReturnType<typeof usePublishTrafficCampaignFlavorsMutation>;
export type PublishTrafficCampaignFlavorsMutationResult = Apollo.MutationResult<PublishTrafficCampaignFlavorsMutation>;
export type PublishTrafficCampaignFlavorsMutationOptions = Apollo.BaseMutationOptions<PublishTrafficCampaignFlavorsMutation, PublishTrafficCampaignFlavorsMutationVariables>;
export const PublishTrafficCampaignFlavorDocument = gql`
    mutation publishTrafficCampaignFlavor($projectId: ID!, $id: ID!, $input: TrafficCreativePublishInput!) {
  publishTrafficCampaignFlavor(projectId: $projectId, id: $id, input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type PublishTrafficCampaignFlavorMutationFn = Apollo.MutationFunction<PublishTrafficCampaignFlavorMutation, PublishTrafficCampaignFlavorMutationVariables>;

/**
 * __usePublishTrafficCampaignFlavorMutation__
 *
 * To run a mutation, you first call `usePublishTrafficCampaignFlavorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishTrafficCampaignFlavorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishTrafficCampaignFlavorMutation, { data, loading, error }] = usePublishTrafficCampaignFlavorMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishTrafficCampaignFlavorMutation(baseOptions?: Apollo.MutationHookOptions<PublishTrafficCampaignFlavorMutation, PublishTrafficCampaignFlavorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishTrafficCampaignFlavorMutation, PublishTrafficCampaignFlavorMutationVariables>(PublishTrafficCampaignFlavorDocument, options);
      }
export type PublishTrafficCampaignFlavorMutationHookResult = ReturnType<typeof usePublishTrafficCampaignFlavorMutation>;
export type PublishTrafficCampaignFlavorMutationResult = Apollo.MutationResult<PublishTrafficCampaignFlavorMutation>;
export type PublishTrafficCampaignFlavorMutationOptions = Apollo.BaseMutationOptions<PublishTrafficCampaignFlavorMutation, PublishTrafficCampaignFlavorMutationVariables>;
export const AsinPsldCheckDocument = gql`
    query asinPsldCheck($first: Int!, $filters: AsinFilterInput, $includeMissingAnnounceDate: Boolean) {
  asins(first: $first, filters: $filters) {
    launchGatingInfo {
      marketplace {
        id
        country
        launchDateThreshold
      }
      gatingAsins(
        first: $first
        includeMissingAnnounceDate: $includeMissingAnnounceDate
      ) {
        nodes {
          id
          announceDate
          asin
        }
        totalCount
      }
    }
    nodes {
      id
    }
    totalCount
  }
}
    `;

/**
 * __useAsinPsldCheckQuery__
 *
 * To run a query within a React component, call `useAsinPsldCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsinPsldCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsinPsldCheckQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      includeMissingAnnounceDate: // value for 'includeMissingAnnounceDate'
 *   },
 * });
 */
export function useAsinPsldCheckQuery(baseOptions: Apollo.QueryHookOptions<AsinPsldCheckQuery, AsinPsldCheckQueryVariables> & ({ variables: AsinPsldCheckQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsinPsldCheckQuery, AsinPsldCheckQueryVariables>(AsinPsldCheckDocument, options);
      }
export function useAsinPsldCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsinPsldCheckQuery, AsinPsldCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsinPsldCheckQuery, AsinPsldCheckQueryVariables>(AsinPsldCheckDocument, options);
        }
// @ts-ignore
export function useAsinPsldCheckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AsinPsldCheckQuery, AsinPsldCheckQueryVariables>): Apollo.UseSuspenseQueryResult<AsinPsldCheckQuery, AsinPsldCheckQueryVariables>;
export function useAsinPsldCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AsinPsldCheckQuery, AsinPsldCheckQueryVariables>): Apollo.UseSuspenseQueryResult<AsinPsldCheckQuery | undefined, AsinPsldCheckQueryVariables>;
export function useAsinPsldCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AsinPsldCheckQuery, AsinPsldCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AsinPsldCheckQuery, AsinPsldCheckQueryVariables>(AsinPsldCheckDocument, options);
        }
export type AsinPsldCheckQueryHookResult = ReturnType<typeof useAsinPsldCheckQuery>;
export type AsinPsldCheckLazyQueryHookResult = ReturnType<typeof useAsinPsldCheckLazyQuery>;
export type AsinPsldCheckSuspenseQueryHookResult = ReturnType<typeof useAsinPsldCheckSuspenseQuery>;
export type AsinPsldCheckQueryResult = Apollo.QueryResult<AsinPsldCheckQuery, AsinPsldCheckQueryVariables>;
export const PsldCheckDocument = gql`
    query psldCheck($asin: String!, $marketplace: String!, $keys: [String!]!) {
  attributes(asin: $asin, marketplace: $marketplace, keys: $keys) {
    key
    value
  }
  asins(
    first: 1
    filters: {asinCountries: [{country: $marketplace, asin: $asin}]}
  ) {
    nodes {
      ...WithinLaunchDate
    }
  }
}
    ${WithinLaunchDateFragmentDoc}`;

/**
 * __usePsldCheckQuery__
 *
 * To run a query within a React component, call `usePsldCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `usePsldCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePsldCheckQuery({
 *   variables: {
 *      asin: // value for 'asin'
 *      marketplace: // value for 'marketplace'
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function usePsldCheckQuery(baseOptions: Apollo.QueryHookOptions<PsldCheckQuery, PsldCheckQueryVariables> & ({ variables: PsldCheckQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PsldCheckQuery, PsldCheckQueryVariables>(PsldCheckDocument, options);
      }
export function usePsldCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PsldCheckQuery, PsldCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PsldCheckQuery, PsldCheckQueryVariables>(PsldCheckDocument, options);
        }
// @ts-ignore
export function usePsldCheckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PsldCheckQuery, PsldCheckQueryVariables>): Apollo.UseSuspenseQueryResult<PsldCheckQuery, PsldCheckQueryVariables>;
export function usePsldCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PsldCheckQuery, PsldCheckQueryVariables>): Apollo.UseSuspenseQueryResult<PsldCheckQuery | undefined, PsldCheckQueryVariables>;
export function usePsldCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PsldCheckQuery, PsldCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PsldCheckQuery, PsldCheckQueryVariables>(PsldCheckDocument, options);
        }
export type PsldCheckQueryHookResult = ReturnType<typeof usePsldCheckQuery>;
export type PsldCheckLazyQueryHookResult = ReturnType<typeof usePsldCheckLazyQuery>;
export type PsldCheckSuspenseQueryHookResult = ReturnType<typeof usePsldCheckSuspenseQuery>;
export type PsldCheckQueryResult = Apollo.QueryResult<PsldCheckQuery, PsldCheckQueryVariables>;
export const RejectTrafficCampaignFlavorsDocument = gql`
    mutation rejectTrafficCampaignFlavors($input: TransitionTrafficCampaignFlavorsInput!) {
  transitionTrafficCampaignFlavors(input: $input) {
    ...useIsCampaignLocked
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${UseIsCampaignLockedFragmentDoc}
${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type RejectTrafficCampaignFlavorsMutationFn = Apollo.MutationFunction<RejectTrafficCampaignFlavorsMutation, RejectTrafficCampaignFlavorsMutationVariables>;

/**
 * __useRejectTrafficCampaignFlavorsMutation__
 *
 * To run a mutation, you first call `useRejectTrafficCampaignFlavorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectTrafficCampaignFlavorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectTrafficCampaignFlavorsMutation, { data, loading, error }] = useRejectTrafficCampaignFlavorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectTrafficCampaignFlavorsMutation(baseOptions?: Apollo.MutationHookOptions<RejectTrafficCampaignFlavorsMutation, RejectTrafficCampaignFlavorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectTrafficCampaignFlavorsMutation, RejectTrafficCampaignFlavorsMutationVariables>(RejectTrafficCampaignFlavorsDocument, options);
      }
export type RejectTrafficCampaignFlavorsMutationHookResult = ReturnType<typeof useRejectTrafficCampaignFlavorsMutation>;
export type RejectTrafficCampaignFlavorsMutationResult = Apollo.MutationResult<RejectTrafficCampaignFlavorsMutation>;
export type RejectTrafficCampaignFlavorsMutationOptions = Apollo.BaseMutationOptions<RejectTrafficCampaignFlavorsMutation, RejectTrafficCampaignFlavorsMutationVariables>;
export const RequestApprovalForTrafficCampaignFlavorsDocument = gql`
    mutation requestApprovalForTrafficCampaignFlavors($input: TransitionTrafficCampaignFlavorsInput!) {
  transitionTrafficCampaignFlavors(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
    ...TPCampaignNavBar
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}
${TpCampaignNavBarFragmentDoc}`;
export type RequestApprovalForTrafficCampaignFlavorsMutationFn = Apollo.MutationFunction<RequestApprovalForTrafficCampaignFlavorsMutation, RequestApprovalForTrafficCampaignFlavorsMutationVariables>;

/**
 * __useRequestApprovalForTrafficCampaignFlavorsMutation__
 *
 * To run a mutation, you first call `useRequestApprovalForTrafficCampaignFlavorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestApprovalForTrafficCampaignFlavorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestApprovalForTrafficCampaignFlavorsMutation, { data, loading, error }] = useRequestApprovalForTrafficCampaignFlavorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestApprovalForTrafficCampaignFlavorsMutation(baseOptions?: Apollo.MutationHookOptions<RequestApprovalForTrafficCampaignFlavorsMutation, RequestApprovalForTrafficCampaignFlavorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestApprovalForTrafficCampaignFlavorsMutation, RequestApprovalForTrafficCampaignFlavorsMutationVariables>(RequestApprovalForTrafficCampaignFlavorsDocument, options);
      }
export type RequestApprovalForTrafficCampaignFlavorsMutationHookResult = ReturnType<typeof useRequestApprovalForTrafficCampaignFlavorsMutation>;
export type RequestApprovalForTrafficCampaignFlavorsMutationResult = Apollo.MutationResult<RequestApprovalForTrafficCampaignFlavorsMutation>;
export type RequestApprovalForTrafficCampaignFlavorsMutationOptions = Apollo.BaseMutationOptions<RequestApprovalForTrafficCampaignFlavorsMutation, RequestApprovalForTrafficCampaignFlavorsMutationVariables>;
export const SaveTrafficCampaignDocument = gql`
    mutation SaveTrafficCampaign($input: SaveTrafficCampaignInput!) {
  saveTrafficCampaign(input: $input) {
    campaign {
      name
      ...TPCampaignSidebar
      ...TPCampaignRequiredFormFields
    }
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type SaveTrafficCampaignMutationFn = Apollo.MutationFunction<SaveTrafficCampaignMutation, SaveTrafficCampaignMutationVariables>;

/**
 * __useSaveTrafficCampaignMutation__
 *
 * To run a mutation, you first call `useSaveTrafficCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTrafficCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTrafficCampaignMutation, { data, loading, error }] = useSaveTrafficCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTrafficCampaignMutation(baseOptions?: Apollo.MutationHookOptions<SaveTrafficCampaignMutation, SaveTrafficCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTrafficCampaignMutation, SaveTrafficCampaignMutationVariables>(SaveTrafficCampaignDocument, options);
      }
export type SaveTrafficCampaignMutationHookResult = ReturnType<typeof useSaveTrafficCampaignMutation>;
export type SaveTrafficCampaignMutationResult = Apollo.MutationResult<SaveTrafficCampaignMutation>;
export type SaveTrafficCampaignMutationOptions = Apollo.BaseMutationOptions<SaveTrafficCampaignMutation, SaveTrafficCampaignMutationVariables>;
export const CreateTrafficCampaignDocument = gql`
    mutation CreateTrafficCampaign($input: CreateTrafficCampaignInput!) {
  createTrafficCampaign(input: $input) {
    createdAt
    createdBy
    globalContent
    flavors {
      active
      id
    }
    id
    modifiedAt
    modifiedBy
    name
    placements {
      ...TPCampaignPlacementsInfo
    }
    project {
      name
      id
    }
    schema
    schemaVersion
    thumbnailURL
    version
  }
}
    ${TpCampaignPlacementsInfoFragmentDoc}`;
export type CreateTrafficCampaignMutationFn = Apollo.MutationFunction<CreateTrafficCampaignMutation, CreateTrafficCampaignMutationVariables>;

/**
 * __useCreateTrafficCampaignMutation__
 *
 * To run a mutation, you first call `useCreateTrafficCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrafficCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrafficCampaignMutation, { data, loading, error }] = useCreateTrafficCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTrafficCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrafficCampaignMutation, CreateTrafficCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrafficCampaignMutation, CreateTrafficCampaignMutationVariables>(CreateTrafficCampaignDocument, options);
      }
export type CreateTrafficCampaignMutationHookResult = ReturnType<typeof useCreateTrafficCampaignMutation>;
export type CreateTrafficCampaignMutationResult = Apollo.MutationResult<CreateTrafficCampaignMutation>;
export type CreateTrafficCampaignMutationOptions = Apollo.BaseMutationOptions<CreateTrafficCampaignMutation, CreateTrafficCampaignMutationVariables>;
export const SuspendTrafficCampaignFlavorDocument = gql`
    mutation suspendTrafficCampaignFlavor($input: TrafficFlavorStateTransitionInput!) {
  suspendTrafficCampaignFlavor(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type SuspendTrafficCampaignFlavorMutationFn = Apollo.MutationFunction<SuspendTrafficCampaignFlavorMutation, SuspendTrafficCampaignFlavorMutationVariables>;

/**
 * __useSuspendTrafficCampaignFlavorMutation__
 *
 * To run a mutation, you first call `useSuspendTrafficCampaignFlavorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendTrafficCampaignFlavorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendTrafficCampaignFlavorMutation, { data, loading, error }] = useSuspendTrafficCampaignFlavorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuspendTrafficCampaignFlavorMutation(baseOptions?: Apollo.MutationHookOptions<SuspendTrafficCampaignFlavorMutation, SuspendTrafficCampaignFlavorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendTrafficCampaignFlavorMutation, SuspendTrafficCampaignFlavorMutationVariables>(SuspendTrafficCampaignFlavorDocument, options);
      }
export type SuspendTrafficCampaignFlavorMutationHookResult = ReturnType<typeof useSuspendTrafficCampaignFlavorMutation>;
export type SuspendTrafficCampaignFlavorMutationResult = Apollo.MutationResult<SuspendTrafficCampaignFlavorMutation>;
export type SuspendTrafficCampaignFlavorMutationOptions = Apollo.BaseMutationOptions<SuspendTrafficCampaignFlavorMutation, SuspendTrafficCampaignFlavorMutationVariables>;
export const SuspendTrafficCampaignFlavorsDocument = gql`
    mutation suspendTrafficCampaignFlavors($input: TransitionTrafficCampaignFlavorsInput!) {
  transitionTrafficCampaignFlavors(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type SuspendTrafficCampaignFlavorsMutationFn = Apollo.MutationFunction<SuspendTrafficCampaignFlavorsMutation, SuspendTrafficCampaignFlavorsMutationVariables>;

/**
 * __useSuspendTrafficCampaignFlavorsMutation__
 *
 * To run a mutation, you first call `useSuspendTrafficCampaignFlavorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendTrafficCampaignFlavorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendTrafficCampaignFlavorsMutation, { data, loading, error }] = useSuspendTrafficCampaignFlavorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuspendTrafficCampaignFlavorsMutation(baseOptions?: Apollo.MutationHookOptions<SuspendTrafficCampaignFlavorsMutation, SuspendTrafficCampaignFlavorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendTrafficCampaignFlavorsMutation, SuspendTrafficCampaignFlavorsMutationVariables>(SuspendTrafficCampaignFlavorsDocument, options);
      }
export type SuspendTrafficCampaignFlavorsMutationHookResult = ReturnType<typeof useSuspendTrafficCampaignFlavorsMutation>;
export type SuspendTrafficCampaignFlavorsMutationResult = Apollo.MutationResult<SuspendTrafficCampaignFlavorsMutation>;
export type SuspendTrafficCampaignFlavorsMutationOptions = Apollo.BaseMutationOptions<SuspendTrafficCampaignFlavorsMutation, SuspendTrafficCampaignFlavorsMutationVariables>;
export const GetTrafficCampaignCountDocument = gql`
    query GetTrafficCampaignCount($projectId: ID!, $first: Int = 1) {
  trafficProject(id: $projectId) {
    id
    campaigns(first: $first) {
      totalCount
    }
  }
}
    `;

/**
 * __useGetTrafficCampaignCountQuery__
 *
 * To run a query within a React component, call `useGetTrafficCampaignCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrafficCampaignCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrafficCampaignCountQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetTrafficCampaignCountQuery(baseOptions: Apollo.QueryHookOptions<GetTrafficCampaignCountQuery, GetTrafficCampaignCountQueryVariables> & ({ variables: GetTrafficCampaignCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrafficCampaignCountQuery, GetTrafficCampaignCountQueryVariables>(GetTrafficCampaignCountDocument, options);
      }
export function useGetTrafficCampaignCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrafficCampaignCountQuery, GetTrafficCampaignCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrafficCampaignCountQuery, GetTrafficCampaignCountQueryVariables>(GetTrafficCampaignCountDocument, options);
        }
// @ts-ignore
export function useGetTrafficCampaignCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTrafficCampaignCountQuery, GetTrafficCampaignCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetTrafficCampaignCountQuery, GetTrafficCampaignCountQueryVariables>;
export function useGetTrafficCampaignCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrafficCampaignCountQuery, GetTrafficCampaignCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetTrafficCampaignCountQuery | undefined, GetTrafficCampaignCountQueryVariables>;
export function useGetTrafficCampaignCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrafficCampaignCountQuery, GetTrafficCampaignCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrafficCampaignCountQuery, GetTrafficCampaignCountQueryVariables>(GetTrafficCampaignCountDocument, options);
        }
export type GetTrafficCampaignCountQueryHookResult = ReturnType<typeof useGetTrafficCampaignCountQuery>;
export type GetTrafficCampaignCountLazyQueryHookResult = ReturnType<typeof useGetTrafficCampaignCountLazyQuery>;
export type GetTrafficCampaignCountSuspenseQueryHookResult = ReturnType<typeof useGetTrafficCampaignCountSuspenseQuery>;
export type GetTrafficCampaignCountQueryResult = Apollo.QueryResult<GetTrafficCampaignCountQuery, GetTrafficCampaignCountQueryVariables>;
export const ApproveMcTrafficCampaignFlavorsDocument = gql`
    mutation approveMCTrafficCampaignFlavors($input: TransitionTrafficCampaignFlavorsInput!) {
  transitionTrafficCampaignFlavors(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type ApproveMcTrafficCampaignFlavorsMutationFn = Apollo.MutationFunction<ApproveMcTrafficCampaignFlavorsMutation, ApproveMcTrafficCampaignFlavorsMutationVariables>;

/**
 * __useApproveMcTrafficCampaignFlavorsMutation__
 *
 * To run a mutation, you first call `useApproveMcTrafficCampaignFlavorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveMcTrafficCampaignFlavorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveMcTrafficCampaignFlavorsMutation, { data, loading, error }] = useApproveMcTrafficCampaignFlavorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveMcTrafficCampaignFlavorsMutation(baseOptions?: Apollo.MutationHookOptions<ApproveMcTrafficCampaignFlavorsMutation, ApproveMcTrafficCampaignFlavorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveMcTrafficCampaignFlavorsMutation, ApproveMcTrafficCampaignFlavorsMutationVariables>(ApproveMcTrafficCampaignFlavorsDocument, options);
      }
export type ApproveMcTrafficCampaignFlavorsMutationHookResult = ReturnType<typeof useApproveMcTrafficCampaignFlavorsMutation>;
export type ApproveMcTrafficCampaignFlavorsMutationResult = Apollo.MutationResult<ApproveMcTrafficCampaignFlavorsMutation>;
export type ApproveMcTrafficCampaignFlavorsMutationOptions = Apollo.BaseMutationOptions<ApproveMcTrafficCampaignFlavorsMutation, ApproveMcTrafficCampaignFlavorsMutationVariables>;
export const RejectMcTrafficCampaignFlavorsDocument = gql`
    mutation rejectMCTrafficCampaignFlavors($input: TransitionTrafficCampaignFlavorsInput!) {
  transitionTrafficCampaignFlavors(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type RejectMcTrafficCampaignFlavorsMutationFn = Apollo.MutationFunction<RejectMcTrafficCampaignFlavorsMutation, RejectMcTrafficCampaignFlavorsMutationVariables>;

/**
 * __useRejectMcTrafficCampaignFlavorsMutation__
 *
 * To run a mutation, you first call `useRejectMcTrafficCampaignFlavorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectMcTrafficCampaignFlavorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectMcTrafficCampaignFlavorsMutation, { data, loading, error }] = useRejectMcTrafficCampaignFlavorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectMcTrafficCampaignFlavorsMutation(baseOptions?: Apollo.MutationHookOptions<RejectMcTrafficCampaignFlavorsMutation, RejectMcTrafficCampaignFlavorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectMcTrafficCampaignFlavorsMutation, RejectMcTrafficCampaignFlavorsMutationVariables>(RejectMcTrafficCampaignFlavorsDocument, options);
      }
export type RejectMcTrafficCampaignFlavorsMutationHookResult = ReturnType<typeof useRejectMcTrafficCampaignFlavorsMutation>;
export type RejectMcTrafficCampaignFlavorsMutationResult = Apollo.MutationResult<RejectMcTrafficCampaignFlavorsMutation>;
export type RejectMcTrafficCampaignFlavorsMutationOptions = Apollo.BaseMutationOptions<RejectMcTrafficCampaignFlavorsMutation, RejectMcTrafficCampaignFlavorsMutationVariables>;
export const SuspendMcTrafficCampaignFlavorsDocument = gql`
    mutation suspendMCTrafficCampaignFlavors($input: TransitionTrafficCampaignFlavorsInput!) {
  transitionTrafficCampaignFlavors(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type SuspendMcTrafficCampaignFlavorsMutationFn = Apollo.MutationFunction<SuspendMcTrafficCampaignFlavorsMutation, SuspendMcTrafficCampaignFlavorsMutationVariables>;

/**
 * __useSuspendMcTrafficCampaignFlavorsMutation__
 *
 * To run a mutation, you first call `useSuspendMcTrafficCampaignFlavorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendMcTrafficCampaignFlavorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendMcTrafficCampaignFlavorsMutation, { data, loading, error }] = useSuspendMcTrafficCampaignFlavorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuspendMcTrafficCampaignFlavorsMutation(baseOptions?: Apollo.MutationHookOptions<SuspendMcTrafficCampaignFlavorsMutation, SuspendMcTrafficCampaignFlavorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendMcTrafficCampaignFlavorsMutation, SuspendMcTrafficCampaignFlavorsMutationVariables>(SuspendMcTrafficCampaignFlavorsDocument, options);
      }
export type SuspendMcTrafficCampaignFlavorsMutationHookResult = ReturnType<typeof useSuspendMcTrafficCampaignFlavorsMutation>;
export type SuspendMcTrafficCampaignFlavorsMutationResult = Apollo.MutationResult<SuspendMcTrafficCampaignFlavorsMutation>;
export type SuspendMcTrafficCampaignFlavorsMutationOptions = Apollo.BaseMutationOptions<SuspendMcTrafficCampaignFlavorsMutation, SuspendMcTrafficCampaignFlavorsMutationVariables>;
export const RequestCbrApprovalMcTrafficCampaignFlavorsDocument = gql`
    mutation requestCbrApprovalMCTrafficCampaignFlavors($input: TransitionTrafficCampaignFlavorsInput!) {
  transitionTrafficCampaignFlavors(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type RequestCbrApprovalMcTrafficCampaignFlavorsMutationFn = Apollo.MutationFunction<RequestCbrApprovalMcTrafficCampaignFlavorsMutation, RequestCbrApprovalMcTrafficCampaignFlavorsMutationVariables>;

/**
 * __useRequestCbrApprovalMcTrafficCampaignFlavorsMutation__
 *
 * To run a mutation, you first call `useRequestCbrApprovalMcTrafficCampaignFlavorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCbrApprovalMcTrafficCampaignFlavorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCbrApprovalMcTrafficCampaignFlavorsMutation, { data, loading, error }] = useRequestCbrApprovalMcTrafficCampaignFlavorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCbrApprovalMcTrafficCampaignFlavorsMutation(baseOptions?: Apollo.MutationHookOptions<RequestCbrApprovalMcTrafficCampaignFlavorsMutation, RequestCbrApprovalMcTrafficCampaignFlavorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCbrApprovalMcTrafficCampaignFlavorsMutation, RequestCbrApprovalMcTrafficCampaignFlavorsMutationVariables>(RequestCbrApprovalMcTrafficCampaignFlavorsDocument, options);
      }
export type RequestCbrApprovalMcTrafficCampaignFlavorsMutationHookResult = ReturnType<typeof useRequestCbrApprovalMcTrafficCampaignFlavorsMutation>;
export type RequestCbrApprovalMcTrafficCampaignFlavorsMutationResult = Apollo.MutationResult<RequestCbrApprovalMcTrafficCampaignFlavorsMutation>;
export type RequestCbrApprovalMcTrafficCampaignFlavorsMutationOptions = Apollo.BaseMutationOptions<RequestCbrApprovalMcTrafficCampaignFlavorsMutation, RequestCbrApprovalMcTrafficCampaignFlavorsMutationVariables>;
export const CancelCbrApprovalRequestMcTrafficCampaignFlavorsDocument = gql`
    mutation cancelCbrApprovalRequestMCTrafficCampaignFlavors($input: TransitionTrafficCampaignFlavorsInput!) {
  transitionTrafficCampaignFlavors(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type CancelCbrApprovalRequestMcTrafficCampaignFlavorsMutationFn = Apollo.MutationFunction<CancelCbrApprovalRequestMcTrafficCampaignFlavorsMutation, CancelCbrApprovalRequestMcTrafficCampaignFlavorsMutationVariables>;

/**
 * __useCancelCbrApprovalRequestMcTrafficCampaignFlavorsMutation__
 *
 * To run a mutation, you first call `useCancelCbrApprovalRequestMcTrafficCampaignFlavorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCbrApprovalRequestMcTrafficCampaignFlavorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCbrApprovalRequestMcTrafficCampaignFlavorsMutation, { data, loading, error }] = useCancelCbrApprovalRequestMcTrafficCampaignFlavorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelCbrApprovalRequestMcTrafficCampaignFlavorsMutation(baseOptions?: Apollo.MutationHookOptions<CancelCbrApprovalRequestMcTrafficCampaignFlavorsMutation, CancelCbrApprovalRequestMcTrafficCampaignFlavorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCbrApprovalRequestMcTrafficCampaignFlavorsMutation, CancelCbrApprovalRequestMcTrafficCampaignFlavorsMutationVariables>(CancelCbrApprovalRequestMcTrafficCampaignFlavorsDocument, options);
      }
export type CancelCbrApprovalRequestMcTrafficCampaignFlavorsMutationHookResult = ReturnType<typeof useCancelCbrApprovalRequestMcTrafficCampaignFlavorsMutation>;
export type CancelCbrApprovalRequestMcTrafficCampaignFlavorsMutationResult = Apollo.MutationResult<CancelCbrApprovalRequestMcTrafficCampaignFlavorsMutation>;
export type CancelCbrApprovalRequestMcTrafficCampaignFlavorsMutationOptions = Apollo.BaseMutationOptions<CancelCbrApprovalRequestMcTrafficCampaignFlavorsMutation, CancelCbrApprovalRequestMcTrafficCampaignFlavorsMutationVariables>;
export const ApproveMcTrafficCampaignCreativesDocument = gql`
    mutation approveMCTrafficCampaignCreatives($input: TransitionTrafficCampaignCreativesInput!) {
  transitionTrafficCampaignCreatives(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type ApproveMcTrafficCampaignCreativesMutationFn = Apollo.MutationFunction<ApproveMcTrafficCampaignCreativesMutation, ApproveMcTrafficCampaignCreativesMutationVariables>;

/**
 * __useApproveMcTrafficCampaignCreativesMutation__
 *
 * To run a mutation, you first call `useApproveMcTrafficCampaignCreativesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveMcTrafficCampaignCreativesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveMcTrafficCampaignCreativesMutation, { data, loading, error }] = useApproveMcTrafficCampaignCreativesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveMcTrafficCampaignCreativesMutation(baseOptions?: Apollo.MutationHookOptions<ApproveMcTrafficCampaignCreativesMutation, ApproveMcTrafficCampaignCreativesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveMcTrafficCampaignCreativesMutation, ApproveMcTrafficCampaignCreativesMutationVariables>(ApproveMcTrafficCampaignCreativesDocument, options);
      }
export type ApproveMcTrafficCampaignCreativesMutationHookResult = ReturnType<typeof useApproveMcTrafficCampaignCreativesMutation>;
export type ApproveMcTrafficCampaignCreativesMutationResult = Apollo.MutationResult<ApproveMcTrafficCampaignCreativesMutation>;
export type ApproveMcTrafficCampaignCreativesMutationOptions = Apollo.BaseMutationOptions<ApproveMcTrafficCampaignCreativesMutation, ApproveMcTrafficCampaignCreativesMutationVariables>;
export const RejectMcTrafficCampaignCreativesDocument = gql`
    mutation rejectMCTrafficCampaignCreatives($input: TransitionTrafficCampaignCreativesInput!) {
  transitionTrafficCampaignCreatives(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type RejectMcTrafficCampaignCreativesMutationFn = Apollo.MutationFunction<RejectMcTrafficCampaignCreativesMutation, RejectMcTrafficCampaignCreativesMutationVariables>;

/**
 * __useRejectMcTrafficCampaignCreativesMutation__
 *
 * To run a mutation, you first call `useRejectMcTrafficCampaignCreativesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectMcTrafficCampaignCreativesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectMcTrafficCampaignCreativesMutation, { data, loading, error }] = useRejectMcTrafficCampaignCreativesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectMcTrafficCampaignCreativesMutation(baseOptions?: Apollo.MutationHookOptions<RejectMcTrafficCampaignCreativesMutation, RejectMcTrafficCampaignCreativesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectMcTrafficCampaignCreativesMutation, RejectMcTrafficCampaignCreativesMutationVariables>(RejectMcTrafficCampaignCreativesDocument, options);
      }
export type RejectMcTrafficCampaignCreativesMutationHookResult = ReturnType<typeof useRejectMcTrafficCampaignCreativesMutation>;
export type RejectMcTrafficCampaignCreativesMutationResult = Apollo.MutationResult<RejectMcTrafficCampaignCreativesMutation>;
export type RejectMcTrafficCampaignCreativesMutationOptions = Apollo.BaseMutationOptions<RejectMcTrafficCampaignCreativesMutation, RejectMcTrafficCampaignCreativesMutationVariables>;
export const SuspendMcTrafficCampaignCreativesDocument = gql`
    mutation suspendMCTrafficCampaignCreatives($input: TransitionTrafficCampaignCreativesInput!) {
  transitionTrafficCampaignCreatives(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type SuspendMcTrafficCampaignCreativesMutationFn = Apollo.MutationFunction<SuspendMcTrafficCampaignCreativesMutation, SuspendMcTrafficCampaignCreativesMutationVariables>;

/**
 * __useSuspendMcTrafficCampaignCreativesMutation__
 *
 * To run a mutation, you first call `useSuspendMcTrafficCampaignCreativesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendMcTrafficCampaignCreativesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendMcTrafficCampaignCreativesMutation, { data, loading, error }] = useSuspendMcTrafficCampaignCreativesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuspendMcTrafficCampaignCreativesMutation(baseOptions?: Apollo.MutationHookOptions<SuspendMcTrafficCampaignCreativesMutation, SuspendMcTrafficCampaignCreativesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendMcTrafficCampaignCreativesMutation, SuspendMcTrafficCampaignCreativesMutationVariables>(SuspendMcTrafficCampaignCreativesDocument, options);
      }
export type SuspendMcTrafficCampaignCreativesMutationHookResult = ReturnType<typeof useSuspendMcTrafficCampaignCreativesMutation>;
export type SuspendMcTrafficCampaignCreativesMutationResult = Apollo.MutationResult<SuspendMcTrafficCampaignCreativesMutation>;
export type SuspendMcTrafficCampaignCreativesMutationOptions = Apollo.BaseMutationOptions<SuspendMcTrafficCampaignCreativesMutation, SuspendMcTrafficCampaignCreativesMutationVariables>;
export const RequestCbrApprovalMcTrafficCampaignCreativesDocument = gql`
    mutation requestCbrApprovalMCTrafficCampaignCreatives($input: TransitionTrafficCampaignCreativesInput!) {
  transitionTrafficCampaignCreatives(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type RequestCbrApprovalMcTrafficCampaignCreativesMutationFn = Apollo.MutationFunction<RequestCbrApprovalMcTrafficCampaignCreativesMutation, RequestCbrApprovalMcTrafficCampaignCreativesMutationVariables>;

/**
 * __useRequestCbrApprovalMcTrafficCampaignCreativesMutation__
 *
 * To run a mutation, you first call `useRequestCbrApprovalMcTrafficCampaignCreativesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCbrApprovalMcTrafficCampaignCreativesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCbrApprovalMcTrafficCampaignCreativesMutation, { data, loading, error }] = useRequestCbrApprovalMcTrafficCampaignCreativesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCbrApprovalMcTrafficCampaignCreativesMutation(baseOptions?: Apollo.MutationHookOptions<RequestCbrApprovalMcTrafficCampaignCreativesMutation, RequestCbrApprovalMcTrafficCampaignCreativesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCbrApprovalMcTrafficCampaignCreativesMutation, RequestCbrApprovalMcTrafficCampaignCreativesMutationVariables>(RequestCbrApprovalMcTrafficCampaignCreativesDocument, options);
      }
export type RequestCbrApprovalMcTrafficCampaignCreativesMutationHookResult = ReturnType<typeof useRequestCbrApprovalMcTrafficCampaignCreativesMutation>;
export type RequestCbrApprovalMcTrafficCampaignCreativesMutationResult = Apollo.MutationResult<RequestCbrApprovalMcTrafficCampaignCreativesMutation>;
export type RequestCbrApprovalMcTrafficCampaignCreativesMutationOptions = Apollo.BaseMutationOptions<RequestCbrApprovalMcTrafficCampaignCreativesMutation, RequestCbrApprovalMcTrafficCampaignCreativesMutationVariables>;
export const CancelCbrApprovalRequestMcTrafficCampaignCreativesDocument = gql`
    mutation cancelCbrApprovalRequestMCTrafficCampaignCreatives($input: TransitionTrafficCampaignCreativesInput!) {
  transitionTrafficCampaignCreatives(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type CancelCbrApprovalRequestMcTrafficCampaignCreativesMutationFn = Apollo.MutationFunction<CancelCbrApprovalRequestMcTrafficCampaignCreativesMutation, CancelCbrApprovalRequestMcTrafficCampaignCreativesMutationVariables>;

/**
 * __useCancelCbrApprovalRequestMcTrafficCampaignCreativesMutation__
 *
 * To run a mutation, you first call `useCancelCbrApprovalRequestMcTrafficCampaignCreativesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCbrApprovalRequestMcTrafficCampaignCreativesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCbrApprovalRequestMcTrafficCampaignCreativesMutation, { data, loading, error }] = useCancelCbrApprovalRequestMcTrafficCampaignCreativesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelCbrApprovalRequestMcTrafficCampaignCreativesMutation(baseOptions?: Apollo.MutationHookOptions<CancelCbrApprovalRequestMcTrafficCampaignCreativesMutation, CancelCbrApprovalRequestMcTrafficCampaignCreativesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCbrApprovalRequestMcTrafficCampaignCreativesMutation, CancelCbrApprovalRequestMcTrafficCampaignCreativesMutationVariables>(CancelCbrApprovalRequestMcTrafficCampaignCreativesDocument, options);
      }
export type CancelCbrApprovalRequestMcTrafficCampaignCreativesMutationHookResult = ReturnType<typeof useCancelCbrApprovalRequestMcTrafficCampaignCreativesMutation>;
export type CancelCbrApprovalRequestMcTrafficCampaignCreativesMutationResult = Apollo.MutationResult<CancelCbrApprovalRequestMcTrafficCampaignCreativesMutation>;
export type CancelCbrApprovalRequestMcTrafficCampaignCreativesMutationOptions = Apollo.BaseMutationOptions<CancelCbrApprovalRequestMcTrafficCampaignCreativesMutation, CancelCbrApprovalRequestMcTrafficCampaignCreativesMutationVariables>;
export const ApproveMcTrafficCampaignPlacementsDocument = gql`
    mutation approveMCTrafficCampaignPlacements($input: TransitionTrafficCampaignPlacementsInput!) {
  transitionTrafficCampaignPlacements(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type ApproveMcTrafficCampaignPlacementsMutationFn = Apollo.MutationFunction<ApproveMcTrafficCampaignPlacementsMutation, ApproveMcTrafficCampaignPlacementsMutationVariables>;

/**
 * __useApproveMcTrafficCampaignPlacementsMutation__
 *
 * To run a mutation, you first call `useApproveMcTrafficCampaignPlacementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveMcTrafficCampaignPlacementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveMcTrafficCampaignPlacementsMutation, { data, loading, error }] = useApproveMcTrafficCampaignPlacementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveMcTrafficCampaignPlacementsMutation(baseOptions?: Apollo.MutationHookOptions<ApproveMcTrafficCampaignPlacementsMutation, ApproveMcTrafficCampaignPlacementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveMcTrafficCampaignPlacementsMutation, ApproveMcTrafficCampaignPlacementsMutationVariables>(ApproveMcTrafficCampaignPlacementsDocument, options);
      }
export type ApproveMcTrafficCampaignPlacementsMutationHookResult = ReturnType<typeof useApproveMcTrafficCampaignPlacementsMutation>;
export type ApproveMcTrafficCampaignPlacementsMutationResult = Apollo.MutationResult<ApproveMcTrafficCampaignPlacementsMutation>;
export type ApproveMcTrafficCampaignPlacementsMutationOptions = Apollo.BaseMutationOptions<ApproveMcTrafficCampaignPlacementsMutation, ApproveMcTrafficCampaignPlacementsMutationVariables>;
export const RejectMcTrafficCampaignPlacementsDocument = gql`
    mutation rejectMCTrafficCampaignPlacements($input: TransitionTrafficCampaignPlacementsInput!) {
  transitionTrafficCampaignPlacements(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type RejectMcTrafficCampaignPlacementsMutationFn = Apollo.MutationFunction<RejectMcTrafficCampaignPlacementsMutation, RejectMcTrafficCampaignPlacementsMutationVariables>;

/**
 * __useRejectMcTrafficCampaignPlacementsMutation__
 *
 * To run a mutation, you first call `useRejectMcTrafficCampaignPlacementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectMcTrafficCampaignPlacementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectMcTrafficCampaignPlacementsMutation, { data, loading, error }] = useRejectMcTrafficCampaignPlacementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectMcTrafficCampaignPlacementsMutation(baseOptions?: Apollo.MutationHookOptions<RejectMcTrafficCampaignPlacementsMutation, RejectMcTrafficCampaignPlacementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectMcTrafficCampaignPlacementsMutation, RejectMcTrafficCampaignPlacementsMutationVariables>(RejectMcTrafficCampaignPlacementsDocument, options);
      }
export type RejectMcTrafficCampaignPlacementsMutationHookResult = ReturnType<typeof useRejectMcTrafficCampaignPlacementsMutation>;
export type RejectMcTrafficCampaignPlacementsMutationResult = Apollo.MutationResult<RejectMcTrafficCampaignPlacementsMutation>;
export type RejectMcTrafficCampaignPlacementsMutationOptions = Apollo.BaseMutationOptions<RejectMcTrafficCampaignPlacementsMutation, RejectMcTrafficCampaignPlacementsMutationVariables>;
export const SuspendMcTrafficCampaignPlacementsDocument = gql`
    mutation suspendMCTrafficCampaignPlacements($input: TransitionTrafficCampaignPlacementsInput!) {
  transitionTrafficCampaignPlacements(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type SuspendMcTrafficCampaignPlacementsMutationFn = Apollo.MutationFunction<SuspendMcTrafficCampaignPlacementsMutation, SuspendMcTrafficCampaignPlacementsMutationVariables>;

/**
 * __useSuspendMcTrafficCampaignPlacementsMutation__
 *
 * To run a mutation, you first call `useSuspendMcTrafficCampaignPlacementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendMcTrafficCampaignPlacementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendMcTrafficCampaignPlacementsMutation, { data, loading, error }] = useSuspendMcTrafficCampaignPlacementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuspendMcTrafficCampaignPlacementsMutation(baseOptions?: Apollo.MutationHookOptions<SuspendMcTrafficCampaignPlacementsMutation, SuspendMcTrafficCampaignPlacementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendMcTrafficCampaignPlacementsMutation, SuspendMcTrafficCampaignPlacementsMutationVariables>(SuspendMcTrafficCampaignPlacementsDocument, options);
      }
export type SuspendMcTrafficCampaignPlacementsMutationHookResult = ReturnType<typeof useSuspendMcTrafficCampaignPlacementsMutation>;
export type SuspendMcTrafficCampaignPlacementsMutationResult = Apollo.MutationResult<SuspendMcTrafficCampaignPlacementsMutation>;
export type SuspendMcTrafficCampaignPlacementsMutationOptions = Apollo.BaseMutationOptions<SuspendMcTrafficCampaignPlacementsMutation, SuspendMcTrafficCampaignPlacementsMutationVariables>;
export const RequestCbrApprovalMcTrafficCampaignPlacementsDocument = gql`
    mutation requestCbrApprovalMCTrafficCampaignPlacements($input: TransitionTrafficCampaignPlacementsInput!) {
  transitionTrafficCampaignPlacements(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type RequestCbrApprovalMcTrafficCampaignPlacementsMutationFn = Apollo.MutationFunction<RequestCbrApprovalMcTrafficCampaignPlacementsMutation, RequestCbrApprovalMcTrafficCampaignPlacementsMutationVariables>;

/**
 * __useRequestCbrApprovalMcTrafficCampaignPlacementsMutation__
 *
 * To run a mutation, you first call `useRequestCbrApprovalMcTrafficCampaignPlacementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCbrApprovalMcTrafficCampaignPlacementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCbrApprovalMcTrafficCampaignPlacementsMutation, { data, loading, error }] = useRequestCbrApprovalMcTrafficCampaignPlacementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCbrApprovalMcTrafficCampaignPlacementsMutation(baseOptions?: Apollo.MutationHookOptions<RequestCbrApprovalMcTrafficCampaignPlacementsMutation, RequestCbrApprovalMcTrafficCampaignPlacementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCbrApprovalMcTrafficCampaignPlacementsMutation, RequestCbrApprovalMcTrafficCampaignPlacementsMutationVariables>(RequestCbrApprovalMcTrafficCampaignPlacementsDocument, options);
      }
export type RequestCbrApprovalMcTrafficCampaignPlacementsMutationHookResult = ReturnType<typeof useRequestCbrApprovalMcTrafficCampaignPlacementsMutation>;
export type RequestCbrApprovalMcTrafficCampaignPlacementsMutationResult = Apollo.MutationResult<RequestCbrApprovalMcTrafficCampaignPlacementsMutation>;
export type RequestCbrApprovalMcTrafficCampaignPlacementsMutationOptions = Apollo.BaseMutationOptions<RequestCbrApprovalMcTrafficCampaignPlacementsMutation, RequestCbrApprovalMcTrafficCampaignPlacementsMutationVariables>;
export const CancelCbrApprovalRequestMcTrafficCampaignPlacementsDocument = gql`
    mutation cancelCbrApprovalRequestMCTrafficCampaignPlacements($input: TransitionTrafficCampaignPlacementsInput!) {
  transitionTrafficCampaignPlacements(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type CancelCbrApprovalRequestMcTrafficCampaignPlacementsMutationFn = Apollo.MutationFunction<CancelCbrApprovalRequestMcTrafficCampaignPlacementsMutation, CancelCbrApprovalRequestMcTrafficCampaignPlacementsMutationVariables>;

/**
 * __useCancelCbrApprovalRequestMcTrafficCampaignPlacementsMutation__
 *
 * To run a mutation, you first call `useCancelCbrApprovalRequestMcTrafficCampaignPlacementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCbrApprovalRequestMcTrafficCampaignPlacementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCbrApprovalRequestMcTrafficCampaignPlacementsMutation, { data, loading, error }] = useCancelCbrApprovalRequestMcTrafficCampaignPlacementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelCbrApprovalRequestMcTrafficCampaignPlacementsMutation(baseOptions?: Apollo.MutationHookOptions<CancelCbrApprovalRequestMcTrafficCampaignPlacementsMutation, CancelCbrApprovalRequestMcTrafficCampaignPlacementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCbrApprovalRequestMcTrafficCampaignPlacementsMutation, CancelCbrApprovalRequestMcTrafficCampaignPlacementsMutationVariables>(CancelCbrApprovalRequestMcTrafficCampaignPlacementsDocument, options);
      }
export type CancelCbrApprovalRequestMcTrafficCampaignPlacementsMutationHookResult = ReturnType<typeof useCancelCbrApprovalRequestMcTrafficCampaignPlacementsMutation>;
export type CancelCbrApprovalRequestMcTrafficCampaignPlacementsMutationResult = Apollo.MutationResult<CancelCbrApprovalRequestMcTrafficCampaignPlacementsMutation>;
export type CancelCbrApprovalRequestMcTrafficCampaignPlacementsMutationOptions = Apollo.BaseMutationOptions<CancelCbrApprovalRequestMcTrafficCampaignPlacementsMutation, CancelCbrApprovalRequestMcTrafficCampaignPlacementsMutationVariables>;
export const CreateTransitionJobDocument = gql`
    mutation CreateTransitionJob($input: TransitionTrafficCampaignInput!) {
  createMCCTransitionJob(input: $input) {
    job {
      ... on MCCTransitionJob {
        id
        status
      }
    }
  }
}
    `;
export type CreateTransitionJobMutationFn = Apollo.MutationFunction<CreateTransitionJobMutation, CreateTransitionJobMutationVariables>;

/**
 * __useCreateTransitionJobMutation__
 *
 * To run a mutation, you first call `useCreateTransitionJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransitionJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransitionJobMutation, { data, loading, error }] = useCreateTransitionJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransitionJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransitionJobMutation, CreateTransitionJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransitionJobMutation, CreateTransitionJobMutationVariables>(CreateTransitionJobDocument, options);
      }
export type CreateTransitionJobMutationHookResult = ReturnType<typeof useCreateTransitionJobMutation>;
export type CreateTransitionJobMutationResult = Apollo.MutationResult<CreateTransitionJobMutation>;
export type CreateTransitionJobMutationOptions = Apollo.BaseMutationOptions<CreateTransitionJobMutation, CreateTransitionJobMutationVariables>;
export const JobTransitionStatusDocument = gql`
    query JobTransitionStatus($jobId: ID!) {
  job(id: $jobId) {
    ... on MCCTransitionJob {
      status
      id
      metadata {
        campaign {
          ...TrafficCampaignPage
        }
      }
    }
  }
}
    ${TrafficCampaignPageFragmentDoc}`;

/**
 * __useJobTransitionStatusQuery__
 *
 * To run a query within a React component, call `useJobTransitionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTransitionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTransitionStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useJobTransitionStatusQuery(baseOptions: Apollo.QueryHookOptions<JobTransitionStatusQuery, JobTransitionStatusQueryVariables> & ({ variables: JobTransitionStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobTransitionStatusQuery, JobTransitionStatusQueryVariables>(JobTransitionStatusDocument, options);
      }
export function useJobTransitionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobTransitionStatusQuery, JobTransitionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobTransitionStatusQuery, JobTransitionStatusQueryVariables>(JobTransitionStatusDocument, options);
        }
// @ts-ignore
export function useJobTransitionStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobTransitionStatusQuery, JobTransitionStatusQueryVariables>): Apollo.UseSuspenseQueryResult<JobTransitionStatusQuery, JobTransitionStatusQueryVariables>;
export function useJobTransitionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobTransitionStatusQuery, JobTransitionStatusQueryVariables>): Apollo.UseSuspenseQueryResult<JobTransitionStatusQuery | undefined, JobTransitionStatusQueryVariables>;
export function useJobTransitionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobTransitionStatusQuery, JobTransitionStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobTransitionStatusQuery, JobTransitionStatusQueryVariables>(JobTransitionStatusDocument, options);
        }
export type JobTransitionStatusQueryHookResult = ReturnType<typeof useJobTransitionStatusQuery>;
export type JobTransitionStatusLazyQueryHookResult = ReturnType<typeof useJobTransitionStatusLazyQuery>;
export type JobTransitionStatusSuspenseQueryHookResult = ReturnType<typeof useJobTransitionStatusSuspenseQuery>;
export type JobTransitionStatusQueryResult = Apollo.QueryResult<JobTransitionStatusQuery, JobTransitionStatusQueryVariables>;
export const SummaryTableBullseyeDocument = gql`
    query summaryTableBullseye($bullseyeSegmentIds: [BullseyeSegmentID!]!, $bullseyeSegmentRealm: String!) {
  BullseyeSegmentStatuses(ids: $bullseyeSegmentIds, realm: $bullseyeSegmentRealm) {
    ... on BullseyeSegmentStatus {
      ...BullseyeSegmentDataRowSegment
    }
    ... on BullseyeSegmentError {
      ...BullseyeDataSegmentDataRowError
    }
  }
}
    ${BullseyeSegmentDataRowSegmentFragmentDoc}
${BullseyeDataSegmentDataRowErrorFragmentDoc}`;

/**
 * __useSummaryTableBullseyeQuery__
 *
 * To run a query within a React component, call `useSummaryTableBullseyeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummaryTableBullseyeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryTableBullseyeQuery({
 *   variables: {
 *      bullseyeSegmentIds: // value for 'bullseyeSegmentIds'
 *      bullseyeSegmentRealm: // value for 'bullseyeSegmentRealm'
 *   },
 * });
 */
export function useSummaryTableBullseyeQuery(baseOptions: Apollo.QueryHookOptions<SummaryTableBullseyeQuery, SummaryTableBullseyeQueryVariables> & ({ variables: SummaryTableBullseyeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummaryTableBullseyeQuery, SummaryTableBullseyeQueryVariables>(SummaryTableBullseyeDocument, options);
      }
export function useSummaryTableBullseyeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummaryTableBullseyeQuery, SummaryTableBullseyeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummaryTableBullseyeQuery, SummaryTableBullseyeQueryVariables>(SummaryTableBullseyeDocument, options);
        }
// @ts-ignore
export function useSummaryTableBullseyeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SummaryTableBullseyeQuery, SummaryTableBullseyeQueryVariables>): Apollo.UseSuspenseQueryResult<SummaryTableBullseyeQuery, SummaryTableBullseyeQueryVariables>;
export function useSummaryTableBullseyeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummaryTableBullseyeQuery, SummaryTableBullseyeQueryVariables>): Apollo.UseSuspenseQueryResult<SummaryTableBullseyeQuery | undefined, SummaryTableBullseyeQueryVariables>;
export function useSummaryTableBullseyeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummaryTableBullseyeQuery, SummaryTableBullseyeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummaryTableBullseyeQuery, SummaryTableBullseyeQueryVariables>(SummaryTableBullseyeDocument, options);
        }
export type SummaryTableBullseyeQueryHookResult = ReturnType<typeof useSummaryTableBullseyeQuery>;
export type SummaryTableBullseyeLazyQueryHookResult = ReturnType<typeof useSummaryTableBullseyeLazyQuery>;
export type SummaryTableBullseyeSuspenseQueryHookResult = ReturnType<typeof useSummaryTableBullseyeSuspenseQuery>;
export type SummaryTableBullseyeQueryResult = Apollo.QueryResult<SummaryTableBullseyeQuery, SummaryTableBullseyeQueryVariables>;
export const CampaignConfigLabelsDocument = gql`
    query CampaignConfigLabels {
  campaignConfigurations(first: 1000) {
    nodes {
      ...CampaignConfigLabels
    }
  }
}
    ${CampaignConfigLabelsFragmentDoc}`;

/**
 * __useCampaignConfigLabelsQuery__
 *
 * To run a query within a React component, call `useCampaignConfigLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignConfigLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignConfigLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCampaignConfigLabelsQuery(baseOptions?: Apollo.QueryHookOptions<CampaignConfigLabelsQuery, CampaignConfigLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignConfigLabelsQuery, CampaignConfigLabelsQueryVariables>(CampaignConfigLabelsDocument, options);
      }
export function useCampaignConfigLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignConfigLabelsQuery, CampaignConfigLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignConfigLabelsQuery, CampaignConfigLabelsQueryVariables>(CampaignConfigLabelsDocument, options);
        }
// @ts-ignore
export function useCampaignConfigLabelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampaignConfigLabelsQuery, CampaignConfigLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignConfigLabelsQuery, CampaignConfigLabelsQueryVariables>;
export function useCampaignConfigLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignConfigLabelsQuery, CampaignConfigLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignConfigLabelsQuery | undefined, CampaignConfigLabelsQueryVariables>;
export function useCampaignConfigLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignConfigLabelsQuery, CampaignConfigLabelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignConfigLabelsQuery, CampaignConfigLabelsQueryVariables>(CampaignConfigLabelsDocument, options);
        }
export type CampaignConfigLabelsQueryHookResult = ReturnType<typeof useCampaignConfigLabelsQuery>;
export type CampaignConfigLabelsLazyQueryHookResult = ReturnType<typeof useCampaignConfigLabelsLazyQuery>;
export type CampaignConfigLabelsSuspenseQueryHookResult = ReturnType<typeof useCampaignConfigLabelsSuspenseQuery>;
export type CampaignConfigLabelsQueryResult = Apollo.QueryResult<CampaignConfigLabelsQuery, CampaignConfigLabelsQueryVariables>;
export const ArchiveOrRestoreTrafficCampaignsDocument = gql`
    mutation archiveOrRestoreTrafficCampaigns($input: ArchiveOrRestoreTrafficCampaignsInput!) {
  archiveOrRestoreTrafficCampaigns(input: $input) {
    campaigns {
      id
    }
  }
}
    `;
export type ArchiveOrRestoreTrafficCampaignsMutationFn = Apollo.MutationFunction<ArchiveOrRestoreTrafficCampaignsMutation, ArchiveOrRestoreTrafficCampaignsMutationVariables>;

/**
 * __useArchiveOrRestoreTrafficCampaignsMutation__
 *
 * To run a mutation, you first call `useArchiveOrRestoreTrafficCampaignsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveOrRestoreTrafficCampaignsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveOrRestoreTrafficCampaignsMutation, { data, loading, error }] = useArchiveOrRestoreTrafficCampaignsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveOrRestoreTrafficCampaignsMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveOrRestoreTrafficCampaignsMutation, ArchiveOrRestoreTrafficCampaignsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveOrRestoreTrafficCampaignsMutation, ArchiveOrRestoreTrafficCampaignsMutationVariables>(ArchiveOrRestoreTrafficCampaignsDocument, options);
      }
export type ArchiveOrRestoreTrafficCampaignsMutationHookResult = ReturnType<typeof useArchiveOrRestoreTrafficCampaignsMutation>;
export type ArchiveOrRestoreTrafficCampaignsMutationResult = Apollo.MutationResult<ArchiveOrRestoreTrafficCampaignsMutation>;
export type ArchiveOrRestoreTrafficCampaignsMutationOptions = Apollo.BaseMutationOptions<ArchiveOrRestoreTrafficCampaignsMutation, ArchiveOrRestoreTrafficCampaignsMutationVariables>;
export const ArchiveOrRestoreTrafficCampaignMccDocument = gql`
    mutation archiveOrRestoreTrafficCampaignMcc($input: ArchiveOrRestoreTrafficCampaignsInput!) {
  archiveOrRestoreTrafficCampaigns(input: $input) {
    campaigns {
      ...TPCampaignSidebar
      ...TPCampaignRequiredFormFields
    }
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type ArchiveOrRestoreTrafficCampaignMccMutationFn = Apollo.MutationFunction<ArchiveOrRestoreTrafficCampaignMccMutation, ArchiveOrRestoreTrafficCampaignMccMutationVariables>;

/**
 * __useArchiveOrRestoreTrafficCampaignMccMutation__
 *
 * To run a mutation, you first call `useArchiveOrRestoreTrafficCampaignMccMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveOrRestoreTrafficCampaignMccMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveOrRestoreTrafficCampaignMccMutation, { data, loading, error }] = useArchiveOrRestoreTrafficCampaignMccMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveOrRestoreTrafficCampaignMccMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveOrRestoreTrafficCampaignMccMutation, ArchiveOrRestoreTrafficCampaignMccMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveOrRestoreTrafficCampaignMccMutation, ArchiveOrRestoreTrafficCampaignMccMutationVariables>(ArchiveOrRestoreTrafficCampaignMccDocument, options);
      }
export type ArchiveOrRestoreTrafficCampaignMccMutationHookResult = ReturnType<typeof useArchiveOrRestoreTrafficCampaignMccMutation>;
export type ArchiveOrRestoreTrafficCampaignMccMutationResult = Apollo.MutationResult<ArchiveOrRestoreTrafficCampaignMccMutation>;
export type ArchiveOrRestoreTrafficCampaignMccMutationOptions = Apollo.BaseMutationOptions<ArchiveOrRestoreTrafficCampaignMccMutation, ArchiveOrRestoreTrafficCampaignMccMutationVariables>;
export const PasteTrafficCampaignsToDifferentProjectDocument = gql`
    mutation pasteTrafficCampaignsToDifferentProject($input: PasteTrafficCampaignsToDifferentProjectInput!) {
  pasteTrafficCampaignsToDifferentProject(input: $input) {
    success
  }
}
    `;
export type PasteTrafficCampaignsToDifferentProjectMutationFn = Apollo.MutationFunction<PasteTrafficCampaignsToDifferentProjectMutation, PasteTrafficCampaignsToDifferentProjectMutationVariables>;

/**
 * __usePasteTrafficCampaignsToDifferentProjectMutation__
 *
 * To run a mutation, you first call `usePasteTrafficCampaignsToDifferentProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasteTrafficCampaignsToDifferentProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pasteTrafficCampaignsToDifferentProjectMutation, { data, loading, error }] = usePasteTrafficCampaignsToDifferentProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasteTrafficCampaignsToDifferentProjectMutation(baseOptions?: Apollo.MutationHookOptions<PasteTrafficCampaignsToDifferentProjectMutation, PasteTrafficCampaignsToDifferentProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasteTrafficCampaignsToDifferentProjectMutation, PasteTrafficCampaignsToDifferentProjectMutationVariables>(PasteTrafficCampaignsToDifferentProjectDocument, options);
      }
export type PasteTrafficCampaignsToDifferentProjectMutationHookResult = ReturnType<typeof usePasteTrafficCampaignsToDifferentProjectMutation>;
export type PasteTrafficCampaignsToDifferentProjectMutationResult = Apollo.MutationResult<PasteTrafficCampaignsToDifferentProjectMutation>;
export type PasteTrafficCampaignsToDifferentProjectMutationOptions = Apollo.BaseMutationOptions<PasteTrafficCampaignsToDifferentProjectMutation, PasteTrafficCampaignsToDifferentProjectMutationVariables>;
export const TrafficCampaignsDocument = gql`
    query TrafficCampaigns($projectId: ID!, $first: Int, $after: String, $last: Int, $before: String, $sortOptions: TrafficCampaingsSortOptionsInput!, $includeLegacy: Boolean!, $filterByView: CampaignFilterByViewInput!, $filterColumnMap: FilterColumnInputType!, $loadFromSymphony: Boolean = true) {
  trafficProject(id: $projectId) {
    id
    ...TPEvent
    campaigns(
      first: $first
      after: $after
      last: $last
      before: $before
      sortOptions: $sortOptions
      includeLegacy: $includeLegacy
      filterByView: $filterByView
      filterColumnMap: $filterColumnMap
    ) {
      edges {
        cursor
        node {
          ...TrafficCampaignsTableData
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      ...TrafficCampaignsFilterOptionValues
    }
  }
}
    ${TpEventFragmentDoc}
${TrafficCampaignsTableDataFragmentDoc}
${TrafficCampaignsFilterOptionValuesFragmentDoc}`;

/**
 * __useTrafficCampaignsQuery__
 *
 * To run a query within a React component, call `useTrafficCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficCampaignsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      sortOptions: // value for 'sortOptions'
 *      includeLegacy: // value for 'includeLegacy'
 *      filterByView: // value for 'filterByView'
 *      filterColumnMap: // value for 'filterColumnMap'
 *      loadFromSymphony: // value for 'loadFromSymphony'
 *   },
 * });
 */
export function useTrafficCampaignsQuery(baseOptions: Apollo.QueryHookOptions<TrafficCampaignsQuery, TrafficCampaignsQueryVariables> & ({ variables: TrafficCampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficCampaignsQuery, TrafficCampaignsQueryVariables>(TrafficCampaignsDocument, options);
      }
export function useTrafficCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficCampaignsQuery, TrafficCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficCampaignsQuery, TrafficCampaignsQueryVariables>(TrafficCampaignsDocument, options);
        }
// @ts-ignore
export function useTrafficCampaignsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrafficCampaignsQuery, TrafficCampaignsQueryVariables>): Apollo.UseSuspenseQueryResult<TrafficCampaignsQuery, TrafficCampaignsQueryVariables>;
export function useTrafficCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrafficCampaignsQuery, TrafficCampaignsQueryVariables>): Apollo.UseSuspenseQueryResult<TrafficCampaignsQuery | undefined, TrafficCampaignsQueryVariables>;
export function useTrafficCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrafficCampaignsQuery, TrafficCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrafficCampaignsQuery, TrafficCampaignsQueryVariables>(TrafficCampaignsDocument, options);
        }
export type TrafficCampaignsQueryHookResult = ReturnType<typeof useTrafficCampaignsQuery>;
export type TrafficCampaignsLazyQueryHookResult = ReturnType<typeof useTrafficCampaignsLazyQuery>;
export type TrafficCampaignsSuspenseQueryHookResult = ReturnType<typeof useTrafficCampaignsSuspenseQuery>;
export type TrafficCampaignsQueryResult = Apollo.QueryResult<TrafficCampaignsQuery, TrafficCampaignsQueryVariables>;
export const TrafficCampaignStatusBadgeDocument = gql`
    query TrafficCampaignStatusBadge($id: ID!, $projectId: ID!) {
  trafficCampaign(id: $id, projectId: $projectId) {
    ...TrafficCampaignStatusBadgeData
  }
}
    ${TrafficCampaignStatusBadgeDataFragmentDoc}`;

/**
 * __useTrafficCampaignStatusBadgeQuery__
 *
 * To run a query within a React component, call `useTrafficCampaignStatusBadgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrafficCampaignStatusBadgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrafficCampaignStatusBadgeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTrafficCampaignStatusBadgeQuery(baseOptions: Apollo.QueryHookOptions<TrafficCampaignStatusBadgeQuery, TrafficCampaignStatusBadgeQueryVariables> & ({ variables: TrafficCampaignStatusBadgeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrafficCampaignStatusBadgeQuery, TrafficCampaignStatusBadgeQueryVariables>(TrafficCampaignStatusBadgeDocument, options);
      }
export function useTrafficCampaignStatusBadgeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrafficCampaignStatusBadgeQuery, TrafficCampaignStatusBadgeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrafficCampaignStatusBadgeQuery, TrafficCampaignStatusBadgeQueryVariables>(TrafficCampaignStatusBadgeDocument, options);
        }
// @ts-ignore
export function useTrafficCampaignStatusBadgeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrafficCampaignStatusBadgeQuery, TrafficCampaignStatusBadgeQueryVariables>): Apollo.UseSuspenseQueryResult<TrafficCampaignStatusBadgeQuery, TrafficCampaignStatusBadgeQueryVariables>;
export function useTrafficCampaignStatusBadgeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrafficCampaignStatusBadgeQuery, TrafficCampaignStatusBadgeQueryVariables>): Apollo.UseSuspenseQueryResult<TrafficCampaignStatusBadgeQuery | undefined, TrafficCampaignStatusBadgeQueryVariables>;
export function useTrafficCampaignStatusBadgeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrafficCampaignStatusBadgeQuery, TrafficCampaignStatusBadgeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrafficCampaignStatusBadgeQuery, TrafficCampaignStatusBadgeQueryVariables>(TrafficCampaignStatusBadgeDocument, options);
        }
export type TrafficCampaignStatusBadgeQueryHookResult = ReturnType<typeof useTrafficCampaignStatusBadgeQuery>;
export type TrafficCampaignStatusBadgeLazyQueryHookResult = ReturnType<typeof useTrafficCampaignStatusBadgeLazyQuery>;
export type TrafficCampaignStatusBadgeSuspenseQueryHookResult = ReturnType<typeof useTrafficCampaignStatusBadgeSuspenseQuery>;
export type TrafficCampaignStatusBadgeQueryResult = Apollo.QueryResult<TrafficCampaignStatusBadgeQuery, TrafficCampaignStatusBadgeQueryVariables>;
export const RequestApprovalTrafficCampaignPlacementsDocument = gql`
    mutation requestApprovalTrafficCampaignPlacements($input: TransitionTrafficCampaignPlacementsInput!) {
  transitionTrafficCampaignPlacements(input: $input) {
    ...TPCampaignSidebar
    ...TPCampaignRequiredFormFields
  }
}
    ${TpCampaignSidebarFragmentDoc}
${TpCampaignRequiredFormFieldsFragmentDoc}`;
export type RequestApprovalTrafficCampaignPlacementsMutationFn = Apollo.MutationFunction<RequestApprovalTrafficCampaignPlacementsMutation, RequestApprovalTrafficCampaignPlacementsMutationVariables>;

/**
 * __useRequestApprovalTrafficCampaignPlacementsMutation__
 *
 * To run a mutation, you first call `useRequestApprovalTrafficCampaignPlacementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestApprovalTrafficCampaignPlacementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestApprovalTrafficCampaignPlacementsMutation, { data, loading, error }] = useRequestApprovalTrafficCampaignPlacementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestApprovalTrafficCampaignPlacementsMutation(baseOptions?: Apollo.MutationHookOptions<RequestApprovalTrafficCampaignPlacementsMutation, RequestApprovalTrafficCampaignPlacementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestApprovalTrafficCampaignPlacementsMutation, RequestApprovalTrafficCampaignPlacementsMutationVariables>(RequestApprovalTrafficCampaignPlacementsDocument, options);
      }
export type RequestApprovalTrafficCampaignPlacementsMutationHookResult = ReturnType<typeof useRequestApprovalTrafficCampaignPlacementsMutation>;
export type RequestApprovalTrafficCampaignPlacementsMutationResult = Apollo.MutationResult<RequestApprovalTrafficCampaignPlacementsMutation>;
export type RequestApprovalTrafficCampaignPlacementsMutationOptions = Apollo.BaseMutationOptions<RequestApprovalTrafficCampaignPlacementsMutation, RequestApprovalTrafficCampaignPlacementsMutationVariables>;
export const AsinsForProgramDocument = gql`
    query AsinsForProgram($first: Int!, $filters: AsinFilterInput, $after: String, $sortOptions: [ASINSortInput!]) {
  asins(
    first: $first
    filters: $filters
    after: $after
    sortOptions: $sortOptions
  ) {
    nodes {
      asin
    }
    totalCount
  }
}
    `;

/**
 * __useAsinsForProgramQuery__
 *
 * To run a query within a React component, call `useAsinsForProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsinsForProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsinsForProgramQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      sortOptions: // value for 'sortOptions'
 *   },
 * });
 */
export function useAsinsForProgramQuery(baseOptions: Apollo.QueryHookOptions<AsinsForProgramQuery, AsinsForProgramQueryVariables> & ({ variables: AsinsForProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsinsForProgramQuery, AsinsForProgramQueryVariables>(AsinsForProgramDocument, options);
      }
export function useAsinsForProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsinsForProgramQuery, AsinsForProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsinsForProgramQuery, AsinsForProgramQueryVariables>(AsinsForProgramDocument, options);
        }
// @ts-ignore
export function useAsinsForProgramSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AsinsForProgramQuery, AsinsForProgramQueryVariables>): Apollo.UseSuspenseQueryResult<AsinsForProgramQuery, AsinsForProgramQueryVariables>;
export function useAsinsForProgramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AsinsForProgramQuery, AsinsForProgramQueryVariables>): Apollo.UseSuspenseQueryResult<AsinsForProgramQuery | undefined, AsinsForProgramQueryVariables>;
export function useAsinsForProgramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AsinsForProgramQuery, AsinsForProgramQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AsinsForProgramQuery, AsinsForProgramQueryVariables>(AsinsForProgramDocument, options);
        }
export type AsinsForProgramQueryHookResult = ReturnType<typeof useAsinsForProgramQuery>;
export type AsinsForProgramLazyQueryHookResult = ReturnType<typeof useAsinsForProgramLazyQuery>;
export type AsinsForProgramSuspenseQueryHookResult = ReturnType<typeof useAsinsForProgramSuspenseQuery>;
export type AsinsForProgramQueryResult = Apollo.QueryResult<AsinsForProgramQuery, AsinsForProgramQueryVariables>;
export const MetadataForAsinsDocument = gql`
    query MetadataForAsins($asinList: [String!]!, $marketplace: String!, $locale: String!) {
  mvesCatalogTitles(
    asinList: $asinList
    marketplace: $marketplace
    locale: $locale
  ) {
    title
  }
  mvesVariantImagesForAsins(asinList: $asinList, marketplace: $marketplace) {
    images
  }
}
    `;

/**
 * __useMetadataForAsinsQuery__
 *
 * To run a query within a React component, call `useMetadataForAsinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetadataForAsinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetadataForAsinsQuery({
 *   variables: {
 *      asinList: // value for 'asinList'
 *      marketplace: // value for 'marketplace'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useMetadataForAsinsQuery(baseOptions: Apollo.QueryHookOptions<MetadataForAsinsQuery, MetadataForAsinsQueryVariables> & ({ variables: MetadataForAsinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetadataForAsinsQuery, MetadataForAsinsQueryVariables>(MetadataForAsinsDocument, options);
      }
export function useMetadataForAsinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetadataForAsinsQuery, MetadataForAsinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetadataForAsinsQuery, MetadataForAsinsQueryVariables>(MetadataForAsinsDocument, options);
        }
// @ts-ignore
export function useMetadataForAsinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MetadataForAsinsQuery, MetadataForAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<MetadataForAsinsQuery, MetadataForAsinsQueryVariables>;
export function useMetadataForAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetadataForAsinsQuery, MetadataForAsinsQueryVariables>): Apollo.UseSuspenseQueryResult<MetadataForAsinsQuery | undefined, MetadataForAsinsQueryVariables>;
export function useMetadataForAsinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetadataForAsinsQuery, MetadataForAsinsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetadataForAsinsQuery, MetadataForAsinsQueryVariables>(MetadataForAsinsDocument, options);
        }
export type MetadataForAsinsQueryHookResult = ReturnType<typeof useMetadataForAsinsQuery>;
export type MetadataForAsinsLazyQueryHookResult = ReturnType<typeof useMetadataForAsinsLazyQuery>;
export type MetadataForAsinsSuspenseQueryHookResult = ReturnType<typeof useMetadataForAsinsSuspenseQuery>;
export type MetadataForAsinsQueryResult = Apollo.QueryResult<MetadataForAsinsQuery, MetadataForAsinsQueryVariables>;
export const FbKeywordRecsDocument = gql`
    query fbKeywordRecs($input: GetFBKeywordRecsInput!) {
  fbKeywordRecs(input: $input) {
    keywordRecsUrl
    expirationDate
  }
}
    `;

/**
 * __useFbKeywordRecsQuery__
 *
 * To run a query within a React component, call `useFbKeywordRecsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFbKeywordRecsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFbKeywordRecsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFbKeywordRecsQuery(baseOptions: Apollo.QueryHookOptions<FbKeywordRecsQuery, FbKeywordRecsQueryVariables> & ({ variables: FbKeywordRecsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FbKeywordRecsQuery, FbKeywordRecsQueryVariables>(FbKeywordRecsDocument, options);
      }
export function useFbKeywordRecsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FbKeywordRecsQuery, FbKeywordRecsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FbKeywordRecsQuery, FbKeywordRecsQueryVariables>(FbKeywordRecsDocument, options);
        }
// @ts-ignore
export function useFbKeywordRecsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FbKeywordRecsQuery, FbKeywordRecsQueryVariables>): Apollo.UseSuspenseQueryResult<FbKeywordRecsQuery, FbKeywordRecsQueryVariables>;
export function useFbKeywordRecsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FbKeywordRecsQuery, FbKeywordRecsQueryVariables>): Apollo.UseSuspenseQueryResult<FbKeywordRecsQuery | undefined, FbKeywordRecsQueryVariables>;
export function useFbKeywordRecsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FbKeywordRecsQuery, FbKeywordRecsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FbKeywordRecsQuery, FbKeywordRecsQueryVariables>(FbKeywordRecsDocument, options);
        }
export type FbKeywordRecsQueryHookResult = ReturnType<typeof useFbKeywordRecsQuery>;
export type FbKeywordRecsLazyQueryHookResult = ReturnType<typeof useFbKeywordRecsLazyQuery>;
export type FbKeywordRecsSuspenseQueryHookResult = ReturnType<typeof useFbKeywordRecsSuspenseQuery>;
export type FbKeywordRecsQueryResult = Apollo.QueryResult<FbKeywordRecsQuery, FbKeywordRecsQueryVariables>;
export const ProgramsForMarketplaceDocument = gql`
    query ProgramsForMarketplace($first: Int!, $filters: ProgramFilterInput, $after: String, $sortOptions: [ProgramSortInput!]) {
  programs(
    first: $first
    filters: $filters
    after: $after
    sortOptions: $sortOptions
  ) {
    nodes {
      id
      name
      programId
    }
    pageInfo {
      hasNextPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useProgramsForMarketplaceQuery__
 *
 * To run a query within a React component, call `useProgramsForMarketplaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramsForMarketplaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramsForMarketplaceQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      sortOptions: // value for 'sortOptions'
 *   },
 * });
 */
export function useProgramsForMarketplaceQuery(baseOptions: Apollo.QueryHookOptions<ProgramsForMarketplaceQuery, ProgramsForMarketplaceQueryVariables> & ({ variables: ProgramsForMarketplaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramsForMarketplaceQuery, ProgramsForMarketplaceQueryVariables>(ProgramsForMarketplaceDocument, options);
      }
export function useProgramsForMarketplaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramsForMarketplaceQuery, ProgramsForMarketplaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramsForMarketplaceQuery, ProgramsForMarketplaceQueryVariables>(ProgramsForMarketplaceDocument, options);
        }
// @ts-ignore
export function useProgramsForMarketplaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProgramsForMarketplaceQuery, ProgramsForMarketplaceQueryVariables>): Apollo.UseSuspenseQueryResult<ProgramsForMarketplaceQuery, ProgramsForMarketplaceQueryVariables>;
export function useProgramsForMarketplaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramsForMarketplaceQuery, ProgramsForMarketplaceQueryVariables>): Apollo.UseSuspenseQueryResult<ProgramsForMarketplaceQuery | undefined, ProgramsForMarketplaceQueryVariables>;
export function useProgramsForMarketplaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramsForMarketplaceQuery, ProgramsForMarketplaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgramsForMarketplaceQuery, ProgramsForMarketplaceQueryVariables>(ProgramsForMarketplaceDocument, options);
        }
export type ProgramsForMarketplaceQueryHookResult = ReturnType<typeof useProgramsForMarketplaceQuery>;
export type ProgramsForMarketplaceLazyQueryHookResult = ReturnType<typeof useProgramsForMarketplaceLazyQuery>;
export type ProgramsForMarketplaceSuspenseQueryHookResult = ReturnType<typeof useProgramsForMarketplaceSuspenseQuery>;
export type ProgramsForMarketplaceQueryResult = Apollo.QueryResult<ProgramsForMarketplaceQuery, ProgramsForMarketplaceQueryVariables>;
export const GetAssetsByIdsDocument = gql`
    query GetAssetsByIds($input: GetAssetsByIdsInput!) {
  getAssetsByIds(input: $input) {
    assets {
      assetId
      s3SignedUrlGet
      thumbnail
      name
    }
    errors
  }
}
    `;

/**
 * __useGetAssetsByIdsQuery__
 *
 * To run a query within a React component, call `useGetAssetsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetsByIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssetsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetAssetsByIdsQuery, GetAssetsByIdsQueryVariables> & ({ variables: GetAssetsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetsByIdsQuery, GetAssetsByIdsQueryVariables>(GetAssetsByIdsDocument, options);
      }
export function useGetAssetsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetsByIdsQuery, GetAssetsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetsByIdsQuery, GetAssetsByIdsQueryVariables>(GetAssetsByIdsDocument, options);
        }
// @ts-ignore
export function useGetAssetsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssetsByIdsQuery, GetAssetsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssetsByIdsQuery, GetAssetsByIdsQueryVariables>;
export function useGetAssetsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssetsByIdsQuery, GetAssetsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssetsByIdsQuery | undefined, GetAssetsByIdsQueryVariables>;
export function useGetAssetsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssetsByIdsQuery, GetAssetsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssetsByIdsQuery, GetAssetsByIdsQueryVariables>(GetAssetsByIdsDocument, options);
        }
export type GetAssetsByIdsQueryHookResult = ReturnType<typeof useGetAssetsByIdsQuery>;
export type GetAssetsByIdsLazyQueryHookResult = ReturnType<typeof useGetAssetsByIdsLazyQuery>;
export type GetAssetsByIdsSuspenseQueryHookResult = ReturnType<typeof useGetAssetsByIdsSuspenseQuery>;
export type GetAssetsByIdsQueryResult = Apollo.QueryResult<GetAssetsByIdsQuery, GetAssetsByIdsQueryVariables>;
export const ComponentDetailsV2Document = gql`
    query ComponentDetailsV2($input: ComponentDetailsInput!) {
  componentDetailsV2(input: $input) {
    componentVersion
    componentNamespace
    componentName
  }
}
    `;

/**
 * __useComponentDetailsV2Query__
 *
 * To run a query within a React component, call `useComponentDetailsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useComponentDetailsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComponentDetailsV2Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useComponentDetailsV2Query(baseOptions: Apollo.QueryHookOptions<ComponentDetailsV2Query, ComponentDetailsV2QueryVariables> & ({ variables: ComponentDetailsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComponentDetailsV2Query, ComponentDetailsV2QueryVariables>(ComponentDetailsV2Document, options);
      }
export function useComponentDetailsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComponentDetailsV2Query, ComponentDetailsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComponentDetailsV2Query, ComponentDetailsV2QueryVariables>(ComponentDetailsV2Document, options);
        }
// @ts-ignore
export function useComponentDetailsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComponentDetailsV2Query, ComponentDetailsV2QueryVariables>): Apollo.UseSuspenseQueryResult<ComponentDetailsV2Query, ComponentDetailsV2QueryVariables>;
export function useComponentDetailsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComponentDetailsV2Query, ComponentDetailsV2QueryVariables>): Apollo.UseSuspenseQueryResult<ComponentDetailsV2Query | undefined, ComponentDetailsV2QueryVariables>;
export function useComponentDetailsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComponentDetailsV2Query, ComponentDetailsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComponentDetailsV2Query, ComponentDetailsV2QueryVariables>(ComponentDetailsV2Document, options);
        }
export type ComponentDetailsV2QueryHookResult = ReturnType<typeof useComponentDetailsV2Query>;
export type ComponentDetailsV2LazyQueryHookResult = ReturnType<typeof useComponentDetailsV2LazyQuery>;
export type ComponentDetailsV2SuspenseQueryHookResult = ReturnType<typeof useComponentDetailsV2SuspenseQuery>;
export type ComponentDetailsV2QueryResult = Apollo.QueryResult<ComponentDetailsV2Query, ComponentDetailsV2QueryVariables>;
export const CampaignConfigProviderDocument = gql`
    query CampaignConfigProvider {
  campaignConfigurations(first: 1000) {
    nodes {
      ...CampaignConfigProviderCampaign
    }
  }
}
    ${CampaignConfigProviderCampaignFragmentDoc}`;

/**
 * __useCampaignConfigProviderQuery__
 *
 * To run a query within a React component, call `useCampaignConfigProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignConfigProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignConfigProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useCampaignConfigProviderQuery(baseOptions?: Apollo.QueryHookOptions<CampaignConfigProviderQuery, CampaignConfigProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignConfigProviderQuery, CampaignConfigProviderQueryVariables>(CampaignConfigProviderDocument, options);
      }
export function useCampaignConfigProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignConfigProviderQuery, CampaignConfigProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignConfigProviderQuery, CampaignConfigProviderQueryVariables>(CampaignConfigProviderDocument, options);
        }
// @ts-ignore
export function useCampaignConfigProviderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampaignConfigProviderQuery, CampaignConfigProviderQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignConfigProviderQuery, CampaignConfigProviderQueryVariables>;
export function useCampaignConfigProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignConfigProviderQuery, CampaignConfigProviderQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignConfigProviderQuery | undefined, CampaignConfigProviderQueryVariables>;
export function useCampaignConfigProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignConfigProviderQuery, CampaignConfigProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignConfigProviderQuery, CampaignConfigProviderQueryVariables>(CampaignConfigProviderDocument, options);
        }
export type CampaignConfigProviderQueryHookResult = ReturnType<typeof useCampaignConfigProviderQuery>;
export type CampaignConfigProviderLazyQueryHookResult = ReturnType<typeof useCampaignConfigProviderLazyQuery>;
export type CampaignConfigProviderSuspenseQueryHookResult = ReturnType<typeof useCampaignConfigProviderSuspenseQuery>;
export type CampaignConfigProviderQueryResult = Apollo.QueryResult<CampaignConfigProviderQuery, CampaignConfigProviderQueryVariables>;
export const CampaignConfigsDropdownListDocument = gql`
    query CampaignConfigsDropdownList {
  campaignConfigurations(first: 1000) {
    nodes {
      ...CampaignConfigsDropdownList
    }
  }
}
    ${CampaignConfigsDropdownListFragmentDoc}`;

/**
 * __useCampaignConfigsDropdownListQuery__
 *
 * To run a query within a React component, call `useCampaignConfigsDropdownListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignConfigsDropdownListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignConfigsDropdownListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCampaignConfigsDropdownListQuery(baseOptions?: Apollo.QueryHookOptions<CampaignConfigsDropdownListQuery, CampaignConfigsDropdownListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignConfigsDropdownListQuery, CampaignConfigsDropdownListQueryVariables>(CampaignConfigsDropdownListDocument, options);
      }
export function useCampaignConfigsDropdownListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignConfigsDropdownListQuery, CampaignConfigsDropdownListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignConfigsDropdownListQuery, CampaignConfigsDropdownListQueryVariables>(CampaignConfigsDropdownListDocument, options);
        }
// @ts-ignore
export function useCampaignConfigsDropdownListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampaignConfigsDropdownListQuery, CampaignConfigsDropdownListQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignConfigsDropdownListQuery, CampaignConfigsDropdownListQueryVariables>;
export function useCampaignConfigsDropdownListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignConfigsDropdownListQuery, CampaignConfigsDropdownListQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignConfigsDropdownListQuery | undefined, CampaignConfigsDropdownListQueryVariables>;
export function useCampaignConfigsDropdownListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignConfigsDropdownListQuery, CampaignConfigsDropdownListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignConfigsDropdownListQuery, CampaignConfigsDropdownListQueryVariables>(CampaignConfigsDropdownListDocument, options);
        }
export type CampaignConfigsDropdownListQueryHookResult = ReturnType<typeof useCampaignConfigsDropdownListQuery>;
export type CampaignConfigsDropdownListLazyQueryHookResult = ReturnType<typeof useCampaignConfigsDropdownListLazyQuery>;
export type CampaignConfigsDropdownListSuspenseQueryHookResult = ReturnType<typeof useCampaignConfigsDropdownListSuspenseQuery>;
export type CampaignConfigsDropdownListQueryResult = Apollo.QueryResult<CampaignConfigsDropdownListQuery, CampaignConfigsDropdownListQueryVariables>;
export const RenderMarsWidgetDocument = gql`
    query RenderMarsWidget($currencyCode: String!, $language: String!, $widget: MarsWidgetDefinition!) {
  renderMarsWidget(
    currencyCode: $currencyCode
    language: $language
    widget: $widget
  ) {
    htmlFragments
  }
}
    `;

/**
 * __useRenderMarsWidgetQuery__
 *
 * To run a query within a React component, call `useRenderMarsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderMarsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderMarsWidgetQuery({
 *   variables: {
 *      currencyCode: // value for 'currencyCode'
 *      language: // value for 'language'
 *      widget: // value for 'widget'
 *   },
 * });
 */
export function useRenderMarsWidgetQuery(baseOptions: Apollo.QueryHookOptions<RenderMarsWidgetQuery, RenderMarsWidgetQueryVariables> & ({ variables: RenderMarsWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenderMarsWidgetQuery, RenderMarsWidgetQueryVariables>(RenderMarsWidgetDocument, options);
      }
export function useRenderMarsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenderMarsWidgetQuery, RenderMarsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenderMarsWidgetQuery, RenderMarsWidgetQueryVariables>(RenderMarsWidgetDocument, options);
        }
// @ts-ignore
export function useRenderMarsWidgetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RenderMarsWidgetQuery, RenderMarsWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<RenderMarsWidgetQuery, RenderMarsWidgetQueryVariables>;
export function useRenderMarsWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenderMarsWidgetQuery, RenderMarsWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<RenderMarsWidgetQuery | undefined, RenderMarsWidgetQueryVariables>;
export function useRenderMarsWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenderMarsWidgetQuery, RenderMarsWidgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RenderMarsWidgetQuery, RenderMarsWidgetQueryVariables>(RenderMarsWidgetDocument, options);
        }
export type RenderMarsWidgetQueryHookResult = ReturnType<typeof useRenderMarsWidgetQuery>;
export type RenderMarsWidgetLazyQueryHookResult = ReturnType<typeof useRenderMarsWidgetLazyQuery>;
export type RenderMarsWidgetSuspenseQueryHookResult = ReturnType<typeof useRenderMarsWidgetSuspenseQuery>;
export type RenderMarsWidgetQueryResult = Apollo.QueryResult<RenderMarsWidgetQuery, RenderMarsWidgetQueryVariables>;
export const GetTpAssetMapDocument = gql`
    query GetTPAssetMap($input: AssetSearchRequest!) {
  assetsSearch(input: $input) {
    results {
      searchResults {
        ...TPAssetMap
      }
    }
  }
}
    ${TpAssetMapFragmentDoc}`;

/**
 * __useGetTpAssetMapQuery__
 *
 * To run a query within a React component, call `useGetTpAssetMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTpAssetMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTpAssetMapQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTpAssetMapQuery(baseOptions: Apollo.QueryHookOptions<GetTpAssetMapQuery, GetTpAssetMapQueryVariables> & ({ variables: GetTpAssetMapQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTpAssetMapQuery, GetTpAssetMapQueryVariables>(GetTpAssetMapDocument, options);
      }
export function useGetTpAssetMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTpAssetMapQuery, GetTpAssetMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTpAssetMapQuery, GetTpAssetMapQueryVariables>(GetTpAssetMapDocument, options);
        }
// @ts-ignore
export function useGetTpAssetMapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTpAssetMapQuery, GetTpAssetMapQueryVariables>): Apollo.UseSuspenseQueryResult<GetTpAssetMapQuery, GetTpAssetMapQueryVariables>;
export function useGetTpAssetMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTpAssetMapQuery, GetTpAssetMapQueryVariables>): Apollo.UseSuspenseQueryResult<GetTpAssetMapQuery | undefined, GetTpAssetMapQueryVariables>;
export function useGetTpAssetMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTpAssetMapQuery, GetTpAssetMapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTpAssetMapQuery, GetTpAssetMapQueryVariables>(GetTpAssetMapDocument, options);
        }
export type GetTpAssetMapQueryHookResult = ReturnType<typeof useGetTpAssetMapQuery>;
export type GetTpAssetMapLazyQueryHookResult = ReturnType<typeof useGetTpAssetMapLazyQuery>;
export type GetTpAssetMapSuspenseQueryHookResult = ReturnType<typeof useGetTpAssetMapSuspenseQuery>;
export type GetTpAssetMapQueryResult = Apollo.QueryResult<GetTpAssetMapQuery, GetTpAssetMapQueryVariables>;